/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  AuditActionScalar: any;
  /** The `Byte` scalar type represents non-fractional whole numeric values. Byte can represent values between 0 and 255. */
  Byte: any;
  /** The `DateTime` scalar represents an ISO-8601 compliant date time type. */
  DateTime: any;
  /** The built-in `Decimal` scalar type. */
  Decimal: number;
  /** The `Long` scalar type represents non-fractional signed whole 64-bit numeric values. Long can represent values between -(2^63) and 2^63 - 1. */
  Long: any;
  /** The multiplier path scalar represents a valid GraphQL multiplier path string. */
  MultiplierPath: any;
  /** The `Short` scalar type represents non-fractional signed whole 16-bit numeric values. Short can represent values between -(2^15) and 2^15 - 1. */
  Short: any;
  /** The `TimeSpan` scalar represents an ISO-8601 compliant duration type. */
  TimeSpan: any;
  UUID: any;
};

export type AddPackageToAuditInput = {
  auditId: Scalars['Int'];
  locId: Scalars['Int'];
  lspId: Scalars['Int'];
  packageId: Scalars['Int'];
  sessionId?: InputMaybe<Scalars['String']>;
  userId: Scalars['Int'];
};

export type AddPackageToAuditResponse = {
  auditDetailId: Scalars['Int'];
  packageId: Scalars['Int'];
};

export type AddressBook = {
  addressId: Scalars['Int'];
  addressState?: Maybe<Scalars['String']>;
  city: Scalars['String'];
  county?: Maybe<Scalars['String']>;
  customer?: Maybe<TblAcct>;
  customerId: Scalars['Int'];
  latitude?: Maybe<Scalars['Decimal']>;
  longitude?: Maybe<Scalars['Decimal']>;
  lspId: Scalars['Int'];
  postalCode?: Maybe<Scalars['String']>;
  street: Scalars['String'];
  street2?: Maybe<Scalars['String']>;
};

export type AddressBookFilterInput = {
  addressId?: InputMaybe<ComparableInt32OperationFilterInput>;
  addressState?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<AddressBookFilterInput>>;
  city?: InputMaybe<StringOperationFilterInput>;
  county?: InputMaybe<StringOperationFilterInput>;
  customer?: InputMaybe<TblAcctFilterInput>;
  customerId?: InputMaybe<ComparableInt32OperationFilterInput>;
  latitude?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  longitude?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  lspId?: InputMaybe<ComparableInt32OperationFilterInput>;
  or?: InputMaybe<Array<AddressBookFilterInput>>;
  postalCode?: InputMaybe<StringOperationFilterInput>;
  street?: InputMaybe<StringOperationFilterInput>;
  street2?: InputMaybe<StringOperationFilterInput>;
};

export type AdilasIntegrationControlInfo = {
  adilasCustomerId?: Maybe<Scalars['Int']>;
  adilasIntegrationControlInfoId: Scalars['Int'];
  apicorpKeyId?: Maybe<Scalars['String']>;
  apicurrentPayeeId?: Maybe<Scalars['String']>;
  apiuserName?: Maybe<Scalars['String']>;
  apiuserPassword?: Maybe<Scalars['String']>;
  baseUrl?: Maybe<Scalars['String']>;
  batchFieldName?: Maybe<Scalars['String']>;
  corpId?: Maybe<Scalars['String']>;
  externalPacakgeIdName?: Maybe<Scalars['String']>;
  ignoreReceivesBefore?: Maybe<Scalars['DateTime']>;
  isEnabled: Scalars['Boolean'];
  loc?: Maybe<TblLspLocation>;
  locId: Scalars['Int'];
  lsp?: Maybe<TblLsp>;
  lspId: Scalars['Int'];
  serialNumberFieldName?: Maybe<Scalars['String']>;
};

export type AdilasIntegrationControlInfoFilterInput = {
  adilasCustomerId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  adilasIntegrationControlInfoId?: InputMaybe<ComparableInt32OperationFilterInput>;
  and?: InputMaybe<Array<AdilasIntegrationControlInfoFilterInput>>;
  apicorpKeyId?: InputMaybe<StringOperationFilterInput>;
  apicurrentPayeeId?: InputMaybe<StringOperationFilterInput>;
  apiuserName?: InputMaybe<StringOperationFilterInput>;
  apiuserPassword?: InputMaybe<StringOperationFilterInput>;
  baseUrl?: InputMaybe<StringOperationFilterInput>;
  batchFieldName?: InputMaybe<StringOperationFilterInput>;
  corpId?: InputMaybe<StringOperationFilterInput>;
  externalPacakgeIdName?: InputMaybe<StringOperationFilterInput>;
  ignoreReceivesBefore?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  isEnabled?: InputMaybe<BooleanOperationFilterInput>;
  loc?: InputMaybe<TblLspLocationFilterInput>;
  locId?: InputMaybe<ComparableInt32OperationFilterInput>;
  lsp?: InputMaybe<TblLspFilterInput>;
  lspId?: InputMaybe<ComparableInt32OperationFilterInput>;
  or?: InputMaybe<Array<AdilasIntegrationControlInfoFilterInput>>;
  serialNumberFieldName?: InputMaybe<StringOperationFilterInput>;
};

export type AllocatedInventory = {
  allocatedInventoryId: Scalars['Int'];
  allocationStatusId?: Maybe<Scalars['Int']>;
  appliedDiscounts?: Maybe<Array<Maybe<AppliedDiscount>>>;
  batchId?: Maybe<Scalars['Int']>;
  biotrackDispenseDate?: Maybe<Scalars['DateTime']>;
  biotrackItemId?: Maybe<Scalars['Int']>;
  cost?: Maybe<Scalars['Decimal']>;
  daysSupply?: Maybe<Scalars['String']>;
  discount?: Maybe<Discount>;
  discountDescription?: Maybe<Scalars['String']>;
  discountId?: Maybe<Scalars['Int']>;
  discountedAmount?: Maybe<Scalars['Decimal']>;
  discountedBy?: Maybe<Scalars['Int']>;
  discountedByNavigation?: Maybe<TblAuthUser>;
  effectivePotencyMg?: Maybe<Scalars['Decimal']>;
  finalDiscount?: Maybe<Scalars['Decimal']>;
  finalGrossPrice?: Maybe<Scalars['Decimal']>;
  finalNetPrice?: Maybe<Scalars['Decimal']>;
  finalNetPriceWithTax?: Maybe<Scalars['Decimal']>;
  finalTax?: Maybe<Scalars['Decimal']>;
  flowerEquivalent?: Maybe<Scalars['Decimal']>;
  instructions?: Maybe<Scalars['String']>;
  itemTotalTax?: Maybe<Scalars['Decimal']>;
  lastModifiedUtc?: Maybe<Scalars['DateTime']>;
  loc?: Maybe<TblLspLocation>;
  locId: Scalars['Int'];
  loyaltyAsDiscountAmount?: Maybe<Scalars['Decimal']>;
  loyaltyDiscountCashValue?: Maybe<Scalars['Decimal']>;
  lsp?: Maybe<TblLsp>;
  lspId: Scalars['Int'];
  mmurdeviceId?: Maybe<Scalars['Int']>;
  mmurformId?: Maybe<Scalars['Int']>;
  mmurorderId?: Maybe<Scalars['Int']>;
  mmursecondOrderId?: Maybe<Scalars['Int']>;
  originalUnitPrice?: Maybe<Scalars['Decimal']>;
  packageId?: Maybe<Scalars['Int']>;
  prescriptionNumber?: Maybe<Scalars['Int']>;
  pricedQuantity?: Maybe<Scalars['Decimal']>;
  product?: Maybe<TblWhseProduct>;
  productId: Scalars['Int'];
  productWeight?: Maybe<Scalars['Decimal']>;
  purchasedBy: Scalars['Int'];
  purchasedByNavigation?: Maybe<TblAcct>;
  purchasedDate?: Maybe<Scalars['DateTime']>;
  quantity?: Maybe<Scalars['Decimal']>;
  returnBy?: Maybe<Scalars['String']>;
  returnDate?: Maybe<Scalars['DateTime']>;
  returnReason?: Maybe<Scalars['String']>;
  returnedByShipment?: Maybe<Scalars['Int']>;
  returnedByShipmentNavigation?: Maybe<TblMdshipment>;
  serialNumber?: Maybe<Scalars['String']>;
  shipment?: Maybe<TblMdshipment>;
  shipmentId: Scalars['Int'];
  startingQuantitySale?: Maybe<Scalars['Decimal']>;
  startingQuantityVoidReturn?: Maybe<Scalars['Decimal']>;
  transmittedToStateSystem?: Maybe<Scalars['Boolean']>;
  unit?: Maybe<Unit>;
  unitId: Scalars['Int'];
  unitPrice?: Maybe<Scalars['Decimal']>;
  vendor?: Maybe<TblVendor>;
  vendorId?: Maybe<Scalars['Int']>;
  voidBy?: Maybe<Scalars['Int']>;
  voidByNavigation?: Maybe<TblAuthUser>;
  voidDate?: Maybe<Scalars['DateTime']>;
};

export type AllocatedInventoryFilterInput = {
  allocatedInventoryId?: InputMaybe<ComparableInt32OperationFilterInput>;
  allocationStatusId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  and?: InputMaybe<Array<AllocatedInventoryFilterInput>>;
  appliedDiscounts?: InputMaybe<ListFilterInputTypeOfAppliedDiscountFilterInput>;
  batchId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  biotrackDispenseDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  biotrackItemId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  cost?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  daysSupply?: InputMaybe<StringOperationFilterInput>;
  discount?: InputMaybe<DiscountFilterInput>;
  discountDescription?: InputMaybe<StringOperationFilterInput>;
  discountId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  discountedAmount?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  discountedBy?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  discountedByNavigation?: InputMaybe<TblAuthUserFilterInput>;
  effectivePotencyMg?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  finalDiscount?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  finalGrossPrice?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  finalNetPrice?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  finalNetPriceWithTax?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  finalTax?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  flowerEquivalent?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  instructions?: InputMaybe<StringOperationFilterInput>;
  itemTotalTax?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  lastModifiedUtc?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  loc?: InputMaybe<TblLspLocationFilterInput>;
  locId?: InputMaybe<ComparableInt32OperationFilterInput>;
  loyaltyAsDiscountAmount?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  loyaltyDiscountCashValue?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  lsp?: InputMaybe<TblLspFilterInput>;
  lspId?: InputMaybe<ComparableInt32OperationFilterInput>;
  mmurdeviceId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  mmurformId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  mmurorderId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  mmursecondOrderId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  or?: InputMaybe<Array<AllocatedInventoryFilterInput>>;
  originalUnitPrice?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  packageId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  prescriptionNumber?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  pricedQuantity?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  product?: InputMaybe<TblWhseProductFilterInput>;
  productId?: InputMaybe<ComparableInt32OperationFilterInput>;
  productWeight?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  purchasedBy?: InputMaybe<ComparableInt32OperationFilterInput>;
  purchasedByNavigation?: InputMaybe<TblAcctFilterInput>;
  purchasedDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  quantity?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  returnBy?: InputMaybe<StringOperationFilterInput>;
  returnDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  returnReason?: InputMaybe<StringOperationFilterInput>;
  returnedByShipment?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  returnedByShipmentNavigation?: InputMaybe<TblMdshipmentFilterInput>;
  serialNumber?: InputMaybe<StringOperationFilterInput>;
  shipment?: InputMaybe<TblMdshipmentFilterInput>;
  shipmentId?: InputMaybe<ComparableInt32OperationFilterInput>;
  startingQuantitySale?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  startingQuantityVoidReturn?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  transmittedToStateSystem?: InputMaybe<BooleanOperationFilterInput>;
  unit?: InputMaybe<UnitFilterInput>;
  unitId?: InputMaybe<ComparableInt32OperationFilterInput>;
  unitPrice?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  vendor?: InputMaybe<TblVendorFilterInput>;
  vendorId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  voidBy?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  voidByNavigation?: InputMaybe<TblAuthUserFilterInput>;
  voidDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
};

export type AlpineIqcontrolInfo = {
  alpineIqcontrolInfoId: Scalars['Int'];
  apiKey?: Maybe<Scalars['String']>;
  baseUrl?: Maybe<Scalars['String']>;
  bypass2Fa?: Maybe<Scalars['Boolean']>;
  bypassEntry?: Maybe<Scalars['Boolean']>;
  isEnabled: Scalars['Boolean'];
  loc?: Maybe<TblLspLocation>;
  locId?: Maybe<Scalars['Int']>;
  lsp?: Maybe<TblLsp>;
  lspId?: Maybe<Scalars['Int']>;
};

export type AlpineIqcontrolInfoFilterInput = {
  alpineIqcontrolInfoId?: InputMaybe<ComparableInt32OperationFilterInput>;
  and?: InputMaybe<Array<AlpineIqcontrolInfoFilterInput>>;
  apiKey?: InputMaybe<StringOperationFilterInput>;
  baseUrl?: InputMaybe<StringOperationFilterInput>;
  bypass2Fa?: InputMaybe<BooleanOperationFilterInput>;
  bypassEntry?: InputMaybe<BooleanOperationFilterInput>;
  isEnabled?: InputMaybe<BooleanOperationFilterInput>;
  loc?: InputMaybe<TblLspLocationFilterInput>;
  locId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  lsp?: InputMaybe<TblLspFilterInput>;
  lspId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  or?: InputMaybe<Array<AlpineIqcontrolInfoFilterInput>>;
};

export type ApiResultOfAddPackageToAuditResponse = {
  data?: Maybe<AddPackageToAuditResponse>;
  message?: Maybe<Scalars['String']>;
  result: Scalars['Boolean'];
};

export type ApiResultOfCloseAuditResponse = {
  data?: Maybe<CloseAuditResponse>;
  message?: Maybe<Scalars['String']>;
  result: Scalars['Boolean'];
};

export type ApiResultOfCreateAuditFromPackagesResponse = {
  data?: Maybe<CreateAuditFromPackagesResponse>;
  message?: Maybe<Scalars['String']>;
  result: Scalars['Boolean'];
};

export type ApiResultOfFgrecon = {
  data?: Maybe<Fgrecon>;
  message?: Maybe<Scalars['String']>;
  result: Scalars['Boolean'];
};

export type ApiResultOfFgreconDetail = {
  data?: Maybe<FgreconDetail>;
  message?: Maybe<Scalars['String']>;
  result: Scalars['Boolean'];
};

export type ApiResultOfInt32 = {
  data: Scalars['Int'];
  message?: Maybe<Scalars['String']>;
  result: Scalars['Boolean'];
};

export type ApiResultOfRemovePackageFromAuditResponse = {
  data?: Maybe<RemovePackageFromAuditResponse>;
  message?: Maybe<Scalars['String']>;
  result: Scalars['Boolean'];
};

export type ApiResultOfSetJobStatusToCancelledResponse = {
  data?: Maybe<SetJobStatusToCancelledResponse>;
  message?: Maybe<Scalars['String']>;
  result: Scalars['Boolean'];
};

export type ApiResultOfTblWhseProduct__ = {
  data?: Maybe<Array<Maybe<TblWhseProduct>>>;
  message?: Maybe<Scalars['String']>;
  result: Scalars['Boolean'];
};

export type ApiResultOfUpdateAuditDetailsViaCsvResponse = {
  data?: Maybe<UpdateAuditDetailsViaCsvResponse>;
  message?: Maybe<Scalars['String']>;
  result: Scalars['Boolean'];
};

export type AppliedDiscount = {
  allocatedInventory?: Maybe<AllocatedInventory>;
  allocatedInventoryId?: Maybe<Scalars['Int']>;
  amount?: Maybe<Scalars['Decimal']>;
  appliedDiscountId: Scalars['Int'];
  approvingManagerUser?: Maybe<TblAuthUser>;
  approvingManagerUserId?: Maybe<Scalars['Int']>;
  discount?: Maybe<Discount>;
  discountApplicationGroupUid?: Maybe<Scalars['String']>;
  discountId?: Maybe<Scalars['Int']>;
  discountPercent?: Maybe<Scalars['Decimal']>;
  discountReason?: Maybe<Scalars['String']>;
  externalId?: Maybe<Scalars['String']>;
  isLoyalty: Scalars['Byte'];
  loyaltyDiscountRedemption?: Maybe<LoyaltyDiscountRedemption>;
  loyaltyDiscountRedemptionId?: Maybe<Scalars['Int']>;
  loyaltyPointCost?: Maybe<Scalars['Decimal']>;
  product?: Maybe<TblWhseProduct>;
  productId?: Maybe<Scalars['Int']>;
  shipment?: Maybe<TblMdshipment>;
  shipmentId?: Maybe<Scalars['Int']>;
};

export type AppliedDiscountFilterInput = {
  allocatedInventory?: InputMaybe<AllocatedInventoryFilterInput>;
  allocatedInventoryId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  amount?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  and?: InputMaybe<Array<AppliedDiscountFilterInput>>;
  appliedDiscountId?: InputMaybe<ComparableInt32OperationFilterInput>;
  approvingManagerUser?: InputMaybe<TblAuthUserFilterInput>;
  approvingManagerUserId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  discount?: InputMaybe<DiscountFilterInput>;
  discountApplicationGroupUid?: InputMaybe<StringOperationFilterInput>;
  discountId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  discountPercent?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  discountReason?: InputMaybe<StringOperationFilterInput>;
  externalId?: InputMaybe<StringOperationFilterInput>;
  isLoyalty?: InputMaybe<ComparableByteOperationFilterInput>;
  loyaltyDiscountRedemption?: InputMaybe<LoyaltyDiscountRedemptionFilterInput>;
  loyaltyDiscountRedemptionId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  loyaltyPointCost?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  or?: InputMaybe<Array<AppliedDiscountFilterInput>>;
  product?: InputMaybe<TblWhseProductFilterInput>;
  productId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  shipment?: InputMaybe<TblMdshipmentFilterInput>;
  shipmentId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
};

export type AppliedFeeDonation = {
  appliedFeeDonationId: Scalars['Int'];
  calculationMethodId: Scalars['Int'];
  calculationValue: Scalars['Decimal'];
  cashValue: Scalars['Decimal'];
  description?: Maybe<Scalars['String']>;
  feeDonation?: Maybe<FeeDonation>;
  feeDonationId: Scalars['Int'];
  shipment?: Maybe<TblMdshipment>;
  shipmentId: Scalars['Int'];
};

export type AppliedFeeDonationFilterInput = {
  and?: InputMaybe<Array<AppliedFeeDonationFilterInput>>;
  appliedFeeDonationId?: InputMaybe<ComparableInt32OperationFilterInput>;
  calculationMethodId?: InputMaybe<ComparableInt32OperationFilterInput>;
  calculationValue?: InputMaybe<ComparableDecimalOperationFilterInput>;
  cashValue?: InputMaybe<ComparableDecimalOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  feeDonation?: InputMaybe<FeeDonationFilterInput>;
  feeDonationId?: InputMaybe<ComparableInt32OperationFilterInput>;
  or?: InputMaybe<Array<AppliedFeeDonationFilterInput>>;
  shipment?: InputMaybe<TblMdshipmentFilterInput>;
  shipmentId?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export enum ApplyPolicy {
  AfterResolver = 'AFTER_RESOLVER',
  BeforeResolver = 'BEFORE_RESOLVER'
}

export type Assembly = {
  assemblyId: Scalars['Int'];
  assemblyOutputItems?: Maybe<Array<Maybe<AssemblyOutputItem>>>;
  assemblyStatus?: Maybe<AssemblyStatus>;
  assemblyStatusId?: Maybe<Scalars['Byte']>;
  billOfMaterials?: Maybe<BillOfMaterial>;
  billOfMaterialsId: Scalars['Int'];
  completedBy?: Maybe<Scalars['Int']>;
  completedByNavigation?: Maybe<TblAuthUser>;
  completedUtc?: Maybe<Scalars['DateTime']>;
  createdBy: Scalars['Int'];
  createdByNavigation?: Maybe<TblAuthUser>;
  createdUtc: Scalars['DateTime'];
  estimatedStartDate: Scalars['DateTime'];
  lastModifiedBy?: Maybe<Scalars['Int']>;
  lastModifiedByNavigation?: Maybe<TblAuthUser>;
  lastModifiedUtc?: Maybe<Scalars['DateTime']>;
  loc?: Maybe<TblLspLocation>;
  locId: Scalars['Int'];
  lsp?: Maybe<TblLsp>;
  lspId: Scalars['Int'];
  metrcProcessingJob?: Maybe<MetrcProcessingJob>;
  name: Scalars['String'];
  quantityWasteAmount?: Maybe<Scalars['Decimal']>;
  quantityWasteUnit?: Maybe<Unit>;
  quantityWasteUnitId?: Maybe<Scalars['Int']>;
  startedBy?: Maybe<Scalars['Int']>;
  startedByNavigation?: Maybe<TblAuthUser>;
  startedUtc?: Maybe<Scalars['DateTime']>;
  volumeWasteAmount?: Maybe<Scalars['Decimal']>;
  volumeWasteUnit?: Maybe<Unit>;
  volumeWasteUnitId?: Maybe<Scalars['Int']>;
  wasteNote?: Maybe<Scalars['String']>;
  weightWasteAmount?: Maybe<Scalars['Decimal']>;
  weightWasteUnit?: Maybe<Unit>;
  weightWasteUnitId?: Maybe<Scalars['Int']>;
};

export type AssemblyCollectionSegment = {
  items?: Maybe<Array<Maybe<Assembly>>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

export type AssemblyFilterInput = {
  and?: InputMaybe<Array<AssemblyFilterInput>>;
  assemblyId?: InputMaybe<ComparableInt32OperationFilterInput>;
  assemblyOutputItems?: InputMaybe<ListFilterInputTypeOfAssemblyOutputItemFilterInput>;
  assemblyStatus?: InputMaybe<AssemblyStatusFilterInput>;
  assemblyStatusId?: InputMaybe<ComparableNullableOfByteOperationFilterInput>;
  billOfMaterials?: InputMaybe<BillOfMaterialFilterInput>;
  billOfMaterialsId?: InputMaybe<ComparableInt32OperationFilterInput>;
  completedBy?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  completedByNavigation?: InputMaybe<TblAuthUserFilterInput>;
  completedUtc?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  createdBy?: InputMaybe<ComparableInt32OperationFilterInput>;
  createdByNavigation?: InputMaybe<TblAuthUserFilterInput>;
  createdUtc?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  estimatedStartDate?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  lastModifiedBy?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  lastModifiedByNavigation?: InputMaybe<TblAuthUserFilterInput>;
  lastModifiedUtc?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  loc?: InputMaybe<TblLspLocationFilterInput>;
  locId?: InputMaybe<ComparableInt32OperationFilterInput>;
  lsp?: InputMaybe<TblLspFilterInput>;
  lspId?: InputMaybe<ComparableInt32OperationFilterInput>;
  metrcProcessingJob?: InputMaybe<MetrcProcessingJobFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<AssemblyFilterInput>>;
  quantityWasteAmount?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  quantityWasteUnit?: InputMaybe<UnitFilterInput>;
  quantityWasteUnitId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  startedBy?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  startedByNavigation?: InputMaybe<TblAuthUserFilterInput>;
  startedUtc?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  volumeWasteAmount?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  volumeWasteUnit?: InputMaybe<UnitFilterInput>;
  volumeWasteUnitId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  wasteNote?: InputMaybe<StringOperationFilterInput>;
  weightWasteAmount?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  weightWasteUnit?: InputMaybe<UnitFilterInput>;
  weightWasteUnitId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
};

export type AssemblyInputItem = {
  assemblyInputItemId: Scalars['Int'];
  assemblyInputPackages?: Maybe<Array<Maybe<AssemblyInputPackage>>>;
  assemblyOutputItem?: Maybe<AssemblyOutputItem>;
  assemblyOutputItemId: Scalars['Int'];
  inputItemType?: Maybe<InputItemType>;
  inputItemTypeId: Scalars['Byte'];
  product?: Maybe<TblWhseProduct>;
  productId?: Maybe<Scalars['Int']>;
  productType?: Maybe<TblWhseProductType>;
  productTypeId?: Maybe<Scalars['Int']>;
  quantity: Scalars['Decimal'];
  skip: Scalars['Boolean'];
  unit?: Maybe<Unit>;
  unitId: Scalars['Int'];
};

export type AssemblyInputItemFilterInput = {
  and?: InputMaybe<Array<AssemblyInputItemFilterInput>>;
  assemblyInputItemId?: InputMaybe<ComparableInt32OperationFilterInput>;
  assemblyInputPackages?: InputMaybe<ListFilterInputTypeOfAssemblyInputPackageFilterInput>;
  assemblyOutputItem?: InputMaybe<AssemblyOutputItemFilterInput>;
  assemblyOutputItemId?: InputMaybe<ComparableInt32OperationFilterInput>;
  inputItemType?: InputMaybe<InputItemTypeFilterInput>;
  inputItemTypeId?: InputMaybe<ComparableByteOperationFilterInput>;
  or?: InputMaybe<Array<AssemblyInputItemFilterInput>>;
  product?: InputMaybe<TblWhseProductFilterInput>;
  productId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  productType?: InputMaybe<TblWhseProductTypeFilterInput>;
  productTypeId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  quantity?: InputMaybe<ComparableDecimalOperationFilterInput>;
  skip?: InputMaybe<BooleanOperationFilterInput>;
  unit?: InputMaybe<UnitFilterInput>;
  unitId?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type AssemblyInputPackage = {
  assemblyInputItem?: Maybe<AssemblyInputItem>;
  assemblyInputItemId: Scalars['Int'];
  assemblyInputPackageId: Scalars['Int'];
  conversionInputPackageId?: Maybe<Scalars['Int']>;
  package?: Maybe<Package>;
  packageId: Scalars['Int'];
  quantity: Scalars['Decimal'];
  unit?: Maybe<Unit>;
  unitId: Scalars['Int'];
};

export type AssemblyInputPackageFilterInput = {
  and?: InputMaybe<Array<AssemblyInputPackageFilterInput>>;
  assemblyInputItem?: InputMaybe<AssemblyInputItemFilterInput>;
  assemblyInputItemId?: InputMaybe<ComparableInt32OperationFilterInput>;
  assemblyInputPackageId?: InputMaybe<ComparableInt32OperationFilterInput>;
  conversionInputPackageId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  or?: InputMaybe<Array<AssemblyInputPackageFilterInput>>;
  package?: InputMaybe<PackageFilterInput>;
  packageId?: InputMaybe<ComparableInt32OperationFilterInput>;
  quantity?: InputMaybe<ComparableDecimalOperationFilterInput>;
  unit?: InputMaybe<UnitFilterInput>;
  unitId?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type AssemblyOutputItem = {
  actualQuantity: Scalars['Decimal'];
  assembly?: Maybe<Assembly>;
  assemblyId: Scalars['Int'];
  assemblyInputItems?: Maybe<Array<Maybe<AssemblyInputItem>>>;
  assemblyOutputItemId: Scalars['Int'];
  batch?: Maybe<TblBatch>;
  batchId?: Maybe<Scalars['Int']>;
  bypassStateSystem: Scalars['Boolean'];
  conversionOutputPackageId?: Maybe<Scalars['Int']>;
  conversionTransactionId?: Maybe<Scalars['Int']>;
  cost?: Maybe<Scalars['Decimal']>;
  costType?: Maybe<CostType>;
  costTypeId?: Maybe<Scalars['Byte']>;
  expirationDateUtc?: Maybe<Scalars['DateTime']>;
  inventoryStatus?: Maybe<TblInventoryStatus>;
  inventoryStatusId?: Maybe<Scalars['Int']>;
  isProductionBatch: Scalars['Boolean'];
  outputItemType?: Maybe<OutputItemType>;
  outputItemTypeId: Scalars['Byte'];
  package?: Maybe<Package>;
  packageDateUtc?: Maybe<Scalars['DateTime']>;
  packageId?: Maybe<Scalars['Int']>;
  product?: Maybe<TblWhseProduct>;
  productId?: Maybe<Scalars['Int']>;
  productType?: Maybe<TblWhseProductType>;
  productTypeId?: Maybe<Scalars['Int']>;
  quantity: Scalars['Decimal'];
  room?: Maybe<TblBatchRoom>;
  roomId?: Maybe<Scalars['Int']>;
  serialNumber?: Maybe<Scalars['String']>;
  skip: Scalars['Boolean'];
  sourceSerialNumber?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<Maybe<Tag>>>;
  unit?: Maybe<Unit>;
  unitId: Scalars['Int'];
  useByDate?: Maybe<Scalars['DateTime']>;
  vendor?: Maybe<TblVendor>;
  vendorId?: Maybe<Scalars['Int']>;
};

export type AssemblyOutputItemFilterInput = {
  actualQuantity?: InputMaybe<ComparableDecimalOperationFilterInput>;
  and?: InputMaybe<Array<AssemblyOutputItemFilterInput>>;
  assembly?: InputMaybe<AssemblyFilterInput>;
  assemblyId?: InputMaybe<ComparableInt32OperationFilterInput>;
  assemblyInputItems?: InputMaybe<ListFilterInputTypeOfAssemblyInputItemFilterInput>;
  assemblyOutputItemId?: InputMaybe<ComparableInt32OperationFilterInput>;
  batch?: InputMaybe<TblBatchFilterInput>;
  batchId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  bypassStateSystem?: InputMaybe<BooleanOperationFilterInput>;
  conversionOutputPackageId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  conversionTransactionId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  cost?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  costType?: InputMaybe<CostTypeFilterInput>;
  costTypeId?: InputMaybe<ComparableNullableOfByteOperationFilterInput>;
  expirationDateUtc?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  inventoryStatus?: InputMaybe<TblInventoryStatusFilterInput>;
  inventoryStatusId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  isProductionBatch?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<AssemblyOutputItemFilterInput>>;
  outputItemType?: InputMaybe<OutputItemTypeFilterInput>;
  outputItemTypeId?: InputMaybe<ComparableByteOperationFilterInput>;
  package?: InputMaybe<PackageFilterInput>;
  packageDateUtc?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  packageId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  product?: InputMaybe<TblWhseProductFilterInput>;
  productId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  productType?: InputMaybe<TblWhseProductTypeFilterInput>;
  productTypeId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  quantity?: InputMaybe<ComparableDecimalOperationFilterInput>;
  room?: InputMaybe<TblBatchRoomFilterInput>;
  roomId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  serialNumber?: InputMaybe<StringOperationFilterInput>;
  skip?: InputMaybe<BooleanOperationFilterInput>;
  sourceSerialNumber?: InputMaybe<StringOperationFilterInput>;
  tags?: InputMaybe<ListFilterInputTypeOfTagFilterInput>;
  unit?: InputMaybe<UnitFilterInput>;
  unitId?: InputMaybe<ComparableInt32OperationFilterInput>;
  useByDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  vendor?: InputMaybe<TblVendorFilterInput>;
  vendorId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
};

export type AssemblySortInput = {
  assemblyId?: InputMaybe<SortEnumType>;
  assemblyStatus?: InputMaybe<AssemblyStatusSortInput>;
  assemblyStatusId?: InputMaybe<SortEnumType>;
  billOfMaterials?: InputMaybe<BillOfMaterialSortInput>;
  billOfMaterialsId?: InputMaybe<SortEnumType>;
  completedBy?: InputMaybe<SortEnumType>;
  completedByNavigation?: InputMaybe<TblAuthUserSortInput>;
  completedUtc?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  createdByNavigation?: InputMaybe<TblAuthUserSortInput>;
  createdUtc?: InputMaybe<SortEnumType>;
  estimatedStartDate?: InputMaybe<SortEnumType>;
  lastModifiedBy?: InputMaybe<SortEnumType>;
  lastModifiedByNavigation?: InputMaybe<TblAuthUserSortInput>;
  lastModifiedUtc?: InputMaybe<SortEnumType>;
  loc?: InputMaybe<TblLspLocationSortInput>;
  locId?: InputMaybe<SortEnumType>;
  lsp?: InputMaybe<TblLspSortInput>;
  lspId?: InputMaybe<SortEnumType>;
  metrcProcessingJob?: InputMaybe<MetrcProcessingJobSortInput>;
  name?: InputMaybe<SortEnumType>;
  quantityWasteAmount?: InputMaybe<SortEnumType>;
  quantityWasteUnit?: InputMaybe<UnitSortInput>;
  quantityWasteUnitId?: InputMaybe<SortEnumType>;
  startedBy?: InputMaybe<SortEnumType>;
  startedByNavigation?: InputMaybe<TblAuthUserSortInput>;
  startedUtc?: InputMaybe<SortEnumType>;
  volumeWasteAmount?: InputMaybe<SortEnumType>;
  volumeWasteUnit?: InputMaybe<UnitSortInput>;
  volumeWasteUnitId?: InputMaybe<SortEnumType>;
  wasteNote?: InputMaybe<SortEnumType>;
  weightWasteAmount?: InputMaybe<SortEnumType>;
  weightWasteUnit?: InputMaybe<UnitSortInput>;
  weightWasteUnitId?: InputMaybe<SortEnumType>;
};

export type AssemblyStatus = {
  assemblies?: Maybe<Array<Maybe<Assembly>>>;
  assemblyStatusId: Scalars['Byte'];
  name?: Maybe<Scalars['String']>;
};

export type AssemblyStatusFilterInput = {
  and?: InputMaybe<Array<AssemblyStatusFilterInput>>;
  assemblies?: InputMaybe<ListFilterInputTypeOfAssemblyFilterInput>;
  assemblyStatusId?: InputMaybe<ComparableByteOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<AssemblyStatusFilterInput>>;
};

export type AssemblyStatusSortInput = {
  assemblyStatusId?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
};

export type AssociatedTagResourceCounts = {
  inventoryDiscountCount: Scalars['Int'];
  inventoryKitItemCount: Scalars['Int'];
  packageCount: Scalars['Int'];
  productCount: Scalars['Int'];
  productDiscountCount: Scalars['Int'];
};

export type AuditDetailUpdatesInput = {
  actualQty?: InputMaybe<Scalars['Decimal']>;
  comment?: InputMaybe<Scalars['String']>;
  expectedQty?: InputMaybe<Scalars['Decimal']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  lastAuditedDateUtc?: InputMaybe<Scalars['DateTime']>;
  reasonCode?: InputMaybe<Scalars['String']>;
  serialNo?: InputMaybe<Scalars['String']>;
  unitId?: InputMaybe<Scalars['Int']>;
  updatedBy?: InputMaybe<Scalars['Int']>;
};

export enum AuditStatus {
  Complete = 'COMPLETE',
  InProgress = 'IN_PROGRESS',
  InReview = 'IN_REVIEW',
  NeedsRecount = 'NEEDS_RECOUNT',
  NeedsReview = 'NEEDS_REVIEW',
  Uncounted = 'UNCOUNTED',
  Unknown = 'UNKNOWN'
}

export type BillOfMaterial = {
  assemblies?: Maybe<Array<Maybe<Assembly>>>;
  billOfMaterialsFiles?: Maybe<Array<Maybe<BillOfMaterialsFile>>>;
  billOfMaterialsId: Scalars['Int'];
  billOfMaterialsImages?: Maybe<Array<Maybe<BillOfMaterialsImage>>>;
  billOfMaterialsInputItems?: Maybe<Array<Maybe<BillOfMaterialsInputItem>>>;
  billOfMaterialsOutputItems?: Maybe<Array<Maybe<BillOfMaterialsOutputItem>>>;
  createdBy: Scalars['Int'];
  createdByNavigation?: Maybe<TblAuthUser>;
  createdOnUtc: Scalars['DateTime'];
  deletedBy?: Maybe<Scalars['Int']>;
  deletedByNavigation?: Maybe<TblAuthUser>;
  deletedOnUtc?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  executionCount: Scalars['Int'];
  isDeleted: Scalars['Boolean'];
  isProcessingJob: Scalars['Boolean'];
  laborHours?: Maybe<Scalars['Decimal']>;
  laborRate?: Maybe<Scalars['Decimal']>;
  lastEditedBy?: Maybe<Scalars['Int']>;
  lastEditedByNavigation?: Maybe<TblAuthUser>;
  lastEditedUtc?: Maybe<Scalars['DateTime']>;
  lastRanBy?: Maybe<Scalars['Int']>;
  lastRanByNavigation?: Maybe<TblAuthUser>;
  lastRanUtc?: Maybe<Scalars['DateTime']>;
  lsp?: Maybe<TblLsp>;
  lspId: Scalars['Int'];
  metrcProcessingJobTypeTemplate?: Maybe<MetrcProcessingJobTypeTemplate>;
  name: Scalars['String'];
};

export type BillOfMaterialCollectionSegment = {
  items?: Maybe<Array<Maybe<BillOfMaterial>>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

export type BillOfMaterialFilterInput = {
  and?: InputMaybe<Array<BillOfMaterialFilterInput>>;
  assemblies?: InputMaybe<ListFilterInputTypeOfAssemblyFilterInput>;
  billOfMaterialsFiles?: InputMaybe<ListFilterInputTypeOfBillOfMaterialsFileFilterInput>;
  billOfMaterialsId?: InputMaybe<ComparableInt32OperationFilterInput>;
  billOfMaterialsImages?: InputMaybe<ListFilterInputTypeOfBillOfMaterialsImageFilterInput>;
  billOfMaterialsInputItems?: InputMaybe<ListFilterInputTypeOfBillOfMaterialsInputItemFilterInput>;
  billOfMaterialsOutputItems?: InputMaybe<ListFilterInputTypeOfBillOfMaterialsOutputItemFilterInput>;
  createdBy?: InputMaybe<ComparableInt32OperationFilterInput>;
  createdByNavigation?: InputMaybe<TblAuthUserFilterInput>;
  createdOnUtc?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  deletedBy?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  deletedByNavigation?: InputMaybe<TblAuthUserFilterInput>;
  deletedOnUtc?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  executionCount?: InputMaybe<ComparableInt32OperationFilterInput>;
  isDeleted?: InputMaybe<BooleanOperationFilterInput>;
  isProcessingJob?: InputMaybe<BooleanOperationFilterInput>;
  laborHours?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  laborRate?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  lastEditedBy?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  lastEditedByNavigation?: InputMaybe<TblAuthUserFilterInput>;
  lastEditedUtc?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  lastRanBy?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  lastRanByNavigation?: InputMaybe<TblAuthUserFilterInput>;
  lastRanUtc?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  lsp?: InputMaybe<TblLspFilterInput>;
  lspId?: InputMaybe<ComparableInt32OperationFilterInput>;
  metrcProcessingJobTypeTemplate?: InputMaybe<MetrcProcessingJobTypeTemplateFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<BillOfMaterialFilterInput>>;
};

export type BillOfMaterialSortInput = {
  billOfMaterialsId?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  createdByNavigation?: InputMaybe<TblAuthUserSortInput>;
  createdOnUtc?: InputMaybe<SortEnumType>;
  deletedBy?: InputMaybe<SortEnumType>;
  deletedByNavigation?: InputMaybe<TblAuthUserSortInput>;
  deletedOnUtc?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  executionCount?: InputMaybe<SortEnumType>;
  isDeleted?: InputMaybe<SortEnumType>;
  isProcessingJob?: InputMaybe<SortEnumType>;
  laborHours?: InputMaybe<SortEnumType>;
  laborRate?: InputMaybe<SortEnumType>;
  lastEditedBy?: InputMaybe<SortEnumType>;
  lastEditedByNavigation?: InputMaybe<TblAuthUserSortInput>;
  lastEditedUtc?: InputMaybe<SortEnumType>;
  lastRanBy?: InputMaybe<SortEnumType>;
  lastRanByNavigation?: InputMaybe<TblAuthUserSortInput>;
  lastRanUtc?: InputMaybe<SortEnumType>;
  lsp?: InputMaybe<TblLspSortInput>;
  lspId?: InputMaybe<SortEnumType>;
  metrcProcessingJobTypeTemplate?: InputMaybe<MetrcProcessingJobTypeTemplateSortInput>;
  name?: InputMaybe<SortEnumType>;
};

export type BillOfMaterialsFile = {
  billOfMaterials?: Maybe<BillOfMaterial>;
  billOfMaterialsFileId: Scalars['Int'];
  billOfMaterialsId: Scalars['Int'];
  documentName: Scalars['String'];
  documentTypeId: Scalars['Int'];
  fileName?: Maybe<Scalars['String']>;
  fileUrl?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  userFileName?: Maybe<Scalars['String']>;
};

export type BillOfMaterialsFileFilterInput = {
  and?: InputMaybe<Array<BillOfMaterialsFileFilterInput>>;
  billOfMaterials?: InputMaybe<BillOfMaterialFilterInput>;
  billOfMaterialsFileId?: InputMaybe<ComparableInt32OperationFilterInput>;
  billOfMaterialsId?: InputMaybe<ComparableInt32OperationFilterInput>;
  documentName?: InputMaybe<StringOperationFilterInput>;
  documentTypeId?: InputMaybe<ComparableInt32OperationFilterInput>;
  fileName?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<BillOfMaterialsFileFilterInput>>;
  url?: InputMaybe<StringOperationFilterInput>;
  userFileName?: InputMaybe<StringOperationFilterInput>;
};

export type BillOfMaterialsImage = {
  altText?: Maybe<Scalars['String']>;
  billOfMaterials?: Maybe<BillOfMaterial>;
  billOfMaterialsId: Scalars['Int'];
  billOfMaterialsImageId: Scalars['Int'];
  imageFileName: Scalars['String'];
  imageUrl?: Maybe<Scalars['String']>;
};

export type BillOfMaterialsImageFilterInput = {
  altText?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<BillOfMaterialsImageFilterInput>>;
  billOfMaterials?: InputMaybe<BillOfMaterialFilterInput>;
  billOfMaterialsId?: InputMaybe<ComparableInt32OperationFilterInput>;
  billOfMaterialsImageId?: InputMaybe<ComparableInt32OperationFilterInput>;
  imageFileName?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<BillOfMaterialsImageFilterInput>>;
};

export type BillOfMaterialsInputItem = {
  billOfMaterials?: Maybe<BillOfMaterial>;
  billOfMaterialsId: Scalars['Int'];
  billOfMaterialsInputItemId: Scalars['Int'];
  billOfMaterialsOutputItem?: Maybe<BillOfMaterialsOutputItem>;
  billOfMaterialsOutputItemId: Scalars['Int'];
  inputType?: Maybe<InputItemType>;
  inputTypeId: Scalars['Byte'];
  product?: Maybe<TblWhseProduct>;
  productId?: Maybe<Scalars['Int']>;
  productType?: Maybe<TblWhseProductType>;
  productTypeId?: Maybe<Scalars['Int']>;
  quantity: Scalars['Decimal'];
  unit?: Maybe<Unit>;
  unitId: Scalars['Int'];
};

export type BillOfMaterialsInputItemFilterInput = {
  and?: InputMaybe<Array<BillOfMaterialsInputItemFilterInput>>;
  billOfMaterials?: InputMaybe<BillOfMaterialFilterInput>;
  billOfMaterialsId?: InputMaybe<ComparableInt32OperationFilterInput>;
  billOfMaterialsInputItemId?: InputMaybe<ComparableInt32OperationFilterInput>;
  billOfMaterialsOutputItem?: InputMaybe<BillOfMaterialsOutputItemFilterInput>;
  billOfMaterialsOutputItemId?: InputMaybe<ComparableInt32OperationFilterInput>;
  inputType?: InputMaybe<InputItemTypeFilterInput>;
  inputTypeId?: InputMaybe<ComparableByteOperationFilterInput>;
  or?: InputMaybe<Array<BillOfMaterialsInputItemFilterInput>>;
  product?: InputMaybe<TblWhseProductFilterInput>;
  productId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  productType?: InputMaybe<TblWhseProductTypeFilterInput>;
  productTypeId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  quantity?: InputMaybe<ComparableDecimalOperationFilterInput>;
  unit?: InputMaybe<UnitFilterInput>;
  unitId?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type BillOfMaterialsOutputItem = {
  billOfMaterials?: Maybe<BillOfMaterial>;
  billOfMaterialsId: Scalars['Int'];
  billOfMaterialsInputItems?: Maybe<Array<Maybe<BillOfMaterialsInputItem>>>;
  billOfMaterialsOutputItemId: Scalars['Int'];
  outputType?: Maybe<OutputItemType>;
  outputTypeId: Scalars['Byte'];
  product?: Maybe<TblWhseProduct>;
  productId?: Maybe<Scalars['Int']>;
  productType?: Maybe<TblWhseProductType>;
  productTypeId?: Maybe<Scalars['Int']>;
  quantity: Scalars['Decimal'];
  unit?: Maybe<Unit>;
  unitId: Scalars['Int'];
};

export type BillOfMaterialsOutputItemFilterInput = {
  and?: InputMaybe<Array<BillOfMaterialsOutputItemFilterInput>>;
  billOfMaterials?: InputMaybe<BillOfMaterialFilterInput>;
  billOfMaterialsId?: InputMaybe<ComparableInt32OperationFilterInput>;
  billOfMaterialsInputItems?: InputMaybe<ListFilterInputTypeOfBillOfMaterialsInputItemFilterInput>;
  billOfMaterialsOutputItemId?: InputMaybe<ComparableInt32OperationFilterInput>;
  or?: InputMaybe<Array<BillOfMaterialsOutputItemFilterInput>>;
  outputType?: InputMaybe<OutputItemTypeFilterInput>;
  outputTypeId?: InputMaybe<ComparableByteOperationFilterInput>;
  product?: InputMaybe<TblWhseProductFilterInput>;
  productId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  productType?: InputMaybe<TblWhseProductTypeFilterInput>;
  productTypeId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  quantity?: InputMaybe<ComparableDecimalOperationFilterInput>;
  unit?: InputMaybe<UnitFilterInput>;
  unitId?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type BirchmountControlInfo = {
  apiKey: Scalars['String'];
  birchmountLocId: Scalars['Int'];
  id: Scalars['Int'];
  isEnabled: Scalars['Boolean'];
  loc?: Maybe<TblLspLocation>;
  locId: Scalars['Int'];
  lsp?: Maybe<TblLsp>;
  lspId: Scalars['Int'];
};

export type BirchmountControlInfoFilterInput = {
  and?: InputMaybe<Array<BirchmountControlInfoFilterInput>>;
  apiKey?: InputMaybe<StringOperationFilterInput>;
  birchmountLocId?: InputMaybe<ComparableInt32OperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  isEnabled?: InputMaybe<BooleanOperationFilterInput>;
  loc?: InputMaybe<TblLspLocationFilterInput>;
  locId?: InputMaybe<ComparableInt32OperationFilterInput>;
  lsp?: InputMaybe<TblLspFilterInput>;
  lspId?: InputMaybe<ComparableInt32OperationFilterInput>;
  or?: InputMaybe<Array<BirchmountControlInfoFilterInput>>;
};

export type BooleanOperationFilterInput = {
  eq?: InputMaybe<Scalars['Boolean']>;
  neq?: InputMaybe<Scalars['Boolean']>;
};

export type Brand = {
  brandCatalogBrandId?: Maybe<Scalars['String']>;
  brandId: Scalars['Int'];
  brandName: Scalars['String'];
  discountBrandRestrictions?: Maybe<Array<Maybe<DiscountBrandRestriction>>>;
  inventoryAuditToBrands?: Maybe<Array<Maybe<InventoryAuditToBrand>>>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lsp?: Maybe<TblLsp>;
  lspId: Scalars['Int'];
  oldBrandId?: Maybe<Scalars['Int']>;
  tblWhseProducts?: Maybe<Array<Maybe<TblWhseProduct>>>;
};

export type BrandCollectionSegment = {
  items?: Maybe<Array<Maybe<Brand>>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

export type BrandFilterInput = {
  and?: InputMaybe<Array<BrandFilterInput>>;
  brandCatalogBrandId?: InputMaybe<StringOperationFilterInput>;
  brandId?: InputMaybe<ComparableInt32OperationFilterInput>;
  brandName?: InputMaybe<StringOperationFilterInput>;
  discountBrandRestrictions?: InputMaybe<ListFilterInputTypeOfDiscountBrandRestrictionFilterInput>;
  inventoryAuditToBrands?: InputMaybe<ListFilterInputTypeOfInventoryAuditToBrandFilterInput>;
  isDeleted?: InputMaybe<BooleanOperationFilterInput>;
  lsp?: InputMaybe<TblLspFilterInput>;
  lspId?: InputMaybe<ComparableInt32OperationFilterInput>;
  oldBrandId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  or?: InputMaybe<Array<BrandFilterInput>>;
  tblWhseProducts?: InputMaybe<ListFilterInputTypeOfTblWhseProductFilterInput>;
};

export type BrandSortInput = {
  brandCatalogBrandId?: InputMaybe<SortEnumType>;
  brandId?: InputMaybe<SortEnumType>;
  brandName?: InputMaybe<SortEnumType>;
  isDeleted?: InputMaybe<SortEnumType>;
  lsp?: InputMaybe<TblLspSortInput>;
  lspId?: InputMaybe<SortEnumType>;
  oldBrandId?: InputMaybe<SortEnumType>;
};

export type BulkAuditDetailUpdatesInput = {
  actualQty?: InputMaybe<Scalars['Decimal']>;
  comment?: InputMaybe<Scalars['String']>;
  reasonCode?: InputMaybe<Scalars['String']>;
};

export type BulkConfirmAuditDetailInput = {
  actualQty: Scalars['Decimal'];
  auditDetailId: Scalars['Int'];
  expectedQty: Scalars['Decimal'];
};

export type BulkConfirmCountError = GqlError | PackageQuantityChangedError;

export type BulkConfirmCountInput = {
  auditDetails?: InputMaybe<Array<InputMaybe<BulkConfirmAuditDetailInput>>>;
  auditId: Scalars['Int'];
  locId: Scalars['Int'];
  lspId: Scalars['Int'];
  reasonCode?: InputMaybe<Scalars['String']>;
  sessionId?: InputMaybe<Scalars['String']>;
  userId: Scalars['Int'];
};

export type BulkConfirmCountOutput = {
  totalRecordsUpdated: Scalars['Int'];
};

export type BulkConfirmCountPayload = {
  bulkConfirmCountOutput?: Maybe<BulkConfirmCountOutput>;
  errors?: Maybe<Array<BulkConfirmCountError>>;
};

export type BulkUpdateAuditDetailsInput = {
  auditDetailIds?: InputMaybe<Array<Scalars['Int']>>;
  bulkAuditDetailUpdates?: InputMaybe<BulkAuditDetailUpdatesInput>;
  locId: Scalars['Int'];
  lspId: Scalars['Int'];
  sessionId?: InputMaybe<Scalars['String']>;
  userId: Scalars['Int'];
};

export type Caregiver = {
  acct?: Maybe<TblAcct>;
  acctId: Scalars['Int'];
  caregiverAddress?: Maybe<Scalars['String']>;
  caregiverAddress2?: Maybe<Scalars['String']>;
  caregiverAddress3?: Maybe<Scalars['String']>;
  caregiverCity?: Maybe<Scalars['String']>;
  caregiverDoB?: Maybe<Scalars['DateTime']>;
  caregiverEmail?: Maybe<Scalars['String']>;
  caregiverExpirationDate?: Maybe<Scalars['DateTime']>;
  caregiverFirstName?: Maybe<Scalars['String']>;
  caregiverId: Scalars['Int'];
  caregiverIndex: Scalars['Byte'];
  caregiverLastName?: Maybe<Scalars['String']>;
  caregiverMjstateIdno?: Maybe<Scalars['String']>;
  caregiverNotes?: Maybe<Scalars['String']>;
  caregiverPhone?: Maybe<Scalars['String']>;
  caregiverPostalCode?: Maybe<Scalars['String']>;
  caregiverRelationship?: Maybe<Scalars['String']>;
  caregiverStartDate?: Maybe<Scalars['DateTime']>;
  caregiverState?: Maybe<Scalars['String']>;
};

export type CaregiverFilterInput = {
  acct?: InputMaybe<TblAcctFilterInput>;
  acctId?: InputMaybe<ComparableInt32OperationFilterInput>;
  and?: InputMaybe<Array<CaregiverFilterInput>>;
  caregiverAddress?: InputMaybe<StringOperationFilterInput>;
  caregiverAddress2?: InputMaybe<StringOperationFilterInput>;
  caregiverAddress3?: InputMaybe<StringOperationFilterInput>;
  caregiverCity?: InputMaybe<StringOperationFilterInput>;
  caregiverDoB?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  caregiverEmail?: InputMaybe<StringOperationFilterInput>;
  caregiverExpirationDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  caregiverFirstName?: InputMaybe<StringOperationFilterInput>;
  caregiverId?: InputMaybe<ComparableInt32OperationFilterInput>;
  caregiverIndex?: InputMaybe<ComparableByteOperationFilterInput>;
  caregiverLastName?: InputMaybe<StringOperationFilterInput>;
  caregiverMjstateIdno?: InputMaybe<StringOperationFilterInput>;
  caregiverNotes?: InputMaybe<StringOperationFilterInput>;
  caregiverPhone?: InputMaybe<StringOperationFilterInput>;
  caregiverPostalCode?: InputMaybe<StringOperationFilterInput>;
  caregiverRelationship?: InputMaybe<StringOperationFilterInput>;
  caregiverStartDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  caregiverState?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<CaregiverFilterInput>>;
};

export type CcrscontrolInfo = {
  emailErrorsTo?: Maybe<Scalars['String']>;
  enableAutomaticUpload: Scalars['Boolean'];
  id: Scalars['Int'];
  integratorId?: Maybe<Scalars['String']>;
  isEnabled: Scalars['Boolean'];
  licenseNumber?: Maybe<Scalars['String']>;
  loc?: Maybe<TblLspLocation>;
  locId: Scalars['Int'];
  lsp?: Maybe<TblLsp>;
  lspId: Scalars['Int'];
};

export type CcrscontrolInfoFilterInput = {
  and?: InputMaybe<Array<CcrscontrolInfoFilterInput>>;
  emailErrorsTo?: InputMaybe<StringOperationFilterInput>;
  enableAutomaticUpload?: InputMaybe<BooleanOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  integratorId?: InputMaybe<StringOperationFilterInput>;
  isEnabled?: InputMaybe<BooleanOperationFilterInput>;
  licenseNumber?: InputMaybe<StringOperationFilterInput>;
  loc?: InputMaybe<TblLspLocationFilterInput>;
  locId?: InputMaybe<ComparableInt32OperationFilterInput>;
  lsp?: InputMaybe<TblLspFilterInput>;
  lspId?: InputMaybe<ComparableInt32OperationFilterInput>;
  or?: InputMaybe<Array<CcrscontrolInfoFilterInput>>;
};

export type CloseAuditInput = {
  auditId: Scalars['Int'];
  bypassStateSystem: Scalars['Boolean'];
  locId: Scalars['Int'];
  lspId: Scalars['Int'];
  reasonCode?: InputMaybe<Scalars['String']>;
  sessionId?: InputMaybe<Scalars['String']>;
  userId: Scalars['Int'];
};

export type CloseAuditResponse = {
  auditId: Scalars['Int'];
};

/** Information about the offset pagination. */
export type CollectionSegmentInfo = {
  /** Indicates whether more items exist following the set defined by the clients arguments. */
  hasNextPage: Scalars['Boolean'];
  /** Indicates whether more items exist prior the set defined by the clients arguments. */
  hasPreviousPage: Scalars['Boolean'];
};

export type ComparableByteOperationFilterInput = {
  eq?: InputMaybe<Scalars['Byte']>;
  gt?: InputMaybe<Scalars['Byte']>;
  gte?: InputMaybe<Scalars['Byte']>;
  in?: InputMaybe<Array<Scalars['Byte']>>;
  lt?: InputMaybe<Scalars['Byte']>;
  lte?: InputMaybe<Scalars['Byte']>;
  neq?: InputMaybe<Scalars['Byte']>;
  ngt?: InputMaybe<Scalars['Byte']>;
  ngte?: InputMaybe<Scalars['Byte']>;
  nin?: InputMaybe<Array<Scalars['Byte']>>;
  nlt?: InputMaybe<Scalars['Byte']>;
  nlte?: InputMaybe<Scalars['Byte']>;
};

export type ComparableDateTimeOperationFilterInput = {
  eq?: InputMaybe<Scalars['DateTime']>;
  gt?: InputMaybe<Scalars['DateTime']>;
  gte?: InputMaybe<Scalars['DateTime']>;
  in?: InputMaybe<Array<Scalars['DateTime']>>;
  lt?: InputMaybe<Scalars['DateTime']>;
  lte?: InputMaybe<Scalars['DateTime']>;
  neq?: InputMaybe<Scalars['DateTime']>;
  ngt?: InputMaybe<Scalars['DateTime']>;
  ngte?: InputMaybe<Scalars['DateTime']>;
  nin?: InputMaybe<Array<Scalars['DateTime']>>;
  nlt?: InputMaybe<Scalars['DateTime']>;
  nlte?: InputMaybe<Scalars['DateTime']>;
};

export type ComparableDecimalOperationFilterInput = {
  eq?: InputMaybe<Scalars['Decimal']>;
  gt?: InputMaybe<Scalars['Decimal']>;
  gte?: InputMaybe<Scalars['Decimal']>;
  in?: InputMaybe<Array<Scalars['Decimal']>>;
  lt?: InputMaybe<Scalars['Decimal']>;
  lte?: InputMaybe<Scalars['Decimal']>;
  neq?: InputMaybe<Scalars['Decimal']>;
  ngt?: InputMaybe<Scalars['Decimal']>;
  ngte?: InputMaybe<Scalars['Decimal']>;
  nin?: InputMaybe<Array<Scalars['Decimal']>>;
  nlt?: InputMaybe<Scalars['Decimal']>;
  nlte?: InputMaybe<Scalars['Decimal']>;
};

export type ComparableGuidOperationFilterInput = {
  eq?: InputMaybe<Scalars['UUID']>;
  gt?: InputMaybe<Scalars['UUID']>;
  gte?: InputMaybe<Scalars['UUID']>;
  in?: InputMaybe<Array<Scalars['UUID']>>;
  lt?: InputMaybe<Scalars['UUID']>;
  lte?: InputMaybe<Scalars['UUID']>;
  neq?: InputMaybe<Scalars['UUID']>;
  ngt?: InputMaybe<Scalars['UUID']>;
  ngte?: InputMaybe<Scalars['UUID']>;
  nin?: InputMaybe<Array<Scalars['UUID']>>;
  nlt?: InputMaybe<Scalars['UUID']>;
  nlte?: InputMaybe<Scalars['UUID']>;
};

export type ComparableInt16OperationFilterInput = {
  eq?: InputMaybe<Scalars['Short']>;
  gt?: InputMaybe<Scalars['Short']>;
  gte?: InputMaybe<Scalars['Short']>;
  in?: InputMaybe<Array<Scalars['Short']>>;
  lt?: InputMaybe<Scalars['Short']>;
  lte?: InputMaybe<Scalars['Short']>;
  neq?: InputMaybe<Scalars['Short']>;
  ngt?: InputMaybe<Scalars['Short']>;
  ngte?: InputMaybe<Scalars['Short']>;
  nin?: InputMaybe<Array<Scalars['Short']>>;
  nlt?: InputMaybe<Scalars['Short']>;
  nlte?: InputMaybe<Scalars['Short']>;
};

export type ComparableInt32OperationFilterInput = {
  eq?: InputMaybe<Scalars['Int']>;
  gt?: InputMaybe<Scalars['Int']>;
  gte?: InputMaybe<Scalars['Int']>;
  in?: InputMaybe<Array<Scalars['Int']>>;
  lt?: InputMaybe<Scalars['Int']>;
  lte?: InputMaybe<Scalars['Int']>;
  neq?: InputMaybe<Scalars['Int']>;
  ngt?: InputMaybe<Scalars['Int']>;
  ngte?: InputMaybe<Scalars['Int']>;
  nin?: InputMaybe<Array<Scalars['Int']>>;
  nlt?: InputMaybe<Scalars['Int']>;
  nlte?: InputMaybe<Scalars['Int']>;
};

export type ComparableInt64OperationFilterInput = {
  eq?: InputMaybe<Scalars['Long']>;
  gt?: InputMaybe<Scalars['Long']>;
  gte?: InputMaybe<Scalars['Long']>;
  in?: InputMaybe<Array<Scalars['Long']>>;
  lt?: InputMaybe<Scalars['Long']>;
  lte?: InputMaybe<Scalars['Long']>;
  neq?: InputMaybe<Scalars['Long']>;
  ngt?: InputMaybe<Scalars['Long']>;
  ngte?: InputMaybe<Scalars['Long']>;
  nin?: InputMaybe<Array<Scalars['Long']>>;
  nlt?: InputMaybe<Scalars['Long']>;
  nlte?: InputMaybe<Scalars['Long']>;
};

export type ComparableNullableOfByteOperationFilterInput = {
  eq?: InputMaybe<Scalars['Byte']>;
  gt?: InputMaybe<Scalars['Byte']>;
  gte?: InputMaybe<Scalars['Byte']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Byte']>>>;
  lt?: InputMaybe<Scalars['Byte']>;
  lte?: InputMaybe<Scalars['Byte']>;
  neq?: InputMaybe<Scalars['Byte']>;
  ngt?: InputMaybe<Scalars['Byte']>;
  ngte?: InputMaybe<Scalars['Byte']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Byte']>>>;
  nlt?: InputMaybe<Scalars['Byte']>;
  nlte?: InputMaybe<Scalars['Byte']>;
};

export type ComparableNullableOfDateTimeOperationFilterInput = {
  eq?: InputMaybe<Scalars['DateTime']>;
  gt?: InputMaybe<Scalars['DateTime']>;
  gte?: InputMaybe<Scalars['DateTime']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  lt?: InputMaybe<Scalars['DateTime']>;
  lte?: InputMaybe<Scalars['DateTime']>;
  neq?: InputMaybe<Scalars['DateTime']>;
  ngt?: InputMaybe<Scalars['DateTime']>;
  ngte?: InputMaybe<Scalars['DateTime']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  nlt?: InputMaybe<Scalars['DateTime']>;
  nlte?: InputMaybe<Scalars['DateTime']>;
};

export type ComparableNullableOfDecimalOperationFilterInput = {
  eq?: InputMaybe<Scalars['Decimal']>;
  gt?: InputMaybe<Scalars['Decimal']>;
  gte?: InputMaybe<Scalars['Decimal']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Decimal']>>>;
  lt?: InputMaybe<Scalars['Decimal']>;
  lte?: InputMaybe<Scalars['Decimal']>;
  neq?: InputMaybe<Scalars['Decimal']>;
  ngt?: InputMaybe<Scalars['Decimal']>;
  ngte?: InputMaybe<Scalars['Decimal']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Decimal']>>>;
  nlt?: InputMaybe<Scalars['Decimal']>;
  nlte?: InputMaybe<Scalars['Decimal']>;
};

export type ComparableNullableOfGuidOperationFilterInput = {
  eq?: InputMaybe<Scalars['UUID']>;
  gt?: InputMaybe<Scalars['UUID']>;
  gte?: InputMaybe<Scalars['UUID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  lt?: InputMaybe<Scalars['UUID']>;
  lte?: InputMaybe<Scalars['UUID']>;
  neq?: InputMaybe<Scalars['UUID']>;
  ngt?: InputMaybe<Scalars['UUID']>;
  ngte?: InputMaybe<Scalars['UUID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  nlt?: InputMaybe<Scalars['UUID']>;
  nlte?: InputMaybe<Scalars['UUID']>;
};

export type ComparableNullableOfInt16OperationFilterInput = {
  eq?: InputMaybe<Scalars['Short']>;
  gt?: InputMaybe<Scalars['Short']>;
  gte?: InputMaybe<Scalars['Short']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Short']>>>;
  lt?: InputMaybe<Scalars['Short']>;
  lte?: InputMaybe<Scalars['Short']>;
  neq?: InputMaybe<Scalars['Short']>;
  ngt?: InputMaybe<Scalars['Short']>;
  ngte?: InputMaybe<Scalars['Short']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Short']>>>;
  nlt?: InputMaybe<Scalars['Short']>;
  nlte?: InputMaybe<Scalars['Short']>;
};

export type ComparableNullableOfInt32OperationFilterInput = {
  eq?: InputMaybe<Scalars['Int']>;
  gt?: InputMaybe<Scalars['Int']>;
  gte?: InputMaybe<Scalars['Int']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  lt?: InputMaybe<Scalars['Int']>;
  lte?: InputMaybe<Scalars['Int']>;
  neq?: InputMaybe<Scalars['Int']>;
  ngt?: InputMaybe<Scalars['Int']>;
  ngte?: InputMaybe<Scalars['Int']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  nlt?: InputMaybe<Scalars['Int']>;
  nlte?: InputMaybe<Scalars['Int']>;
};

export type ComparableNullableOfInt64OperationFilterInput = {
  eq?: InputMaybe<Scalars['Long']>;
  gt?: InputMaybe<Scalars['Long']>;
  gte?: InputMaybe<Scalars['Long']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Long']>>>;
  lt?: InputMaybe<Scalars['Long']>;
  lte?: InputMaybe<Scalars['Long']>;
  neq?: InputMaybe<Scalars['Long']>;
  ngt?: InputMaybe<Scalars['Long']>;
  ngte?: InputMaybe<Scalars['Long']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Long']>>>;
  nlt?: InputMaybe<Scalars['Long']>;
  nlte?: InputMaybe<Scalars['Long']>;
};

export type ComparableNullableOfTimeSpanOperationFilterInput = {
  eq?: InputMaybe<Scalars['TimeSpan']>;
  gt?: InputMaybe<Scalars['TimeSpan']>;
  gte?: InputMaybe<Scalars['TimeSpan']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['TimeSpan']>>>;
  lt?: InputMaybe<Scalars['TimeSpan']>;
  lte?: InputMaybe<Scalars['TimeSpan']>;
  neq?: InputMaybe<Scalars['TimeSpan']>;
  ngt?: InputMaybe<Scalars['TimeSpan']>;
  ngte?: InputMaybe<Scalars['TimeSpan']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['TimeSpan']>>>;
  nlt?: InputMaybe<Scalars['TimeSpan']>;
  nlte?: InputMaybe<Scalars['TimeSpan']>;
};

export type CostType = {
  assemblyOutputItems?: Maybe<Array<Maybe<AssemblyOutputItem>>>;
  costTypeId: Scalars['Byte'];
  name: Scalars['String'];
};

export type CostTypeFilterInput = {
  and?: InputMaybe<Array<CostTypeFilterInput>>;
  assemblyOutputItems?: InputMaybe<ListFilterInputTypeOfAssemblyOutputItemFilterInput>;
  costTypeId?: InputMaybe<ComparableByteOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<CostTypeFilterInput>>;
};

export type County = {
  countryCode: Scalars['String'];
  countyId: Scalars['Int'];
  countyName: Scalars['String'];
  deliveryZoneCounties?: Maybe<Array<Maybe<DeliveryZoneCounty>>>;
  stateCode: Scalars['String'];
  wikiId: Scalars['String'];
};

export type CountyFilterInput = {
  and?: InputMaybe<Array<CountyFilterInput>>;
  countryCode?: InputMaybe<StringOperationFilterInput>;
  countyId?: InputMaybe<ComparableInt32OperationFilterInput>;
  countyName?: InputMaybe<StringOperationFilterInput>;
  deliveryZoneCounties?: InputMaybe<ListFilterInputTypeOfDeliveryZoneCountyFilterInput>;
  or?: InputMaybe<Array<CountyFilterInput>>;
  stateCode?: InputMaybe<StringOperationFilterInput>;
  wikiId?: InputMaybe<StringOperationFilterInput>;
};

export type CreateAuditFromPackagesInput = {
  isBlind: Scalars['Boolean'];
  isScan?: InputMaybe<Scalars['Boolean']>;
  locId: Scalars['Int'];
  lspId: Scalars['Int'];
  packageIds: Array<Scalars['Int']>;
  sessionId?: InputMaybe<Scalars['String']>;
  userId: Scalars['Int'];
  workflowId?: Scalars['Int'];
};

export type CreateAuditFromPackagesResponse = {
  auditDetailCount?: Maybe<Scalars['Int']>;
  auditId?: Maybe<Scalars['Int']>;
};

export type CreateAuditInput = {
  brandIds?: InputMaybe<Array<Scalars['Int']>>;
  isBlind: Scalars['Boolean'];
  isScan: Scalars['Boolean'];
  locId: Scalars['Int'];
  lspId: Scalars['Int'];
  masterCategory?: InputMaybe<Scalars['String']>;
  productCategoryIds?: InputMaybe<Array<Scalars['Int']>>;
  roomIds?: InputMaybe<Array<Scalars['Int']>>;
  sessionId?: InputMaybe<Scalars['String']>;
  userId: Scalars['Int'];
  workflowId: Scalars['Int'];
};

export type CultivationMetadataTag = {
  lspId?: Maybe<Scalars['Int']>;
  plants?: Maybe<Array<Maybe<TblMdbatchPlantId>>>;
  tag?: Maybe<Scalars['String']>;
  tagId: Scalars['Int'];
};

export type CultivationMetadataTagFilterInput = {
  and?: InputMaybe<Array<CultivationMetadataTagFilterInput>>;
  lspId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  or?: InputMaybe<Array<CultivationMetadataTagFilterInput>>;
  plants?: InputMaybe<ListFilterInputTypeOfTblMdbatchPlantIdFilterInput>;
  tag?: InputMaybe<StringOperationFilterInput>;
  tagId?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type CustomerType = {
  customerTypeId: Scalars['Int'];
  customerTypeName: Scalars['String'];
  isMedical: Scalars['Boolean'];
  isRetail: Scalars['Boolean'];
  packageToCustomerTypes?: Maybe<Array<Maybe<PackageToCustomerType>>>;
  productToCustomerTypes?: Maybe<Array<Maybe<ProductToCustomerType>>>;
  productTypeToCustomerTypes?: Maybe<Array<Maybe<ProductTypeToCustomerType>>>;
};

export type CustomerTypeFilterInput = {
  and?: InputMaybe<Array<CustomerTypeFilterInput>>;
  customerTypeId?: InputMaybe<ComparableInt32OperationFilterInput>;
  customerTypeName?: InputMaybe<StringOperationFilterInput>;
  isMedical?: InputMaybe<BooleanOperationFilterInput>;
  isRetail?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<CustomerTypeFilterInput>>;
  packageToCustomerTypes?: InputMaybe<ListFilterInputTypeOfPackageToCustomerTypeFilterInput>;
  productToCustomerTypes?: InputMaybe<ListFilterInputTypeOfProductToCustomerTypeFilterInput>;
  productTypeToCustomerTypes?: InputMaybe<ListFilterInputTypeOfProductTypeToCustomerTypeFilterInput>;
};

export type DcdirectControlInfo = {
  baseUrl: Scalars['String'];
  feeCeiling?: Maybe<Scalars['Decimal']>;
  isEnabled: Scalars['Boolean'];
  isTippingEnabled: Scalars['Boolean'];
  loc?: Maybe<TblLspLocation>;
  locId: Scalars['Int'];
  lsp?: Maybe<TblLsp>;
  lspId: Scalars['Int'];
  merchantId: Scalars['String'];
  timeoutSeconds: Scalars['Int'];
};

export type DcdirectControlInfoFilterInput = {
  and?: InputMaybe<Array<DcdirectControlInfoFilterInput>>;
  baseUrl?: InputMaybe<StringOperationFilterInput>;
  feeCeiling?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  isEnabled?: InputMaybe<BooleanOperationFilterInput>;
  isTippingEnabled?: InputMaybe<BooleanOperationFilterInput>;
  loc?: InputMaybe<TblLspLocationFilterInput>;
  locId?: InputMaybe<ComparableInt32OperationFilterInput>;
  lsp?: InputMaybe<TblLspFilterInput>;
  lspId?: InputMaybe<ComparableInt32OperationFilterInput>;
  merchantId?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<DcdirectControlInfoFilterInput>>;
  timeoutSeconds?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type DeleteAuditStatusInput = {
  auditId: Scalars['Int'];
  locId: Scalars['Int'];
  lspId: Scalars['Int'];
  sessionId?: InputMaybe<Scalars['String']>;
  userId: Scalars['Int'];
};

export type DeliveryRoute = {
  car?: Maybe<TblMdcar>;
  carId?: Maybe<Scalars['Int']>;
  deliveryRouteHistories?: Maybe<Array<Maybe<DeliveryRouteHistory>>>;
  deliveryRouteId: Scalars['Int'];
  deliveryStatusId?: Maybe<Scalars['Int']>;
  driver1?: Maybe<TblMddriver>;
  driver1Id?: Maybe<Scalars['Int']>;
  driver2?: Maybe<TblMddriver>;
  driver2Id?: Maybe<Scalars['Int']>;
  endUtc?: Maybe<Scalars['DateTime']>;
  locId: Scalars['Int'];
  lspId: Scalars['Int'];
  mdManifests?: Maybe<Array<Maybe<MdManifest>>>;
  note?: Maybe<Scalars['String']>;
  startUtc?: Maybe<Scalars['DateTime']>;
  tblMdcars?: Maybe<Array<Maybe<TblMdcar>>>;
};

export type DeliveryRouteAction = {
  actionName: Scalars['String'];
  deliveryRouteActionId: Scalars['Int'];
  deliveryRouteHistories?: Maybe<Array<Maybe<DeliveryRouteHistory>>>;
};

export type DeliveryRouteActionFilterInput = {
  actionName?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<DeliveryRouteActionFilterInput>>;
  deliveryRouteActionId?: InputMaybe<ComparableInt32OperationFilterInput>;
  deliveryRouteHistories?: InputMaybe<ListFilterInputTypeOfDeliveryRouteHistoryFilterInput>;
  or?: InputMaybe<Array<DeliveryRouteActionFilterInput>>;
};

export type DeliveryRouteFilterInput = {
  and?: InputMaybe<Array<DeliveryRouteFilterInput>>;
  car?: InputMaybe<TblMdcarFilterInput>;
  carId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  deliveryRouteHistories?: InputMaybe<ListFilterInputTypeOfDeliveryRouteHistoryFilterInput>;
  deliveryRouteId?: InputMaybe<ComparableInt32OperationFilterInput>;
  deliveryStatusId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  driver1?: InputMaybe<TblMddriverFilterInput>;
  driver1Id?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  driver2?: InputMaybe<TblMddriverFilterInput>;
  driver2Id?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  endUtc?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  locId?: InputMaybe<ComparableInt32OperationFilterInput>;
  lspId?: InputMaybe<ComparableInt32OperationFilterInput>;
  mdManifests?: InputMaybe<ListFilterInputTypeOfMdManifestFilterInput>;
  note?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<DeliveryRouteFilterInput>>;
  startUtc?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  tblMdcars?: InputMaybe<ListFilterInputTypeOfTblMdcarFilterInput>;
};

export type DeliveryRouteHistory = {
  car?: Maybe<TblMdcar>;
  carId?: Maybe<Scalars['Int']>;
  deliveryRoute?: Maybe<DeliveryRoute>;
  deliveryRouteAction?: Maybe<DeliveryRouteAction>;
  deliveryRouteActionId: Scalars['Int'];
  deliveryRouteHistoryId: Scalars['Int'];
  deliveryRouteId: Scalars['Int'];
  driver1?: Maybe<TblMddriver>;
  driver1Id?: Maybe<Scalars['Int']>;
  driver2?: Maybe<TblMddriver>;
  driver2Id?: Maybe<Scalars['Int']>;
  manifest?: Maybe<MdManifest>;
  manifestId?: Maybe<Scalars['Int']>;
  timestampUtc: Scalars['DateTime'];
  user?: Maybe<TblAuthUser>;
  userId: Scalars['Int'];
};

export type DeliveryRouteHistoryFilterInput = {
  and?: InputMaybe<Array<DeliveryRouteHistoryFilterInput>>;
  car?: InputMaybe<TblMdcarFilterInput>;
  carId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  deliveryRoute?: InputMaybe<DeliveryRouteFilterInput>;
  deliveryRouteAction?: InputMaybe<DeliveryRouteActionFilterInput>;
  deliveryRouteActionId?: InputMaybe<ComparableInt32OperationFilterInput>;
  deliveryRouteHistoryId?: InputMaybe<ComparableInt32OperationFilterInput>;
  deliveryRouteId?: InputMaybe<ComparableInt32OperationFilterInput>;
  driver1?: InputMaybe<TblMddriverFilterInput>;
  driver1Id?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  driver2?: InputMaybe<TblMddriverFilterInput>;
  driver2Id?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  manifest?: InputMaybe<MdManifestFilterInput>;
  manifestId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  or?: InputMaybe<Array<DeliveryRouteHistoryFilterInput>>;
  timestampUtc?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  user?: InputMaybe<TblAuthUserFilterInput>;
  userId?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type DeliveryRouteSortInput = {
  car?: InputMaybe<TblMdcarSortInput>;
  carId?: InputMaybe<SortEnumType>;
  deliveryRouteId?: InputMaybe<SortEnumType>;
  deliveryStatusId?: InputMaybe<SortEnumType>;
  driver1?: InputMaybe<TblMddriverSortInput>;
  driver1Id?: InputMaybe<SortEnumType>;
  driver2?: InputMaybe<TblMddriverSortInput>;
  driver2Id?: InputMaybe<SortEnumType>;
  endUtc?: InputMaybe<SortEnumType>;
  locId?: InputMaybe<SortEnumType>;
  lspId?: InputMaybe<SortEnumType>;
  note?: InputMaybe<SortEnumType>;
  startUtc?: InputMaybe<SortEnumType>;
};

export type DeliveryZone = {
  cities?: Maybe<Array<Maybe<DeliveryZoneCity>>>;
  counties?: Maybe<Array<Maybe<DeliveryZoneCounty>>>;
  feeDonations?: Maybe<Array<Maybe<FeeDonation>>>;
  loc?: Maybe<TblLspLocation>;
  locId: Scalars['Int'];
  lsp?: Maybe<TblLsp>;
  lspId: Scalars['Int'];
  maxRadius?: Maybe<Scalars['Decimal']>;
  minRadius?: Maybe<Scalars['Decimal']>;
  name: Scalars['String'];
  note?: Maybe<Scalars['String']>;
  taxRates?: Maybe<Array<Maybe<TaxRate>>>;
  zipCodes?: Maybe<Array<Maybe<DeliveryZoneZip>>>;
  zoneId: Scalars['Int'];
  zoneType: Scalars['Int'];
  zoneTypeNavigation?: Maybe<DeliveryZoneType>;
};

export type DeliveryZoneCity = {
  cityName?: Maybe<Scalars['String']>;
  zoneId: Scalars['Int'];
};

export type DeliveryZoneCityFilterInput = {
  and?: InputMaybe<Array<DeliveryZoneCityFilterInput>>;
  cityName?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<DeliveryZoneCityFilterInput>>;
  zoneId?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type DeliveryZoneCollectionSegment = {
  items?: Maybe<Array<Maybe<DeliveryZone>>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

export type DeliveryZoneCounty = {
  county?: Maybe<County>;
  countyId: Scalars['Int'];
  zoneId: Scalars['Int'];
};

export type DeliveryZoneCountyFilterInput = {
  and?: InputMaybe<Array<DeliveryZoneCountyFilterInput>>;
  county?: InputMaybe<CountyFilterInput>;
  countyId?: InputMaybe<ComparableInt32OperationFilterInput>;
  or?: InputMaybe<Array<DeliveryZoneCountyFilterInput>>;
  zoneId?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type DeliveryZoneFilterInput = {
  and?: InputMaybe<Array<DeliveryZoneFilterInput>>;
  cities?: InputMaybe<ListFilterInputTypeOfDeliveryZoneCityFilterInput>;
  counties?: InputMaybe<ListFilterInputTypeOfDeliveryZoneCountyFilterInput>;
  feeDonations?: InputMaybe<ListFilterInputTypeOfFeeDonationFilterInput>;
  loc?: InputMaybe<TblLspLocationFilterInput>;
  locId?: InputMaybe<ComparableInt32OperationFilterInput>;
  lsp?: InputMaybe<TblLspFilterInput>;
  lspId?: InputMaybe<ComparableInt32OperationFilterInput>;
  maxRadius?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  minRadius?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  note?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<DeliveryZoneFilterInput>>;
  taxRates?: InputMaybe<ListFilterInputTypeOfTaxRateFilterInput>;
  zipCodes?: InputMaybe<ListFilterInputTypeOfDeliveryZoneZipFilterInput>;
  zoneId?: InputMaybe<ComparableInt32OperationFilterInput>;
  zoneType?: InputMaybe<ComparableInt32OperationFilterInput>;
  zoneTypeNavigation?: InputMaybe<DeliveryZoneTypeFilterInput>;
};

export type DeliveryZoneSortInput = {
  loc?: InputMaybe<TblLspLocationSortInput>;
  locId?: InputMaybe<SortEnumType>;
  lsp?: InputMaybe<TblLspSortInput>;
  lspId?: InputMaybe<SortEnumType>;
  maxRadius?: InputMaybe<SortEnumType>;
  minRadius?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  note?: InputMaybe<SortEnumType>;
  zoneId?: InputMaybe<SortEnumType>;
  zoneType?: InputMaybe<SortEnumType>;
  zoneTypeNavigation?: InputMaybe<DeliveryZoneTypeSortInput>;
};

export type DeliveryZoneType = {
  deliveryZones?: Maybe<Array<Maybe<DeliveryZone>>>;
  typeId: Scalars['Int'];
  typeName: Scalars['String'];
};

export type DeliveryZoneTypeFilterInput = {
  and?: InputMaybe<Array<DeliveryZoneTypeFilterInput>>;
  deliveryZones?: InputMaybe<ListFilterInputTypeOfDeliveryZoneFilterInput>;
  or?: InputMaybe<Array<DeliveryZoneTypeFilterInput>>;
  typeId?: InputMaybe<ComparableInt32OperationFilterInput>;
  typeName?: InputMaybe<StringOperationFilterInput>;
};

export type DeliveryZoneTypeSortInput = {
  typeId?: InputMaybe<SortEnumType>;
  typeName?: InputMaybe<SortEnumType>;
};

export type DeliveryZoneZip = {
  zipcode?: Maybe<Scalars['String']>;
  zoneId: Scalars['Int'];
};

export type DeliveryZoneZipFilterInput = {
  and?: InputMaybe<Array<DeliveryZoneZipFilterInput>>;
  or?: InputMaybe<Array<DeliveryZoneZipFilterInput>>;
  zipcode?: InputMaybe<StringOperationFilterInput>;
  zoneId?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type Discount = {
  allocatedInventories?: Maybe<Array<Maybe<AllocatedInventory>>>;
  applicationMethod?: Maybe<DiscountApplicationMethod>;
  applicationMethodId?: Maybe<Scalars['Int']>;
  appliedDiscounts?: Maybe<Array<Maybe<AppliedDiscount>>>;
  canStackAutomatically: Scalars['Boolean'];
  discountCode?: Maybe<Scalars['String']>;
  discountConstraints?: Maybe<Array<Maybe<DiscountConstraint>>>;
  discountId: Scalars['Int'];
  discountName: Scalars['String'];
  discountRewards?: Maybe<Array<Maybe<DiscountReward>>>;
  discountToDiscountGroups?: Maybe<Array<Maybe<DiscountToDiscountGroup>>>;
  discountWeeklyRecurrences?: Maybe<Array<Maybe<DiscountWeeklyRecurrence>>>;
  externalId?: Maybe<Scalars['String']>;
  firstTimeCustomerOnly: Scalars['Int'];
  isAvailableOnline: Scalars['Boolean'];
  isBundledDiscount: Scalars['Boolean'];
  isDeleted: Scalars['Boolean'];
  loyaltyDiscountRedemptions?: Maybe<Array<Maybe<LoyaltyDiscountRedemption>>>;
  loyaltyPointValue?: Maybe<Scalars['Decimal']>;
  lsp?: Maybe<TblLsp>;
  lspId: Scalars['Int'];
  maxRedemptions?: Maybe<Scalars['Int']>;
  onlineName?: Maybe<Scalars['String']>;
  requireManagerApproval: Scalars['Boolean'];
  savedWithAdvancedOptions: Scalars['Boolean'];
  validDateFrom: Scalars['DateTime'];
  validDateTo: Scalars['DateTime'];
};

export type DiscountApplicationMethod = {
  discountApplicationMethod1?: Maybe<Scalars['String']>;
  discountApplicationMethodId: Scalars['Int'];
  discounts?: Maybe<Array<Maybe<Discount>>>;
};

export type DiscountApplicationMethodFilterInput = {
  and?: InputMaybe<Array<DiscountApplicationMethodFilterInput>>;
  discountApplicationMethod1?: InputMaybe<StringOperationFilterInput>;
  discountApplicationMethodId?: InputMaybe<ComparableInt32OperationFilterInput>;
  discounts?: InputMaybe<ListFilterInputTypeOfDiscountFilterInput>;
  or?: InputMaybe<Array<DiscountApplicationMethodFilterInput>>;
};

export type DiscountApplicationMethodSortInput = {
  discountApplicationMethod1?: InputMaybe<SortEnumType>;
  discountApplicationMethodId?: InputMaybe<SortEnumType>;
};

export type DiscountAudit = {
  auditAction?: Maybe<Scalars['AuditActionScalar']>;
  auditDateTimeUtc: Scalars['DateTime'];
  changedByUser?: Maybe<TblAuthUser>;
  discountAuditData?: Maybe<Array<Maybe<DiscountAuditDatum>>>;
  discountAuditId: Scalars['Int'];
  discountChanged?: Maybe<Discount>;
  discountId?: Maybe<Scalars['Int']>;
  lspId?: Maybe<Scalars['Int']>;
  sessionlocId?: Maybe<Scalars['Int']>;
  sessionlspId?: Maybe<Scalars['Int']>;
  userId?: Maybe<Scalars['Int']>;
};

export type DiscountAuditCollectionSegment = {
  items?: Maybe<Array<Maybe<DiscountAudit>>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

export type DiscountAuditDatum = {
  columnChanged?: Maybe<Scalars['String']>;
  discountAudit?: Maybe<DiscountAudit>;
  discountAuditId: Scalars['Int'];
  id: Scalars['Int'];
  newValue?: Maybe<Scalars['String']>;
  oldValue?: Maybe<Scalars['String']>;
};

export type DiscountAuditDatumFilterInput = {
  and?: InputMaybe<Array<DiscountAuditDatumFilterInput>>;
  columnChanged?: InputMaybe<StringOperationFilterInput>;
  discountAudit?: InputMaybe<DiscountAuditFilterInput>;
  discountAuditId?: InputMaybe<ComparableInt32OperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  newValue?: InputMaybe<StringOperationFilterInput>;
  oldValue?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<DiscountAuditDatumFilterInput>>;
};

export type DiscountAuditFilterInput = {
  and?: InputMaybe<Array<DiscountAuditFilterInput>>;
  auditAction?: InputMaybe<StringOperationFilterInput>;
  auditDateTimeUtc?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  discountAuditData?: InputMaybe<ListFilterInputTypeOfDiscountAuditDatumFilterInput>;
  discountAuditId?: InputMaybe<ComparableInt32OperationFilterInput>;
  discountChanged?: InputMaybe<DiscountFilterInput>;
  discountId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  lspId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  or?: InputMaybe<Array<DiscountAuditFilterInput>>;
  sessionlocId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  sessionlspId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  userId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
};

export type DiscountAuditSortInput = {
  auditAction?: InputMaybe<SortEnumType>;
  auditDateTimeUtc?: InputMaybe<SortEnumType>;
  discountAuditId?: InputMaybe<SortEnumType>;
  discountChanged?: InputMaybe<DiscountSortInput>;
  discountId?: InputMaybe<SortEnumType>;
  lspId?: InputMaybe<SortEnumType>;
  sessionlocId?: InputMaybe<SortEnumType>;
  sessionlspId?: InputMaybe<SortEnumType>;
  userId?: InputMaybe<SortEnumType>;
};

export type DiscountBrandRestriction = {
  brand?: Maybe<Brand>;
  brandId: Scalars['Int'];
  discountBrandRestrictionId: Scalars['Int'];
  discountConstraint?: Maybe<DiscountConstraint>;
  discountConstraintId?: Maybe<Scalars['Int']>;
  discountReward?: Maybe<DiscountReward>;
  discountRewardId?: Maybe<Scalars['Int']>;
  isExclusion: Scalars['Boolean'];
};

export type DiscountBrandRestrictionFilterInput = {
  and?: InputMaybe<Array<DiscountBrandRestrictionFilterInput>>;
  brand?: InputMaybe<BrandFilterInput>;
  brandId?: InputMaybe<ComparableInt32OperationFilterInput>;
  discountBrandRestrictionId?: InputMaybe<ComparableInt32OperationFilterInput>;
  discountConstraint?: InputMaybe<DiscountConstraintFilterInput>;
  discountConstraintId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  discountReward?: InputMaybe<DiscountRewardFilterInput>;
  discountRewardId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  isExclusion?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<DiscountBrandRestrictionFilterInput>>;
};

export type DiscountCategoryRestriction = {
  category?: Maybe<TblWhseProductType>;
  categoryId: Scalars['Int'];
  discountCategoryRestrictionId: Scalars['Int'];
  discountConstraint?: Maybe<DiscountConstraint>;
  discountConstraintId?: Maybe<Scalars['Int']>;
  discountReward?: Maybe<DiscountReward>;
  discountRewardId?: Maybe<Scalars['Int']>;
  isExclusion: Scalars['Boolean'];
};

export type DiscountCategoryRestrictionFilterInput = {
  and?: InputMaybe<Array<DiscountCategoryRestrictionFilterInput>>;
  category?: InputMaybe<TblWhseProductTypeFilterInput>;
  categoryId?: InputMaybe<ComparableInt32OperationFilterInput>;
  discountCategoryRestrictionId?: InputMaybe<ComparableInt32OperationFilterInput>;
  discountConstraint?: InputMaybe<DiscountConstraintFilterInput>;
  discountConstraintId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  discountReward?: InputMaybe<DiscountRewardFilterInput>;
  discountRewardId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  isExclusion?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<DiscountCategoryRestrictionFilterInput>>;
};

export type DiscountCollectionSegment = {
  items?: Maybe<Array<Maybe<Discount>>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

export type DiscountConstraint = {
  discount?: Maybe<Discount>;
  discountBrandRestrictions?: Maybe<Array<Maybe<DiscountBrandRestriction>>>;
  discountCategoryRestrictions?: Maybe<Array<Maybe<DiscountCategoryRestriction>>>;
  discountConstraintId: Scalars['Int'];
  discountCustomerTypeRestrictions?: Maybe<Array<Maybe<DiscountCustomerTypeRestriction>>>;
  discountId: Scalars['Int'];
  discountInventoryTagRestrictions?: Maybe<Array<Maybe<DiscountInventoryTagRestriction>>>;
  discountItemGroupTypeId?: Maybe<Scalars['Int']>;
  discountStrainRestrictions?: Maybe<Array<Maybe<DiscountStrainRestriction>>>;
  discountTagRestrictions?: Maybe<Array<Maybe<DiscountTagRestriction>>>;
  discountTierRestrictions?: Maybe<Array<Maybe<DiscountTierRestriction>>>;
  discountVendorRestrictions?: Maybe<Array<Maybe<DiscountVendorRestriction>>>;
  includeNonCannabis: Scalars['Boolean'];
  mddiscountProducts?: Maybe<Array<Maybe<MddiscountProduct>>>;
  thresholdMax?: Maybe<Scalars['Decimal']>;
  thresholdMin?: Maybe<Scalars['Decimal']>;
  thresholdTypeId?: Maybe<Scalars['Int']>;
};

export type DiscountConstraintFilterInput = {
  and?: InputMaybe<Array<DiscountConstraintFilterInput>>;
  discount?: InputMaybe<DiscountFilterInput>;
  discountBrandRestrictions?: InputMaybe<ListFilterInputTypeOfDiscountBrandRestrictionFilterInput>;
  discountCategoryRestrictions?: InputMaybe<ListFilterInputTypeOfDiscountCategoryRestrictionFilterInput>;
  discountConstraintId?: InputMaybe<ComparableInt32OperationFilterInput>;
  discountCustomerTypeRestrictions?: InputMaybe<ListFilterInputTypeOfDiscountCustomerTypeRestrictionFilterInput>;
  discountId?: InputMaybe<ComparableInt32OperationFilterInput>;
  discountInventoryTagRestrictions?: InputMaybe<ListFilterInputTypeOfDiscountInventoryTagRestrictionFilterInput>;
  discountItemGroupTypeId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  discountStrainRestrictions?: InputMaybe<ListFilterInputTypeOfDiscountStrainRestrictionFilterInput>;
  discountTagRestrictions?: InputMaybe<ListFilterInputTypeOfDiscountTagRestrictionFilterInput>;
  discountTierRestrictions?: InputMaybe<ListFilterInputTypeOfDiscountTierRestrictionFilterInput>;
  discountVendorRestrictions?: InputMaybe<ListFilterInputTypeOfDiscountVendorRestrictionFilterInput>;
  includeNonCannabis?: InputMaybe<BooleanOperationFilterInput>;
  mddiscountProducts?: InputMaybe<ListFilterInputTypeOfMddiscountProductFilterInput>;
  or?: InputMaybe<Array<DiscountConstraintFilterInput>>;
  thresholdMax?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  thresholdMin?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  thresholdTypeId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
};

export type DiscountCustomerTypeRestriction = {
  customerTypeId?: Maybe<Scalars['Int']>;
  discountConstraint?: Maybe<DiscountConstraint>;
  discountConstraintId?: Maybe<Scalars['Int']>;
  discountCustomerTypeRestrictionId: Scalars['Int'];
  discountReward?: Maybe<DiscountReward>;
  discountRewardId?: Maybe<Scalars['Int']>;
  isExclusion: Scalars['Boolean'];
};

export type DiscountCustomerTypeRestrictionFilterInput = {
  and?: InputMaybe<Array<DiscountCustomerTypeRestrictionFilterInput>>;
  customerTypeId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  discountConstraint?: InputMaybe<DiscountConstraintFilterInput>;
  discountConstraintId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  discountCustomerTypeRestrictionId?: InputMaybe<ComparableInt32OperationFilterInput>;
  discountReward?: InputMaybe<DiscountRewardFilterInput>;
  discountRewardId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  isExclusion?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<DiscountCustomerTypeRestrictionFilterInput>>;
};

export type DiscountFilterInput = {
  allocatedInventories?: InputMaybe<ListFilterInputTypeOfAllocatedInventoryFilterInput>;
  and?: InputMaybe<Array<DiscountFilterInput>>;
  applicationMethod?: InputMaybe<DiscountApplicationMethodFilterInput>;
  applicationMethodId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  appliedDiscounts?: InputMaybe<ListFilterInputTypeOfAppliedDiscountFilterInput>;
  canStackAutomatically?: InputMaybe<BooleanOperationFilterInput>;
  discountCode?: InputMaybe<StringOperationFilterInput>;
  discountConstraints?: InputMaybe<ListFilterInputTypeOfDiscountConstraintFilterInput>;
  discountId?: InputMaybe<ComparableInt32OperationFilterInput>;
  discountName?: InputMaybe<StringOperationFilterInput>;
  discountRewards?: InputMaybe<ListFilterInputTypeOfDiscountRewardFilterInput>;
  discountToDiscountGroups?: InputMaybe<ListFilterInputTypeOfDiscountToDiscountGroupFilterInput>;
  discountWeeklyRecurrences?: InputMaybe<ListFilterInputTypeOfDiscountWeeklyRecurrenceFilterInput>;
  externalId?: InputMaybe<StringOperationFilterInput>;
  firstTimeCustomerOnly?: InputMaybe<ComparableInt32OperationFilterInput>;
  isAvailableOnline?: InputMaybe<BooleanOperationFilterInput>;
  isBundledDiscount?: InputMaybe<BooleanOperationFilterInput>;
  isDeleted?: InputMaybe<BooleanOperationFilterInput>;
  loyaltyDiscountRedemptions?: InputMaybe<ListFilterInputTypeOfLoyaltyDiscountRedemptionFilterInput>;
  loyaltyPointValue?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  lsp?: InputMaybe<TblLspFilterInput>;
  lspId?: InputMaybe<ComparableInt32OperationFilterInput>;
  maxRedemptions?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  onlineName?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<DiscountFilterInput>>;
  requireManagerApproval?: InputMaybe<BooleanOperationFilterInput>;
  savedWithAdvancedOptions?: InputMaybe<BooleanOperationFilterInput>;
  validDateFrom?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  validDateTo?: InputMaybe<ComparableDateTimeOperationFilterInput>;
};

export type DiscountInventoryTagRestriction = {
  discountConstraint?: Maybe<DiscountConstraint>;
  discountConstraintId?: Maybe<Scalars['Int']>;
  discountInventoryTagRestrictionId: Scalars['Int'];
  discountReward?: Maybe<DiscountReward>;
  discountRewardId?: Maybe<Scalars['Int']>;
  isExclusion: Scalars['Boolean'];
  tag?: Maybe<Tag>;
  tagId?: Maybe<Scalars['Int']>;
};

export type DiscountInventoryTagRestrictionFilterInput = {
  and?: InputMaybe<Array<DiscountInventoryTagRestrictionFilterInput>>;
  discountConstraint?: InputMaybe<DiscountConstraintFilterInput>;
  discountConstraintId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  discountInventoryTagRestrictionId?: InputMaybe<ComparableInt32OperationFilterInput>;
  discountReward?: InputMaybe<DiscountRewardFilterInput>;
  discountRewardId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  isExclusion?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<DiscountInventoryTagRestrictionFilterInput>>;
  tag?: InputMaybe<TagFilterInput>;
  tagId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
};

export type DiscountReward = {
  applyToOnlyOneItem?: Maybe<Scalars['Boolean']>;
  calculationMethodId: Scalars['Int'];
  discount?: Maybe<Discount>;
  discountBrandRestrictions?: Maybe<Array<Maybe<DiscountBrandRestriction>>>;
  discountCategoryRestrictions?: Maybe<Array<Maybe<DiscountCategoryRestriction>>>;
  discountCustomerTypeRestrictions?: Maybe<Array<Maybe<DiscountCustomerTypeRestriction>>>;
  discountId: Scalars['Int'];
  discountInventoryTagRestrictions?: Maybe<Array<Maybe<DiscountInventoryTagRestriction>>>;
  discountRewardId: Scalars['Int'];
  discountStrainRestrictions?: Maybe<Array<Maybe<DiscountStrainRestriction>>>;
  discountTagRestrictions?: Maybe<Array<Maybe<DiscountTagRestriction>>>;
  discountTierRestrictions?: Maybe<Array<Maybe<DiscountTierRestriction>>>;
  discountValue?: Maybe<Scalars['Decimal']>;
  discountVendorRestrictions?: Maybe<Array<Maybe<DiscountVendorRestriction>>>;
  highestOrLowest?: Maybe<Scalars['String']>;
  includeNonCannabis: Scalars['Boolean'];
  itemGroupTypeId?: Maybe<Scalars['Int']>;
  manualDefaultApplyTo?: Maybe<Scalars['Int']>;
  mddiscountProducts?: Maybe<Array<Maybe<MddiscountProduct>>>;
  thresholdMax?: Maybe<Scalars['Decimal']>;
  thresholdMin?: Maybe<Scalars['Decimal']>;
  thresholdTypeId?: Maybe<Scalars['Int']>;
};

export type DiscountRewardFilterInput = {
  and?: InputMaybe<Array<DiscountRewardFilterInput>>;
  applyToOnlyOneItem?: InputMaybe<BooleanOperationFilterInput>;
  calculationMethodId?: InputMaybe<ComparableInt32OperationFilterInput>;
  discount?: InputMaybe<DiscountFilterInput>;
  discountBrandRestrictions?: InputMaybe<ListFilterInputTypeOfDiscountBrandRestrictionFilterInput>;
  discountCategoryRestrictions?: InputMaybe<ListFilterInputTypeOfDiscountCategoryRestrictionFilterInput>;
  discountCustomerTypeRestrictions?: InputMaybe<ListFilterInputTypeOfDiscountCustomerTypeRestrictionFilterInput>;
  discountId?: InputMaybe<ComparableInt32OperationFilterInput>;
  discountInventoryTagRestrictions?: InputMaybe<ListFilterInputTypeOfDiscountInventoryTagRestrictionFilterInput>;
  discountRewardId?: InputMaybe<ComparableInt32OperationFilterInput>;
  discountStrainRestrictions?: InputMaybe<ListFilterInputTypeOfDiscountStrainRestrictionFilterInput>;
  discountTagRestrictions?: InputMaybe<ListFilterInputTypeOfDiscountTagRestrictionFilterInput>;
  discountTierRestrictions?: InputMaybe<ListFilterInputTypeOfDiscountTierRestrictionFilterInput>;
  discountValue?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  discountVendorRestrictions?: InputMaybe<ListFilterInputTypeOfDiscountVendorRestrictionFilterInput>;
  highestOrLowest?: InputMaybe<StringOperationFilterInput>;
  includeNonCannabis?: InputMaybe<BooleanOperationFilterInput>;
  itemGroupTypeId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  manualDefaultApplyTo?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  mddiscountProducts?: InputMaybe<ListFilterInputTypeOfMddiscountProductFilterInput>;
  or?: InputMaybe<Array<DiscountRewardFilterInput>>;
  thresholdMax?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  thresholdMin?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  thresholdTypeId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
};

export type DiscountSortInput = {
  applicationMethod?: InputMaybe<DiscountApplicationMethodSortInput>;
  applicationMethodId?: InputMaybe<SortEnumType>;
  canStackAutomatically?: InputMaybe<SortEnumType>;
  discountCode?: InputMaybe<SortEnumType>;
  discountId?: InputMaybe<SortEnumType>;
  discountName?: InputMaybe<SortEnumType>;
  externalId?: InputMaybe<SortEnumType>;
  firstTimeCustomerOnly?: InputMaybe<SortEnumType>;
  isAvailableOnline?: InputMaybe<SortEnumType>;
  isBundledDiscount?: InputMaybe<SortEnumType>;
  isDeleted?: InputMaybe<SortEnumType>;
  loyaltyPointValue?: InputMaybe<SortEnumType>;
  lsp?: InputMaybe<TblLspSortInput>;
  lspId?: InputMaybe<SortEnumType>;
  maxRedemptions?: InputMaybe<SortEnumType>;
  onlineName?: InputMaybe<SortEnumType>;
  requireManagerApproval?: InputMaybe<SortEnumType>;
  savedWithAdvancedOptions?: InputMaybe<SortEnumType>;
  validDateFrom?: InputMaybe<SortEnumType>;
  validDateTo?: InputMaybe<SortEnumType>;
};

export type DiscountStrainRestriction = {
  discountConstraint?: Maybe<DiscountConstraint>;
  discountConstraintId?: Maybe<Scalars['Int']>;
  discountReward?: Maybe<DiscountReward>;
  discountRewardId?: Maybe<Scalars['Int']>;
  discountStrainRestrictionId: Scalars['Int'];
  isExclusion: Scalars['Boolean'];
  strain?: Maybe<TblBatchStrain>;
  strainId: Scalars['Int'];
};

export type DiscountStrainRestrictionFilterInput = {
  and?: InputMaybe<Array<DiscountStrainRestrictionFilterInput>>;
  discountConstraint?: InputMaybe<DiscountConstraintFilterInput>;
  discountConstraintId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  discountReward?: InputMaybe<DiscountRewardFilterInput>;
  discountRewardId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  discountStrainRestrictionId?: InputMaybe<ComparableInt32OperationFilterInput>;
  isExclusion?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<DiscountStrainRestrictionFilterInput>>;
  strain?: InputMaybe<TblBatchStrainFilterInput>;
  strainId?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type DiscountTagRestriction = {
  discountConstraint?: Maybe<DiscountConstraint>;
  discountConstraintId?: Maybe<Scalars['Int']>;
  discountReward?: Maybe<DiscountReward>;
  discountRewardId?: Maybe<Scalars['Int']>;
  discountTagRestrictionId: Scalars['Int'];
  isExclusion: Scalars['Boolean'];
  tag?: Maybe<Tag>;
  tagId?: Maybe<Scalars['Int']>;
};

export type DiscountTagRestrictionFilterInput = {
  and?: InputMaybe<Array<DiscountTagRestrictionFilterInput>>;
  discountConstraint?: InputMaybe<DiscountConstraintFilterInput>;
  discountConstraintId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  discountReward?: InputMaybe<DiscountRewardFilterInput>;
  discountRewardId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  discountTagRestrictionId?: InputMaybe<ComparableInt32OperationFilterInput>;
  isExclusion?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<DiscountTagRestrictionFilterInput>>;
  tag?: InputMaybe<TagFilterInput>;
  tagId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
};

export type DiscountTierRestriction = {
  chargeCode?: Maybe<TblChargeCodesSet>;
  chargeCodeId?: Maybe<Scalars['Int']>;
  discountConstraint?: Maybe<DiscountConstraint>;
  discountConstraintId?: Maybe<Scalars['Int']>;
  discountReward?: Maybe<DiscountReward>;
  discountRewardId?: Maybe<Scalars['Int']>;
  discountTierRestrictionId: Scalars['Int'];
  isExclusion: Scalars['Boolean'];
};

export type DiscountTierRestrictionFilterInput = {
  and?: InputMaybe<Array<DiscountTierRestrictionFilterInput>>;
  chargeCode?: InputMaybe<TblChargeCodesSetFilterInput>;
  chargeCodeId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  discountConstraint?: InputMaybe<DiscountConstraintFilterInput>;
  discountConstraintId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  discountReward?: InputMaybe<DiscountRewardFilterInput>;
  discountRewardId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  discountTierRestrictionId?: InputMaybe<ComparableInt32OperationFilterInput>;
  isExclusion?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<DiscountTierRestrictionFilterInput>>;
};

export type DiscountToDiscountGroup = {
  discount?: Maybe<Discount>;
  discountGroup?: Maybe<MddiscountGroup>;
  discountGroupId?: Maybe<Scalars['Int']>;
  discountId?: Maybe<Scalars['Int']>;
  discountToDiscountGroupId: Scalars['Int'];
};

export type DiscountToDiscountGroupFilterInput = {
  and?: InputMaybe<Array<DiscountToDiscountGroupFilterInput>>;
  discount?: InputMaybe<DiscountFilterInput>;
  discountGroup?: InputMaybe<MddiscountGroupFilterInput>;
  discountGroupId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  discountId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  discountToDiscountGroupId?: InputMaybe<ComparableInt32OperationFilterInput>;
  or?: InputMaybe<Array<DiscountToDiscountGroupFilterInput>>;
};

export type DiscountVendorRestriction = {
  discountConstraint?: Maybe<DiscountConstraint>;
  discountConstraintId?: Maybe<Scalars['Int']>;
  discountReward?: Maybe<DiscountReward>;
  discountRewardId?: Maybe<Scalars['Int']>;
  discountVendorRestrictionId: Scalars['Int'];
  isExclusion: Scalars['Boolean'];
  vendor?: Maybe<TblVendor>;
  vendorId: Scalars['Int'];
};

export type DiscountVendorRestrictionFilterInput = {
  and?: InputMaybe<Array<DiscountVendorRestrictionFilterInput>>;
  discountConstraint?: InputMaybe<DiscountConstraintFilterInput>;
  discountConstraintId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  discountReward?: InputMaybe<DiscountRewardFilterInput>;
  discountRewardId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  discountVendorRestrictionId?: InputMaybe<ComparableInt32OperationFilterInput>;
  isExclusion?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<DiscountVendorRestrictionFilterInput>>;
  vendor?: InputMaybe<TblVendorFilterInput>;
  vendorId?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type DiscountWeeklyRecurrence = {
  discount?: Maybe<Discount>;
  discountId?: Maybe<Scalars['Int']>;
  endTime?: Maybe<Scalars['TimeSpan']>;
  friday?: Maybe<Scalars['Boolean']>;
  id: Scalars['Int'];
  monday?: Maybe<Scalars['Boolean']>;
  saturday?: Maybe<Scalars['Boolean']>;
  startTime?: Maybe<Scalars['TimeSpan']>;
  sunday?: Maybe<Scalars['Boolean']>;
  thursday?: Maybe<Scalars['Boolean']>;
  tuesday?: Maybe<Scalars['Boolean']>;
  wednesday?: Maybe<Scalars['Boolean']>;
};

export type DiscountWeeklyRecurrenceFilterInput = {
  and?: InputMaybe<Array<DiscountWeeklyRecurrenceFilterInput>>;
  discount?: InputMaybe<DiscountFilterInput>;
  discountId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  endTime?: InputMaybe<ComparableNullableOfTimeSpanOperationFilterInput>;
  friday?: InputMaybe<BooleanOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  monday?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<DiscountWeeklyRecurrenceFilterInput>>;
  saturday?: InputMaybe<BooleanOperationFilterInput>;
  startTime?: InputMaybe<ComparableNullableOfTimeSpanOperationFilterInput>;
  sunday?: InputMaybe<BooleanOperationFilterInput>;
  thursday?: InputMaybe<BooleanOperationFilterInput>;
  tuesday?: InputMaybe<BooleanOperationFilterInput>;
  wednesday?: InputMaybe<BooleanOperationFilterInput>;
};

export type Distillation = {
  distillationId: Scalars['Int'];
  distillationName: Scalars['String'];
  isDeleted?: Maybe<Scalars['Boolean']>;
  lsp?: Maybe<TblLsp>;
  lspId: Scalars['Int'];
  tblWhseProducts?: Maybe<Array<Maybe<TblWhseProduct>>>;
};

export type DistillationFilterInput = {
  and?: InputMaybe<Array<DistillationFilterInput>>;
  distillationId?: InputMaybe<ComparableInt32OperationFilterInput>;
  distillationName?: InputMaybe<StringOperationFilterInput>;
  isDeleted?: InputMaybe<BooleanOperationFilterInput>;
  lsp?: InputMaybe<TblLspFilterInput>;
  lspId?: InputMaybe<ComparableInt32OperationFilterInput>;
  or?: InputMaybe<Array<DistillationFilterInput>>;
  tblWhseProducts?: InputMaybe<ListFilterInputTypeOfTblWhseProductFilterInput>;
};

export type DistillationSortInput = {
  distillationId?: InputMaybe<SortEnumType>;
  distillationName?: InputMaybe<SortEnumType>;
  isDeleted?: InputMaybe<SortEnumType>;
  lsp?: InputMaybe<TblLspSortInput>;
  lspId?: InputMaybe<SortEnumType>;
};

export type DriverLocation = {
  driver?: Maybe<TblMddriver>;
  driverId: Scalars['Int'];
  externalDriverId: Scalars['String'];
  isOnline: Scalars['Boolean'];
  lastUpdateTimeUtc: Scalars['DateTime'];
  latitude: Scalars['Decimal'];
  longitude: Scalars['Decimal'];
};

export type DriverLocationFilterInput = {
  and?: InputMaybe<Array<DriverLocationFilterInput>>;
  driver?: InputMaybe<TblMddriverFilterInput>;
  driverId?: InputMaybe<ComparableInt32OperationFilterInput>;
  externalDriverId?: InputMaybe<StringOperationFilterInput>;
  isOnline?: InputMaybe<BooleanOperationFilterInput>;
  lastUpdateTimeUtc?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  latitude?: InputMaybe<ComparableDecimalOperationFilterInput>;
  longitude?: InputMaybe<ComparableDecimalOperationFilterInput>;
  or?: InputMaybe<Array<DriverLocationFilterInput>>;
};

export type DriverLocationSortInput = {
  driver?: InputMaybe<TblMddriverSortInput>;
  driverId?: InputMaybe<SortEnumType>;
  externalDriverId?: InputMaybe<SortEnumType>;
  isOnline?: InputMaybe<SortEnumType>;
  lastUpdateTimeUtc?: InputMaybe<SortEnumType>;
  latitude?: InputMaybe<SortEnumType>;
  longitude?: InputMaybe<SortEnumType>;
};

export type Error = {
  message: Scalars['String'];
};

export type Feature = {
  category?: Maybe<Scalars['String']>;
  defaultValue: Scalars['Boolean'];
  displayName?: Maybe<Scalars['String']>;
  featureDescription?: Maybe<Scalars['String']>;
  featureName?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  isOption: Scalars['Boolean'];
};

export type FeatureFilterInput = {
  and?: InputMaybe<Array<FeatureFilterInput>>;
  category?: InputMaybe<StringOperationFilterInput>;
  defaultValue?: InputMaybe<BooleanOperationFilterInput>;
  displayName?: InputMaybe<StringOperationFilterInput>;
  featureDescription?: InputMaybe<StringOperationFilterInput>;
  featureName?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  isOption?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<FeatureFilterInput>>;
};

export type FeatureSortInput = {
  category?: InputMaybe<SortEnumType>;
  defaultValue?: InputMaybe<SortEnumType>;
  displayName?: InputMaybe<SortEnumType>;
  featureDescription?: InputMaybe<SortEnumType>;
  featureName?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isOption?: InputMaybe<SortEnumType>;
};

export type FeeDonation = {
  appliedFeeDonations?: Maybe<Array<Maybe<AppliedFeeDonation>>>;
  appliesToAllZones: Scalars['Boolean'];
  calculationMethodId: Scalars['Int'];
  calculationValue: Scalars['Decimal'];
  deliveryOnly: Scalars['Boolean'];
  deliveryZones?: Maybe<Array<Maybe<DeliveryZone>>>;
  dollarMaximum?: Maybe<Scalars['Decimal']>;
  dollarMinimum?: Maybe<Scalars['Decimal']>;
  feeDonationId: Scalars['Int'];
  feePaymentMethod?: Maybe<Scalars['Int']>;
  feeType?: Maybe<Scalars['Int']>;
  isActive: Scalars['Boolean'];
  isAutomatic: Scalars['Boolean'];
  isRevenue: Scalars['Boolean'];
  loc?: Maybe<TblLspLocation>;
  locId: Scalars['Int'];
  lsp?: Maybe<TblLsp>;
  lspId: Scalars['Int'];
  name: Scalars['String'];
  productCategory?: Maybe<TblWhseProductType>;
  productCategoryId?: Maybe<Scalars['Int']>;
  taxable: Scalars['Boolean'];
};

export type FeeDonationCollectionSegment = {
  items?: Maybe<Array<Maybe<FeeDonation>>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

export type FeeDonationFilterInput = {
  and?: InputMaybe<Array<FeeDonationFilterInput>>;
  appliedFeeDonations?: InputMaybe<ListFilterInputTypeOfAppliedFeeDonationFilterInput>;
  appliesToAllZones?: InputMaybe<BooleanOperationFilterInput>;
  calculationMethodId?: InputMaybe<ComparableInt32OperationFilterInput>;
  calculationValue?: InputMaybe<ComparableDecimalOperationFilterInput>;
  deliveryOnly?: InputMaybe<BooleanOperationFilterInput>;
  deliveryZones?: InputMaybe<ListFilterInputTypeOfDeliveryZoneFilterInput>;
  dollarMaximum?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  dollarMinimum?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  feeDonationId?: InputMaybe<ComparableInt32OperationFilterInput>;
  feePaymentMethod?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  feeType?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  isActive?: InputMaybe<BooleanOperationFilterInput>;
  isAutomatic?: InputMaybe<BooleanOperationFilterInput>;
  isRevenue?: InputMaybe<BooleanOperationFilterInput>;
  loc?: InputMaybe<TblLspLocationFilterInput>;
  locId?: InputMaybe<ComparableInt32OperationFilterInput>;
  lsp?: InputMaybe<TblLspFilterInput>;
  lspId?: InputMaybe<ComparableInt32OperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<FeeDonationFilterInput>>;
  productCategory?: InputMaybe<TblWhseProductTypeFilterInput>;
  productCategoryId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  taxable?: InputMaybe<BooleanOperationFilterInput>;
};

export type FeeDonationSortInput = {
  appliesToAllZones?: InputMaybe<SortEnumType>;
  calculationMethodId?: InputMaybe<SortEnumType>;
  calculationValue?: InputMaybe<SortEnumType>;
  deliveryOnly?: InputMaybe<SortEnumType>;
  dollarMaximum?: InputMaybe<SortEnumType>;
  dollarMinimum?: InputMaybe<SortEnumType>;
  feeDonationId?: InputMaybe<SortEnumType>;
  feePaymentMethod?: InputMaybe<SortEnumType>;
  feeType?: InputMaybe<SortEnumType>;
  isActive?: InputMaybe<SortEnumType>;
  isAutomatic?: InputMaybe<SortEnumType>;
  isRevenue?: InputMaybe<SortEnumType>;
  loc?: InputMaybe<TblLspLocationSortInput>;
  locId?: InputMaybe<SortEnumType>;
  lsp?: InputMaybe<TblLspSortInput>;
  lspId?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  productCategory?: InputMaybe<TblWhseProductTypeSortInput>;
  productCategoryId?: InputMaybe<SortEnumType>;
  taxable?: InputMaybe<SortEnumType>;
};

export type Fgrecon = {
  discrepancies: Scalars['Decimal'];
  fgreconDetails?: Maybe<Array<Maybe<FgreconDetail>>>;
  id: Scalars['Int'];
  inventoryAuditFiles?: Maybe<Array<Maybe<InventoryAuditFile>>>;
  inventoryAuditToBrands?: Maybe<Array<Maybe<InventoryAuditToBrand>>>;
  inventoryAuditToCategories?: Maybe<Array<Maybe<InventoryAuditToCategory>>>;
  inventoryAuditToRooms?: Maybe<Array<Maybe<InventoryAuditToRoom>>>;
  isBlind: Scalars['Boolean'];
  isDeleted: Scalars['Boolean'];
  isFromPackages: Scalars['Boolean'];
  loc?: Maybe<TblLspLocation>;
  locId: Scalars['Int'];
  lsp?: Maybe<TblLsp>;
  lspId: Scalars['Int'];
  masterCategory?: Maybe<Scalars['String']>;
  productCategoryId?: Maybe<Scalars['Int']>;
  reconBy: Scalars['Int'];
  reconByNavigation?: Maybe<TblAuthUser>;
  reconCompletedUTC?: Maybe<Scalars['DateTime']>;
  reconDate: Scalars['DateTime'];
  reconSubmittedBy?: Maybe<Scalars['Int']>;
  reconSubmittedByNavigation?: Maybe<TblAuthUser>;
  reconTotalFg?: Maybe<Scalars['Int']>;
  room?: Maybe<TblBatchRoom>;
  roomId?: Maybe<Scalars['Int']>;
  scan: Scalars['Boolean'];
  status?: Maybe<InventoryAuditStatus>;
  statusId: Scalars['Int'];
  workflow?: Maybe<InventoryAuditWorkflow>;
  workflowId: Scalars['Int'];
};

export type FgreconCollectionSegment = {
  items?: Maybe<Array<Maybe<Fgrecon>>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

export type FgreconDetail = {
  actualQty?: Maybe<Scalars['Decimal']>;
  comment?: Maybe<Scalars['String']>;
  expectedQty?: Maybe<Scalars['Decimal']>;
  fgrecon?: Maybe<Fgrecon>;
  fgreconId?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  isDeleted: Scalars['Boolean'];
  lastAuditedDateUtc?: Maybe<Scalars['DateTime']>;
  package?: Maybe<Package>;
  packageId?: Maybe<Scalars['Int']>;
  product?: Maybe<TblWhseProduct>;
  productId?: Maybe<Scalars['Int']>;
  reasonCode?: Maybe<Scalars['String']>;
  serialNo?: Maybe<Scalars['String']>;
  unitId?: Maybe<Scalars['Int']>;
  updatedBy?: Maybe<Scalars['Int']>;
  updatedByNavigation?: Maybe<TblAuthUser>;
};

export type FgreconDetailCollectionSegment = {
  items?: Maybe<Array<Maybe<FgreconDetail>>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

export type FgreconDetailFilterInput = {
  actualQty?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  and?: InputMaybe<Array<FgreconDetailFilterInput>>;
  comment?: InputMaybe<StringOperationFilterInput>;
  expectedQty?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  fgrecon?: InputMaybe<FgreconFilterInput>;
  fgreconId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  isDeleted?: InputMaybe<BooleanOperationFilterInput>;
  lastAuditedDateUtc?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  or?: InputMaybe<Array<FgreconDetailFilterInput>>;
  package?: InputMaybe<PackageFilterInput>;
  packageId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  product?: InputMaybe<TblWhseProductFilterInput>;
  productId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  reasonCode?: InputMaybe<StringOperationFilterInput>;
  serialNo?: InputMaybe<StringOperationFilterInput>;
  unitId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  updatedBy?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  updatedByNavigation?: InputMaybe<TblAuthUserFilterInput>;
};

export type FgreconDetailSortInput = {
  actualQty?: InputMaybe<SortEnumType>;
  comment?: InputMaybe<SortEnumType>;
  expectedQty?: InputMaybe<SortEnumType>;
  fgrecon?: InputMaybe<FgreconSortInput>;
  fgreconId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isDeleted?: InputMaybe<SortEnumType>;
  lastAuditedDateUtc?: InputMaybe<SortEnumType>;
  package?: InputMaybe<PackageSortInput>;
  packageId?: InputMaybe<SortEnumType>;
  product?: InputMaybe<TblWhseProductSortInput>;
  productId?: InputMaybe<SortEnumType>;
  reasonCode?: InputMaybe<SortEnumType>;
  serialNo?: InputMaybe<SortEnumType>;
  unitId?: InputMaybe<SortEnumType>;
  updatedBy?: InputMaybe<SortEnumType>;
  updatedByNavigation?: InputMaybe<TblAuthUserSortInput>;
};

export type FgreconFilterInput = {
  and?: InputMaybe<Array<FgreconFilterInput>>;
  discrepancies?: InputMaybe<ComparableDecimalOperationFilterInput>;
  fgreconDetails?: InputMaybe<ListFilterInputTypeOfFgreconDetailFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  inventoryAuditFiles?: InputMaybe<ListFilterInputTypeOfInventoryAuditFileFilterInput>;
  inventoryAuditToBrands?: InputMaybe<ListFilterInputTypeOfInventoryAuditToBrandFilterInput>;
  inventoryAuditToCategories?: InputMaybe<ListFilterInputTypeOfInventoryAuditToCategoryFilterInput>;
  inventoryAuditToRooms?: InputMaybe<ListFilterInputTypeOfInventoryAuditToRoomFilterInput>;
  isBlind?: InputMaybe<BooleanOperationFilterInput>;
  isDeleted?: InputMaybe<BooleanOperationFilterInput>;
  isFromPackages?: InputMaybe<BooleanOperationFilterInput>;
  loc?: InputMaybe<TblLspLocationFilterInput>;
  locId?: InputMaybe<ComparableInt32OperationFilterInput>;
  lsp?: InputMaybe<TblLspFilterInput>;
  lspId?: InputMaybe<ComparableInt32OperationFilterInput>;
  masterCategory?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<FgreconFilterInput>>;
  productCategoryId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  reconBy?: InputMaybe<ComparableInt32OperationFilterInput>;
  reconByNavigation?: InputMaybe<TblAuthUserFilterInput>;
  reconCompletedUTC?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  reconDate?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  reconSubmittedBy?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  reconSubmittedByNavigation?: InputMaybe<TblAuthUserFilterInput>;
  reconTotalFg?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  room?: InputMaybe<TblBatchRoomFilterInput>;
  roomId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  scan?: InputMaybe<BooleanOperationFilterInput>;
  status?: InputMaybe<InventoryAuditStatusFilterInput>;
  statusId?: InputMaybe<ComparableInt32OperationFilterInput>;
  workflow?: InputMaybe<InventoryAuditWorkflowFilterInput>;
  workflowId?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type FgreconSortInput = {
  discrepancies?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isBlind?: InputMaybe<SortEnumType>;
  isDeleted?: InputMaybe<SortEnumType>;
  isFromPackages?: InputMaybe<SortEnumType>;
  loc?: InputMaybe<TblLspLocationSortInput>;
  locId?: InputMaybe<SortEnumType>;
  lsp?: InputMaybe<TblLspSortInput>;
  lspId?: InputMaybe<SortEnumType>;
  masterCategory?: InputMaybe<SortEnumType>;
  productCategoryId?: InputMaybe<SortEnumType>;
  reconBy?: InputMaybe<SortEnumType>;
  reconByNavigation?: InputMaybe<TblAuthUserSortInput>;
  reconCompletedUTC?: InputMaybe<SortEnumType>;
  reconDate?: InputMaybe<SortEnumType>;
  reconSubmittedBy?: InputMaybe<SortEnumType>;
  reconSubmittedByNavigation?: InputMaybe<TblAuthUserSortInput>;
  reconTotalFg?: InputMaybe<SortEnumType>;
  room?: InputMaybe<TblBatchRoomSortInput>;
  roomId?: InputMaybe<SortEnumType>;
  scan?: InputMaybe<SortEnumType>;
  status?: InputMaybe<InventoryAuditStatusSortInput>;
  statusId?: InputMaybe<SortEnumType>;
  workflow?: InputMaybe<InventoryAuditWorkflowSortInput>;
  workflowId?: InputMaybe<SortEnumType>;
};

export type GqlError = Error & {
  message: Scalars['String'];
};

export type InputItemType = {
  assemblyInputItems?: Maybe<Array<Maybe<AssemblyInputItem>>>;
  billOfMaterialsInputItems?: Maybe<Array<Maybe<BillOfMaterialsInputItem>>>;
  inputItemTypeId: Scalars['Byte'];
  name?: Maybe<Scalars['String']>;
};

export type InputItemTypeFilterInput = {
  and?: InputMaybe<Array<InputItemTypeFilterInput>>;
  assemblyInputItems?: InputMaybe<ListFilterInputTypeOfAssemblyInputItemFilterInput>;
  billOfMaterialsInputItems?: InputMaybe<ListFilterInputTypeOfBillOfMaterialsInputItemFilterInput>;
  inputItemTypeId?: InputMaybe<ComparableByteOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<InputItemTypeFilterInput>>;
};

export type IntegrationConfiguration = {
  apiversion?: Maybe<Scalars['String']>;
  baseUrl?: Maybe<Scalars['String']>;
  dateCreated: Scalars['DateTime'];
  id: Scalars['Int'];
  isEnabled: Scalars['Boolean'];
  loc?: Maybe<TblLspLocation>;
  locId?: Maybe<Scalars['Int']>;
  lsp?: Maybe<TblLsp>;
  lspId?: Maybe<Scalars['Int']>;
};

export type IntegrationConfigurationFilterInput = {
  and?: InputMaybe<Array<IntegrationConfigurationFilterInput>>;
  apiversion?: InputMaybe<StringOperationFilterInput>;
  baseUrl?: InputMaybe<StringOperationFilterInput>;
  dateCreated?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  isEnabled?: InputMaybe<BooleanOperationFilterInput>;
  loc?: InputMaybe<TblLspLocationFilterInput>;
  locId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  lsp?: InputMaybe<TblLspFilterInput>;
  lspId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  or?: InputMaybe<Array<IntegrationConfigurationFilterInput>>;
};

export type InventoryAdjustTransaction = {
  adjustFromQty?: Maybe<Scalars['Decimal']>;
  adjustToQty?: Maybe<Scalars['Decimal']>;
  inventoryAdjustTransationId: Scalars['Int'];
  inventoryTransaction?: Maybe<InventoryTransaction>;
  inventoryTransactionId?: Maybe<Scalars['Int']>;
  reason?: Maybe<Scalars['String']>;
  roomId?: Maybe<Scalars['Int']>;
  unit?: Maybe<Unit>;
  unitId?: Maybe<Scalars['Int']>;
};

export type InventoryAdjustTransactionFilterInput = {
  adjustFromQty?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  adjustToQty?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  and?: InputMaybe<Array<InventoryAdjustTransactionFilterInput>>;
  inventoryAdjustTransationId?: InputMaybe<ComparableInt32OperationFilterInput>;
  inventoryTransaction?: InputMaybe<InventoryTransactionFilterInput>;
  inventoryTransactionId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  or?: InputMaybe<Array<InventoryAdjustTransactionFilterInput>>;
  reason?: InputMaybe<StringOperationFilterInput>;
  roomId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  unit?: InputMaybe<UnitFilterInput>;
  unitId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
};

export type InventoryAuditFile = {
  deletedDateUtc?: Maybe<Scalars['DateTime']>;
  fileName: Scalars['String'];
  inventoryAudit?: Maybe<Fgrecon>;
  inventoryAuditFileId: Scalars['Int'];
  inventoryAuditId: Scalars['Int'];
  isDeleted?: Maybe<Scalars['Boolean']>;
  loc?: Maybe<TblLspLocation>;
  locId: Scalars['Int'];
  lsp?: Maybe<TblLsp>;
  lspId: Scalars['Int'];
  storageFileName: Scalars['String'];
  uploadedBy: Scalars['Int'];
  uploadedByNavigation?: Maybe<TblAuthUser>;
  uploadedDateUtc: Scalars['DateTime'];
};

export type InventoryAuditFileFilterInput = {
  and?: InputMaybe<Array<InventoryAuditFileFilterInput>>;
  deletedDateUtc?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  fileName?: InputMaybe<StringOperationFilterInput>;
  inventoryAudit?: InputMaybe<FgreconFilterInput>;
  inventoryAuditFileId?: InputMaybe<ComparableInt32OperationFilterInput>;
  inventoryAuditId?: InputMaybe<ComparableInt32OperationFilterInput>;
  isDeleted?: InputMaybe<BooleanOperationFilterInput>;
  loc?: InputMaybe<TblLspLocationFilterInput>;
  locId?: InputMaybe<ComparableInt32OperationFilterInput>;
  lsp?: InputMaybe<TblLspFilterInput>;
  lspId?: InputMaybe<ComparableInt32OperationFilterInput>;
  or?: InputMaybe<Array<InventoryAuditFileFilterInput>>;
  storageFileName?: InputMaybe<StringOperationFilterInput>;
  uploadedBy?: InputMaybe<ComparableInt32OperationFilterInput>;
  uploadedByNavigation?: InputMaybe<TblAuthUserFilterInput>;
  uploadedDateUtc?: InputMaybe<ComparableDateTimeOperationFilterInput>;
};

export type InventoryAuditStatus = {
  fgrecons?: Maybe<Array<Maybe<Fgrecon>>>;
  statusId: Scalars['Int'];
  statusName: Scalars['String'];
};

export type InventoryAuditStatusCollectionSegment = {
  items?: Maybe<Array<Maybe<InventoryAuditStatus>>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

export type InventoryAuditStatusFilterInput = {
  and?: InputMaybe<Array<InventoryAuditStatusFilterInput>>;
  fgrecons?: InputMaybe<ListFilterInputTypeOfFgreconFilterInput>;
  or?: InputMaybe<Array<InventoryAuditStatusFilterInput>>;
  statusId?: InputMaybe<ComparableInt32OperationFilterInput>;
  statusName?: InputMaybe<StringOperationFilterInput>;
};

export type InventoryAuditStatusSortInput = {
  statusId?: InputMaybe<SortEnumType>;
  statusName?: InputMaybe<SortEnumType>;
};

export type InventoryAuditToBrand = {
  audit?: Maybe<Fgrecon>;
  auditId: Scalars['Int'];
  brand?: Maybe<Brand>;
  brandId: Scalars['Int'];
  id: Scalars['Int'];
  loc?: Maybe<TblLspLocation>;
  locId?: Maybe<Scalars['Int']>;
  lsp?: Maybe<TblLsp>;
  lspId?: Maybe<Scalars['Int']>;
};

export type InventoryAuditToBrandFilterInput = {
  and?: InputMaybe<Array<InventoryAuditToBrandFilterInput>>;
  audit?: InputMaybe<FgreconFilterInput>;
  auditId?: InputMaybe<ComparableInt32OperationFilterInput>;
  brand?: InputMaybe<BrandFilterInput>;
  brandId?: InputMaybe<ComparableInt32OperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  loc?: InputMaybe<TblLspLocationFilterInput>;
  locId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  lsp?: InputMaybe<TblLspFilterInput>;
  lspId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  or?: InputMaybe<Array<InventoryAuditToBrandFilterInput>>;
};

export type InventoryAuditToCategory = {
  audit?: Maybe<Fgrecon>;
  auditId: Scalars['Int'];
  category?: Maybe<TblWhseProductType>;
  categoryId: Scalars['Int'];
  id: Scalars['Int'];
  loc?: Maybe<TblLspLocation>;
  locId?: Maybe<Scalars['Int']>;
  lsp?: Maybe<TblLsp>;
  lspId?: Maybe<Scalars['Int']>;
};

export type InventoryAuditToCategoryFilterInput = {
  and?: InputMaybe<Array<InventoryAuditToCategoryFilterInput>>;
  audit?: InputMaybe<FgreconFilterInput>;
  auditId?: InputMaybe<ComparableInt32OperationFilterInput>;
  category?: InputMaybe<TblWhseProductTypeFilterInput>;
  categoryId?: InputMaybe<ComparableInt32OperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  loc?: InputMaybe<TblLspLocationFilterInput>;
  locId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  lsp?: InputMaybe<TblLspFilterInput>;
  lspId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  or?: InputMaybe<Array<InventoryAuditToCategoryFilterInput>>;
};

export type InventoryAuditToRoom = {
  audit?: Maybe<Fgrecon>;
  auditId: Scalars['Int'];
  id: Scalars['Int'];
  loc?: Maybe<TblLspLocation>;
  locId?: Maybe<Scalars['Int']>;
  lsp?: Maybe<TblLsp>;
  lspId?: Maybe<Scalars['Int']>;
  room?: Maybe<TblBatchRoom>;
  roomId: Scalars['Int'];
};

export type InventoryAuditToRoomFilterInput = {
  and?: InputMaybe<Array<InventoryAuditToRoomFilterInput>>;
  audit?: InputMaybe<FgreconFilterInput>;
  auditId?: InputMaybe<ComparableInt32OperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  loc?: InputMaybe<TblLspLocationFilterInput>;
  locId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  lsp?: InputMaybe<TblLspFilterInput>;
  lspId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  or?: InputMaybe<Array<InventoryAuditToRoomFilterInput>>;
  room?: InputMaybe<TblBatchRoomFilterInput>;
  roomId?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type InventoryAuditWorkflow = {
  fgrecons?: Maybe<Array<Maybe<Fgrecon>>>;
  workflowId: Scalars['Int'];
  workflowName: Scalars['String'];
};

export type InventoryAuditWorkflowFilterInput = {
  and?: InputMaybe<Array<InventoryAuditWorkflowFilterInput>>;
  fgrecons?: InputMaybe<ListFilterInputTypeOfFgreconFilterInput>;
  or?: InputMaybe<Array<InventoryAuditWorkflowFilterInput>>;
  workflowId?: InputMaybe<ComparableInt32OperationFilterInput>;
  workflowName?: InputMaybe<StringOperationFilterInput>;
};

export type InventoryAuditWorkflowSortInput = {
  workflowId?: InputMaybe<SortEnumType>;
  workflowName?: InputMaybe<SortEnumType>;
};

export type InventorySourceBatch = {
  id: Scalars['Int'];
  inventoryId?: Maybe<Scalars['Int']>;
  package?: Maybe<Package>;
  packageId?: Maybe<Scalars['Int']>;
  sourceBatch?: Maybe<Scalars['String']>;
};

export type InventorySourceBatchFilterInput = {
  and?: InputMaybe<Array<InventorySourceBatchFilterInput>>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  inventoryId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  or?: InputMaybe<Array<InventorySourceBatchFilterInput>>;
  package?: InputMaybe<PackageFilterInput>;
  packageId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  sourceBatch?: InputMaybe<StringOperationFilterInput>;
};

export type InventoryTransaction = {
  actionComment?: Maybe<Scalars['String']>;
  inventoryAdjustTransactions?: Maybe<Array<Maybe<InventoryAdjustTransaction>>>;
  inventoryTransactionId: Scalars['Int'];
  loc?: Maybe<TblLspLocation>;
  locId: Scalars['Int'];
  lsp?: Maybe<TblLsp>;
  lspId: Scalars['Int'];
  package?: Maybe<Package>;
  packageId?: Maybe<Scalars['Int']>;
  product?: Maybe<TblWhseProduct>;
  productId: Scalars['Int'];
  quantity?: Maybe<Scalars['Decimal']>;
  receiveInventoryHistory?: Maybe<ReceiveInventoryHistory>;
  receiveInventoryHistoryId?: Maybe<Scalars['Int']>;
  serialNumber?: Maybe<Scalars['String']>;
  startingQuantity?: Maybe<Scalars['Decimal']>;
  transactionBy: Scalars['Int'];
  transactionByNavigation?: Maybe<TblAuthUser>;
  transactionDate: Scalars['DateTime'];
  transactionType?: Maybe<InventoryTransactionType>;
  transactionTypeId: Scalars['Int'];
  unit?: Maybe<Unit>;
  unitId: Scalars['Int'];
};

export type InventoryTransactionFilterInput = {
  actionComment?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<InventoryTransactionFilterInput>>;
  inventoryAdjustTransactions?: InputMaybe<ListFilterInputTypeOfInventoryAdjustTransactionFilterInput>;
  inventoryTransactionId?: InputMaybe<ComparableInt32OperationFilterInput>;
  loc?: InputMaybe<TblLspLocationFilterInput>;
  locId?: InputMaybe<ComparableInt32OperationFilterInput>;
  lsp?: InputMaybe<TblLspFilterInput>;
  lspId?: InputMaybe<ComparableInt32OperationFilterInput>;
  or?: InputMaybe<Array<InventoryTransactionFilterInput>>;
  package?: InputMaybe<PackageFilterInput>;
  packageId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  product?: InputMaybe<TblWhseProductFilterInput>;
  productId?: InputMaybe<ComparableInt32OperationFilterInput>;
  quantity?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  receiveInventoryHistory?: InputMaybe<ReceiveInventoryHistoryFilterInput>;
  receiveInventoryHistoryId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  serialNumber?: InputMaybe<StringOperationFilterInput>;
  startingQuantity?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  transactionBy?: InputMaybe<ComparableInt32OperationFilterInput>;
  transactionByNavigation?: InputMaybe<TblAuthUserFilterInput>;
  transactionDate?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  transactionType?: InputMaybe<InventoryTransactionTypeFilterInput>;
  transactionTypeId?: InputMaybe<ComparableInt32OperationFilterInput>;
  unit?: InputMaybe<UnitFilterInput>;
  unitId?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type InventoryTransactionType = {
  inventoryTransactions?: Maybe<Array<Maybe<InventoryTransaction>>>;
  transactionType: Scalars['String'];
  transactionTypeId: Scalars['Int'];
};

export type InventoryTransactionTypeFilterInput = {
  and?: InputMaybe<Array<InventoryTransactionTypeFilterInput>>;
  inventoryTransactions?: InputMaybe<ListFilterInputTypeOfInventoryTransactionFilterInput>;
  or?: InputMaybe<Array<InventoryTransactionTypeFilterInput>>;
  transactionType?: InputMaybe<StringOperationFilterInput>;
  transactionTypeId?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type JobStatus = {
  cancel: Scalars['Boolean'];
  createdAtUtc: Scalars['DateTime'];
  id: Scalars['Int'];
  jobName: Scalars['String'];
  jobSource: Scalars['String'];
  loc?: Maybe<TblLspLocation>;
  locId: Scalars['Int'];
  lsp?: Maybe<TblLsp>;
  lspId: Scalars['Int'];
  status: Scalars['String'];
  statusDetails?: Maybe<Scalars['String']>;
  updatedAtUtc: Scalars['DateTime'];
  user?: Maybe<TblAuthUser>;
  userId: Scalars['Int'];
};

export type JobStatusCollectionSegment = {
  items?: Maybe<Array<Maybe<JobStatus>>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

export type JobStatusFilterInput = {
  and?: InputMaybe<Array<JobStatusFilterInput>>;
  cancel?: InputMaybe<BooleanOperationFilterInput>;
  createdAtUtc?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  jobName?: InputMaybe<StringOperationFilterInput>;
  jobSource?: InputMaybe<StringOperationFilterInput>;
  loc?: InputMaybe<TblLspLocationFilterInput>;
  locId?: InputMaybe<ComparableInt32OperationFilterInput>;
  lsp?: InputMaybe<TblLspFilterInput>;
  lspId?: InputMaybe<ComparableInt32OperationFilterInput>;
  or?: InputMaybe<Array<JobStatusFilterInput>>;
  status?: InputMaybe<StringOperationFilterInput>;
  statusDetails?: InputMaybe<StringOperationFilterInput>;
  updatedAtUtc?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  user?: InputMaybe<TblAuthUserFilterInput>;
  userId?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type JobStatusSortInput = {
  cancel?: InputMaybe<SortEnumType>;
  createdAtUtc?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  jobName?: InputMaybe<SortEnumType>;
  jobSource?: InputMaybe<SortEnumType>;
  loc?: InputMaybe<TblLspLocationSortInput>;
  locId?: InputMaybe<SortEnumType>;
  lsp?: InputMaybe<TblLspSortInput>;
  lspId?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  statusDetails?: InputMaybe<SortEnumType>;
  updatedAtUtc?: InputMaybe<SortEnumType>;
  user?: InputMaybe<TblAuthUserSortInput>;
  userId?: InputMaybe<SortEnumType>;
};

export type LeafControlInfo = {
  apiKey?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  isEnabled: Scalars['Boolean'];
  leafUrl?: Maybe<Scalars['String']>;
  loc?: Maybe<TblLspLocation>;
  locId: Scalars['Int'];
  lsp?: Maybe<TblLsp>;
  lspId: Scalars['Int'];
  mmecode?: Maybe<Scalars['String']>;
  mmeid?: Maybe<Scalars['String']>;
  scheduleDestructions: Scalars['Boolean'];
  stateCode?: Maybe<Scalars['String']>;
  useLeafLabData: Scalars['Boolean'];
  useNewDestoryEndpoint: Scalars['Boolean'];
};

export type LeafControlInfoFilterInput = {
  and?: InputMaybe<Array<LeafControlInfoFilterInput>>;
  apiKey?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  isEnabled?: InputMaybe<BooleanOperationFilterInput>;
  leafUrl?: InputMaybe<StringOperationFilterInput>;
  loc?: InputMaybe<TblLspLocationFilterInput>;
  locId?: InputMaybe<ComparableInt32OperationFilterInput>;
  lsp?: InputMaybe<TblLspFilterInput>;
  lspId?: InputMaybe<ComparableInt32OperationFilterInput>;
  mmecode?: InputMaybe<StringOperationFilterInput>;
  mmeid?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<LeafControlInfoFilterInput>>;
  scheduleDestructions?: InputMaybe<BooleanOperationFilterInput>;
  stateCode?: InputMaybe<StringOperationFilterInput>;
  useLeafLabData?: InputMaybe<BooleanOperationFilterInput>;
  useNewDestoryEndpoint?: InputMaybe<BooleanOperationFilterInput>;
};

export type LeafLinkControlInfo = {
  apikey?: Maybe<Scalars['String']>;
  baseUrl?: Maybe<Scalars['String']>;
  companyId?: Maybe<Scalars['Int']>;
  defaultBrandId?: Maybe<Scalars['Int']>;
  defaultCustomerLicenseTypeId?: Maybe<Scalars['Int']>;
  defaultSellerId?: Maybe<Scalars['Int']>;
  enableBatchSync: Scalars['Boolean'];
  enableCustomerSync: Scalars['Boolean'];
  id: Scalars['Int'];
  isEnabled: Scalars['Boolean'];
  licenseId?: Maybe<Scalars['Int']>;
  licenseType: Scalars['Int'];
  loc?: Maybe<TblLspLocation>;
  locId: Scalars['Int'];
  lsp?: Maybe<TblLsp>;
  lspId: Scalars['Int'];
  newArchivingFunctionality?: Maybe<Scalars['Boolean']>;
  useUpdatedProductPatchRequest: Scalars['Boolean'];
};

export type LeafLinkControlInfoFilterInput = {
  and?: InputMaybe<Array<LeafLinkControlInfoFilterInput>>;
  apikey?: InputMaybe<StringOperationFilterInput>;
  baseUrl?: InputMaybe<StringOperationFilterInput>;
  companyId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  defaultBrandId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  defaultCustomerLicenseTypeId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  defaultSellerId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  enableBatchSync?: InputMaybe<BooleanOperationFilterInput>;
  enableCustomerSync?: InputMaybe<BooleanOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  isEnabled?: InputMaybe<BooleanOperationFilterInput>;
  licenseId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  licenseType?: InputMaybe<ComparableInt32OperationFilterInput>;
  loc?: InputMaybe<TblLspLocationFilterInput>;
  locId?: InputMaybe<ComparableInt32OperationFilterInput>;
  lsp?: InputMaybe<TblLspFilterInput>;
  lspId?: InputMaybe<ComparableInt32OperationFilterInput>;
  newArchivingFunctionality?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<LeafLinkControlInfoFilterInput>>;
  useUpdatedProductPatchRequest?: InputMaybe<BooleanOperationFilterInput>;
};

export type LinxControlInfo = {
  baseUrl?: Maybe<Scalars['String']>;
  clientKey?: Maybe<Scalars['String']>;
  clientSecret?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  isEnabled?: Maybe<Scalars['Boolean']>;
  loc?: Maybe<TblLspLocation>;
  locId: Scalars['Int'];
  locationName?: Maybe<Scalars['String']>;
  lsp?: Maybe<TblLsp>;
  lspId: Scalars['Int'];
};

export type LinxControlInfoFilterInput = {
  and?: InputMaybe<Array<LinxControlInfoFilterInput>>;
  baseUrl?: InputMaybe<StringOperationFilterInput>;
  clientKey?: InputMaybe<StringOperationFilterInput>;
  clientSecret?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  isEnabled?: InputMaybe<BooleanOperationFilterInput>;
  loc?: InputMaybe<TblLspLocationFilterInput>;
  locId?: InputMaybe<ComparableInt32OperationFilterInput>;
  locationName?: InputMaybe<StringOperationFilterInput>;
  lsp?: InputMaybe<TblLspFilterInput>;
  lspId?: InputMaybe<ComparableInt32OperationFilterInput>;
  or?: InputMaybe<Array<LinxControlInfoFilterInput>>;
};

export type ListComparableByteOperationFilterInput = {
  all?: InputMaybe<ComparableByteOperationFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<ComparableByteOperationFilterInput>;
  some?: InputMaybe<ComparableByteOperationFilterInput>;
};

export type ListFilterInputTypeOfAddressBookFilterInput = {
  all?: InputMaybe<AddressBookFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<AddressBookFilterInput>;
  some?: InputMaybe<AddressBookFilterInput>;
};

export type ListFilterInputTypeOfAdilasIntegrationControlInfoFilterInput = {
  all?: InputMaybe<AdilasIntegrationControlInfoFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<AdilasIntegrationControlInfoFilterInput>;
  some?: InputMaybe<AdilasIntegrationControlInfoFilterInput>;
};

export type ListFilterInputTypeOfAllocatedInventoryFilterInput = {
  all?: InputMaybe<AllocatedInventoryFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<AllocatedInventoryFilterInput>;
  some?: InputMaybe<AllocatedInventoryFilterInput>;
};

export type ListFilterInputTypeOfAlpineIqcontrolInfoFilterInput = {
  all?: InputMaybe<AlpineIqcontrolInfoFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<AlpineIqcontrolInfoFilterInput>;
  some?: InputMaybe<AlpineIqcontrolInfoFilterInput>;
};

export type ListFilterInputTypeOfAppliedDiscountFilterInput = {
  all?: InputMaybe<AppliedDiscountFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<AppliedDiscountFilterInput>;
  some?: InputMaybe<AppliedDiscountFilterInput>;
};

export type ListFilterInputTypeOfAppliedFeeDonationFilterInput = {
  all?: InputMaybe<AppliedFeeDonationFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<AppliedFeeDonationFilterInput>;
  some?: InputMaybe<AppliedFeeDonationFilterInput>;
};

export type ListFilterInputTypeOfAssemblyFilterInput = {
  all?: InputMaybe<AssemblyFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<AssemblyFilterInput>;
  some?: InputMaybe<AssemblyFilterInput>;
};

export type ListFilterInputTypeOfAssemblyInputItemFilterInput = {
  all?: InputMaybe<AssemblyInputItemFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<AssemblyInputItemFilterInput>;
  some?: InputMaybe<AssemblyInputItemFilterInput>;
};

export type ListFilterInputTypeOfAssemblyInputPackageFilterInput = {
  all?: InputMaybe<AssemblyInputPackageFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<AssemblyInputPackageFilterInput>;
  some?: InputMaybe<AssemblyInputPackageFilterInput>;
};

export type ListFilterInputTypeOfAssemblyOutputItemFilterInput = {
  all?: InputMaybe<AssemblyOutputItemFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<AssemblyOutputItemFilterInput>;
  some?: InputMaybe<AssemblyOutputItemFilterInput>;
};

export type ListFilterInputTypeOfBillOfMaterialFilterInput = {
  all?: InputMaybe<BillOfMaterialFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<BillOfMaterialFilterInput>;
  some?: InputMaybe<BillOfMaterialFilterInput>;
};

export type ListFilterInputTypeOfBillOfMaterialsFileFilterInput = {
  all?: InputMaybe<BillOfMaterialsFileFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<BillOfMaterialsFileFilterInput>;
  some?: InputMaybe<BillOfMaterialsFileFilterInput>;
};

export type ListFilterInputTypeOfBillOfMaterialsImageFilterInput = {
  all?: InputMaybe<BillOfMaterialsImageFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<BillOfMaterialsImageFilterInput>;
  some?: InputMaybe<BillOfMaterialsImageFilterInput>;
};

export type ListFilterInputTypeOfBillOfMaterialsInputItemFilterInput = {
  all?: InputMaybe<BillOfMaterialsInputItemFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<BillOfMaterialsInputItemFilterInput>;
  some?: InputMaybe<BillOfMaterialsInputItemFilterInput>;
};

export type ListFilterInputTypeOfBillOfMaterialsOutputItemFilterInput = {
  all?: InputMaybe<BillOfMaterialsOutputItemFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<BillOfMaterialsOutputItemFilterInput>;
  some?: InputMaybe<BillOfMaterialsOutputItemFilterInput>;
};

export type ListFilterInputTypeOfBirchmountControlInfoFilterInput = {
  all?: InputMaybe<BirchmountControlInfoFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<BirchmountControlInfoFilterInput>;
  some?: InputMaybe<BirchmountControlInfoFilterInput>;
};

export type ListFilterInputTypeOfBrandFilterInput = {
  all?: InputMaybe<BrandFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<BrandFilterInput>;
  some?: InputMaybe<BrandFilterInput>;
};

export type ListFilterInputTypeOfCaregiverFilterInput = {
  all?: InputMaybe<CaregiverFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<CaregiverFilterInput>;
  some?: InputMaybe<CaregiverFilterInput>;
};

export type ListFilterInputTypeOfCcrscontrolInfoFilterInput = {
  all?: InputMaybe<CcrscontrolInfoFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<CcrscontrolInfoFilterInput>;
  some?: InputMaybe<CcrscontrolInfoFilterInput>;
};

export type ListFilterInputTypeOfCultivationMetadataTagFilterInput = {
  all?: InputMaybe<CultivationMetadataTagFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<CultivationMetadataTagFilterInput>;
  some?: InputMaybe<CultivationMetadataTagFilterInput>;
};

export type ListFilterInputTypeOfDcdirectControlInfoFilterInput = {
  all?: InputMaybe<DcdirectControlInfoFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<DcdirectControlInfoFilterInput>;
  some?: InputMaybe<DcdirectControlInfoFilterInput>;
};

export type ListFilterInputTypeOfDeliveryRouteFilterInput = {
  all?: InputMaybe<DeliveryRouteFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<DeliveryRouteFilterInput>;
  some?: InputMaybe<DeliveryRouteFilterInput>;
};

export type ListFilterInputTypeOfDeliveryRouteHistoryFilterInput = {
  all?: InputMaybe<DeliveryRouteHistoryFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<DeliveryRouteHistoryFilterInput>;
  some?: InputMaybe<DeliveryRouteHistoryFilterInput>;
};

export type ListFilterInputTypeOfDeliveryZoneCityFilterInput = {
  all?: InputMaybe<DeliveryZoneCityFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<DeliveryZoneCityFilterInput>;
  some?: InputMaybe<DeliveryZoneCityFilterInput>;
};

export type ListFilterInputTypeOfDeliveryZoneCountyFilterInput = {
  all?: InputMaybe<DeliveryZoneCountyFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<DeliveryZoneCountyFilterInput>;
  some?: InputMaybe<DeliveryZoneCountyFilterInput>;
};

export type ListFilterInputTypeOfDeliveryZoneFilterInput = {
  all?: InputMaybe<DeliveryZoneFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<DeliveryZoneFilterInput>;
  some?: InputMaybe<DeliveryZoneFilterInput>;
};

export type ListFilterInputTypeOfDeliveryZoneZipFilterInput = {
  all?: InputMaybe<DeliveryZoneZipFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<DeliveryZoneZipFilterInput>;
  some?: InputMaybe<DeliveryZoneZipFilterInput>;
};

export type ListFilterInputTypeOfDiscountAuditDatumFilterInput = {
  all?: InputMaybe<DiscountAuditDatumFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<DiscountAuditDatumFilterInput>;
  some?: InputMaybe<DiscountAuditDatumFilterInput>;
};

export type ListFilterInputTypeOfDiscountBrandRestrictionFilterInput = {
  all?: InputMaybe<DiscountBrandRestrictionFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<DiscountBrandRestrictionFilterInput>;
  some?: InputMaybe<DiscountBrandRestrictionFilterInput>;
};

export type ListFilterInputTypeOfDiscountCategoryRestrictionFilterInput = {
  all?: InputMaybe<DiscountCategoryRestrictionFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<DiscountCategoryRestrictionFilterInput>;
  some?: InputMaybe<DiscountCategoryRestrictionFilterInput>;
};

export type ListFilterInputTypeOfDiscountConstraintFilterInput = {
  all?: InputMaybe<DiscountConstraintFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<DiscountConstraintFilterInput>;
  some?: InputMaybe<DiscountConstraintFilterInput>;
};

export type ListFilterInputTypeOfDiscountCustomerTypeRestrictionFilterInput = {
  all?: InputMaybe<DiscountCustomerTypeRestrictionFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<DiscountCustomerTypeRestrictionFilterInput>;
  some?: InputMaybe<DiscountCustomerTypeRestrictionFilterInput>;
};

export type ListFilterInputTypeOfDiscountFilterInput = {
  all?: InputMaybe<DiscountFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<DiscountFilterInput>;
  some?: InputMaybe<DiscountFilterInput>;
};

export type ListFilterInputTypeOfDiscountInventoryTagRestrictionFilterInput = {
  all?: InputMaybe<DiscountInventoryTagRestrictionFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<DiscountInventoryTagRestrictionFilterInput>;
  some?: InputMaybe<DiscountInventoryTagRestrictionFilterInput>;
};

export type ListFilterInputTypeOfDiscountRewardFilterInput = {
  all?: InputMaybe<DiscountRewardFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<DiscountRewardFilterInput>;
  some?: InputMaybe<DiscountRewardFilterInput>;
};

export type ListFilterInputTypeOfDiscountStrainRestrictionFilterInput = {
  all?: InputMaybe<DiscountStrainRestrictionFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<DiscountStrainRestrictionFilterInput>;
  some?: InputMaybe<DiscountStrainRestrictionFilterInput>;
};

export type ListFilterInputTypeOfDiscountTagRestrictionFilterInput = {
  all?: InputMaybe<DiscountTagRestrictionFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<DiscountTagRestrictionFilterInput>;
  some?: InputMaybe<DiscountTagRestrictionFilterInput>;
};

export type ListFilterInputTypeOfDiscountTierRestrictionFilterInput = {
  all?: InputMaybe<DiscountTierRestrictionFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<DiscountTierRestrictionFilterInput>;
  some?: InputMaybe<DiscountTierRestrictionFilterInput>;
};

export type ListFilterInputTypeOfDiscountToDiscountGroupFilterInput = {
  all?: InputMaybe<DiscountToDiscountGroupFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<DiscountToDiscountGroupFilterInput>;
  some?: InputMaybe<DiscountToDiscountGroupFilterInput>;
};

export type ListFilterInputTypeOfDiscountVendorRestrictionFilterInput = {
  all?: InputMaybe<DiscountVendorRestrictionFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<DiscountVendorRestrictionFilterInput>;
  some?: InputMaybe<DiscountVendorRestrictionFilterInput>;
};

export type ListFilterInputTypeOfDiscountWeeklyRecurrenceFilterInput = {
  all?: InputMaybe<DiscountWeeklyRecurrenceFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<DiscountWeeklyRecurrenceFilterInput>;
  some?: InputMaybe<DiscountWeeklyRecurrenceFilterInput>;
};

export type ListFilterInputTypeOfDistillationFilterInput = {
  all?: InputMaybe<DistillationFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<DistillationFilterInput>;
  some?: InputMaybe<DistillationFilterInput>;
};

export type ListFilterInputTypeOfFeeDonationFilterInput = {
  all?: InputMaybe<FeeDonationFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<FeeDonationFilterInput>;
  some?: InputMaybe<FeeDonationFilterInput>;
};

export type ListFilterInputTypeOfFgreconDetailFilterInput = {
  all?: InputMaybe<FgreconDetailFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<FgreconDetailFilterInput>;
  some?: InputMaybe<FgreconDetailFilterInput>;
};

export type ListFilterInputTypeOfFgreconFilterInput = {
  all?: InputMaybe<FgreconFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<FgreconFilterInput>;
  some?: InputMaybe<FgreconFilterInput>;
};

export type ListFilterInputTypeOfIntegrationConfigurationFilterInput = {
  all?: InputMaybe<IntegrationConfigurationFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<IntegrationConfigurationFilterInput>;
  some?: InputMaybe<IntegrationConfigurationFilterInput>;
};

export type ListFilterInputTypeOfInventoryAdjustTransactionFilterInput = {
  all?: InputMaybe<InventoryAdjustTransactionFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<InventoryAdjustTransactionFilterInput>;
  some?: InputMaybe<InventoryAdjustTransactionFilterInput>;
};

export type ListFilterInputTypeOfInventoryAuditFileFilterInput = {
  all?: InputMaybe<InventoryAuditFileFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<InventoryAuditFileFilterInput>;
  some?: InputMaybe<InventoryAuditFileFilterInput>;
};

export type ListFilterInputTypeOfInventoryAuditToBrandFilterInput = {
  all?: InputMaybe<InventoryAuditToBrandFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<InventoryAuditToBrandFilterInput>;
  some?: InputMaybe<InventoryAuditToBrandFilterInput>;
};

export type ListFilterInputTypeOfInventoryAuditToCategoryFilterInput = {
  all?: InputMaybe<InventoryAuditToCategoryFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<InventoryAuditToCategoryFilterInput>;
  some?: InputMaybe<InventoryAuditToCategoryFilterInput>;
};

export type ListFilterInputTypeOfInventoryAuditToRoomFilterInput = {
  all?: InputMaybe<InventoryAuditToRoomFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<InventoryAuditToRoomFilterInput>;
  some?: InputMaybe<InventoryAuditToRoomFilterInput>;
};

export type ListFilterInputTypeOfInventorySourceBatchFilterInput = {
  all?: InputMaybe<InventorySourceBatchFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<InventorySourceBatchFilterInput>;
  some?: InputMaybe<InventorySourceBatchFilterInput>;
};

export type ListFilterInputTypeOfInventoryTransactionFilterInput = {
  all?: InputMaybe<InventoryTransactionFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<InventoryTransactionFilterInput>;
  some?: InputMaybe<InventoryTransactionFilterInput>;
};

export type ListFilterInputTypeOfLeafControlInfoFilterInput = {
  all?: InputMaybe<LeafControlInfoFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<LeafControlInfoFilterInput>;
  some?: InputMaybe<LeafControlInfoFilterInput>;
};

export type ListFilterInputTypeOfLeafLinkControlInfoFilterInput = {
  all?: InputMaybe<LeafLinkControlInfoFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<LeafLinkControlInfoFilterInput>;
  some?: InputMaybe<LeafLinkControlInfoFilterInput>;
};

export type ListFilterInputTypeOfLinxControlInfoFilterInput = {
  all?: InputMaybe<LinxControlInfoFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<LinxControlInfoFilterInput>;
  some?: InputMaybe<LinxControlInfoFilterInput>;
};

export type ListFilterInputTypeOfLoyaltyDiscountRedemptionFilterInput = {
  all?: InputMaybe<LoyaltyDiscountRedemptionFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<LoyaltyDiscountRedemptionFilterInput>;
  some?: InputMaybe<LoyaltyDiscountRedemptionFilterInput>;
};

export type ListFilterInputTypeOfManifestToDriverFilterInput = {
  all?: InputMaybe<ManifestToDriverFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<ManifestToDriverFilterInput>;
  some?: InputMaybe<ManifestToDriverFilterInput>;
};

export type ListFilterInputTypeOfMdDiscountProductsListFilterInput = {
  all?: InputMaybe<MdDiscountProductsListFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<MdDiscountProductsListFilterInput>;
  some?: InputMaybe<MdDiscountProductsListFilterInput>;
};

export type ListFilterInputTypeOfMdDoctorFilterInput = {
  all?: InputMaybe<MdDoctorFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<MdDoctorFilterInput>;
  some?: InputMaybe<MdDoctorFilterInput>;
};

export type ListFilterInputTypeOfMdManifestFilterInput = {
  all?: InputMaybe<MdManifestFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<MdManifestFilterInput>;
  some?: InputMaybe<MdManifestFilterInput>;
};

export type ListFilterInputTypeOfMdPosTerminalFilterInput = {
  all?: InputMaybe<MdPosTerminalFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<MdPosTerminalFilterInput>;
  some?: InputMaybe<MdPosTerminalFilterInput>;
};

export type ListFilterInputTypeOfMdPricingDtlFilterInput = {
  all?: InputMaybe<MdPricingDtlFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<MdPricingDtlFilterInput>;
  some?: InputMaybe<MdPricingDtlFilterInput>;
};

export type ListFilterInputTypeOfMddiscountProductFilterInput = {
  all?: InputMaybe<MddiscountProductFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<MddiscountProductFilterInput>;
  some?: InputMaybe<MddiscountProductFilterInput>;
};

export type ListFilterInputTypeOfMdpricingHdrFilterInput = {
  all?: InputMaybe<MdpricingHdrFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<MdpricingHdrFilterInput>;
  some?: InputMaybe<MdpricingHdrFilterInput>;
};

export type ListFilterInputTypeOfMetrcProcessingJobFilterInput = {
  all?: InputMaybe<MetrcProcessingJobFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<MetrcProcessingJobFilterInput>;
  some?: InputMaybe<MetrcProcessingJobFilterInput>;
};

export type ListFilterInputTypeOfMetrcProcessingJobTypeAttributeFilterInput = {
  all?: InputMaybe<MetrcProcessingJobTypeAttributeFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<MetrcProcessingJobTypeAttributeFilterInput>;
  some?: InputMaybe<MetrcProcessingJobTypeAttributeFilterInput>;
};

export type ListFilterInputTypeOfMetrcProcessingJobTypeFilterInput = {
  all?: InputMaybe<MetrcProcessingJobTypeFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<MetrcProcessingJobTypeFilterInput>;
  some?: InputMaybe<MetrcProcessingJobTypeFilterInput>;
};

export type ListFilterInputTypeOfMetrcProcessingJobTypeTemplateFilterInput = {
  all?: InputMaybe<MetrcProcessingJobTypeTemplateFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<MetrcProcessingJobTypeTemplateFilterInput>;
  some?: InputMaybe<MetrcProcessingJobTypeTemplateFilterInput>;
};

export type ListFilterInputTypeOfMmurformFilterInput = {
  all?: InputMaybe<MmurformFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<MmurformFilterInput>;
  some?: InputMaybe<MmurformFilterInput>;
};

export type ListFilterInputTypeOfMncontrolInfoFilterInput = {
  all?: InputMaybe<MncontrolInfoFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<MncontrolInfoFilterInput>;
  some?: InputMaybe<MncontrolInfoFilterInput>;
};

export type ListFilterInputTypeOfOrderFilterInput = {
  all?: InputMaybe<OrderFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<OrderFilterInput>;
  some?: InputMaybe<OrderFilterInput>;
};

export type ListFilterInputTypeOfOrderItemFilterInput = {
  all?: InputMaybe<OrderItemFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<OrderItemFilterInput>;
  some?: InputMaybe<OrderItemFilterInput>;
};

export type ListFilterInputTypeOfOrderRedemptionFilterInput = {
  all?: InputMaybe<OrderRedemptionFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<OrderRedemptionFilterInput>;
  some?: InputMaybe<OrderRedemptionFilterInput>;
};

export type ListFilterInputTypeOfPackageAuditDatumFilterInput = {
  all?: InputMaybe<PackageAuditDatumFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<PackageAuditDatumFilterInput>;
  some?: InputMaybe<PackageAuditDatumFilterInput>;
};

export type ListFilterInputTypeOfPackageFilterInput = {
  all?: InputMaybe<PackageFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<PackageFilterInput>;
  some?: InputMaybe<PackageFilterInput>;
};

export type ListFilterInputTypeOfPackageItemLabelFilterInput = {
  all?: InputMaybe<PackageItemLabelFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<PackageItemLabelFilterInput>;
  some?: InputMaybe<PackageItemLabelFilterInput>;
};

export type ListFilterInputTypeOfPackageToCustomerTypeFilterInput = {
  all?: InputMaybe<PackageToCustomerTypeFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<PackageToCustomerTypeFilterInput>;
  some?: InputMaybe<PackageToCustomerTypeFilterInput>;
};

export type ListFilterInputTypeOfPackageToTagFilterInput = {
  all?: InputMaybe<PackageToTagFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<PackageToTagFilterInput>;
  some?: InputMaybe<PackageToTagFilterInput>;
};

export type ListFilterInputTypeOfPermissionFilterInput = {
  all?: InputMaybe<PermissionFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<PermissionFilterInput>;
  some?: InputMaybe<PermissionFilterInput>;
};

export type ListFilterInputTypeOfPlantNutrientLogFilterInput = {
  all?: InputMaybe<PlantNutrientLogFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<PlantNutrientLogFilterInput>;
  some?: InputMaybe<PlantNutrientLogFilterInput>;
};

export type ListFilterInputTypeOfPlantRoomHistoryFilterInput = {
  all?: InputMaybe<PlantRoomHistoryFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<PlantRoomHistoryFilterInput>;
  some?: InputMaybe<PlantRoomHistoryFilterInput>;
};

export type ListFilterInputTypeOfPlantStageTransitionFilterInput = {
  all?: InputMaybe<PlantStageTransitionFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<PlantStageTransitionFilterInput>;
  some?: InputMaybe<PlantStageTransitionFilterInput>;
};

export type ListFilterInputTypeOfPlantTransactionFilterInput = {
  all?: InputMaybe<PlantTransactionFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<PlantTransactionFilterInput>;
  some?: InputMaybe<PlantTransactionFilterInput>;
};

export type ListFilterInputTypeOfPmpcontrolInfoFilterInput = {
  all?: InputMaybe<PmpcontrolInfoFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<PmpcontrolInfoFilterInput>;
  some?: InputMaybe<PmpcontrolInfoFilterInput>;
};

export type ListFilterInputTypeOfPricingTierGroupFilterInput = {
  all?: InputMaybe<PricingTierGroupFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<PricingTierGroupFilterInput>;
  some?: InputMaybe<PricingTierGroupFilterInput>;
};

export type ListFilterInputTypeOfProductDosageFilterInput = {
  all?: InputMaybe<ProductDosageFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<ProductDosageFilterInput>;
  some?: InputMaybe<ProductDosageFilterInput>;
};

export type ListFilterInputTypeOfProductSizeListItemFilterInput = {
  all?: InputMaybe<ProductSizeListItemFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<ProductSizeListItemFilterInput>;
  some?: InputMaybe<ProductSizeListItemFilterInput>;
};

export type ListFilterInputTypeOfProductTaxCategoryFilterInput = {
  all?: InputMaybe<ProductTaxCategoryFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<ProductTaxCategoryFilterInput>;
  some?: InputMaybe<ProductTaxCategoryFilterInput>;
};

export type ListFilterInputTypeOfProductToCustomerTypeFilterInput = {
  all?: InputMaybe<ProductToCustomerTypeFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<ProductToCustomerTypeFilterInput>;
  some?: InputMaybe<ProductToCustomerTypeFilterInput>;
};

export type ListFilterInputTypeOfProductToTagFilterInput = {
  all?: InputMaybe<ProductToTagFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<ProductToTagFilterInput>;
  some?: InputMaybe<ProductToTagFilterInput>;
};

export type ListFilterInputTypeOfProductTypeToCustomerTypeFilterInput = {
  all?: InputMaybe<ProductTypeToCustomerTypeFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<ProductTypeToCustomerTypeFilterInput>;
  some?: InputMaybe<ProductTypeToCustomerTypeFilterInput>;
};

export type ListFilterInputTypeOfPurchaseLimitFilterInput = {
  all?: InputMaybe<PurchaseLimitFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<PurchaseLimitFilterInput>;
  some?: InputMaybe<PurchaseLimitFilterInput>;
};

export type ListFilterInputTypeOfPurchaseLimitToPurchaseLimitCategoryFilterInput = {
  all?: InputMaybe<PurchaseLimitToPurchaseLimitCategoryFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<PurchaseLimitToPurchaseLimitCategoryFilterInput>;
  some?: InputMaybe<PurchaseLimitToPurchaseLimitCategoryFilterInput>;
};

export type ListFilterInputTypeOfReceiptSettingFilterInput = {
  all?: InputMaybe<ReceiptSettingFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<ReceiptSettingFilterInput>;
  some?: InputMaybe<ReceiptSettingFilterInput>;
};

export type ListFilterInputTypeOfReceiveInventoryHistoryFilterInput = {
  all?: InputMaybe<ReceiveInventoryHistoryFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<ReceiveInventoryHistoryFilterInput>;
  some?: InputMaybe<ReceiveInventoryHistoryFilterInput>;
};

export type ListFilterInputTypeOfRegisterLedgerFilterInput = {
  all?: InputMaybe<RegisterLedgerFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<RegisterLedgerFilterInput>;
  some?: InputMaybe<RegisterLedgerFilterInput>;
};

export type ListFilterInputTypeOfRemovedInventoryFilterInput = {
  all?: InputMaybe<RemovedInventoryFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<RemovedInventoryFilterInput>;
  some?: InputMaybe<RemovedInventoryFilterInput>;
};

export type ListFilterInputTypeOfReturnReasonFilterInput = {
  all?: InputMaybe<ReturnReasonFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<ReturnReasonFilterInput>;
  some?: InputMaybe<ReturnReasonFilterInput>;
};

export type ListFilterInputTypeOfRoomTerminalFilterInput = {
  all?: InputMaybe<RoomTerminalFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<RoomTerminalFilterInput>;
  some?: InputMaybe<RoomTerminalFilterInput>;
};

export type ListFilterInputTypeOfRoomToMenuFilterInput = {
  all?: InputMaybe<RoomToMenuFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<RoomToMenuFilterInput>;
  some?: InputMaybe<RoomToMenuFilterInput>;
};

export type ListFilterInputTypeOfTagFilterInput = {
  all?: InputMaybe<TagFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<TagFilterInput>;
  some?: InputMaybe<TagFilterInput>;
};

export type ListFilterInputTypeOfTaxRateFilterInput = {
  all?: InputMaybe<TaxRateFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<TaxRateFilterInput>;
  some?: InputMaybe<TaxRateFilterInput>;
};

export type ListFilterInputTypeOfTaxRateToCustomerTypeFilterInput = {
  all?: InputMaybe<TaxRateToCustomerTypeFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<TaxRateToCustomerTypeFilterInput>;
  some?: InputMaybe<TaxRateToCustomerTypeFilterInput>;
};

export type ListFilterInputTypeOfTaxRateToProductTaxCategoryFilterInput = {
  all?: InputMaybe<TaxRateToProductTaxCategoryFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<TaxRateToProductTaxCategoryFilterInput>;
  some?: InputMaybe<TaxRateToProductTaxCategoryFilterInput>;
};

export type ListFilterInputTypeOfTblAcctFilterInput = {
  all?: InputMaybe<TblAcctFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<TblAcctFilterInput>;
  some?: InputMaybe<TblAcctFilterInput>;
};

export type ListFilterInputTypeOfTblAuthDomainLspLinkFilterInput = {
  all?: InputMaybe<TblAuthDomainLspLinkFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<TblAuthDomainLspLinkFilterInput>;
  some?: InputMaybe<TblAuthDomainLspLinkFilterInput>;
};

export type ListFilterInputTypeOfTblAuthUserFilterInput = {
  all?: InputMaybe<TblAuthUserFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<TblAuthUserFilterInput>;
  some?: InputMaybe<TblAuthUserFilterInput>;
};

export type ListFilterInputTypeOfTblAuthUsersAuditDatumFilterInput = {
  all?: InputMaybe<TblAuthUsersAuditDatumFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<TblAuthUsersAuditDatumFilterInput>;
  some?: InputMaybe<TblAuthUsersAuditDatumFilterInput>;
};

export type ListFilterInputTypeOfTblBatchFilterInput = {
  all?: InputMaybe<TblBatchFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<TblBatchFilterInput>;
  some?: InputMaybe<TblBatchFilterInput>;
};

export type ListFilterInputTypeOfTblBatchRoomFilterInput = {
  all?: InputMaybe<TblBatchRoomFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<TblBatchRoomFilterInput>;
  some?: InputMaybe<TblBatchRoomFilterInput>;
};

export type ListFilterInputTypeOfTblBatchStrainFilterInput = {
  all?: InputMaybe<TblBatchStrainFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<TblBatchStrainFilterInput>;
  some?: InputMaybe<TblBatchStrainFilterInput>;
};

export type ListFilterInputTypeOfTblBatchThcFilterInput = {
  all?: InputMaybe<TblBatchThcFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<TblBatchThcFilterInput>;
  some?: InputMaybe<TblBatchThcFilterInput>;
};

export type ListFilterInputTypeOfTblBatchTrayFilterInput = {
  all?: InputMaybe<TblBatchTrayFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<TblBatchTrayFilterInput>;
  some?: InputMaybe<TblBatchTrayFilterInput>;
};

export type ListFilterInputTypeOfTblChargeCodesSetFilterInput = {
  all?: InputMaybe<TblChargeCodesSetFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<TblChargeCodesSetFilterInput>;
  some?: InputMaybe<TblChargeCodesSetFilterInput>;
};

export type ListFilterInputTypeOfTblDispensaryScheduleFilterInput = {
  all?: InputMaybe<TblDispensaryScheduleFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<TblDispensaryScheduleFilterInput>;
  some?: InputMaybe<TblDispensaryScheduleFilterInput>;
};

export type ListFilterInputTypeOfTblInventoryStatusFilterInput = {
  all?: InputMaybe<TblInventoryStatusFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<TblInventoryStatusFilterInput>;
  some?: InputMaybe<TblInventoryStatusFilterInput>;
};

export type ListFilterInputTypeOfTblLspFilterInput = {
  all?: InputMaybe<TblLspFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<TblLspFilterInput>;
  some?: InputMaybe<TblLspFilterInput>;
};

export type ListFilterInputTypeOfTblLspLocationFilterInput = {
  all?: InputMaybe<TblLspLocationFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<TblLspLocationFilterInput>;
  some?: InputMaybe<TblLspLocationFilterInput>;
};

export type ListFilterInputTypeOfTblMdbatchPlantIdFilterInput = {
  all?: InputMaybe<TblMdbatchPlantIdFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<TblMdbatchPlantIdFilterInput>;
  some?: InputMaybe<TblMdbatchPlantIdFilterInput>;
};

export type ListFilterInputTypeOfTblMdcarFilterInput = {
  all?: InputMaybe<TblMdcarFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<TblMdcarFilterInput>;
  some?: InputMaybe<TblMdcarFilterInput>;
};

export type ListFilterInputTypeOfTblMddriverFilterInput = {
  all?: InputMaybe<TblMddriverFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<TblMddriverFilterInput>;
  some?: InputMaybe<TblMddriverFilterInput>;
};

export type ListFilterInputTypeOfTblMdlabelFilterInput = {
  all?: InputMaybe<TblMdlabelFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<TblMdlabelFilterInput>;
  some?: InputMaybe<TblMdlabelFilterInput>;
};

export type ListFilterInputTypeOfTblMdorderFilterInput = {
  all?: InputMaybe<TblMdorderFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<TblMdorderFilterInput>;
  some?: InputMaybe<TblMdorderFilterInput>;
};

export type ListFilterInputTypeOfTblMdshipmentFilterInput = {
  all?: InputMaybe<TblMdshipmentFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<TblMdshipmentFilterInput>;
  some?: InputMaybe<TblMdshipmentFilterInput>;
};

export type ListFilterInputTypeOfTblVendorFilterInput = {
  all?: InputMaybe<TblVendorFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<TblVendorFilterInput>;
  some?: InputMaybe<TblVendorFilterInput>;
};

export type ListFilterInputTypeOfTblWhseProductFilterInput = {
  all?: InputMaybe<TblWhseProductFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<TblWhseProductFilterInput>;
  some?: InputMaybe<TblWhseProductFilterInput>;
};

export type ListFilterInputTypeOfTblWhseProductTypeFilterInput = {
  all?: InputMaybe<TblWhseProductTypeFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<TblWhseProductTypeFilterInput>;
  some?: InputMaybe<TblWhseProductTypeFilterInput>;
};

export type ListFilterInputTypeOfTblWhseProductsAuditDatumFilterInput = {
  all?: InputMaybe<TblWhseProductsAuditDatumFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<TblWhseProductsAuditDatumFilterInput>;
  some?: InputMaybe<TblWhseProductsAuditDatumFilterInput>;
};

export type ListFilterInputTypeOfTrymControlInfoFilterInput = {
  all?: InputMaybe<TrymControlInfoFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<TrymControlInfoFilterInput>;
  some?: InputMaybe<TrymControlInfoFilterInput>;
};

export type ListFilterInputTypeOfUnitFilterInput = {
  all?: InputMaybe<UnitFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<UnitFilterInput>;
  some?: InputMaybe<UnitFilterInput>;
};

export type ListFilterInputTypeOfUserGroupFilterInput = {
  all?: InputMaybe<UserGroupFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<UserGroupFilterInput>;
  some?: InputMaybe<UserGroupFilterInput>;
};

export type ListFilterInputTypeOfUserLspFilterInput = {
  all?: InputMaybe<UserLspFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<UserLspFilterInput>;
  some?: InputMaybe<UserLspFilterInput>;
};

export type ListFilterInputTypeOfUserToPermissionFilterInput = {
  all?: InputMaybe<UserToPermissionFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<UserToPermissionFilterInput>;
  some?: InputMaybe<UserToPermissionFilterInput>;
};

export type ListFilterInputTypeOfUserToUserGroupFilterInput = {
  all?: InputMaybe<UserToUserGroupFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<UserToUserGroupFilterInput>;
  some?: InputMaybe<UserToUserGroupFilterInput>;
};

export type ListFilterInputTypeOfValidatedFormFieldFilterInput = {
  all?: InputMaybe<ValidatedFormFieldFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<ValidatedFormFieldFilterInput>;
  some?: InputMaybe<ValidatedFormFieldFilterInput>;
};

export type ListFilterInputTypeOfValidatedFormFieldOptionFilterInput = {
  all?: InputMaybe<ValidatedFormFieldOptionFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<ValidatedFormFieldOptionFilterInput>;
  some?: InputMaybe<ValidatedFormFieldOptionFilterInput>;
};

export type LocationInfo = {
  id: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
};

export type LocationProductMaster = {
  cost?: Maybe<Scalars['Decimal']>;
  externalCategory?: Maybe<Scalars['String']>;
  externalId?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  locId: Scalars['Int'];
  lowInventoryThreshold?: Maybe<Scalars['Decimal']>;
  maxPurchasable?: Maybe<Scalars['Decimal']>;
  onlineAvailable?: Maybe<Scalars['Byte']>;
  package?: Maybe<Package>;
  posAvailable?: Maybe<Scalars['Byte']>;
  price?: Maybe<Scalars['Decimal']>;
  productId: Scalars['Int'];
  recPrice?: Maybe<Scalars['Decimal']>;
  salesAccount?: Maybe<Scalars['String']>;
};

export type LocationProductMasterFilterInput = {
  and?: InputMaybe<Array<LocationProductMasterFilterInput>>;
  cost?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  externalCategory?: InputMaybe<StringOperationFilterInput>;
  externalId?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  locId?: InputMaybe<ComparableInt32OperationFilterInput>;
  lowInventoryThreshold?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  maxPurchasable?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  onlineAvailable?: InputMaybe<ComparableNullableOfByteOperationFilterInput>;
  or?: InputMaybe<Array<LocationProductMasterFilterInput>>;
  package?: InputMaybe<PackageFilterInput>;
  posAvailable?: InputMaybe<ComparableNullableOfByteOperationFilterInput>;
  price?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  productId?: InputMaybe<ComparableInt32OperationFilterInput>;
  recPrice?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  salesAccount?: InputMaybe<StringOperationFilterInput>;
};

export type LocationProductMasterSortInput = {
  cost?: InputMaybe<SortEnumType>;
  externalCategory?: InputMaybe<SortEnumType>;
  externalId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  locId?: InputMaybe<SortEnumType>;
  lowInventoryThreshold?: InputMaybe<SortEnumType>;
  maxPurchasable?: InputMaybe<SortEnumType>;
  onlineAvailable?: InputMaybe<SortEnumType>;
  package?: InputMaybe<PackageSortInput>;
  posAvailable?: InputMaybe<SortEnumType>;
  price?: InputMaybe<SortEnumType>;
  productId?: InputMaybe<SortEnumType>;
  recPrice?: InputMaybe<SortEnumType>;
  salesAccount?: InputMaybe<SortEnumType>;
};

export type LoyaltyDiscountRedemption = {
  alpineIqid?: Maybe<Scalars['String']>;
  appliedDiscounts?: Maybe<Array<Maybe<AppliedDiscount>>>;
  callbackUrl?: Maybe<Scalars['String']>;
  fylloId?: Maybe<Scalars['Int']>;
  locId?: Maybe<Scalars['Int']>;
  loyaltyDiscount?: Maybe<Discount>;
  loyaltyDiscountId?: Maybe<Scalars['Int']>;
  loyaltyDiscountRedemptionId: Scalars['Int'];
  loyaltyPointCost: Scalars['Int'];
  lspId?: Maybe<Scalars['Int']>;
  redemptionName?: Maybe<Scalars['String']>;
  shipmentId?: Maybe<Scalars['Int']>;
  springBigId?: Maybe<Scalars['String']>;
};

export type LoyaltyDiscountRedemptionFilterInput = {
  alpineIqid?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<LoyaltyDiscountRedemptionFilterInput>>;
  appliedDiscounts?: InputMaybe<ListFilterInputTypeOfAppliedDiscountFilterInput>;
  callbackUrl?: InputMaybe<StringOperationFilterInput>;
  fylloId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  locId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  loyaltyDiscount?: InputMaybe<DiscountFilterInput>;
  loyaltyDiscountId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  loyaltyDiscountRedemptionId?: InputMaybe<ComparableInt32OperationFilterInput>;
  loyaltyPointCost?: InputMaybe<ComparableInt32OperationFilterInput>;
  lspId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  or?: InputMaybe<Array<LoyaltyDiscountRedemptionFilterInput>>;
  redemptionName?: InputMaybe<StringOperationFilterInput>;
  shipmentId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  springBigId?: InputMaybe<StringOperationFilterInput>;
};

export type LspFeature = {
  feature?: Maybe<Feature>;
  featureId: Scalars['Int'];
  id: Scalars['Int'];
  isEnabled: Scalars['Boolean'];
  locId?: Maybe<Scalars['Int']>;
  lspId?: Maybe<Scalars['Int']>;
};

export type LspFeatureFilterInput = {
  and?: InputMaybe<Array<LspFeatureFilterInput>>;
  feature?: InputMaybe<FeatureFilterInput>;
  featureId?: InputMaybe<ComparableInt32OperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  isEnabled?: InputMaybe<BooleanOperationFilterInput>;
  locId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  lspId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  or?: InputMaybe<Array<LspFeatureFilterInput>>;
};

export type LspFeatureSortInput = {
  feature?: InputMaybe<FeatureSortInput>;
  featureId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isEnabled?: InputMaybe<SortEnumType>;
  locId?: InputMaybe<SortEnumType>;
  lspId?: InputMaybe<SortEnumType>;
};

export type LspFeaturesAudit = {
  auditAction?: Maybe<Scalars['AuditActionScalar']>;
  auditDateTimeUtc: Scalars['DateTime'];
  changedByUser?: Maybe<TblAuthUser>;
  featureChanged?: Maybe<Feature>;
  featureId: Scalars['Int'];
  id: Scalars['Int'];
  isEnabled: Scalars['Boolean'];
  locId?: Maybe<Scalars['Int']>;
  location?: Maybe<LocationInfo>;
  lspId?: Maybe<Scalars['Int']>;
  sessionLocId?: Maybe<Scalars['Int']>;
  sessionLspId?: Maybe<Scalars['Int']>;
  sessionUserID?: Maybe<Scalars['Int']>;
};

export type LspFeaturesAuditCollectionSegment = {
  items?: Maybe<Array<Maybe<LspFeaturesAudit>>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

export type LspFeaturesAuditFilterInput = {
  and?: InputMaybe<Array<LspFeaturesAuditFilterInput>>;
  auditAction?: InputMaybe<StringOperationFilterInput>;
  auditDateTimeUtc?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  featureChanged?: InputMaybe<FeatureFilterInput>;
  featureId?: InputMaybe<ComparableInt32OperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  isEnabled?: InputMaybe<BooleanOperationFilterInput>;
  locId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  lspId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  or?: InputMaybe<Array<LspFeaturesAuditFilterInput>>;
  sessionLocId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  sessionLspId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  sessionUserID?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
};

export type LspFeaturesAuditSortInput = {
  auditAction?: InputMaybe<SortEnumType>;
  auditDateTimeUtc?: InputMaybe<SortEnumType>;
  featureChanged?: InputMaybe<FeatureSortInput>;
  featureId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isEnabled?: InputMaybe<SortEnumType>;
  locId?: InputMaybe<SortEnumType>;
  lspId?: InputMaybe<SortEnumType>;
  sessionLocId?: InputMaybe<SortEnumType>;
  sessionLspId?: InputMaybe<SortEnumType>;
  sessionUserID?: InputMaybe<SortEnumType>;
};

export type ManifestToDriver = {
  driver?: Maybe<TblMddriver>;
  driverId: Scalars['Int'];
  driverPosition: Scalars['Int'];
  manifest?: Maybe<MdManifest>;
  manifestId: Scalars['Int'];
};

export type ManifestToDriverFilterInput = {
  and?: InputMaybe<Array<ManifestToDriverFilterInput>>;
  driver?: InputMaybe<TblMddriverFilterInput>;
  driverId?: InputMaybe<ComparableInt32OperationFilterInput>;
  driverPosition?: InputMaybe<ComparableInt32OperationFilterInput>;
  manifest?: InputMaybe<MdManifestFilterInput>;
  manifestId?: InputMaybe<ComparableInt32OperationFilterInput>;
  or?: InputMaybe<Array<ManifestToDriverFilterInput>>;
};

export type MdDiscountProductsList = {
  dprod?: Maybe<TblWhseProduct>;
  dprodId: Scalars['Int'];
  id: Scalars['Int'];
  prod?: Maybe<TblWhseProduct>;
  prodId: Scalars['Int'];
};

export type MdDiscountProductsListFilterInput = {
  and?: InputMaybe<Array<MdDiscountProductsListFilterInput>>;
  dprod?: InputMaybe<TblWhseProductFilterInput>;
  dprodId?: InputMaybe<ComparableInt32OperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  or?: InputMaybe<Array<MdDiscountProductsListFilterInput>>;
  prod?: InputMaybe<TblWhseProductFilterInput>;
  prodId?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type MdDoctor = {
  deanumber?: Maybe<Scalars['String']>;
  doctorsAdd1?: Maybe<Scalars['String']>;
  doctorsAdd2?: Maybe<Scalars['String']>;
  doctorsCity?: Maybe<Scalars['String']>;
  doctorsCtry?: Maybe<Scalars['Int']>;
  doctorsEmail?: Maybe<Scalars['String']>;
  doctorsId: Scalars['String'];
  doctorsName: Scalars['String'];
  doctorsPhone?: Maybe<Scalars['String']>;
  doctorsState?: Maybe<Scalars['String']>;
  faxNo?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  loc?: Maybe<TblLspLocation>;
  locId: Scalars['Int'];
  lsp?: Maybe<TblLsp>;
  lspId: Scalars['Int'];
  npinumber?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  tblAccts?: Maybe<Array<Maybe<TblAcct>>>;
};

export type MdDoctorCollectionSegment = {
  items?: Maybe<Array<Maybe<MdDoctor>>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

export type MdDoctorFilterInput = {
  and?: InputMaybe<Array<MdDoctorFilterInput>>;
  deanumber?: InputMaybe<StringOperationFilterInput>;
  doctorsAdd1?: InputMaybe<StringOperationFilterInput>;
  doctorsAdd2?: InputMaybe<StringOperationFilterInput>;
  doctorsCity?: InputMaybe<StringOperationFilterInput>;
  doctorsCtry?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  doctorsEmail?: InputMaybe<StringOperationFilterInput>;
  doctorsId?: InputMaybe<StringOperationFilterInput>;
  doctorsName?: InputMaybe<StringOperationFilterInput>;
  doctorsPhone?: InputMaybe<StringOperationFilterInput>;
  doctorsState?: InputMaybe<StringOperationFilterInput>;
  faxNo?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  loc?: InputMaybe<TblLspLocationFilterInput>;
  locId?: InputMaybe<ComparableInt32OperationFilterInput>;
  lsp?: InputMaybe<TblLspFilterInput>;
  lspId?: InputMaybe<ComparableInt32OperationFilterInput>;
  npinumber?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<MdDoctorFilterInput>>;
  postalCode?: InputMaybe<StringOperationFilterInput>;
  tblAccts?: InputMaybe<ListFilterInputTypeOfTblAcctFilterInput>;
};

export type MdDoctorSortInput = {
  deanumber?: InputMaybe<SortEnumType>;
  doctorsAdd1?: InputMaybe<SortEnumType>;
  doctorsAdd2?: InputMaybe<SortEnumType>;
  doctorsCity?: InputMaybe<SortEnumType>;
  doctorsCtry?: InputMaybe<SortEnumType>;
  doctorsEmail?: InputMaybe<SortEnumType>;
  doctorsId?: InputMaybe<SortEnumType>;
  doctorsName?: InputMaybe<SortEnumType>;
  doctorsPhone?: InputMaybe<SortEnumType>;
  doctorsState?: InputMaybe<SortEnumType>;
  faxNo?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  loc?: InputMaybe<TblLspLocationSortInput>;
  locId?: InputMaybe<SortEnumType>;
  lsp?: InputMaybe<TblLspSortInput>;
  lspId?: InputMaybe<SortEnumType>;
  npinumber?: InputMaybe<SortEnumType>;
  postalCode?: InputMaybe<SortEnumType>;
};

export type MdManifest = {
  assignedToRouteBy?: Maybe<Scalars['Int']>;
  assignedToRouteByNavigation?: Maybe<TblAuthUser>;
  biotId?: Maybe<Scalars['String']>;
  car?: Maybe<TblMdcar>;
  carId?: Maybe<Scalars['Int']>;
  closedDate?: Maybe<Scalars['DateTime']>;
  companyName?: Maybe<Scalars['String']>;
  deliveryRoute?: Maybe<DeliveryRoute>;
  deliveryRouteHistories?: Maybe<Array<Maybe<DeliveryRouteHistory>>>;
  deliveryRouteId?: Maybe<Scalars['Int']>;
  deliveryStatusId?: Maybe<Scalars['Int']>;
  failedReason?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  isAutoDispatched: Scalars['Boolean'];
  isPickup: Scalars['Boolean'];
  lastModifiedDateUtc?: Maybe<Scalars['DateTime']>;
  leafTransporterMmeId?: Maybe<Scalars['String']>;
  leafType?: Maybe<Scalars['String']>;
  licenseNo?: Maybe<Scalars['String']>;
  loc?: Maybe<TblLspLocation>;
  locId?: Maybe<Scalars['Int']>;
  lsp?: Maybe<TblLsp>;
  lspId?: Maybe<Scalars['Int']>;
  manifestToDrivers?: Maybe<Array<Maybe<ManifestToDriver>>>;
  pointOfContact?: Maybe<Scalars['String']>;
  readyDate?: Maybe<Scalars['DateTime']>;
  superManifestId?: Maybe<Scalars['Int']>;
  tblMdshipments?: Maybe<Array<Maybe<TblMdshipment>>>;
};

export type MdManifestFilterInput = {
  and?: InputMaybe<Array<MdManifestFilterInput>>;
  assignedToRouteBy?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  assignedToRouteByNavigation?: InputMaybe<TblAuthUserFilterInput>;
  biotId?: InputMaybe<StringOperationFilterInput>;
  car?: InputMaybe<TblMdcarFilterInput>;
  carId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  closedDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  companyName?: InputMaybe<StringOperationFilterInput>;
  deliveryRoute?: InputMaybe<DeliveryRouteFilterInput>;
  deliveryRouteHistories?: InputMaybe<ListFilterInputTypeOfDeliveryRouteHistoryFilterInput>;
  deliveryRouteId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  deliveryStatusId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  failedReason?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  isAutoDispatched?: InputMaybe<BooleanOperationFilterInput>;
  isPickup?: InputMaybe<BooleanOperationFilterInput>;
  lastModifiedDateUtc?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  leafTransporterMmeId?: InputMaybe<StringOperationFilterInput>;
  leafType?: InputMaybe<StringOperationFilterInput>;
  licenseNo?: InputMaybe<StringOperationFilterInput>;
  loc?: InputMaybe<TblLspLocationFilterInput>;
  locId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  lsp?: InputMaybe<TblLspFilterInput>;
  lspId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  manifestToDrivers?: InputMaybe<ListFilterInputTypeOfManifestToDriverFilterInput>;
  or?: InputMaybe<Array<MdManifestFilterInput>>;
  pointOfContact?: InputMaybe<StringOperationFilterInput>;
  readyDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  superManifestId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  tblMdshipments?: InputMaybe<ListFilterInputTypeOfTblMdshipmentFilterInput>;
};

export type MdManifestSortInput = {
  assignedToRouteBy?: InputMaybe<SortEnumType>;
  assignedToRouteByNavigation?: InputMaybe<TblAuthUserSortInput>;
  biotId?: InputMaybe<SortEnumType>;
  car?: InputMaybe<TblMdcarSortInput>;
  carId?: InputMaybe<SortEnumType>;
  closedDate?: InputMaybe<SortEnumType>;
  companyName?: InputMaybe<SortEnumType>;
  deliveryRoute?: InputMaybe<DeliveryRouteSortInput>;
  deliveryRouteId?: InputMaybe<SortEnumType>;
  deliveryStatusId?: InputMaybe<SortEnumType>;
  failedReason?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isAutoDispatched?: InputMaybe<SortEnumType>;
  isPickup?: InputMaybe<SortEnumType>;
  lastModifiedDateUtc?: InputMaybe<SortEnumType>;
  leafTransporterMmeId?: InputMaybe<SortEnumType>;
  leafType?: InputMaybe<SortEnumType>;
  licenseNo?: InputMaybe<SortEnumType>;
  loc?: InputMaybe<TblLspLocationSortInput>;
  locId?: InputMaybe<SortEnumType>;
  lsp?: InputMaybe<TblLspSortInput>;
  lspId?: InputMaybe<SortEnumType>;
  pointOfContact?: InputMaybe<SortEnumType>;
  readyDate?: InputMaybe<SortEnumType>;
  superManifestId?: InputMaybe<SortEnumType>;
};

export type MdPosTerminal = {
  allowDeliveryReceipts: Scalars['Boolean'];
  autoPrintFulfillmentTicket: Scalars['Boolean'];
  autoPrintLabels?: Maybe<Scalars['Boolean']>;
  autoPrintReceipts?: Maybe<Scalars['Boolean']>;
  cashThreshold?: Maybe<Scalars['Int']>;
  dcdirectDeviceId?: Maybe<Scalars['Int']>;
  defaultLabelId?: Maybe<Scalars['Int']>;
  defaultRoom?: Maybe<Scalars['Int']>;
  drawerStatusId: Scalars['Int'];
  fulfillmentPrinterId?: Maybe<Scalars['Int']>;
  hardwareId?: Maybe<Scalars['String']>;
  hideSalesFloorInventory: Scalars['Boolean'];
  id: Scalars['Int'];
  isHidden: Scalars['Boolean'];
  joryDeviceId?: Maybe<Scalars['Int']>;
  labelPrinterId?: Maybe<Scalars['Int']>;
  loc?: Maybe<TblLspLocation>;
  locId: Scalars['Int'];
  lsp?: Maybe<TblLsp>;
  lspId: Scalars['Int'];
  planetPaymentsDeviceId?: Maybe<Scalars['Int']>;
  popCashDrawer: Scalars['Boolean'];
  popUpNotesOnEntry?: Maybe<Scalars['Boolean']>;
  receiptPrinterId?: Maybe<Scalars['Int']>;
  registerLedgers?: Maybe<Array<Maybe<RegisterLedger>>>;
  restrictToScaleWeighing: Scalars['Boolean'];
  roomTerminals?: Maybe<Array<Maybe<RoomTerminal>>>;
  skylightDeviceId?: Maybe<Scalars['Int']>;
  spinDeviceId?: Maybe<Scalars['Int']>;
  tblBatchRooms?: Maybe<Array<Maybe<TblBatchRoom>>>;
  tblDispensarySchedules?: Maybe<Array<Maybe<TblDispensarySchedule>>>;
  tblLspLocations?: Maybe<Array<Maybe<TblLspLocation>>>;
  tblMdcars?: Maybe<Array<Maybe<TblMdcar>>>;
  tblMdshipments?: Maybe<Array<Maybe<TblMdshipment>>>;
  terminalName: Scalars['String'];
  tranCloudDeviceId?: Maybe<Scalars['Int']>;
};

export type MdPosTerminalFilterInput = {
  allowDeliveryReceipts?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<MdPosTerminalFilterInput>>;
  autoPrintFulfillmentTicket?: InputMaybe<BooleanOperationFilterInput>;
  autoPrintLabels?: InputMaybe<BooleanOperationFilterInput>;
  autoPrintReceipts?: InputMaybe<BooleanOperationFilterInput>;
  cashThreshold?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  dcdirectDeviceId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  defaultLabelId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  defaultRoom?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  drawerStatusId?: InputMaybe<ComparableInt32OperationFilterInput>;
  fulfillmentPrinterId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  hardwareId?: InputMaybe<StringOperationFilterInput>;
  hideSalesFloorInventory?: InputMaybe<BooleanOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  isHidden?: InputMaybe<BooleanOperationFilterInput>;
  joryDeviceId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  labelPrinterId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  loc?: InputMaybe<TblLspLocationFilterInput>;
  locId?: InputMaybe<ComparableInt32OperationFilterInput>;
  lsp?: InputMaybe<TblLspFilterInput>;
  lspId?: InputMaybe<ComparableInt32OperationFilterInput>;
  or?: InputMaybe<Array<MdPosTerminalFilterInput>>;
  planetPaymentsDeviceId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  popCashDrawer?: InputMaybe<BooleanOperationFilterInput>;
  popUpNotesOnEntry?: InputMaybe<BooleanOperationFilterInput>;
  receiptPrinterId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  registerLedgers?: InputMaybe<ListFilterInputTypeOfRegisterLedgerFilterInput>;
  restrictToScaleWeighing?: InputMaybe<BooleanOperationFilterInput>;
  roomTerminals?: InputMaybe<ListFilterInputTypeOfRoomTerminalFilterInput>;
  skylightDeviceId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  spinDeviceId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  tblBatchRooms?: InputMaybe<ListFilterInputTypeOfTblBatchRoomFilterInput>;
  tblDispensarySchedules?: InputMaybe<ListFilterInputTypeOfTblDispensaryScheduleFilterInput>;
  tblLspLocations?: InputMaybe<ListFilterInputTypeOfTblLspLocationFilterInput>;
  tblMdcars?: InputMaybe<ListFilterInputTypeOfTblMdcarFilterInput>;
  tblMdshipments?: InputMaybe<ListFilterInputTypeOfTblMdshipmentFilterInput>;
  terminalName?: InputMaybe<StringOperationFilterInput>;
  tranCloudDeviceId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
};

export type MdPosTerminalSortInput = {
  allowDeliveryReceipts?: InputMaybe<SortEnumType>;
  autoPrintFulfillmentTicket?: InputMaybe<SortEnumType>;
  autoPrintLabels?: InputMaybe<SortEnumType>;
  autoPrintReceipts?: InputMaybe<SortEnumType>;
  cashThreshold?: InputMaybe<SortEnumType>;
  dcdirectDeviceId?: InputMaybe<SortEnumType>;
  defaultLabelId?: InputMaybe<SortEnumType>;
  defaultRoom?: InputMaybe<SortEnumType>;
  drawerStatusId?: InputMaybe<SortEnumType>;
  fulfillmentPrinterId?: InputMaybe<SortEnumType>;
  hardwareId?: InputMaybe<SortEnumType>;
  hideSalesFloorInventory?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isHidden?: InputMaybe<SortEnumType>;
  joryDeviceId?: InputMaybe<SortEnumType>;
  labelPrinterId?: InputMaybe<SortEnumType>;
  loc?: InputMaybe<TblLspLocationSortInput>;
  locId?: InputMaybe<SortEnumType>;
  lsp?: InputMaybe<TblLspSortInput>;
  lspId?: InputMaybe<SortEnumType>;
  planetPaymentsDeviceId?: InputMaybe<SortEnumType>;
  popCashDrawer?: InputMaybe<SortEnumType>;
  popUpNotesOnEntry?: InputMaybe<SortEnumType>;
  receiptPrinterId?: InputMaybe<SortEnumType>;
  restrictToScaleWeighing?: InputMaybe<SortEnumType>;
  skylightDeviceId?: InputMaybe<SortEnumType>;
  spinDeviceId?: InputMaybe<SortEnumType>;
  terminalName?: InputMaybe<SortEnumType>;
  tranCloudDeviceId?: InputMaybe<SortEnumType>;
};

export type MdPricingDtl = {
  id: Scalars['Int'];
  lsp?: Maybe<TblLsp>;
  lspId?: Maybe<Scalars['Int']>;
  medicalPrice?: Maybe<Scalars['Decimal']>;
  postTax?: Maybe<Scalars['Decimal']>;
  price?: Maybe<Scalars['Decimal']>;
  pricing?: Maybe<MdpricingHdr>;
  pricingId?: Maybe<Scalars['Int']>;
  weight?: Maybe<Scalars['Decimal']>;
};

export type MdPricingDtlCollectionSegment = {
  items?: Maybe<Array<Maybe<MdPricingDtl>>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

export type MdPricingDtlFilterInput = {
  and?: InputMaybe<Array<MdPricingDtlFilterInput>>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  lsp?: InputMaybe<TblLspFilterInput>;
  lspId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  medicalPrice?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  or?: InputMaybe<Array<MdPricingDtlFilterInput>>;
  postTax?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  price?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  pricing?: InputMaybe<MdpricingHdrFilterInput>;
  pricingId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  weight?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
};

export type MdPricingDtlSortInput = {
  id?: InputMaybe<SortEnumType>;
  lsp?: InputMaybe<TblLspSortInput>;
  lspId?: InputMaybe<SortEnumType>;
  medicalPrice?: InputMaybe<SortEnumType>;
  postTax?: InputMaybe<SortEnumType>;
  price?: InputMaybe<SortEnumType>;
  pricing?: InputMaybe<MdpricingHdrSortInput>;
  pricingId?: InputMaybe<SortEnumType>;
  weight?: InputMaybe<SortEnumType>;
};

export type MddiscountGroup = {
  discountDescription?: Maybe<Scalars['String']>;
  discountToDiscountGroups?: Maybe<Array<Maybe<DiscountToDiscountGroup>>>;
  id: Scalars['Int'];
  isActive: Scalars['Boolean'];
  isDeleted: Scalars['Boolean'];
  locId: Scalars['Int'];
  lspId: Scalars['Int'];
  tblAcctGroup1Navigations?: Maybe<Array<Maybe<TblAcct>>>;
  tblAcctGroup2Navigations?: Maybe<Array<Maybe<TblAcct>>>;
  tblAcctGroup3Navigations?: Maybe<Array<Maybe<TblAcct>>>;
  tblAcctGroup4Navigations?: Maybe<Array<Maybe<TblAcct>>>;
  tblAcctGroup5Navigations?: Maybe<Array<Maybe<TblAcct>>>;
};

export type MddiscountGroupCollectionSegment = {
  items?: Maybe<Array<Maybe<MddiscountGroup>>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

export type MddiscountGroupFilterInput = {
  and?: InputMaybe<Array<MddiscountGroupFilterInput>>;
  discountDescription?: InputMaybe<StringOperationFilterInput>;
  discountToDiscountGroups?: InputMaybe<ListFilterInputTypeOfDiscountToDiscountGroupFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  isActive?: InputMaybe<BooleanOperationFilterInput>;
  isDeleted?: InputMaybe<BooleanOperationFilterInput>;
  locId?: InputMaybe<ComparableInt32OperationFilterInput>;
  lspId?: InputMaybe<ComparableInt32OperationFilterInput>;
  or?: InputMaybe<Array<MddiscountGroupFilterInput>>;
  tblAcctGroup1Navigations?: InputMaybe<ListFilterInputTypeOfTblAcctFilterInput>;
  tblAcctGroup2Navigations?: InputMaybe<ListFilterInputTypeOfTblAcctFilterInput>;
  tblAcctGroup3Navigations?: InputMaybe<ListFilterInputTypeOfTblAcctFilterInput>;
  tblAcctGroup4Navigations?: InputMaybe<ListFilterInputTypeOfTblAcctFilterInput>;
  tblAcctGroup5Navigations?: InputMaybe<ListFilterInputTypeOfTblAcctFilterInput>;
};

export type MddiscountGroupSortInput = {
  discountDescription?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isActive?: InputMaybe<SortEnumType>;
  isDeleted?: InputMaybe<SortEnumType>;
  locId?: InputMaybe<SortEnumType>;
  lspId?: InputMaybe<SortEnumType>;
};

export type MddiscountProduct = {
  discountConstraint?: Maybe<DiscountConstraint>;
  discountConstraintId?: Maybe<Scalars['Int']>;
  discountMultiplier?: Maybe<Scalars['Decimal']>;
  discountReward?: Maybe<DiscountReward>;
  discountRewardId?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  isExclusion: Scalars['Boolean'];
  product?: Maybe<TblWhseProduct>;
  productId: Scalars['Int'];
};

export type MddiscountProductFilterInput = {
  and?: InputMaybe<Array<MddiscountProductFilterInput>>;
  discountConstraint?: InputMaybe<DiscountConstraintFilterInput>;
  discountConstraintId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  discountMultiplier?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  discountReward?: InputMaybe<DiscountRewardFilterInput>;
  discountRewardId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  isExclusion?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<MddiscountProductFilterInput>>;
  product?: InputMaybe<TblWhseProductFilterInput>;
  productId?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type MdpricingHdr = {
  category?: Maybe<TblWhseProductType>;
  categoryId?: Maybe<Scalars['Int']>;
  chargeCode?: Maybe<Scalars['Int']>;
  chargeCodeNavigation?: Maybe<TblChargeCodesSet>;
  id: Scalars['Int'];
  isExactWeightBundle: Scalars['Boolean'];
  loc?: Maybe<TblLspLocation>;
  locId?: Maybe<Scalars['Int']>;
  lsp?: Maybe<TblLsp>;
  lspId?: Maybe<Scalars['Int']>;
  mdPricingDtls?: Maybe<Array<Maybe<MdPricingDtl>>>;
  medical?: Maybe<Scalars['String']>;
  pricingTierGroup?: Maybe<PricingTierGroup>;
  pricingTierGroupId?: Maybe<Scalars['Int']>;
  pricingTierPerProduct: Scalars['Boolean'];
  qtyPricePoint?: Maybe<Scalars['Decimal']>;
  recreational?: Maybe<Scalars['String']>;
  strain?: Maybe<TblBatchStrain>;
  strainId?: Maybe<Scalars['Int']>;
  vendor?: Maybe<TblVendor>;
  vendorId?: Maybe<Scalars['Int']>;
  weighItem?: Maybe<Scalars['String']>;
};

export type MdpricingHdrFilterInput = {
  and?: InputMaybe<Array<MdpricingHdrFilterInput>>;
  category?: InputMaybe<TblWhseProductTypeFilterInput>;
  categoryId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  chargeCode?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  chargeCodeNavigation?: InputMaybe<TblChargeCodesSetFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  isExactWeightBundle?: InputMaybe<BooleanOperationFilterInput>;
  loc?: InputMaybe<TblLspLocationFilterInput>;
  locId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  lsp?: InputMaybe<TblLspFilterInput>;
  lspId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  mdPricingDtls?: InputMaybe<ListFilterInputTypeOfMdPricingDtlFilterInput>;
  medical?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<MdpricingHdrFilterInput>>;
  pricingTierGroup?: InputMaybe<PricingTierGroupFilterInput>;
  pricingTierGroupId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  pricingTierPerProduct?: InputMaybe<BooleanOperationFilterInput>;
  qtyPricePoint?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  recreational?: InputMaybe<StringOperationFilterInput>;
  strain?: InputMaybe<TblBatchStrainFilterInput>;
  strainId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  vendor?: InputMaybe<TblVendorFilterInput>;
  vendorId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  weighItem?: InputMaybe<StringOperationFilterInput>;
};

export type MdpricingHdrSortInput = {
  category?: InputMaybe<TblWhseProductTypeSortInput>;
  categoryId?: InputMaybe<SortEnumType>;
  chargeCode?: InputMaybe<SortEnumType>;
  chargeCodeNavigation?: InputMaybe<TblChargeCodesSetSortInput>;
  id?: InputMaybe<SortEnumType>;
  isExactWeightBundle?: InputMaybe<SortEnumType>;
  loc?: InputMaybe<TblLspLocationSortInput>;
  locId?: InputMaybe<SortEnumType>;
  lsp?: InputMaybe<TblLspSortInput>;
  lspId?: InputMaybe<SortEnumType>;
  medical?: InputMaybe<SortEnumType>;
  pricingTierGroup?: InputMaybe<PricingTierGroupSortInput>;
  pricingTierGroupId?: InputMaybe<SortEnumType>;
  pricingTierPerProduct?: InputMaybe<SortEnumType>;
  qtyPricePoint?: InputMaybe<SortEnumType>;
  recreational?: InputMaybe<SortEnumType>;
  strain?: InputMaybe<TblBatchStrainSortInput>;
  strainId?: InputMaybe<SortEnumType>;
  vendor?: InputMaybe<TblVendorSortInput>;
  vendorId?: InputMaybe<SortEnumType>;
  weighItem?: InputMaybe<SortEnumType>;
};

export type MetrcProcessingJob = {
  assembly?: Maybe<Assembly>;
  assemblyId: Scalars['Int'];
  metrcProcessingJobId: Scalars['Int'];
  metrcProcessingJobType?: Maybe<MetrcProcessingJobType>;
  metrcProcessingJobTypeId: Scalars['Int'];
  name: Scalars['String'];
};

export type MetrcProcessingJobFilterInput = {
  and?: InputMaybe<Array<MetrcProcessingJobFilterInput>>;
  assembly?: InputMaybe<AssemblyFilterInput>;
  assemblyId?: InputMaybe<ComparableInt32OperationFilterInput>;
  metrcProcessingJobId?: InputMaybe<ComparableInt32OperationFilterInput>;
  metrcProcessingJobType?: InputMaybe<MetrcProcessingJobTypeFilterInput>;
  metrcProcessingJobTypeId?: InputMaybe<ComparableInt32OperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<MetrcProcessingJobFilterInput>>;
};

export type MetrcProcessingJobSortInput = {
  assembly?: InputMaybe<AssemblySortInput>;
  assemblyId?: InputMaybe<SortEnumType>;
  metrcProcessingJobId?: InputMaybe<SortEnumType>;
  metrcProcessingJobType?: InputMaybe<MetrcProcessingJobTypeSortInput>;
  metrcProcessingJobTypeId?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
};

export type MetrcProcessingJobType = {
  externalId: Scalars['Int'];
  externalName: Scalars['String'];
  isDeprecated: Scalars['Boolean'];
  loc?: Maybe<TblLspLocation>;
  locId: Scalars['Int'];
  lsp?: Maybe<TblLsp>;
  lspId: Scalars['Int'];
  metrcProcessingJobTypeId: Scalars['Int'];
  metrcProcessingJobTypeTemplate?: Maybe<MetrcProcessingJobTypeTemplate>;
  metrcProcessingJobTypeTemplateId: Scalars['Int'];
  metrcProcessingJobs?: Maybe<Array<Maybe<MetrcProcessingJob>>>;
};

export type MetrcProcessingJobTypeAttribute = {
  metrcProcessingJobTypeAttributeId: Scalars['Int'];
  metrcProcessingJobTypeTemplate?: Maybe<MetrcProcessingJobTypeTemplate>;
  metrcProcessingJobTypeTemplateId: Scalars['Int'];
  name: Scalars['String'];
};

export type MetrcProcessingJobTypeAttributeFilterInput = {
  and?: InputMaybe<Array<MetrcProcessingJobTypeAttributeFilterInput>>;
  metrcProcessingJobTypeAttributeId?: InputMaybe<ComparableInt32OperationFilterInput>;
  metrcProcessingJobTypeTemplate?: InputMaybe<MetrcProcessingJobTypeTemplateFilterInput>;
  metrcProcessingJobTypeTemplateId?: InputMaybe<ComparableInt32OperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<MetrcProcessingJobTypeAttributeFilterInput>>;
};

export type MetrcProcessingJobTypeFilterInput = {
  and?: InputMaybe<Array<MetrcProcessingJobTypeFilterInput>>;
  externalId?: InputMaybe<ComparableInt32OperationFilterInput>;
  externalName?: InputMaybe<StringOperationFilterInput>;
  isDeprecated?: InputMaybe<BooleanOperationFilterInput>;
  loc?: InputMaybe<TblLspLocationFilterInput>;
  locId?: InputMaybe<ComparableInt32OperationFilterInput>;
  lsp?: InputMaybe<TblLspFilterInput>;
  lspId?: InputMaybe<ComparableInt32OperationFilterInput>;
  metrcProcessingJobTypeId?: InputMaybe<ComparableInt32OperationFilterInput>;
  metrcProcessingJobTypeTemplate?: InputMaybe<MetrcProcessingJobTypeTemplateFilterInput>;
  metrcProcessingJobTypeTemplateId?: InputMaybe<ComparableInt32OperationFilterInput>;
  metrcProcessingJobs?: InputMaybe<ListFilterInputTypeOfMetrcProcessingJobFilterInput>;
  or?: InputMaybe<Array<MetrcProcessingJobTypeFilterInput>>;
};

export type MetrcProcessingJobTypeSortInput = {
  externalId?: InputMaybe<SortEnumType>;
  externalName?: InputMaybe<SortEnumType>;
  isDeprecated?: InputMaybe<SortEnumType>;
  loc?: InputMaybe<TblLspLocationSortInput>;
  locId?: InputMaybe<SortEnumType>;
  lsp?: InputMaybe<TblLspSortInput>;
  lspId?: InputMaybe<SortEnumType>;
  metrcProcessingJobTypeId?: InputMaybe<SortEnumType>;
  metrcProcessingJobTypeTemplate?: InputMaybe<MetrcProcessingJobTypeTemplateSortInput>;
  metrcProcessingJobTypeTemplateId?: InputMaybe<SortEnumType>;
};

export type MetrcProcessingJobTypeTemplate = {
  billOfMaterials?: Maybe<BillOfMaterial>;
  billOfMaterialsId: Scalars['Int'];
  categoryName?: Maybe<Scalars['String']>;
  createdBy: Scalars['Int'];
  createdByNavigation?: Maybe<TblAuthUser>;
  createdOnUtc: Scalars['DateTime'];
  description: Scalars['String'];
  lastEditedBy?: Maybe<Scalars['Int']>;
  lastEditedByNavigation?: Maybe<TblAuthUser>;
  lastEditedOnUtc?: Maybe<Scalars['DateTime']>;
  lsp?: Maybe<TblLsp>;
  lspId: Scalars['Int'];
  metrcProcessingJobTypeAttributes?: Maybe<Array<Maybe<MetrcProcessingJobTypeAttribute>>>;
  metrcProcessingJobTypeTemplateId: Scalars['Int'];
  metrcProcessingJobTypes?: Maybe<Array<Maybe<MetrcProcessingJobType>>>;
  name: Scalars['String'];
  processingSteps?: Maybe<Scalars['String']>;
};

export type MetrcProcessingJobTypeTemplateFilterInput = {
  and?: InputMaybe<Array<MetrcProcessingJobTypeTemplateFilterInput>>;
  billOfMaterials?: InputMaybe<BillOfMaterialFilterInput>;
  billOfMaterialsId?: InputMaybe<ComparableInt32OperationFilterInput>;
  categoryName?: InputMaybe<StringOperationFilterInput>;
  createdBy?: InputMaybe<ComparableInt32OperationFilterInput>;
  createdByNavigation?: InputMaybe<TblAuthUserFilterInput>;
  createdOnUtc?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  lastEditedBy?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  lastEditedByNavigation?: InputMaybe<TblAuthUserFilterInput>;
  lastEditedOnUtc?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  lsp?: InputMaybe<TblLspFilterInput>;
  lspId?: InputMaybe<ComparableInt32OperationFilterInput>;
  metrcProcessingJobTypeAttributes?: InputMaybe<ListFilterInputTypeOfMetrcProcessingJobTypeAttributeFilterInput>;
  metrcProcessingJobTypeTemplateId?: InputMaybe<ComparableInt32OperationFilterInput>;
  metrcProcessingJobTypes?: InputMaybe<ListFilterInputTypeOfMetrcProcessingJobTypeFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<MetrcProcessingJobTypeTemplateFilterInput>>;
  processingSteps?: InputMaybe<StringOperationFilterInput>;
};

export type MetrcProcessingJobTypeTemplateSortInput = {
  billOfMaterials?: InputMaybe<BillOfMaterialSortInput>;
  billOfMaterialsId?: InputMaybe<SortEnumType>;
  categoryName?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  createdByNavigation?: InputMaybe<TblAuthUserSortInput>;
  createdOnUtc?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  lastEditedBy?: InputMaybe<SortEnumType>;
  lastEditedByNavigation?: InputMaybe<TblAuthUserSortInput>;
  lastEditedOnUtc?: InputMaybe<SortEnumType>;
  lsp?: InputMaybe<TblLspSortInput>;
  lspId?: InputMaybe<SortEnumType>;
  metrcProcessingJobTypeTemplateId?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  processingSteps?: InputMaybe<SortEnumType>;
};

export type Mmurform = {
  form?: Maybe<Scalars['String']>;
  formId: Scalars['Int'];
  productTypes?: Maybe<Array<Maybe<TblWhseProductType>>>;
};

export type MmurformFilterInput = {
  and?: InputMaybe<Array<MmurformFilterInput>>;
  form?: InputMaybe<StringOperationFilterInput>;
  formId?: InputMaybe<ComparableInt32OperationFilterInput>;
  or?: InputMaybe<Array<MmurformFilterInput>>;
  productTypes?: InputMaybe<ListFilterInputTypeOfTblWhseProductTypeFilterInput>;
};

export type MncontrolInfo = {
  authBaseUrl?: Maybe<Scalars['String']>;
  authPathUrl?: Maybe<Scalars['String']>;
  clientId?: Maybe<Scalars['String']>;
  clientSecret?: Maybe<Scalars['String']>;
  distributionId?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  integrationBaseUrl?: Maybe<Scalars['String']>;
  isEnabled?: Maybe<Scalars['Boolean']>;
  loc?: Maybe<TblLspLocation>;
  locId: Scalars['Int'];
  lsp?: Maybe<TblLsp>;
  lspId: Scalars['Int'];
  manufacturerId?: Maybe<Scalars['String']>;
};

export type MncontrolInfoFilterInput = {
  and?: InputMaybe<Array<MncontrolInfoFilterInput>>;
  authBaseUrl?: InputMaybe<StringOperationFilterInput>;
  authPathUrl?: InputMaybe<StringOperationFilterInput>;
  clientId?: InputMaybe<StringOperationFilterInput>;
  clientSecret?: InputMaybe<StringOperationFilterInput>;
  distributionId?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  integrationBaseUrl?: InputMaybe<StringOperationFilterInput>;
  isEnabled?: InputMaybe<BooleanOperationFilterInput>;
  loc?: InputMaybe<TblLspLocationFilterInput>;
  locId?: InputMaybe<ComparableInt32OperationFilterInput>;
  lsp?: InputMaybe<TblLspFilterInput>;
  lspId?: InputMaybe<ComparableInt32OperationFilterInput>;
  manufacturerId?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<MncontrolInfoFilterInput>>;
};

export type Mutation = {
  addPackageToAudit?: Maybe<ApiResultOfAddPackageToAuditResponse>;
  bulkConfirmCount: BulkConfirmCountPayload;
  bulkUpdateAuditDetails?: Maybe<ApiResultOfInt32>;
  /** Mutation to close an audit and make adjustments to inventory */
  closeAudit?: Maybe<ApiResultOfCloseAuditResponse>;
  createAudit: ApiResultOfInt32;
  /** Creates an audit from a list of packageIds */
  createAuditFromPackages: ApiResultOfCreateAuditFromPackagesResponse;
  deleteAudit?: Maybe<ApiResultOfFgrecon>;
  removePackageFromAudit?: Maybe<ApiResultOfRemovePackageFromAuditResponse>;
  setJobStatusCancelled?: Maybe<ApiResultOfSetJobStatusToCancelledResponse>;
  /** Mutation to submit an audit for review */
  submitAuditForReview?: Maybe<ApiResultOfFgrecon>;
  updateAuditDetail?: Maybe<ApiResultOfFgreconDetail>;
  /** Mutation to update audit details via CSV data */
  updateAuditDetailsViaCsv?: Maybe<ApiResultOfUpdateAuditDetailsViaCsvResponse>;
  updateAuditPackageCount?: Maybe<ApiResultOfFgreconDetail>;
  updateAuditStatus?: Maybe<ApiResultOfFgrecon>;
  updateProductRetiredStatus?: Maybe<ApiResultOfTblWhseProduct__>;
};


export type MutationAddPackageToAuditArgs = {
  input?: InputMaybe<AddPackageToAuditInput>;
};


export type MutationBulkConfirmCountArgs = {
  input?: InputMaybe<BulkConfirmCountInput>;
};


export type MutationBulkUpdateAuditDetailsArgs = {
  input?: InputMaybe<BulkUpdateAuditDetailsInput>;
};


export type MutationCloseAuditArgs = {
  input?: InputMaybe<CloseAuditInput>;
};


export type MutationCreateAuditArgs = {
  input: CreateAuditInput;
};


export type MutationCreateAuditFromPackagesArgs = {
  input: CreateAuditFromPackagesInput;
};


export type MutationDeleteAuditArgs = {
  input?: InputMaybe<DeleteAuditStatusInput>;
};


export type MutationRemovePackageFromAuditArgs = {
  input?: InputMaybe<RemovePackageFromAuditInput>;
};


export type MutationSetJobStatusCancelledArgs = {
  input?: InputMaybe<SetJobStatusToCancelledInput>;
};


export type MutationSubmitAuditForReviewArgs = {
  input?: InputMaybe<SubmitAuditForReviewInput>;
};


export type MutationUpdateAuditDetailArgs = {
  input?: InputMaybe<UpdateAuditDetailInput>;
};


export type MutationUpdateAuditDetailsViaCsvArgs = {
  input?: InputMaybe<UpdateAuditDetailsViaCsvInput>;
};


export type MutationUpdateAuditPackageCountArgs = {
  input?: InputMaybe<UpdatePackageCountInput>;
};


export type MutationUpdateAuditStatusArgs = {
  input?: InputMaybe<UpdateAuditStatusInput>;
};


export type MutationUpdateProductRetiredStatusArgs = {
  input?: InputMaybe<UpdateProductRetiredStatusInput>;
};

export type NewPackageQuantity = {
  id: Scalars['Int'];
  quantity: Scalars['Decimal'];
};

export type Order = {
  apiPreOrderStatus?: Maybe<Scalars['Int']>;
  customer?: Maybe<TblAcct>;
  customerId?: Maybe<Scalars['Int']>;
  dateCreated?: Maybe<Scalars['DateTime']>;
  fulfillNotes?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  loc?: Maybe<TblLspLocation>;
  locId: Scalars['Int'];
  lsp?: Maybe<TblLsp>;
  lspId: Scalars['Int'];
  orderItems?: Maybe<Array<Maybe<OrderItem>>>;
  orderRedemptions?: Maybe<Array<Maybe<OrderRedemption>>>;
  orderSourceId?: Maybe<Scalars['Int']>;
  orderStatus?: Maybe<Scalars['Int']>;
  orderType?: Maybe<Scalars['Int']>;
  rejectedReason?: Maybe<Scalars['String']>;
  shipment?: Maybe<TblMdshipment>;
  shipmentId?: Maybe<Scalars['Int']>;
};

export type OrderFilterInput = {
  and?: InputMaybe<Array<OrderFilterInput>>;
  apiPreOrderStatus?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  customer?: InputMaybe<TblAcctFilterInput>;
  customerId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  dateCreated?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  fulfillNotes?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  loc?: InputMaybe<TblLspLocationFilterInput>;
  locId?: InputMaybe<ComparableInt32OperationFilterInput>;
  lsp?: InputMaybe<TblLspFilterInput>;
  lspId?: InputMaybe<ComparableInt32OperationFilterInput>;
  or?: InputMaybe<Array<OrderFilterInput>>;
  orderItems?: InputMaybe<ListFilterInputTypeOfOrderItemFilterInput>;
  orderRedemptions?: InputMaybe<ListFilterInputTypeOfOrderRedemptionFilterInput>;
  orderSourceId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  orderStatus?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  orderType?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  rejectedReason?: InputMaybe<StringOperationFilterInput>;
  shipment?: InputMaybe<TblMdshipmentFilterInput>;
  shipmentId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
};

export type OrderItem = {
  id: Scalars['Int'];
  isDeleted: Scalars['Boolean'];
  order?: Maybe<Order>;
  orderId?: Maybe<Scalars['Int']>;
  product?: Maybe<TblWhseProduct>;
  productId?: Maybe<Scalars['Int']>;
  quantity?: Maybe<Scalars['Decimal']>;
  unit?: Maybe<Unit>;
  unitId?: Maybe<Scalars['Int']>;
  unitPrice?: Maybe<Scalars['Decimal']>;
  wgt?: Maybe<Scalars['Decimal']>;
};

export type OrderItemFilterInput = {
  and?: InputMaybe<Array<OrderItemFilterInput>>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  isDeleted?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<OrderItemFilterInput>>;
  order?: InputMaybe<OrderFilterInput>;
  orderId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  product?: InputMaybe<TblWhseProductFilterInput>;
  productId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  quantity?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  unit?: InputMaybe<UnitFilterInput>;
  unitId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  unitPrice?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  wgt?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
};

export type OrderRedemption = {
  alpineId?: Maybe<Scalars['String']>;
  callbackUrl?: Maybe<Scalars['String']>;
  fylloId?: Maybe<Scalars['String']>;
  isDeleted: Scalars['Boolean'];
  isRedeemed: Scalars['Boolean'];
  leafLogixCode?: Maybe<Scalars['String']>;
  order?: Maybe<Order>;
  orderId?: Maybe<Scalars['Int']>;
  orderRedemptionId: Scalars['Int'];
  productId?: Maybe<Scalars['Int']>;
  redemptionDescription?: Maybe<Scalars['String']>;
  springBigId?: Maybe<Scalars['String']>;
  springBigType?: Maybe<Scalars['String']>;
};

export type OrderRedemptionFilterInput = {
  alpineId?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<OrderRedemptionFilterInput>>;
  callbackUrl?: InputMaybe<StringOperationFilterInput>;
  fylloId?: InputMaybe<StringOperationFilterInput>;
  isDeleted?: InputMaybe<BooleanOperationFilterInput>;
  isRedeemed?: InputMaybe<BooleanOperationFilterInput>;
  leafLogixCode?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<OrderRedemptionFilterInput>>;
  order?: InputMaybe<OrderFilterInput>;
  orderId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  orderRedemptionId?: InputMaybe<ComparableInt32OperationFilterInput>;
  productId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  redemptionDescription?: InputMaybe<StringOperationFilterInput>;
  springBigId?: InputMaybe<StringOperationFilterInput>;
  springBigType?: InputMaybe<StringOperationFilterInput>;
};

export type OutputItemType = {
  assemblyOutputItems?: Maybe<Array<Maybe<AssemblyOutputItem>>>;
  billOfMaterialsOutputItems?: Maybe<Array<Maybe<BillOfMaterialsOutputItem>>>;
  name?: Maybe<Scalars['String']>;
  outputItemTypeId: Scalars['Byte'];
};

export type OutputItemTypeFilterInput = {
  and?: InputMaybe<Array<OutputItemTypeFilterInput>>;
  assemblyOutputItems?: InputMaybe<ListFilterInputTypeOfAssemblyOutputItemFilterInput>;
  billOfMaterialsOutputItems?: InputMaybe<ListFilterInputTypeOfBillOfMaterialsOutputItemFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<OutputItemTypeFilterInput>>;
  outputItemTypeId?: InputMaybe<ComparableByteOperationFilterInput>;
};

export type Package = {
  allocatedInventorySum?: Maybe<Scalars['Decimal']>;
  assemblyInputPackages?: Maybe<Array<Maybe<AssemblyInputPackage>>>;
  assemblyOutputItems?: Maybe<Array<Maybe<AssemblyOutputItem>>>;
  batch?: Maybe<TblBatch>;
  batchId?: Maybe<Scalars['Int']>;
  bioTrackProductCategoryId?: Maybe<Scalars['Int']>;
  bioTrackQAStatus?: Maybe<Scalars['String']>;
  cbd?: Maybe<Scalars['String']>;
  cost?: Maybe<Scalars['Decimal']>;
  cultivationTax?: Maybe<Scalars['Decimal']>;
  daysSupply?: Maybe<Scalars['String']>;
  effectivePotencyMg?: Maybe<Scalars['Decimal']>;
  exciseTax?: Maybe<Scalars['Decimal']>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  fgreconDetails?: Maybe<Array<Maybe<FgreconDetail>>>;
  flowerEquivalent?: Maybe<Scalars['Decimal']>;
  growPackageId?: Maybe<Scalars['Int']>;
  hasMultipleParentPackages: Scalars['Boolean'];
  iltaxCategory?: Maybe<Scalars['Byte']>;
  instructions?: Maybe<Scalars['String']>;
  inventorySourceBatches?: Maybe<Array<Maybe<InventorySourceBatch>>>;
  inventoryStatus?: Maybe<TblInventoryStatus>;
  inventoryStatusId?: Maybe<Scalars['Int']>;
  inventoryTransactions?: Maybe<Array<Maybe<InventoryTransaction>>>;
  inverseParentPackage?: Maybe<Array<Maybe<Package>>>;
  inverseReturnFromPackage?: Maybe<Array<Maybe<Package>>>;
  isFinishedInIntegration?: Maybe<Scalars['Boolean']>;
  isOnHold: Scalars['Boolean'];
  isOnRecall?: Maybe<Scalars['Boolean']>;
  isSample?: Maybe<Scalars['Boolean']>;
  lastDatePackageAuditedUtc?: Maybe<Scalars['DateTime']>;
  lastModifiedUtc?: Maybe<Scalars['DateTime']>;
  loc?: Maybe<TblLspLocation>;
  locId: Scalars['Int'];
  locationProductMaster?: Maybe<LocationProductMaster>;
  lsp?: Maybe<TblLsp>;
  lspId: Scalars['Int'];
  manufacturingDate?: Maybe<Scalars['DateTime']>;
  medicalOnly: Scalars['Boolean'];
  metrclabTestingStatus?: Maybe<Scalars['String']>;
  netWeight?: Maybe<Scalars['Decimal']>;
  netWeightUnit?: Maybe<Scalars['Int']>;
  netWeightUnitNavigation?: Maybe<Unit>;
  packageGroup?: Maybe<PackageGroup>;
  packageGroupId?: Maybe<Scalars['Long']>;
  packageId: Scalars['Int'];
  packageNdc?: Maybe<Scalars['String']>;
  packageToCustomerTypes?: Maybe<Array<Maybe<PackageToCustomerType>>>;
  packageToTags?: Maybe<Array<Maybe<PackageToTag>>>;
  packageWeight?: Maybe<Scalars['Decimal']>;
  packagedDate?: Maybe<Scalars['DateTime']>;
  parentPackage?: Maybe<Package>;
  parentPackageId?: Maybe<Scalars['Int']>;
  parentPackageSerialNumber?: Maybe<Scalars['String']>;
  potencyIndicator?: Maybe<Scalars['Int']>;
  prescriptionNumber?: Maybe<Scalars['Int']>;
  producer?: Maybe<Producer>;
  producerId?: Maybe<Scalars['Int']>;
  product?: Maybe<TblWhseProduct>;
  productId: Scalars['Int'];
  productWeight?: Maybe<Scalars['Decimal']>;
  productionBatchNumber?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Decimal']>;
  recFlowerEquivalent?: Maybe<Scalars['Decimal']>;
  recUnitPrice?: Maybe<Scalars['Decimal']>;
  receiveInventoryHistory?: Maybe<ReceiveInventoryHistory>;
  receiveInventoryHistoryId?: Maybe<Scalars['Int']>;
  receivedDate?: Maybe<Scalars['DateTime']>;
  removedInventories?: Maybe<Array<Maybe<RemovedInventory>>>;
  returnFromPackage?: Maybe<Package>;
  returnFromPackageId?: Maybe<Scalars['Int']>;
  room?: Maybe<TblBatchRoom>;
  roomId?: Maybe<Scalars['Int']>;
  sampleType?: Maybe<Scalars['String']>;
  serialNumber: Scalars['String'];
  sourceSerialNumber?: Maybe<Scalars['String']>;
  table?: Maybe<TblBatchTray>;
  tableId?: Maybe<Scalars['Int']>;
  tax?: Maybe<Scalars['Decimal']>;
  thc?: Maybe<Scalars['String']>;
  totalPackageCost?: Maybe<Scalars['Decimal']>;
  unit?: Maybe<Unit>;
  unitId: Scalars['Int'];
  unitPrice?: Maybe<Scalars['Decimal']>;
  updatedBy?: Maybe<Scalars['Int']>;
  useByDate?: Maybe<Scalars['DateTime']>;
  vendor?: Maybe<TblVendor>;
  vendorId?: Maybe<Scalars['Int']>;
};

export type PackageAudit = {
  auditAction?: Maybe<Scalars['AuditActionScalar']>;
  auditDateTimeUtc: Scalars['DateTime'];
  changedByUser?: Maybe<TblAuthUser>;
  locId?: Maybe<Scalars['Int']>;
  location?: Maybe<LocationInfo>;
  lspId?: Maybe<Scalars['Int']>;
  packageAuditData?: Maybe<Array<Maybe<PackageAuditDatum>>>;
  packageAuditId: Scalars['Int'];
  packageChanged?: Maybe<Package>;
  packageId?: Maybe<Scalars['Int']>;
  sessionlocId?: Maybe<Scalars['Int']>;
  sessionlspId?: Maybe<Scalars['Int']>;
  userId?: Maybe<Scalars['Int']>;
};

export type PackageAuditCollectionSegment = {
  items?: Maybe<Array<Maybe<PackageAudit>>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

export type PackageAuditDatum = {
  columnChanged?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  newValue?: Maybe<Scalars['String']>;
  oldValue?: Maybe<Scalars['String']>;
  packageAudit?: Maybe<PackageAudit>;
  packageAuditID: Scalars['Int'];
};

export type PackageAuditDatumFilterInput = {
  and?: InputMaybe<Array<PackageAuditDatumFilterInput>>;
  columnChanged?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  newValue?: InputMaybe<StringOperationFilterInput>;
  oldValue?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<PackageAuditDatumFilterInput>>;
  packageAudit?: InputMaybe<PackageAuditFilterInput>;
  packageAuditID?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type PackageAuditFilterInput = {
  and?: InputMaybe<Array<PackageAuditFilterInput>>;
  auditAction?: InputMaybe<StringOperationFilterInput>;
  auditDateTimeUtc?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  locId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  lspId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  or?: InputMaybe<Array<PackageAuditFilterInput>>;
  packageAuditData?: InputMaybe<ListFilterInputTypeOfPackageAuditDatumFilterInput>;
  packageAuditId?: InputMaybe<ComparableInt32OperationFilterInput>;
  packageChanged?: InputMaybe<PackageFilterInput>;
  packageId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  sessionlocId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  sessionlspId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  userId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
};

export type PackageAuditSortInput = {
  auditAction?: InputMaybe<SortEnumType>;
  auditDateTimeUtc?: InputMaybe<SortEnumType>;
  locId?: InputMaybe<SortEnumType>;
  lspId?: InputMaybe<SortEnumType>;
  packageAuditId?: InputMaybe<SortEnumType>;
  packageChanged?: InputMaybe<PackageSortInput>;
  packageId?: InputMaybe<SortEnumType>;
  sessionlocId?: InputMaybe<SortEnumType>;
  sessionlspId?: InputMaybe<SortEnumType>;
  userId?: InputMaybe<SortEnumType>;
};

export type PackageCollectionSegment = {
  items?: Maybe<Array<Maybe<Package>>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

export type PackageFilterInput = {
  and?: InputMaybe<Array<PackageFilterInput>>;
  assemblyInputPackages?: InputMaybe<ListFilterInputTypeOfAssemblyInputPackageFilterInput>;
  assemblyOutputItems?: InputMaybe<ListFilterInputTypeOfAssemblyOutputItemFilterInput>;
  batch?: InputMaybe<TblBatchFilterInput>;
  batchId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  bioTrackProductCategoryId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  bioTrackQAStatus?: InputMaybe<StringOperationFilterInput>;
  cbd?: InputMaybe<StringOperationFilterInput>;
  cost?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  cultivationTax?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  daysSupply?: InputMaybe<StringOperationFilterInput>;
  effectivePotencyMg?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  exciseTax?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  expirationDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  fgreconDetails?: InputMaybe<ListFilterInputTypeOfFgreconDetailFilterInput>;
  flowerEquivalent?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  growPackageId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  hasMultipleParentPackages?: InputMaybe<BooleanOperationFilterInput>;
  iltaxCategory?: InputMaybe<ComparableNullableOfByteOperationFilterInput>;
  instructions?: InputMaybe<StringOperationFilterInput>;
  inventorySourceBatches?: InputMaybe<ListFilterInputTypeOfInventorySourceBatchFilterInput>;
  inventoryStatus?: InputMaybe<TblInventoryStatusFilterInput>;
  inventoryStatusId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  inventoryTransactions?: InputMaybe<ListFilterInputTypeOfInventoryTransactionFilterInput>;
  inverseParentPackage?: InputMaybe<ListFilterInputTypeOfPackageFilterInput>;
  inverseReturnFromPackage?: InputMaybe<ListFilterInputTypeOfPackageFilterInput>;
  isFinishedInIntegration?: InputMaybe<BooleanOperationFilterInput>;
  isSample?: InputMaybe<BooleanOperationFilterInput>;
  lastModifiedUtc?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  loc?: InputMaybe<TblLspLocationFilterInput>;
  locId?: InputMaybe<ComparableInt32OperationFilterInput>;
  locationProductMaster?: InputMaybe<LocationProductMasterFilterInput>;
  lsp?: InputMaybe<TblLspFilterInput>;
  lspId?: InputMaybe<ComparableInt32OperationFilterInput>;
  manufacturingDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  medicalOnly?: InputMaybe<BooleanOperationFilterInput>;
  metrclabTestingStatus?: InputMaybe<StringOperationFilterInput>;
  netWeight?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  netWeightUnit?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  netWeightUnitNavigation?: InputMaybe<UnitFilterInput>;
  or?: InputMaybe<Array<PackageFilterInput>>;
  packageGroup?: InputMaybe<PackageGroupFilterInput>;
  packageGroupId?: InputMaybe<ComparableNullableOfInt64OperationFilterInput>;
  packageId?: InputMaybe<ComparableInt32OperationFilterInput>;
  packageNdc?: InputMaybe<StringOperationFilterInput>;
  packageToCustomerTypes?: InputMaybe<ListFilterInputTypeOfPackageToCustomerTypeFilterInput>;
  packageToTags?: InputMaybe<ListFilterInputTypeOfPackageToTagFilterInput>;
  packageWeight?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  packagedDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  parentPackage?: InputMaybe<PackageFilterInput>;
  parentPackageId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  parentPackageSerialNumber?: InputMaybe<StringOperationFilterInput>;
  potencyIndicator?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  prescriptionNumber?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  producer?: InputMaybe<ProducerFilterInput>;
  producerId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  product?: InputMaybe<TblWhseProductFilterInput>;
  productId?: InputMaybe<ComparableInt32OperationFilterInput>;
  productWeight?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  productionBatchNumber?: InputMaybe<StringOperationFilterInput>;
  quantity?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  recFlowerEquivalent?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  recUnitPrice?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  receiveInventoryHistory?: InputMaybe<ReceiveInventoryHistoryFilterInput>;
  receiveInventoryHistoryId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  receivedDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  removedInventories?: InputMaybe<ListFilterInputTypeOfRemovedInventoryFilterInput>;
  returnFromPackage?: InputMaybe<PackageFilterInput>;
  returnFromPackageId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  room?: InputMaybe<TblBatchRoomFilterInput>;
  roomId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  sampleType?: InputMaybe<StringOperationFilterInput>;
  serialNumber?: InputMaybe<StringOperationFilterInput>;
  sourceSerialNumber?: InputMaybe<StringOperationFilterInput>;
  table?: InputMaybe<TblBatchTrayFilterInput>;
  tableId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  tax?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  thc?: InputMaybe<StringOperationFilterInput>;
  totalPackageCost?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  unit?: InputMaybe<UnitFilterInput>;
  unitId?: InputMaybe<ComparableInt32OperationFilterInput>;
  unitPrice?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  updatedBy?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  useByDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  vendor?: InputMaybe<TblVendorFilterInput>;
  vendorId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
};

export type PackageGroup = {
  packageGroupId: Scalars['Long'];
  packageItemLabels?: Maybe<Array<Maybe<PackageItemLabel>>>;
  packages?: Maybe<Array<Maybe<Package>>>;
};

export type PackageGroupFilterInput = {
  and?: InputMaybe<Array<PackageGroupFilterInput>>;
  or?: InputMaybe<Array<PackageGroupFilterInput>>;
  packageGroupId?: InputMaybe<ComparableInt64OperationFilterInput>;
  packageItemLabels?: InputMaybe<ListFilterInputTypeOfPackageItemLabelFilterInput>;
  packages?: InputMaybe<ListFilterInputTypeOfPackageFilterInput>;
};

export type PackageGroupSortInput = {
  packageGroupId?: InputMaybe<SortEnumType>;
};

export type PackageItemLabel = {
  id: Scalars['Int'];
  itemLabel?: Maybe<Scalars['String']>;
  lsp?: Maybe<TblLsp>;
  lspId?: Maybe<Scalars['Int']>;
  packageGroup?: Maybe<PackageGroup>;
  packageGroupId: Scalars['Long'];
};

export type PackageItemLabelFilterInput = {
  and?: InputMaybe<Array<PackageItemLabelFilterInput>>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  itemLabel?: InputMaybe<StringOperationFilterInput>;
  lsp?: InputMaybe<TblLspFilterInput>;
  lspId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  or?: InputMaybe<Array<PackageItemLabelFilterInput>>;
  packageGroup?: InputMaybe<PackageGroupFilterInput>;
  packageGroupId?: InputMaybe<ComparableInt64OperationFilterInput>;
};

export type PackageQuantityChangedError = Error & {
  message: Scalars['String'];
  updatedPackageQuantities?: Maybe<Array<Maybe<NewPackageQuantity>>>;
};

export type PackageSortInput = {
  batch?: InputMaybe<TblBatchSortInput>;
  batchId?: InputMaybe<SortEnumType>;
  bioTrackProductCategoryId?: InputMaybe<SortEnumType>;
  bioTrackQAStatus?: InputMaybe<SortEnumType>;
  cbd?: InputMaybe<SortEnumType>;
  cost?: InputMaybe<SortEnumType>;
  cultivationTax?: InputMaybe<SortEnumType>;
  daysSupply?: InputMaybe<SortEnumType>;
  effectivePotencyMg?: InputMaybe<SortEnumType>;
  exciseTax?: InputMaybe<SortEnumType>;
  expirationDate?: InputMaybe<SortEnumType>;
  flowerEquivalent?: InputMaybe<SortEnumType>;
  growPackageId?: InputMaybe<SortEnumType>;
  hasMultipleParentPackages?: InputMaybe<SortEnumType>;
  iltaxCategory?: InputMaybe<SortEnumType>;
  instructions?: InputMaybe<SortEnumType>;
  inventoryStatus?: InputMaybe<TblInventoryStatusSortInput>;
  inventoryStatusId?: InputMaybe<SortEnumType>;
  isFinishedInIntegration?: InputMaybe<SortEnumType>;
  isSample?: InputMaybe<SortEnumType>;
  lastModifiedUtc?: InputMaybe<SortEnumType>;
  loc?: InputMaybe<TblLspLocationSortInput>;
  locId?: InputMaybe<SortEnumType>;
  locationProductMaster?: InputMaybe<LocationProductMasterSortInput>;
  lsp?: InputMaybe<TblLspSortInput>;
  lspId?: InputMaybe<SortEnumType>;
  manufacturingDate?: InputMaybe<SortEnumType>;
  medicalOnly?: InputMaybe<SortEnumType>;
  metrclabTestingStatus?: InputMaybe<SortEnumType>;
  netWeight?: InputMaybe<SortEnumType>;
  netWeightUnit?: InputMaybe<SortEnumType>;
  netWeightUnitNavigation?: InputMaybe<UnitSortInput>;
  packageGroup?: InputMaybe<PackageGroupSortInput>;
  packageGroupId?: InputMaybe<SortEnumType>;
  packageId?: InputMaybe<SortEnumType>;
  packageNdc?: InputMaybe<SortEnumType>;
  packageWeight?: InputMaybe<SortEnumType>;
  packagedDate?: InputMaybe<SortEnumType>;
  parentPackage?: InputMaybe<PackageSortInput>;
  parentPackageId?: InputMaybe<SortEnumType>;
  parentPackageSerialNumber?: InputMaybe<SortEnumType>;
  potencyIndicator?: InputMaybe<SortEnumType>;
  prescriptionNumber?: InputMaybe<SortEnumType>;
  producer?: InputMaybe<ProducerSortInput>;
  producerId?: InputMaybe<SortEnumType>;
  product?: InputMaybe<TblWhseProductSortInput>;
  productId?: InputMaybe<SortEnumType>;
  productWeight?: InputMaybe<SortEnumType>;
  productionBatchNumber?: InputMaybe<SortEnumType>;
  quantity?: InputMaybe<SortEnumType>;
  recFlowerEquivalent?: InputMaybe<SortEnumType>;
  recUnitPrice?: InputMaybe<SortEnumType>;
  receiveInventoryHistory?: InputMaybe<ReceiveInventoryHistorySortInput>;
  receiveInventoryHistoryId?: InputMaybe<SortEnumType>;
  receivedDate?: InputMaybe<SortEnumType>;
  returnFromPackage?: InputMaybe<PackageSortInput>;
  returnFromPackageId?: InputMaybe<SortEnumType>;
  room?: InputMaybe<TblBatchRoomSortInput>;
  roomId?: InputMaybe<SortEnumType>;
  sampleType?: InputMaybe<SortEnumType>;
  serialNumber?: InputMaybe<SortEnumType>;
  sourceSerialNumber?: InputMaybe<SortEnumType>;
  table?: InputMaybe<TblBatchTraySortInput>;
  tableId?: InputMaybe<SortEnumType>;
  tax?: InputMaybe<SortEnumType>;
  thc?: InputMaybe<SortEnumType>;
  totalPackageCost?: InputMaybe<SortEnumType>;
  unit?: InputMaybe<UnitSortInput>;
  unitId?: InputMaybe<SortEnumType>;
  unitPrice?: InputMaybe<SortEnumType>;
  updatedBy?: InputMaybe<SortEnumType>;
  useByDate?: InputMaybe<SortEnumType>;
  vendor?: InputMaybe<TblVendorSortInput>;
  vendorId?: InputMaybe<SortEnumType>;
};

export type PackageToCustomerType = {
  customerType?: Maybe<CustomerType>;
  customerTypeId: Scalars['Int'];
  id: Scalars['Int'];
  loc?: Maybe<TblLspLocation>;
  locId: Scalars['Int'];
  lsp?: Maybe<TblLsp>;
  lspId: Scalars['Int'];
  serialNumber?: Maybe<Scalars['String']>;
};

export type PackageToCustomerTypeFilterInput = {
  and?: InputMaybe<Array<PackageToCustomerTypeFilterInput>>;
  customerType?: InputMaybe<CustomerTypeFilterInput>;
  customerTypeId?: InputMaybe<ComparableInt32OperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  loc?: InputMaybe<TblLspLocationFilterInput>;
  locId?: InputMaybe<ComparableInt32OperationFilterInput>;
  lsp?: InputMaybe<TblLspFilterInput>;
  lspId?: InputMaybe<ComparableInt32OperationFilterInput>;
  or?: InputMaybe<Array<PackageToCustomerTypeFilterInput>>;
  serialNumber?: InputMaybe<StringOperationFilterInput>;
};

export type PackageToTag = {
  id: Scalars['Int'];
  loc?: Maybe<TblLspLocation>;
  locId?: Maybe<Scalars['Int']>;
  lsp?: Maybe<TblLsp>;
  lspId?: Maybe<Scalars['Int']>;
  package?: Maybe<Package>;
  packageId: Scalars['Int'];
  smartTag?: Maybe<SmartTag>;
  tag?: Maybe<Tag>;
  tagId: Scalars['Int'];
};

export type PackageToTagFilterInput = {
  and?: InputMaybe<Array<PackageToTagFilterInput>>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  loc?: InputMaybe<TblLspLocationFilterInput>;
  locId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  lsp?: InputMaybe<TblLspFilterInput>;
  lspId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  or?: InputMaybe<Array<PackageToTagFilterInput>>;
  package?: InputMaybe<PackageFilterInput>;
  packageId?: InputMaybe<ComparableInt32OperationFilterInput>;
  smartTag?: InputMaybe<SmartTagFilterInput>;
  tag?: InputMaybe<TagFilterInput>;
  tagId?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type Permission = {
  featureId?: Maybe<Scalars['Int']>;
  permissionCategoryId?: Maybe<Scalars['Int']>;
  permissionDescription?: Maybe<Scalars['String']>;
  permissionId: Scalars['Int'];
  permissionName: Scalars['String'];
  userGroups?: Maybe<Array<Maybe<UserGroup>>>;
  userToPermissions?: Maybe<Array<Maybe<UserToPermission>>>;
  visible: Scalars['Boolean'];
};

export type PermissionFilterInput = {
  and?: InputMaybe<Array<PermissionFilterInput>>;
  featureId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  or?: InputMaybe<Array<PermissionFilterInput>>;
  permissionCategoryId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  permissionDescription?: InputMaybe<StringOperationFilterInput>;
  permissionId?: InputMaybe<ComparableInt32OperationFilterInput>;
  permissionName?: InputMaybe<StringOperationFilterInput>;
  userGroups?: InputMaybe<ListFilterInputTypeOfUserGroupFilterInput>;
  userToPermissions?: InputMaybe<ListFilterInputTypeOfUserToPermissionFilterInput>;
  visible?: InputMaybe<BooleanOperationFilterInput>;
};

export type PermissionSortInput = {
  featureId?: InputMaybe<SortEnumType>;
  permissionCategoryId?: InputMaybe<SortEnumType>;
  permissionDescription?: InputMaybe<SortEnumType>;
  permissionId?: InputMaybe<SortEnumType>;
  permissionName?: InputMaybe<SortEnumType>;
  visible?: InputMaybe<SortEnumType>;
};

export type PlantNutrientLog = {
  appliedBy: Scalars['Int'];
  appliedByUser?: Maybe<TblAuthUser>;
  appliedOnUtc: Scalars['DateTime'];
  id: Scalars['Int'];
  plant?: Maybe<TblMdbatchPlantId>;
  plantId: Scalars['Int'];
  product?: Maybe<TblWhseProduct>;
  productId: Scalars['Int'];
  quantity: Scalars['Decimal'];
  totalCost?: Maybe<Scalars['Decimal']>;
  unitCost?: Maybe<Scalars['Decimal']>;
  unitId: Scalars['Int'];
};

export type PlantNutrientLogFilterInput = {
  and?: InputMaybe<Array<PlantNutrientLogFilterInput>>;
  appliedBy?: InputMaybe<ComparableInt32OperationFilterInput>;
  appliedByUser?: InputMaybe<TblAuthUserFilterInput>;
  appliedOnUtc?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  or?: InputMaybe<Array<PlantNutrientLogFilterInput>>;
  plant?: InputMaybe<TblMdbatchPlantIdFilterInput>;
  plantId?: InputMaybe<ComparableInt32OperationFilterInput>;
  product?: InputMaybe<TblWhseProductFilterInput>;
  productId?: InputMaybe<ComparableInt32OperationFilterInput>;
  quantity?: InputMaybe<ComparableDecimalOperationFilterInput>;
  totalCost?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  unitCost?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  unitId?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type PlantNutrientLogSortInput = {
  appliedBy?: InputMaybe<SortEnumType>;
  appliedByUser?: InputMaybe<TblAuthUserSortInput>;
  appliedOnUtc?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  plant?: InputMaybe<TblMdbatchPlantIdSortInput>;
  plantId?: InputMaybe<SortEnumType>;
  product?: InputMaybe<TblWhseProductSortInput>;
  productId?: InputMaybe<SortEnumType>;
  quantity?: InputMaybe<SortEnumType>;
  totalCost?: InputMaybe<SortEnumType>;
  unitCost?: InputMaybe<SortEnumType>;
  unitId?: InputMaybe<SortEnumType>;
};

export type PlantPhasesResults = {
  daysInCurrentPhase?: Maybe<Scalars['Decimal']>;
  daysInFlowering?: Maybe<Scalars['Decimal']>;
  daysInVegetation?: Maybe<Scalars['Decimal']>;
  floweringEndedOn?: Maybe<Scalars['DateTime']>;
  floweringStartedOn?: Maybe<Scalars['DateTime']>;
  plantId?: Maybe<Scalars['Int']>;
  vegetationEndedOn?: Maybe<Scalars['DateTime']>;
  vegetationStartedOn?: Maybe<Scalars['DateTime']>;
};

export type PlantRoomHistory = {
  locId?: Maybe<Scalars['Int']>;
  locationName?: Maybe<TblLspLocation>;
  moveDateTime: Scalars['DateTime'];
  plant?: Maybe<TblMdbatchPlantId>;
  plantId: Scalars['Int'];
  plantRoomHistoryId: Scalars['Long'];
  room?: Maybe<TblBatchRoom>;
  roomId: Scalars['Int'];
  table?: Maybe<TblBatchTray>;
  tableId?: Maybe<Scalars['Int']>;
  userId?: Maybe<Scalars['Int']>;
  userName?: Maybe<TblAuthUser>;
};

export type PlantRoomHistoryFilterInput = {
  and?: InputMaybe<Array<PlantRoomHistoryFilterInput>>;
  locId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  locationName?: InputMaybe<TblLspLocationFilterInput>;
  moveDateTime?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  or?: InputMaybe<Array<PlantRoomHistoryFilterInput>>;
  plant?: InputMaybe<TblMdbatchPlantIdFilterInput>;
  plantId?: InputMaybe<ComparableInt32OperationFilterInput>;
  plantRoomHistoryId?: InputMaybe<ComparableInt64OperationFilterInput>;
  room?: InputMaybe<TblBatchRoomFilterInput>;
  roomId?: InputMaybe<ComparableInt32OperationFilterInput>;
  table?: InputMaybe<TblBatchTrayFilterInput>;
  tableId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  userId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  userName?: InputMaybe<TblAuthUserFilterInput>;
};

export type PlantRoomHistorySortInput = {
  locId?: InputMaybe<SortEnumType>;
  locationName?: InputMaybe<TblLspLocationSortInput>;
  moveDateTime?: InputMaybe<SortEnumType>;
  plant?: InputMaybe<TblMdbatchPlantIdSortInput>;
  plantId?: InputMaybe<SortEnumType>;
  plantRoomHistoryId?: InputMaybe<SortEnumType>;
  room?: InputMaybe<TblBatchRoomSortInput>;
  roomId?: InputMaybe<SortEnumType>;
  table?: InputMaybe<TblBatchTraySortInput>;
  tableId?: InputMaybe<SortEnumType>;
  userId?: InputMaybe<SortEnumType>;
  userName?: InputMaybe<TblAuthUserSortInput>;
};

export type PlantStageTransition = {
  fromStage?: Maybe<Scalars['String']>;
  plant?: Maybe<TblMdbatchPlantId>;
  plantId: Scalars['Int'];
  plantStageTransitionId: Scalars['Int'];
  plantTransaction?: Maybe<PlantTransaction>;
  plantTransactionId?: Maybe<Scalars['Int']>;
  toStage: Scalars['String'];
  transitionDateUtc: Scalars['DateTime'];
};

export type PlantStageTransitionFilterInput = {
  and?: InputMaybe<Array<PlantStageTransitionFilterInput>>;
  fromStage?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<PlantStageTransitionFilterInput>>;
  plant?: InputMaybe<TblMdbatchPlantIdFilterInput>;
  plantId?: InputMaybe<ComparableInt32OperationFilterInput>;
  plantStageTransitionId?: InputMaybe<ComparableInt32OperationFilterInput>;
  plantTransaction?: InputMaybe<PlantTransactionFilterInput>;
  plantTransactionId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  toStage?: InputMaybe<StringOperationFilterInput>;
  transitionDateUtc?: InputMaybe<ComparableDateTimeOperationFilterInput>;
};

export type PlantTransaction = {
  locId?: Maybe<Scalars['Int']>;
  lspId?: Maybe<Scalars['Int']>;
  migratedFromTblNotesId?: Maybe<Scalars['Int']>;
  plantId: Scalars['Int'];
  plantSerialNumber?: Maybe<Scalars['String']>;
  plantStageTransitions?: Maybe<Array<Maybe<PlantStageTransition>>>;
  plantTransactionId: Scalars['Int'];
  transactionBy?: Maybe<Scalars['Int']>;
  transactionByNavigation?: Maybe<TblAuthUser>;
  transactionComment?: Maybe<Scalars['String']>;
  transactionDate: Scalars['DateTime'];
  transactionSubject?: Maybe<Scalars['String']>;
  transactionTypeId?: Maybe<Scalars['Int']>;
};

export type PlantTransactionFilterInput = {
  and?: InputMaybe<Array<PlantTransactionFilterInput>>;
  locId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  lspId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  migratedFromTblNotesId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  or?: InputMaybe<Array<PlantTransactionFilterInput>>;
  plantId?: InputMaybe<ComparableInt32OperationFilterInput>;
  plantSerialNumber?: InputMaybe<StringOperationFilterInput>;
  plantStageTransitions?: InputMaybe<ListFilterInputTypeOfPlantStageTransitionFilterInput>;
  plantTransactionId?: InputMaybe<ComparableInt32OperationFilterInput>;
  transactionBy?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  transactionByNavigation?: InputMaybe<TblAuthUserFilterInput>;
  transactionComment?: InputMaybe<StringOperationFilterInput>;
  transactionDate?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  transactionSubject?: InputMaybe<StringOperationFilterInput>;
  transactionTypeId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
};

export type PmpcontrolInfo = {
  deanumber?: Maybe<Scalars['String']>;
  loc?: Maybe<TblLspLocation>;
  locId: Scalars['Int'];
  lsp?: Maybe<TblLsp>;
  lspId: Scalars['Int'];
  npinumber?: Maybe<Scalars['String']>;
  password: Scalars['String'];
  sFtpflag?: Maybe<Scalars['Boolean']>;
  testFlag: Scalars['Boolean'];
  url: Scalars['String'];
  usePackageNdc: Scalars['Boolean'];
  usePrescriptionNumber: Scalars['Boolean'];
  useStateSubdirectories: Scalars['Boolean'];
  username: Scalars['String'];
  versionId?: Maybe<Scalars['Byte']>;
  zeroFileRequired: Scalars['Boolean'];
};

export type PmpcontrolInfoFilterInput = {
  and?: InputMaybe<Array<PmpcontrolInfoFilterInput>>;
  deanumber?: InputMaybe<StringOperationFilterInput>;
  loc?: InputMaybe<TblLspLocationFilterInput>;
  locId?: InputMaybe<ComparableInt32OperationFilterInput>;
  lsp?: InputMaybe<TblLspFilterInput>;
  lspId?: InputMaybe<ComparableInt32OperationFilterInput>;
  npinumber?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<PmpcontrolInfoFilterInput>>;
  password?: InputMaybe<StringOperationFilterInput>;
  sFtpflag?: InputMaybe<BooleanOperationFilterInput>;
  testFlag?: InputMaybe<BooleanOperationFilterInput>;
  url?: InputMaybe<StringOperationFilterInput>;
  usePackageNdc?: InputMaybe<BooleanOperationFilterInput>;
  usePrescriptionNumber?: InputMaybe<BooleanOperationFilterInput>;
  useStateSubdirectories?: InputMaybe<BooleanOperationFilterInput>;
  username?: InputMaybe<StringOperationFilterInput>;
  versionId?: InputMaybe<ComparableNullableOfByteOperationFilterInput>;
  zeroFileRequired?: InputMaybe<BooleanOperationFilterInput>;
};

export type PmpcontrolInfoSortInput = {
  deanumber?: InputMaybe<SortEnumType>;
  loc?: InputMaybe<TblLspLocationSortInput>;
  locId?: InputMaybe<SortEnumType>;
  lsp?: InputMaybe<TblLspSortInput>;
  lspId?: InputMaybe<SortEnumType>;
  npinumber?: InputMaybe<SortEnumType>;
  password?: InputMaybe<SortEnumType>;
  sFtpflag?: InputMaybe<SortEnumType>;
  testFlag?: InputMaybe<SortEnumType>;
  url?: InputMaybe<SortEnumType>;
  usePackageNdc?: InputMaybe<SortEnumType>;
  usePrescriptionNumber?: InputMaybe<SortEnumType>;
  useStateSubdirectories?: InputMaybe<SortEnumType>;
  username?: InputMaybe<SortEnumType>;
  versionId?: InputMaybe<SortEnumType>;
  zeroFileRequired?: InputMaybe<SortEnumType>;
};

export type Posstatus = {
  color?: Maybe<Scalars['String']>;
  locId?: Maybe<Scalars['Int']>;
  lspId?: Maybe<Scalars['Int']>;
  posStatusId: Scalars['Int'];
  posstatus1?: Maybe<Scalars['String']>;
  sortOrder?: Maybe<Scalars['Int']>;
};

export type PosstatusFilterInput = {
  and?: InputMaybe<Array<PosstatusFilterInput>>;
  color?: InputMaybe<StringOperationFilterInput>;
  locId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  lspId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  or?: InputMaybe<Array<PosstatusFilterInput>>;
  posStatusId?: InputMaybe<ComparableInt32OperationFilterInput>;
  posstatus1?: InputMaybe<StringOperationFilterInput>;
  sortOrder?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
};

export type PosstatusSortInput = {
  color?: InputMaybe<SortEnumType>;
  locId?: InputMaybe<SortEnumType>;
  lspId?: InputMaybe<SortEnumType>;
  posStatusId?: InputMaybe<SortEnumType>;
  posstatus1?: InputMaybe<SortEnumType>;
  sortOrder?: InputMaybe<SortEnumType>;
};

export type PricingTierGroup = {
  groupName: Scalars['String'];
  isDeleted: Scalars['Boolean'];
  lsp?: Maybe<TblLsp>;
  lspId: Scalars['Int'];
  mdpricingHdrs?: Maybe<Array<Maybe<MdpricingHdr>>>;
  pricingTierGroupId: Scalars['Int'];
};

export type PricingTierGroupFilterInput = {
  and?: InputMaybe<Array<PricingTierGroupFilterInput>>;
  groupName?: InputMaybe<StringOperationFilterInput>;
  isDeleted?: InputMaybe<BooleanOperationFilterInput>;
  lsp?: InputMaybe<TblLspFilterInput>;
  lspId?: InputMaybe<ComparableInt32OperationFilterInput>;
  mdpricingHdrs?: InputMaybe<ListFilterInputTypeOfMdpricingHdrFilterInput>;
  or?: InputMaybe<Array<PricingTierGroupFilterInput>>;
  pricingTierGroupId?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type PricingTierGroupSortInput = {
  groupName?: InputMaybe<SortEnumType>;
  isDeleted?: InputMaybe<SortEnumType>;
  lsp?: InputMaybe<TblLspSortInput>;
  lspId?: InputMaybe<SortEnumType>;
  pricingTierGroupId?: InputMaybe<SortEnumType>;
};

export type Producer = {
  isDeleted: Scalars['Boolean'];
  lspId: Scalars['Int'];
  packages?: Maybe<Array<Maybe<Package>>>;
  producerId: Scalars['Int'];
  producerName?: Maybe<Scalars['String']>;
  receiveInventoryHistories?: Maybe<Array<Maybe<ReceiveInventoryHistory>>>;
  tblWhseProducts?: Maybe<Array<Maybe<TblWhseProduct>>>;
};

export type ProducerCollectionSegment = {
  items?: Maybe<Array<Maybe<Producer>>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

export type ProducerFilterInput = {
  and?: InputMaybe<Array<ProducerFilterInput>>;
  isDeleted?: InputMaybe<BooleanOperationFilterInput>;
  lspId?: InputMaybe<ComparableInt32OperationFilterInput>;
  or?: InputMaybe<Array<ProducerFilterInput>>;
  packages?: InputMaybe<ListFilterInputTypeOfPackageFilterInput>;
  producerId?: InputMaybe<ComparableInt32OperationFilterInput>;
  producerName?: InputMaybe<StringOperationFilterInput>;
  receiveInventoryHistories?: InputMaybe<ListFilterInputTypeOfReceiveInventoryHistoryFilterInput>;
  tblWhseProducts?: InputMaybe<ListFilterInputTypeOfTblWhseProductFilterInput>;
};

export type ProducerSortInput = {
  isDeleted?: InputMaybe<SortEnumType>;
  lspId?: InputMaybe<SortEnumType>;
  producerId?: InputMaybe<SortEnumType>;
  producerName?: InputMaybe<SortEnumType>;
};

export type ProductDosage = {
  description: Scalars['String'];
  id: Scalars['Int'];
  isDeleted: Scalars['Boolean'];
  locId?: Maybe<Scalars['Int']>;
  lsp: Scalars['Int'];
  lspNavigation?: Maybe<TblLsp>;
  name: Scalars['String'];
  tblWhseProducts?: Maybe<Array<Maybe<TblWhseProduct>>>;
};

export type ProductDosageFilterInput = {
  and?: InputMaybe<Array<ProductDosageFilterInput>>;
  description?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  isDeleted?: InputMaybe<BooleanOperationFilterInput>;
  locId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  lsp?: InputMaybe<ComparableInt32OperationFilterInput>;
  lspNavigation?: InputMaybe<TblLspFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ProductDosageFilterInput>>;
  tblWhseProducts?: InputMaybe<ListFilterInputTypeOfTblWhseProductFilterInput>;
};

export type ProductDosageSortInput = {
  description?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isDeleted?: InputMaybe<SortEnumType>;
  locId?: InputMaybe<SortEnumType>;
  lsp?: InputMaybe<SortEnumType>;
  lspNavigation?: InputMaybe<TblLspSortInput>;
  name?: InputMaybe<SortEnumType>;
};

export type ProductRetiredUpdatesInput = {
  isRetired: Scalars['Boolean'];
  productId: Scalars['Int'];
};

export type ProductSizeListItem = {
  description: Scalars['String'];
  id: Scalars['Int'];
  isDeleted: Scalars['Boolean'];
  location?: Maybe<Scalars['Int']>;
  lsp: Scalars['Int'];
  lspNavigation?: Maybe<TblLsp>;
  name: Scalars['String'];
  tblWhseProducts?: Maybe<Array<Maybe<TblWhseProduct>>>;
};

export type ProductSizeListItemFilterInput = {
  and?: InputMaybe<Array<ProductSizeListItemFilterInput>>;
  description?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  isDeleted?: InputMaybe<BooleanOperationFilterInput>;
  location?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  lsp?: InputMaybe<ComparableInt32OperationFilterInput>;
  lspNavigation?: InputMaybe<TblLspFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ProductSizeListItemFilterInput>>;
  tblWhseProducts?: InputMaybe<ListFilterInputTypeOfTblWhseProductFilterInput>;
};

export type ProductSizeListItemSortInput = {
  description?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isDeleted?: InputMaybe<SortEnumType>;
  location?: InputMaybe<SortEnumType>;
  lsp?: InputMaybe<SortEnumType>;
  lspNavigation?: InputMaybe<TblLspSortInput>;
  name?: InputMaybe<SortEnumType>;
};

export type ProductTaxCategory = {
  lsp?: Maybe<TblLsp>;
  lspId: Scalars['Int'];
  productTaxCategory1: Scalars['String'];
  productTaxCategoryId: Scalars['Int'];
  productTypes?: Maybe<Array<Maybe<TblWhseProductType>>>;
  products?: Maybe<Array<Maybe<TblWhseProduct>>>;
  taxRateToProductTaxCategories?: Maybe<Array<Maybe<TaxRateToProductTaxCategory>>>;
};

export type ProductTaxCategoryFilterInput = {
  and?: InputMaybe<Array<ProductTaxCategoryFilterInput>>;
  lsp?: InputMaybe<TblLspFilterInput>;
  lspId?: InputMaybe<ComparableInt32OperationFilterInput>;
  or?: InputMaybe<Array<ProductTaxCategoryFilterInput>>;
  productTaxCategory1?: InputMaybe<StringOperationFilterInput>;
  productTaxCategoryId?: InputMaybe<ComparableInt32OperationFilterInput>;
  productTypes?: InputMaybe<ListFilterInputTypeOfTblWhseProductTypeFilterInput>;
  products?: InputMaybe<ListFilterInputTypeOfTblWhseProductFilterInput>;
  taxRateToProductTaxCategories?: InputMaybe<ListFilterInputTypeOfTaxRateToProductTaxCategoryFilterInput>;
};

export type ProductToCustomerType = {
  customerType?: Maybe<CustomerType>;
  customerTypeId: Scalars['Int'];
  id: Scalars['Int'];
  lsp?: Maybe<TblLsp>;
  lspId?: Maybe<Scalars['Int']>;
  product?: Maybe<TblWhseProduct>;
  productId: Scalars['Int'];
};

export type ProductToCustomerTypeFilterInput = {
  and?: InputMaybe<Array<ProductToCustomerTypeFilterInput>>;
  customerType?: InputMaybe<CustomerTypeFilterInput>;
  customerTypeId?: InputMaybe<ComparableInt32OperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  lsp?: InputMaybe<TblLspFilterInput>;
  lspId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  or?: InputMaybe<Array<ProductToCustomerTypeFilterInput>>;
  product?: InputMaybe<TblWhseProductFilterInput>;
  productId?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type ProductToTag = {
  id: Scalars['Int'];
  product?: Maybe<TblWhseProduct>;
  productId: Scalars['Int'];
  tag?: Maybe<Tag>;
  tagId: Scalars['Int'];
};

export type ProductToTagFilterInput = {
  and?: InputMaybe<Array<ProductToTagFilterInput>>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  or?: InputMaybe<Array<ProductToTagFilterInput>>;
  product?: InputMaybe<TblWhseProductFilterInput>;
  productId?: InputMaybe<ComparableInt32OperationFilterInput>;
  tag?: InputMaybe<TagFilterInput>;
  tagId?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type ProductTypeToCustomerType = {
  customerType?: Maybe<CustomerType>;
  customerTypeId: Scalars['Int'];
  id: Scalars['Int'];
  lsp?: Maybe<TblLsp>;
  lspId?: Maybe<Scalars['Int']>;
  productType?: Maybe<TblWhseProductType>;
  productTypeId: Scalars['Int'];
};

export type ProductTypeToCustomerTypeFilterInput = {
  and?: InputMaybe<Array<ProductTypeToCustomerTypeFilterInput>>;
  customerType?: InputMaybe<CustomerTypeFilterInput>;
  customerTypeId?: InputMaybe<ComparableInt32OperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  lsp?: InputMaybe<TblLspFilterInput>;
  lspId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  or?: InputMaybe<Array<ProductTypeToCustomerTypeFilterInput>>;
  productType?: InputMaybe<TblWhseProductTypeFilterInput>;
  productTypeId?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type ProductTypeToRevenueAccount = {
  accountId: Scalars['String'];
  locId: Scalars['Int'];
  lspId: Scalars['Int'];
  productTypeId: Scalars['Int'];
  tblWhseProductType?: Maybe<TblWhseProductType>;
};

export type ProductTypeToRevenueAccountFilterInput = {
  accountId?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<ProductTypeToRevenueAccountFilterInput>>;
  locId?: InputMaybe<ComparableInt32OperationFilterInput>;
  lspId?: InputMaybe<ComparableInt32OperationFilterInput>;
  or?: InputMaybe<Array<ProductTypeToRevenueAccountFilterInput>>;
  productTypeId?: InputMaybe<ComparableInt32OperationFilterInput>;
  tblWhseProductType?: InputMaybe<TblWhseProductTypeFilterInput>;
};

export type ProductTypeToRevenueAccountSortInput = {
  accountId?: InputMaybe<SortEnumType>;
  locId?: InputMaybe<SortEnumType>;
  lspId?: InputMaybe<SortEnumType>;
  productTypeId?: InputMaybe<SortEnumType>;
  tblWhseProductType?: InputMaybe<TblWhseProductTypeSortInput>;
};

export type PurchaseLimit = {
  calendarDays?: Maybe<Scalars['Int']>;
  customerTypeId?: Maybe<Scalars['Int']>;
  cycleDays?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  limitType?: Maybe<Scalars['Int']>;
  limitUnit: Scalars['Int'];
  loc?: Maybe<TblLspLocation>;
  locId: Scalars['Int'];
  lsp?: Maybe<TblLsp>;
  lspId: Scalars['Int'];
  purchaseLimit1: Scalars['Decimal'];
  purchaseLimitCategoryId?: Maybe<Scalars['Int']>;
  purchaseLimitToPurchaseLimitCategories?: Maybe<Array<Maybe<PurchaseLimitToPurchaseLimitCategory>>>;
};

export type PurchaseLimitFilterInput = {
  and?: InputMaybe<Array<PurchaseLimitFilterInput>>;
  calendarDays?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  customerTypeId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  cycleDays?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  limitType?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  limitUnit?: InputMaybe<ComparableInt32OperationFilterInput>;
  loc?: InputMaybe<TblLspLocationFilterInput>;
  locId?: InputMaybe<ComparableInt32OperationFilterInput>;
  lsp?: InputMaybe<TblLspFilterInput>;
  lspId?: InputMaybe<ComparableInt32OperationFilterInput>;
  or?: InputMaybe<Array<PurchaseLimitFilterInput>>;
  purchaseLimit1?: InputMaybe<ComparableDecimalOperationFilterInput>;
  purchaseLimitCategoryId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  purchaseLimitToPurchaseLimitCategories?: InputMaybe<ListFilterInputTypeOfPurchaseLimitToPurchaseLimitCategoryFilterInput>;
};

export type PurchaseLimitSortInput = {
  calendarDays?: InputMaybe<SortEnumType>;
  customerTypeId?: InputMaybe<SortEnumType>;
  cycleDays?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  limitType?: InputMaybe<SortEnumType>;
  limitUnit?: InputMaybe<SortEnumType>;
  loc?: InputMaybe<TblLspLocationSortInput>;
  locId?: InputMaybe<SortEnumType>;
  lsp?: InputMaybe<TblLspSortInput>;
  lspId?: InputMaybe<SortEnumType>;
  purchaseLimit1?: InputMaybe<SortEnumType>;
  purchaseLimitCategoryId?: InputMaybe<SortEnumType>;
};

export type PurchaseLimitToPurchaseLimitCategory = {
  purchaseLimit?: Maybe<PurchaseLimit>;
  purchaseLimitCategoryId: Scalars['Int'];
  purchaseLimitId: Scalars['Int'];
};

export type PurchaseLimitToPurchaseLimitCategoryFilterInput = {
  and?: InputMaybe<Array<PurchaseLimitToPurchaseLimitCategoryFilterInput>>;
  or?: InputMaybe<Array<PurchaseLimitToPurchaseLimitCategoryFilterInput>>;
  purchaseLimit?: InputMaybe<PurchaseLimitFilterInput>;
  purchaseLimitCategoryId?: InputMaybe<ComparableInt32OperationFilterInput>;
  purchaseLimitId?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type Query = {
  assemblies?: Maybe<AssemblyCollectionSegment>;
  assembly?: Maybe<Assembly>;
  associatedTagResourceCounts?: Maybe<AssociatedTagResourceCounts>;
  audit?: Maybe<Fgrecon>;
  auditHasNegativePackageUpdates: Scalars['Boolean'];
  /** Get audit packages. If isComplete is true, returns only complete packages. If isComplete is false, returns only incomplete packages. If hasDiscrepancy is true, returns only packages with discrepancies. If both isComplete and hasDiscrepancy are true, returns only complete packages with discrepancies. If both are false or omitted, returns all packages. */
  auditPackages?: Maybe<FgreconDetailCollectionSegment>;
  auditStatuses?: Maybe<InventoryAuditStatusCollectionSegment>;
  audits?: Maybe<FgreconCollectionSegment>;
  batch?: Maybe<TblBatch>;
  batchStrain?: Maybe<TblBatchStrain>;
  batchStrains?: Maybe<TblBatchStrainCollectionSegment>;
  batches?: Maybe<TblBatchCollectionSegment>;
  billOfMaterial?: Maybe<BillOfMaterial>;
  billOfMaterials?: Maybe<BillOfMaterialCollectionSegment>;
  brand?: Maybe<Brand>;
  brands?: Maybe<BrandCollectionSegment>;
  car?: Maybe<TblMdcar>;
  cars?: Maybe<TblMdcarCollectionSegment>;
  consumerStatuses?: Maybe<Array<Maybe<Posstatus>>>;
  consumers?: Maybe<TblAcctCollectionSegment>;
  discountAudits?: Maybe<DiscountAuditCollectionSegment>;
  discountGroups?: Maybe<MddiscountGroupCollectionSegment>;
  discounts?: Maybe<DiscountCollectionSegment>;
  doctors?: Maybe<MdDoctorCollectionSegment>;
  driver?: Maybe<TblMddriver>;
  drivers?: Maybe<TblMddriverCollectionSegment>;
  featureFlags?: Maybe<Array<Maybe<LspFeature>>>;
  features?: Maybe<Array<Maybe<Feature>>>;
  feeDonations?: Maybe<FeeDonationCollectionSegment>;
  harvestBatchLite?: Maybe<TblBatch>;
  harvestBatchesLite?: Maybe<TblBatchCollectionSegment>;
  inventoryStatuses?: Maybe<TblInventoryStatusCollectionSegment>;
  jobStatus?: Maybe<JobStatus>;
  jobStatuses?: Maybe<JobStatusCollectionSegment>;
  labResults?: Maybe<TblBatchThcCollectionSegment>;
  locations?: Maybe<Array<Maybe<TblLspLocation>>>;
  lspFeatureAudits?: Maybe<LspFeaturesAuditCollectionSegment>;
  lsps?: Maybe<Array<Maybe<TblLsp>>>;
  orders?: Maybe<TblMdshipmentCollectionSegment>;
  package?: Maybe<Package>;
  packageAudits?: Maybe<PackageAuditCollectionSegment>;
  packages?: Maybe<PackageCollectionSegment>;
  permissions?: Maybe<Array<Maybe<Permission>>>;
  plant?: Maybe<TblMdbatchPlantId>;
  plants?: Maybe<TblMdbatchPlantIdCollectionSegment>;
  pricingTiers?: Maybe<MdPricingDtlCollectionSegment>;
  producer?: Maybe<Producer>;
  producers?: Maybe<ProducerCollectionSegment>;
  productAudits?: Maybe<TblWhseProductsAuditCollectionSegment>;
  productType?: Maybe<TblWhseProductType>;
  productTypes?: Maybe<TblWhseProductTypeCollectionSegment>;
  products?: Maybe<TblWhseProductCollectionSegment>;
  purchaseLimits?: Maybe<Array<Maybe<PurchaseLimit>>>;
  receiptSettings?: Maybe<Array<Maybe<ReceiptSetting>>>;
  registerLedgers?: Maybe<RegisterLedgerCollectionSegment>;
  registers?: Maybe<Array<Maybe<MdPosTerminal>>>;
  returnReasons?: Maybe<ReturnReasonCollectionSegment>;
  room?: Maybe<TblBatchRoom>;
  rooms?: Maybe<TblBatchRoomCollectionSegment>;
  subroom?: Maybe<TblBatchTray>;
  subrooms?: Maybe<TblBatchTrayCollectionSegment>;
  tag?: Maybe<Tag>;
  tags?: Maybe<TagCollectionSegment>;
  taxRates?: Maybe<Array<Maybe<TaxRate>>>;
  units?: Maybe<UnitsResponse>;
  userAudits?: Maybe<TblAuthUsersAuditCollectionSegment>;
  userGroups?: Maybe<Array<Maybe<UserGroup>>>;
  users?: Maybe<TblAuthUserCollectionSegment>;
  validatedFormFieldOptions?: Maybe<Array<Maybe<ValidatedFormFieldOption>>>;
  vendor?: Maybe<TblVendor>;
  vendors?: Maybe<TblVendorCollectionSegment>;
  voidReasons?: Maybe<VoidReasonCollectionSegment>;
  zone?: Maybe<DeliveryZone>;
  zones?: Maybe<DeliveryZoneCollectionSegment>;
};


export type QueryAssembliesArgs = {
  locId: Scalars['Int'];
  lspId: Scalars['Int'];
  order?: InputMaybe<Array<AssemblySortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AssemblyFilterInput>;
};


export type QueryAssemblyArgs = {
  id: Scalars['Int'];
  locId: Scalars['Int'];
  lspId: Scalars['Int'];
};


export type QueryAssociatedTagResourceCountsArgs = {
  lspId: Scalars['Int'];
  tagId: Scalars['Int'];
};


export type QueryAuditArgs = {
  id: Scalars['Int'];
  lspId: Scalars['Int'];
};


export type QueryAuditHasNegativePackageUpdatesArgs = {
  auditId: Scalars['Int'];
  lspId: Scalars['Int'];
};


export type QueryAuditPackagesArgs = {
  fgreconId: Scalars['Int'];
  hasDiscrepancy?: InputMaybe<Scalars['Boolean']>;
  isComplete?: InputMaybe<Scalars['Boolean']>;
  lspId: Scalars['Int'];
  order?: InputMaybe<Array<FgreconDetailSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FgreconDetailFilterInput>;
};


export type QueryAuditStatusesArgs = {
  order?: InputMaybe<Array<InventoryAuditStatusSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<InventoryAuditStatusFilterInput>;
};


export type QueryAuditsArgs = {
  lspId: Scalars['Int'];
  order?: InputMaybe<Array<FgreconSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FgreconFilterInput>;
};


export type QueryBatchArgs = {
  id: Scalars['Int'];
  locId: Scalars['Int'];
  lspId: Scalars['Int'];
};


export type QueryBatchStrainArgs = {
  id: Scalars['Int'];
  locId: Scalars['Int'];
  lspId: Scalars['Int'];
};


export type QueryBatchStrainsArgs = {
  locId: Scalars['Int'];
  lspId: Scalars['Int'];
  order?: InputMaybe<Array<TblBatchStrainSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TblBatchStrainFilterInput>;
};


export type QueryBatchesArgs = {
  locId: Scalars['Int'];
  lspId: Scalars['Int'];
  order?: InputMaybe<Array<TblBatchSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TblBatchFilterInput>;
};


export type QueryBillOfMaterialArgs = {
  id: Scalars['Int'];
  lspId: Scalars['Int'];
};


export type QueryBillOfMaterialsArgs = {
  lspId: Scalars['Int'];
  order?: InputMaybe<Array<BillOfMaterialSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BillOfMaterialFilterInput>;
};


export type QueryBrandArgs = {
  id: Scalars['Int'];
  lspId: Scalars['Int'];
};


export type QueryBrandsArgs = {
  lspId: Scalars['Int'];
  order?: InputMaybe<Array<BrandSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BrandFilterInput>;
};


export type QueryCarArgs = {
  id: Scalars['Int'];
  locId: Scalars['Int'];
  lspId: Scalars['Int'];
};


export type QueryCarsArgs = {
  locId: Scalars['Int'];
  lspId: Scalars['Int'];
  order?: InputMaybe<Array<TblMdcarSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TblMdcarFilterInput>;
};


export type QueryConsumerStatusesArgs = {
  locId: Scalars['Int'];
  lspId: Scalars['Int'];
  order?: InputMaybe<Array<PosstatusSortInput>>;
  where?: InputMaybe<PosstatusFilterInput>;
};


export type QueryConsumersArgs = {
  lspId: Scalars['Int'];
  order?: InputMaybe<Array<TblAcctSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TblAcctFilterInput>;
};


export type QueryDiscountAuditsArgs = {
  locId: Scalars['Int'];
  lspId: Scalars['Int'];
  order?: InputMaybe<Array<DiscountAuditSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  userId: Scalars['Int'];
  where?: InputMaybe<DiscountAuditFilterInput>;
};


export type QueryDiscountGroupsArgs = {
  locId: Scalars['Int'];
  lspId: Scalars['Int'];
  order?: InputMaybe<Array<MddiscountGroupSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<MddiscountGroupFilterInput>;
};


export type QueryDiscountsArgs = {
  lspId: Scalars['Int'];
  order?: InputMaybe<Array<DiscountSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<DiscountFilterInput>;
};


export type QueryDoctorsArgs = {
  locId: Scalars['Int'];
  lspId: Scalars['Int'];
  order?: InputMaybe<Array<MdDoctorSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<MdDoctorFilterInput>;
};


export type QueryDriverArgs = {
  id: Scalars['Int'];
  locId: Scalars['Int'];
  lspId: Scalars['Int'];
};


export type QueryDriversArgs = {
  locId: Scalars['Int'];
  lspId: Scalars['Int'];
  order?: InputMaybe<Array<TblMddriverSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TblMddriverFilterInput>;
};


export type QueryFeatureFlagsArgs = {
  locId: Scalars['Int'];
  lspId: Scalars['Int'];
  order?: InputMaybe<Array<LspFeatureSortInput>>;
  where?: InputMaybe<LspFeatureFilterInput>;
};


export type QueryFeaturesArgs = {
  order?: InputMaybe<Array<FeatureSortInput>>;
  where?: InputMaybe<FeatureFilterInput>;
};


export type QueryFeeDonationsArgs = {
  locId: Scalars['Int'];
  lspId: Scalars['Int'];
  order?: InputMaybe<Array<FeeDonationSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FeeDonationFilterInput>;
};


export type QueryHarvestBatchLiteArgs = {
  id: Scalars['Int'];
  locId: Scalars['Int'];
  lspId: Scalars['Int'];
};


export type QueryHarvestBatchesLiteArgs = {
  locId: Scalars['Int'];
  lspId: Scalars['Int'];
  order?: InputMaybe<Array<TblBatchSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TblBatchFilterInput>;
};


export type QueryInventoryStatusesArgs = {
  locId: Scalars['Int'];
  lspId: Scalars['Int'];
  order?: InputMaybe<Array<TblInventoryStatusSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TblInventoryStatusFilterInput>;
};


export type QueryJobStatusArgs = {
  id: Scalars['Int'];
  locId: Scalars['Int'];
  lspId: Scalars['Int'];
};


export type QueryJobStatusesArgs = {
  locId: Scalars['Int'];
  lspId: Scalars['Int'];
  order?: InputMaybe<Array<JobStatusSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<JobStatusFilterInput>;
};


export type QueryLabResultsArgs = {
  lspId: Scalars['Int'];
  order?: InputMaybe<Array<TblBatchThcSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TblBatchThcFilterInput>;
};


export type QueryLocationsArgs = {
  locId: Scalars['Int'];
  lspId: Scalars['Int'];
  order?: InputMaybe<Array<TblLspLocationSortInput>>;
  where?: InputMaybe<TblLspLocationFilterInput>;
};


export type QueryLspFeatureAuditsArgs = {
  locId: Scalars['Int'];
  lspId: Scalars['Int'];
  order?: InputMaybe<Array<LspFeaturesAuditSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  userId: Scalars['Int'];
  where?: InputMaybe<LspFeaturesAuditFilterInput>;
};


export type QueryLspsArgs = {
  locId: Scalars['Int'];
  lspId: Scalars['Int'];
  order?: InputMaybe<Array<TblLspSortInput>>;
  where?: InputMaybe<TblLspFilterInput>;
};


export type QueryOrdersArgs = {
  locId: Scalars['Int'];
  lspId: Scalars['Int'];
  openOrders: Scalars['Boolean'];
  order?: InputMaybe<Array<TblMdshipmentSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TblMdshipmentFilterInput>;
};


export type QueryPackageArgs = {
  id: Scalars['Int'];
  locId: Scalars['Int'];
  lspId: Scalars['Int'];
};


export type QueryPackageAuditsArgs = {
  locId: Scalars['Int'];
  lspId: Scalars['Int'];
  order?: InputMaybe<Array<PackageAuditSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  userId: Scalars['Int'];
  where?: InputMaybe<PackageAuditFilterInput>;
};


export type QueryPackagesArgs = {
  locId: Scalars['Int'];
  lspId: Scalars['Int'];
  order?: InputMaybe<Array<PackageSortInput>>;
  showLowInventory?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  userId: Scalars['Int'];
  where?: InputMaybe<PackageFilterInput>;
};


export type QueryPermissionsArgs = {
  order?: InputMaybe<Array<PermissionSortInput>>;
  where?: InputMaybe<PermissionFilterInput>;
};


export type QueryPlantArgs = {
  id: Scalars['Int'];
  locId: Scalars['Int'];
  lspId: Scalars['Int'];
};


export type QueryPlantsArgs = {
  locId: Scalars['Int'];
  lspId: Scalars['Int'];
  order?: InputMaybe<Array<TblMdbatchPlantIdSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TblMdbatchPlantIdFilterInput>;
};


export type QueryPricingTiersArgs = {
  lspId: Scalars['Int'];
  order?: InputMaybe<Array<MdPricingDtlSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<MdPricingDtlFilterInput>;
};


export type QueryProducerArgs = {
  id: Scalars['Int'];
  locId: Scalars['Int'];
  lspId: Scalars['Int'];
  userId: Scalars['Int'];
};


export type QueryProducersArgs = {
  locId: Scalars['Int'];
  lspId: Scalars['Int'];
  order?: InputMaybe<Array<ProducerSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  userId: Scalars['Int'];
  where?: InputMaybe<ProducerFilterInput>;
};


export type QueryProductAuditsArgs = {
  locId: Scalars['Int'];
  lspId: Scalars['Int'];
  order?: InputMaybe<Array<TblWhseProductsAuditSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  userId: Scalars['Int'];
  where?: InputMaybe<TblWhseProductsAuditFilterInput>;
};


export type QueryProductTypeArgs = {
  id: Scalars['Int'];
  lspId: Scalars['Int'];
};


export type QueryProductTypesArgs = {
  lspId: Scalars['Int'];
  order?: InputMaybe<Array<TblWhseProductTypeSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TblWhseProductTypeFilterInput>;
};


export type QueryProductsArgs = {
  lspId: Scalars['Int'];
  order?: InputMaybe<Array<TblWhseProductSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  userId: Scalars['Int'];
  where?: InputMaybe<TblWhseProductFilterInput>;
};


export type QueryPurchaseLimitsArgs = {
  locId: Scalars['Int'];
  lspId: Scalars['Int'];
  order?: InputMaybe<Array<PurchaseLimitSortInput>>;
  where?: InputMaybe<PurchaseLimitFilterInput>;
};


export type QueryReceiptSettingsArgs = {
  locId: Scalars['Int'];
  lspId: Scalars['Int'];
  order?: InputMaybe<Array<ReceiptSettingSortInput>>;
  where?: InputMaybe<ReceiptSettingFilterInput>;
};


export type QueryRegisterLedgersArgs = {
  locId: Scalars['Int'];
  lspId: Scalars['Int'];
  order?: InputMaybe<Array<RegisterLedgerSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<RegisterLedgerFilterInput>;
};


export type QueryRegistersArgs = {
  locId: Scalars['Int'];
  lspId: Scalars['Int'];
  order?: InputMaybe<Array<MdPosTerminalSortInput>>;
  where?: InputMaybe<MdPosTerminalFilterInput>;
};


export type QueryReturnReasonsArgs = {
  lspId: Scalars['Int'];
  order?: InputMaybe<Array<ReturnReasonSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ReturnReasonFilterInput>;
};


export type QueryRoomArgs = {
  id: Scalars['Int'];
  locId: Scalars['Int'];
  lspId: Scalars['Int'];
};


export type QueryRoomsArgs = {
  hideEmpty?: Scalars['Boolean'];
  locId: Scalars['Int'];
  lspId: Scalars['Int'];
  order?: InputMaybe<Array<TblBatchRoomSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TblBatchRoomFilterInput>;
};


export type QuerySubroomArgs = {
  id: Scalars['Int'];
  locId: Scalars['Int'];
  lspId: Scalars['Int'];
};


export type QuerySubroomsArgs = {
  locId: Scalars['Int'];
  lspId: Scalars['Int'];
  order?: InputMaybe<Array<TblBatchTraySortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TblBatchTrayFilterInput>;
};


export type QueryTagArgs = {
  id: Scalars['Int'];
  lspId: Scalars['Int'];
};


export type QueryTagsArgs = {
  lspId: Scalars['Int'];
  order?: InputMaybe<Array<TagSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TagFilterInput>;
};


export type QueryTaxRatesArgs = {
  locId: Scalars['Int'];
  lspId: Scalars['Int'];
  order?: InputMaybe<Array<TaxRateSortInput>>;
  where?: InputMaybe<TaxRateFilterInput>;
};


export type QueryUserAuditsArgs = {
  locId: Scalars['Int'];
  lspId: Scalars['Int'];
  order?: InputMaybe<Array<TblAuthUsersAuditSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  userId: Scalars['Int'];
  where?: InputMaybe<TblAuthUsersAuditFilterInput>;
};


export type QueryUserGroupsArgs = {
  locId: Scalars['Int'];
  lspId: Scalars['Int'];
  order?: InputMaybe<Array<UserGroupSortInput>>;
  where?: InputMaybe<UserGroupFilterInput>;
};


export type QueryUsersArgs = {
  lspId: Scalars['Int'];
  order?: InputMaybe<Array<TblAuthUserSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TblAuthUserFilterInput>;
};


export type QueryValidatedFormFieldOptionsArgs = {
  locId: Scalars['Int'];
  lspId: Scalars['Int'];
  order?: InputMaybe<Array<ValidatedFormFieldOptionSortInput>>;
  where?: InputMaybe<ValidatedFormFieldOptionFilterInput>;
};


export type QueryVendorArgs = {
  id: Scalars['Int'];
  lspId: Scalars['Int'];
};


export type QueryVendorsArgs = {
  lspId: Scalars['Int'];
  order?: InputMaybe<Array<TblVendorSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TblVendorFilterInput>;
};


export type QueryVoidReasonsArgs = {
  lspId: Scalars['Int'];
  order?: InputMaybe<Array<VoidReasonSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<VoidReasonFilterInput>;
};


export type QueryZoneArgs = {
  id: Scalars['Int'];
  locId: Scalars['Int'];
  lspId: Scalars['Int'];
};


export type QueryZonesArgs = {
  locId: Scalars['Int'];
  lspId: Scalars['Int'];
  order?: InputMaybe<Array<DeliveryZoneSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<DeliveryZoneFilterInput>;
};

export type ReceiptSetting = {
  aggregateDuplicates: Scalars['Boolean'];
  cashierTitle: Scalars['String'];
  customerTitle: Scalars['String'];
  emailFrom: Scalars['String'];
  footerText?: Maybe<Scalars['String']>;
  itemizeDiscounts: Scalars['Boolean'];
  loc?: Maybe<TblLspLocation>;
  locId: Scalars['Int'];
  lsp?: Maybe<TblLsp>;
  lspId: Scalars['Int'];
  printTwoReceipts: Scalars['Boolean'];
  receiptSettingsId: Scalars['Int'];
  showAllotmentData: Scalars['Boolean'];
  showBatchIngredients: Scalars['Boolean'];
  showBatchNames: Scalars['Boolean'];
  showCaregiverAddress: Scalars['Boolean'];
  showCaregiverName: Scalars['Boolean'];
  showCashierId: Scalars['Boolean'];
  showCashierName: Scalars['Boolean'];
  showCustomerAddress?: Maybe<Scalars['Boolean']>;
  showCustomerDateOfBirth?: Maybe<Scalars['Boolean']>;
  showCustomerId: Scalars['Boolean'];
  showCustomerName: Scalars['Boolean'];
  showDaysSupply: Scalars['Boolean'];
  showDeliveryInformation: Scalars['Boolean'];
  showExternalCategory: Scalars['Boolean'];
  showExternalPackageId: Scalars['Boolean'];
  showFlowerEquivalents: Scalars['Boolean'];
  showLoyaltyPoints: Scalars['Boolean'];
  showProductCategory: Scalars['Boolean'];
  showProductName: Scalars['Boolean'];
  showProductSku: Scalars['Boolean'];
  showRegisterId?: Maybe<Scalars['Boolean']>;
  showRounding: Scalars['Boolean'];
  showSignatureLine: Scalars['Boolean'];
  showTotalGramsPurchased: Scalars['Boolean'];
  showTransactionBarcode: Scalars['Boolean'];
};

export type ReceiptSettingFilterInput = {
  aggregateDuplicates?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<ReceiptSettingFilterInput>>;
  cashierTitle?: InputMaybe<StringOperationFilterInput>;
  customerTitle?: InputMaybe<StringOperationFilterInput>;
  emailFrom?: InputMaybe<StringOperationFilterInput>;
  footerText?: InputMaybe<StringOperationFilterInput>;
  itemizeDiscounts?: InputMaybe<BooleanOperationFilterInput>;
  loc?: InputMaybe<TblLspLocationFilterInput>;
  locId?: InputMaybe<ComparableInt32OperationFilterInput>;
  lsp?: InputMaybe<TblLspFilterInput>;
  lspId?: InputMaybe<ComparableInt32OperationFilterInput>;
  or?: InputMaybe<Array<ReceiptSettingFilterInput>>;
  printTwoReceipts?: InputMaybe<BooleanOperationFilterInput>;
  receiptSettingsId?: InputMaybe<ComparableInt32OperationFilterInput>;
  showAllotmentData?: InputMaybe<BooleanOperationFilterInput>;
  showBatchIngredients?: InputMaybe<BooleanOperationFilterInput>;
  showBatchNames?: InputMaybe<BooleanOperationFilterInput>;
  showCaregiverAddress?: InputMaybe<BooleanOperationFilterInput>;
  showCaregiverName?: InputMaybe<BooleanOperationFilterInput>;
  showCashierId?: InputMaybe<BooleanOperationFilterInput>;
  showCashierName?: InputMaybe<BooleanOperationFilterInput>;
  showCustomerAddress?: InputMaybe<BooleanOperationFilterInput>;
  showCustomerDateOfBirth?: InputMaybe<BooleanOperationFilterInput>;
  showCustomerId?: InputMaybe<BooleanOperationFilterInput>;
  showCustomerName?: InputMaybe<BooleanOperationFilterInput>;
  showDaysSupply?: InputMaybe<BooleanOperationFilterInput>;
  showDeliveryInformation?: InputMaybe<BooleanOperationFilterInput>;
  showExternalCategory?: InputMaybe<BooleanOperationFilterInput>;
  showExternalPackageId?: InputMaybe<BooleanOperationFilterInput>;
  showFlowerEquivalents?: InputMaybe<BooleanOperationFilterInput>;
  showLoyaltyPoints?: InputMaybe<BooleanOperationFilterInput>;
  showProductCategory?: InputMaybe<BooleanOperationFilterInput>;
  showProductName?: InputMaybe<BooleanOperationFilterInput>;
  showProductSku?: InputMaybe<BooleanOperationFilterInput>;
  showRegisterId?: InputMaybe<BooleanOperationFilterInput>;
  showRounding?: InputMaybe<BooleanOperationFilterInput>;
  showSignatureLine?: InputMaybe<BooleanOperationFilterInput>;
  showTotalGramsPurchased?: InputMaybe<BooleanOperationFilterInput>;
  showTransactionBarcode?: InputMaybe<BooleanOperationFilterInput>;
};

export type ReceiptSettingSortInput = {
  aggregateDuplicates?: InputMaybe<SortEnumType>;
  cashierTitle?: InputMaybe<SortEnumType>;
  customerTitle?: InputMaybe<SortEnumType>;
  emailFrom?: InputMaybe<SortEnumType>;
  footerText?: InputMaybe<SortEnumType>;
  itemizeDiscounts?: InputMaybe<SortEnumType>;
  loc?: InputMaybe<TblLspLocationSortInput>;
  locId?: InputMaybe<SortEnumType>;
  lsp?: InputMaybe<TblLspSortInput>;
  lspId?: InputMaybe<SortEnumType>;
  printTwoReceipts?: InputMaybe<SortEnumType>;
  receiptSettingsId?: InputMaybe<SortEnumType>;
  showAllotmentData?: InputMaybe<SortEnumType>;
  showBatchIngredients?: InputMaybe<SortEnumType>;
  showBatchNames?: InputMaybe<SortEnumType>;
  showCaregiverAddress?: InputMaybe<SortEnumType>;
  showCaregiverName?: InputMaybe<SortEnumType>;
  showCashierId?: InputMaybe<SortEnumType>;
  showCashierName?: InputMaybe<SortEnumType>;
  showCustomerAddress?: InputMaybe<SortEnumType>;
  showCustomerDateOfBirth?: InputMaybe<SortEnumType>;
  showCustomerId?: InputMaybe<SortEnumType>;
  showCustomerName?: InputMaybe<SortEnumType>;
  showDaysSupply?: InputMaybe<SortEnumType>;
  showDeliveryInformation?: InputMaybe<SortEnumType>;
  showExternalCategory?: InputMaybe<SortEnumType>;
  showExternalPackageId?: InputMaybe<SortEnumType>;
  showFlowerEquivalents?: InputMaybe<SortEnumType>;
  showLoyaltyPoints?: InputMaybe<SortEnumType>;
  showProductCategory?: InputMaybe<SortEnumType>;
  showProductName?: InputMaybe<SortEnumType>;
  showProductSku?: InputMaybe<SortEnumType>;
  showRegisterId?: InputMaybe<SortEnumType>;
  showRounding?: InputMaybe<SortEnumType>;
  showSignatureLine?: InputMaybe<SortEnumType>;
  showTotalGramsPurchased?: InputMaybe<SortEnumType>;
  showTransactionBarcode?: InputMaybe<SortEnumType>;
};

export type ReceiveInventoryHistory = {
  adilasInvoiceId?: Maybe<Scalars['Int']>;
  costOption?: Maybe<Scalars['Int']>;
  deliveredBy?: Maybe<Scalars['String']>;
  deliveredOn?: Maybe<Scalars['DateTime']>;
  externalId?: Maybe<Scalars['String']>;
  inventoryTransactions?: Maybe<Array<Maybe<InventoryTransaction>>>;
  loc?: Maybe<TblLspLocation>;
  locId: Scalars['Int'];
  lsp?: Maybe<TblLsp>;
  lspId: Scalars['Int'];
  note?: Maybe<Scalars['String']>;
  orderTitle?: Maybe<Scalars['String']>;
  packages?: Maybe<Array<Maybe<Package>>>;
  paid: Scalars['Boolean'];
  producer?: Maybe<Producer>;
  producerId?: Maybe<Scalars['Int']>;
  purchaseOrderId?: Maybe<Scalars['Int']>;
  receiveInventoryHistoryId: Scalars['Int'];
  receivedByUserId?: Maybe<Scalars['Int']>;
  resultMessage?: Maybe<Scalars['String']>;
  shipment?: Maybe<TblMdshipment>;
  shipmentId?: Maybe<Scalars['Int']>;
  shippingCharge?: Maybe<Scalars['Decimal']>;
  status: Scalars['String'];
  totalCredit?: Maybe<Scalars['Decimal']>;
  transactionId?: Maybe<Scalars['String']>;
  updatedBy?: Maybe<Scalars['Int']>;
  updatedDate?: Maybe<Scalars['DateTime']>;
  uploaded?: Maybe<Scalars['Boolean']>;
  vendor?: Maybe<TblVendor>;
  vendorId?: Maybe<Scalars['Int']>;
  vendorLicense?: Maybe<Scalars['String']>;
};

export type ReceiveInventoryHistoryFilterInput = {
  adilasInvoiceId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  and?: InputMaybe<Array<ReceiveInventoryHistoryFilterInput>>;
  costOption?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  deliveredBy?: InputMaybe<StringOperationFilterInput>;
  deliveredOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  externalId?: InputMaybe<StringOperationFilterInput>;
  inventoryTransactions?: InputMaybe<ListFilterInputTypeOfInventoryTransactionFilterInput>;
  loc?: InputMaybe<TblLspLocationFilterInput>;
  locId?: InputMaybe<ComparableInt32OperationFilterInput>;
  lsp?: InputMaybe<TblLspFilterInput>;
  lspId?: InputMaybe<ComparableInt32OperationFilterInput>;
  note?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ReceiveInventoryHistoryFilterInput>>;
  orderTitle?: InputMaybe<StringOperationFilterInput>;
  packages?: InputMaybe<ListFilterInputTypeOfPackageFilterInput>;
  paid?: InputMaybe<BooleanOperationFilterInput>;
  producer?: InputMaybe<ProducerFilterInput>;
  producerId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  purchaseOrderId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  receiveInventoryHistoryId?: InputMaybe<ComparableInt32OperationFilterInput>;
  receivedByUserId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  resultMessage?: InputMaybe<StringOperationFilterInput>;
  shipment?: InputMaybe<TblMdshipmentFilterInput>;
  shipmentId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  shippingCharge?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  status?: InputMaybe<StringOperationFilterInput>;
  totalCredit?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  transactionId?: InputMaybe<StringOperationFilterInput>;
  updatedBy?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  updatedDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  uploaded?: InputMaybe<BooleanOperationFilterInput>;
  vendor?: InputMaybe<TblVendorFilterInput>;
  vendorId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  vendorLicense?: InputMaybe<StringOperationFilterInput>;
};

export type ReceiveInventoryHistorySortInput = {
  adilasInvoiceId?: InputMaybe<SortEnumType>;
  costOption?: InputMaybe<SortEnumType>;
  deliveredBy?: InputMaybe<SortEnumType>;
  deliveredOn?: InputMaybe<SortEnumType>;
  externalId?: InputMaybe<SortEnumType>;
  loc?: InputMaybe<TblLspLocationSortInput>;
  locId?: InputMaybe<SortEnumType>;
  lsp?: InputMaybe<TblLspSortInput>;
  lspId?: InputMaybe<SortEnumType>;
  note?: InputMaybe<SortEnumType>;
  orderTitle?: InputMaybe<SortEnumType>;
  paid?: InputMaybe<SortEnumType>;
  producer?: InputMaybe<ProducerSortInput>;
  producerId?: InputMaybe<SortEnumType>;
  purchaseOrderId?: InputMaybe<SortEnumType>;
  receiveInventoryHistoryId?: InputMaybe<SortEnumType>;
  receivedByUserId?: InputMaybe<SortEnumType>;
  resultMessage?: InputMaybe<SortEnumType>;
  shipment?: InputMaybe<TblMdshipmentSortInput>;
  shipmentId?: InputMaybe<SortEnumType>;
  shippingCharge?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  totalCredit?: InputMaybe<SortEnumType>;
  transactionId?: InputMaybe<SortEnumType>;
  updatedBy?: InputMaybe<SortEnumType>;
  updatedDate?: InputMaybe<SortEnumType>;
  uploaded?: InputMaybe<SortEnumType>;
  vendor?: InputMaybe<TblVendorSortInput>;
  vendorId?: InputMaybe<SortEnumType>;
  vendorLicense?: InputMaybe<SortEnumType>;
};

export type RegisterLedger = {
  closeOutId?: Maybe<Scalars['Int']>;
  comment?: Maybe<Scalars['String']>;
  entryAmount: Scalars['Decimal'];
  entryDateUtc: Scalars['DateTime'];
  entryTypeId: Scalars['Byte'];
  loc?: Maybe<TblLspLocation>;
  locId: Scalars['Int'];
  lsp?: Maybe<TblLsp>;
  lspId: Scalars['Int'];
  registerLedgerId: Scalars['Int'];
  shipment?: Maybe<TblMdshipment>;
  shipmentId?: Maybe<Scalars['Int']>;
  terminal?: Maybe<MdPosTerminal>;
  terminalId: Scalars['Int'];
  transactionAdjustmentReasonId?: Maybe<Scalars['Int']>;
  user?: Maybe<TblAuthUser>;
  userId: Scalars['Int'];
};

export type RegisterLedgerCollectionSegment = {
  items?: Maybe<Array<Maybe<RegisterLedger>>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

export type RegisterLedgerFilterInput = {
  and?: InputMaybe<Array<RegisterLedgerFilterInput>>;
  closeOutId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  comment?: InputMaybe<StringOperationFilterInput>;
  entryAmount?: InputMaybe<ComparableDecimalOperationFilterInput>;
  entryDateUtc?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  entryTypeId?: InputMaybe<ComparableByteOperationFilterInput>;
  loc?: InputMaybe<TblLspLocationFilterInput>;
  locId?: InputMaybe<ComparableInt32OperationFilterInput>;
  lsp?: InputMaybe<TblLspFilterInput>;
  lspId?: InputMaybe<ComparableInt32OperationFilterInput>;
  or?: InputMaybe<Array<RegisterLedgerFilterInput>>;
  registerLedgerId?: InputMaybe<ComparableInt32OperationFilterInput>;
  shipment?: InputMaybe<TblMdshipmentFilterInput>;
  shipmentId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  terminal?: InputMaybe<MdPosTerminalFilterInput>;
  terminalId?: InputMaybe<ComparableInt32OperationFilterInput>;
  transactionAdjustmentReasonId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  user?: InputMaybe<TblAuthUserFilterInput>;
  userId?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type RegisterLedgerSortInput = {
  closeOutId?: InputMaybe<SortEnumType>;
  comment?: InputMaybe<SortEnumType>;
  entryAmount?: InputMaybe<SortEnumType>;
  entryDateUtc?: InputMaybe<SortEnumType>;
  entryTypeId?: InputMaybe<SortEnumType>;
  loc?: InputMaybe<TblLspLocationSortInput>;
  locId?: InputMaybe<SortEnumType>;
  lsp?: InputMaybe<TblLspSortInput>;
  lspId?: InputMaybe<SortEnumType>;
  registerLedgerId?: InputMaybe<SortEnumType>;
  shipment?: InputMaybe<TblMdshipmentSortInput>;
  shipmentId?: InputMaybe<SortEnumType>;
  terminal?: InputMaybe<MdPosTerminalSortInput>;
  terminalId?: InputMaybe<SortEnumType>;
  transactionAdjustmentReasonId?: InputMaybe<SortEnumType>;
  user?: InputMaybe<TblAuthUserSortInput>;
  userId?: InputMaybe<SortEnumType>;
};

export type RegulatoryCategory = {
  regulatoryCategory1?: Maybe<Scalars['String']>;
  regulatoryCategoryId: Scalars['Short'];
  state?: Maybe<Scalars['String']>;
  tblWhseProductTypes?: Maybe<Array<Maybe<TblWhseProductType>>>;
  tblWhseProducts?: Maybe<Array<Maybe<TblWhseProduct>>>;
};

export type RegulatoryCategoryFilterInput = {
  and?: InputMaybe<Array<RegulatoryCategoryFilterInput>>;
  or?: InputMaybe<Array<RegulatoryCategoryFilterInput>>;
  regulatoryCategory1?: InputMaybe<StringOperationFilterInput>;
  regulatoryCategoryId?: InputMaybe<ComparableInt16OperationFilterInput>;
  state?: InputMaybe<StringOperationFilterInput>;
  tblWhseProductTypes?: InputMaybe<ListFilterInputTypeOfTblWhseProductTypeFilterInput>;
  tblWhseProducts?: InputMaybe<ListFilterInputTypeOfTblWhseProductFilterInput>;
};

export type RegulatoryCategorySortInput = {
  regulatoryCategory1?: InputMaybe<SortEnumType>;
  regulatoryCategoryId?: InputMaybe<SortEnumType>;
  state?: InputMaybe<SortEnumType>;
};

export type RemovePackageFromAuditInput = {
  auditDetailId: Scalars['Int'];
  auditId: Scalars['Int'];
  locId: Scalars['Int'];
  lspId: Scalars['Int'];
  sessionId?: InputMaybe<Scalars['String']>;
  userId: Scalars['Int'];
};

export type RemovePackageFromAuditResponse = {
  auditDetailId: Scalars['Int'];
};

export type RemovedInventory = {
  package?: Maybe<Package>;
  packageId: Scalars['Int'];
  productWeight?: Maybe<Scalars['Decimal']>;
  quantity?: Maybe<Scalars['Decimal']>;
  removedDate?: Maybe<Scalars['DateTime']>;
  removedInventoryId: Scalars['Int'];
  removedReason?: Maybe<Scalars['String']>;
  transferredToBatchId?: Maybe<Scalars['Int']>;
  unit?: Maybe<Unit>;
  unitId?: Maybe<Scalars['Int']>;
};

export type RemovedInventoryFilterInput = {
  and?: InputMaybe<Array<RemovedInventoryFilterInput>>;
  or?: InputMaybe<Array<RemovedInventoryFilterInput>>;
  package?: InputMaybe<PackageFilterInput>;
  packageId?: InputMaybe<ComparableInt32OperationFilterInput>;
  productWeight?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  quantity?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  removedDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  removedInventoryId?: InputMaybe<ComparableInt32OperationFilterInput>;
  removedReason?: InputMaybe<StringOperationFilterInput>;
  transferredToBatchId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  unit?: InputMaybe<UnitFilterInput>;
  unitId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
};

export type ReportedPlantWeight = {
  metrcReportedWeight?: Maybe<Scalars['Decimal']>;
  metrcReportedWeightDate?: Maybe<Scalars['DateTime']>;
  metrcReportedWeightStatus?: Maybe<Scalars['Int']>;
  plant?: Maybe<TblMdbatchPlantId>;
  plantId: Scalars['Int'];
};

export type ReportedPlantWeightFilterInput = {
  and?: InputMaybe<Array<ReportedPlantWeightFilterInput>>;
  metrcReportedWeight?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  metrcReportedWeightDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  metrcReportedWeightStatus?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  or?: InputMaybe<Array<ReportedPlantWeightFilterInput>>;
  plant?: InputMaybe<TblMdbatchPlantIdFilterInput>;
  plantId?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type ReportedPlantWeightSortInput = {
  metrcReportedWeight?: InputMaybe<SortEnumType>;
  metrcReportedWeightDate?: InputMaybe<SortEnumType>;
  metrcReportedWeightStatus?: InputMaybe<SortEnumType>;
  plant?: InputMaybe<TblMdbatchPlantIdSortInput>;
  plantId?: InputMaybe<SortEnumType>;
};

export type ReturnReason = {
  lsp?: Maybe<TblLsp>;
  lspId?: Maybe<Scalars['Int']>;
  reason?: Maybe<Scalars['String']>;
  returnReasonId: Scalars['Int'];
};

export type ReturnReasonCollectionSegment = {
  items?: Maybe<Array<Maybe<ReturnReason>>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

export type ReturnReasonFilterInput = {
  and?: InputMaybe<Array<ReturnReasonFilterInput>>;
  lsp?: InputMaybe<TblLspFilterInput>;
  lspId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  or?: InputMaybe<Array<ReturnReasonFilterInput>>;
  reason?: InputMaybe<StringOperationFilterInput>;
  returnReasonId?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type ReturnReasonSortInput = {
  lsp?: InputMaybe<TblLspSortInput>;
  lspId?: InputMaybe<SortEnumType>;
  reason?: InputMaybe<SortEnumType>;
  returnReasonId?: InputMaybe<SortEnumType>;
};

export type RoomTerminal = {
  id: Scalars['Int'];
  loc?: Maybe<TblLspLocation>;
  locId?: Maybe<Scalars['Int']>;
  lsp?: Maybe<TblLsp>;
  lspId?: Maybe<Scalars['Int']>;
  room?: Maybe<TblBatchRoom>;
  roomId?: Maybe<Scalars['Int']>;
  terminal?: Maybe<MdPosTerminal>;
  terminalId?: Maybe<Scalars['Int']>;
};

export type RoomTerminalFilterInput = {
  and?: InputMaybe<Array<RoomTerminalFilterInput>>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  loc?: InputMaybe<TblLspLocationFilterInput>;
  locId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  lsp?: InputMaybe<TblLspFilterInput>;
  lspId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  or?: InputMaybe<Array<RoomTerminalFilterInput>>;
  room?: InputMaybe<TblBatchRoomFilterInput>;
  roomId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  terminal?: InputMaybe<MdPosTerminalFilterInput>;
  terminalId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
};

export type RoomToMenu = {
  loc?: Maybe<TblLspLocation>;
  locId: Scalars['Int'];
  lsp?: Maybe<TblLsp>;
  lspId: Scalars['Int'];
  menuName?: Maybe<Scalars['String']>;
  room?: Maybe<TblBatchRoom>;
  roomId: Scalars['Int'];
};

export type RoomToMenuFilterInput = {
  and?: InputMaybe<Array<RoomToMenuFilterInput>>;
  loc?: InputMaybe<TblLspLocationFilterInput>;
  locId?: InputMaybe<ComparableInt32OperationFilterInput>;
  lsp?: InputMaybe<TblLspFilterInput>;
  lspId?: InputMaybe<ComparableInt32OperationFilterInput>;
  menuName?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<RoomToMenuFilterInput>>;
  room?: InputMaybe<TblBatchRoomFilterInput>;
  roomId?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type SetJobStatusToCancelledInput = {
  jobStatusId: Scalars['Int'];
  jobStatusUserId: Scalars['Int'];
  locId: Scalars['Int'];
  lspId: Scalars['Int'];
  sessionId?: InputMaybe<Scalars['String']>;
  userId: Scalars['Int'];
};

export type SetJobStatusToCancelledResponse = {
  cancelled: Scalars['Boolean'];
  jobStatusId: Scalars['Int'];
  message?: Maybe<Scalars['String']>;
};

export type SmartTag = {
  combinator?: Maybe<Scalars['String']>;
  createdBy: Scalars['Int'];
  createdOnUtc: Scalars['DateTime'];
  isInactive: Scalars['Boolean'];
  isUpdating: Scalars['Boolean'];
  lastCalculatedUtc?: Maybe<Scalars['DateTime']>;
  lastEditedUtc?: Maybe<Scalars['DateTime']>;
  lspId: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
  tag?: Maybe<Tag>;
  tagId: Scalars['Int'];
};

export type SmartTagFilterInput = {
  and?: InputMaybe<Array<SmartTagFilterInput>>;
  combinator?: InputMaybe<StringOperationFilterInput>;
  createdBy?: InputMaybe<ComparableInt32OperationFilterInput>;
  createdOnUtc?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  isInactive?: InputMaybe<BooleanOperationFilterInput>;
  isUpdating?: InputMaybe<BooleanOperationFilterInput>;
  lastCalculatedUtc?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  lastEditedUtc?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  lspId?: InputMaybe<ComparableInt32OperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<SmartTagFilterInput>>;
  tag?: InputMaybe<TagFilterInput>;
  tagId?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type SmartTagSortInput = {
  combinator?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  createdOnUtc?: InputMaybe<SortEnumType>;
  isInactive?: InputMaybe<SortEnumType>;
  isUpdating?: InputMaybe<SortEnumType>;
  lastCalculatedUtc?: InputMaybe<SortEnumType>;
  lastEditedUtc?: InputMaybe<SortEnumType>;
  lspId?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  tag?: InputMaybe<TagSortInput>;
  tagId?: InputMaybe<SortEnumType>;
};

export enum SortEnumType {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type StringOperationFilterInput = {
  and?: InputMaybe<Array<StringOperationFilterInput>>;
  contains?: InputMaybe<Scalars['String']>;
  endsWith?: InputMaybe<Scalars['String']>;
  eq?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ncontains?: InputMaybe<Scalars['String']>;
  nendsWith?: InputMaybe<Scalars['String']>;
  neq?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nstartsWith?: InputMaybe<Scalars['String']>;
  or?: InputMaybe<Array<StringOperationFilterInput>>;
  startsWith?: InputMaybe<Scalars['String']>;
};

export type SubmitAuditForReviewInput = {
  auditId: Scalars['Int'];
  locId: Scalars['Int'];
  lspId: Scalars['Int'];
  sessionId?: InputMaybe<Scalars['String']>;
  userId: Scalars['Int'];
};

export type Tag = {
  assemblyOutputItems?: Maybe<Array<Maybe<AssemblyOutputItem>>>;
  discountInventoryTagRestrictions?: Maybe<Array<Maybe<DiscountInventoryTagRestriction>>>;
  discountTagRestrictions?: Maybe<Array<Maybe<DiscountTagRestriction>>>;
  lsp?: Maybe<TblLsp>;
  lspId: Scalars['Int'];
  packageToTags?: Maybe<Array<Maybe<PackageToTag>>>;
  productToTags?: Maybe<Array<Maybe<ProductToTag>>>;
  smartTag?: Maybe<SmartTag>;
  tagId: Scalars['Int'];
  tagName: Scalars['String'];
};

export type TagCollectionSegment = {
  items?: Maybe<Array<Maybe<Tag>>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

export type TagFilterInput = {
  and?: InputMaybe<Array<TagFilterInput>>;
  assemblyOutputItems?: InputMaybe<ListFilterInputTypeOfAssemblyOutputItemFilterInput>;
  discountInventoryTagRestrictions?: InputMaybe<ListFilterInputTypeOfDiscountInventoryTagRestrictionFilterInput>;
  discountTagRestrictions?: InputMaybe<ListFilterInputTypeOfDiscountTagRestrictionFilterInput>;
  lsp?: InputMaybe<TblLspFilterInput>;
  lspId?: InputMaybe<ComparableInt32OperationFilterInput>;
  or?: InputMaybe<Array<TagFilterInput>>;
  packageToTags?: InputMaybe<ListFilterInputTypeOfPackageToTagFilterInput>;
  productToTags?: InputMaybe<ListFilterInputTypeOfProductToTagFilterInput>;
  smartTag?: InputMaybe<SmartTagFilterInput>;
  tagId?: InputMaybe<ComparableInt32OperationFilterInput>;
  tagName?: InputMaybe<StringOperationFilterInput>;
};

export type TagSortInput = {
  lsp?: InputMaybe<TblLspSortInput>;
  lspId?: InputMaybe<SortEnumType>;
  smartTag?: InputMaybe<SmartTagSortInput>;
  tagId?: InputMaybe<SortEnumType>;
  tagName?: InputMaybe<SortEnumType>;
};

export type TaxRate = {
  accountId?: Maybe<Scalars['String']>;
  appliesToAllCustomers: Scalars['Boolean'];
  appliesToAllProducts: Scalars['Boolean'];
  appliesToAllZones: Scalars['Boolean'];
  appliesToWholesaleTransfers: Scalars['Boolean'];
  applyMarkupRate: Scalars['Boolean'];
  applyPreDiscount: Scalars['Boolean'];
  applyToCost: Scalars['Boolean'];
  armsLength: Scalars['Boolean'];
  bookToSalesAccount: Scalars['Boolean'];
  includeInCost: Scalars['Boolean'];
  isBuiltIntoPrice: Scalars['Boolean'];
  isExciseTax: Scalars['Boolean'];
  isRefundable: Scalars['Boolean'];
  loc?: Maybe<TblLspLocation>;
  locId: Scalars['Int'];
  lsp?: Maybe<TblLsp>;
  lspId: Scalars['Int'];
  markupRate?: Maybe<Scalars['Decimal']>;
  rateAmount?: Maybe<Scalars['Decimal']>;
  rateName: Scalars['String'];
  rateTypeUnitId?: Maybe<Scalars['Byte']>;
  stackingOrder?: Maybe<Scalars['Int']>;
  stacksOnOtherRates: Scalars['Boolean'];
  taxRateId: Scalars['Int'];
  taxRateToCustomerTypes?: Maybe<Array<Maybe<TaxRateToCustomerType>>>;
  taxRateToProductTaxCategories?: Maybe<Array<Maybe<TaxRateToProductTaxCategory>>>;
  taxRateTypeId: Scalars['Short'];
  zones?: Maybe<Array<Maybe<DeliveryZone>>>;
};

export type TaxRateFilterInput = {
  accountId?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<TaxRateFilterInput>>;
  appliesToAllCustomers?: InputMaybe<BooleanOperationFilterInput>;
  appliesToAllProducts?: InputMaybe<BooleanOperationFilterInput>;
  appliesToAllZones?: InputMaybe<BooleanOperationFilterInput>;
  appliesToWholesaleTransfers?: InputMaybe<BooleanOperationFilterInput>;
  applyMarkupRate?: InputMaybe<BooleanOperationFilterInput>;
  applyPreDiscount?: InputMaybe<BooleanOperationFilterInput>;
  applyToCost?: InputMaybe<BooleanOperationFilterInput>;
  armsLength?: InputMaybe<BooleanOperationFilterInput>;
  bookToSalesAccount?: InputMaybe<BooleanOperationFilterInput>;
  includeInCost?: InputMaybe<BooleanOperationFilterInput>;
  isBuiltIntoPrice?: InputMaybe<BooleanOperationFilterInput>;
  isExciseTax?: InputMaybe<BooleanOperationFilterInput>;
  isRefundable?: InputMaybe<BooleanOperationFilterInput>;
  loc?: InputMaybe<TblLspLocationFilterInput>;
  locId?: InputMaybe<ComparableInt32OperationFilterInput>;
  lsp?: InputMaybe<TblLspFilterInput>;
  lspId?: InputMaybe<ComparableInt32OperationFilterInput>;
  markupRate?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  or?: InputMaybe<Array<TaxRateFilterInput>>;
  rateAmount?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  rateName?: InputMaybe<StringOperationFilterInput>;
  rateTypeUnitId?: InputMaybe<ComparableNullableOfByteOperationFilterInput>;
  stackingOrder?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  stacksOnOtherRates?: InputMaybe<BooleanOperationFilterInput>;
  taxRateId?: InputMaybe<ComparableInt32OperationFilterInput>;
  taxRateToCustomerTypes?: InputMaybe<ListFilterInputTypeOfTaxRateToCustomerTypeFilterInput>;
  taxRateToProductTaxCategories?: InputMaybe<ListFilterInputTypeOfTaxRateToProductTaxCategoryFilterInput>;
  taxRateTypeId?: InputMaybe<ComparableInt16OperationFilterInput>;
  zones?: InputMaybe<ListFilterInputTypeOfDeliveryZoneFilterInput>;
};

export type TaxRateSortInput = {
  accountId?: InputMaybe<SortEnumType>;
  appliesToAllCustomers?: InputMaybe<SortEnumType>;
  appliesToAllProducts?: InputMaybe<SortEnumType>;
  appliesToAllZones?: InputMaybe<SortEnumType>;
  appliesToWholesaleTransfers?: InputMaybe<SortEnumType>;
  applyMarkupRate?: InputMaybe<SortEnumType>;
  applyPreDiscount?: InputMaybe<SortEnumType>;
  applyToCost?: InputMaybe<SortEnumType>;
  armsLength?: InputMaybe<SortEnumType>;
  bookToSalesAccount?: InputMaybe<SortEnumType>;
  includeInCost?: InputMaybe<SortEnumType>;
  isBuiltIntoPrice?: InputMaybe<SortEnumType>;
  isExciseTax?: InputMaybe<SortEnumType>;
  isRefundable?: InputMaybe<SortEnumType>;
  loc?: InputMaybe<TblLspLocationSortInput>;
  locId?: InputMaybe<SortEnumType>;
  lsp?: InputMaybe<TblLspSortInput>;
  lspId?: InputMaybe<SortEnumType>;
  markupRate?: InputMaybe<SortEnumType>;
  rateAmount?: InputMaybe<SortEnumType>;
  rateName?: InputMaybe<SortEnumType>;
  rateTypeUnitId?: InputMaybe<SortEnumType>;
  stackingOrder?: InputMaybe<SortEnumType>;
  stacksOnOtherRates?: InputMaybe<SortEnumType>;
  taxRateId?: InputMaybe<SortEnumType>;
  taxRateTypeId?: InputMaybe<SortEnumType>;
};

export type TaxRateToCustomerType = {
  customerTypeId: Scalars['Int'];
  rateAmount?: Maybe<Scalars['Decimal']>;
  taxRate?: Maybe<TaxRate>;
  taxRateId: Scalars['Int'];
};

export type TaxRateToCustomerTypeFilterInput = {
  and?: InputMaybe<Array<TaxRateToCustomerTypeFilterInput>>;
  customerTypeId?: InputMaybe<ComparableInt32OperationFilterInput>;
  or?: InputMaybe<Array<TaxRateToCustomerTypeFilterInput>>;
  rateAmount?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  taxRate?: InputMaybe<TaxRateFilterInput>;
  taxRateId?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type TaxRateToProductTaxCategory = {
  productTaxCategory?: Maybe<ProductTaxCategory>;
  productTaxCategoryId: Scalars['Int'];
  rateAmount?: Maybe<Scalars['Decimal']>;
  taxRate?: Maybe<TaxRate>;
  taxRateId: Scalars['Int'];
};

export type TaxRateToProductTaxCategoryFilterInput = {
  and?: InputMaybe<Array<TaxRateToProductTaxCategoryFilterInput>>;
  or?: InputMaybe<Array<TaxRateToProductTaxCategoryFilterInput>>;
  productTaxCategory?: InputMaybe<ProductTaxCategoryFilterInput>;
  productTaxCategoryId?: InputMaybe<ComparableInt32OperationFilterInput>;
  rateAmount?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  taxRate?: InputMaybe<TaxRateFilterInput>;
  taxRateId?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type TblAcct = {
  acctCode: Scalars['String'];
  acctsAddr1: Scalars['String'];
  acctsAddr2?: Maybe<Scalars['String']>;
  acctsAddr3?: Maybe<Scalars['String']>;
  acctsCity: Scalars['String'];
  acctsFax?: Maybe<Scalars['String']>;
  acctsName?: Maybe<Scalars['String']>;
  acctsPhone?: Maybe<Scalars['String']>;
  acctsPostalCode?: Maybe<Scalars['String']>;
  acctsState?: Maybe<Scalars['String']>;
  additionalStateIdentifiers?: Maybe<Scalars['String']>;
  addressBooks?: Maybe<Array<Maybe<AddressBook>>>;
  allocatedInventories?: Maybe<Array<Maybe<AllocatedInventory>>>;
  attestation?: Maybe<Scalars['String']>;
  attestationExpirationDate?: Maybe<Scalars['DateTime']>;
  attestationSignedDate?: Maybe<Scalars['DateTime']>;
  caregivers?: Maybe<Array<Maybe<Caregiver>>>;
  carryOverLoyalty?: Maybe<Scalars['Decimal']>;
  cellPhone?: Maybe<Scalars['String']>;
  certificationCollectionDate?: Maybe<Scalars['DateTime']>;
  certificationExpirationDate?: Maybe<Scalars['DateTime']>;
  condition?: Maybe<Scalars['String']>;
  county?: Maybe<Scalars['String']>;
  createDt?: Maybe<Scalars['DateTime']>;
  createdByIntegrator?: Maybe<Scalars['String']>;
  creditNotes?: Maybe<Scalars['String']>;
  currentPurchaseLimitOverride?: Maybe<Scalars['Decimal']>;
  customIdentifier?: Maybe<Scalars['String']>;
  customerTypeId?: Maybe<Scalars['Int']>;
  cycleDate?: Maybe<Scalars['DateTime']>;
  daysSupplyRemaining?: Maybe<Scalars['Int']>;
  ddnumber?: Maybe<Scalars['String']>;
  defaultStatusEmail?: Maybe<Scalars['String']>;
  demoName?: Maybe<Scalars['String']>;
  dlexpirationDate?: Maybe<Scalars['DateTime']>;
  doctor?: Maybe<Scalars['Int']>;
  doctorNavigation?: Maybe<MdDoctor>;
  driversLicenseHash?: Maybe<Array<Scalars['Byte']>>;
  driversLicenseId?: Maybe<Scalars['String']>;
  dutchiePayUserKey?: Maybe<Scalars['String']>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  externalDispensed?: Maybe<Scalars['Decimal']>;
  externalId?: Maybe<Scalars['String']>;
  externalName?: Maybe<Scalars['String']>;
  firstLastName?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  firstTransaction?: Maybe<Scalars['DateTime']>;
  fullName?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['String']>;
  group1?: Maybe<Scalars['Int']>;
  group1Navigation?: Maybe<MddiscountGroup>;
  group2?: Maybe<Scalars['Int']>;
  group2Navigation?: Maybe<MddiscountGroup>;
  group3?: Maybe<Scalars['Int']>;
  group3Navigation?: Maybe<MddiscountGroup>;
  group4?: Maybe<Scalars['Int']>;
  group4Navigation?: Maybe<MddiscountGroup>;
  group5?: Maybe<Scalars['Int']>;
  group5Navigation?: Maybe<MddiscountGroup>;
  guardian?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  inventoryPercent?: Maybe<Scalars['Decimal']>;
  isAnonymous: Scalars['Boolean'];
  isLoyaltyMember: Scalars['Boolean'];
  lastModifiedDateUtc: Scalars['DateTime'];
  lastName?: Maybe<Scalars['String']>;
  lastTransaction?: Maybe<Scalars['DateTime']>;
  latitude?: Maybe<Scalars['Decimal']>;
  leafLinkLicenseTypeId?: Maybe<Scalars['Int']>;
  loc?: Maybe<TblLspLocation>;
  locId?: Maybe<Scalars['Int']>;
  longitude?: Maybe<Scalars['Decimal']>;
  loyaltyPoints?: Maybe<Scalars['Decimal']>;
  loyaltyTier?: Maybe<Scalars['String']>;
  lsp?: Maybe<TblLsp>;
  lspId?: Maybe<Scalars['Int']>;
  maxTotalPurchaseLimitOverride?: Maybe<Scalars['Decimal']>;
  mergedIntoAcctId?: Maybe<Scalars['Int']>;
  middleName?: Maybe<Scalars['String']>;
  mjstateIdno?: Maybe<Scalars['String']>;
  mjstateIdstartDate?: Maybe<Scalars['DateTime']>;
  mmceuremainingFifteenDays?: Maybe<Scalars['Decimal']>;
  mmceuremainingThirtyDaysRolling?: Maybe<Scalars['Decimal']>;
  mmceuremainingThisWeek?: Maybe<Scalars['Decimal']>;
  mmjidstate?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  optedIntoEngagementSms?: Maybe<Scalars['Boolean']>;
  optedIntoMarketing?: Maybe<Scalars['Boolean']>;
  orders?: Maybe<Array<Maybe<Order>>>;
  otherReferralSource?: Maybe<Scalars['String']>;
  overideQty?: Maybe<Scalars['Decimal']>;
  patientDob?: Maybe<Scalars['DateTime']>;
  patientPhone?: Maybe<Scalars['String']>;
  patientPictureFileName?: Maybe<Scalars['String']>;
  preferredMethodOfContact?: Maybe<Scalars['String']>;
  primaryQualifyingConditionId?: Maybe<Scalars['Int']>;
  pronoun?: Maybe<Scalars['String']>;
  quickbooksId?: Maybe<Scalars['String']>;
  referral?: Maybe<Scalars['String']>;
  referralSourceId?: Maybe<Scalars['Int']>;
  shortname?: Maybe<Scalars['String']>;
  springbigId?: Maybe<Scalars['String']>;
  tblAcctsTblCountryCodes?: Maybe<Scalars['Int']>;
  tblAcctsTblStatus: Scalars['Int'];
  tblAuthUsers?: Maybe<Array<Maybe<TblAuthUser>>>;
  tblDispensarySchedules?: Maybe<Array<Maybe<TblDispensarySchedule>>>;
  tblLspLocations?: Maybe<Array<Maybe<TblLspLocation>>>;
  tblLsps?: Maybe<Array<Maybe<TblLsp>>>;
  tblMdshipments?: Maybe<Array<Maybe<TblMdshipment>>>;
  tblWhseProducts?: Maybe<Array<Maybe<TblWhseProduct>>>;
};

export type TblAcctCollectionSegment = {
  items?: Maybe<Array<Maybe<TblAcct>>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

export type TblAcctFilterInput = {
  acctCode?: InputMaybe<StringOperationFilterInput>;
  acctsAddr1?: InputMaybe<StringOperationFilterInput>;
  acctsAddr2?: InputMaybe<StringOperationFilterInput>;
  acctsAddr3?: InputMaybe<StringOperationFilterInput>;
  acctsCity?: InputMaybe<StringOperationFilterInput>;
  acctsFax?: InputMaybe<StringOperationFilterInput>;
  acctsName?: InputMaybe<StringOperationFilterInput>;
  acctsPhone?: InputMaybe<StringOperationFilterInput>;
  acctsPostalCode?: InputMaybe<StringOperationFilterInput>;
  acctsState?: InputMaybe<StringOperationFilterInput>;
  additionalStateIdentifiers?: InputMaybe<StringOperationFilterInput>;
  addressBooks?: InputMaybe<ListFilterInputTypeOfAddressBookFilterInput>;
  allocatedInventories?: InputMaybe<ListFilterInputTypeOfAllocatedInventoryFilterInput>;
  and?: InputMaybe<Array<TblAcctFilterInput>>;
  attestation?: InputMaybe<StringOperationFilterInput>;
  attestationExpirationDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  attestationSignedDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  caregivers?: InputMaybe<ListFilterInputTypeOfCaregiverFilterInput>;
  carryOverLoyalty?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  cellPhone?: InputMaybe<StringOperationFilterInput>;
  certificationCollectionDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  certificationExpirationDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  condition?: InputMaybe<StringOperationFilterInput>;
  county?: InputMaybe<StringOperationFilterInput>;
  createDt?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  createdByIntegrator?: InputMaybe<StringOperationFilterInput>;
  creditNotes?: InputMaybe<StringOperationFilterInput>;
  currentPurchaseLimitOverride?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  customIdentifier?: InputMaybe<StringOperationFilterInput>;
  customerTypeId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  cycleDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  daysSupplyRemaining?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  ddnumber?: InputMaybe<StringOperationFilterInput>;
  defaultStatusEmail?: InputMaybe<StringOperationFilterInput>;
  demoName?: InputMaybe<StringOperationFilterInput>;
  dlexpirationDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  doctor?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  doctorNavigation?: InputMaybe<MdDoctorFilterInput>;
  driversLicenseHash?: InputMaybe<ListComparableByteOperationFilterInput>;
  driversLicenseId?: InputMaybe<StringOperationFilterInput>;
  dutchiePayUserKey?: InputMaybe<StringOperationFilterInput>;
  expirationDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  externalDispensed?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  externalId?: InputMaybe<StringOperationFilterInput>;
  externalName?: InputMaybe<StringOperationFilterInput>;
  firstLastName?: InputMaybe<StringOperationFilterInput>;
  firstName?: InputMaybe<StringOperationFilterInput>;
  firstTransaction?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  fullName?: InputMaybe<StringOperationFilterInput>;
  gender?: InputMaybe<StringOperationFilterInput>;
  group1?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  group1Navigation?: InputMaybe<MddiscountGroupFilterInput>;
  group2?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  group2Navigation?: InputMaybe<MddiscountGroupFilterInput>;
  group3?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  group3Navigation?: InputMaybe<MddiscountGroupFilterInput>;
  group4?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  group4Navigation?: InputMaybe<MddiscountGroupFilterInput>;
  group5?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  group5Navigation?: InputMaybe<MddiscountGroupFilterInput>;
  guardian?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  inventoryPercent?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  isAnonymous?: InputMaybe<BooleanOperationFilterInput>;
  isLoyaltyMember?: InputMaybe<BooleanOperationFilterInput>;
  lastModifiedDateUtc?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  lastName?: InputMaybe<StringOperationFilterInput>;
  lastTransaction?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  latitude?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  leafLinkLicenseTypeId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  loc?: InputMaybe<TblLspLocationFilterInput>;
  locId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  longitude?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  loyaltyPoints?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  loyaltyTier?: InputMaybe<StringOperationFilterInput>;
  lsp?: InputMaybe<TblLspFilterInput>;
  lspId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  maxTotalPurchaseLimitOverride?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  mergedIntoAcctId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  middleName?: InputMaybe<StringOperationFilterInput>;
  mjstateIdno?: InputMaybe<StringOperationFilterInput>;
  mjstateIdstartDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  mmceuremainingFifteenDays?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  mmceuremainingThirtyDaysRolling?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  mmceuremainingThisWeek?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  mmjidstate?: InputMaybe<StringOperationFilterInput>;
  namePrefix?: InputMaybe<StringOperationFilterInput>;
  nameSuffix?: InputMaybe<StringOperationFilterInput>;
  optedIntoEngagementSms?: InputMaybe<BooleanOperationFilterInput>;
  optedIntoMarketing?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<TblAcctFilterInput>>;
  orders?: InputMaybe<ListFilterInputTypeOfOrderFilterInput>;
  otherReferralSource?: InputMaybe<StringOperationFilterInput>;
  overideQty?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  patientDob?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  patientPhone?: InputMaybe<StringOperationFilterInput>;
  patientPictureFileName?: InputMaybe<StringOperationFilterInput>;
  preferredMethodOfContact?: InputMaybe<StringOperationFilterInput>;
  primaryQualifyingConditionId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  pronoun?: InputMaybe<StringOperationFilterInput>;
  quickbooksId?: InputMaybe<StringOperationFilterInput>;
  referral?: InputMaybe<StringOperationFilterInput>;
  referralSourceId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  shortname?: InputMaybe<StringOperationFilterInput>;
  springbigId?: InputMaybe<StringOperationFilterInput>;
  tblAcctsTblCountryCodes?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  tblAcctsTblStatus?: InputMaybe<ComparableInt32OperationFilterInput>;
  tblAuthUsers?: InputMaybe<ListFilterInputTypeOfTblAuthUserFilterInput>;
  tblDispensarySchedules?: InputMaybe<ListFilterInputTypeOfTblDispensaryScheduleFilterInput>;
  tblLspLocations?: InputMaybe<ListFilterInputTypeOfTblLspLocationFilterInput>;
  tblLsps?: InputMaybe<ListFilterInputTypeOfTblLspFilterInput>;
  tblMdshipments?: InputMaybe<ListFilterInputTypeOfTblMdshipmentFilterInput>;
  tblWhseProducts?: InputMaybe<ListFilterInputTypeOfTblWhseProductFilterInput>;
};

export type TblAcctSortInput = {
  acctCode?: InputMaybe<SortEnumType>;
  acctsAddr1?: InputMaybe<SortEnumType>;
  acctsAddr2?: InputMaybe<SortEnumType>;
  acctsAddr3?: InputMaybe<SortEnumType>;
  acctsCity?: InputMaybe<SortEnumType>;
  acctsFax?: InputMaybe<SortEnumType>;
  acctsName?: InputMaybe<SortEnumType>;
  acctsPhone?: InputMaybe<SortEnumType>;
  acctsPostalCode?: InputMaybe<SortEnumType>;
  acctsState?: InputMaybe<SortEnumType>;
  additionalStateIdentifiers?: InputMaybe<SortEnumType>;
  attestation?: InputMaybe<SortEnumType>;
  attestationExpirationDate?: InputMaybe<SortEnumType>;
  attestationSignedDate?: InputMaybe<SortEnumType>;
  carryOverLoyalty?: InputMaybe<SortEnumType>;
  cellPhone?: InputMaybe<SortEnumType>;
  certificationCollectionDate?: InputMaybe<SortEnumType>;
  certificationExpirationDate?: InputMaybe<SortEnumType>;
  condition?: InputMaybe<SortEnumType>;
  county?: InputMaybe<SortEnumType>;
  createDt?: InputMaybe<SortEnumType>;
  createdByIntegrator?: InputMaybe<SortEnumType>;
  creditNotes?: InputMaybe<SortEnumType>;
  currentPurchaseLimitOverride?: InputMaybe<SortEnumType>;
  customIdentifier?: InputMaybe<SortEnumType>;
  customerTypeId?: InputMaybe<SortEnumType>;
  cycleDate?: InputMaybe<SortEnumType>;
  daysSupplyRemaining?: InputMaybe<SortEnumType>;
  ddnumber?: InputMaybe<SortEnumType>;
  defaultStatusEmail?: InputMaybe<SortEnumType>;
  demoName?: InputMaybe<SortEnumType>;
  dlexpirationDate?: InputMaybe<SortEnumType>;
  doctor?: InputMaybe<SortEnumType>;
  doctorNavigation?: InputMaybe<MdDoctorSortInput>;
  driversLicenseId?: InputMaybe<SortEnumType>;
  dutchiePayUserKey?: InputMaybe<SortEnumType>;
  expirationDate?: InputMaybe<SortEnumType>;
  externalDispensed?: InputMaybe<SortEnumType>;
  externalId?: InputMaybe<SortEnumType>;
  externalName?: InputMaybe<SortEnumType>;
  firstLastName?: InputMaybe<SortEnumType>;
  firstName?: InputMaybe<SortEnumType>;
  firstTransaction?: InputMaybe<SortEnumType>;
  fullName?: InputMaybe<SortEnumType>;
  gender?: InputMaybe<SortEnumType>;
  group1?: InputMaybe<SortEnumType>;
  group1Navigation?: InputMaybe<MddiscountGroupSortInput>;
  group2?: InputMaybe<SortEnumType>;
  group2Navigation?: InputMaybe<MddiscountGroupSortInput>;
  group3?: InputMaybe<SortEnumType>;
  group3Navigation?: InputMaybe<MddiscountGroupSortInput>;
  group4?: InputMaybe<SortEnumType>;
  group4Navigation?: InputMaybe<MddiscountGroupSortInput>;
  group5?: InputMaybe<SortEnumType>;
  group5Navigation?: InputMaybe<MddiscountGroupSortInput>;
  guardian?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  inventoryPercent?: InputMaybe<SortEnumType>;
  isAnonymous?: InputMaybe<SortEnumType>;
  isLoyaltyMember?: InputMaybe<SortEnumType>;
  lastModifiedDateUtc?: InputMaybe<SortEnumType>;
  lastName?: InputMaybe<SortEnumType>;
  lastTransaction?: InputMaybe<SortEnumType>;
  latitude?: InputMaybe<SortEnumType>;
  leafLinkLicenseTypeId?: InputMaybe<SortEnumType>;
  loc?: InputMaybe<TblLspLocationSortInput>;
  locId?: InputMaybe<SortEnumType>;
  longitude?: InputMaybe<SortEnumType>;
  loyaltyPoints?: InputMaybe<SortEnumType>;
  loyaltyTier?: InputMaybe<SortEnumType>;
  lsp?: InputMaybe<TblLspSortInput>;
  lspId?: InputMaybe<SortEnumType>;
  maxTotalPurchaseLimitOverride?: InputMaybe<SortEnumType>;
  mergedIntoAcctId?: InputMaybe<SortEnumType>;
  middleName?: InputMaybe<SortEnumType>;
  mjstateIdno?: InputMaybe<SortEnumType>;
  mjstateIdstartDate?: InputMaybe<SortEnumType>;
  mmceuremainingFifteenDays?: InputMaybe<SortEnumType>;
  mmceuremainingThirtyDaysRolling?: InputMaybe<SortEnumType>;
  mmceuremainingThisWeek?: InputMaybe<SortEnumType>;
  mmjidstate?: InputMaybe<SortEnumType>;
  namePrefix?: InputMaybe<SortEnumType>;
  nameSuffix?: InputMaybe<SortEnumType>;
  optedIntoEngagementSms?: InputMaybe<SortEnumType>;
  optedIntoMarketing?: InputMaybe<SortEnumType>;
  otherReferralSource?: InputMaybe<SortEnumType>;
  overideQty?: InputMaybe<SortEnumType>;
  patientDob?: InputMaybe<SortEnumType>;
  patientPhone?: InputMaybe<SortEnumType>;
  patientPictureFileName?: InputMaybe<SortEnumType>;
  preferredMethodOfContact?: InputMaybe<SortEnumType>;
  primaryQualifyingConditionId?: InputMaybe<SortEnumType>;
  pronoun?: InputMaybe<SortEnumType>;
  quickbooksId?: InputMaybe<SortEnumType>;
  referral?: InputMaybe<SortEnumType>;
  referralSourceId?: InputMaybe<SortEnumType>;
  shortname?: InputMaybe<SortEnumType>;
  springbigId?: InputMaybe<SortEnumType>;
  tblAcctsTblCountryCodes?: InputMaybe<SortEnumType>;
  tblAcctsTblStatus?: InputMaybe<SortEnumType>;
};

export type TblAuthDomainLspLink = {
  id: Scalars['Int'];
  rowVersion: Array<Scalars['Byte']>;
  tblAuthDomainLspLinkTblAuthDomain: Scalars['Int'];
  tblAuthDomainLspLinkTblLsp: Scalars['Int'];
  tblAuthDomainLspLinkTblLspNavigation?: Maybe<TblLsp>;
};

export type TblAuthDomainLspLinkFilterInput = {
  and?: InputMaybe<Array<TblAuthDomainLspLinkFilterInput>>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  or?: InputMaybe<Array<TblAuthDomainLspLinkFilterInput>>;
  rowVersion?: InputMaybe<ListComparableByteOperationFilterInput>;
  tblAuthDomainLspLinkTblAuthDomain?: InputMaybe<ComparableInt32OperationFilterInput>;
  tblAuthDomainLspLinkTblLsp?: InputMaybe<ComparableInt32OperationFilterInput>;
  tblAuthDomainLspLinkTblLspNavigation?: InputMaybe<TblLspFilterInput>;
};

export type TblAuthUser = {
  allocatedInventoryDiscountedByNavigations?: Maybe<Array<Maybe<AllocatedInventory>>>;
  allocatedInventoryVoidByNavigations?: Maybe<Array<Maybe<AllocatedInventory>>>;
  appliedByUser?: Maybe<PlantNutrientLog>;
  appliedDiscounts?: Maybe<Array<Maybe<AppliedDiscount>>>;
  assemblyCompletedByNavigations?: Maybe<Array<Maybe<Assembly>>>;
  assemblyCreatedByNavigations?: Maybe<Array<Maybe<Assembly>>>;
  assemblyLastModifiedByNavigations?: Maybe<Array<Maybe<Assembly>>>;
  assemblyStartedByNavigations?: Maybe<Array<Maybe<Assembly>>>;
  billOfMaterialCreatedByNavigations?: Maybe<Array<Maybe<BillOfMaterial>>>;
  billOfMaterialDeletedByNavigations?: Maybe<Array<Maybe<BillOfMaterial>>>;
  billOfMaterialLastEditedByNavigations?: Maybe<Array<Maybe<BillOfMaterial>>>;
  billOfMaterialLastRanByNavigations?: Maybe<Array<Maybe<BillOfMaterial>>>;
  changePassword: Scalars['String'];
  comments?: Maybe<Scalars['String']>;
  contactName?: Maybe<Scalars['String']>;
  contactPhone?: Maybe<Scalars['String']>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  deliveryRouteHistories?: Maybe<Array<Maybe<DeliveryRouteHistory>>>;
  demoMode?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  employeePinCode?: Maybe<Scalars['String']>;
  fgreconDetails?: Maybe<Array<Maybe<FgreconDetail>>>;
  fgreconReconSubmittedByNavigations?: Maybe<Array<Maybe<Fgrecon>>>;
  fgrecons?: Maybe<Array<Maybe<Fgrecon>>>;
  forcePasswordChange: Scalars['Boolean'];
  fullName: Scalars['String'];
  hashedPassword?: Maybe<Scalars['String']>;
  headSetXferDate?: Maybe<Scalars['DateTime']>;
  iamAnAdministrator?: Maybe<Scalars['String']>;
  iamAnInspector?: Maybe<Scalars['String']>;
  iamRestrictedToOfficeAcess?: Maybe<Scalars['String']>;
  icanAccessInventory?: Maybe<Scalars['String']>;
  icanAccessReports?: Maybe<Scalars['String']>;
  icanExportReports?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  idispensaryCheckIn?: Maybe<Scalars['String']>;
  inventoryAuditFiles?: Maybe<Array<Maybe<InventoryAuditFile>>>;
  inventoryReadOnly?: Maybe<Scalars['String']>;
  inventoryTransactions?: Maybe<Array<Maybe<InventoryTransaction>>>;
  isLocalSuperuser?: Maybe<Scalars['Boolean']>;
  iworkInAdispensary?: Maybe<Scalars['String']>;
  iworkInAgrower?: Maybe<Scalars['String']>;
  lastLoginFailure?: Maybe<Scalars['DateTime']>;
  lastLoginSuccess?: Maybe<Scalars['DateTime']>;
  lastPasswordChange?: Maybe<Scalars['DateTime']>;
  loginFailureCount: Scalars['Int'];
  maxQty?: Maybe<Scalars['Decimal']>;
  mdManifests?: Maybe<Array<Maybe<MdManifest>>>;
  mddefaultLocation?: Maybe<Scalars['Int']>;
  mddefaultLocationNavigation?: Maybe<TblLspLocation>;
  mddefaultLsp?: Maybe<Scalars['Int']>;
  mddefaultLspNavigation?: Maybe<TblLsp>;
  mdlogin?: Maybe<Scalars['String']>;
  mdloginType?: Maybe<Scalars['String']>;
  metrcProcessingJobTypeTemplateCreatedByNavigations?: Maybe<Array<Maybe<MetrcProcessingJobTypeTemplate>>>;
  metrcProcessingJobTypeTemplateLastEditedByNavigations?: Maybe<Array<Maybe<MetrcProcessingJobTypeTemplate>>>;
  mmjexpiration?: Maybe<Scalars['DateTime']>;
  name: Scalars['String'];
  nickName?: Maybe<Scalars['String']>;
  onlineStatus?: Maybe<Scalars['String']>;
  patientAcctLink?: Maybe<Scalars['Int']>;
  patientAcctLinkNavigation?: Maybe<TblAcct>;
  plantTransactions?: Maybe<Array<Maybe<PlantTransaction>>>;
  registerLedgers?: Maybe<Array<Maybe<RegisterLedger>>>;
  stateId?: Maybe<Scalars['String']>;
  stateIdExpiration?: Maybe<Scalars['DateTime']>;
  stateInspector?: Maybe<Scalars['String']>;
  tblAuthUserTblAuthCode1: Scalars['Int'];
  tblAuthUserTblAuthDomain: Scalars['Int'];
  tblBatchBatchIssuedByNavigations?: Maybe<Array<Maybe<TblBatch>>>;
  tblBatchComplianceApprovalNavigations?: Maybe<Array<Maybe<TblBatch>>>;
  tblBatchFuserNavigations?: Maybe<Array<Maybe<TblBatch>>>;
  tblBatchGrowingApprovalNavigations?: Maybe<Array<Maybe<TblBatch>>>;
  tblBatchPackagingApprovalNavigations?: Maybe<Array<Maybe<TblBatch>>>;
  tblBatchSfeuserNavigations?: Maybe<Array<Maybe<TblBatch>>>;
  tblBatchThcs?: Maybe<Array<Maybe<TblBatchThc>>>;
  tblMddrivers?: Maybe<Array<Maybe<TblMddriver>>>;
  tblMdorders?: Maybe<Array<Maybe<TblMdorder>>>;
  tblMdshipmentResponsibleForSaleUsers?: Maybe<Array<Maybe<TblMdshipment>>>;
  tblMdshipmentShipmentByNavigations?: Maybe<Array<Maybe<TblMdshipment>>>;
  tblMdshipmentVerifiedByNavigations?: Maybe<Array<Maybe<TblMdshipment>>>;
  userLsps?: Maybe<Array<Maybe<UserLsp>>>;
  userName?: Maybe<PlantRoomHistory>;
  userStatus: Scalars['String'];
  userToPermissions?: Maybe<Array<Maybe<UserToPermission>>>;
  userToUserGroups?: Maybe<Array<Maybe<UserToUserGroup>>>;
  userType?: Maybe<Scalars['String']>;
};

export type TblAuthUserCollectionSegment = {
  items?: Maybe<Array<Maybe<TblAuthUser>>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

export type TblAuthUserFilterInput = {
  allocatedInventoryDiscountedByNavigations?: InputMaybe<ListFilterInputTypeOfAllocatedInventoryFilterInput>;
  allocatedInventoryVoidByNavigations?: InputMaybe<ListFilterInputTypeOfAllocatedInventoryFilterInput>;
  and?: InputMaybe<Array<TblAuthUserFilterInput>>;
  appliedByUser?: InputMaybe<PlantNutrientLogFilterInput>;
  appliedDiscounts?: InputMaybe<ListFilterInputTypeOfAppliedDiscountFilterInput>;
  assemblyCompletedByNavigations?: InputMaybe<ListFilterInputTypeOfAssemblyFilterInput>;
  assemblyCreatedByNavigations?: InputMaybe<ListFilterInputTypeOfAssemblyFilterInput>;
  assemblyLastModifiedByNavigations?: InputMaybe<ListFilterInputTypeOfAssemblyFilterInput>;
  assemblyStartedByNavigations?: InputMaybe<ListFilterInputTypeOfAssemblyFilterInput>;
  billOfMaterialCreatedByNavigations?: InputMaybe<ListFilterInputTypeOfBillOfMaterialFilterInput>;
  billOfMaterialDeletedByNavigations?: InputMaybe<ListFilterInputTypeOfBillOfMaterialFilterInput>;
  billOfMaterialLastEditedByNavigations?: InputMaybe<ListFilterInputTypeOfBillOfMaterialFilterInput>;
  billOfMaterialLastRanByNavigations?: InputMaybe<ListFilterInputTypeOfBillOfMaterialFilterInput>;
  changePassword?: InputMaybe<StringOperationFilterInput>;
  comments?: InputMaybe<StringOperationFilterInput>;
  contactName?: InputMaybe<StringOperationFilterInput>;
  contactPhone?: InputMaybe<StringOperationFilterInput>;
  dateOfBirth?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  deliveryRouteHistories?: InputMaybe<ListFilterInputTypeOfDeliveryRouteHistoryFilterInput>;
  demoMode?: InputMaybe<StringOperationFilterInput>;
  email?: InputMaybe<StringOperationFilterInput>;
  employeePinCode?: InputMaybe<StringOperationFilterInput>;
  fgreconDetails?: InputMaybe<ListFilterInputTypeOfFgreconDetailFilterInput>;
  fgreconReconSubmittedByNavigations?: InputMaybe<ListFilterInputTypeOfFgreconFilterInput>;
  fgrecons?: InputMaybe<ListFilterInputTypeOfFgreconFilterInput>;
  forcePasswordChange?: InputMaybe<BooleanOperationFilterInput>;
  fullName?: InputMaybe<StringOperationFilterInput>;
  hashedPassword?: InputMaybe<StringOperationFilterInput>;
  headSetXferDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  iamAnAdministrator?: InputMaybe<StringOperationFilterInput>;
  iamAnInspector?: InputMaybe<StringOperationFilterInput>;
  iamRestrictedToOfficeAcess?: InputMaybe<StringOperationFilterInput>;
  icanAccessInventory?: InputMaybe<StringOperationFilterInput>;
  icanAccessReports?: InputMaybe<StringOperationFilterInput>;
  icanExportReports?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  idispensaryCheckIn?: InputMaybe<StringOperationFilterInput>;
  inventoryAuditFiles?: InputMaybe<ListFilterInputTypeOfInventoryAuditFileFilterInput>;
  inventoryReadOnly?: InputMaybe<StringOperationFilterInput>;
  inventoryTransactions?: InputMaybe<ListFilterInputTypeOfInventoryTransactionFilterInput>;
  isLocalSuperuser?: InputMaybe<BooleanOperationFilterInput>;
  iworkInAdispensary?: InputMaybe<StringOperationFilterInput>;
  iworkInAgrower?: InputMaybe<StringOperationFilterInput>;
  lastLoginFailure?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  lastLoginSuccess?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  lastPasswordChange?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  loginFailureCount?: InputMaybe<ComparableInt32OperationFilterInput>;
  maxQty?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  mdManifests?: InputMaybe<ListFilterInputTypeOfMdManifestFilterInput>;
  mddefaultLocation?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  mddefaultLocationNavigation?: InputMaybe<TblLspLocationFilterInput>;
  mddefaultLsp?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  mddefaultLspNavigation?: InputMaybe<TblLspFilterInput>;
  mdlogin?: InputMaybe<StringOperationFilterInput>;
  mdloginType?: InputMaybe<StringOperationFilterInput>;
  metrcProcessingJobTypeTemplateCreatedByNavigations?: InputMaybe<ListFilterInputTypeOfMetrcProcessingJobTypeTemplateFilterInput>;
  metrcProcessingJobTypeTemplateLastEditedByNavigations?: InputMaybe<ListFilterInputTypeOfMetrcProcessingJobTypeTemplateFilterInput>;
  mmjexpiration?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  nickName?: InputMaybe<StringOperationFilterInput>;
  onlineStatus?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<TblAuthUserFilterInput>>;
  patientAcctLink?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  patientAcctLinkNavigation?: InputMaybe<TblAcctFilterInput>;
  plantTransactions?: InputMaybe<ListFilterInputTypeOfPlantTransactionFilterInput>;
  registerLedgers?: InputMaybe<ListFilterInputTypeOfRegisterLedgerFilterInput>;
  stateId?: InputMaybe<StringOperationFilterInput>;
  stateIdExpiration?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  stateInspector?: InputMaybe<StringOperationFilterInput>;
  tblAuthUserTblAuthCode1?: InputMaybe<ComparableInt32OperationFilterInput>;
  tblAuthUserTblAuthDomain?: InputMaybe<ComparableInt32OperationFilterInput>;
  tblBatchBatchIssuedByNavigations?: InputMaybe<ListFilterInputTypeOfTblBatchFilterInput>;
  tblBatchComplianceApprovalNavigations?: InputMaybe<ListFilterInputTypeOfTblBatchFilterInput>;
  tblBatchFuserNavigations?: InputMaybe<ListFilterInputTypeOfTblBatchFilterInput>;
  tblBatchGrowingApprovalNavigations?: InputMaybe<ListFilterInputTypeOfTblBatchFilterInput>;
  tblBatchPackagingApprovalNavigations?: InputMaybe<ListFilterInputTypeOfTblBatchFilterInput>;
  tblBatchSfeuserNavigations?: InputMaybe<ListFilterInputTypeOfTblBatchFilterInput>;
  tblBatchThcs?: InputMaybe<ListFilterInputTypeOfTblBatchThcFilterInput>;
  tblMddrivers?: InputMaybe<ListFilterInputTypeOfTblMddriverFilterInput>;
  tblMdorders?: InputMaybe<ListFilterInputTypeOfTblMdorderFilterInput>;
  tblMdshipmentResponsibleForSaleUsers?: InputMaybe<ListFilterInputTypeOfTblMdshipmentFilterInput>;
  tblMdshipmentShipmentByNavigations?: InputMaybe<ListFilterInputTypeOfTblMdshipmentFilterInput>;
  tblMdshipmentVerifiedByNavigations?: InputMaybe<ListFilterInputTypeOfTblMdshipmentFilterInput>;
  userLsps?: InputMaybe<ListFilterInputTypeOfUserLspFilterInput>;
  userName?: InputMaybe<PlantRoomHistoryFilterInput>;
  userStatus?: InputMaybe<StringOperationFilterInput>;
  userToPermissions?: InputMaybe<ListFilterInputTypeOfUserToPermissionFilterInput>;
  userToUserGroups?: InputMaybe<ListFilterInputTypeOfUserToUserGroupFilterInput>;
  userType?: InputMaybe<StringOperationFilterInput>;
};

export type TblAuthUserSortInput = {
  appliedByUser?: InputMaybe<PlantNutrientLogSortInput>;
  changePassword?: InputMaybe<SortEnumType>;
  comments?: InputMaybe<SortEnumType>;
  contactName?: InputMaybe<SortEnumType>;
  contactPhone?: InputMaybe<SortEnumType>;
  dateOfBirth?: InputMaybe<SortEnumType>;
  demoMode?: InputMaybe<SortEnumType>;
  email?: InputMaybe<SortEnumType>;
  employeePinCode?: InputMaybe<SortEnumType>;
  forcePasswordChange?: InputMaybe<SortEnumType>;
  fullName?: InputMaybe<SortEnumType>;
  hashedPassword?: InputMaybe<SortEnumType>;
  headSetXferDate?: InputMaybe<SortEnumType>;
  iamAnAdministrator?: InputMaybe<SortEnumType>;
  iamAnInspector?: InputMaybe<SortEnumType>;
  iamRestrictedToOfficeAcess?: InputMaybe<SortEnumType>;
  icanAccessInventory?: InputMaybe<SortEnumType>;
  icanAccessReports?: InputMaybe<SortEnumType>;
  icanExportReports?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  idispensaryCheckIn?: InputMaybe<SortEnumType>;
  inventoryReadOnly?: InputMaybe<SortEnumType>;
  isLocalSuperuser?: InputMaybe<SortEnumType>;
  iworkInAdispensary?: InputMaybe<SortEnumType>;
  iworkInAgrower?: InputMaybe<SortEnumType>;
  lastLoginFailure?: InputMaybe<SortEnumType>;
  lastLoginSuccess?: InputMaybe<SortEnumType>;
  lastPasswordChange?: InputMaybe<SortEnumType>;
  loginFailureCount?: InputMaybe<SortEnumType>;
  maxQty?: InputMaybe<SortEnumType>;
  mddefaultLocation?: InputMaybe<SortEnumType>;
  mddefaultLocationNavigation?: InputMaybe<TblLspLocationSortInput>;
  mddefaultLsp?: InputMaybe<SortEnumType>;
  mddefaultLspNavigation?: InputMaybe<TblLspSortInput>;
  mdlogin?: InputMaybe<SortEnumType>;
  mdloginType?: InputMaybe<SortEnumType>;
  mmjexpiration?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  nickName?: InputMaybe<SortEnumType>;
  onlineStatus?: InputMaybe<SortEnumType>;
  patientAcctLink?: InputMaybe<SortEnumType>;
  patientAcctLinkNavigation?: InputMaybe<TblAcctSortInput>;
  stateId?: InputMaybe<SortEnumType>;
  stateIdExpiration?: InputMaybe<SortEnumType>;
  stateInspector?: InputMaybe<SortEnumType>;
  tblAuthUserTblAuthCode1?: InputMaybe<SortEnumType>;
  tblAuthUserTblAuthDomain?: InputMaybe<SortEnumType>;
  userName?: InputMaybe<PlantRoomHistorySortInput>;
  userStatus?: InputMaybe<SortEnumType>;
  userType?: InputMaybe<SortEnumType>;
};

export type TblAuthUsersAudit = {
  auditAction?: Maybe<Scalars['AuditActionScalar']>;
  auditDateTimeUtc: Scalars['DateTime'];
  authUsersAuditData?: Maybe<Array<TblAuthUsersAuditDatum>>;
  authUsersAuditId: Scalars['Int'];
  authUsersId?: Maybe<Scalars['Int']>;
  changedByUser?: Maybe<TblAuthUser>;
  locId?: Maybe<Scalars['Int']>;
  location?: Maybe<LocationInfo>;
  lspId?: Maybe<Scalars['Int']>;
  sessionlocId?: Maybe<Scalars['Int']>;
  sessionlspId?: Maybe<Scalars['Int']>;
  userChanged?: Maybe<TblAuthUser>;
  userId?: Maybe<Scalars['Int']>;
};

export type TblAuthUsersAuditCollectionSegment = {
  items?: Maybe<Array<Maybe<TblAuthUsersAudit>>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

export type TblAuthUsersAuditDatum = {
  authUsersAudit?: Maybe<TblAuthUsersAudit>;
  authUsersAuditId: Scalars['Int'];
  columnChanged?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  newValue?: Maybe<Scalars['String']>;
  oldValue?: Maybe<Scalars['String']>;
};

export type TblAuthUsersAuditDatumFilterInput = {
  and?: InputMaybe<Array<TblAuthUsersAuditDatumFilterInput>>;
  authUsersAudit?: InputMaybe<TblAuthUsersAuditFilterInput>;
  authUsersAuditId?: InputMaybe<ComparableInt32OperationFilterInput>;
  columnChanged?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  newValue?: InputMaybe<StringOperationFilterInput>;
  oldValue?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<TblAuthUsersAuditDatumFilterInput>>;
};

export type TblAuthUsersAuditFilterInput = {
  and?: InputMaybe<Array<TblAuthUsersAuditFilterInput>>;
  auditAction?: InputMaybe<StringOperationFilterInput>;
  auditDateTimeUtc?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  authUsersAuditData?: InputMaybe<ListFilterInputTypeOfTblAuthUsersAuditDatumFilterInput>;
  authUsersAuditId?: InputMaybe<ComparableInt32OperationFilterInput>;
  authUsersId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  locId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  lspId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  or?: InputMaybe<Array<TblAuthUsersAuditFilterInput>>;
  sessionlocId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  sessionlspId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  userId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
};

export type TblAuthUsersAuditSortInput = {
  auditAction?: InputMaybe<SortEnumType>;
  auditDateTimeUtc?: InputMaybe<SortEnumType>;
  authUsersAuditId?: InputMaybe<SortEnumType>;
  authUsersId?: InputMaybe<SortEnumType>;
  locId?: InputMaybe<SortEnumType>;
  lspId?: InputMaybe<SortEnumType>;
  sessionlocId?: InputMaybe<SortEnumType>;
  sessionlspId?: InputMaybe<SortEnumType>;
  userId?: InputMaybe<SortEnumType>;
};

export type TblBatch = {
  appearance?: Maybe<Scalars['String']>;
  aroma?: Maybe<Scalars['String']>;
  assemblyOutputItems?: Maybe<Array<Maybe<AssemblyOutputItem>>>;
  batchClosed?: Maybe<Scalars['DateTime']>;
  batchCurrentStep?: Maybe<Scalars['Int']>;
  batchIssuedBy: Scalars['Int'];
  batchIssuedByNavigation?: Maybe<TblAuthUser>;
  batchIssuedDate: Scalars['DateTime'];
  batchLotNumber: Scalars['String'];
  batchLsp: Scalars['Int'];
  batchLspLocation: Scalars['Int'];
  batchLspLocationNavigation?: Maybe<TblLspLocation>;
  batchLspNavigation?: Maybe<TblLsp>;
  batchNo?: Maybe<Scalars['String']>;
  batchSerialNumber?: Maybe<Scalars['String']>;
  batchStrain: Scalars['Int'];
  batchStrainNavigation?: Maybe<TblBatchStrain>;
  batchType: Scalars['String'];
  bioTcuredDtTm?: Maybe<Scalars['DateTime']>;
  bioTharvestedDtTm?: Maybe<Scalars['DateTime']>;
  bioTlotCreatedDtTm?: Maybe<Scalars['DateTime']>;
  bioTlotNo?: Maybe<Scalars['String']>;
  bioTotherPlantMaterialLotCreatedDtTm?: Maybe<Scalars['DateTime']>;
  bioTotherPlantMaterialLotNo?: Maybe<Scalars['String']>;
  bioTsubmittedToHarvestDtTm?: Maybe<Scalars['DateTime']>;
  brand?: Maybe<Scalars['String']>;
  budSize?: Maybe<Scalars['String']>;
  budYield?: Maybe<Scalars['Decimal']>;
  change?: Maybe<Scalars['Int']>;
  color?: Maybe<Scalars['String']>;
  compianceMgrApproval?: Maybe<Scalars['String']>;
  complianceApproval?: Maybe<Scalars['Int']>;
  complianceApprovalNavigation?: Maybe<TblAuthUser>;
  cureDate?: Maybe<Scalars['DateTime']>;
  currentRoom?: Maybe<Scalars['Int']>;
  currentStatus?: Maybe<Scalars['String']>;
  currentStatusDate?: Maybe<Scalars['DateTime']>;
  currentcount?: Maybe<Scalars['Int']>;
  density?: Maybe<Scalars['String']>;
  dryLeafWaste?: Maybe<Scalars['Decimal']>;
  dryWgtPreTrim?: Maybe<Scalars['Decimal']>;
  excessWeightThatDidntFit?: Maybe<Scalars['Decimal']>;
  extractRawDate?: Maybe<Scalars['DateTime']>;
  extractRawType?: Maybe<Scalars['String']>;
  femalesFailed?: Maybe<Scalars['Int']>;
  ffillTankFinishWgt?: Maybe<Scalars['Decimal']>;
  fhomeTankLost?: Maybe<Scalars['Decimal']>;
  fhotPlateTemp?: Maybe<Scalars['Decimal']>;
  fhotTankFinishWgt?: Maybe<Scalars['Decimal']>;
  finalInTakeWeight?: Maybe<Scalars['Decimal']>;
  fprePurgeWgt?: Maybe<Scalars['Decimal']>;
  ftotalTimeRan?: Maybe<Scalars['Decimal']>;
  fuser?: Maybe<Scalars['Int']>;
  fuserNavigation?: Maybe<TblAuthUser>;
  fweight?: Maybe<Scalars['Decimal']>;
  growingApproval?: Maybe<Scalars['Int']>;
  growingApprovalNavigation?: Maybe<TblAuthUser>;
  growingMgrApproval?: Maybe<Scalars['String']>;
  harvestCompletedOn?: Maybe<Scalars['DateTime']>;
  harvestReportingStage?: Maybe<Scalars['Int']>;
  harvestStartDate?: Maybe<Scalars['DateTime']>;
  harvestUnitId?: Maybe<Scalars['Int']>;
  harvested?: Maybe<Scalars['Int']>;
  holdForExtractYield?: Maybe<Scalars['Decimal']>;
  homogenzationRoom?: Maybe<Scalars['Int']>;
  homogenzationRoomNavigation?: Maybe<TblBatchRoom>;
  id: Scalars['Int'];
  initialInTakeWgt?: Maybe<Scalars['Decimal']>;
  invBatchFlag?: Maybe<Scalars['String']>;
  inverseMergeBatch?: Maybe<Array<Maybe<TblBatch>>>;
  inverseMotherBatch?: Maybe<Array<Maybe<TblBatch>>>;
  inverseSection2MotherStrainLotNoNavigation?: Maybe<Array<Maybe<TblBatch>>>;
  itemNum?: Maybe<Scalars['String']>;
  jointMaterialDesc?: Maybe<Scalars['String']>;
  jointMaterialValue?: Maybe<Scalars['Decimal']>;
  kief?: Maybe<Scalars['String']>;
  kiefDesc?: Maybe<Scalars['String']>;
  kiefValue?: Maybe<Scalars['Decimal']>;
  lastCount?: Maybe<Scalars['Int']>;
  lastModifiedDateUtc: Scalars['DateTime'];
  locBeforeDel?: Maybe<Scalars['Int']>;
  locDelDtTm?: Maybe<Scalars['DateTime']>;
  malePlantRemoved?: Maybe<Scalars['Int']>;
  mergeBatch?: Maybe<TblBatch>;
  mergeBatchId?: Maybe<Scalars['Int']>;
  mildYield?: Maybe<Scalars['Decimal']>;
  moistureContent?: Maybe<Scalars['String']>;
  motherBatch?: Maybe<TblBatch>;
  motherBatchId?: Maybe<Scalars['Int']>;
  mothersRemoved?: Maybe<Scalars['Int']>;
  netBudWgt?: Maybe<Scalars['Decimal']>;
  netCount?: Maybe<Scalars['Int']>;
  nexStepDescription?: Maybe<Scalars['String']>;
  nextStepFld?: Maybe<Scalars['String']>;
  nextStepNo?: Maybe<Scalars['Int']>;
  nextStepTitle?: Maybe<Scalars['String']>;
  notes1?: Maybe<Scalars['String']>;
  notes2?: Maybe<Scalars['String']>;
  notes3?: Maybe<Scalars['String']>;
  notes4?: Maybe<Scalars['String']>;
  nrOfPlants?: Maybe<Scalars['Int']>;
  otherPlantLotNo?: Maybe<Scalars['String']>;
  packages?: Maybe<Array<Maybe<Package>>>;
  packagingApproval?: Maybe<Scalars['Int']>;
  packagingApprovalNavigation?: Maybe<TblAuthUser>;
  packagingMgrApproval?: Maybe<Scalars['String']>;
  postTrimWetWgt?: Maybe<Scalars['Decimal']>;
  productType?: Maybe<Scalars['String']>;
  projectedHarvestDate?: Maybe<Scalars['DateTime']>;
  projectedYield?: Maybe<Scalars['Decimal']>;
  projectedYieldUnitId?: Maybe<Scalars['Int']>;
  rextractorPsi?: Maybe<Scalars['Decimal']>;
  rextractorTemp?: Maybe<Scalars['Decimal']>;
  rfillTankStartWgt?: Maybe<Scalars['Decimal']>;
  rhomeTankStartWgt?: Maybe<Scalars['Decimal']>;
  rnewFillStartWgt?: Maybe<Scalars['Decimal']>;
  rseperatorPsi?: Maybe<Scalars['Decimal']>;
  rseperatorTemp?: Maybe<Scalars['Decimal']>;
  runNumber?: Maybe<Scalars['String']>;
  ruser?: Maybe<Scalars['Int']>;
  saleabilityNotes?: Maybe<Scalars['String']>;
  sectin6SupervisorContacted?: Maybe<Scalars['String']>;
  section1PlantSeedlings?: Maybe<Scalars['String']>;
  section1Preparecubes?: Maybe<Scalars['String']>;
  section1RoomNo?: Maybe<Scalars['Int']>;
  section1RoomNoNavigation?: Maybe<TblBatchRoom>;
  section1SeedCnt?: Maybe<Scalars['Int']>;
  section1SeedlingsCnt?: Maybe<Scalars['Int']>;
  section1SeedlingsRooted?: Maybe<Scalars['String']>;
  section1TrayCnt?: Maybe<Scalars['Int']>;
  section1TraysLabeled?: Maybe<Scalars['String']>;
  section2CloneMister?: Maybe<Scalars['String']>;
  section2CloneStarts?: Maybe<Scalars['Int']>;
  section2ClonesRooted?: Maybe<Scalars['String']>;
  section2CuttingsCnt?: Maybe<Scalars['Int']>;
  section2HormoneSolution?: Maybe<Scalars['String']>;
  section2Mother?: Maybe<Scalars['String']>;
  section2MotherPhenoType?: Maybe<Scalars['Int']>;
  section2MotherStrainLotNo?: Maybe<Scalars['Int']>;
  section2MotherStrainLotNoNavigation?: Maybe<TblBatch>;
  section2PlantClones?: Maybe<Scalars['String']>;
  section2RoomNo?: Maybe<Scalars['Int']>;
  section2RoomNoNavigation?: Maybe<TblBatchRoom>;
  section2SuccessfulClonesCnt?: Maybe<Scalars['Int']>;
  section2TrayCnt?: Maybe<Scalars['Int']>;
  section2TraysLabeled?: Maybe<Scalars['String']>;
  section3Match?: Maybe<Scalars['String']>;
  section3Plant4by4Cubes?: Maybe<Scalars['String']>;
  section3PlantCnt?: Maybe<Scalars['Int']>;
  section3RoomNo?: Maybe<Scalars['Int']>;
  section3RoomNoNavigation?: Maybe<TblBatchRoom>;
  section3TrayCnt?: Maybe<Scalars['Int']>;
  section3WasteGrams?: Maybe<Scalars['Decimal']>;
  section4Match?: Maybe<Scalars['String']>;
  section4PlantCnt?: Maybe<Scalars['Int']>;
  section4RoomNo?: Maybe<Scalars['Int']>;
  section4RoomNoNavigation?: Maybe<TblBatchRoom>;
  section4TrayCnt?: Maybe<Scalars['Int']>;
  section4TraysLabeled?: Maybe<Scalars['String']>;
  section4WasteGrams?: Maybe<Scalars['Decimal']>;
  section5FlowersWeight?: Maybe<Scalars['Decimal']>;
  section5HarvestWeight?: Maybe<Scalars['Decimal']>;
  section5Match?: Maybe<Scalars['String']>;
  section5PlantCnt?: Maybe<Scalars['Int']>;
  section5RoomNo?: Maybe<Scalars['Int']>;
  section5RoomNoNavigation?: Maybe<TblBatchRoom>;
  section5Trays?: Maybe<Scalars['Int']>;
  section5TraysLabeled?: Maybe<Scalars['String']>;
  section5WasteCollected?: Maybe<Scalars['String']>;
  section5WasteWeight?: Maybe<Scalars['Decimal']>;
  section6DryingCompleted?: Maybe<Scalars['String']>;
  section6ExtContWgt?: Maybe<Scalars['Decimal']>;
  section6ExtLabel?: Maybe<Scalars['String']>;
  section6ExtNetWgt?: Maybe<Scalars['Decimal']>;
  section6ExtTtlWgt?: Maybe<Scalars['Decimal']>;
  section6ExtractionPercent?: Maybe<Scalars['Decimal']>;
  section6FlowersHung?: Maybe<Scalars['String']>;
  section6NettingLabeled?: Maybe<Scalars['String']>;
  section6RawCannabis?: Maybe<Scalars['Decimal']>;
  section6RawContWgt?: Maybe<Scalars['Decimal']>;
  section6RawLabel?: Maybe<Scalars['String']>;
  section6RawNetWgt?: Maybe<Scalars['Decimal']>;
  section6RawTtlWgt?: Maybe<Scalars['Decimal']>;
  section6RoomNo?: Maybe<Scalars['Int']>;
  section6RoomNoNavigation?: Maybe<TblBatchRoom>;
  section7ContainerizedAndLabeled?: Maybe<Scalars['String']>;
  section7EquipmentCleaned?: Maybe<Scalars['String']>;
  section7EquipmentInspected?: Maybe<Scalars['String']>;
  section7ExtRoomNo?: Maybe<Scalars['Int']>;
  section7ExtRoomNoNavigation?: Maybe<TblBatchRoom>;
  section7LabAnalysisReportsUploaded?: Maybe<Scalars['String']>;
  section7LabCollection?: Maybe<Scalars['String']>;
  section7LabCollectionCompany?: Maybe<Scalars['String']>;
  section7LabPerson?: Maybe<Scalars['String']>;
  section7LabReportStatus?: Maybe<Scalars['String']>;
  section7LabReportStatusDate?: Maybe<Scalars['DateTime']>;
  section7PendingLabRoom?: Maybe<Scalars['Int']>;
  section7PendingLabRoomNavigation?: Maybe<TblBatchRoom>;
  section7RawEmptyContWgt?: Maybe<Scalars['Decimal']>;
  section7RawFilledContWgt?: Maybe<Scalars['Decimal']>;
  section7RawNetWgt?: Maybe<Scalars['Decimal']>;
  section7RawRoomNo?: Maybe<Scalars['Int']>;
  section7RawRoomNoNavigation?: Maybe<TblBatchRoom>;
  section7SampleLabeled?: Maybe<Scalars['String']>;
  section7SampleWeight?: Maybe<Scalars['Decimal']>;
  section7WasteDiscarded?: Maybe<Scalars['String']>;
  section8CapAndLabel?: Maybe<Scalars['String']>;
  section8EmptyBagWgt?: Maybe<Scalars['Decimal']>;
  section8FullBagWgt?: Maybe<Scalars['Decimal']>;
  section8LabelSpecimen?: Maybe<Scalars['String']>;
  section8NetWgt?: Maybe<Scalars['Decimal']>;
  section8PackageLabel?: Maybe<Scalars['String']>;
  section8PendingReleaseRoom?: Maybe<Scalars['Int']>;
  section8ProductReconciled?: Maybe<Scalars['String']>;
  section8Qasubmitted?: Maybe<Scalars['String']>;
  section8RoomNo?: Maybe<Scalars['Int']>;
  section8RoomNoNavigation?: Maybe<TblBatchRoom>;
  section8SampleNetWgt?: Maybe<Scalars['Decimal']>;
  section8WorkOrder?: Maybe<Scalars['String']>;
  sectionQastatus?: Maybe<Scalars['String']>;
  sectoin8LabelReconciled?: Maybe<Scalars['String']>;
  sfefillTankStartWgt?: Maybe<Scalars['Decimal']>;
  sfehomeTankStartWgt?: Maybe<Scalars['Decimal']>;
  sfenewFillTankStartWgt?: Maybe<Scalars['Decimal']>;
  sfeuser?: Maybe<Scalars['Int']>;
  sfeuserNavigation?: Maybe<TblAuthUser>;
  shakeWgt?: Maybe<Scalars['Decimal']>;
  sugarLeafDesc?: Maybe<Scalars['String']>;
  sugarLeafValue?: Maybe<Scalars['Decimal']>;
  tblBatchThcs?: Maybe<Array<Maybe<TblBatchThc>>>;
  tblMdbatchPlantIds?: Maybe<Array<Maybe<TblMdbatchPlantId>>>;
  tempActionType?: Maybe<Scalars['String']>;
  tempStepId?: Maybe<Scalars['Int']>;
  trimWasteWgt?: Maybe<Scalars['Decimal']>;
  wasteId?: Maybe<Scalars['Int']>;
  waterLeafDesc?: Maybe<Scalars['String']>;
  waterLeafValue?: Maybe<Scalars['Decimal']>;
  weightAfterDebrisRemoval?: Maybe<Scalars['Decimal']>;
  weightAfterGrinder?: Maybe<Scalars['Decimal']>;
  weightAfterSifting?: Maybe<Scalars['Decimal']>;
  wetLeafWaste?: Maybe<Scalars['Decimal']>;
  wetStemWaste?: Maybe<Scalars['Decimal']>;
  wetTrimWeight?: Maybe<Scalars['Decimal']>;
  wetWaste?: Maybe<Scalars['Decimal']>;
  wetWgt?: Maybe<Scalars['Decimal']>;
  whseTransId?: Maybe<Scalars['Int']>;
};


export type TblBatchTblBatchThcsArgs = {
  order?: InputMaybe<Array<TblBatchThcSortInput>>;
};

export type TblBatchCollectionSegment = {
  items?: Maybe<Array<Maybe<TblBatch>>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

export type TblBatchFilterInput = {
  and?: InputMaybe<Array<TblBatchFilterInput>>;
  appearance?: InputMaybe<StringOperationFilterInput>;
  aroma?: InputMaybe<StringOperationFilterInput>;
  assemblyOutputItems?: InputMaybe<ListFilterInputTypeOfAssemblyOutputItemFilterInput>;
  batchClosed?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  batchCurrentStep?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  batchIssuedBy?: InputMaybe<ComparableInt32OperationFilterInput>;
  batchIssuedByNavigation?: InputMaybe<TblAuthUserFilterInput>;
  batchIssuedDate?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  batchLotNumber?: InputMaybe<StringOperationFilterInput>;
  batchLsp?: InputMaybe<ComparableInt32OperationFilterInput>;
  batchLspLocation?: InputMaybe<ComparableInt32OperationFilterInput>;
  batchLspLocationNavigation?: InputMaybe<TblLspLocationFilterInput>;
  batchLspNavigation?: InputMaybe<TblLspFilterInput>;
  batchNo?: InputMaybe<StringOperationFilterInput>;
  batchSerialNumber?: InputMaybe<StringOperationFilterInput>;
  batchStrain?: InputMaybe<ComparableInt32OperationFilterInput>;
  batchStrainNavigation?: InputMaybe<TblBatchStrainFilterInput>;
  batchType?: InputMaybe<StringOperationFilterInput>;
  bioTcuredDtTm?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  bioTharvestedDtTm?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  bioTlotCreatedDtTm?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  bioTlotNo?: InputMaybe<StringOperationFilterInput>;
  bioTotherPlantMaterialLotCreatedDtTm?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  bioTotherPlantMaterialLotNo?: InputMaybe<StringOperationFilterInput>;
  bioTsubmittedToHarvestDtTm?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  brand?: InputMaybe<StringOperationFilterInput>;
  budSize?: InputMaybe<StringOperationFilterInput>;
  budYield?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  change?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  color?: InputMaybe<StringOperationFilterInput>;
  compianceMgrApproval?: InputMaybe<StringOperationFilterInput>;
  complianceApproval?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  complianceApprovalNavigation?: InputMaybe<TblAuthUserFilterInput>;
  cureDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  currentRoom?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  currentStatus?: InputMaybe<StringOperationFilterInput>;
  currentStatusDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  currentcount?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  density?: InputMaybe<StringOperationFilterInput>;
  dryLeafWaste?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  dryWgtPreTrim?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  excessWeightThatDidntFit?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  extractRawDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  extractRawType?: InputMaybe<StringOperationFilterInput>;
  femalesFailed?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  ffillTankFinishWgt?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  fhomeTankLost?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  fhotPlateTemp?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  fhotTankFinishWgt?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  finalInTakeWeight?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  fprePurgeWgt?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  ftotalTimeRan?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  fuser?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  fuserNavigation?: InputMaybe<TblAuthUserFilterInput>;
  fweight?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  growingApproval?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  growingApprovalNavigation?: InputMaybe<TblAuthUserFilterInput>;
  growingMgrApproval?: InputMaybe<StringOperationFilterInput>;
  harvestCompletedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  harvestReportingStage?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  harvestStartDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  harvestUnitId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  harvested?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  holdForExtractYield?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  homogenzationRoom?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  homogenzationRoomNavigation?: InputMaybe<TblBatchRoomFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  initialInTakeWgt?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  invBatchFlag?: InputMaybe<StringOperationFilterInput>;
  inverseMergeBatch?: InputMaybe<ListFilterInputTypeOfTblBatchFilterInput>;
  inverseMotherBatch?: InputMaybe<ListFilterInputTypeOfTblBatchFilterInput>;
  inverseSection2MotherStrainLotNoNavigation?: InputMaybe<ListFilterInputTypeOfTblBatchFilterInput>;
  itemNum?: InputMaybe<StringOperationFilterInput>;
  jointMaterialDesc?: InputMaybe<StringOperationFilterInput>;
  jointMaterialValue?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  kief?: InputMaybe<StringOperationFilterInput>;
  kiefDesc?: InputMaybe<StringOperationFilterInput>;
  kiefValue?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  lastCount?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  lastModifiedDateUtc?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  locBeforeDel?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  locDelDtTm?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  malePlantRemoved?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  mergeBatch?: InputMaybe<TblBatchFilterInput>;
  mergeBatchId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  mildYield?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  moistureContent?: InputMaybe<StringOperationFilterInput>;
  motherBatch?: InputMaybe<TblBatchFilterInput>;
  motherBatchId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  mothersRemoved?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  netBudWgt?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  netCount?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  nexStepDescription?: InputMaybe<StringOperationFilterInput>;
  nextStepFld?: InputMaybe<StringOperationFilterInput>;
  nextStepNo?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  nextStepTitle?: InputMaybe<StringOperationFilterInput>;
  notes1?: InputMaybe<StringOperationFilterInput>;
  notes2?: InputMaybe<StringOperationFilterInput>;
  notes3?: InputMaybe<StringOperationFilterInput>;
  notes4?: InputMaybe<StringOperationFilterInput>;
  nrOfPlants?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  or?: InputMaybe<Array<TblBatchFilterInput>>;
  otherPlantLotNo?: InputMaybe<StringOperationFilterInput>;
  packages?: InputMaybe<ListFilterInputTypeOfPackageFilterInput>;
  packagingApproval?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  packagingApprovalNavigation?: InputMaybe<TblAuthUserFilterInput>;
  packagingMgrApproval?: InputMaybe<StringOperationFilterInput>;
  postTrimWetWgt?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  productType?: InputMaybe<StringOperationFilterInput>;
  projectedHarvestDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  projectedYield?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  projectedYieldUnitId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  rextractorPsi?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  rextractorTemp?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  rfillTankStartWgt?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  rhomeTankStartWgt?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  rnewFillStartWgt?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  rseperatorPsi?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  rseperatorTemp?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  runNumber?: InputMaybe<StringOperationFilterInput>;
  ruser?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  saleabilityNotes?: InputMaybe<StringOperationFilterInput>;
  sectin6SupervisorContacted?: InputMaybe<StringOperationFilterInput>;
  section1PlantSeedlings?: InputMaybe<StringOperationFilterInput>;
  section1Preparecubes?: InputMaybe<StringOperationFilterInput>;
  section1RoomNo?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  section1RoomNoNavigation?: InputMaybe<TblBatchRoomFilterInput>;
  section1SeedCnt?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  section1SeedlingsCnt?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  section1SeedlingsRooted?: InputMaybe<StringOperationFilterInput>;
  section1TrayCnt?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  section1TraysLabeled?: InputMaybe<StringOperationFilterInput>;
  section2CloneMister?: InputMaybe<StringOperationFilterInput>;
  section2CloneStarts?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  section2ClonesRooted?: InputMaybe<StringOperationFilterInput>;
  section2CuttingsCnt?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  section2HormoneSolution?: InputMaybe<StringOperationFilterInput>;
  section2Mother?: InputMaybe<StringOperationFilterInput>;
  section2MotherPhenoType?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  section2MotherStrainLotNo?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  section2MotherStrainLotNoNavigation?: InputMaybe<TblBatchFilterInput>;
  section2PlantClones?: InputMaybe<StringOperationFilterInput>;
  section2RoomNo?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  section2RoomNoNavigation?: InputMaybe<TblBatchRoomFilterInput>;
  section2SuccessfulClonesCnt?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  section2TrayCnt?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  section2TraysLabeled?: InputMaybe<StringOperationFilterInput>;
  section3Match?: InputMaybe<StringOperationFilterInput>;
  section3Plant4by4Cubes?: InputMaybe<StringOperationFilterInput>;
  section3PlantCnt?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  section3RoomNo?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  section3RoomNoNavigation?: InputMaybe<TblBatchRoomFilterInput>;
  section3TrayCnt?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  section3WasteGrams?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  section4Match?: InputMaybe<StringOperationFilterInput>;
  section4PlantCnt?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  section4RoomNo?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  section4RoomNoNavigation?: InputMaybe<TblBatchRoomFilterInput>;
  section4TrayCnt?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  section4TraysLabeled?: InputMaybe<StringOperationFilterInput>;
  section4WasteGrams?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  section5FlowersWeight?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  section5HarvestWeight?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  section5Match?: InputMaybe<StringOperationFilterInput>;
  section5PlantCnt?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  section5RoomNo?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  section5RoomNoNavigation?: InputMaybe<TblBatchRoomFilterInput>;
  section5Trays?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  section5TraysLabeled?: InputMaybe<StringOperationFilterInput>;
  section5WasteCollected?: InputMaybe<StringOperationFilterInput>;
  section5WasteWeight?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  section6DryingCompleted?: InputMaybe<StringOperationFilterInput>;
  section6ExtContWgt?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  section6ExtLabel?: InputMaybe<StringOperationFilterInput>;
  section6ExtNetWgt?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  section6ExtTtlWgt?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  section6ExtractionPercent?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  section6FlowersHung?: InputMaybe<StringOperationFilterInput>;
  section6NettingLabeled?: InputMaybe<StringOperationFilterInput>;
  section6RawCannabis?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  section6RawContWgt?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  section6RawLabel?: InputMaybe<StringOperationFilterInput>;
  section6RawNetWgt?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  section6RawTtlWgt?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  section6RoomNo?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  section6RoomNoNavigation?: InputMaybe<TblBatchRoomFilterInput>;
  section7ContainerizedAndLabeled?: InputMaybe<StringOperationFilterInput>;
  section7EquipmentCleaned?: InputMaybe<StringOperationFilterInput>;
  section7EquipmentInspected?: InputMaybe<StringOperationFilterInput>;
  section7ExtRoomNo?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  section7ExtRoomNoNavigation?: InputMaybe<TblBatchRoomFilterInput>;
  section7LabAnalysisReportsUploaded?: InputMaybe<StringOperationFilterInput>;
  section7LabCollection?: InputMaybe<StringOperationFilterInput>;
  section7LabCollectionCompany?: InputMaybe<StringOperationFilterInput>;
  section7LabPerson?: InputMaybe<StringOperationFilterInput>;
  section7LabReportStatus?: InputMaybe<StringOperationFilterInput>;
  section7LabReportStatusDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  section7PendingLabRoom?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  section7PendingLabRoomNavigation?: InputMaybe<TblBatchRoomFilterInput>;
  section7RawEmptyContWgt?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  section7RawFilledContWgt?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  section7RawNetWgt?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  section7RawRoomNo?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  section7RawRoomNoNavigation?: InputMaybe<TblBatchRoomFilterInput>;
  section7SampleLabeled?: InputMaybe<StringOperationFilterInput>;
  section7SampleWeight?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  section7WasteDiscarded?: InputMaybe<StringOperationFilterInput>;
  section8CapAndLabel?: InputMaybe<StringOperationFilterInput>;
  section8EmptyBagWgt?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  section8FullBagWgt?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  section8LabelSpecimen?: InputMaybe<StringOperationFilterInput>;
  section8NetWgt?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  section8PackageLabel?: InputMaybe<StringOperationFilterInput>;
  section8PendingReleaseRoom?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  section8ProductReconciled?: InputMaybe<StringOperationFilterInput>;
  section8Qasubmitted?: InputMaybe<StringOperationFilterInput>;
  section8RoomNo?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  section8RoomNoNavigation?: InputMaybe<TblBatchRoomFilterInput>;
  section8SampleNetWgt?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  section8WorkOrder?: InputMaybe<StringOperationFilterInput>;
  sectionQastatus?: InputMaybe<StringOperationFilterInput>;
  sectoin8LabelReconciled?: InputMaybe<StringOperationFilterInput>;
  sfefillTankStartWgt?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  sfehomeTankStartWgt?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  sfenewFillTankStartWgt?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  sfeuser?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  sfeuserNavigation?: InputMaybe<TblAuthUserFilterInput>;
  shakeWgt?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  sugarLeafDesc?: InputMaybe<StringOperationFilterInput>;
  sugarLeafValue?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  tblBatchThcs?: InputMaybe<ListFilterInputTypeOfTblBatchThcFilterInput>;
  tblMdbatchPlantIds?: InputMaybe<ListFilterInputTypeOfTblMdbatchPlantIdFilterInput>;
  tempActionType?: InputMaybe<StringOperationFilterInput>;
  tempStepId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  trimWasteWgt?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  wasteId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  waterLeafDesc?: InputMaybe<StringOperationFilterInput>;
  waterLeafValue?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  weightAfterDebrisRemoval?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  weightAfterGrinder?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  weightAfterSifting?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  wetLeafWaste?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  wetStemWaste?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  wetTrimWeight?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  wetWaste?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  wetWgt?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  whseTransId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
};

export type TblBatchRoom = {
  addInfo?: Maybe<Scalars['String']>;
  assemblyOutputItems?: Maybe<Array<Maybe<AssemblyOutputItem>>>;
  bioTdeletedFlag?: Maybe<Scalars['String']>;
  bioTroomId?: Maybe<Scalars['Int']>;
  bioTtranIdOriginal?: Maybe<Scalars['Int']>;
  biotRoomIdPlant?: Maybe<Scalars['Int']>;
  car?: Maybe<TblMdcar>;
  checkOutRoom?: Maybe<Scalars['String']>;
  createdBy?: Maybe<Scalars['Int']>;
  createdDate?: Maybe<Scalars['DateTime']>;
  cultivationStage?: Maybe<Scalars['String']>;
  dispensaryLimitedroom?: Maybe<Scalars['String']>;
  dispensaryRestrictedRoom?: Maybe<Scalars['String']>;
  ecommerceRoom?: Maybe<Scalars['String']>;
  examRoom?: Maybe<Scalars['String']>;
  externalId?: Maybe<Scalars['String']>;
  fgrecons?: Maybe<Array<Maybe<Fgrecon>>>;
  id: Scalars['Int'];
  inspectionRoom?: Maybe<Scalars['String']>;
  inventoryAuditToRooms?: Maybe<Array<Maybe<InventoryAuditToRoom>>>;
  inventoryRoom?: Maybe<Scalars['String']>;
  isDeleted: Scalars['Boolean'];
  locId: Scalars['Int'];
  locationNavigation?: Maybe<TblLspLocation>;
  locationType?: Maybe<Scalars['String']>;
  lspId: Scalars['Int'];
  lspNavigation?: Maybe<TblLsp>;
  medicationRoom?: Maybe<Scalars['String']>;
  onHoldRoom?: Maybe<Scalars['String']>;
  packages?: Maybe<Array<Maybe<Package>>>;
  posRoom?: Maybe<Scalars['String']>;
  preOrderRoom?: Maybe<Scalars['String']>;
  publishToMenus: Scalars['Boolean'];
  quarantineRoom?: Maybe<Scalars['String']>;
  register?: Maybe<Scalars['Int']>;
  registerNavigation?: Maybe<MdPosTerminal>;
  room?: Maybe<PlantRoomHistory>;
  roomArea?: Maybe<Scalars['Decimal']>;
  roomAreaUnits?: Maybe<Scalars['String']>;
  roomNo: Scalars['String'];
  roomPurpose?: Maybe<Scalars['String']>;
  roomTerminals?: Maybe<Array<Maybe<RoomTerminal>>>;
  roomToMenus?: Maybe<Array<Maybe<RoomToMenu>>>;
  roomType?: Maybe<Scalars['String']>;
  squareFt?: Maybe<Scalars['Int']>;
  tblBatchHomogenzationRoomNavigations?: Maybe<Array<Maybe<TblBatch>>>;
  tblBatchSection1RoomNoNavigations?: Maybe<Array<Maybe<TblBatch>>>;
  tblBatchSection2RoomNoNavigations?: Maybe<Array<Maybe<TblBatch>>>;
  tblBatchSection3RoomNoNavigations?: Maybe<Array<Maybe<TblBatch>>>;
  tblBatchSection4RoomNoNavigations?: Maybe<Array<Maybe<TblBatch>>>;
  tblBatchSection5RoomNoNavigations?: Maybe<Array<Maybe<TblBatch>>>;
  tblBatchSection6RoomNoNavigations?: Maybe<Array<Maybe<TblBatch>>>;
  tblBatchSection7ExtRoomNoNavigations?: Maybe<Array<Maybe<TblBatch>>>;
  tblBatchSection7PendingLabRoomNavigations?: Maybe<Array<Maybe<TblBatch>>>;
  tblBatchSection7RawRoomNoNavigations?: Maybe<Array<Maybe<TblBatch>>>;
  tblBatchSection8RoomNoNavigations?: Maybe<Array<Maybe<TblBatch>>>;
  tblBatchTrays?: Maybe<Array<Maybe<TblBatchTray>>>;
  tblDispensarySchedules?: Maybe<Array<Maybe<TblDispensarySchedule>>>;
  tblMdbatchPlantIds?: Maybe<Array<Maybe<TblMdbatchPlantId>>>;
  updatedBy?: Maybe<Scalars['Int']>;
  updatedDate?: Maybe<Scalars['DateTime']>;
  vaultRoom?: Maybe<Scalars['String']>;
  waitingRoom?: Maybe<Scalars['String']>;
};

export type TblBatchRoomCollectionSegment = {
  items?: Maybe<Array<Maybe<TblBatchRoom>>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

export type TblBatchRoomFilterInput = {
  addInfo?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<TblBatchRoomFilterInput>>;
  assemblyOutputItems?: InputMaybe<ListFilterInputTypeOfAssemblyOutputItemFilterInput>;
  bioTdeletedFlag?: InputMaybe<StringOperationFilterInput>;
  bioTroomId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  bioTtranIdOriginal?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  biotRoomIdPlant?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  car?: InputMaybe<TblMdcarFilterInput>;
  checkOutRoom?: InputMaybe<StringOperationFilterInput>;
  createdBy?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  createdDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  cultivationStage?: InputMaybe<StringOperationFilterInput>;
  dispensaryLimitedroom?: InputMaybe<StringOperationFilterInput>;
  dispensaryRestrictedRoom?: InputMaybe<StringOperationFilterInput>;
  ecommerceRoom?: InputMaybe<StringOperationFilterInput>;
  examRoom?: InputMaybe<StringOperationFilterInput>;
  externalId?: InputMaybe<StringOperationFilterInput>;
  fgrecons?: InputMaybe<ListFilterInputTypeOfFgreconFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  inspectionRoom?: InputMaybe<StringOperationFilterInput>;
  inventoryAuditToRooms?: InputMaybe<ListFilterInputTypeOfInventoryAuditToRoomFilterInput>;
  inventoryRoom?: InputMaybe<StringOperationFilterInput>;
  isDeleted?: InputMaybe<BooleanOperationFilterInput>;
  locId?: InputMaybe<ComparableInt32OperationFilterInput>;
  locationNavigation?: InputMaybe<TblLspLocationFilterInput>;
  locationType?: InputMaybe<StringOperationFilterInput>;
  lspId?: InputMaybe<ComparableInt32OperationFilterInput>;
  lspNavigation?: InputMaybe<TblLspFilterInput>;
  medicationRoom?: InputMaybe<StringOperationFilterInput>;
  onHoldRoom?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<TblBatchRoomFilterInput>>;
  packages?: InputMaybe<ListFilterInputTypeOfPackageFilterInput>;
  posRoom?: InputMaybe<StringOperationFilterInput>;
  preOrderRoom?: InputMaybe<StringOperationFilterInput>;
  publishToMenus?: InputMaybe<BooleanOperationFilterInput>;
  quarantineRoom?: InputMaybe<StringOperationFilterInput>;
  register?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  registerNavigation?: InputMaybe<MdPosTerminalFilterInput>;
  room?: InputMaybe<PlantRoomHistoryFilterInput>;
  roomArea?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  roomAreaUnits?: InputMaybe<StringOperationFilterInput>;
  roomNo?: InputMaybe<StringOperationFilterInput>;
  roomPurpose?: InputMaybe<StringOperationFilterInput>;
  roomTerminals?: InputMaybe<ListFilterInputTypeOfRoomTerminalFilterInput>;
  roomToMenus?: InputMaybe<ListFilterInputTypeOfRoomToMenuFilterInput>;
  roomType?: InputMaybe<StringOperationFilterInput>;
  squareFt?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  tblBatchHomogenzationRoomNavigations?: InputMaybe<ListFilterInputTypeOfTblBatchFilterInput>;
  tblBatchSection1RoomNoNavigations?: InputMaybe<ListFilterInputTypeOfTblBatchFilterInput>;
  tblBatchSection2RoomNoNavigations?: InputMaybe<ListFilterInputTypeOfTblBatchFilterInput>;
  tblBatchSection3RoomNoNavigations?: InputMaybe<ListFilterInputTypeOfTblBatchFilterInput>;
  tblBatchSection4RoomNoNavigations?: InputMaybe<ListFilterInputTypeOfTblBatchFilterInput>;
  tblBatchSection5RoomNoNavigations?: InputMaybe<ListFilterInputTypeOfTblBatchFilterInput>;
  tblBatchSection6RoomNoNavigations?: InputMaybe<ListFilterInputTypeOfTblBatchFilterInput>;
  tblBatchSection7ExtRoomNoNavigations?: InputMaybe<ListFilterInputTypeOfTblBatchFilterInput>;
  tblBatchSection7PendingLabRoomNavigations?: InputMaybe<ListFilterInputTypeOfTblBatchFilterInput>;
  tblBatchSection7RawRoomNoNavigations?: InputMaybe<ListFilterInputTypeOfTblBatchFilterInput>;
  tblBatchSection8RoomNoNavigations?: InputMaybe<ListFilterInputTypeOfTblBatchFilterInput>;
  tblBatchTrays?: InputMaybe<ListFilterInputTypeOfTblBatchTrayFilterInput>;
  tblDispensarySchedules?: InputMaybe<ListFilterInputTypeOfTblDispensaryScheduleFilterInput>;
  tblMdbatchPlantIds?: InputMaybe<ListFilterInputTypeOfTblMdbatchPlantIdFilterInput>;
  updatedBy?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  updatedDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  vaultRoom?: InputMaybe<StringOperationFilterInput>;
  waitingRoom?: InputMaybe<StringOperationFilterInput>;
};

export type TblBatchRoomSortInput = {
  addInfo?: InputMaybe<SortEnumType>;
  bioTdeletedFlag?: InputMaybe<SortEnumType>;
  bioTroomId?: InputMaybe<SortEnumType>;
  bioTtranIdOriginal?: InputMaybe<SortEnumType>;
  biotRoomIdPlant?: InputMaybe<SortEnumType>;
  car?: InputMaybe<TblMdcarSortInput>;
  checkOutRoom?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  createdDate?: InputMaybe<SortEnumType>;
  cultivationStage?: InputMaybe<SortEnumType>;
  dispensaryLimitedroom?: InputMaybe<SortEnumType>;
  dispensaryRestrictedRoom?: InputMaybe<SortEnumType>;
  ecommerceRoom?: InputMaybe<SortEnumType>;
  examRoom?: InputMaybe<SortEnumType>;
  externalId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  inspectionRoom?: InputMaybe<SortEnumType>;
  inventoryRoom?: InputMaybe<SortEnumType>;
  isDeleted?: InputMaybe<SortEnumType>;
  locId?: InputMaybe<SortEnumType>;
  locationNavigation?: InputMaybe<TblLspLocationSortInput>;
  locationType?: InputMaybe<SortEnumType>;
  lspId?: InputMaybe<SortEnumType>;
  lspNavigation?: InputMaybe<TblLspSortInput>;
  medicationRoom?: InputMaybe<SortEnumType>;
  onHoldRoom?: InputMaybe<SortEnumType>;
  posRoom?: InputMaybe<SortEnumType>;
  preOrderRoom?: InputMaybe<SortEnumType>;
  publishToMenus?: InputMaybe<SortEnumType>;
  quarantineRoom?: InputMaybe<SortEnumType>;
  register?: InputMaybe<SortEnumType>;
  registerNavigation?: InputMaybe<MdPosTerminalSortInput>;
  room?: InputMaybe<PlantRoomHistorySortInput>;
  roomArea?: InputMaybe<SortEnumType>;
  roomAreaUnits?: InputMaybe<SortEnumType>;
  roomNo?: InputMaybe<SortEnumType>;
  roomPurpose?: InputMaybe<SortEnumType>;
  roomType?: InputMaybe<SortEnumType>;
  squareFt?: InputMaybe<SortEnumType>;
  updatedBy?: InputMaybe<SortEnumType>;
  updatedDate?: InputMaybe<SortEnumType>;
  vaultRoom?: InputMaybe<SortEnumType>;
  waitingRoom?: InputMaybe<SortEnumType>;
};

export type TblBatchSortInput = {
  appearance?: InputMaybe<SortEnumType>;
  aroma?: InputMaybe<SortEnumType>;
  batchClosed?: InputMaybe<SortEnumType>;
  batchCurrentStep?: InputMaybe<SortEnumType>;
  batchIssuedBy?: InputMaybe<SortEnumType>;
  batchIssuedByNavigation?: InputMaybe<TblAuthUserSortInput>;
  batchIssuedDate?: InputMaybe<SortEnumType>;
  batchLotNumber?: InputMaybe<SortEnumType>;
  batchLsp?: InputMaybe<SortEnumType>;
  batchLspLocation?: InputMaybe<SortEnumType>;
  batchLspLocationNavigation?: InputMaybe<TblLspLocationSortInput>;
  batchLspNavigation?: InputMaybe<TblLspSortInput>;
  batchNo?: InputMaybe<SortEnumType>;
  batchSerialNumber?: InputMaybe<SortEnumType>;
  batchStrain?: InputMaybe<SortEnumType>;
  batchStrainNavigation?: InputMaybe<TblBatchStrainSortInput>;
  batchType?: InputMaybe<SortEnumType>;
  bioTcuredDtTm?: InputMaybe<SortEnumType>;
  bioTharvestedDtTm?: InputMaybe<SortEnumType>;
  bioTlotCreatedDtTm?: InputMaybe<SortEnumType>;
  bioTlotNo?: InputMaybe<SortEnumType>;
  bioTotherPlantMaterialLotCreatedDtTm?: InputMaybe<SortEnumType>;
  bioTotherPlantMaterialLotNo?: InputMaybe<SortEnumType>;
  bioTsubmittedToHarvestDtTm?: InputMaybe<SortEnumType>;
  brand?: InputMaybe<SortEnumType>;
  budSize?: InputMaybe<SortEnumType>;
  budYield?: InputMaybe<SortEnumType>;
  change?: InputMaybe<SortEnumType>;
  color?: InputMaybe<SortEnumType>;
  compianceMgrApproval?: InputMaybe<SortEnumType>;
  complianceApproval?: InputMaybe<SortEnumType>;
  complianceApprovalNavigation?: InputMaybe<TblAuthUserSortInput>;
  cureDate?: InputMaybe<SortEnumType>;
  currentRoom?: InputMaybe<SortEnumType>;
  currentStatus?: InputMaybe<SortEnumType>;
  currentStatusDate?: InputMaybe<SortEnumType>;
  currentcount?: InputMaybe<SortEnumType>;
  density?: InputMaybe<SortEnumType>;
  dryLeafWaste?: InputMaybe<SortEnumType>;
  dryWgtPreTrim?: InputMaybe<SortEnumType>;
  excessWeightThatDidntFit?: InputMaybe<SortEnumType>;
  extractRawDate?: InputMaybe<SortEnumType>;
  extractRawType?: InputMaybe<SortEnumType>;
  femalesFailed?: InputMaybe<SortEnumType>;
  ffillTankFinishWgt?: InputMaybe<SortEnumType>;
  fhomeTankLost?: InputMaybe<SortEnumType>;
  fhotPlateTemp?: InputMaybe<SortEnumType>;
  fhotTankFinishWgt?: InputMaybe<SortEnumType>;
  finalInTakeWeight?: InputMaybe<SortEnumType>;
  fprePurgeWgt?: InputMaybe<SortEnumType>;
  ftotalTimeRan?: InputMaybe<SortEnumType>;
  fuser?: InputMaybe<SortEnumType>;
  fuserNavigation?: InputMaybe<TblAuthUserSortInput>;
  fweight?: InputMaybe<SortEnumType>;
  growingApproval?: InputMaybe<SortEnumType>;
  growingApprovalNavigation?: InputMaybe<TblAuthUserSortInput>;
  growingMgrApproval?: InputMaybe<SortEnumType>;
  harvestCompletedOn?: InputMaybe<SortEnumType>;
  harvestReportingStage?: InputMaybe<SortEnumType>;
  harvestStartDate?: InputMaybe<SortEnumType>;
  harvestUnitId?: InputMaybe<SortEnumType>;
  harvested?: InputMaybe<SortEnumType>;
  holdForExtractYield?: InputMaybe<SortEnumType>;
  homogenzationRoom?: InputMaybe<SortEnumType>;
  homogenzationRoomNavigation?: InputMaybe<TblBatchRoomSortInput>;
  id?: InputMaybe<SortEnumType>;
  initialInTakeWgt?: InputMaybe<SortEnumType>;
  invBatchFlag?: InputMaybe<SortEnumType>;
  itemNum?: InputMaybe<SortEnumType>;
  jointMaterialDesc?: InputMaybe<SortEnumType>;
  jointMaterialValue?: InputMaybe<SortEnumType>;
  kief?: InputMaybe<SortEnumType>;
  kiefDesc?: InputMaybe<SortEnumType>;
  kiefValue?: InputMaybe<SortEnumType>;
  lastCount?: InputMaybe<SortEnumType>;
  lastModifiedDateUtc?: InputMaybe<SortEnumType>;
  locBeforeDel?: InputMaybe<SortEnumType>;
  locDelDtTm?: InputMaybe<SortEnumType>;
  malePlantRemoved?: InputMaybe<SortEnumType>;
  mergeBatch?: InputMaybe<TblBatchSortInput>;
  mergeBatchId?: InputMaybe<SortEnumType>;
  mildYield?: InputMaybe<SortEnumType>;
  moistureContent?: InputMaybe<SortEnumType>;
  motherBatch?: InputMaybe<TblBatchSortInput>;
  motherBatchId?: InputMaybe<SortEnumType>;
  mothersRemoved?: InputMaybe<SortEnumType>;
  netBudWgt?: InputMaybe<SortEnumType>;
  netCount?: InputMaybe<SortEnumType>;
  nexStepDescription?: InputMaybe<SortEnumType>;
  nextStepFld?: InputMaybe<SortEnumType>;
  nextStepNo?: InputMaybe<SortEnumType>;
  nextStepTitle?: InputMaybe<SortEnumType>;
  notes1?: InputMaybe<SortEnumType>;
  notes2?: InputMaybe<SortEnumType>;
  notes3?: InputMaybe<SortEnumType>;
  notes4?: InputMaybe<SortEnumType>;
  nrOfPlants?: InputMaybe<SortEnumType>;
  otherPlantLotNo?: InputMaybe<SortEnumType>;
  packagingApproval?: InputMaybe<SortEnumType>;
  packagingApprovalNavigation?: InputMaybe<TblAuthUserSortInput>;
  packagingMgrApproval?: InputMaybe<SortEnumType>;
  postTrimWetWgt?: InputMaybe<SortEnumType>;
  productType?: InputMaybe<SortEnumType>;
  projectedHarvestDate?: InputMaybe<SortEnumType>;
  projectedYield?: InputMaybe<SortEnumType>;
  projectedYieldUnitId?: InputMaybe<SortEnumType>;
  rextractorPsi?: InputMaybe<SortEnumType>;
  rextractorTemp?: InputMaybe<SortEnumType>;
  rfillTankStartWgt?: InputMaybe<SortEnumType>;
  rhomeTankStartWgt?: InputMaybe<SortEnumType>;
  rnewFillStartWgt?: InputMaybe<SortEnumType>;
  rseperatorPsi?: InputMaybe<SortEnumType>;
  rseperatorTemp?: InputMaybe<SortEnumType>;
  runNumber?: InputMaybe<SortEnumType>;
  ruser?: InputMaybe<SortEnumType>;
  saleabilityNotes?: InputMaybe<SortEnumType>;
  sectin6SupervisorContacted?: InputMaybe<SortEnumType>;
  section1PlantSeedlings?: InputMaybe<SortEnumType>;
  section1Preparecubes?: InputMaybe<SortEnumType>;
  section1RoomNo?: InputMaybe<SortEnumType>;
  section1RoomNoNavigation?: InputMaybe<TblBatchRoomSortInput>;
  section1SeedCnt?: InputMaybe<SortEnumType>;
  section1SeedlingsCnt?: InputMaybe<SortEnumType>;
  section1SeedlingsRooted?: InputMaybe<SortEnumType>;
  section1TrayCnt?: InputMaybe<SortEnumType>;
  section1TraysLabeled?: InputMaybe<SortEnumType>;
  section2CloneMister?: InputMaybe<SortEnumType>;
  section2CloneStarts?: InputMaybe<SortEnumType>;
  section2ClonesRooted?: InputMaybe<SortEnumType>;
  section2CuttingsCnt?: InputMaybe<SortEnumType>;
  section2HormoneSolution?: InputMaybe<SortEnumType>;
  section2Mother?: InputMaybe<SortEnumType>;
  section2MotherPhenoType?: InputMaybe<SortEnumType>;
  section2MotherStrainLotNo?: InputMaybe<SortEnumType>;
  section2MotherStrainLotNoNavigation?: InputMaybe<TblBatchSortInput>;
  section2PlantClones?: InputMaybe<SortEnumType>;
  section2RoomNo?: InputMaybe<SortEnumType>;
  section2RoomNoNavigation?: InputMaybe<TblBatchRoomSortInput>;
  section2SuccessfulClonesCnt?: InputMaybe<SortEnumType>;
  section2TrayCnt?: InputMaybe<SortEnumType>;
  section2TraysLabeled?: InputMaybe<SortEnumType>;
  section3Match?: InputMaybe<SortEnumType>;
  section3Plant4by4Cubes?: InputMaybe<SortEnumType>;
  section3PlantCnt?: InputMaybe<SortEnumType>;
  section3RoomNo?: InputMaybe<SortEnumType>;
  section3RoomNoNavigation?: InputMaybe<TblBatchRoomSortInput>;
  section3TrayCnt?: InputMaybe<SortEnumType>;
  section3WasteGrams?: InputMaybe<SortEnumType>;
  section4Match?: InputMaybe<SortEnumType>;
  section4PlantCnt?: InputMaybe<SortEnumType>;
  section4RoomNo?: InputMaybe<SortEnumType>;
  section4RoomNoNavigation?: InputMaybe<TblBatchRoomSortInput>;
  section4TrayCnt?: InputMaybe<SortEnumType>;
  section4TraysLabeled?: InputMaybe<SortEnumType>;
  section4WasteGrams?: InputMaybe<SortEnumType>;
  section5FlowersWeight?: InputMaybe<SortEnumType>;
  section5HarvestWeight?: InputMaybe<SortEnumType>;
  section5Match?: InputMaybe<SortEnumType>;
  section5PlantCnt?: InputMaybe<SortEnumType>;
  section5RoomNo?: InputMaybe<SortEnumType>;
  section5RoomNoNavigation?: InputMaybe<TblBatchRoomSortInput>;
  section5Trays?: InputMaybe<SortEnumType>;
  section5TraysLabeled?: InputMaybe<SortEnumType>;
  section5WasteCollected?: InputMaybe<SortEnumType>;
  section5WasteWeight?: InputMaybe<SortEnumType>;
  section6DryingCompleted?: InputMaybe<SortEnumType>;
  section6ExtContWgt?: InputMaybe<SortEnumType>;
  section6ExtLabel?: InputMaybe<SortEnumType>;
  section6ExtNetWgt?: InputMaybe<SortEnumType>;
  section6ExtTtlWgt?: InputMaybe<SortEnumType>;
  section6ExtractionPercent?: InputMaybe<SortEnumType>;
  section6FlowersHung?: InputMaybe<SortEnumType>;
  section6NettingLabeled?: InputMaybe<SortEnumType>;
  section6RawCannabis?: InputMaybe<SortEnumType>;
  section6RawContWgt?: InputMaybe<SortEnumType>;
  section6RawLabel?: InputMaybe<SortEnumType>;
  section6RawNetWgt?: InputMaybe<SortEnumType>;
  section6RawTtlWgt?: InputMaybe<SortEnumType>;
  section6RoomNo?: InputMaybe<SortEnumType>;
  section6RoomNoNavigation?: InputMaybe<TblBatchRoomSortInput>;
  section7ContainerizedAndLabeled?: InputMaybe<SortEnumType>;
  section7EquipmentCleaned?: InputMaybe<SortEnumType>;
  section7EquipmentInspected?: InputMaybe<SortEnumType>;
  section7ExtRoomNo?: InputMaybe<SortEnumType>;
  section7ExtRoomNoNavigation?: InputMaybe<TblBatchRoomSortInput>;
  section7LabAnalysisReportsUploaded?: InputMaybe<SortEnumType>;
  section7LabCollection?: InputMaybe<SortEnumType>;
  section7LabCollectionCompany?: InputMaybe<SortEnumType>;
  section7LabPerson?: InputMaybe<SortEnumType>;
  section7LabReportStatus?: InputMaybe<SortEnumType>;
  section7LabReportStatusDate?: InputMaybe<SortEnumType>;
  section7PendingLabRoom?: InputMaybe<SortEnumType>;
  section7PendingLabRoomNavigation?: InputMaybe<TblBatchRoomSortInput>;
  section7RawEmptyContWgt?: InputMaybe<SortEnumType>;
  section7RawFilledContWgt?: InputMaybe<SortEnumType>;
  section7RawNetWgt?: InputMaybe<SortEnumType>;
  section7RawRoomNo?: InputMaybe<SortEnumType>;
  section7RawRoomNoNavigation?: InputMaybe<TblBatchRoomSortInput>;
  section7SampleLabeled?: InputMaybe<SortEnumType>;
  section7SampleWeight?: InputMaybe<SortEnumType>;
  section7WasteDiscarded?: InputMaybe<SortEnumType>;
  section8CapAndLabel?: InputMaybe<SortEnumType>;
  section8EmptyBagWgt?: InputMaybe<SortEnumType>;
  section8FullBagWgt?: InputMaybe<SortEnumType>;
  section8LabelSpecimen?: InputMaybe<SortEnumType>;
  section8NetWgt?: InputMaybe<SortEnumType>;
  section8PackageLabel?: InputMaybe<SortEnumType>;
  section8PendingReleaseRoom?: InputMaybe<SortEnumType>;
  section8ProductReconciled?: InputMaybe<SortEnumType>;
  section8Qasubmitted?: InputMaybe<SortEnumType>;
  section8RoomNo?: InputMaybe<SortEnumType>;
  section8RoomNoNavigation?: InputMaybe<TblBatchRoomSortInput>;
  section8SampleNetWgt?: InputMaybe<SortEnumType>;
  section8WorkOrder?: InputMaybe<SortEnumType>;
  sectionQastatus?: InputMaybe<SortEnumType>;
  sectoin8LabelReconciled?: InputMaybe<SortEnumType>;
  sfefillTankStartWgt?: InputMaybe<SortEnumType>;
  sfehomeTankStartWgt?: InputMaybe<SortEnumType>;
  sfenewFillTankStartWgt?: InputMaybe<SortEnumType>;
  sfeuser?: InputMaybe<SortEnumType>;
  sfeuserNavigation?: InputMaybe<TblAuthUserSortInput>;
  shakeWgt?: InputMaybe<SortEnumType>;
  sugarLeafDesc?: InputMaybe<SortEnumType>;
  sugarLeafValue?: InputMaybe<SortEnumType>;
  tempActionType?: InputMaybe<SortEnumType>;
  tempStepId?: InputMaybe<SortEnumType>;
  trimWasteWgt?: InputMaybe<SortEnumType>;
  wasteId?: InputMaybe<SortEnumType>;
  waterLeafDesc?: InputMaybe<SortEnumType>;
  waterLeafValue?: InputMaybe<SortEnumType>;
  weightAfterDebrisRemoval?: InputMaybe<SortEnumType>;
  weightAfterGrinder?: InputMaybe<SortEnumType>;
  weightAfterSifting?: InputMaybe<SortEnumType>;
  wetLeafWaste?: InputMaybe<SortEnumType>;
  wetStemWaste?: InputMaybe<SortEnumType>;
  wetTrimWeight?: InputMaybe<SortEnumType>;
  wetWaste?: InputMaybe<SortEnumType>;
  wetWgt?: InputMaybe<SortEnumType>;
  whseTransId?: InputMaybe<SortEnumType>;
};

export type TblBatchStrain = {
  createdBy?: Maybe<Scalars['Int']>;
  createdDate?: Maybe<Scalars['DateTime']>;
  discountStrainRestrictions?: Maybe<Array<Maybe<DiscountStrainRestriction>>>;
  externalId?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  isDeleted: Scalars['Boolean'];
  locBeforeDel?: Maybe<Scalars['Int']>;
  locDelDtTm?: Maybe<Scalars['DateTime']>;
  locId?: Maybe<Scalars['Int']>;
  lsp: Scalars['Int'];
  lspNavigation?: Maybe<TblLsp>;
  mdpricingHdrs?: Maybe<Array<Maybe<MdpricingHdr>>>;
  percentIndica?: Maybe<Scalars['Decimal']>;
  percentSativa?: Maybe<Scalars['Decimal']>;
  plantIdCnt?: Maybe<Scalars['Int']>;
  plantLabelDesignator?: Maybe<Scalars['String']>;
  strainDescription: Scalars['String'];
  strainName: Scalars['String'];
  strainNo?: Maybe<Scalars['String']>;
  strainType?: Maybe<Scalars['String']>;
  tblBatches?: Maybe<Array<Maybe<TblBatch>>>;
  tblMdbatchPlantIds?: Maybe<Array<Maybe<TblMdbatchPlantId>>>;
  tblWhseProducts?: Maybe<Array<Maybe<TblWhseProduct>>>;
};

export type TblBatchStrainCollectionSegment = {
  items?: Maybe<Array<Maybe<TblBatchStrain>>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

export type TblBatchStrainFilterInput = {
  and?: InputMaybe<Array<TblBatchStrainFilterInput>>;
  createdBy?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  createdDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  discountStrainRestrictions?: InputMaybe<ListFilterInputTypeOfDiscountStrainRestrictionFilterInput>;
  externalId?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  isDeleted?: InputMaybe<BooleanOperationFilterInput>;
  locBeforeDel?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  locDelDtTm?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  locId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  lsp?: InputMaybe<ComparableInt32OperationFilterInput>;
  lspNavigation?: InputMaybe<TblLspFilterInput>;
  mdpricingHdrs?: InputMaybe<ListFilterInputTypeOfMdpricingHdrFilterInput>;
  or?: InputMaybe<Array<TblBatchStrainFilterInput>>;
  percentIndica?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  percentSativa?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  plantIdCnt?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  plantLabelDesignator?: InputMaybe<StringOperationFilterInput>;
  strainDescription?: InputMaybe<StringOperationFilterInput>;
  strainName?: InputMaybe<StringOperationFilterInput>;
  strainNo?: InputMaybe<StringOperationFilterInput>;
  strainType?: InputMaybe<StringOperationFilterInput>;
  tblBatches?: InputMaybe<ListFilterInputTypeOfTblBatchFilterInput>;
  tblMdbatchPlantIds?: InputMaybe<ListFilterInputTypeOfTblMdbatchPlantIdFilterInput>;
  tblWhseProducts?: InputMaybe<ListFilterInputTypeOfTblWhseProductFilterInput>;
};

export type TblBatchStrainSortInput = {
  createdBy?: InputMaybe<SortEnumType>;
  createdDate?: InputMaybe<SortEnumType>;
  externalId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isDeleted?: InputMaybe<SortEnumType>;
  locBeforeDel?: InputMaybe<SortEnumType>;
  locDelDtTm?: InputMaybe<SortEnumType>;
  locId?: InputMaybe<SortEnumType>;
  lsp?: InputMaybe<SortEnumType>;
  lspNavigation?: InputMaybe<TblLspSortInput>;
  percentIndica?: InputMaybe<SortEnumType>;
  percentSativa?: InputMaybe<SortEnumType>;
  plantIdCnt?: InputMaybe<SortEnumType>;
  plantLabelDesignator?: InputMaybe<SortEnumType>;
  strainDescription?: InputMaybe<SortEnumType>;
  strainName?: InputMaybe<SortEnumType>;
  strainNo?: InputMaybe<SortEnumType>;
  strainType?: InputMaybe<SortEnumType>;
};

export type TblBatchThc = {
  alphaBisabololUnit?: Maybe<Scalars['Byte']>;
  alphaBisabololValue?: Maybe<Scalars['Decimal']>;
  alphaPhellandreneUnit?: Maybe<Scalars['Byte']>;
  alphaPhellandreneValue?: Maybe<Scalars['Decimal']>;
  alphaPineneUnit?: Maybe<Scalars['Int']>;
  alphaPineneValue?: Maybe<Scalars['Decimal']>;
  alphaTerpineneUnit?: Maybe<Scalars['Byte']>;
  alphaTerpineneValue?: Maybe<Scalars['Decimal']>;
  aplhaPinene?: Maybe<Scalars['String']>;
  batch?: Maybe<TblBatch>;
  batchId: Scalars['Int'];
  betaCaryphyllene?: Maybe<Scalars['String']>;
  betaCaryphylleneUnit?: Maybe<Scalars['Int']>;
  betaCaryphylleneValue?: Maybe<Scalars['Decimal']>;
  betaEudesmol?: Maybe<Scalars['String']>;
  betaEudesmolUnit?: Maybe<Scalars['Int']>;
  betaEudesmolValue?: Maybe<Scalars['Decimal']>;
  betaMyrcene?: Maybe<Scalars['String']>;
  betaMyrceneUnit?: Maybe<Scalars['Int']>;
  betaMyrceneValue?: Maybe<Scalars['Decimal']>;
  betaPinene?: Maybe<Scalars['String']>;
  betaPineneUnit?: Maybe<Scalars['Int']>;
  betaPineneValue?: Maybe<Scalars['Decimal']>;
  bisabolol?: Maybe<Scalars['String']>;
  bisabololUnit?: Maybe<Scalars['Int']>;
  bisabololValue?: Maybe<Scalars['Decimal']>;
  borneolUnit?: Maybe<Scalars['Byte']>;
  borneolValue?: Maybe<Scalars['Decimal']>;
  campheneUnit?: Maybe<Scalars['Byte']>;
  campheneValue?: Maybe<Scalars['Decimal']>;
  cannabanoid?: Maybe<Scalars['String']>;
  cannabanoidUnit?: Maybe<Scalars['Int']>;
  cannabanoidValue?: Maybe<Scalars['Decimal']>;
  caryophylleneOxide?: Maybe<Scalars['String']>;
  caryophylleneOxideUnit?: Maybe<Scalars['Int']>;
  caryophylleneOxideValue?: Maybe<Scalars['Decimal']>;
  cbc?: Maybe<Scalars['String']>;
  cbcUnit?: Maybe<Scalars['Int']>;
  cbcValue?: Maybe<Scalars['Decimal']>;
  cbca?: Maybe<Scalars['String']>;
  cbcaUnit?: Maybe<Scalars['Int']>;
  cbcaValue?: Maybe<Scalars['Decimal']>;
  cbcv?: Maybe<Scalars['String']>;
  cbcvUnit?: Maybe<Scalars['Int']>;
  cbcvValue?: Maybe<Scalars['Decimal']>;
  cbd?: Maybe<Scalars['String']>;
  cbdUnit?: Maybe<Scalars['Int']>;
  cbdValue?: Maybe<Scalars['Decimal']>;
  cbda?: Maybe<Scalars['String']>;
  cbdaUnit?: Maybe<Scalars['Int']>;
  cbdaValue?: Maybe<Scalars['Decimal']>;
  cbdml?: Maybe<Scalars['Decimal']>;
  cbdv?: Maybe<Scalars['String']>;
  cbdvUnit?: Maybe<Scalars['Int']>;
  cbdvValue?: Maybe<Scalars['Decimal']>;
  cbdva?: Maybe<Scalars['String']>;
  cbdvaUnit?: Maybe<Scalars['Int']>;
  cbdvaValue?: Maybe<Scalars['Decimal']>;
  cbg?: Maybe<Scalars['String']>;
  cbgUnit?: Maybe<Scalars['Int']>;
  cbgValue?: Maybe<Scalars['Decimal']>;
  cbga?: Maybe<Scalars['String']>;
  cbgaUnit?: Maybe<Scalars['Int']>;
  cbgaValue?: Maybe<Scalars['Decimal']>;
  cbl?: Maybe<Scalars['String']>;
  cblUnit?: Maybe<Scalars['Int']>;
  cblValue?: Maybe<Scalars['Decimal']>;
  cbla?: Maybe<Scalars['String']>;
  cblaUnit?: Maybe<Scalars['Int']>;
  cblaValue?: Maybe<Scalars['Decimal']>;
  cbn?: Maybe<Scalars['String']>;
  cbnUnit?: Maybe<Scalars['Int']>;
  cbnValue?: Maybe<Scalars['Decimal']>;
  cbna?: Maybe<Scalars['String']>;
  cbnaUnit?: Maybe<Scalars['Int']>;
  cbnaValue?: Maybe<Scalars['Decimal']>;
  cbt?: Maybe<Scalars['String']>;
  cbtUnit?: Maybe<Scalars['Int']>;
  cbtValue?: Maybe<Scalars['Decimal']>;
  checmicalResidue?: Maybe<Scalars['String']>;
  deltaTerpineneUnit?: Maybe<Scalars['Byte']>;
  deltaTerpineneValue?: Maybe<Scalars['Decimal']>;
  eucalyptolUnit?: Maybe<Scalars['Byte']>;
  eucalyptolValue?: Maybe<Scalars['Decimal']>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  extractionDate?: Maybe<Scalars['DateTime']>;
  farneseneUnit?: Maybe<Scalars['Byte']>;
  farneseneValue?: Maybe<Scalars['Decimal']>;
  fencholUnit?: Maybe<Scalars['Byte']>;
  fencholValue?: Maybe<Scalars['Decimal']>;
  flowerEquiv?: Maybe<Scalars['String']>;
  gammaTerpineneUnit?: Maybe<Scalars['Byte']>;
  gammaTerpineneValue?: Maybe<Scalars['Decimal']>;
  geraniolAcetateUnit?: Maybe<Scalars['Byte']>;
  geraniolAcetateValue?: Maybe<Scalars['Decimal']>;
  geraniolUnit?: Maybe<Scalars['Byte']>;
  geraniolValue?: Maybe<Scalars['Decimal']>;
  guaiol?: Maybe<Scalars['String']>;
  guaiolUnit?: Maybe<Scalars['Int']>;
  guaiolValue?: Maybe<Scalars['Decimal']>;
  heavyMetal?: Maybe<Scalars['String']>;
  humulene?: Maybe<Scalars['String']>;
  humuleneUnit?: Maybe<Scalars['Int']>;
  humuleneValue?: Maybe<Scalars['Decimal']>;
  id: Scalars['Int'];
  ingredientDetails?: Maybe<Scalars['String']>;
  isopulegolUnit?: Maybe<Scalars['Byte']>;
  isopulegolValue?: Maybe<Scalars['Decimal']>;
  labName?: Maybe<Scalars['String']>;
  labResultUrl?: Maybe<Scalars['String']>;
  limonene?: Maybe<Scalars['String']>;
  limoneneUnit?: Maybe<Scalars['Int']>;
  limoneneValue?: Maybe<Scalars['Decimal']>;
  linalool?: Maybe<Scalars['String']>;
  linaloolUnit?: Maybe<Scalars['Int']>;
  linaloolValue?: Maybe<Scalars['Decimal']>;
  lsp?: Maybe<TblLsp>;
  lspId?: Maybe<Scalars['Int']>;
  microbiology?: Maybe<Scalars['String']>;
  moistureAnalysis?: Maybe<Scalars['String']>;
  mycotoxin?: Maybe<Scalars['String']>;
  nerolUnit?: Maybe<Scalars['Byte']>;
  nerolValue?: Maybe<Scalars['Decimal']>;
  nerolidolTwoUnit?: Maybe<Scalars['Byte']>;
  nerolidolTwoValue?: Maybe<Scalars['Decimal']>;
  nerolidolUnit?: Maybe<Scalars['Byte']>;
  nerolidolValue?: Maybe<Scalars['Decimal']>;
  ocimene?: Maybe<Scalars['String']>;
  ocimeneOneUnit?: Maybe<Scalars['Byte']>;
  ocimeneOneValue?: Maybe<Scalars['Decimal']>;
  ocimeneTwoUnit?: Maybe<Scalars['Byte']>;
  ocimeneTwoValue?: Maybe<Scalars['Decimal']>;
  ocimeneUnit?: Maybe<Scalars['Int']>;
  ocimeneValue?: Maybe<Scalars['Decimal']>;
  other1?: Maybe<Scalars['String']>;
  other1Desc?: Maybe<Scalars['String']>;
  other2?: Maybe<Scalars['String']>;
  other2Desc?: Maybe<Scalars['String']>;
  other3?: Maybe<Scalars['String']>;
  other3Desc?: Maybe<Scalars['String']>;
  other4?: Maybe<Scalars['String']>;
  other4Desc?: Maybe<Scalars['String']>;
  pCymeneUnit?: Maybe<Scalars['Byte']>;
  pCymeneValue?: Maybe<Scalars['Decimal']>;
  pIsopropyltoulueneUnit?: Maybe<Scalars['Byte']>;
  pIsopropyltoulueneValue?: Maybe<Scalars['Decimal']>;
  packageDate?: Maybe<Scalars['DateTime']>;
  packageId?: Maybe<Scalars['Int']>;
  pesticides?: Maybe<Scalars['String']>;
  pesticidesUsed?: Maybe<Scalars['String']>;
  phytolUnit?: Maybe<Scalars['Byte']>;
  phytolValue?: Maybe<Scalars['Decimal']>;
  rawFlowerEquivalent?: Maybe<Scalars['Decimal']>;
  sabineneUnit?: Maybe<Scalars['Byte']>;
  sabineneValue?: Maybe<Scalars['Decimal']>;
  sampleWeight: Scalars['Decimal'];
  sampledPackageId?: Maybe<Scalars['String']>;
  solventResidue?: Maybe<Scalars['String']>;
  subLotId?: Maybe<Scalars['Int']>;
  sublotPackageId?: Maybe<Scalars['Int']>;
  tac?: Maybe<Scalars['String']>;
  tacUnit?: Maybe<Scalars['Int']>;
  tacValue?: Maybe<Scalars['Decimal']>;
  tchDate?: Maybe<Scalars['DateTime']>;
  terpinene?: Maybe<Scalars['String']>;
  terpineneUnit?: Maybe<Scalars['Int']>;
  terpineneValue?: Maybe<Scalars['Decimal']>;
  terpineolUnit?: Maybe<Scalars['Byte']>;
  terpineolValue?: Maybe<Scalars['Decimal']>;
  terpinolene?: Maybe<Scalars['String']>;
  terpinoleneUnit?: Maybe<Scalars['Int']>;
  terpinoleneValue?: Maybe<Scalars['Decimal']>;
  testedDate?: Maybe<Scalars['DateTime']>;
  thc?: Maybe<Scalars['String']>;
  thc8?: Maybe<Scalars['String']>;
  thc8Unit?: Maybe<Scalars['Int']>;
  thc8Value?: Maybe<Scalars['Decimal']>;
  thc9?: Maybe<Scalars['String']>;
  thc9Unit?: Maybe<Scalars['Int']>;
  thc9Value?: Maybe<Scalars['Decimal']>;
  thc10Unit?: Maybe<Scalars['Byte']>;
  thc10Value?: Maybe<Scalars['Decimal']>;
  thcBy?: Maybe<Scalars['Int']>;
  thcByNavigation?: Maybe<TblAuthUser>;
  thcUnit?: Maybe<Scalars['Int']>;
  thcValue?: Maybe<Scalars['Decimal']>;
  thca?: Maybe<Scalars['String']>;
  thcaUnit?: Maybe<Scalars['Int']>;
  thcaValue?: Maybe<Scalars['Decimal']>;
  thcml?: Maybe<Scalars['Decimal']>;
  thctcc?: Maybe<Scalars['String']>;
  thcv?: Maybe<Scalars['String']>;
  thcvUnit?: Maybe<Scalars['Int']>;
  thcvValue?: Maybe<Scalars['Decimal']>;
  thcva?: Maybe<Scalars['String']>;
  thcvaUnit?: Maybe<Scalars['Int']>;
  thcvaValue?: Maybe<Scalars['Decimal']>;
  threeCarene?: Maybe<Scalars['String']>;
  threeCareneUnit?: Maybe<Scalars['Int']>;
  threeCareneValue?: Maybe<Scalars['Decimal']>;
  totalCannabinoidsUnit?: Maybe<Scalars['Byte']>;
  totalCannabinoidsValue?: Maybe<Scalars['Decimal']>;
  totalTerpenesUnit?: Maybe<Scalars['Byte']>;
  totalTerpenesValue?: Maybe<Scalars['Decimal']>;
  transNerolidol?: Maybe<Scalars['String']>;
  transNerolidolUnit?: Maybe<Scalars['Int']>;
  transNerolidolValue?: Maybe<Scalars['Decimal']>;
  valenceneUnit?: Maybe<Scalars['Byte']>;
  valenceneValue?: Maybe<Scalars['Decimal']>;
  visualInspection?: Maybe<Scalars['String']>;
  yTerpineneUnit?: Maybe<Scalars['Byte']>;
  yTerpineneValue?: Maybe<Scalars['Decimal']>;
};

export type TblBatchThcCollectionSegment = {
  items?: Maybe<Array<Maybe<TblBatchThc>>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

export type TblBatchThcFilterInput = {
  alphaBisabololUnit?: InputMaybe<ComparableNullableOfByteOperationFilterInput>;
  alphaBisabololValue?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  alphaPhellandreneUnit?: InputMaybe<ComparableNullableOfByteOperationFilterInput>;
  alphaPhellandreneValue?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  alphaPineneUnit?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  alphaPineneValue?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  alphaTerpineneUnit?: InputMaybe<ComparableNullableOfByteOperationFilterInput>;
  alphaTerpineneValue?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  and?: InputMaybe<Array<TblBatchThcFilterInput>>;
  aplhaPinene?: InputMaybe<StringOperationFilterInput>;
  batch?: InputMaybe<TblBatchFilterInput>;
  batchId?: InputMaybe<ComparableInt32OperationFilterInput>;
  betaCaryphyllene?: InputMaybe<StringOperationFilterInput>;
  betaCaryphylleneUnit?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  betaCaryphylleneValue?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  betaEudesmol?: InputMaybe<StringOperationFilterInput>;
  betaEudesmolUnit?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  betaEudesmolValue?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  betaMyrcene?: InputMaybe<StringOperationFilterInput>;
  betaMyrceneUnit?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  betaMyrceneValue?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  betaPinene?: InputMaybe<StringOperationFilterInput>;
  betaPineneUnit?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  betaPineneValue?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  bisabolol?: InputMaybe<StringOperationFilterInput>;
  bisabololUnit?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  bisabololValue?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  borneolUnit?: InputMaybe<ComparableNullableOfByteOperationFilterInput>;
  borneolValue?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  campheneUnit?: InputMaybe<ComparableNullableOfByteOperationFilterInput>;
  campheneValue?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  cannabanoid?: InputMaybe<StringOperationFilterInput>;
  cannabanoidUnit?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  cannabanoidValue?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  caryophylleneOxide?: InputMaybe<StringOperationFilterInput>;
  caryophylleneOxideUnit?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  caryophylleneOxideValue?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  cbc?: InputMaybe<StringOperationFilterInput>;
  cbcUnit?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  cbcValue?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  cbca?: InputMaybe<StringOperationFilterInput>;
  cbcaUnit?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  cbcaValue?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  cbcv?: InputMaybe<StringOperationFilterInput>;
  cbcvUnit?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  cbcvValue?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  cbd?: InputMaybe<StringOperationFilterInput>;
  cbdUnit?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  cbdValue?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  cbda?: InputMaybe<StringOperationFilterInput>;
  cbdaUnit?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  cbdaValue?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  cbdml?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  cbdv?: InputMaybe<StringOperationFilterInput>;
  cbdvUnit?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  cbdvValue?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  cbdva?: InputMaybe<StringOperationFilterInput>;
  cbdvaUnit?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  cbdvaValue?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  cbg?: InputMaybe<StringOperationFilterInput>;
  cbgUnit?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  cbgValue?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  cbga?: InputMaybe<StringOperationFilterInput>;
  cbgaUnit?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  cbgaValue?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  cbl?: InputMaybe<StringOperationFilterInput>;
  cblUnit?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  cblValue?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  cbla?: InputMaybe<StringOperationFilterInput>;
  cblaUnit?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  cblaValue?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  cbn?: InputMaybe<StringOperationFilterInput>;
  cbnUnit?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  cbnValue?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  cbna?: InputMaybe<StringOperationFilterInput>;
  cbnaUnit?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  cbnaValue?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  cbt?: InputMaybe<StringOperationFilterInput>;
  cbtUnit?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  cbtValue?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  checmicalResidue?: InputMaybe<StringOperationFilterInput>;
  deltaTerpineneUnit?: InputMaybe<ComparableNullableOfByteOperationFilterInput>;
  deltaTerpineneValue?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  eucalyptolUnit?: InputMaybe<ComparableNullableOfByteOperationFilterInput>;
  eucalyptolValue?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  expirationDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  extractionDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  farneseneUnit?: InputMaybe<ComparableNullableOfByteOperationFilterInput>;
  farneseneValue?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  fencholUnit?: InputMaybe<ComparableNullableOfByteOperationFilterInput>;
  fencholValue?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  flowerEquiv?: InputMaybe<StringOperationFilterInput>;
  gammaTerpineneUnit?: InputMaybe<ComparableNullableOfByteOperationFilterInput>;
  gammaTerpineneValue?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  geraniolAcetateUnit?: InputMaybe<ComparableNullableOfByteOperationFilterInput>;
  geraniolAcetateValue?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  geraniolUnit?: InputMaybe<ComparableNullableOfByteOperationFilterInput>;
  geraniolValue?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  guaiol?: InputMaybe<StringOperationFilterInput>;
  guaiolUnit?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  guaiolValue?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  heavyMetal?: InputMaybe<StringOperationFilterInput>;
  humulene?: InputMaybe<StringOperationFilterInput>;
  humuleneUnit?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  humuleneValue?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  ingredientDetails?: InputMaybe<StringOperationFilterInput>;
  isopulegolUnit?: InputMaybe<ComparableNullableOfByteOperationFilterInput>;
  isopulegolValue?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  labName?: InputMaybe<StringOperationFilterInput>;
  labResultUrl?: InputMaybe<StringOperationFilterInput>;
  limonene?: InputMaybe<StringOperationFilterInput>;
  limoneneUnit?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  limoneneValue?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  linalool?: InputMaybe<StringOperationFilterInput>;
  linaloolUnit?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  linaloolValue?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  lsp?: InputMaybe<TblLspFilterInput>;
  lspId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  microbiology?: InputMaybe<StringOperationFilterInput>;
  moistureAnalysis?: InputMaybe<StringOperationFilterInput>;
  mycotoxin?: InputMaybe<StringOperationFilterInput>;
  nerolUnit?: InputMaybe<ComparableNullableOfByteOperationFilterInput>;
  nerolValue?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  nerolidolTwoUnit?: InputMaybe<ComparableNullableOfByteOperationFilterInput>;
  nerolidolTwoValue?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  nerolidolUnit?: InputMaybe<ComparableNullableOfByteOperationFilterInput>;
  nerolidolValue?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  ocimene?: InputMaybe<StringOperationFilterInput>;
  ocimeneOneUnit?: InputMaybe<ComparableNullableOfByteOperationFilterInput>;
  ocimeneOneValue?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  ocimeneTwoUnit?: InputMaybe<ComparableNullableOfByteOperationFilterInput>;
  ocimeneTwoValue?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  ocimeneUnit?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  ocimeneValue?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  or?: InputMaybe<Array<TblBatchThcFilterInput>>;
  other1?: InputMaybe<StringOperationFilterInput>;
  other1Desc?: InputMaybe<StringOperationFilterInput>;
  other2?: InputMaybe<StringOperationFilterInput>;
  other2Desc?: InputMaybe<StringOperationFilterInput>;
  other3?: InputMaybe<StringOperationFilterInput>;
  other3Desc?: InputMaybe<StringOperationFilterInput>;
  other4?: InputMaybe<StringOperationFilterInput>;
  other4Desc?: InputMaybe<StringOperationFilterInput>;
  pCymeneUnit?: InputMaybe<ComparableNullableOfByteOperationFilterInput>;
  pCymeneValue?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  pIsopropyltoulueneUnit?: InputMaybe<ComparableNullableOfByteOperationFilterInput>;
  pIsopropyltoulueneValue?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  packageDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  packageId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  pesticides?: InputMaybe<StringOperationFilterInput>;
  pesticidesUsed?: InputMaybe<StringOperationFilterInput>;
  phytolUnit?: InputMaybe<ComparableNullableOfByteOperationFilterInput>;
  phytolValue?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  rawFlowerEquivalent?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  sabineneUnit?: InputMaybe<ComparableNullableOfByteOperationFilterInput>;
  sabineneValue?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  sampleWeight?: InputMaybe<ComparableDecimalOperationFilterInput>;
  sampledPackageId?: InputMaybe<StringOperationFilterInput>;
  solventResidue?: InputMaybe<StringOperationFilterInput>;
  subLotId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  sublotPackageId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  tac?: InputMaybe<StringOperationFilterInput>;
  tacUnit?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  tacValue?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  tchDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  terpinene?: InputMaybe<StringOperationFilterInput>;
  terpineneUnit?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  terpineneValue?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  terpineolUnit?: InputMaybe<ComparableNullableOfByteOperationFilterInput>;
  terpineolValue?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  terpinolene?: InputMaybe<StringOperationFilterInput>;
  terpinoleneUnit?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  terpinoleneValue?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  testedDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  thc?: InputMaybe<StringOperationFilterInput>;
  thc8?: InputMaybe<StringOperationFilterInput>;
  thc8Unit?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  thc8Value?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  thc9?: InputMaybe<StringOperationFilterInput>;
  thc9Unit?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  thc9Value?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  thc10Unit?: InputMaybe<ComparableNullableOfByteOperationFilterInput>;
  thc10Value?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  thcBy?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  thcByNavigation?: InputMaybe<TblAuthUserFilterInput>;
  thcUnit?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  thcValue?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  thca?: InputMaybe<StringOperationFilterInput>;
  thcaUnit?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  thcaValue?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  thcml?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  thctcc?: InputMaybe<StringOperationFilterInput>;
  thcv?: InputMaybe<StringOperationFilterInput>;
  thcvUnit?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  thcvValue?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  thcva?: InputMaybe<StringOperationFilterInput>;
  thcvaUnit?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  thcvaValue?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  threeCarene?: InputMaybe<StringOperationFilterInput>;
  threeCareneUnit?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  threeCareneValue?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  totalCannabinoidsUnit?: InputMaybe<ComparableNullableOfByteOperationFilterInput>;
  totalCannabinoidsValue?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  totalTerpenesUnit?: InputMaybe<ComparableNullableOfByteOperationFilterInput>;
  totalTerpenesValue?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  transNerolidol?: InputMaybe<StringOperationFilterInput>;
  transNerolidolUnit?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  transNerolidolValue?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  valenceneUnit?: InputMaybe<ComparableNullableOfByteOperationFilterInput>;
  valenceneValue?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  visualInspection?: InputMaybe<StringOperationFilterInput>;
  yTerpineneUnit?: InputMaybe<ComparableNullableOfByteOperationFilterInput>;
  yTerpineneValue?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
};

export type TblBatchThcSortInput = {
  alphaBisabololUnit?: InputMaybe<SortEnumType>;
  alphaBisabololValue?: InputMaybe<SortEnumType>;
  alphaPhellandreneUnit?: InputMaybe<SortEnumType>;
  alphaPhellandreneValue?: InputMaybe<SortEnumType>;
  alphaPineneUnit?: InputMaybe<SortEnumType>;
  alphaPineneValue?: InputMaybe<SortEnumType>;
  alphaTerpineneUnit?: InputMaybe<SortEnumType>;
  alphaTerpineneValue?: InputMaybe<SortEnumType>;
  aplhaPinene?: InputMaybe<SortEnumType>;
  batch?: InputMaybe<TblBatchSortInput>;
  batchId?: InputMaybe<SortEnumType>;
  betaCaryphyllene?: InputMaybe<SortEnumType>;
  betaCaryphylleneUnit?: InputMaybe<SortEnumType>;
  betaCaryphylleneValue?: InputMaybe<SortEnumType>;
  betaEudesmol?: InputMaybe<SortEnumType>;
  betaEudesmolUnit?: InputMaybe<SortEnumType>;
  betaEudesmolValue?: InputMaybe<SortEnumType>;
  betaMyrcene?: InputMaybe<SortEnumType>;
  betaMyrceneUnit?: InputMaybe<SortEnumType>;
  betaMyrceneValue?: InputMaybe<SortEnumType>;
  betaPinene?: InputMaybe<SortEnumType>;
  betaPineneUnit?: InputMaybe<SortEnumType>;
  betaPineneValue?: InputMaybe<SortEnumType>;
  bisabolol?: InputMaybe<SortEnumType>;
  bisabololUnit?: InputMaybe<SortEnumType>;
  bisabololValue?: InputMaybe<SortEnumType>;
  borneolUnit?: InputMaybe<SortEnumType>;
  borneolValue?: InputMaybe<SortEnumType>;
  campheneUnit?: InputMaybe<SortEnumType>;
  campheneValue?: InputMaybe<SortEnumType>;
  cannabanoid?: InputMaybe<SortEnumType>;
  cannabanoidUnit?: InputMaybe<SortEnumType>;
  cannabanoidValue?: InputMaybe<SortEnumType>;
  caryophylleneOxide?: InputMaybe<SortEnumType>;
  caryophylleneOxideUnit?: InputMaybe<SortEnumType>;
  caryophylleneOxideValue?: InputMaybe<SortEnumType>;
  cbc?: InputMaybe<SortEnumType>;
  cbcUnit?: InputMaybe<SortEnumType>;
  cbcValue?: InputMaybe<SortEnumType>;
  cbca?: InputMaybe<SortEnumType>;
  cbcaUnit?: InputMaybe<SortEnumType>;
  cbcaValue?: InputMaybe<SortEnumType>;
  cbcv?: InputMaybe<SortEnumType>;
  cbcvUnit?: InputMaybe<SortEnumType>;
  cbcvValue?: InputMaybe<SortEnumType>;
  cbd?: InputMaybe<SortEnumType>;
  cbdUnit?: InputMaybe<SortEnumType>;
  cbdValue?: InputMaybe<SortEnumType>;
  cbda?: InputMaybe<SortEnumType>;
  cbdaUnit?: InputMaybe<SortEnumType>;
  cbdaValue?: InputMaybe<SortEnumType>;
  cbdml?: InputMaybe<SortEnumType>;
  cbdv?: InputMaybe<SortEnumType>;
  cbdvUnit?: InputMaybe<SortEnumType>;
  cbdvValue?: InputMaybe<SortEnumType>;
  cbdva?: InputMaybe<SortEnumType>;
  cbdvaUnit?: InputMaybe<SortEnumType>;
  cbdvaValue?: InputMaybe<SortEnumType>;
  cbg?: InputMaybe<SortEnumType>;
  cbgUnit?: InputMaybe<SortEnumType>;
  cbgValue?: InputMaybe<SortEnumType>;
  cbga?: InputMaybe<SortEnumType>;
  cbgaUnit?: InputMaybe<SortEnumType>;
  cbgaValue?: InputMaybe<SortEnumType>;
  cbl?: InputMaybe<SortEnumType>;
  cblUnit?: InputMaybe<SortEnumType>;
  cblValue?: InputMaybe<SortEnumType>;
  cbla?: InputMaybe<SortEnumType>;
  cblaUnit?: InputMaybe<SortEnumType>;
  cblaValue?: InputMaybe<SortEnumType>;
  cbn?: InputMaybe<SortEnumType>;
  cbnUnit?: InputMaybe<SortEnumType>;
  cbnValue?: InputMaybe<SortEnumType>;
  cbna?: InputMaybe<SortEnumType>;
  cbnaUnit?: InputMaybe<SortEnumType>;
  cbnaValue?: InputMaybe<SortEnumType>;
  cbt?: InputMaybe<SortEnumType>;
  cbtUnit?: InputMaybe<SortEnumType>;
  cbtValue?: InputMaybe<SortEnumType>;
  checmicalResidue?: InputMaybe<SortEnumType>;
  deltaTerpineneUnit?: InputMaybe<SortEnumType>;
  deltaTerpineneValue?: InputMaybe<SortEnumType>;
  eucalyptolUnit?: InputMaybe<SortEnumType>;
  eucalyptolValue?: InputMaybe<SortEnumType>;
  expirationDate?: InputMaybe<SortEnumType>;
  extractionDate?: InputMaybe<SortEnumType>;
  farneseneUnit?: InputMaybe<SortEnumType>;
  farneseneValue?: InputMaybe<SortEnumType>;
  fencholUnit?: InputMaybe<SortEnumType>;
  fencholValue?: InputMaybe<SortEnumType>;
  flowerEquiv?: InputMaybe<SortEnumType>;
  gammaTerpineneUnit?: InputMaybe<SortEnumType>;
  gammaTerpineneValue?: InputMaybe<SortEnumType>;
  geraniolAcetateUnit?: InputMaybe<SortEnumType>;
  geraniolAcetateValue?: InputMaybe<SortEnumType>;
  geraniolUnit?: InputMaybe<SortEnumType>;
  geraniolValue?: InputMaybe<SortEnumType>;
  guaiol?: InputMaybe<SortEnumType>;
  guaiolUnit?: InputMaybe<SortEnumType>;
  guaiolValue?: InputMaybe<SortEnumType>;
  heavyMetal?: InputMaybe<SortEnumType>;
  humulene?: InputMaybe<SortEnumType>;
  humuleneUnit?: InputMaybe<SortEnumType>;
  humuleneValue?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  ingredientDetails?: InputMaybe<SortEnumType>;
  isopulegolUnit?: InputMaybe<SortEnumType>;
  isopulegolValue?: InputMaybe<SortEnumType>;
  labName?: InputMaybe<SortEnumType>;
  labResultUrl?: InputMaybe<SortEnumType>;
  limonene?: InputMaybe<SortEnumType>;
  limoneneUnit?: InputMaybe<SortEnumType>;
  limoneneValue?: InputMaybe<SortEnumType>;
  linalool?: InputMaybe<SortEnumType>;
  linaloolUnit?: InputMaybe<SortEnumType>;
  linaloolValue?: InputMaybe<SortEnumType>;
  lsp?: InputMaybe<TblLspSortInput>;
  lspId?: InputMaybe<SortEnumType>;
  microbiology?: InputMaybe<SortEnumType>;
  moistureAnalysis?: InputMaybe<SortEnumType>;
  mycotoxin?: InputMaybe<SortEnumType>;
  nerolUnit?: InputMaybe<SortEnumType>;
  nerolValue?: InputMaybe<SortEnumType>;
  nerolidolTwoUnit?: InputMaybe<SortEnumType>;
  nerolidolTwoValue?: InputMaybe<SortEnumType>;
  nerolidolUnit?: InputMaybe<SortEnumType>;
  nerolidolValue?: InputMaybe<SortEnumType>;
  ocimene?: InputMaybe<SortEnumType>;
  ocimeneOneUnit?: InputMaybe<SortEnumType>;
  ocimeneOneValue?: InputMaybe<SortEnumType>;
  ocimeneTwoUnit?: InputMaybe<SortEnumType>;
  ocimeneTwoValue?: InputMaybe<SortEnumType>;
  ocimeneUnit?: InputMaybe<SortEnumType>;
  ocimeneValue?: InputMaybe<SortEnumType>;
  other1?: InputMaybe<SortEnumType>;
  other1Desc?: InputMaybe<SortEnumType>;
  other2?: InputMaybe<SortEnumType>;
  other2Desc?: InputMaybe<SortEnumType>;
  other3?: InputMaybe<SortEnumType>;
  other3Desc?: InputMaybe<SortEnumType>;
  other4?: InputMaybe<SortEnumType>;
  other4Desc?: InputMaybe<SortEnumType>;
  pCymeneUnit?: InputMaybe<SortEnumType>;
  pCymeneValue?: InputMaybe<SortEnumType>;
  pIsopropyltoulueneUnit?: InputMaybe<SortEnumType>;
  pIsopropyltoulueneValue?: InputMaybe<SortEnumType>;
  packageDate?: InputMaybe<SortEnumType>;
  packageId?: InputMaybe<SortEnumType>;
  pesticides?: InputMaybe<SortEnumType>;
  pesticidesUsed?: InputMaybe<SortEnumType>;
  phytolUnit?: InputMaybe<SortEnumType>;
  phytolValue?: InputMaybe<SortEnumType>;
  rawFlowerEquivalent?: InputMaybe<SortEnumType>;
  sabineneUnit?: InputMaybe<SortEnumType>;
  sabineneValue?: InputMaybe<SortEnumType>;
  sampleWeight?: InputMaybe<SortEnumType>;
  sampledPackageId?: InputMaybe<SortEnumType>;
  solventResidue?: InputMaybe<SortEnumType>;
  subLotId?: InputMaybe<SortEnumType>;
  sublotPackageId?: InputMaybe<SortEnumType>;
  tac?: InputMaybe<SortEnumType>;
  tacUnit?: InputMaybe<SortEnumType>;
  tacValue?: InputMaybe<SortEnumType>;
  tchDate?: InputMaybe<SortEnumType>;
  terpinene?: InputMaybe<SortEnumType>;
  terpineneUnit?: InputMaybe<SortEnumType>;
  terpineneValue?: InputMaybe<SortEnumType>;
  terpineolUnit?: InputMaybe<SortEnumType>;
  terpineolValue?: InputMaybe<SortEnumType>;
  terpinolene?: InputMaybe<SortEnumType>;
  terpinoleneUnit?: InputMaybe<SortEnumType>;
  terpinoleneValue?: InputMaybe<SortEnumType>;
  testedDate?: InputMaybe<SortEnumType>;
  thc?: InputMaybe<SortEnumType>;
  thc8?: InputMaybe<SortEnumType>;
  thc8Unit?: InputMaybe<SortEnumType>;
  thc8Value?: InputMaybe<SortEnumType>;
  thc9?: InputMaybe<SortEnumType>;
  thc9Unit?: InputMaybe<SortEnumType>;
  thc9Value?: InputMaybe<SortEnumType>;
  thc10Unit?: InputMaybe<SortEnumType>;
  thc10Value?: InputMaybe<SortEnumType>;
  thcBy?: InputMaybe<SortEnumType>;
  thcByNavigation?: InputMaybe<TblAuthUserSortInput>;
  thcUnit?: InputMaybe<SortEnumType>;
  thcValue?: InputMaybe<SortEnumType>;
  thca?: InputMaybe<SortEnumType>;
  thcaUnit?: InputMaybe<SortEnumType>;
  thcaValue?: InputMaybe<SortEnumType>;
  thcml?: InputMaybe<SortEnumType>;
  thctcc?: InputMaybe<SortEnumType>;
  thcv?: InputMaybe<SortEnumType>;
  thcvUnit?: InputMaybe<SortEnumType>;
  thcvValue?: InputMaybe<SortEnumType>;
  thcva?: InputMaybe<SortEnumType>;
  thcvaUnit?: InputMaybe<SortEnumType>;
  thcvaValue?: InputMaybe<SortEnumType>;
  threeCarene?: InputMaybe<SortEnumType>;
  threeCareneUnit?: InputMaybe<SortEnumType>;
  threeCareneValue?: InputMaybe<SortEnumType>;
  totalCannabinoidsUnit?: InputMaybe<SortEnumType>;
  totalCannabinoidsValue?: InputMaybe<SortEnumType>;
  totalTerpenesUnit?: InputMaybe<SortEnumType>;
  totalTerpenesValue?: InputMaybe<SortEnumType>;
  transNerolidol?: InputMaybe<SortEnumType>;
  transNerolidolUnit?: InputMaybe<SortEnumType>;
  transNerolidolValue?: InputMaybe<SortEnumType>;
  valenceneUnit?: InputMaybe<SortEnumType>;
  valenceneValue?: InputMaybe<SortEnumType>;
  visualInspection?: InputMaybe<SortEnumType>;
  yTerpineneUnit?: InputMaybe<SortEnumType>;
  yTerpineneValue?: InputMaybe<SortEnumType>;
};

export type TblBatchTray = {
  areaFt?: Maybe<Scalars['Decimal']>;
  id: Scalars['Int'];
  isDeleted: Scalars['Boolean'];
  length?: Maybe<Scalars['Decimal']>;
  lengthUnit?: Maybe<Scalars['Int']>;
  lsp: Scalars['Int'];
  lspLocation: Scalars['Int'];
  lspLocationNavigation?: Maybe<TblLspLocation>;
  lspNavigation?: Maybe<TblLsp>;
  packages?: Maybe<Array<Maybe<Package>>>;
  room?: Maybe<TblBatchRoom>;
  roomId?: Maybe<Scalars['Int']>;
  table?: Maybe<PlantRoomHistory>;
  tblMdbatchPlantIds?: Maybe<Array<Maybe<TblMdbatchPlantId>>>;
  trayExpired?: Maybe<Scalars['Boolean']>;
  trayNumber: Scalars['String'];
  trayNumberInProcess?: Maybe<Scalars['Boolean']>;
  width?: Maybe<Scalars['Decimal']>;
  widthUnit?: Maybe<Scalars['Int']>;
};

export type TblBatchTrayCollectionSegment = {
  items?: Maybe<Array<Maybe<TblBatchTray>>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

export type TblBatchTrayFilterInput = {
  and?: InputMaybe<Array<TblBatchTrayFilterInput>>;
  areaFt?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  isDeleted?: InputMaybe<BooleanOperationFilterInput>;
  length?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  lengthUnit?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  lsp?: InputMaybe<ComparableInt32OperationFilterInput>;
  lspLocation?: InputMaybe<ComparableInt32OperationFilterInput>;
  lspLocationNavigation?: InputMaybe<TblLspLocationFilterInput>;
  lspNavigation?: InputMaybe<TblLspFilterInput>;
  or?: InputMaybe<Array<TblBatchTrayFilterInput>>;
  packages?: InputMaybe<ListFilterInputTypeOfPackageFilterInput>;
  room?: InputMaybe<TblBatchRoomFilterInput>;
  roomId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  table?: InputMaybe<PlantRoomHistoryFilterInput>;
  tblMdbatchPlantIds?: InputMaybe<ListFilterInputTypeOfTblMdbatchPlantIdFilterInput>;
  trayExpired?: InputMaybe<BooleanOperationFilterInput>;
  trayNumber?: InputMaybe<StringOperationFilterInput>;
  trayNumberInProcess?: InputMaybe<BooleanOperationFilterInput>;
  width?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  widthUnit?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
};

export type TblBatchTraySortInput = {
  areaFt?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isDeleted?: InputMaybe<SortEnumType>;
  length?: InputMaybe<SortEnumType>;
  lengthUnit?: InputMaybe<SortEnumType>;
  lsp?: InputMaybe<SortEnumType>;
  lspLocation?: InputMaybe<SortEnumType>;
  lspLocationNavigation?: InputMaybe<TblLspLocationSortInput>;
  lspNavigation?: InputMaybe<TblLspSortInput>;
  room?: InputMaybe<TblBatchRoomSortInput>;
  roomId?: InputMaybe<SortEnumType>;
  table?: InputMaybe<PlantRoomHistorySortInput>;
  trayExpired?: InputMaybe<SortEnumType>;
  trayNumber?: InputMaybe<SortEnumType>;
  trayNumberInProcess?: InputMaybe<SortEnumType>;
  width?: InputMaybe<SortEnumType>;
  widthUnit?: InputMaybe<SortEnumType>;
};

export type TblChargeCodesSet = {
  chargeCodesActive?: Maybe<Scalars['String']>;
  chargeCodesCategory?: Maybe<Scalars['Int']>;
  chargeCodesCostRequired?: Maybe<Scalars['String']>;
  chargeCodesDesc: Scalars['String'];
  discountTierRestrictions?: Maybe<Array<Maybe<DiscountTierRestriction>>>;
  id: Scalars['Int'];
  mdpricingHdrs?: Maybe<Array<Maybe<MdpricingHdr>>>;
  tblChargeCodesTblLsp: Scalars['Int'];
  tblChargeCodesTblLspNavigation?: Maybe<TblLsp>;
  tblWhseProducts?: Maybe<Array<Maybe<TblWhseProduct>>>;
};

export type TblChargeCodesSetFilterInput = {
  and?: InputMaybe<Array<TblChargeCodesSetFilterInput>>;
  chargeCodesActive?: InputMaybe<StringOperationFilterInput>;
  chargeCodesCategory?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  chargeCodesCostRequired?: InputMaybe<StringOperationFilterInput>;
  chargeCodesDesc?: InputMaybe<StringOperationFilterInput>;
  discountTierRestrictions?: InputMaybe<ListFilterInputTypeOfDiscountTierRestrictionFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  mdpricingHdrs?: InputMaybe<ListFilterInputTypeOfMdpricingHdrFilterInput>;
  or?: InputMaybe<Array<TblChargeCodesSetFilterInput>>;
  tblChargeCodesTblLsp?: InputMaybe<ComparableInt32OperationFilterInput>;
  tblChargeCodesTblLspNavigation?: InputMaybe<TblLspFilterInput>;
  tblWhseProducts?: InputMaybe<ListFilterInputTypeOfTblWhseProductFilterInput>;
};

export type TblChargeCodesSetSortInput = {
  chargeCodesActive?: InputMaybe<SortEnumType>;
  chargeCodesCategory?: InputMaybe<SortEnumType>;
  chargeCodesCostRequired?: InputMaybe<SortEnumType>;
  chargeCodesDesc?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  tblChargeCodesTblLsp?: InputMaybe<SortEnumType>;
  tblChargeCodesTblLspNavigation?: InputMaybe<TblLspSortInput>;
};

export type TblDispensarySchedule = {
  actionDate?: Maybe<Scalars['DateTime']>;
  checkInDate?: Maybe<Scalars['DateTime']>;
  checkInType?: Maybe<Scalars['String']>;
  checkOutDate?: Maybe<Scalars['DateTime']>;
  comments?: Maybe<Scalars['String']>;
  currentRoom?: Maybe<Scalars['Int']>;
  currentRoomNavigation?: Maybe<TblBatchRoom>;
  id: Scalars['Int'];
  location?: Maybe<TblLspLocation>;
  locationId: Scalars['Int'];
  lsp?: Maybe<TblLsp>;
  lspId: Scalars['Int'];
  patient: Scalars['Int'];
  patientNavigation?: Maybe<TblAcct>;
  register?: Maybe<MdPosTerminal>;
  registerId?: Maybe<Scalars['Int']>;
  scheduleDateString?: Maybe<Scalars['String']>;
  scheduledDate: Scalars['DateTime'];
  shipment?: Maybe<TblMdshipment>;
  shipmentId?: Maybe<Scalars['Int']>;
};

export type TblDispensaryScheduleFilterInput = {
  actionDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  and?: InputMaybe<Array<TblDispensaryScheduleFilterInput>>;
  checkInDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  checkInType?: InputMaybe<StringOperationFilterInput>;
  checkOutDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  comments?: InputMaybe<StringOperationFilterInput>;
  currentRoom?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  currentRoomNavigation?: InputMaybe<TblBatchRoomFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  location?: InputMaybe<TblLspLocationFilterInput>;
  locationId?: InputMaybe<ComparableInt32OperationFilterInput>;
  lsp?: InputMaybe<TblLspFilterInput>;
  lspId?: InputMaybe<ComparableInt32OperationFilterInput>;
  or?: InputMaybe<Array<TblDispensaryScheduleFilterInput>>;
  patient?: InputMaybe<ComparableInt32OperationFilterInput>;
  patientNavigation?: InputMaybe<TblAcctFilterInput>;
  register?: InputMaybe<MdPosTerminalFilterInput>;
  registerId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  scheduleDateString?: InputMaybe<StringOperationFilterInput>;
  scheduledDate?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  shipment?: InputMaybe<TblMdshipmentFilterInput>;
  shipmentId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
};

export type TblInventoryStatus = {
  assemblyOutputItems?: Maybe<Array<Maybe<AssemblyOutputItem>>>;
  b2blevel?: Maybe<Scalars['Int']>;
  b2blevel1?: Maybe<Scalars['Int']>;
  finalProduct?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  invCode?: Maybe<Scalars['String']>;
  invStatusDesc?: Maybe<Scalars['String']>;
  isDeleted: Scalars['Boolean'];
  levelB2b?: Maybe<Scalars['String']>;
  loc?: Maybe<TblLspLocation>;
  locId?: Maybe<Scalars['Int']>;
  lsp?: Maybe<TblLsp>;
  lspId?: Maybe<Scalars['Int']>;
  packages?: Maybe<Array<Maybe<Package>>>;
};

export type TblInventoryStatusCollectionSegment = {
  items?: Maybe<Array<Maybe<TblInventoryStatus>>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

export type TblInventoryStatusFilterInput = {
  and?: InputMaybe<Array<TblInventoryStatusFilterInput>>;
  assemblyOutputItems?: InputMaybe<ListFilterInputTypeOfAssemblyOutputItemFilterInput>;
  b2blevel?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  b2blevel1?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  finalProduct?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  invCode?: InputMaybe<StringOperationFilterInput>;
  invStatusDesc?: InputMaybe<StringOperationFilterInput>;
  isDeleted?: InputMaybe<BooleanOperationFilterInput>;
  levelB2b?: InputMaybe<StringOperationFilterInput>;
  loc?: InputMaybe<TblLspLocationFilterInput>;
  locId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  lsp?: InputMaybe<TblLspFilterInput>;
  lspId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  or?: InputMaybe<Array<TblInventoryStatusFilterInput>>;
  packages?: InputMaybe<ListFilterInputTypeOfPackageFilterInput>;
};

export type TblInventoryStatusSortInput = {
  b2blevel?: InputMaybe<SortEnumType>;
  b2blevel1?: InputMaybe<SortEnumType>;
  finalProduct?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  invCode?: InputMaybe<SortEnumType>;
  invStatusDesc?: InputMaybe<SortEnumType>;
  isDeleted?: InputMaybe<SortEnumType>;
  levelB2b?: InputMaybe<SortEnumType>;
  loc?: InputMaybe<TblLspLocationSortInput>;
  locId?: InputMaybe<SortEnumType>;
  lsp?: InputMaybe<TblLspSortInput>;
  lspId?: InputMaybe<SortEnumType>;
};

export type TblLsp = {
  adilasIntegrationControlInfos?: Maybe<Array<Maybe<AdilasIntegrationControlInfo>>>;
  allocatedInventories?: Maybe<Array<Maybe<AllocatedInventory>>>;
  alpineIqcontrolInfos?: Maybe<Array<Maybe<AlpineIqcontrolInfo>>>;
  apbatchNo?: Maybe<Scalars['Int']>;
  apbreak1?: Maybe<Scalars['Int']>;
  apbreak2?: Maybe<Scalars['Int']>;
  apbreak3?: Maybe<Scalars['Int']>;
  apbreak4?: Maybe<Scalars['Int']>;
  apbreak5?: Maybe<Scalars['Int']>;
  apcontra?: Maybe<Scalars['Int']>;
  appostBgroupByVendor?: Maybe<Scalars['String']>;
  arbatchNo?: Maybe<Scalars['Int']>;
  arbreak1?: Maybe<Scalars['Int']>;
  arbreak2?: Maybe<Scalars['Int']>;
  arbreak3?: Maybe<Scalars['Int']>;
  arbreak4?: Maybe<Scalars['Int']>;
  arbreak5?: Maybe<Scalars['Int']>;
  assemblies?: Maybe<Array<Maybe<Assembly>>>;
  bankReconNo?: Maybe<Scalars['Int']>;
  billOfMaterials?: Maybe<Array<Maybe<BillOfMaterial>>>;
  birchmountControlInfos?: Maybe<Array<Maybe<BirchmountControlInfo>>>;
  brands?: Maybe<Array<Maybe<Brand>>>;
  brokerAdd1?: Maybe<Scalars['String']>;
  brokerCity?: Maybe<Scalars['String']>;
  brokerCountry?: Maybe<Scalars['Int']>;
  brokerEmail?: Maybe<Scalars['String']>;
  brokerFax?: Maybe<Scalars['String']>;
  brokerName?: Maybe<Scalars['String']>;
  brokerPhone?: Maybe<Scalars['String']>;
  brokerPostal?: Maybe<Scalars['String']>;
  brokerState?: Maybe<Scalars['String']>;
  ccrscontrolInfos?: Maybe<Array<Maybe<CcrscontrolInfo>>>;
  daysInCycle?: Maybe<Scalars['Int']>;
  dcdirectControlInfos?: Maybe<Array<Maybe<DcdirectControlInfo>>>;
  defaultStatusEmail?: Maybe<Scalars['String']>;
  deliveryZones?: Maybe<Array<Maybe<DeliveryZone>>>;
  demoAddr1?: Maybe<Scalars['String']>;
  demoName?: Maybe<Scalars['String']>;
  discounts?: Maybe<Array<Maybe<Discount>>>;
  distillations?: Maybe<Array<Maybe<Distillation>>>;
  feeDonations?: Maybe<Array<Maybe<FeeDonation>>>;
  fgrecons?: Maybe<Array<Maybe<Fgrecon>>>;
  fullStoryId?: Maybe<Scalars['String']>;
  globalId: Scalars['UUID'];
  helpDeskUrl?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  integrationConfigurations?: Maybe<Array<Maybe<IntegrationConfiguration>>>;
  inventoryAuditFiles?: Maybe<Array<Maybe<InventoryAuditFile>>>;
  inventoryAuditToBrands?: Maybe<Array<Maybe<InventoryAuditToBrand>>>;
  inventoryAuditToCategories?: Maybe<Array<Maybe<InventoryAuditToCategory>>>;
  inventoryAuditToRooms?: Maybe<Array<Maybe<InventoryAuditToRoom>>>;
  inventoryTransactions?: Maybe<Array<Maybe<InventoryTransaction>>>;
  inverseLspAcctLsp?: Maybe<Array<Maybe<TblLsp>>>;
  isActive: Scalars['Boolean'];
  leafControlInfos?: Maybe<Array<Maybe<LeafControlInfo>>>;
  leafLinkControlInfos?: Maybe<Array<Maybe<LeafLinkControlInfo>>>;
  linxControlInfos?: Maybe<Array<Maybe<LinxControlInfo>>>;
  lookerUserLimit: Scalars['Int'];
  lspAcctLsp?: Maybe<TblLsp>;
  lspAcctLspId?: Maybe<Scalars['Int']>;
  lspAddress?: Maybe<Scalars['String']>;
  lspAllowAutGenWhseRecFromShip: Scalars['Boolean'];
  lspAllowAutoGenMasterFromShip: Scalars['Boolean'];
  lspAllowAutoGenPickupFromWhseShip: Scalars['Boolean'];
  lspAllowAutoGenShipFromPickup: Scalars['Boolean'];
  lspCity?: Maybe<Scalars['String']>;
  lspCode: Scalars['String'];
  lspConsolidator?: Maybe<Scalars['String']>;
  lspContainerStuffingLoc?: Maybe<Scalars['String']>;
  lspHouseIncludeOrg?: Maybe<Scalars['String']>;
  lspHouseNo?: Maybe<Scalars['Int']>;
  lspHousePrefix?: Maybe<Scalars['String']>;
  lspIdentificationNo?: Maybe<Scalars['String']>;
  lspIdentificationNoValue?: Maybe<Scalars['String']>;
  lspInvoiceCntByHouse?: Maybe<Scalars['String']>;
  lspInvoiceIncludeHouseNo?: Maybe<Scalars['String']>;
  lspInvoiceIncludeHouseOrg?: Maybe<Scalars['String']>;
  lspInvoiceNo?: Maybe<Scalars['Int']>;
  lspInvoicePrefix?: Maybe<Scalars['String']>;
  lspIsfno?: Maybe<Scalars['String']>;
  lspMasterIncludeOrg?: Maybe<Scalars['String']>;
  lspMasterNo?: Maybe<Scalars['Int']>;
  lspMasterPrefix?: Maybe<Scalars['String']>;
  lspName: Scalars['String'];
  lspPasswordExpiration?: Maybe<Scalars['Int']>;
  lspPasswordExpirationEnabled: Scalars['Boolean'];
  lspPasswordLength?: Maybe<Scalars['Int']>;
  lspPasswordLengthEnabled: Scalars['Boolean'];
  lspPickupIncludeOrg?: Maybe<Scalars['String']>;
  lspPickupNo?: Maybe<Scalars['Int']>;
  lspPickupPrefix?: Maybe<Scalars['String']>;
  lspPlanSeqNo?: Maybe<Scalars['Int']>;
  lspPostalCode?: Maybe<Scalars['String']>;
  lspProductAcctLink?: Maybe<Scalars['Int']>;
  lspProductAcctLinkNavigation?: Maybe<TblAcct>;
  lspState?: Maybe<Scalars['String']>;
  mdDoctors?: Maybe<Array<Maybe<MdDoctor>>>;
  mdManifests?: Maybe<Array<Maybe<MdManifest>>>;
  mdPosTerminals?: Maybe<Array<Maybe<MdPosTerminal>>>;
  mdPricingDtls?: Maybe<Array<Maybe<MdPricingDtl>>>;
  mdhideCannabisType?: Maybe<Scalars['String']>;
  mdhideMgrApproval?: Maybe<Scalars['String']>;
  mdlabelNo?: Maybe<Scalars['Int']>;
  mdpricingHdrs?: Maybe<Array<Maybe<MdpricingHdr>>>;
  mdtaxRt?: Maybe<Scalars['Decimal']>;
  metrcProcessingJobTypeTemplates?: Maybe<Array<Maybe<MetrcProcessingJobTypeTemplate>>>;
  metrcProcessingJobTypes?: Maybe<Array<Maybe<MetrcProcessingJobType>>>;
  mjstateIdno?: Maybe<Scalars['String']>;
  mncontrolInfos?: Maybe<Array<Maybe<MncontrolInfo>>>;
  orders?: Maybe<Array<Maybe<Order>>>;
  orgId?: Maybe<Scalars['Short']>;
  packageItemLabels?: Maybe<Array<Maybe<PackageItemLabel>>>;
  packageToCustomerTypes?: Maybe<Array<Maybe<PackageToCustomerType>>>;
  packageToTags?: Maybe<Array<Maybe<PackageToTag>>>;
  packages?: Maybe<Array<Maybe<Package>>>;
  patientMaxFlag?: Maybe<Scalars['String']>;
  pmpcontrolInfos?: Maybe<Array<Maybe<PmpcontrolInfo>>>;
  pricingTierGroups?: Maybe<Array<Maybe<PricingTierGroup>>>;
  productDosages?: Maybe<Array<Maybe<ProductDosage>>>;
  productSizeListItems?: Maybe<Array<Maybe<ProductSizeListItem>>>;
  productTaxCategories?: Maybe<Array<Maybe<ProductTaxCategory>>>;
  productToCustomerTypes?: Maybe<Array<Maybe<ProductToCustomerType>>>;
  productTypeToCustomerTypes?: Maybe<Array<Maybe<ProductTypeToCustomerType>>>;
  purchaseLimits?: Maybe<Array<Maybe<PurchaseLimit>>>;
  receiptSettings?: Maybe<Array<Maybe<ReceiptSetting>>>;
  receiveInventoryHistories?: Maybe<Array<Maybe<ReceiveInventoryHistory>>>;
  registerLedgers?: Maybe<Array<Maybe<RegisterLedger>>>;
  registerLocations?: Maybe<Scalars['String']>;
  returnReasons?: Maybe<Array<Maybe<ReturnReason>>>;
  roomTerminals?: Maybe<Array<Maybe<RoomTerminal>>>;
  roomToMenus?: Maybe<Array<Maybe<RoomToMenu>>>;
  shareCustomerProfiles: Scalars['Boolean'];
  tags?: Maybe<Array<Maybe<Tag>>>;
  takeInventorySnapshots: Scalars['Boolean'];
  taxRates?: Maybe<Array<Maybe<TaxRate>>>;
  tblAccts?: Maybe<Array<Maybe<TblAcct>>>;
  tblAuthDomainLspLinks?: Maybe<Array<Maybe<TblAuthDomainLspLink>>>;
  tblAuthUsers?: Maybe<Array<Maybe<TblAuthUser>>>;
  tblBatchRooms?: Maybe<Array<Maybe<TblBatchRoom>>>;
  tblBatchStrains?: Maybe<Array<Maybe<TblBatchStrain>>>;
  tblBatchThcs?: Maybe<Array<Maybe<TblBatchThc>>>;
  tblBatchTrays?: Maybe<Array<Maybe<TblBatchTray>>>;
  tblBatches?: Maybe<Array<Maybe<TblBatch>>>;
  tblChargeCodesSets?: Maybe<Array<Maybe<TblChargeCodesSet>>>;
  tblDispensarySchedules?: Maybe<Array<Maybe<TblDispensarySchedule>>>;
  tblInventoryStatuses?: Maybe<Array<Maybe<TblInventoryStatus>>>;
  tblLspLocationAccountingLspNavigations?: Maybe<Array<Maybe<TblLspLocation>>>;
  tblLspLocationTblLspLocationsTblLspNavigations?: Maybe<Array<Maybe<TblLspLocation>>>;
  tblLspTblCountryCodes?: Maybe<Scalars['Int']>;
  tblLspTblStatus?: Maybe<Scalars['Int']>;
  tblMdcars?: Maybe<Array<Maybe<TblMdcar>>>;
  tblMddrivers?: Maybe<Array<Maybe<TblMddriver>>>;
  tblMdlabels?: Maybe<Array<Maybe<TblMdlabel>>>;
  tblMdorderDispensaryNavigations?: Maybe<Array<Maybe<TblMdorder>>>;
  tblMdorderGrowerNavigations?: Maybe<Array<Maybe<TblMdorder>>>;
  tblMdshipments?: Maybe<Array<Maybe<TblMdshipment>>>;
  tblVendors?: Maybe<Array<Maybe<TblVendor>>>;
  tblWhseProductTypes?: Maybe<Array<Maybe<TblWhseProductType>>>;
  tblWhseProducts?: Maybe<Array<Maybe<TblWhseProduct>>>;
  trymControlInfos?: Maybe<Array<Maybe<TrymControlInfo>>>;
  useCycleDate: Scalars['Boolean'];
  userGroups?: Maybe<Array<Maybe<UserGroup>>>;
  userLsps?: Maybe<Array<Maybe<UserLsp>>>;
  userPinLength: Scalars['Int'];
  userToPermissions?: Maybe<Array<Maybe<UserToPermission>>>;
};

export type TblLspFilterInput = {
  adilasIntegrationControlInfos?: InputMaybe<ListFilterInputTypeOfAdilasIntegrationControlInfoFilterInput>;
  allocatedInventories?: InputMaybe<ListFilterInputTypeOfAllocatedInventoryFilterInput>;
  alpineIqcontrolInfos?: InputMaybe<ListFilterInputTypeOfAlpineIqcontrolInfoFilterInput>;
  and?: InputMaybe<Array<TblLspFilterInput>>;
  apbatchNo?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  apbreak1?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  apbreak2?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  apbreak3?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  apbreak4?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  apbreak5?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  apcontra?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  appostBgroupByVendor?: InputMaybe<StringOperationFilterInput>;
  arbatchNo?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  arbreak1?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  arbreak2?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  arbreak3?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  arbreak4?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  arbreak5?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  assemblies?: InputMaybe<ListFilterInputTypeOfAssemblyFilterInput>;
  bankReconNo?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  billOfMaterials?: InputMaybe<ListFilterInputTypeOfBillOfMaterialFilterInput>;
  birchmountControlInfos?: InputMaybe<ListFilterInputTypeOfBirchmountControlInfoFilterInput>;
  brands?: InputMaybe<ListFilterInputTypeOfBrandFilterInput>;
  brokerAdd1?: InputMaybe<StringOperationFilterInput>;
  brokerCity?: InputMaybe<StringOperationFilterInput>;
  brokerCountry?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  brokerEmail?: InputMaybe<StringOperationFilterInput>;
  brokerFax?: InputMaybe<StringOperationFilterInput>;
  brokerName?: InputMaybe<StringOperationFilterInput>;
  brokerPhone?: InputMaybe<StringOperationFilterInput>;
  brokerPostal?: InputMaybe<StringOperationFilterInput>;
  brokerState?: InputMaybe<StringOperationFilterInput>;
  ccrscontrolInfos?: InputMaybe<ListFilterInputTypeOfCcrscontrolInfoFilterInput>;
  daysInCycle?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  dcdirectControlInfos?: InputMaybe<ListFilterInputTypeOfDcdirectControlInfoFilterInput>;
  defaultStatusEmail?: InputMaybe<StringOperationFilterInput>;
  deliveryZones?: InputMaybe<ListFilterInputTypeOfDeliveryZoneFilterInput>;
  demoAddr1?: InputMaybe<StringOperationFilterInput>;
  demoName?: InputMaybe<StringOperationFilterInput>;
  discounts?: InputMaybe<ListFilterInputTypeOfDiscountFilterInput>;
  distillations?: InputMaybe<ListFilterInputTypeOfDistillationFilterInput>;
  feeDonations?: InputMaybe<ListFilterInputTypeOfFeeDonationFilterInput>;
  fgrecons?: InputMaybe<ListFilterInputTypeOfFgreconFilterInput>;
  fullStoryId?: InputMaybe<StringOperationFilterInput>;
  globalId?: InputMaybe<ComparableGuidOperationFilterInput>;
  helpDeskUrl?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  integrationConfigurations?: InputMaybe<ListFilterInputTypeOfIntegrationConfigurationFilterInput>;
  inventoryAuditFiles?: InputMaybe<ListFilterInputTypeOfInventoryAuditFileFilterInput>;
  inventoryAuditToBrands?: InputMaybe<ListFilterInputTypeOfInventoryAuditToBrandFilterInput>;
  inventoryAuditToCategories?: InputMaybe<ListFilterInputTypeOfInventoryAuditToCategoryFilterInput>;
  inventoryAuditToRooms?: InputMaybe<ListFilterInputTypeOfInventoryAuditToRoomFilterInput>;
  inventoryTransactions?: InputMaybe<ListFilterInputTypeOfInventoryTransactionFilterInput>;
  inverseLspAcctLsp?: InputMaybe<ListFilterInputTypeOfTblLspFilterInput>;
  isActive?: InputMaybe<BooleanOperationFilterInput>;
  leafControlInfos?: InputMaybe<ListFilterInputTypeOfLeafControlInfoFilterInput>;
  leafLinkControlInfos?: InputMaybe<ListFilterInputTypeOfLeafLinkControlInfoFilterInput>;
  linxControlInfos?: InputMaybe<ListFilterInputTypeOfLinxControlInfoFilterInput>;
  lookerUserLimit?: InputMaybe<ComparableInt32OperationFilterInput>;
  lspAcctLsp?: InputMaybe<TblLspFilterInput>;
  lspAcctLspId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  lspAddress?: InputMaybe<StringOperationFilterInput>;
  lspAllowAutGenWhseRecFromShip?: InputMaybe<BooleanOperationFilterInput>;
  lspAllowAutoGenMasterFromShip?: InputMaybe<BooleanOperationFilterInput>;
  lspAllowAutoGenPickupFromWhseShip?: InputMaybe<BooleanOperationFilterInput>;
  lspAllowAutoGenShipFromPickup?: InputMaybe<BooleanOperationFilterInput>;
  lspCity?: InputMaybe<StringOperationFilterInput>;
  lspCode?: InputMaybe<StringOperationFilterInput>;
  lspConsolidator?: InputMaybe<StringOperationFilterInput>;
  lspContainerStuffingLoc?: InputMaybe<StringOperationFilterInput>;
  lspHouseIncludeOrg?: InputMaybe<StringOperationFilterInput>;
  lspHouseNo?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  lspHousePrefix?: InputMaybe<StringOperationFilterInput>;
  lspIdentificationNo?: InputMaybe<StringOperationFilterInput>;
  lspIdentificationNoValue?: InputMaybe<StringOperationFilterInput>;
  lspInvoiceCntByHouse?: InputMaybe<StringOperationFilterInput>;
  lspInvoiceIncludeHouseNo?: InputMaybe<StringOperationFilterInput>;
  lspInvoiceIncludeHouseOrg?: InputMaybe<StringOperationFilterInput>;
  lspInvoiceNo?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  lspInvoicePrefix?: InputMaybe<StringOperationFilterInput>;
  lspIsfno?: InputMaybe<StringOperationFilterInput>;
  lspMasterIncludeOrg?: InputMaybe<StringOperationFilterInput>;
  lspMasterNo?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  lspMasterPrefix?: InputMaybe<StringOperationFilterInput>;
  lspName?: InputMaybe<StringOperationFilterInput>;
  lspPasswordExpiration?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  lspPasswordExpirationEnabled?: InputMaybe<BooleanOperationFilterInput>;
  lspPasswordLength?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  lspPasswordLengthEnabled?: InputMaybe<BooleanOperationFilterInput>;
  lspPickupIncludeOrg?: InputMaybe<StringOperationFilterInput>;
  lspPickupNo?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  lspPickupPrefix?: InputMaybe<StringOperationFilterInput>;
  lspPlanSeqNo?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  lspPostalCode?: InputMaybe<StringOperationFilterInput>;
  lspProductAcctLink?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  lspProductAcctLinkNavigation?: InputMaybe<TblAcctFilterInput>;
  lspState?: InputMaybe<StringOperationFilterInput>;
  mdDoctors?: InputMaybe<ListFilterInputTypeOfMdDoctorFilterInput>;
  mdManifests?: InputMaybe<ListFilterInputTypeOfMdManifestFilterInput>;
  mdPosTerminals?: InputMaybe<ListFilterInputTypeOfMdPosTerminalFilterInput>;
  mdPricingDtls?: InputMaybe<ListFilterInputTypeOfMdPricingDtlFilterInput>;
  mdhideCannabisType?: InputMaybe<StringOperationFilterInput>;
  mdhideMgrApproval?: InputMaybe<StringOperationFilterInput>;
  mdlabelNo?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  mdpricingHdrs?: InputMaybe<ListFilterInputTypeOfMdpricingHdrFilterInput>;
  mdtaxRt?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  metrcProcessingJobTypeTemplates?: InputMaybe<ListFilterInputTypeOfMetrcProcessingJobTypeTemplateFilterInput>;
  metrcProcessingJobTypes?: InputMaybe<ListFilterInputTypeOfMetrcProcessingJobTypeFilterInput>;
  mjstateIdno?: InputMaybe<StringOperationFilterInput>;
  mncontrolInfos?: InputMaybe<ListFilterInputTypeOfMncontrolInfoFilterInput>;
  or?: InputMaybe<Array<TblLspFilterInput>>;
  orders?: InputMaybe<ListFilterInputTypeOfOrderFilterInput>;
  orgId?: InputMaybe<ComparableNullableOfInt16OperationFilterInput>;
  packageItemLabels?: InputMaybe<ListFilterInputTypeOfPackageItemLabelFilterInput>;
  packageToCustomerTypes?: InputMaybe<ListFilterInputTypeOfPackageToCustomerTypeFilterInput>;
  packageToTags?: InputMaybe<ListFilterInputTypeOfPackageToTagFilterInput>;
  packages?: InputMaybe<ListFilterInputTypeOfPackageFilterInput>;
  patientMaxFlag?: InputMaybe<StringOperationFilterInput>;
  pmpcontrolInfos?: InputMaybe<ListFilterInputTypeOfPmpcontrolInfoFilterInput>;
  pricingTierGroups?: InputMaybe<ListFilterInputTypeOfPricingTierGroupFilterInput>;
  productDosages?: InputMaybe<ListFilterInputTypeOfProductDosageFilterInput>;
  productSizeListItems?: InputMaybe<ListFilterInputTypeOfProductSizeListItemFilterInput>;
  productTaxCategories?: InputMaybe<ListFilterInputTypeOfProductTaxCategoryFilterInput>;
  productToCustomerTypes?: InputMaybe<ListFilterInputTypeOfProductToCustomerTypeFilterInput>;
  productTypeToCustomerTypes?: InputMaybe<ListFilterInputTypeOfProductTypeToCustomerTypeFilterInput>;
  purchaseLimits?: InputMaybe<ListFilterInputTypeOfPurchaseLimitFilterInput>;
  receiptSettings?: InputMaybe<ListFilterInputTypeOfReceiptSettingFilterInput>;
  receiveInventoryHistories?: InputMaybe<ListFilterInputTypeOfReceiveInventoryHistoryFilterInput>;
  registerLedgers?: InputMaybe<ListFilterInputTypeOfRegisterLedgerFilterInput>;
  registerLocations?: InputMaybe<StringOperationFilterInput>;
  returnReasons?: InputMaybe<ListFilterInputTypeOfReturnReasonFilterInput>;
  roomTerminals?: InputMaybe<ListFilterInputTypeOfRoomTerminalFilterInput>;
  roomToMenus?: InputMaybe<ListFilterInputTypeOfRoomToMenuFilterInput>;
  shareCustomerProfiles?: InputMaybe<BooleanOperationFilterInput>;
  tags?: InputMaybe<ListFilterInputTypeOfTagFilterInput>;
  takeInventorySnapshots?: InputMaybe<BooleanOperationFilterInput>;
  taxRates?: InputMaybe<ListFilterInputTypeOfTaxRateFilterInput>;
  tblAccts?: InputMaybe<ListFilterInputTypeOfTblAcctFilterInput>;
  tblAuthDomainLspLinks?: InputMaybe<ListFilterInputTypeOfTblAuthDomainLspLinkFilterInput>;
  tblAuthUsers?: InputMaybe<ListFilterInputTypeOfTblAuthUserFilterInput>;
  tblBatchRooms?: InputMaybe<ListFilterInputTypeOfTblBatchRoomFilterInput>;
  tblBatchStrains?: InputMaybe<ListFilterInputTypeOfTblBatchStrainFilterInput>;
  tblBatchThcs?: InputMaybe<ListFilterInputTypeOfTblBatchThcFilterInput>;
  tblBatchTrays?: InputMaybe<ListFilterInputTypeOfTblBatchTrayFilterInput>;
  tblBatches?: InputMaybe<ListFilterInputTypeOfTblBatchFilterInput>;
  tblChargeCodesSets?: InputMaybe<ListFilterInputTypeOfTblChargeCodesSetFilterInput>;
  tblDispensarySchedules?: InputMaybe<ListFilterInputTypeOfTblDispensaryScheduleFilterInput>;
  tblInventoryStatuses?: InputMaybe<ListFilterInputTypeOfTblInventoryStatusFilterInput>;
  tblLspLocationAccountingLspNavigations?: InputMaybe<ListFilterInputTypeOfTblLspLocationFilterInput>;
  tblLspLocationTblLspLocationsTblLspNavigations?: InputMaybe<ListFilterInputTypeOfTblLspLocationFilterInput>;
  tblLspTblCountryCodes?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  tblLspTblStatus?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  tblMdcars?: InputMaybe<ListFilterInputTypeOfTblMdcarFilterInput>;
  tblMddrivers?: InputMaybe<ListFilterInputTypeOfTblMddriverFilterInput>;
  tblMdlabels?: InputMaybe<ListFilterInputTypeOfTblMdlabelFilterInput>;
  tblMdorderDispensaryNavigations?: InputMaybe<ListFilterInputTypeOfTblMdorderFilterInput>;
  tblMdorderGrowerNavigations?: InputMaybe<ListFilterInputTypeOfTblMdorderFilterInput>;
  tblMdshipments?: InputMaybe<ListFilterInputTypeOfTblMdshipmentFilterInput>;
  tblVendors?: InputMaybe<ListFilterInputTypeOfTblVendorFilterInput>;
  tblWhseProductTypes?: InputMaybe<ListFilterInputTypeOfTblWhseProductTypeFilterInput>;
  tblWhseProducts?: InputMaybe<ListFilterInputTypeOfTblWhseProductFilterInput>;
  trymControlInfos?: InputMaybe<ListFilterInputTypeOfTrymControlInfoFilterInput>;
  useCycleDate?: InputMaybe<BooleanOperationFilterInput>;
  userGroups?: InputMaybe<ListFilterInputTypeOfUserGroupFilterInput>;
  userLsps?: InputMaybe<ListFilterInputTypeOfUserLspFilterInput>;
  userPinLength?: InputMaybe<ComparableInt32OperationFilterInput>;
  userToPermissions?: InputMaybe<ListFilterInputTypeOfUserToPermissionFilterInput>;
};

export type TblLspLocation = {
  accountingLsp?: Maybe<Scalars['Int']>;
  accountingLspNavigation?: Maybe<TblLsp>;
  actualWeightThreshold?: Maybe<Scalars['Decimal']>;
  actualWeightThresholdUnitId: Scalars['Int'];
  adilasIntegrationControlInfos?: Maybe<Array<Maybe<AdilasIntegrationControlInfo>>>;
  aeemail?: Maybe<Scalars['String']>;
  aiemail?: Maybe<Scalars['String']>;
  allEmail?: Maybe<Scalars['String']>;
  allocatedInventories?: Maybe<Array<Maybe<AllocatedInventory>>>;
  alpineIqcontrolInfos?: Maybe<Array<Maybe<AlpineIqcontrolInfo>>>;
  apiFlags?: Maybe<Scalars['String']>;
  assemblies?: Maybe<Array<Maybe<Assembly>>>;
  autoCreateBatchMethod: Scalars['Int'];
  batchId?: Maybe<Scalars['Int']>;
  batchIdentityFormat?: Maybe<Scalars['String']>;
  bioTrackIntegration?: Maybe<Scalars['String']>;
  bioTrackInventoryReceipt?: Maybe<Scalars['String']>;
  biotrackProcessPlants?: Maybe<Scalars['String']>;
  biotrackProcessSalesPatientNotInsystem?: Maybe<Scalars['String']>;
  birchmountControlInfos?: Maybe<Array<Maybe<BirchmountControlInfo>>>;
  cartPhoneDisclaimer?: Maybe<Scalars['String']>;
  ccrscontrolInfos?: Maybe<Array<Maybe<CcrscontrolInfo>>>;
  cfdcustomIdleImage?: Maybe<Scalars['String']>;
  county?: Maybe<Scalars['String']>;
  coupon?: Maybe<TblWhseProduct>;
  couponId?: Maybe<Scalars['Int']>;
  crescoProcessingFeature?: Maybe<Scalars['String']>;
  curbsidePickupEnabled: Scalars['Boolean'];
  dcdirectControlInfos?: Maybe<Array<Maybe<DcdirectControlInfo>>>;
  defaultConversionMultiplier: Scalars['String'];
  defaultCustomerTypeId?: Maybe<Scalars['Int']>;
  defaultDeliveryWindowEnd?: Maybe<Scalars['TimeSpan']>;
  defaultDeliveryWindowStart?: Maybe<Scalars['TimeSpan']>;
  defaultExciseTax?: Maybe<Scalars['Decimal']>;
  defaultGrowerRegister?: Maybe<Scalars['Int']>;
  defaultGrowerRegisterNavigation?: Maybe<MdPosTerminal>;
  defaultInvoicePrefix?: Maybe<Scalars['String']>;
  defaultLabResultsUnit?: Maybe<Scalars['Int']>;
  defaultLabel?: Maybe<Scalars['Int']>;
  defaultLabelDpi: Scalars['Short'];
  defaultLoyaltyPoints: Scalars['Int'];
  defaultMarkupRate?: Maybe<Scalars['Decimal']>;
  defaultMinorAge: Scalars['Int'];
  defaultOrderSourceId?: Maybe<Scalars['Int']>;
  defaultPaymentTerms?: Maybe<Scalars['String']>;
  defaultPosStatus?: Maybe<Scalars['String']>;
  defaultPostransactionExistingCustomer?: Maybe<Scalars['Int']>;
  defaultPostransactionExistingCustomerNavigation?: Maybe<TblWhseProduct>;
  defaultPostransactionNewCustomer?: Maybe<Scalars['Int']>;
  defaultPostransactionNewCustomerNavigation?: Maybe<TblWhseProduct>;
  defaultRecMinorAge: Scalars['Int'];
  defaultReceiptPrint?: Maybe<Scalars['Int']>;
  defaultReceiptPrintNavigation?: Maybe<TblMdlabel>;
  defaultTerpenesLabResultsUnit?: Maybe<Scalars['Int']>;
  deliveryConcurrency?: Maybe<Scalars['Int']>;
  deliveryMaxConcentrateWeight?: Maybe<Scalars['Int']>;
  deliveryMaxIctinventoryDollars?: Maybe<Scalars['Int']>;
  deliveryMaxTotalInventoryDollars?: Maybe<Scalars['Int']>;
  deliveryMaxTotalWeight?: Maybe<Scalars['Int']>;
  deliveryProvider?: Maybe<Scalars['Int']>;
  deliveryStatus?: Maybe<Scalars['String']>;
  deliveryZones?: Maybe<Array<Maybe<DeliveryZone>>>;
  demoAddr1?: Maybe<Scalars['String']>;
  demoName?: Maybe<Scalars['String']>;
  doNotAllowReturns?: Maybe<Scalars['String']>;
  doingBusinessAs?: Maybe<Scalars['String']>;
  exciseTax?: Maybe<Scalars['Decimal']>;
  excludeFromVolumeDiscount?: Maybe<Scalars['String']>;
  feeDonations?: Maybe<Array<Maybe<FeeDonation>>>;
  fgrecons?: Maybe<Array<Maybe<Fgrecon>>>;
  fullStoryId?: Maybe<Scalars['String']>;
  globalId: Scalars['UUID'];
  guestListRefreshRate: Scalars['Int'];
  hideInactivePosCustomers: Scalars['Boolean'];
  id: Scalars['Int'];
  inStorePickupEnabled: Scalars['Boolean'];
  integrationConfigurations?: Maybe<Array<Maybe<IntegrationConfiguration>>>;
  inventoryAdjustmentThreshold?: Maybe<Scalars['Int']>;
  inventoryAuditFiles?: Maybe<Array<Maybe<InventoryAuditFile>>>;
  inventoryAuditToBrands?: Maybe<Array<Maybe<InventoryAuditToBrand>>>;
  inventoryAuditToCategories?: Maybe<Array<Maybe<InventoryAuditToCategory>>>;
  inventoryAuditToRooms?: Maybe<Array<Maybe<InventoryAuditToRoom>>>;
  inventoryByRegister?: Maybe<Scalars['String']>;
  inventoryDisplayBy?: Maybe<Scalars['String']>;
  inventoryTransactions?: Maybe<Array<Maybe<InventoryTransaction>>>;
  invoiceStaticText?: Maybe<Scalars['String']>;
  isActive: Scalars['Boolean'];
  isLicensed: Scalars['Boolean'];
  isLive?: Maybe<Scalars['Boolean']>;
  isSandbox: Scalars['Boolean'];
  kioskOrderStatus?: Maybe<Scalars['String']>;
  latitude?: Maybe<Scalars['Decimal']>;
  leafControlInfos?: Maybe<Array<Maybe<LeafControlInfo>>>;
  leafLinkControlInfos?: Maybe<Array<Maybe<LeafLinkControlInfo>>>;
  linxControlInfos?: Maybe<Array<Maybe<LinxControlInfo>>>;
  liveDate?: Maybe<Scalars['DateTime']>;
  locationName?: Maybe<PlantRoomHistory>;
  logoUrl?: Maybe<Scalars['String']>;
  longitude?: Maybe<Scalars['Decimal']>;
  loyaltyPointAccumulationPercentage?: Maybe<Scalars['Decimal']>;
  loyaltyPointDollarValue?: Maybe<Scalars['Decimal']>;
  loyaltyPointRedeemValue?: Maybe<Scalars['Decimal']>;
  lspAcctLink?: Maybe<Scalars['Int']>;
  lspAcctLinkNavigation?: Maybe<TblAcct>;
  lspLocationsAddr1: Scalars['String'];
  lspLocationsAddr2?: Maybe<Scalars['String']>;
  lspLocationsCity: Scalars['String'];
  lspLocationsCode: Scalars['String'];
  lspLocationsName: Scalars['String'];
  lspLocationsPostalCode?: Maybe<Scalars['String']>;
  lspLocationsState?: Maybe<Scalars['String']>;
  lsplocationsConsolidator?: Maybe<Scalars['String']>;
  lsplocationsStuffingLocation?: Maybe<Scalars['String']>;
  managerDeleteItemFromCart?: Maybe<Scalars['String']>;
  maxDispensaryOzOutOfVault?: Maybe<Scalars['Decimal']>;
  maxDispensaryOzStrainOutOfVault?: Maybe<Scalars['Decimal']>;
  mdDoctors?: Maybe<Array<Maybe<MdDoctor>>>;
  mdManifests?: Maybe<Array<Maybe<MdManifest>>>;
  mdPosTerminals?: Maybe<Array<Maybe<MdPosTerminal>>>;
  mdcompanyFlag?: Maybe<Scalars['String']>;
  mdpricingHdrs?: Maybe<Array<Maybe<MdpricingHdr>>>;
  metrcProcessingJobTypes?: Maybe<Array<Maybe<MetrcProcessingJobType>>>;
  minimumCheckoutAge?: Maybe<Scalars['Int']>;
  mncontrolInfos?: Maybe<Array<Maybe<MncontrolInfo>>>;
  nextBatchNo?: Maybe<Scalars['Int']>;
  nightlyMgrEmail?: Maybe<Scalars['String']>;
  notifyStatus?: Maybe<Scalars['String']>;
  nutrientGroupNo?: Maybe<Scalars['Int']>;
  oeemail?: Maybe<Scalars['String']>;
  ofAge: Scalars['Int'];
  oiemail?: Maybe<Scalars['String']>;
  onFleetDeliveryCompletedStatus?: Maybe<Scalars['String']>;
  onlineOrderExpirationTime?: Maybe<Scalars['Int']>;
  orders?: Maybe<Array<Maybe<Order>>>;
  packageIdentityFormat?: Maybe<Scalars['String']>;
  packageToCustomerTypes?: Maybe<Array<Maybe<PackageToCustomerType>>>;
  packageToTags?: Maybe<Array<Maybe<PackageToTag>>>;
  packages?: Maybe<Array<Maybe<Package>>>;
  passwordDispensarySearch?: Maybe<Scalars['String']>;
  patientCylceDateType?: Maybe<Scalars['String']>;
  patientCylcleDays?: Maybe<Scalars['Int']>;
  phoneNo?: Maybe<Scalars['String']>;
  placeholderDirections?: Maybe<Scalars['String']>;
  plantId?: Maybe<Scalars['Int']>;
  plantLabelDesignator?: Maybe<Scalars['String']>;
  plantSerialNumberLength?: Maybe<Scalars['Int']>;
  pmpcontrolInfo?: Maybe<PmpcontrolInfo>;
  poapprovalThreshold?: Maybe<Scalars['Decimal']>;
  pos15DayAllowedOz?: Maybe<Scalars['Decimal']>;
  posdailyPassword?: Maybe<Scalars['String']>;
  posgramsOz?: Maybe<Scalars['String']>;
  posweightFlag?: Maybe<Scalars['String']>;
  preorderStatus?: Maybe<Scalars['String']>;
  prescriptionNo?: Maybe<Scalars['Int']>;
  printedInvoiceId?: Maybe<Scalars['Short']>;
  printedLabelDecimalPrecision?: Maybe<Scalars['Int']>;
  printedManifestId?: Maybe<Scalars['Short']>;
  productSkuFormat?: Maybe<Scalars['String']>;
  purchaseLimits?: Maybe<Array<Maybe<PurchaseLimit>>>;
  readyForDeliveryStatus?: Maybe<Scalars['String']>;
  receiptSettings?: Maybe<Array<Maybe<ReceiptSetting>>>;
  receiveInventoryHistories?: Maybe<Array<Maybe<ReceiveInventoryHistory>>>;
  reconZeroBalance?: Maybe<Scalars['String']>;
  reconcileFlag?: Maybe<Scalars['String']>;
  recreationaLimit?: Maybe<Scalars['Decimal']>;
  recreationalAllotment?: Maybe<Scalars['Decimal']>;
  recreationalTaxRate?: Maybe<Scalars['Decimal']>;
  registerLedgers?: Maybe<Array<Maybe<RegisterLedger>>>;
  registerLocations?: Maybe<Scalars['String']>;
  restrictWindowEnd?: Maybe<Scalars['TimeSpan']>;
  restrictWindowStart?: Maybe<Scalars['TimeSpan']>;
  roomTerminals?: Maybe<Array<Maybe<RoomTerminal>>>;
  roomToMenus?: Maybe<Array<Maybe<RoomToMenu>>>;
  routeStartedStatus?: Maybe<Scalars['String']>;
  serialNoMethod?: Maybe<Scalars['String']>;
  sessionTimeoutMinutes: Scalars['Int'];
  shareCustomerProfiles?: Maybe<Scalars['Boolean']>;
  showInternalBalances?: Maybe<Scalars['String']>;
  ssolocationName?: Maybe<Scalars['String']>;
  stateComplianceFlag?: Maybe<Scalars['Int']>;
  stopDate?: Maybe<Scalars['DateTime']>;
  storefrontKey?: Maybe<Scalars['String']>;
  storefrontUrl?: Maybe<Scalars['String']>;
  taxCoupons: Scalars['Boolean'];
  taxRates?: Maybe<Array<Maybe<TaxRate>>>;
  taxRt?: Maybe<Scalars['Decimal']>;
  taxRtNonCannibis?: Maybe<Scalars['Decimal']>;
  tblAccts?: Maybe<Array<Maybe<TblAcct>>>;
  tblAuthUsers?: Maybe<Array<Maybe<TblAuthUser>>>;
  tblBatchRooms?: Maybe<Array<Maybe<TblBatchRoom>>>;
  tblBatchTrays?: Maybe<Array<Maybe<TblBatchTray>>>;
  tblBatches?: Maybe<Array<Maybe<TblBatch>>>;
  tblDispensarySchedules?: Maybe<Array<Maybe<TblDispensarySchedule>>>;
  tblInventoryStatuses?: Maybe<Array<Maybe<TblInventoryStatus>>>;
  tblLspLocationsTblCountryCodes: Scalars['Int'];
  tblLspLocationsTblLsp: Scalars['Int'];
  tblLspLocationsTblLspNavigation?: Maybe<TblLsp>;
  tblMdcars?: Maybe<Array<Maybe<TblMdcar>>>;
  tblMddrivers?: Maybe<Array<Maybe<TblMddriver>>>;
  tblMdlabels?: Maybe<Array<Maybe<TblMdlabel>>>;
  tblMdorderDispensaryLocationNavigations?: Maybe<Array<Maybe<TblMdorder>>>;
  tblMdorderGrowerLocationNavigations?: Maybe<Array<Maybe<TblMdorder>>>;
  tblMdshipments?: Maybe<Array<Maybe<TblMdshipment>>>;
  templateUsed?: Maybe<Scalars['String']>;
  timeDiff?: Maybe<Scalars['Int']>;
  timeZoneId?: Maybe<Scalars['Byte']>;
  trymControlInfos?: Maybe<Array<Maybe<TrymControlInfo>>>;
  twilioPhoneNo?: Maybe<Scalars['String']>;
  undeliverableStatus?: Maybe<Scalars['String']>;
  useBiotrackPlantId?: Maybe<Scalars['String']>;
  useCachedPosproductSearch?: Maybe<Scalars['Boolean']>;
  useFulfillmentModel: Scalars['Boolean'];
  usePrintNode: Scalars['Boolean'];
  userGroups?: Maybe<Array<Maybe<UserGroup>>>;
  userToPermissions?: Maybe<Array<Maybe<UserToPermission>>>;
  vaultRegisterId?: Maybe<Scalars['Int']>;
  vendor?: Maybe<TblVendor>;
  vendorId?: Maybe<Scalars['Int']>;
  walkInEnabled: Scalars['Boolean'];
  wgtMustUseScale?: Maybe<Scalars['String']>;
  whichUnitCost?: Maybe<Scalars['String']>;
  whichUnitPrice?: Maybe<Scalars['String']>;
};

export type TblLspLocationFilterInput = {
  accountingLsp?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  accountingLspNavigation?: InputMaybe<TblLspFilterInput>;
  actualWeightThreshold?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  actualWeightThresholdUnitId?: InputMaybe<ComparableInt32OperationFilterInput>;
  adilasIntegrationControlInfos?: InputMaybe<ListFilterInputTypeOfAdilasIntegrationControlInfoFilterInput>;
  aeemail?: InputMaybe<StringOperationFilterInput>;
  aiemail?: InputMaybe<StringOperationFilterInput>;
  allEmail?: InputMaybe<StringOperationFilterInput>;
  allocatedInventories?: InputMaybe<ListFilterInputTypeOfAllocatedInventoryFilterInput>;
  alpineIqcontrolInfos?: InputMaybe<ListFilterInputTypeOfAlpineIqcontrolInfoFilterInput>;
  and?: InputMaybe<Array<TblLspLocationFilterInput>>;
  apiFlags?: InputMaybe<StringOperationFilterInput>;
  assemblies?: InputMaybe<ListFilterInputTypeOfAssemblyFilterInput>;
  autoCreateBatchMethod?: InputMaybe<ComparableInt32OperationFilterInput>;
  batchId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  batchIdentityFormat?: InputMaybe<StringOperationFilterInput>;
  bioTrackIntegration?: InputMaybe<StringOperationFilterInput>;
  bioTrackInventoryReceipt?: InputMaybe<StringOperationFilterInput>;
  biotrackProcessPlants?: InputMaybe<StringOperationFilterInput>;
  biotrackProcessSalesPatientNotInsystem?: InputMaybe<StringOperationFilterInput>;
  birchmountControlInfos?: InputMaybe<ListFilterInputTypeOfBirchmountControlInfoFilterInput>;
  cartPhoneDisclaimer?: InputMaybe<StringOperationFilterInput>;
  ccrscontrolInfos?: InputMaybe<ListFilterInputTypeOfCcrscontrolInfoFilterInput>;
  cfdcustomIdleImage?: InputMaybe<StringOperationFilterInput>;
  county?: InputMaybe<StringOperationFilterInput>;
  coupon?: InputMaybe<TblWhseProductFilterInput>;
  couponId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  crescoProcessingFeature?: InputMaybe<StringOperationFilterInput>;
  curbsidePickupEnabled?: InputMaybe<BooleanOperationFilterInput>;
  dcdirectControlInfos?: InputMaybe<ListFilterInputTypeOfDcdirectControlInfoFilterInput>;
  defaultConversionMultiplier?: InputMaybe<StringOperationFilterInput>;
  defaultCustomerTypeId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  defaultDeliveryWindowEnd?: InputMaybe<ComparableNullableOfTimeSpanOperationFilterInput>;
  defaultDeliveryWindowStart?: InputMaybe<ComparableNullableOfTimeSpanOperationFilterInput>;
  defaultExciseTax?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  defaultGrowerRegister?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  defaultGrowerRegisterNavigation?: InputMaybe<MdPosTerminalFilterInput>;
  defaultInvoicePrefix?: InputMaybe<StringOperationFilterInput>;
  defaultLabResultsUnit?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  defaultLabel?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  defaultLabelDpi?: InputMaybe<ComparableInt16OperationFilterInput>;
  defaultLoyaltyPoints?: InputMaybe<ComparableInt32OperationFilterInput>;
  defaultMarkupRate?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  defaultMinorAge?: InputMaybe<ComparableInt32OperationFilterInput>;
  defaultOrderSourceId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  defaultPaymentTerms?: InputMaybe<StringOperationFilterInput>;
  defaultPosStatus?: InputMaybe<StringOperationFilterInput>;
  defaultPostransactionExistingCustomer?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  defaultPostransactionExistingCustomerNavigation?: InputMaybe<TblWhseProductFilterInput>;
  defaultPostransactionNewCustomer?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  defaultPostransactionNewCustomerNavigation?: InputMaybe<TblWhseProductFilterInput>;
  defaultRecMinorAge?: InputMaybe<ComparableInt32OperationFilterInput>;
  defaultReceiptPrint?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  defaultReceiptPrintNavigation?: InputMaybe<TblMdlabelFilterInput>;
  defaultTerpenesLabResultsUnit?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  deliveryConcurrency?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  deliveryMaxConcentrateWeight?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  deliveryMaxIctinventoryDollars?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  deliveryMaxTotalInventoryDollars?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  deliveryMaxTotalWeight?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  deliveryProvider?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  deliveryStatus?: InputMaybe<StringOperationFilterInput>;
  deliveryZones?: InputMaybe<ListFilterInputTypeOfDeliveryZoneFilterInput>;
  demoAddr1?: InputMaybe<StringOperationFilterInput>;
  demoName?: InputMaybe<StringOperationFilterInput>;
  doNotAllowReturns?: InputMaybe<StringOperationFilterInput>;
  doingBusinessAs?: InputMaybe<StringOperationFilterInput>;
  exciseTax?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  excludeFromVolumeDiscount?: InputMaybe<StringOperationFilterInput>;
  feeDonations?: InputMaybe<ListFilterInputTypeOfFeeDonationFilterInput>;
  fgrecons?: InputMaybe<ListFilterInputTypeOfFgreconFilterInput>;
  fullStoryId?: InputMaybe<StringOperationFilterInput>;
  globalId?: InputMaybe<ComparableGuidOperationFilterInput>;
  guestListRefreshRate?: InputMaybe<ComparableInt32OperationFilterInput>;
  hideInactivePosCustomers?: InputMaybe<BooleanOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  inStorePickupEnabled?: InputMaybe<BooleanOperationFilterInput>;
  integrationConfigurations?: InputMaybe<ListFilterInputTypeOfIntegrationConfigurationFilterInput>;
  inventoryAdjustmentThreshold?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  inventoryAuditFiles?: InputMaybe<ListFilterInputTypeOfInventoryAuditFileFilterInput>;
  inventoryAuditToBrands?: InputMaybe<ListFilterInputTypeOfInventoryAuditToBrandFilterInput>;
  inventoryAuditToCategories?: InputMaybe<ListFilterInputTypeOfInventoryAuditToCategoryFilterInput>;
  inventoryAuditToRooms?: InputMaybe<ListFilterInputTypeOfInventoryAuditToRoomFilterInput>;
  inventoryByRegister?: InputMaybe<StringOperationFilterInput>;
  inventoryDisplayBy?: InputMaybe<StringOperationFilterInput>;
  inventoryTransactions?: InputMaybe<ListFilterInputTypeOfInventoryTransactionFilterInput>;
  invoiceStaticText?: InputMaybe<StringOperationFilterInput>;
  isActive?: InputMaybe<BooleanOperationFilterInput>;
  isLicensed?: InputMaybe<BooleanOperationFilterInput>;
  isLive?: InputMaybe<BooleanOperationFilterInput>;
  isSandbox?: InputMaybe<BooleanOperationFilterInput>;
  kioskOrderStatus?: InputMaybe<StringOperationFilterInput>;
  latitude?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  leafControlInfos?: InputMaybe<ListFilterInputTypeOfLeafControlInfoFilterInput>;
  leafLinkControlInfos?: InputMaybe<ListFilterInputTypeOfLeafLinkControlInfoFilterInput>;
  linxControlInfos?: InputMaybe<ListFilterInputTypeOfLinxControlInfoFilterInput>;
  liveDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  locationName?: InputMaybe<PlantRoomHistoryFilterInput>;
  logoUrl?: InputMaybe<StringOperationFilterInput>;
  longitude?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  loyaltyPointAccumulationPercentage?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  loyaltyPointDollarValue?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  loyaltyPointRedeemValue?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  lspAcctLink?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  lspAcctLinkNavigation?: InputMaybe<TblAcctFilterInput>;
  lspLocationsAddr1?: InputMaybe<StringOperationFilterInput>;
  lspLocationsAddr2?: InputMaybe<StringOperationFilterInput>;
  lspLocationsCity?: InputMaybe<StringOperationFilterInput>;
  lspLocationsCode?: InputMaybe<StringOperationFilterInput>;
  lspLocationsName?: InputMaybe<StringOperationFilterInput>;
  lspLocationsPostalCode?: InputMaybe<StringOperationFilterInput>;
  lspLocationsState?: InputMaybe<StringOperationFilterInput>;
  lsplocationsConsolidator?: InputMaybe<StringOperationFilterInput>;
  lsplocationsStuffingLocation?: InputMaybe<StringOperationFilterInput>;
  managerDeleteItemFromCart?: InputMaybe<StringOperationFilterInput>;
  maxDispensaryOzOutOfVault?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  maxDispensaryOzStrainOutOfVault?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  mdDoctors?: InputMaybe<ListFilterInputTypeOfMdDoctorFilterInput>;
  mdManifests?: InputMaybe<ListFilterInputTypeOfMdManifestFilterInput>;
  mdPosTerminals?: InputMaybe<ListFilterInputTypeOfMdPosTerminalFilterInput>;
  mdcompanyFlag?: InputMaybe<StringOperationFilterInput>;
  mdpricingHdrs?: InputMaybe<ListFilterInputTypeOfMdpricingHdrFilterInput>;
  metrcProcessingJobTypes?: InputMaybe<ListFilterInputTypeOfMetrcProcessingJobTypeFilterInput>;
  minimumCheckoutAge?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  mncontrolInfos?: InputMaybe<ListFilterInputTypeOfMncontrolInfoFilterInput>;
  nextBatchNo?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  nightlyMgrEmail?: InputMaybe<StringOperationFilterInput>;
  notifyStatus?: InputMaybe<StringOperationFilterInput>;
  nutrientGroupNo?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  oeemail?: InputMaybe<StringOperationFilterInput>;
  ofAge?: InputMaybe<ComparableInt32OperationFilterInput>;
  oiemail?: InputMaybe<StringOperationFilterInput>;
  onFleetDeliveryCompletedStatus?: InputMaybe<StringOperationFilterInput>;
  onlineOrderExpirationTime?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  or?: InputMaybe<Array<TblLspLocationFilterInput>>;
  orders?: InputMaybe<ListFilterInputTypeOfOrderFilterInput>;
  packageIdentityFormat?: InputMaybe<StringOperationFilterInput>;
  packageToCustomerTypes?: InputMaybe<ListFilterInputTypeOfPackageToCustomerTypeFilterInput>;
  packageToTags?: InputMaybe<ListFilterInputTypeOfPackageToTagFilterInput>;
  packages?: InputMaybe<ListFilterInputTypeOfPackageFilterInput>;
  passwordDispensarySearch?: InputMaybe<StringOperationFilterInput>;
  patientCylceDateType?: InputMaybe<StringOperationFilterInput>;
  patientCylcleDays?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  phoneNo?: InputMaybe<StringOperationFilterInput>;
  placeholderDirections?: InputMaybe<StringOperationFilterInput>;
  plantId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  plantLabelDesignator?: InputMaybe<StringOperationFilterInput>;
  plantSerialNumberLength?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  pmpcontrolInfo?: InputMaybe<PmpcontrolInfoFilterInput>;
  poapprovalThreshold?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  pos15DayAllowedOz?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  posdailyPassword?: InputMaybe<StringOperationFilterInput>;
  posgramsOz?: InputMaybe<StringOperationFilterInput>;
  posweightFlag?: InputMaybe<StringOperationFilterInput>;
  preorderStatus?: InputMaybe<StringOperationFilterInput>;
  prescriptionNo?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  printedInvoiceId?: InputMaybe<ComparableNullableOfInt16OperationFilterInput>;
  printedLabelDecimalPrecision?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  printedManifestId?: InputMaybe<ComparableNullableOfInt16OperationFilterInput>;
  productSkuFormat?: InputMaybe<StringOperationFilterInput>;
  purchaseLimits?: InputMaybe<ListFilterInputTypeOfPurchaseLimitFilterInput>;
  readyForDeliveryStatus?: InputMaybe<StringOperationFilterInput>;
  receiptSettings?: InputMaybe<ListFilterInputTypeOfReceiptSettingFilterInput>;
  receiveInventoryHistories?: InputMaybe<ListFilterInputTypeOfReceiveInventoryHistoryFilterInput>;
  reconZeroBalance?: InputMaybe<StringOperationFilterInput>;
  reconcileFlag?: InputMaybe<StringOperationFilterInput>;
  recreationaLimit?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  recreationalAllotment?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  recreationalTaxRate?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  registerLedgers?: InputMaybe<ListFilterInputTypeOfRegisterLedgerFilterInput>;
  registerLocations?: InputMaybe<StringOperationFilterInput>;
  restrictWindowEnd?: InputMaybe<ComparableNullableOfTimeSpanOperationFilterInput>;
  restrictWindowStart?: InputMaybe<ComparableNullableOfTimeSpanOperationFilterInput>;
  roomTerminals?: InputMaybe<ListFilterInputTypeOfRoomTerminalFilterInput>;
  roomToMenus?: InputMaybe<ListFilterInputTypeOfRoomToMenuFilterInput>;
  routeStartedStatus?: InputMaybe<StringOperationFilterInput>;
  serialNoMethod?: InputMaybe<StringOperationFilterInput>;
  sessionTimeoutMinutes?: InputMaybe<ComparableInt32OperationFilterInput>;
  shareCustomerProfiles?: InputMaybe<BooleanOperationFilterInput>;
  showInternalBalances?: InputMaybe<StringOperationFilterInput>;
  ssolocationName?: InputMaybe<StringOperationFilterInput>;
  stateComplianceFlag?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  stopDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  storefrontKey?: InputMaybe<StringOperationFilterInput>;
  storefrontUrl?: InputMaybe<StringOperationFilterInput>;
  taxCoupons?: InputMaybe<BooleanOperationFilterInput>;
  taxRates?: InputMaybe<ListFilterInputTypeOfTaxRateFilterInput>;
  taxRt?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  taxRtNonCannibis?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  tblAccts?: InputMaybe<ListFilterInputTypeOfTblAcctFilterInput>;
  tblAuthUsers?: InputMaybe<ListFilterInputTypeOfTblAuthUserFilterInput>;
  tblBatchRooms?: InputMaybe<ListFilterInputTypeOfTblBatchRoomFilterInput>;
  tblBatchTrays?: InputMaybe<ListFilterInputTypeOfTblBatchTrayFilterInput>;
  tblBatches?: InputMaybe<ListFilterInputTypeOfTblBatchFilterInput>;
  tblDispensarySchedules?: InputMaybe<ListFilterInputTypeOfTblDispensaryScheduleFilterInput>;
  tblInventoryStatuses?: InputMaybe<ListFilterInputTypeOfTblInventoryStatusFilterInput>;
  tblLspLocationsTblCountryCodes?: InputMaybe<ComparableInt32OperationFilterInput>;
  tblLspLocationsTblLsp?: InputMaybe<ComparableInt32OperationFilterInput>;
  tblLspLocationsTblLspNavigation?: InputMaybe<TblLspFilterInput>;
  tblMdcars?: InputMaybe<ListFilterInputTypeOfTblMdcarFilterInput>;
  tblMddrivers?: InputMaybe<ListFilterInputTypeOfTblMddriverFilterInput>;
  tblMdlabels?: InputMaybe<ListFilterInputTypeOfTblMdlabelFilterInput>;
  tblMdorderDispensaryLocationNavigations?: InputMaybe<ListFilterInputTypeOfTblMdorderFilterInput>;
  tblMdorderGrowerLocationNavigations?: InputMaybe<ListFilterInputTypeOfTblMdorderFilterInput>;
  tblMdshipments?: InputMaybe<ListFilterInputTypeOfTblMdshipmentFilterInput>;
  templateUsed?: InputMaybe<StringOperationFilterInput>;
  timeDiff?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  timeZoneId?: InputMaybe<ComparableNullableOfByteOperationFilterInput>;
  trymControlInfos?: InputMaybe<ListFilterInputTypeOfTrymControlInfoFilterInput>;
  twilioPhoneNo?: InputMaybe<StringOperationFilterInput>;
  undeliverableStatus?: InputMaybe<StringOperationFilterInput>;
  useBiotrackPlantId?: InputMaybe<StringOperationFilterInput>;
  useCachedPosproductSearch?: InputMaybe<BooleanOperationFilterInput>;
  useFulfillmentModel?: InputMaybe<BooleanOperationFilterInput>;
  usePrintNode?: InputMaybe<BooleanOperationFilterInput>;
  userGroups?: InputMaybe<ListFilterInputTypeOfUserGroupFilterInput>;
  userToPermissions?: InputMaybe<ListFilterInputTypeOfUserToPermissionFilterInput>;
  vaultRegisterId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  vendor?: InputMaybe<TblVendorFilterInput>;
  vendorId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  walkInEnabled?: InputMaybe<BooleanOperationFilterInput>;
  wgtMustUseScale?: InputMaybe<StringOperationFilterInput>;
  whichUnitCost?: InputMaybe<StringOperationFilterInput>;
  whichUnitPrice?: InputMaybe<StringOperationFilterInput>;
};

export type TblLspLocationSortInput = {
  accountingLsp?: InputMaybe<SortEnumType>;
  accountingLspNavigation?: InputMaybe<TblLspSortInput>;
  actualWeightThreshold?: InputMaybe<SortEnumType>;
  actualWeightThresholdUnitId?: InputMaybe<SortEnumType>;
  aeemail?: InputMaybe<SortEnumType>;
  aiemail?: InputMaybe<SortEnumType>;
  allEmail?: InputMaybe<SortEnumType>;
  apiFlags?: InputMaybe<SortEnumType>;
  autoCreateBatchMethod?: InputMaybe<SortEnumType>;
  batchId?: InputMaybe<SortEnumType>;
  batchIdentityFormat?: InputMaybe<SortEnumType>;
  bioTrackIntegration?: InputMaybe<SortEnumType>;
  bioTrackInventoryReceipt?: InputMaybe<SortEnumType>;
  biotrackProcessPlants?: InputMaybe<SortEnumType>;
  biotrackProcessSalesPatientNotInsystem?: InputMaybe<SortEnumType>;
  cartPhoneDisclaimer?: InputMaybe<SortEnumType>;
  cfdcustomIdleImage?: InputMaybe<SortEnumType>;
  county?: InputMaybe<SortEnumType>;
  coupon?: InputMaybe<TblWhseProductSortInput>;
  couponId?: InputMaybe<SortEnumType>;
  crescoProcessingFeature?: InputMaybe<SortEnumType>;
  curbsidePickupEnabled?: InputMaybe<SortEnumType>;
  defaultConversionMultiplier?: InputMaybe<SortEnumType>;
  defaultCustomerTypeId?: InputMaybe<SortEnumType>;
  defaultDeliveryWindowEnd?: InputMaybe<SortEnumType>;
  defaultDeliveryWindowStart?: InputMaybe<SortEnumType>;
  defaultExciseTax?: InputMaybe<SortEnumType>;
  defaultGrowerRegister?: InputMaybe<SortEnumType>;
  defaultGrowerRegisterNavigation?: InputMaybe<MdPosTerminalSortInput>;
  defaultInvoicePrefix?: InputMaybe<SortEnumType>;
  defaultLabResultsUnit?: InputMaybe<SortEnumType>;
  defaultLabel?: InputMaybe<SortEnumType>;
  defaultLabelDpi?: InputMaybe<SortEnumType>;
  defaultLoyaltyPoints?: InputMaybe<SortEnumType>;
  defaultMarkupRate?: InputMaybe<SortEnumType>;
  defaultMinorAge?: InputMaybe<SortEnumType>;
  defaultOrderSourceId?: InputMaybe<SortEnumType>;
  defaultPaymentTerms?: InputMaybe<SortEnumType>;
  defaultPosStatus?: InputMaybe<SortEnumType>;
  defaultPostransactionExistingCustomer?: InputMaybe<SortEnumType>;
  defaultPostransactionExistingCustomerNavigation?: InputMaybe<TblWhseProductSortInput>;
  defaultPostransactionNewCustomer?: InputMaybe<SortEnumType>;
  defaultPostransactionNewCustomerNavigation?: InputMaybe<TblWhseProductSortInput>;
  defaultRecMinorAge?: InputMaybe<SortEnumType>;
  defaultReceiptPrint?: InputMaybe<SortEnumType>;
  defaultReceiptPrintNavigation?: InputMaybe<TblMdlabelSortInput>;
  defaultTerpenesLabResultsUnit?: InputMaybe<SortEnumType>;
  deliveryConcurrency?: InputMaybe<SortEnumType>;
  deliveryMaxConcentrateWeight?: InputMaybe<SortEnumType>;
  deliveryMaxIctinventoryDollars?: InputMaybe<SortEnumType>;
  deliveryMaxTotalInventoryDollars?: InputMaybe<SortEnumType>;
  deliveryMaxTotalWeight?: InputMaybe<SortEnumType>;
  deliveryProvider?: InputMaybe<SortEnumType>;
  deliveryStatus?: InputMaybe<SortEnumType>;
  demoAddr1?: InputMaybe<SortEnumType>;
  demoName?: InputMaybe<SortEnumType>;
  doNotAllowReturns?: InputMaybe<SortEnumType>;
  doingBusinessAs?: InputMaybe<SortEnumType>;
  exciseTax?: InputMaybe<SortEnumType>;
  excludeFromVolumeDiscount?: InputMaybe<SortEnumType>;
  fullStoryId?: InputMaybe<SortEnumType>;
  globalId?: InputMaybe<SortEnumType>;
  guestListRefreshRate?: InputMaybe<SortEnumType>;
  hideInactivePosCustomers?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  inStorePickupEnabled?: InputMaybe<SortEnumType>;
  inventoryAdjustmentThreshold?: InputMaybe<SortEnumType>;
  inventoryByRegister?: InputMaybe<SortEnumType>;
  inventoryDisplayBy?: InputMaybe<SortEnumType>;
  invoiceStaticText?: InputMaybe<SortEnumType>;
  isActive?: InputMaybe<SortEnumType>;
  isLicensed?: InputMaybe<SortEnumType>;
  isLive?: InputMaybe<SortEnumType>;
  isSandbox?: InputMaybe<SortEnumType>;
  kioskOrderStatus?: InputMaybe<SortEnumType>;
  latitude?: InputMaybe<SortEnumType>;
  liveDate?: InputMaybe<SortEnumType>;
  locationName?: InputMaybe<PlantRoomHistorySortInput>;
  logoUrl?: InputMaybe<SortEnumType>;
  longitude?: InputMaybe<SortEnumType>;
  loyaltyPointAccumulationPercentage?: InputMaybe<SortEnumType>;
  loyaltyPointDollarValue?: InputMaybe<SortEnumType>;
  loyaltyPointRedeemValue?: InputMaybe<SortEnumType>;
  lspAcctLink?: InputMaybe<SortEnumType>;
  lspAcctLinkNavigation?: InputMaybe<TblAcctSortInput>;
  lspLocationsAddr1?: InputMaybe<SortEnumType>;
  lspLocationsAddr2?: InputMaybe<SortEnumType>;
  lspLocationsCity?: InputMaybe<SortEnumType>;
  lspLocationsCode?: InputMaybe<SortEnumType>;
  lspLocationsName?: InputMaybe<SortEnumType>;
  lspLocationsPostalCode?: InputMaybe<SortEnumType>;
  lspLocationsState?: InputMaybe<SortEnumType>;
  lsplocationsConsolidator?: InputMaybe<SortEnumType>;
  lsplocationsStuffingLocation?: InputMaybe<SortEnumType>;
  managerDeleteItemFromCart?: InputMaybe<SortEnumType>;
  maxDispensaryOzOutOfVault?: InputMaybe<SortEnumType>;
  maxDispensaryOzStrainOutOfVault?: InputMaybe<SortEnumType>;
  mdcompanyFlag?: InputMaybe<SortEnumType>;
  minimumCheckoutAge?: InputMaybe<SortEnumType>;
  nextBatchNo?: InputMaybe<SortEnumType>;
  nightlyMgrEmail?: InputMaybe<SortEnumType>;
  notifyStatus?: InputMaybe<SortEnumType>;
  nutrientGroupNo?: InputMaybe<SortEnumType>;
  oeemail?: InputMaybe<SortEnumType>;
  ofAge?: InputMaybe<SortEnumType>;
  oiemail?: InputMaybe<SortEnumType>;
  onFleetDeliveryCompletedStatus?: InputMaybe<SortEnumType>;
  onlineOrderExpirationTime?: InputMaybe<SortEnumType>;
  packageIdentityFormat?: InputMaybe<SortEnumType>;
  passwordDispensarySearch?: InputMaybe<SortEnumType>;
  patientCylceDateType?: InputMaybe<SortEnumType>;
  patientCylcleDays?: InputMaybe<SortEnumType>;
  phoneNo?: InputMaybe<SortEnumType>;
  placeholderDirections?: InputMaybe<SortEnumType>;
  plantId?: InputMaybe<SortEnumType>;
  plantLabelDesignator?: InputMaybe<SortEnumType>;
  plantSerialNumberLength?: InputMaybe<SortEnumType>;
  pmpcontrolInfo?: InputMaybe<PmpcontrolInfoSortInput>;
  poapprovalThreshold?: InputMaybe<SortEnumType>;
  pos15DayAllowedOz?: InputMaybe<SortEnumType>;
  posdailyPassword?: InputMaybe<SortEnumType>;
  posgramsOz?: InputMaybe<SortEnumType>;
  posweightFlag?: InputMaybe<SortEnumType>;
  preorderStatus?: InputMaybe<SortEnumType>;
  prescriptionNo?: InputMaybe<SortEnumType>;
  printedInvoiceId?: InputMaybe<SortEnumType>;
  printedLabelDecimalPrecision?: InputMaybe<SortEnumType>;
  printedManifestId?: InputMaybe<SortEnumType>;
  productSkuFormat?: InputMaybe<SortEnumType>;
  readyForDeliveryStatus?: InputMaybe<SortEnumType>;
  reconZeroBalance?: InputMaybe<SortEnumType>;
  reconcileFlag?: InputMaybe<SortEnumType>;
  recreationaLimit?: InputMaybe<SortEnumType>;
  recreationalAllotment?: InputMaybe<SortEnumType>;
  recreationalTaxRate?: InputMaybe<SortEnumType>;
  registerLocations?: InputMaybe<SortEnumType>;
  restrictWindowEnd?: InputMaybe<SortEnumType>;
  restrictWindowStart?: InputMaybe<SortEnumType>;
  routeStartedStatus?: InputMaybe<SortEnumType>;
  serialNoMethod?: InputMaybe<SortEnumType>;
  sessionTimeoutMinutes?: InputMaybe<SortEnumType>;
  shareCustomerProfiles?: InputMaybe<SortEnumType>;
  showInternalBalances?: InputMaybe<SortEnumType>;
  ssolocationName?: InputMaybe<SortEnumType>;
  stateComplianceFlag?: InputMaybe<SortEnumType>;
  stopDate?: InputMaybe<SortEnumType>;
  storefrontKey?: InputMaybe<SortEnumType>;
  storefrontUrl?: InputMaybe<SortEnumType>;
  taxCoupons?: InputMaybe<SortEnumType>;
  taxRt?: InputMaybe<SortEnumType>;
  taxRtNonCannibis?: InputMaybe<SortEnumType>;
  tblLspLocationsTblCountryCodes?: InputMaybe<SortEnumType>;
  tblLspLocationsTblLsp?: InputMaybe<SortEnumType>;
  tblLspLocationsTblLspNavigation?: InputMaybe<TblLspSortInput>;
  templateUsed?: InputMaybe<SortEnumType>;
  timeDiff?: InputMaybe<SortEnumType>;
  timeZoneId?: InputMaybe<SortEnumType>;
  twilioPhoneNo?: InputMaybe<SortEnumType>;
  undeliverableStatus?: InputMaybe<SortEnumType>;
  useBiotrackPlantId?: InputMaybe<SortEnumType>;
  useCachedPosproductSearch?: InputMaybe<SortEnumType>;
  useFulfillmentModel?: InputMaybe<SortEnumType>;
  usePrintNode?: InputMaybe<SortEnumType>;
  vaultRegisterId?: InputMaybe<SortEnumType>;
  vendor?: InputMaybe<TblVendorSortInput>;
  vendorId?: InputMaybe<SortEnumType>;
  walkInEnabled?: InputMaybe<SortEnumType>;
  wgtMustUseScale?: InputMaybe<SortEnumType>;
  whichUnitCost?: InputMaybe<SortEnumType>;
  whichUnitPrice?: InputMaybe<SortEnumType>;
};

export type TblLspSortInput = {
  apbatchNo?: InputMaybe<SortEnumType>;
  apbreak1?: InputMaybe<SortEnumType>;
  apbreak2?: InputMaybe<SortEnumType>;
  apbreak3?: InputMaybe<SortEnumType>;
  apbreak4?: InputMaybe<SortEnumType>;
  apbreak5?: InputMaybe<SortEnumType>;
  apcontra?: InputMaybe<SortEnumType>;
  appostBgroupByVendor?: InputMaybe<SortEnumType>;
  arbatchNo?: InputMaybe<SortEnumType>;
  arbreak1?: InputMaybe<SortEnumType>;
  arbreak2?: InputMaybe<SortEnumType>;
  arbreak3?: InputMaybe<SortEnumType>;
  arbreak4?: InputMaybe<SortEnumType>;
  arbreak5?: InputMaybe<SortEnumType>;
  bankReconNo?: InputMaybe<SortEnumType>;
  brokerAdd1?: InputMaybe<SortEnumType>;
  brokerCity?: InputMaybe<SortEnumType>;
  brokerCountry?: InputMaybe<SortEnumType>;
  brokerEmail?: InputMaybe<SortEnumType>;
  brokerFax?: InputMaybe<SortEnumType>;
  brokerName?: InputMaybe<SortEnumType>;
  brokerPhone?: InputMaybe<SortEnumType>;
  brokerPostal?: InputMaybe<SortEnumType>;
  brokerState?: InputMaybe<SortEnumType>;
  daysInCycle?: InputMaybe<SortEnumType>;
  defaultStatusEmail?: InputMaybe<SortEnumType>;
  demoAddr1?: InputMaybe<SortEnumType>;
  demoName?: InputMaybe<SortEnumType>;
  fullStoryId?: InputMaybe<SortEnumType>;
  globalId?: InputMaybe<SortEnumType>;
  helpDeskUrl?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isActive?: InputMaybe<SortEnumType>;
  lookerUserLimit?: InputMaybe<SortEnumType>;
  lspAcctLsp?: InputMaybe<TblLspSortInput>;
  lspAcctLspId?: InputMaybe<SortEnumType>;
  lspAddress?: InputMaybe<SortEnumType>;
  lspAllowAutGenWhseRecFromShip?: InputMaybe<SortEnumType>;
  lspAllowAutoGenMasterFromShip?: InputMaybe<SortEnumType>;
  lspAllowAutoGenPickupFromWhseShip?: InputMaybe<SortEnumType>;
  lspAllowAutoGenShipFromPickup?: InputMaybe<SortEnumType>;
  lspCity?: InputMaybe<SortEnumType>;
  lspCode?: InputMaybe<SortEnumType>;
  lspConsolidator?: InputMaybe<SortEnumType>;
  lspContainerStuffingLoc?: InputMaybe<SortEnumType>;
  lspHouseIncludeOrg?: InputMaybe<SortEnumType>;
  lspHouseNo?: InputMaybe<SortEnumType>;
  lspHousePrefix?: InputMaybe<SortEnumType>;
  lspIdentificationNo?: InputMaybe<SortEnumType>;
  lspIdentificationNoValue?: InputMaybe<SortEnumType>;
  lspInvoiceCntByHouse?: InputMaybe<SortEnumType>;
  lspInvoiceIncludeHouseNo?: InputMaybe<SortEnumType>;
  lspInvoiceIncludeHouseOrg?: InputMaybe<SortEnumType>;
  lspInvoiceNo?: InputMaybe<SortEnumType>;
  lspInvoicePrefix?: InputMaybe<SortEnumType>;
  lspIsfno?: InputMaybe<SortEnumType>;
  lspMasterIncludeOrg?: InputMaybe<SortEnumType>;
  lspMasterNo?: InputMaybe<SortEnumType>;
  lspMasterPrefix?: InputMaybe<SortEnumType>;
  lspName?: InputMaybe<SortEnumType>;
  lspPasswordExpiration?: InputMaybe<SortEnumType>;
  lspPasswordExpirationEnabled?: InputMaybe<SortEnumType>;
  lspPasswordLength?: InputMaybe<SortEnumType>;
  lspPasswordLengthEnabled?: InputMaybe<SortEnumType>;
  lspPickupIncludeOrg?: InputMaybe<SortEnumType>;
  lspPickupNo?: InputMaybe<SortEnumType>;
  lspPickupPrefix?: InputMaybe<SortEnumType>;
  lspPlanSeqNo?: InputMaybe<SortEnumType>;
  lspPostalCode?: InputMaybe<SortEnumType>;
  lspProductAcctLink?: InputMaybe<SortEnumType>;
  lspProductAcctLinkNavigation?: InputMaybe<TblAcctSortInput>;
  lspState?: InputMaybe<SortEnumType>;
  mdhideCannabisType?: InputMaybe<SortEnumType>;
  mdhideMgrApproval?: InputMaybe<SortEnumType>;
  mdlabelNo?: InputMaybe<SortEnumType>;
  mdtaxRt?: InputMaybe<SortEnumType>;
  mjstateIdno?: InputMaybe<SortEnumType>;
  orgId?: InputMaybe<SortEnumType>;
  patientMaxFlag?: InputMaybe<SortEnumType>;
  registerLocations?: InputMaybe<SortEnumType>;
  shareCustomerProfiles?: InputMaybe<SortEnumType>;
  takeInventorySnapshots?: InputMaybe<SortEnumType>;
  tblLspTblCountryCodes?: InputMaybe<SortEnumType>;
  tblLspTblStatus?: InputMaybe<SortEnumType>;
  useCycleDate?: InputMaybe<SortEnumType>;
  userPinLength?: InputMaybe<SortEnumType>;
};

export type TblMdbatchPlantId = {
  acctId?: Maybe<Scalars['Int']>;
  addedToHarvestOn?: Maybe<Scalars['DateTime']>;
  batch?: Maybe<TblBatch>;
  batchId: Scalars['Int'];
  bioTbarcodeId?: Maybe<Scalars['String']>;
  bioTcureId?: Maybe<Scalars['String']>;
  bioTlotNo?: Maybe<Scalars['String']>;
  bioTparentId?: Maybe<Scalars['String']>;
  bioTplantBarcodeId?: Maybe<Scalars['String']>;
  bornDate?: Maybe<Scalars['DateTime']>;
  budWgt?: Maybe<Scalars['Decimal']>;
  createDt?: Maybe<Scalars['DateTime']>;
  currentHeight?: Maybe<Scalars['Decimal']>;
  currentRoom?: Maybe<Scalars['Int']>;
  currentRoomNavigation?: Maybe<TblBatchRoom>;
  currentTray?: Maybe<Scalars['Int']>;
  currentTrayNavigation?: Maybe<TblBatchTray>;
  currentWeight?: Maybe<Scalars['Decimal']>;
  cuttingsComment?: Maybe<Scalars['String']>;
  destroyedReasonCode?: Maybe<Scalars['Int']>;
  dryWgt?: Maybe<Scalars['Decimal']>;
  externalId?: Maybe<Scalars['String']>;
  genoType?: Maybe<Scalars['String']>;
  growthPhases?: Maybe<Array<Maybe<PlantStageTransition>>>;
  harvestDate?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  inverseSeedling?: Maybe<Array<Maybe<TblMdbatchPlantId>>>;
  lastModifiedDate?: Maybe<Scalars['DateTime']>;
  lastScanDate?: Maybe<Scalars['DateTime']>;
  locId?: Maybe<Scalars['Int']>;
  lspId?: Maybe<Scalars['Int']>;
  metrcWeights?: Maybe<ReportedPlantWeight>;
  motherPlant?: Maybe<Scalars['String']>;
  motherPlantData?: Maybe<TblMdbatchPlantId>;
  motherPlantId?: Maybe<Scalars['Int']>;
  nutrientLog?: Maybe<Array<Maybe<PlantNutrientLog>>>;
  pcounter?: Maybe<Scalars['Int']>;
  phenoType?: Maybe<Scalars['String']>;
  plantDestroyedComment?: Maybe<Scalars['String']>;
  plantDestroyedDate?: Maybe<Scalars['DateTime']>;
  plantGroup?: Maybe<Scalars['String']>;
  plantGroupId?: Maybe<Scalars['Int']>;
  plantPhaseResults?: Maybe<PlantPhasesResults>;
  plantSerialNo?: Maybe<Scalars['String']>;
  plantStage?: Maybe<Scalars['String']>;
  plantStatus: Scalars['String'];
  plantType?: Maybe<Scalars['String']>;
  plantVerified?: Maybe<Scalars['DateTime']>;
  plantVerifiedFlag?: Maybe<Scalars['String']>;
  reconId?: Maybe<Scalars['Int']>;
  reconcileVerifiedFlag?: Maybe<Scalars['String']>;
  replacementMother?: Maybe<Scalars['String']>;
  roomHistory?: Maybe<Array<Maybe<PlantRoomHistory>>>;
  seedling?: Maybe<TblMdbatchPlantId>;
  seedlingId?: Maybe<Scalars['Int']>;
  strain?: Maybe<TblBatchStrain>;
  strainId?: Maybe<Scalars['Int']>;
  tags?: Maybe<Array<Maybe<CultivationMetadataTag>>>;
  transferredToPackageId?: Maybe<Scalars['Int']>;
  trimDate?: Maybe<Scalars['DateTime']>;
  trimWasteWgt?: Maybe<Scalars['Decimal']>;
  trimWgt?: Maybe<Scalars['Decimal']>;
  wasteId?: Maybe<Scalars['Int']>;
  wasteWgt?: Maybe<Scalars['Decimal']>;
  weekPlanted?: Maybe<Scalars['Int']>;
  wetWgt?: Maybe<Scalars['Decimal']>;
};

export type TblMdbatchPlantIdCollectionSegment = {
  items?: Maybe<Array<Maybe<TblMdbatchPlantId>>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

export type TblMdbatchPlantIdFilterInput = {
  acctId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  addedToHarvestOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  and?: InputMaybe<Array<TblMdbatchPlantIdFilterInput>>;
  batch?: InputMaybe<TblBatchFilterInput>;
  batchId?: InputMaybe<ComparableInt32OperationFilterInput>;
  bioTbarcodeId?: InputMaybe<StringOperationFilterInput>;
  bioTcureId?: InputMaybe<StringOperationFilterInput>;
  bioTlotNo?: InputMaybe<StringOperationFilterInput>;
  bioTparentId?: InputMaybe<StringOperationFilterInput>;
  bioTplantBarcodeId?: InputMaybe<StringOperationFilterInput>;
  bornDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  budWgt?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  createDt?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  currentHeight?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  currentRoom?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  currentRoomNavigation?: InputMaybe<TblBatchRoomFilterInput>;
  currentTray?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  currentTrayNavigation?: InputMaybe<TblBatchTrayFilterInput>;
  currentWeight?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  cuttingsComment?: InputMaybe<StringOperationFilterInput>;
  destroyedReasonCode?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  dryWgt?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  externalId?: InputMaybe<StringOperationFilterInput>;
  genoType?: InputMaybe<StringOperationFilterInput>;
  growthPhases?: InputMaybe<ListFilterInputTypeOfPlantStageTransitionFilterInput>;
  harvestDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  inverseSeedling?: InputMaybe<ListFilterInputTypeOfTblMdbatchPlantIdFilterInput>;
  lastModifiedDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  lastScanDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  locId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  lspId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  metrcWeights?: InputMaybe<ReportedPlantWeightFilterInput>;
  motherPlant?: InputMaybe<StringOperationFilterInput>;
  motherPlantData?: InputMaybe<TblMdbatchPlantIdFilterInput>;
  motherPlantId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  nutrientLog?: InputMaybe<ListFilterInputTypeOfPlantNutrientLogFilterInput>;
  or?: InputMaybe<Array<TblMdbatchPlantIdFilterInput>>;
  pcounter?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  phenoType?: InputMaybe<StringOperationFilterInput>;
  plantDestroyedComment?: InputMaybe<StringOperationFilterInput>;
  plantDestroyedDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  plantGroup?: InputMaybe<StringOperationFilterInput>;
  plantGroupId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  plantSerialNo?: InputMaybe<StringOperationFilterInput>;
  plantStage?: InputMaybe<StringOperationFilterInput>;
  plantStatus?: InputMaybe<StringOperationFilterInput>;
  plantType?: InputMaybe<StringOperationFilterInput>;
  plantVerified?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  plantVerifiedFlag?: InputMaybe<StringOperationFilterInput>;
  reconId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  reconcileVerifiedFlag?: InputMaybe<StringOperationFilterInput>;
  replacementMother?: InputMaybe<StringOperationFilterInput>;
  roomHistory?: InputMaybe<ListFilterInputTypeOfPlantRoomHistoryFilterInput>;
  seedling?: InputMaybe<TblMdbatchPlantIdFilterInput>;
  seedlingId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  strain?: InputMaybe<TblBatchStrainFilterInput>;
  strainId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  tags?: InputMaybe<ListFilterInputTypeOfCultivationMetadataTagFilterInput>;
  transferredToPackageId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  trimDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  trimWasteWgt?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  trimWgt?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  wasteId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  wasteWgt?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  weekPlanted?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  wetWgt?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
};

export type TblMdbatchPlantIdSortInput = {
  acctId?: InputMaybe<SortEnumType>;
  addedToHarvestOn?: InputMaybe<SortEnumType>;
  batch?: InputMaybe<TblBatchSortInput>;
  batchId?: InputMaybe<SortEnumType>;
  bioTbarcodeId?: InputMaybe<SortEnumType>;
  bioTcureId?: InputMaybe<SortEnumType>;
  bioTlotNo?: InputMaybe<SortEnumType>;
  bioTparentId?: InputMaybe<SortEnumType>;
  bioTplantBarcodeId?: InputMaybe<SortEnumType>;
  bornDate?: InputMaybe<SortEnumType>;
  budWgt?: InputMaybe<SortEnumType>;
  createDt?: InputMaybe<SortEnumType>;
  currentHeight?: InputMaybe<SortEnumType>;
  currentRoom?: InputMaybe<SortEnumType>;
  currentRoomNavigation?: InputMaybe<TblBatchRoomSortInput>;
  currentTray?: InputMaybe<SortEnumType>;
  currentTrayNavigation?: InputMaybe<TblBatchTraySortInput>;
  currentWeight?: InputMaybe<SortEnumType>;
  cuttingsComment?: InputMaybe<SortEnumType>;
  destroyedReasonCode?: InputMaybe<SortEnumType>;
  dryWgt?: InputMaybe<SortEnumType>;
  externalId?: InputMaybe<SortEnumType>;
  genoType?: InputMaybe<SortEnumType>;
  harvestDate?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  lastModifiedDate?: InputMaybe<SortEnumType>;
  lastScanDate?: InputMaybe<SortEnumType>;
  locId?: InputMaybe<SortEnumType>;
  lspId?: InputMaybe<SortEnumType>;
  metrcWeights?: InputMaybe<ReportedPlantWeightSortInput>;
  motherPlant?: InputMaybe<SortEnumType>;
  motherPlantData?: InputMaybe<TblMdbatchPlantIdSortInput>;
  motherPlantId?: InputMaybe<SortEnumType>;
  pcounter?: InputMaybe<SortEnumType>;
  phenoType?: InputMaybe<SortEnumType>;
  plantDestroyedComment?: InputMaybe<SortEnumType>;
  plantDestroyedDate?: InputMaybe<SortEnumType>;
  plantGroup?: InputMaybe<SortEnumType>;
  plantGroupId?: InputMaybe<SortEnumType>;
  plantSerialNo?: InputMaybe<SortEnumType>;
  plantStage?: InputMaybe<SortEnumType>;
  plantStatus?: InputMaybe<SortEnumType>;
  plantType?: InputMaybe<SortEnumType>;
  plantVerified?: InputMaybe<SortEnumType>;
  plantVerifiedFlag?: InputMaybe<SortEnumType>;
  reconId?: InputMaybe<SortEnumType>;
  reconcileVerifiedFlag?: InputMaybe<SortEnumType>;
  replacementMother?: InputMaybe<SortEnumType>;
  seedling?: InputMaybe<TblMdbatchPlantIdSortInput>;
  seedlingId?: InputMaybe<SortEnumType>;
  strain?: InputMaybe<TblBatchStrainSortInput>;
  strainId?: InputMaybe<SortEnumType>;
  transferredToPackageId?: InputMaybe<SortEnumType>;
  trimDate?: InputMaybe<SortEnumType>;
  trimWasteWgt?: InputMaybe<SortEnumType>;
  trimWgt?: InputMaybe<SortEnumType>;
  wasteId?: InputMaybe<SortEnumType>;
  wasteWgt?: InputMaybe<SortEnumType>;
  weekPlanted?: InputMaybe<SortEnumType>;
  wetWgt?: InputMaybe<SortEnumType>;
};

export type TblMdcar = {
  bioTvcarId?: Maybe<Scalars['Long']>;
  carColor?: Maybe<Scalars['String']>;
  carLicId: Scalars['String'];
  carMake: Scalars['String'];
  carModel: Scalars['String'];
  carName?: Maybe<Scalars['String']>;
  carVin?: Maybe<Scalars['String']>;
  carYear?: Maybe<Scalars['String']>;
  deliveryRouteHistories?: Maybe<Array<Maybe<DeliveryRouteHistory>>>;
  deliveryRoutes?: Maybe<Array<Maybe<DeliveryRoute>>>;
  dynamicDeliveryRoute?: Maybe<DeliveryRoute>;
  dynamicDeliveryRouteId?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  isDeleted: Scalars['Boolean'];
  isOperatedByThirdParty: Scalars['Boolean'];
  locId: Scalars['Int'];
  locationNavigation?: Maybe<TblLspLocation>;
  lsp?: Maybe<TblLsp>;
  lspId: Scalars['Int'];
  mdManifests?: Maybe<Array<Maybe<MdManifest>>>;
  register?: Maybe<MdPosTerminal>;
  registerId?: Maybe<Scalars['Int']>;
  room?: Maybe<TblBatchRoom>;
  roomId?: Maybe<Scalars['Int']>;
  stateCode?: Maybe<Scalars['String']>;
  thirdPartyLicenseNumber?: Maybe<Scalars['String']>;
};

export type TblMdcarCollectionSegment = {
  items?: Maybe<Array<Maybe<TblMdcar>>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

export type TblMdcarFilterInput = {
  and?: InputMaybe<Array<TblMdcarFilterInput>>;
  bioTvcarId?: InputMaybe<ComparableNullableOfInt64OperationFilterInput>;
  carColor?: InputMaybe<StringOperationFilterInput>;
  carLicId?: InputMaybe<StringOperationFilterInput>;
  carMake?: InputMaybe<StringOperationFilterInput>;
  carModel?: InputMaybe<StringOperationFilterInput>;
  carName?: InputMaybe<StringOperationFilterInput>;
  carVin?: InputMaybe<StringOperationFilterInput>;
  carYear?: InputMaybe<StringOperationFilterInput>;
  deliveryRouteHistories?: InputMaybe<ListFilterInputTypeOfDeliveryRouteHistoryFilterInput>;
  deliveryRoutes?: InputMaybe<ListFilterInputTypeOfDeliveryRouteFilterInput>;
  dynamicDeliveryRoute?: InputMaybe<DeliveryRouteFilterInput>;
  dynamicDeliveryRouteId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  isDeleted?: InputMaybe<BooleanOperationFilterInput>;
  isOperatedByThirdParty?: InputMaybe<BooleanOperationFilterInput>;
  locId?: InputMaybe<ComparableInt32OperationFilterInput>;
  locationNavigation?: InputMaybe<TblLspLocationFilterInput>;
  lsp?: InputMaybe<TblLspFilterInput>;
  lspId?: InputMaybe<ComparableInt32OperationFilterInput>;
  mdManifests?: InputMaybe<ListFilterInputTypeOfMdManifestFilterInput>;
  or?: InputMaybe<Array<TblMdcarFilterInput>>;
  register?: InputMaybe<MdPosTerminalFilterInput>;
  registerId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  room?: InputMaybe<TblBatchRoomFilterInput>;
  roomId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  stateCode?: InputMaybe<StringOperationFilterInput>;
  thirdPartyLicenseNumber?: InputMaybe<StringOperationFilterInput>;
};

export type TblMdcarSortInput = {
  bioTvcarId?: InputMaybe<SortEnumType>;
  carColor?: InputMaybe<SortEnumType>;
  carLicId?: InputMaybe<SortEnumType>;
  carMake?: InputMaybe<SortEnumType>;
  carModel?: InputMaybe<SortEnumType>;
  carName?: InputMaybe<SortEnumType>;
  carVin?: InputMaybe<SortEnumType>;
  carYear?: InputMaybe<SortEnumType>;
  dynamicDeliveryRoute?: InputMaybe<DeliveryRouteSortInput>;
  dynamicDeliveryRouteId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isDeleted?: InputMaybe<SortEnumType>;
  isOperatedByThirdParty?: InputMaybe<SortEnumType>;
  locId?: InputMaybe<SortEnumType>;
  locationNavigation?: InputMaybe<TblLspLocationSortInput>;
  lsp?: InputMaybe<TblLspSortInput>;
  lspId?: InputMaybe<SortEnumType>;
  register?: InputMaybe<MdPosTerminalSortInput>;
  registerId?: InputMaybe<SortEnumType>;
  room?: InputMaybe<TblBatchRoomSortInput>;
  roomId?: InputMaybe<SortEnumType>;
  stateCode?: InputMaybe<SortEnumType>;
  thirdPartyLicenseNumber?: InputMaybe<SortEnumType>;
};

export type TblMddriver = {
  bioTdriverAltId?: Maybe<Scalars['String']>;
  bioTdriverId?: Maybe<Scalars['Int']>;
  deliveryRouteDriver1s?: Maybe<Array<Maybe<DeliveryRoute>>>;
  deliveryRouteDriver2s?: Maybe<Array<Maybe<DeliveryRoute>>>;
  deliveryRouteHistoryDriver1s?: Maybe<Array<Maybe<DeliveryRouteHistory>>>;
  deliveryRouteHistoryDriver2s?: Maybe<Array<Maybe<DeliveryRouteHistory>>>;
  driverDob?: Maybe<Scalars['DateTime']>;
  driverEmail?: Maybe<Scalars['String']>;
  driverHireDt?: Maybe<Scalars['DateTime']>;
  driverId: Scalars['String'];
  driverLocation?: Maybe<DriverLocation>;
  driverName: Scalars['String'];
  driverPhone?: Maybe<Scalars['String']>;
  driverPicture?: Maybe<Scalars['String']>;
  driverStateId?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  isDeleted: Scalars['Boolean'];
  isOperatedByThirdParty: Scalars['Boolean'];
  locId: Scalars['Int'];
  locationNavigation?: Maybe<TblLspLocation>;
  lsp?: Maybe<TblLsp>;
  lspId: Scalars['Int'];
  manifestToDrivers?: Maybe<Array<Maybe<ManifestToDriver>>>;
  stateCode?: Maybe<Scalars['String']>;
  thirdPartyLicenseNumber?: Maybe<Scalars['String']>;
  user?: Maybe<TblAuthUser>;
  userId?: Maybe<Scalars['Int']>;
};

export type TblMddriverCollectionSegment = {
  items?: Maybe<Array<Maybe<TblMddriver>>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

export type TblMddriverFilterInput = {
  and?: InputMaybe<Array<TblMddriverFilterInput>>;
  bioTdriverAltId?: InputMaybe<StringOperationFilterInput>;
  bioTdriverId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  deliveryRouteDriver1s?: InputMaybe<ListFilterInputTypeOfDeliveryRouteFilterInput>;
  deliveryRouteDriver2s?: InputMaybe<ListFilterInputTypeOfDeliveryRouteFilterInput>;
  deliveryRouteHistoryDriver1s?: InputMaybe<ListFilterInputTypeOfDeliveryRouteHistoryFilterInput>;
  deliveryRouteHistoryDriver2s?: InputMaybe<ListFilterInputTypeOfDeliveryRouteHistoryFilterInput>;
  driverDob?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  driverEmail?: InputMaybe<StringOperationFilterInput>;
  driverHireDt?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  driverId?: InputMaybe<StringOperationFilterInput>;
  driverLocation?: InputMaybe<DriverLocationFilterInput>;
  driverName?: InputMaybe<StringOperationFilterInput>;
  driverPhone?: InputMaybe<StringOperationFilterInput>;
  driverPicture?: InputMaybe<StringOperationFilterInput>;
  driverStateId?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  isDeleted?: InputMaybe<BooleanOperationFilterInput>;
  isOperatedByThirdParty?: InputMaybe<BooleanOperationFilterInput>;
  locId?: InputMaybe<ComparableInt32OperationFilterInput>;
  locationNavigation?: InputMaybe<TblLspLocationFilterInput>;
  lsp?: InputMaybe<TblLspFilterInput>;
  lspId?: InputMaybe<ComparableInt32OperationFilterInput>;
  manifestToDrivers?: InputMaybe<ListFilterInputTypeOfManifestToDriverFilterInput>;
  or?: InputMaybe<Array<TblMddriverFilterInput>>;
  stateCode?: InputMaybe<StringOperationFilterInput>;
  thirdPartyLicenseNumber?: InputMaybe<StringOperationFilterInput>;
  user?: InputMaybe<TblAuthUserFilterInput>;
  userId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
};

export type TblMddriverSortInput = {
  bioTdriverAltId?: InputMaybe<SortEnumType>;
  bioTdriverId?: InputMaybe<SortEnumType>;
  driverDob?: InputMaybe<SortEnumType>;
  driverEmail?: InputMaybe<SortEnumType>;
  driverHireDt?: InputMaybe<SortEnumType>;
  driverId?: InputMaybe<SortEnumType>;
  driverLocation?: InputMaybe<DriverLocationSortInput>;
  driverName?: InputMaybe<SortEnumType>;
  driverPhone?: InputMaybe<SortEnumType>;
  driverPicture?: InputMaybe<SortEnumType>;
  driverStateId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isDeleted?: InputMaybe<SortEnumType>;
  isOperatedByThirdParty?: InputMaybe<SortEnumType>;
  locId?: InputMaybe<SortEnumType>;
  locationNavigation?: InputMaybe<TblLspLocationSortInput>;
  lsp?: InputMaybe<TblLspSortInput>;
  lspId?: InputMaybe<SortEnumType>;
  stateCode?: InputMaybe<SortEnumType>;
  thirdPartyLicenseNumber?: InputMaybe<SortEnumType>;
  user?: InputMaybe<TblAuthUserSortInput>;
  userId?: InputMaybe<SortEnumType>;
};

export type TblMdlabel = {
  category?: Maybe<TblWhseProductType>;
  categoryId?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  isDeleted: Scalars['Boolean'];
  labelDescription: Scalars['String'];
  labelDpi: Scalars['Short'];
  labelFeed?: Maybe<Scalars['String']>;
  labelHeight?: Maybe<Scalars['Decimal']>;
  labelId: Scalars['String'];
  labelOrientation?: Maybe<Scalars['String']>;
  labelType: Scalars['String'];
  labelWidth?: Maybe<Scalars['Decimal']>;
  location?: Maybe<TblLspLocation>;
  locationId: Scalars['Int'];
  lsp?: Maybe<TblLsp>;
  lspId: Scalars['Int'];
  printNodePrinterId?: Maybe<Scalars['Long']>;
  printerName?: Maybe<Scalars['String']>;
  productType?: Maybe<Scalars['String']>;
  tblLspLocations?: Maybe<Array<Maybe<TblLspLocation>>>;
  verticalLabelCount?: Maybe<Scalars['Int']>;
  verticalLengthOfLabel?: Maybe<Scalars['Decimal']>;
  verticalWidthOfLabel?: Maybe<Scalars['Decimal']>;
};

export type TblMdlabelFilterInput = {
  and?: InputMaybe<Array<TblMdlabelFilterInput>>;
  category?: InputMaybe<TblWhseProductTypeFilterInput>;
  categoryId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  isDeleted?: InputMaybe<BooleanOperationFilterInput>;
  labelDescription?: InputMaybe<StringOperationFilterInput>;
  labelDpi?: InputMaybe<ComparableInt16OperationFilterInput>;
  labelFeed?: InputMaybe<StringOperationFilterInput>;
  labelHeight?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  labelId?: InputMaybe<StringOperationFilterInput>;
  labelOrientation?: InputMaybe<StringOperationFilterInput>;
  labelType?: InputMaybe<StringOperationFilterInput>;
  labelWidth?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  location?: InputMaybe<TblLspLocationFilterInput>;
  locationId?: InputMaybe<ComparableInt32OperationFilterInput>;
  lsp?: InputMaybe<TblLspFilterInput>;
  lspId?: InputMaybe<ComparableInt32OperationFilterInput>;
  or?: InputMaybe<Array<TblMdlabelFilterInput>>;
  printNodePrinterId?: InputMaybe<ComparableNullableOfInt64OperationFilterInput>;
  printerName?: InputMaybe<StringOperationFilterInput>;
  productType?: InputMaybe<StringOperationFilterInput>;
  tblLspLocations?: InputMaybe<ListFilterInputTypeOfTblLspLocationFilterInput>;
  verticalLabelCount?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  verticalLengthOfLabel?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  verticalWidthOfLabel?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
};

export type TblMdlabelSortInput = {
  category?: InputMaybe<TblWhseProductTypeSortInput>;
  categoryId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isDeleted?: InputMaybe<SortEnumType>;
  labelDescription?: InputMaybe<SortEnumType>;
  labelDpi?: InputMaybe<SortEnumType>;
  labelFeed?: InputMaybe<SortEnumType>;
  labelHeight?: InputMaybe<SortEnumType>;
  labelId?: InputMaybe<SortEnumType>;
  labelOrientation?: InputMaybe<SortEnumType>;
  labelType?: InputMaybe<SortEnumType>;
  labelWidth?: InputMaybe<SortEnumType>;
  location?: InputMaybe<TblLspLocationSortInput>;
  locationId?: InputMaybe<SortEnumType>;
  lsp?: InputMaybe<TblLspSortInput>;
  lspId?: InputMaybe<SortEnumType>;
  printNodePrinterId?: InputMaybe<SortEnumType>;
  printerName?: InputMaybe<SortEnumType>;
  productType?: InputMaybe<SortEnumType>;
  verticalLabelCount?: InputMaybe<SortEnumType>;
  verticalLengthOfLabel?: InputMaybe<SortEnumType>;
  verticalWidthOfLabel?: InputMaybe<SortEnumType>;
};

export type TblMdorder = {
  created?: Maybe<Scalars['DateTime']>;
  dispensary: Scalars['Int'];
  dispensaryLocation: Scalars['Int'];
  dispensaryLocationNavigation?: Maybe<TblLspLocation>;
  dispensaryNavigation?: Maybe<TblLsp>;
  grower: Scalars['Int'];
  growerLocation: Scalars['Int'];
  growerLocationNavigation?: Maybe<TblLspLocation>;
  growerNavigation?: Maybe<TblLsp>;
  id: Scalars['Int'];
  issuedBy: Scalars['Int'];
  issuedByNavigation?: Maybe<TblAuthUser>;
  orderDate: Scalars['DateTime'];
  orderNo: Scalars['String'];
};

export type TblMdorderFilterInput = {
  and?: InputMaybe<Array<TblMdorderFilterInput>>;
  created?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  dispensary?: InputMaybe<ComparableInt32OperationFilterInput>;
  dispensaryLocation?: InputMaybe<ComparableInt32OperationFilterInput>;
  dispensaryLocationNavigation?: InputMaybe<TblLspLocationFilterInput>;
  dispensaryNavigation?: InputMaybe<TblLspFilterInput>;
  grower?: InputMaybe<ComparableInt32OperationFilterInput>;
  growerLocation?: InputMaybe<ComparableInt32OperationFilterInput>;
  growerLocationNavigation?: InputMaybe<TblLspLocationFilterInput>;
  growerNavigation?: InputMaybe<TblLspFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  issuedBy?: InputMaybe<ComparableInt32OperationFilterInput>;
  issuedByNavigation?: InputMaybe<TblAuthUserFilterInput>;
  or?: InputMaybe<Array<TblMdorderFilterInput>>;
  orderDate?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  orderNo?: InputMaybe<StringOperationFilterInput>;
};

export type TblMdshipment = {
  addRemoveItemReferenceCount: Scalars['Int'];
  adjustmentFor?: Maybe<Scalars['Int']>;
  adjustmentForNavigation?: Maybe<TblMdshipment>;
  allocatedInventoryReturnedByShipmentNavigations?: Maybe<Array<Maybe<AllocatedInventory>>>;
  allocatedInventoryShipments?: Maybe<Array<Maybe<AllocatedInventory>>>;
  appName?: Maybe<Scalars['String']>;
  appVersion?: Maybe<Scalars['String']>;
  appliedDiscounts?: Maybe<Array<Maybe<AppliedDiscount>>>;
  appliedFeeDonations?: Maybe<Array<Maybe<AppliedFeeDonation>>>;
  arrivalDate?: Maybe<Scalars['DateTime']>;
  authCode?: Maybe<Scalars['String']>;
  autoDiscountsRun: Scalars['Boolean'];
  biotEndGramsAvailable?: Maybe<Scalars['Decimal']>;
  biotStartGramsAvailable?: Maybe<Scalars['Decimal']>;
  buildVersion?: Maybe<Scalars['String']>;
  cancelDate?: Maybe<Scalars['DateTime']>;
  cancelDateLocal?: Maybe<Scalars['DateTime']>;
  cancelReason?: Maybe<Scalars['String']>;
  canceledBy?: Maybe<Scalars['Int']>;
  caperLbTax?: Maybe<Scalars['Decimal']>;
  cardType?: Maybe<Scalars['String']>;
  cardholderName?: Maybe<Scalars['String']>;
  caregiverIdNumber?: Maybe<Scalars['String']>;
  cashReturned?: Maybe<Scalars['Boolean']>;
  chargeIncludedTaxes: Scalars['Boolean'];
  checkPaid?: Maybe<Scalars['Decimal']>;
  checkoutSignature?: Maybe<Scalars['UUID']>;
  comments?: Maybe<Scalars['String']>;
  creditPaid?: Maybe<Scalars['Decimal']>;
  creditReturned?: Maybe<Scalars['Boolean']>;
  currentLoyaltyBalance?: Maybe<Scalars['Decimal']>;
  customer: Scalars['Int'];
  customerNavigation?: Maybe<TblAcct>;
  customerTypeId?: Maybe<Scalars['Int']>;
  debitPaid?: Maybe<Scalars['Decimal']>;
  debitReturned?: Maybe<Scalars['Boolean']>;
  deliveryAddressId?: Maybe<Scalars['Int']>;
  departureDate?: Maybe<Scalars['DateTime']>;
  discountAmt?: Maybe<Scalars['Decimal']>;
  educationalMaterialsAccepted?: Maybe<Scalars['Boolean']>;
  electronicAmount?: Maybe<Scalars['Decimal']>;
  electronicType?: Maybe<Scalars['String']>;
  endingAllotment?: Maybe<Scalars['Decimal']>;
  externalDeliveryId?: Maybe<Scalars['String']>;
  giftPaid?: Maybe<Scalars['Decimal']>;
  headSetXferDate?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  invdateString?: Maybe<Scalars['String']>;
  inverseAdjustmentForNavigation?: Maybe<Array<Maybe<TblMdshipment>>>;
  inverseReturnForShipmentNavigation?: Maybe<Array<Maybe<TblMdshipment>>>;
  invoiceCredit?: Maybe<Scalars['Decimal']>;
  invoiceNumber?: Maybe<Scalars['String']>;
  invoiceTotal?: Maybe<Scalars['Decimal']>;
  isAdjustment: Scalars['Boolean'];
  isAutoCheckout: Scalars['Boolean'];
  isLoyaltyAsAdiscount?: Maybe<Scalars['Boolean']>;
  isStatefulCheckout?: Maybe<Scalars['Boolean']>;
  isTaxInclusive?: Maybe<Scalars['Boolean']>;
  isZoned: Scalars['Boolean'];
  itemReturnedToInventory?: Maybe<Scalars['Boolean']>;
  last4?: Maybe<Scalars['String']>;
  lastLockDate?: Maybe<Scalars['DateTime']>;
  lastModifiedDateUtc: Scalars['DateTime'];
  loyaltyAdjustment?: Maybe<Scalars['Decimal']>;
  loyaltyAdjustmentReason?: Maybe<Scalars['String']>;
  loyaltyAsDiscountAmt?: Maybe<Scalars['Decimal']>;
  loyaltyCouponPointValue?: Maybe<Scalars['Decimal']>;
  loyaltyDiscountCashValue?: Maybe<Scalars['Decimal']>;
  loyaltyDiscountPointValue?: Maybe<Scalars['Decimal']>;
  loyaltyPoints?: Maybe<Scalars['Decimal']>;
  loyaltyPts?: Maybe<Scalars['Decimal']>;
  loyaltyTier?: Maybe<Scalars['String']>;
  lsp?: Maybe<TblLsp>;
  lspId: Scalars['Int'];
  lspLoc?: Maybe<TblLspLocation>;
  lspLocId: Scalars['Int'];
  mMAPPaid?: Maybe<Scalars['Decimal']>;
  manifest?: Maybe<MdManifest>;
  manifestId?: Maybe<Scalars['Int']>;
  manifestStatus?: Maybe<Scalars['String']>;
  manifestStopNumber?: Maybe<Scalars['Int']>;
  manualCheckOutDate?: Maybe<Scalars['DateTime']>;
  metrcTransferTemplateType?: Maybe<Scalars['String']>;
  mmjid?: Maybe<Scalars['String']>;
  mnapprovalCode?: Maybe<Scalars['String']>;
  moveToBioT?: Maybe<Scalars['DateTime']>;
  moveToBioTError?: Maybe<Scalars['String']>;
  moveToBioTTransId?: Maybe<Scalars['String']>;
  moveToBioTVoid?: Maybe<Scalars['DateTime']>;
  moveToBioTVoidError?: Maybe<Scalars['String']>;
  optimizedStopNumber?: Maybe<Scalars['Int']>;
  orderComplete?: Maybe<Scalars['DateTime']>;
  orderNo?: Maybe<Scalars['String']>;
  orderSource?: Maybe<Scalars['String']>;
  orderTypeId?: Maybe<Scalars['Int']>;
  orders?: Maybe<Array<Maybe<Order>>>;
  paymentTerms?: Maybe<Scalars['String']>;
  paymentType?: Maybe<Scalars['String']>;
  pmpoutId?: Maybe<Scalars['Int']>;
  pmpvoided: Scalars['Boolean'];
  pobroundup?: Maybe<Scalars['Int']>;
  preCheckOutPaidAmt?: Maybe<Scalars['Decimal']>;
  prePaymentAmount?: Maybe<Scalars['Decimal']>;
  quickbooksId?: Maybe<Scalars['String']>;
  reactVersion?: Maybe<Scalars['String']>;
  readyForDelivery?: Maybe<Scalars['Boolean']>;
  receiveInventoryHistories?: Maybe<Array<Maybe<ReceiveInventoryHistory>>>;
  referenceNumber?: Maybe<Scalars['String']>;
  registerLedgers?: Maybe<Array<Maybe<RegisterLedger>>>;
  requestedDeliveryDate?: Maybe<Scalars['DateTime']>;
  responsibleForSaleUser?: Maybe<TblAuthUser>;
  responsibleForSaleUserId?: Maybe<Scalars['Int']>;
  returnForShipment?: Maybe<Scalars['Int']>;
  returnForShipmentNavigation?: Maybe<TblMdshipment>;
  roundingAmount: Scalars['Decimal'];
  routeDetails?: Maybe<Scalars['String']>;
  routeStopNo?: Maybe<Scalars['Int']>;
  sessionId?: Maybe<Scalars['String']>;
  shipmentBy: Scalars['Int'];
  shipmentByNavigation?: Maybe<TblAuthUser>;
  shipmentDate: Scalars['DateTime'];
  shipmentDateLocal?: Maybe<Scalars['DateTime']>;
  shipmentDelivered?: Maybe<Scalars['DateTime']>;
  shipmentDeliveredLocal?: Maybe<Scalars['DateTime']>;
  shipmentStatusId: Scalars['Byte'];
  shipmentType?: Maybe<Scalars['String']>;
  startingAllotment?: Maybe<Scalars['Decimal']>;
  stateSystemBypassed: Scalars['Boolean'];
  stateTransmissionDate?: Maybe<Scalars['DateTime']>;
  stateTransmissionReference?: Maybe<Scalars['String']>;
  taxRate?: Maybe<Scalars['Decimal']>;
  tblDispensarySchedules?: Maybe<Array<Maybe<TblDispensarySchedule>>>;
  terminal?: Maybe<MdPosTerminal>;
  terminalId?: Maybe<Scalars['Int']>;
  timeWindowEndDateUtc?: Maybe<Scalars['DateTime']>;
  timeWindowStartDateUtc?: Maybe<Scalars['DateTime']>;
  tipAmount?: Maybe<Scalars['Decimal']>;
  title?: Maybe<Scalars['String']>;
  totalCharges?: Maybe<Scalars['Decimal']>;
  totalCost?: Maybe<Scalars['Decimal']>;
  totalDueCustomer?: Maybe<Scalars['Decimal']>;
  totalDueCustomerRounded?: Maybe<Scalars['Decimal']>;
  totalGrams?: Maybe<Scalars['Decimal']>;
  totalItems?: Maybe<Scalars['Int']>;
  totalOz?: Maybe<Scalars['Decimal']>;
  totalPaid?: Maybe<Scalars['Decimal']>;
  totalTax?: Maybe<Scalars['Decimal']>;
  transactionNotes?: Maybe<Scalars['String']>;
  transactionStatus?: Maybe<Scalars['String']>;
  transmittedToIntegratedSystem: Scalars['Boolean'];
  verifiedBy?: Maybe<Scalars['Int']>;
  verifiedByNavigation?: Maybe<TblAuthUser>;
  verifiedDate?: Maybe<Scalars['DateTime']>;
  visitReason?: Maybe<Scalars['String']>;
  voidDate?: Maybe<Scalars['DateTime']>;
  voidDateLocal?: Maybe<Scalars['DateTime']>;
  voidReason?: Maybe<Scalars['String']>;
};

export type TblMdshipmentCollectionSegment = {
  items?: Maybe<Array<Maybe<TblMdshipment>>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

export type TblMdshipmentFilterInput = {
  addRemoveItemReferenceCount?: InputMaybe<ComparableInt32OperationFilterInput>;
  adjustmentFor?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  adjustmentForNavigation?: InputMaybe<TblMdshipmentFilterInput>;
  allocatedInventoryReturnedByShipmentNavigations?: InputMaybe<ListFilterInputTypeOfAllocatedInventoryFilterInput>;
  allocatedInventoryShipments?: InputMaybe<ListFilterInputTypeOfAllocatedInventoryFilterInput>;
  and?: InputMaybe<Array<TblMdshipmentFilterInput>>;
  appName?: InputMaybe<StringOperationFilterInput>;
  appVersion?: InputMaybe<StringOperationFilterInput>;
  appliedDiscounts?: InputMaybe<ListFilterInputTypeOfAppliedDiscountFilterInput>;
  appliedFeeDonations?: InputMaybe<ListFilterInputTypeOfAppliedFeeDonationFilterInput>;
  arrivalDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  authCode?: InputMaybe<StringOperationFilterInput>;
  autoDiscountsRun?: InputMaybe<BooleanOperationFilterInput>;
  biotEndGramsAvailable?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  biotStartGramsAvailable?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  buildVersion?: InputMaybe<StringOperationFilterInput>;
  cancelDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  cancelDateLocal?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  cancelReason?: InputMaybe<StringOperationFilterInput>;
  canceledBy?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  caperLbTax?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  cardType?: InputMaybe<StringOperationFilterInput>;
  cardholderName?: InputMaybe<StringOperationFilterInput>;
  caregiverIdNumber?: InputMaybe<StringOperationFilterInput>;
  cashReturned?: InputMaybe<BooleanOperationFilterInput>;
  chargeIncludedTaxes?: InputMaybe<BooleanOperationFilterInput>;
  checkPaid?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  checkoutSignature?: InputMaybe<ComparableNullableOfGuidOperationFilterInput>;
  comments?: InputMaybe<StringOperationFilterInput>;
  creditPaid?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  creditReturned?: InputMaybe<BooleanOperationFilterInput>;
  currentLoyaltyBalance?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  customer?: InputMaybe<ComparableInt32OperationFilterInput>;
  customerNavigation?: InputMaybe<TblAcctFilterInput>;
  customerTypeId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  debitPaid?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  debitReturned?: InputMaybe<BooleanOperationFilterInput>;
  deliveryAddressId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  departureDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  discountAmt?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  educationalMaterialsAccepted?: InputMaybe<BooleanOperationFilterInput>;
  electronicAmount?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  electronicType?: InputMaybe<StringOperationFilterInput>;
  endingAllotment?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  externalDeliveryId?: InputMaybe<StringOperationFilterInput>;
  giftPaid?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  headSetXferDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  invdateString?: InputMaybe<StringOperationFilterInput>;
  inverseAdjustmentForNavigation?: InputMaybe<ListFilterInputTypeOfTblMdshipmentFilterInput>;
  inverseReturnForShipmentNavigation?: InputMaybe<ListFilterInputTypeOfTblMdshipmentFilterInput>;
  invoiceCredit?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  invoiceNumber?: InputMaybe<StringOperationFilterInput>;
  invoiceTotal?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  isAdjustment?: InputMaybe<BooleanOperationFilterInput>;
  isAutoCheckout?: InputMaybe<BooleanOperationFilterInput>;
  isLoyaltyAsAdiscount?: InputMaybe<BooleanOperationFilterInput>;
  isStatefulCheckout?: InputMaybe<BooleanOperationFilterInput>;
  isTaxInclusive?: InputMaybe<BooleanOperationFilterInput>;
  isZoned?: InputMaybe<BooleanOperationFilterInput>;
  itemReturnedToInventory?: InputMaybe<BooleanOperationFilterInput>;
  last4?: InputMaybe<StringOperationFilterInput>;
  lastLockDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  lastModifiedDateUtc?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  loyaltyAdjustment?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  loyaltyAdjustmentReason?: InputMaybe<StringOperationFilterInput>;
  loyaltyAsDiscountAmt?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  loyaltyCouponPointValue?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  loyaltyDiscountCashValue?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  loyaltyDiscountPointValue?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  loyaltyPoints?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  loyaltyPts?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  loyaltyTier?: InputMaybe<StringOperationFilterInput>;
  lsp?: InputMaybe<TblLspFilterInput>;
  lspId?: InputMaybe<ComparableInt32OperationFilterInput>;
  lspLoc?: InputMaybe<TblLspLocationFilterInput>;
  lspLocId?: InputMaybe<ComparableInt32OperationFilterInput>;
  mMAPPaid?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  manifest?: InputMaybe<MdManifestFilterInput>;
  manifestId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  manifestStatus?: InputMaybe<StringOperationFilterInput>;
  manifestStopNumber?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  manualCheckOutDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  metrcTransferTemplateType?: InputMaybe<StringOperationFilterInput>;
  mmjid?: InputMaybe<StringOperationFilterInput>;
  mnapprovalCode?: InputMaybe<StringOperationFilterInput>;
  moveToBioT?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  moveToBioTError?: InputMaybe<StringOperationFilterInput>;
  moveToBioTTransId?: InputMaybe<StringOperationFilterInput>;
  moveToBioTVoid?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  moveToBioTVoidError?: InputMaybe<StringOperationFilterInput>;
  optimizedStopNumber?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  or?: InputMaybe<Array<TblMdshipmentFilterInput>>;
  orderComplete?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  orderNo?: InputMaybe<StringOperationFilterInput>;
  orderSource?: InputMaybe<StringOperationFilterInput>;
  orderTypeId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  orders?: InputMaybe<ListFilterInputTypeOfOrderFilterInput>;
  paymentTerms?: InputMaybe<StringOperationFilterInput>;
  paymentType?: InputMaybe<StringOperationFilterInput>;
  pmpoutId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  pmpvoided?: InputMaybe<BooleanOperationFilterInput>;
  pobroundup?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  preCheckOutPaidAmt?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  prePaymentAmount?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  quickbooksId?: InputMaybe<StringOperationFilterInput>;
  reactVersion?: InputMaybe<StringOperationFilterInput>;
  readyForDelivery?: InputMaybe<BooleanOperationFilterInput>;
  receiveInventoryHistories?: InputMaybe<ListFilterInputTypeOfReceiveInventoryHistoryFilterInput>;
  referenceNumber?: InputMaybe<StringOperationFilterInput>;
  registerLedgers?: InputMaybe<ListFilterInputTypeOfRegisterLedgerFilterInput>;
  requestedDeliveryDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  responsibleForSaleUser?: InputMaybe<TblAuthUserFilterInput>;
  responsibleForSaleUserId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  returnForShipment?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  returnForShipmentNavigation?: InputMaybe<TblMdshipmentFilterInput>;
  roundingAmount?: InputMaybe<ComparableDecimalOperationFilterInput>;
  routeDetails?: InputMaybe<StringOperationFilterInput>;
  routeStopNo?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  sessionId?: InputMaybe<StringOperationFilterInput>;
  shipmentBy?: InputMaybe<ComparableInt32OperationFilterInput>;
  shipmentByNavigation?: InputMaybe<TblAuthUserFilterInput>;
  shipmentDate?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  shipmentDateLocal?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  shipmentDelivered?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  shipmentDeliveredLocal?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  shipmentStatusId?: InputMaybe<ComparableByteOperationFilterInput>;
  shipmentType?: InputMaybe<StringOperationFilterInput>;
  startingAllotment?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  stateSystemBypassed?: InputMaybe<BooleanOperationFilterInput>;
  stateTransmissionDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  stateTransmissionReference?: InputMaybe<StringOperationFilterInput>;
  taxRate?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  tblDispensarySchedules?: InputMaybe<ListFilterInputTypeOfTblDispensaryScheduleFilterInput>;
  terminal?: InputMaybe<MdPosTerminalFilterInput>;
  terminalId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  timeWindowEndDateUtc?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  timeWindowStartDateUtc?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  tipAmount?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  title?: InputMaybe<StringOperationFilterInput>;
  totalCharges?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  totalCost?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  totalDueCustomer?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  totalDueCustomerRounded?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  totalGrams?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  totalItems?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  totalOz?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  totalPaid?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  totalTax?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  transactionNotes?: InputMaybe<StringOperationFilterInput>;
  transactionStatus?: InputMaybe<StringOperationFilterInput>;
  transmittedToIntegratedSystem?: InputMaybe<BooleanOperationFilterInput>;
  verifiedBy?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  verifiedByNavigation?: InputMaybe<TblAuthUserFilterInput>;
  verifiedDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  visitReason?: InputMaybe<StringOperationFilterInput>;
  voidDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  voidDateLocal?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  voidReason?: InputMaybe<StringOperationFilterInput>;
};

export type TblMdshipmentSortInput = {
  addRemoveItemReferenceCount?: InputMaybe<SortEnumType>;
  adjustmentFor?: InputMaybe<SortEnumType>;
  adjustmentForNavigation?: InputMaybe<TblMdshipmentSortInput>;
  appName?: InputMaybe<SortEnumType>;
  appVersion?: InputMaybe<SortEnumType>;
  arrivalDate?: InputMaybe<SortEnumType>;
  authCode?: InputMaybe<SortEnumType>;
  autoDiscountsRun?: InputMaybe<SortEnumType>;
  biotEndGramsAvailable?: InputMaybe<SortEnumType>;
  biotStartGramsAvailable?: InputMaybe<SortEnumType>;
  buildVersion?: InputMaybe<SortEnumType>;
  cancelDate?: InputMaybe<SortEnumType>;
  cancelDateLocal?: InputMaybe<SortEnumType>;
  cancelReason?: InputMaybe<SortEnumType>;
  canceledBy?: InputMaybe<SortEnumType>;
  caperLbTax?: InputMaybe<SortEnumType>;
  cardType?: InputMaybe<SortEnumType>;
  cardholderName?: InputMaybe<SortEnumType>;
  caregiverIdNumber?: InputMaybe<SortEnumType>;
  cashReturned?: InputMaybe<SortEnumType>;
  chargeIncludedTaxes?: InputMaybe<SortEnumType>;
  checkPaid?: InputMaybe<SortEnumType>;
  checkoutSignature?: InputMaybe<SortEnumType>;
  comments?: InputMaybe<SortEnumType>;
  creditPaid?: InputMaybe<SortEnumType>;
  creditReturned?: InputMaybe<SortEnumType>;
  currentLoyaltyBalance?: InputMaybe<SortEnumType>;
  customer?: InputMaybe<SortEnumType>;
  customerNavigation?: InputMaybe<TblAcctSortInput>;
  customerTypeId?: InputMaybe<SortEnumType>;
  debitPaid?: InputMaybe<SortEnumType>;
  debitReturned?: InputMaybe<SortEnumType>;
  deliveryAddressId?: InputMaybe<SortEnumType>;
  departureDate?: InputMaybe<SortEnumType>;
  discountAmt?: InputMaybe<SortEnumType>;
  educationalMaterialsAccepted?: InputMaybe<SortEnumType>;
  electronicAmount?: InputMaybe<SortEnumType>;
  electronicType?: InputMaybe<SortEnumType>;
  endingAllotment?: InputMaybe<SortEnumType>;
  externalDeliveryId?: InputMaybe<SortEnumType>;
  giftPaid?: InputMaybe<SortEnumType>;
  headSetXferDate?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  invdateString?: InputMaybe<SortEnumType>;
  invoiceCredit?: InputMaybe<SortEnumType>;
  invoiceNumber?: InputMaybe<SortEnumType>;
  invoiceTotal?: InputMaybe<SortEnumType>;
  isAdjustment?: InputMaybe<SortEnumType>;
  isAutoCheckout?: InputMaybe<SortEnumType>;
  isLoyaltyAsAdiscount?: InputMaybe<SortEnumType>;
  isStatefulCheckout?: InputMaybe<SortEnumType>;
  isTaxInclusive?: InputMaybe<SortEnumType>;
  isZoned?: InputMaybe<SortEnumType>;
  itemReturnedToInventory?: InputMaybe<SortEnumType>;
  last4?: InputMaybe<SortEnumType>;
  lastLockDate?: InputMaybe<SortEnumType>;
  lastModifiedDateUtc?: InputMaybe<SortEnumType>;
  loyaltyAdjustment?: InputMaybe<SortEnumType>;
  loyaltyAdjustmentReason?: InputMaybe<SortEnumType>;
  loyaltyAsDiscountAmt?: InputMaybe<SortEnumType>;
  loyaltyCouponPointValue?: InputMaybe<SortEnumType>;
  loyaltyDiscountCashValue?: InputMaybe<SortEnumType>;
  loyaltyDiscountPointValue?: InputMaybe<SortEnumType>;
  loyaltyPoints?: InputMaybe<SortEnumType>;
  loyaltyPts?: InputMaybe<SortEnumType>;
  loyaltyTier?: InputMaybe<SortEnumType>;
  lsp?: InputMaybe<TblLspSortInput>;
  lspId?: InputMaybe<SortEnumType>;
  lspLoc?: InputMaybe<TblLspLocationSortInput>;
  lspLocId?: InputMaybe<SortEnumType>;
  mMAPPaid?: InputMaybe<SortEnumType>;
  manifest?: InputMaybe<MdManifestSortInput>;
  manifestId?: InputMaybe<SortEnumType>;
  manifestStatus?: InputMaybe<SortEnumType>;
  manifestStopNumber?: InputMaybe<SortEnumType>;
  manualCheckOutDate?: InputMaybe<SortEnumType>;
  metrcTransferTemplateType?: InputMaybe<SortEnumType>;
  mmjid?: InputMaybe<SortEnumType>;
  mnapprovalCode?: InputMaybe<SortEnumType>;
  moveToBioT?: InputMaybe<SortEnumType>;
  moveToBioTError?: InputMaybe<SortEnumType>;
  moveToBioTTransId?: InputMaybe<SortEnumType>;
  moveToBioTVoid?: InputMaybe<SortEnumType>;
  moveToBioTVoidError?: InputMaybe<SortEnumType>;
  optimizedStopNumber?: InputMaybe<SortEnumType>;
  orderComplete?: InputMaybe<SortEnumType>;
  orderNo?: InputMaybe<SortEnumType>;
  orderSource?: InputMaybe<SortEnumType>;
  orderTypeId?: InputMaybe<SortEnumType>;
  paymentTerms?: InputMaybe<SortEnumType>;
  paymentType?: InputMaybe<SortEnumType>;
  pmpoutId?: InputMaybe<SortEnumType>;
  pmpvoided?: InputMaybe<SortEnumType>;
  pobroundup?: InputMaybe<SortEnumType>;
  preCheckOutPaidAmt?: InputMaybe<SortEnumType>;
  prePaymentAmount?: InputMaybe<SortEnumType>;
  quickbooksId?: InputMaybe<SortEnumType>;
  reactVersion?: InputMaybe<SortEnumType>;
  readyForDelivery?: InputMaybe<SortEnumType>;
  referenceNumber?: InputMaybe<SortEnumType>;
  requestedDeliveryDate?: InputMaybe<SortEnumType>;
  responsibleForSaleUser?: InputMaybe<TblAuthUserSortInput>;
  responsibleForSaleUserId?: InputMaybe<SortEnumType>;
  returnForShipment?: InputMaybe<SortEnumType>;
  returnForShipmentNavigation?: InputMaybe<TblMdshipmentSortInput>;
  roundingAmount?: InputMaybe<SortEnumType>;
  routeDetails?: InputMaybe<SortEnumType>;
  routeStopNo?: InputMaybe<SortEnumType>;
  sessionId?: InputMaybe<SortEnumType>;
  shipmentBy?: InputMaybe<SortEnumType>;
  shipmentByNavigation?: InputMaybe<TblAuthUserSortInput>;
  shipmentDate?: InputMaybe<SortEnumType>;
  shipmentDateLocal?: InputMaybe<SortEnumType>;
  shipmentDelivered?: InputMaybe<SortEnumType>;
  shipmentDeliveredLocal?: InputMaybe<SortEnumType>;
  shipmentStatusId?: InputMaybe<SortEnumType>;
  shipmentType?: InputMaybe<SortEnumType>;
  startingAllotment?: InputMaybe<SortEnumType>;
  stateSystemBypassed?: InputMaybe<SortEnumType>;
  stateTransmissionDate?: InputMaybe<SortEnumType>;
  stateTransmissionReference?: InputMaybe<SortEnumType>;
  taxRate?: InputMaybe<SortEnumType>;
  terminal?: InputMaybe<MdPosTerminalSortInput>;
  terminalId?: InputMaybe<SortEnumType>;
  timeWindowEndDateUtc?: InputMaybe<SortEnumType>;
  timeWindowStartDateUtc?: InputMaybe<SortEnumType>;
  tipAmount?: InputMaybe<SortEnumType>;
  title?: InputMaybe<SortEnumType>;
  totalCharges?: InputMaybe<SortEnumType>;
  totalCost?: InputMaybe<SortEnumType>;
  totalDueCustomer?: InputMaybe<SortEnumType>;
  totalDueCustomerRounded?: InputMaybe<SortEnumType>;
  totalGrams?: InputMaybe<SortEnumType>;
  totalItems?: InputMaybe<SortEnumType>;
  totalOz?: InputMaybe<SortEnumType>;
  totalPaid?: InputMaybe<SortEnumType>;
  totalTax?: InputMaybe<SortEnumType>;
  transactionNotes?: InputMaybe<SortEnumType>;
  transactionStatus?: InputMaybe<SortEnumType>;
  transmittedToIntegratedSystem?: InputMaybe<SortEnumType>;
  verifiedBy?: InputMaybe<SortEnumType>;
  verifiedByNavigation?: InputMaybe<TblAuthUserSortInput>;
  verifiedDate?: InputMaybe<SortEnumType>;
  visitReason?: InputMaybe<SortEnumType>;
  voidDate?: InputMaybe<SortEnumType>;
  voidDateLocal?: InputMaybe<SortEnumType>;
  voidReason?: InputMaybe<SortEnumType>;
};

export type TblVendor = {
  abbreviation?: Maybe<Scalars['String']>;
  allocatedInventories?: Maybe<Array<Maybe<AllocatedInventory>>>;
  assemblyOutputItems?: Maybe<Array<Maybe<AssemblyOutputItem>>>;
  bioTlocations?: Maybe<Scalars['String']>;
  bioTloctionType?: Maybe<Scalars['Int']>;
  bioTprocessor?: Maybe<Scalars['String']>;
  bioTproducer?: Maybe<Scalars['String']>;
  bioTretail?: Maybe<Scalars['String']>;
  bioTtranIdOriginal?: Maybe<Scalars['Int']>;
  bioTubi?: Maybe<Scalars['String']>;
  brandId?: Maybe<Scalars['Int']>;
  contactEmail?: Maybe<Scalars['String']>;
  contactName?: Maybe<Scalars['String']>;
  contactPhone?: Maybe<Scalars['String']>;
  countryId: Scalars['Int'];
  discountVendorRestrictions?: Maybe<Array<Maybe<DiscountVendorRestriction>>>;
  generalEmail?: Maybe<Scalars['String']>;
  generalPhone?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  isActive: Scalars['Boolean'];
  lsp?: Maybe<TblLsp>;
  lspId: Scalars['Int'];
  mdpricingHdrs?: Maybe<Array<Maybe<MdpricingHdr>>>;
  notes?: Maybe<Scalars['String']>;
  packages?: Maybe<Array<Maybe<Package>>>;
  quickbooksId?: Maybe<Scalars['String']>;
  receiveInventoryHistories?: Maybe<Array<Maybe<ReceiveInventoryHistory>>>;
  tblLspLocations?: Maybe<Array<Maybe<TblLspLocation>>>;
  tblWhseProducts?: Maybe<Array<Maybe<TblWhseProduct>>>;
  vendorAddr1: Scalars['String'];
  vendorCity: Scalars['String'];
  vendorCode?: Maybe<Scalars['String']>;
  vendorName: Scalars['String'];
  vendorPostalCode: Scalars['String'];
  vendorState?: Maybe<Scalars['String']>;
  vendorStatus: Scalars['String'];
  vendorType?: Maybe<VendorType>;
  vendorTypeId?: Maybe<Scalars['Short']>;
};

export type TblVendorCollectionSegment = {
  items?: Maybe<Array<Maybe<TblVendor>>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

export type TblVendorFilterInput = {
  abbreviation?: InputMaybe<StringOperationFilterInput>;
  allocatedInventories?: InputMaybe<ListFilterInputTypeOfAllocatedInventoryFilterInput>;
  and?: InputMaybe<Array<TblVendorFilterInput>>;
  assemblyOutputItems?: InputMaybe<ListFilterInputTypeOfAssemblyOutputItemFilterInput>;
  bioTlocations?: InputMaybe<StringOperationFilterInput>;
  bioTloctionType?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  bioTprocessor?: InputMaybe<StringOperationFilterInput>;
  bioTproducer?: InputMaybe<StringOperationFilterInput>;
  bioTretail?: InputMaybe<StringOperationFilterInput>;
  bioTtranIdOriginal?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  bioTubi?: InputMaybe<StringOperationFilterInput>;
  brandId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  contactEmail?: InputMaybe<StringOperationFilterInput>;
  contactName?: InputMaybe<StringOperationFilterInput>;
  contactPhone?: InputMaybe<StringOperationFilterInput>;
  countryId?: InputMaybe<ComparableInt32OperationFilterInput>;
  discountVendorRestrictions?: InputMaybe<ListFilterInputTypeOfDiscountVendorRestrictionFilterInput>;
  generalEmail?: InputMaybe<StringOperationFilterInput>;
  generalPhone?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  isActive?: InputMaybe<BooleanOperationFilterInput>;
  lsp?: InputMaybe<TblLspFilterInput>;
  lspId?: InputMaybe<ComparableInt32OperationFilterInput>;
  mdpricingHdrs?: InputMaybe<ListFilterInputTypeOfMdpricingHdrFilterInput>;
  notes?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<TblVendorFilterInput>>;
  packages?: InputMaybe<ListFilterInputTypeOfPackageFilterInput>;
  quickbooksId?: InputMaybe<StringOperationFilterInput>;
  receiveInventoryHistories?: InputMaybe<ListFilterInputTypeOfReceiveInventoryHistoryFilterInput>;
  tblLspLocations?: InputMaybe<ListFilterInputTypeOfTblLspLocationFilterInput>;
  tblWhseProducts?: InputMaybe<ListFilterInputTypeOfTblWhseProductFilterInput>;
  vendorAddr1?: InputMaybe<StringOperationFilterInput>;
  vendorCity?: InputMaybe<StringOperationFilterInput>;
  vendorCode?: InputMaybe<StringOperationFilterInput>;
  vendorName?: InputMaybe<StringOperationFilterInput>;
  vendorPostalCode?: InputMaybe<StringOperationFilterInput>;
  vendorState?: InputMaybe<StringOperationFilterInput>;
  vendorStatus?: InputMaybe<StringOperationFilterInput>;
  vendorType?: InputMaybe<VendorTypeFilterInput>;
  vendorTypeId?: InputMaybe<ComparableNullableOfInt16OperationFilterInput>;
};

export type TblVendorSortInput = {
  abbreviation?: InputMaybe<SortEnumType>;
  bioTlocations?: InputMaybe<SortEnumType>;
  bioTloctionType?: InputMaybe<SortEnumType>;
  bioTprocessor?: InputMaybe<SortEnumType>;
  bioTproducer?: InputMaybe<SortEnumType>;
  bioTretail?: InputMaybe<SortEnumType>;
  bioTtranIdOriginal?: InputMaybe<SortEnumType>;
  bioTubi?: InputMaybe<SortEnumType>;
  brandId?: InputMaybe<SortEnumType>;
  contactEmail?: InputMaybe<SortEnumType>;
  contactName?: InputMaybe<SortEnumType>;
  contactPhone?: InputMaybe<SortEnumType>;
  countryId?: InputMaybe<SortEnumType>;
  generalEmail?: InputMaybe<SortEnumType>;
  generalPhone?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isActive?: InputMaybe<SortEnumType>;
  lsp?: InputMaybe<TblLspSortInput>;
  lspId?: InputMaybe<SortEnumType>;
  notes?: InputMaybe<SortEnumType>;
  quickbooksId?: InputMaybe<SortEnumType>;
  vendorAddr1?: InputMaybe<SortEnumType>;
  vendorCity?: InputMaybe<SortEnumType>;
  vendorCode?: InputMaybe<SortEnumType>;
  vendorName?: InputMaybe<SortEnumType>;
  vendorPostalCode?: InputMaybe<SortEnumType>;
  vendorState?: InputMaybe<SortEnumType>;
  vendorStatus?: InputMaybe<SortEnumType>;
  vendorType?: InputMaybe<VendorTypeSortInput>;
  vendorTypeId?: InputMaybe<SortEnumType>;
};

export type TblWhseProduct = {
  abbreviation?: Maybe<Scalars['String']>;
  acceptedByMetric?: Maybe<Scalars['DateTime']>;
  acctBeforeDel?: Maybe<Scalars['Int']>;
  acctDelDtTm?: Maybe<Scalars['DateTime']>;
  administrationMethod?: Maybe<Scalars['String']>;
  allergenList?: Maybe<Scalars['String']>;
  allocatedInventories?: Maybe<Array<Maybe<AllocatedInventory>>>;
  allowAutomaticDiscounts: Scalars['Boolean'];
  alternateDesc?: Maybe<Scalars['String']>;
  appliedDiscounts?: Maybe<Array<Maybe<AppliedDiscount>>>;
  approvalDateUTC?: Maybe<Scalars['DateTime']>;
  assemblyInputItems?: Maybe<Array<Maybe<AssemblyInputItem>>>;
  assemblyOutputItems?: Maybe<Array<Maybe<AssemblyOutputItem>>>;
  bigOnlineDescription?: Maybe<Scalars['String']>;
  billOfMaterialsInputItems?: Maybe<Array<Maybe<BillOfMaterialsInputItem>>>;
  billOfMaterialsOutputItems?: Maybe<Array<Maybe<BillOfMaterialsOutputItem>>>;
  brand?: Maybe<Brand>;
  brandCatalogProductId?: Maybe<Scalars['String']>;
  brandCatalogProductVersionAccepted?: Maybe<Scalars['Int']>;
  brandId?: Maybe<Scalars['Int']>;
  cannabisInventory?: Maybe<Scalars['String']>;
  cbdcontent?: Maybe<Scalars['Decimal']>;
  cbdcontentUnitId?: Maybe<Scalars['Int']>;
  chargeCode?: Maybe<Scalars['Int']>;
  chargeCodeNavigation?: Maybe<TblChargeCodesSet>;
  coupon?: Maybe<Scalars['String']>;
  couponItem?: Maybe<Scalars['String']>;
  createdBy?: Maybe<Scalars['Int']>;
  createdDate?: Maybe<Scalars['DateTime']>;
  cultivator?: Maybe<Scalars['String']>;
  defaultLabelId?: Maybe<Scalars['Int']>;
  defaultUnit?: Maybe<Unit>;
  defaultUnitId?: Maybe<Scalars['Int']>;
  discountItem?: Maybe<Scalars['String']>;
  discountType?: Maybe<Scalars['String']>;
  distillation?: Maybe<Distillation>;
  distillationId?: Maybe<Scalars['Int']>;
  dosage?: Maybe<ProductDosage>;
  dosageId?: Maybe<Scalars['Int']>;
  expirationDays?: Maybe<Scalars['Int']>;
  externalCategory?: Maybe<Scalars['String']>;
  externalId?: Maybe<Scalars['String']>;
  externalSubCategory?: Maybe<Scalars['String']>;
  extractProduct?: Maybe<Scalars['String']>;
  fgreconDetails?: Maybe<Array<Maybe<FgreconDetail>>>;
  flavor?: Maybe<Scalars['String']>;
  flowerEquivalent?: Maybe<Scalars['Decimal']>;
  grossWeight?: Maybe<Scalars['Decimal']>;
  gtin?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  iltaxCategory?: Maybe<Scalars['Byte']>;
  ingredientList?: Maybe<Scalars['String']>;
  instructions?: Maybe<Scalars['String']>;
  inventoryLowCount?: Maybe<Scalars['Int']>;
  inventoryOwner?: Maybe<Scalars['Int']>;
  inventoryTransactions?: Maybe<Array<Maybe<InventoryTransaction>>>;
  isDeliveryDevice?: Maybe<Scalars['Boolean']>;
  isFinished?: Maybe<Scalars['Boolean']>;
  isNutrient: Scalars['Boolean'];
  isOnSale: Scalars['Boolean'];
  isRetired: Scalars['Boolean'];
  isTestProduct?: Maybe<Scalars['Boolean']>;
  itemTaxable?: Maybe<Scalars['String']>;
  lastAuditedDateUtc?: Maybe<Scalars['DateTime']>;
  lastModifiedDateUtc: Scalars['DateTime'];
  leafLinkBrandId?: Maybe<Scalars['Int']>;
  leafLinkCategoryId?: Maybe<Scalars['Int']>;
  leafLinkSubCategoryId?: Maybe<Scalars['Int']>;
  leaflyCategory?: Maybe<Scalars['String']>;
  lineageId?: Maybe<Scalars['Int']>;
  locBeforeDel?: Maybe<Scalars['Int']>;
  lowInventoryThreshold?: Maybe<Scalars['Decimal']>;
  lsp?: Maybe<TblLsp>;
  lspId?: Maybe<Scalars['Int']>;
  maxQuantityPerTransaction?: Maybe<Scalars['Decimal']>;
  mdDiscountProductsListDprods?: Maybe<Array<Maybe<MdDiscountProductsList>>>;
  mdDiscountProductsListProds?: Maybe<Array<Maybe<MdDiscountProductsList>>>;
  mddiscountProducts?: Maybe<Array<Maybe<MddiscountProduct>>>;
  medicalOnly: Scalars['Boolean'];
  mmurformId?: Maybe<Scalars['Int']>;
  mmurorderTypeId?: Maybe<Scalars['Int']>;
  mnmedicineId?: Maybe<Scalars['String']>;
  ndc?: Maybe<Scalars['String']>;
  netWeight?: Maybe<Scalars['Decimal']>;
  netWeightUnit?: Maybe<Scalars['Int']>;
  netWeightUnitNavigation?: Maybe<Unit>;
  nonCannabisWeight?: Maybe<Scalars['Decimal']>;
  nonCannabisWeightUnit?: Maybe<Scalars['Byte']>;
  ocsitemNumber?: Maybe<Scalars['String']>;
  ocsvariantNumber?: Maybe<Scalars['String']>;
  oilVolume?: Maybe<Scalars['Decimal']>;
  onlineDescription?: Maybe<Scalars['String']>;
  onlineProduct?: Maybe<Scalars['String']>;
  onlineTitle?: Maybe<Scalars['String']>;
  orderItems?: Maybe<Array<Maybe<OrderItem>>>;
  packages?: Maybe<Array<Maybe<Package>>>;
  pointValue?: Maybe<Scalars['Decimal']>;
  posproducts?: Maybe<Scalars['String']>;
  prescription?: Maybe<Scalars['String']>;
  producer?: Maybe<Producer>;
  producerId?: Maybe<Scalars['Int']>;
  product?: Maybe<PlantNutrientLog>;
  productGrams?: Maybe<Scalars['Decimal']>;
  productGroupId?: Maybe<Scalars['Int']>;
  productImageFileName?: Maybe<Scalars['String']>;
  productImageFileNameProcessed?: Maybe<Scalars['String']>;
  productMeasure?: Maybe<Scalars['String']>;
  productOz?: Maybe<Scalars['Decimal']>;
  productQty?: Maybe<Scalars['Int']>;
  productTaxCategories?: Maybe<Array<Maybe<ProductTaxCategory>>>;
  productToCustomerTypes?: Maybe<Array<Maybe<ProductToCustomerType>>>;
  productToTags?: Maybe<Array<Maybe<ProductToTag>>>;
  productType?: Maybe<Scalars['String']>;
  productTypeId?: Maybe<Scalars['Int']>;
  productTypeNavigation?: Maybe<TblWhseProductType>;
  recFlowerEquivalent?: Maybe<Scalars['Decimal']>;
  regulatoryCategory?: Maybe<RegulatoryCategory>;
  regulatoryCategoryId?: Maybe<Scalars['Short']>;
  retailPrice?: Maybe<Scalars['Decimal']>;
  sample?: Maybe<Scalars['String']>;
  servingSize?: Maybe<Scalars['String']>;
  servingSizePerUnit?: Maybe<Scalars['Int']>;
  sizeId?: Maybe<Scalars['Int']>;
  sizeListItem?: Maybe<ProductSizeListItem>;
  sizeListItemId?: Maybe<Scalars['Int']>;
  strain?: Maybe<TblBatchStrain>;
  strainId?: Maybe<Scalars['Int']>;
  subTotal?: Maybe<Scalars['Decimal']>;
  submittedToMetric?: Maybe<Scalars['DateTime']>;
  syncExternally: Scalars['Boolean'];
  taxAmt?: Maybe<Scalars['Decimal']>;
  tblLspLocationCoupons?: Maybe<Array<Maybe<TblLspLocation>>>;
  tblLspLocationDefaultPostransactionExistingCustomerNavigations?: Maybe<Array<Maybe<TblLspLocation>>>;
  tblLspLocationDefaultPostransactionNewCustomerNavigations?: Maybe<Array<Maybe<TblLspLocation>>>;
  tblWhseProductsTblAccts: Scalars['Int'];
  tblWhseProductsTblAcctsNavigation?: Maybe<TblAcct>;
  thccontent?: Maybe<Scalars['Decimal']>;
  thccontentUnitId?: Maybe<Scalars['Int']>;
  unitCbdContentDose?: Maybe<Scalars['Decimal']>;
  unitCost?: Maybe<Scalars['Decimal']>;
  unitThcContentDose?: Maybe<Scalars['Decimal']>;
  unitType?: Maybe<UnitType>;
  unitTypeId?: Maybe<Scalars['Int']>;
  uom?: Maybe<Scalars['String']>;
  upc?: Maybe<Scalars['String']>;
  useSkuNumberAsSerialNo?: Maybe<Scalars['String']>;
  vendor?: Maybe<Scalars['Int']>;
  vendorNavigation?: Maybe<TblVendor>;
  weedMapsCategoryId?: Maybe<Scalars['Short']>;
  weedMapsOnlineOrderable?: Maybe<Scalars['Boolean']>;
  weedMapsSubCategoryId?: Maybe<Scalars['Int']>;
  wholesalePrice?: Maybe<Scalars['Decimal']>;
  whseProductImage?: Maybe<Array<Scalars['Byte']>>;
  whseProductsDescription: Scalars['String'];
  whseProductsProductNo: Scalars['String'];
  whseProductsRecUnitPrice?: Maybe<Scalars['Decimal']>;
  whseProductsUnitPrice?: Maybe<Scalars['Decimal']>;
};

export type TblWhseProductCollectionSegment = {
  items?: Maybe<Array<Maybe<TblWhseProduct>>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

export type TblWhseProductFilterInput = {
  abbreviation?: InputMaybe<StringOperationFilterInput>;
  acceptedByMetric?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  acctBeforeDel?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  acctDelDtTm?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  administrationMethod?: InputMaybe<StringOperationFilterInput>;
  allergenList?: InputMaybe<StringOperationFilterInput>;
  allocatedInventories?: InputMaybe<ListFilterInputTypeOfAllocatedInventoryFilterInput>;
  allowAutomaticDiscounts?: InputMaybe<BooleanOperationFilterInput>;
  alternateDesc?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<TblWhseProductFilterInput>>;
  appliedDiscounts?: InputMaybe<ListFilterInputTypeOfAppliedDiscountFilterInput>;
  approvalDateUTC?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  assemblyInputItems?: InputMaybe<ListFilterInputTypeOfAssemblyInputItemFilterInput>;
  assemblyOutputItems?: InputMaybe<ListFilterInputTypeOfAssemblyOutputItemFilterInput>;
  bigOnlineDescription?: InputMaybe<StringOperationFilterInput>;
  billOfMaterialsInputItems?: InputMaybe<ListFilterInputTypeOfBillOfMaterialsInputItemFilterInput>;
  billOfMaterialsOutputItems?: InputMaybe<ListFilterInputTypeOfBillOfMaterialsOutputItemFilterInput>;
  brand?: InputMaybe<BrandFilterInput>;
  brandCatalogProductId?: InputMaybe<StringOperationFilterInput>;
  brandCatalogProductVersionAccepted?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  brandId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  cannabisInventory?: InputMaybe<StringOperationFilterInput>;
  cbdcontent?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  cbdcontentUnitId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  chargeCode?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  chargeCodeNavigation?: InputMaybe<TblChargeCodesSetFilterInput>;
  coupon?: InputMaybe<StringOperationFilterInput>;
  couponItem?: InputMaybe<StringOperationFilterInput>;
  createdBy?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  createdDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  cultivator?: InputMaybe<StringOperationFilterInput>;
  defaultLabelId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  defaultUnit?: InputMaybe<UnitFilterInput>;
  defaultUnitId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  discountItem?: InputMaybe<StringOperationFilterInput>;
  discountType?: InputMaybe<StringOperationFilterInput>;
  distillation?: InputMaybe<DistillationFilterInput>;
  distillationId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  dosage?: InputMaybe<ProductDosageFilterInput>;
  dosageId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  expirationDays?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  externalCategory?: InputMaybe<StringOperationFilterInput>;
  externalId?: InputMaybe<StringOperationFilterInput>;
  externalSubCategory?: InputMaybe<StringOperationFilterInput>;
  extractProduct?: InputMaybe<StringOperationFilterInput>;
  fgreconDetails?: InputMaybe<ListFilterInputTypeOfFgreconDetailFilterInput>;
  flavor?: InputMaybe<StringOperationFilterInput>;
  flowerEquivalent?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  grossWeight?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  gtin?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  iltaxCategory?: InputMaybe<ComparableNullableOfByteOperationFilterInput>;
  ingredientList?: InputMaybe<StringOperationFilterInput>;
  instructions?: InputMaybe<StringOperationFilterInput>;
  inventoryLowCount?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  inventoryOwner?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  inventoryTransactions?: InputMaybe<ListFilterInputTypeOfInventoryTransactionFilterInput>;
  isDeliveryDevice?: InputMaybe<BooleanOperationFilterInput>;
  isFinished?: InputMaybe<BooleanOperationFilterInput>;
  isNutrient?: InputMaybe<BooleanOperationFilterInput>;
  isOnSale?: InputMaybe<BooleanOperationFilterInput>;
  isRetired?: InputMaybe<BooleanOperationFilterInput>;
  isTestProduct?: InputMaybe<BooleanOperationFilterInput>;
  itemTaxable?: InputMaybe<StringOperationFilterInput>;
  lastModifiedDateUtc?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  leafLinkBrandId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  leafLinkCategoryId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  leafLinkSubCategoryId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  leaflyCategory?: InputMaybe<StringOperationFilterInput>;
  lineageId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  locBeforeDel?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  lowInventoryThreshold?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  lsp?: InputMaybe<TblLspFilterInput>;
  lspId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  maxQuantityPerTransaction?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  mdDiscountProductsListDprods?: InputMaybe<ListFilterInputTypeOfMdDiscountProductsListFilterInput>;
  mdDiscountProductsListProds?: InputMaybe<ListFilterInputTypeOfMdDiscountProductsListFilterInput>;
  mddiscountProducts?: InputMaybe<ListFilterInputTypeOfMddiscountProductFilterInput>;
  medicalOnly?: InputMaybe<BooleanOperationFilterInput>;
  mmurformId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  mmurorderTypeId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  mnmedicineId?: InputMaybe<StringOperationFilterInput>;
  ndc?: InputMaybe<StringOperationFilterInput>;
  netWeight?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  netWeightUnit?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  netWeightUnitNavigation?: InputMaybe<UnitFilterInput>;
  nonCannabisWeight?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  nonCannabisWeightUnit?: InputMaybe<ComparableNullableOfByteOperationFilterInput>;
  ocsitemNumber?: InputMaybe<StringOperationFilterInput>;
  ocsvariantNumber?: InputMaybe<StringOperationFilterInput>;
  oilVolume?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  onlineDescription?: InputMaybe<StringOperationFilterInput>;
  onlineProduct?: InputMaybe<StringOperationFilterInput>;
  onlineTitle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<TblWhseProductFilterInput>>;
  orderItems?: InputMaybe<ListFilterInputTypeOfOrderItemFilterInput>;
  packages?: InputMaybe<ListFilterInputTypeOfPackageFilterInput>;
  pointValue?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  posproducts?: InputMaybe<StringOperationFilterInput>;
  prescription?: InputMaybe<StringOperationFilterInput>;
  producer?: InputMaybe<ProducerFilterInput>;
  producerId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  product?: InputMaybe<PlantNutrientLogFilterInput>;
  productGrams?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  productGroupId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  productImageFileName?: InputMaybe<StringOperationFilterInput>;
  productMeasure?: InputMaybe<StringOperationFilterInput>;
  productOz?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  productQty?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  productTaxCategories?: InputMaybe<ListFilterInputTypeOfProductTaxCategoryFilterInput>;
  productToCustomerTypes?: InputMaybe<ListFilterInputTypeOfProductToCustomerTypeFilterInput>;
  productToTags?: InputMaybe<ListFilterInputTypeOfProductToTagFilterInput>;
  productType?: InputMaybe<StringOperationFilterInput>;
  productTypeId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  productTypeNavigation?: InputMaybe<TblWhseProductTypeFilterInput>;
  recFlowerEquivalent?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  regulatoryCategory?: InputMaybe<RegulatoryCategoryFilterInput>;
  regulatoryCategoryId?: InputMaybe<ComparableNullableOfInt16OperationFilterInput>;
  retailPrice?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  sample?: InputMaybe<StringOperationFilterInput>;
  servingSize?: InputMaybe<StringOperationFilterInput>;
  servingSizePerUnit?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  sizeId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  sizeListItem?: InputMaybe<ProductSizeListItemFilterInput>;
  sizeListItemId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  strain?: InputMaybe<TblBatchStrainFilterInput>;
  strainId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  subTotal?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  submittedToMetric?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  syncExternally?: InputMaybe<BooleanOperationFilterInput>;
  taxAmt?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  tblLspLocationCoupons?: InputMaybe<ListFilterInputTypeOfTblLspLocationFilterInput>;
  tblLspLocationDefaultPostransactionExistingCustomerNavigations?: InputMaybe<ListFilterInputTypeOfTblLspLocationFilterInput>;
  tblLspLocationDefaultPostransactionNewCustomerNavigations?: InputMaybe<ListFilterInputTypeOfTblLspLocationFilterInput>;
  tblWhseProductsTblAccts?: InputMaybe<ComparableInt32OperationFilterInput>;
  tblWhseProductsTblAcctsNavigation?: InputMaybe<TblAcctFilterInput>;
  thccontent?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  thccontentUnitId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  unitCbdContentDose?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  unitCost?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  unitThcContentDose?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  unitType?: InputMaybe<UnitTypeFilterInput>;
  unitTypeId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  uom?: InputMaybe<StringOperationFilterInput>;
  upc?: InputMaybe<StringOperationFilterInput>;
  useSkuNumberAsSerialNo?: InputMaybe<StringOperationFilterInput>;
  vendor?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  vendorNavigation?: InputMaybe<TblVendorFilterInput>;
  weedMapsCategoryId?: InputMaybe<ComparableNullableOfInt16OperationFilterInput>;
  weedMapsOnlineOrderable?: InputMaybe<BooleanOperationFilterInput>;
  weedMapsSubCategoryId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  wholesalePrice?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  whseProductImage?: InputMaybe<ListComparableByteOperationFilterInput>;
  whseProductsDescription?: InputMaybe<StringOperationFilterInput>;
  whseProductsProductNo?: InputMaybe<StringOperationFilterInput>;
  whseProductsRecUnitPrice?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  whseProductsUnitPrice?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
};

export type TblWhseProductSortInput = {
  abbreviation?: InputMaybe<SortEnumType>;
  acceptedByMetric?: InputMaybe<SortEnumType>;
  acctBeforeDel?: InputMaybe<SortEnumType>;
  acctDelDtTm?: InputMaybe<SortEnumType>;
  administrationMethod?: InputMaybe<SortEnumType>;
  allergenList?: InputMaybe<SortEnumType>;
  allowAutomaticDiscounts?: InputMaybe<SortEnumType>;
  alternateDesc?: InputMaybe<SortEnumType>;
  approvalDateUTC?: InputMaybe<SortEnumType>;
  bigOnlineDescription?: InputMaybe<SortEnumType>;
  brand?: InputMaybe<BrandSortInput>;
  brandCatalogProductId?: InputMaybe<SortEnumType>;
  brandCatalogProductVersionAccepted?: InputMaybe<SortEnumType>;
  brandId?: InputMaybe<SortEnumType>;
  cannabisInventory?: InputMaybe<SortEnumType>;
  cbdcontent?: InputMaybe<SortEnumType>;
  cbdcontentUnitId?: InputMaybe<SortEnumType>;
  chargeCode?: InputMaybe<SortEnumType>;
  chargeCodeNavigation?: InputMaybe<TblChargeCodesSetSortInput>;
  coupon?: InputMaybe<SortEnumType>;
  couponItem?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  createdDate?: InputMaybe<SortEnumType>;
  cultivator?: InputMaybe<SortEnumType>;
  defaultLabelId?: InputMaybe<SortEnumType>;
  defaultUnit?: InputMaybe<UnitSortInput>;
  defaultUnitId?: InputMaybe<SortEnumType>;
  discountItem?: InputMaybe<SortEnumType>;
  discountType?: InputMaybe<SortEnumType>;
  distillation?: InputMaybe<DistillationSortInput>;
  distillationId?: InputMaybe<SortEnumType>;
  dosage?: InputMaybe<ProductDosageSortInput>;
  dosageId?: InputMaybe<SortEnumType>;
  expirationDays?: InputMaybe<SortEnumType>;
  externalCategory?: InputMaybe<SortEnumType>;
  externalId?: InputMaybe<SortEnumType>;
  externalSubCategory?: InputMaybe<SortEnumType>;
  extractProduct?: InputMaybe<SortEnumType>;
  flavor?: InputMaybe<SortEnumType>;
  flowerEquivalent?: InputMaybe<SortEnumType>;
  grossWeight?: InputMaybe<SortEnumType>;
  gtin?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  iltaxCategory?: InputMaybe<SortEnumType>;
  ingredientList?: InputMaybe<SortEnumType>;
  instructions?: InputMaybe<SortEnumType>;
  inventoryLowCount?: InputMaybe<SortEnumType>;
  inventoryOwner?: InputMaybe<SortEnumType>;
  isDeliveryDevice?: InputMaybe<SortEnumType>;
  isFinished?: InputMaybe<SortEnumType>;
  isNutrient?: InputMaybe<SortEnumType>;
  isOnSale?: InputMaybe<SortEnumType>;
  isRetired?: InputMaybe<SortEnumType>;
  isTestProduct?: InputMaybe<SortEnumType>;
  itemTaxable?: InputMaybe<SortEnumType>;
  lastModifiedDateUtc?: InputMaybe<SortEnumType>;
  leafLinkBrandId?: InputMaybe<SortEnumType>;
  leafLinkCategoryId?: InputMaybe<SortEnumType>;
  leafLinkSubCategoryId?: InputMaybe<SortEnumType>;
  leaflyCategory?: InputMaybe<SortEnumType>;
  lineageId?: InputMaybe<SortEnumType>;
  locBeforeDel?: InputMaybe<SortEnumType>;
  lowInventoryThreshold?: InputMaybe<SortEnumType>;
  lsp?: InputMaybe<TblLspSortInput>;
  lspId?: InputMaybe<SortEnumType>;
  maxQuantityPerTransaction?: InputMaybe<SortEnumType>;
  medicalOnly?: InputMaybe<SortEnumType>;
  mmurformId?: InputMaybe<SortEnumType>;
  mmurorderTypeId?: InputMaybe<SortEnumType>;
  mnmedicineId?: InputMaybe<SortEnumType>;
  ndc?: InputMaybe<SortEnumType>;
  netWeight?: InputMaybe<SortEnumType>;
  netWeightUnit?: InputMaybe<SortEnumType>;
  netWeightUnitNavigation?: InputMaybe<UnitSortInput>;
  nonCannabisWeight?: InputMaybe<SortEnumType>;
  nonCannabisWeightUnit?: InputMaybe<SortEnumType>;
  ocsitemNumber?: InputMaybe<SortEnumType>;
  ocsvariantNumber?: InputMaybe<SortEnumType>;
  oilVolume?: InputMaybe<SortEnumType>;
  onlineDescription?: InputMaybe<SortEnumType>;
  onlineProduct?: InputMaybe<SortEnumType>;
  onlineTitle?: InputMaybe<SortEnumType>;
  pointValue?: InputMaybe<SortEnumType>;
  posproducts?: InputMaybe<SortEnumType>;
  prescription?: InputMaybe<SortEnumType>;
  producer?: InputMaybe<ProducerSortInput>;
  producerId?: InputMaybe<SortEnumType>;
  product?: InputMaybe<PlantNutrientLogSortInput>;
  productGrams?: InputMaybe<SortEnumType>;
  productGroupId?: InputMaybe<SortEnumType>;
  productImageFileName?: InputMaybe<SortEnumType>;
  productMeasure?: InputMaybe<SortEnumType>;
  productOz?: InputMaybe<SortEnumType>;
  productQty?: InputMaybe<SortEnumType>;
  productType?: InputMaybe<SortEnumType>;
  productTypeId?: InputMaybe<SortEnumType>;
  productTypeNavigation?: InputMaybe<TblWhseProductTypeSortInput>;
  recFlowerEquivalent?: InputMaybe<SortEnumType>;
  regulatoryCategory?: InputMaybe<RegulatoryCategorySortInput>;
  regulatoryCategoryId?: InputMaybe<SortEnumType>;
  retailPrice?: InputMaybe<SortEnumType>;
  sample?: InputMaybe<SortEnumType>;
  servingSize?: InputMaybe<SortEnumType>;
  servingSizePerUnit?: InputMaybe<SortEnumType>;
  sizeId?: InputMaybe<SortEnumType>;
  sizeListItem?: InputMaybe<ProductSizeListItemSortInput>;
  sizeListItemId?: InputMaybe<SortEnumType>;
  strain?: InputMaybe<TblBatchStrainSortInput>;
  strainId?: InputMaybe<SortEnumType>;
  subTotal?: InputMaybe<SortEnumType>;
  submittedToMetric?: InputMaybe<SortEnumType>;
  syncExternally?: InputMaybe<SortEnumType>;
  taxAmt?: InputMaybe<SortEnumType>;
  tblWhseProductsTblAccts?: InputMaybe<SortEnumType>;
  tblWhseProductsTblAcctsNavigation?: InputMaybe<TblAcctSortInput>;
  thccontent?: InputMaybe<SortEnumType>;
  thccontentUnitId?: InputMaybe<SortEnumType>;
  unitCbdContentDose?: InputMaybe<SortEnumType>;
  unitCost?: InputMaybe<SortEnumType>;
  unitThcContentDose?: InputMaybe<SortEnumType>;
  unitType?: InputMaybe<UnitTypeSortInput>;
  unitTypeId?: InputMaybe<SortEnumType>;
  uom?: InputMaybe<SortEnumType>;
  upc?: InputMaybe<SortEnumType>;
  useSkuNumberAsSerialNo?: InputMaybe<SortEnumType>;
  vendor?: InputMaybe<SortEnumType>;
  vendorNavigation?: InputMaybe<TblVendorSortInput>;
  weedMapsCategoryId?: InputMaybe<SortEnumType>;
  weedMapsOnlineOrderable?: InputMaybe<SortEnumType>;
  weedMapsSubCategoryId?: InputMaybe<SortEnumType>;
  wholesalePrice?: InputMaybe<SortEnumType>;
  whseProductsDescription?: InputMaybe<SortEnumType>;
  whseProductsProductNo?: InputMaybe<SortEnumType>;
  whseProductsRecUnitPrice?: InputMaybe<SortEnumType>;
  whseProductsUnitPrice?: InputMaybe<SortEnumType>;
};

export type TblWhseProductType = {
  allotment?: Maybe<Scalars['Decimal']>;
  allotmentDays?: Maybe<Scalars['Int']>;
  allotmentRdays?: Maybe<Scalars['Int']>;
  allotmentRecreational?: Maybe<Scalars['Decimal']>;
  assemblyInputItems?: Maybe<Array<Maybe<AssemblyInputItem>>>;
  assemblyOutputItems?: Maybe<Array<Maybe<AssemblyOutputItem>>>;
  billOfMaterialsInputItems?: Maybe<Array<Maybe<BillOfMaterialsInputItem>>>;
  billOfMaterialsOutputItems?: Maybe<Array<Maybe<BillOfMaterialsOutputItem>>>;
  categoryGroup?: Maybe<Scalars['Int']>;
  discountCategoryRestrictions?: Maybe<Array<Maybe<DiscountCategoryRestriction>>>;
  discountFlag?: Maybe<Scalars['String']>;
  ecomCategory?: Maybe<Scalars['String']>;
  ecomSubcategory?: Maybe<Scalars['String']>;
  feeDonations?: Maybe<Array<Maybe<FeeDonation>>>;
  flowerEquivalent?: Maybe<Scalars['Decimal']>;
  id: Scalars['Int'];
  inventoryAuditToCategories?: Maybe<Array<Maybe<InventoryAuditToCategory>>>;
  isDeleted: Scalars['Boolean'];
  labelId?: Maybe<Scalars['Int']>;
  leafLinkCategoryId?: Maybe<Scalars['Int']>;
  leafLinkSubCategoryId?: Maybe<Scalars['Int']>;
  leaflyCategory?: Maybe<Scalars['String']>;
  lsp?: Maybe<TblLsp>;
  lspId: Scalars['Int'];
  masterCategory?: Maybe<Scalars['String']>;
  mdpricingHdrs?: Maybe<Array<Maybe<MdpricingHdr>>>;
  metricCategoryId?: Maybe<Scalars['Int']>;
  mmurformId?: Maybe<Scalars['Int']>;
  mmurforms?: Maybe<Array<Maybe<Mmurform>>>;
  productFlag?: Maybe<Scalars['String']>;
  productTaxCategories?: Maybe<Array<Maybe<ProductTaxCategory>>>;
  productType?: Maybe<Scalars['String']>;
  productTypeToCustomerTypes?: Maybe<Array<Maybe<ProductTypeToCustomerType>>>;
  productTypeToRevenueAccount?: Maybe<ProductTypeToRevenueAccount>;
  purchaseLimitCategoryId?: Maybe<Scalars['Int']>;
  recFlowerEquivalent?: Maybe<Scalars['Decimal']>;
  regulatoryCategory?: Maybe<RegulatoryCategory>;
  regulatoryCategoryId?: Maybe<Scalars['Short']>;
  stateInventoryFlag: Scalars['String'];
  taxRate?: Maybe<Scalars['Decimal']>;
  tblMdlabels?: Maybe<Array<Maybe<TblMdlabel>>>;
  tblWhseProducts?: Maybe<Array<Maybe<TblWhseProduct>>>;
  weedMapsCategoryId?: Maybe<Scalars['Short']>;
  weedMapsSubCategoryId?: Maybe<Scalars['Short']>;
};

export type TblWhseProductTypeCollectionSegment = {
  items?: Maybe<Array<Maybe<TblWhseProductType>>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

export type TblWhseProductTypeFilterInput = {
  allotment?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  allotmentDays?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  allotmentRdays?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  allotmentRecreational?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  and?: InputMaybe<Array<TblWhseProductTypeFilterInput>>;
  assemblyInputItems?: InputMaybe<ListFilterInputTypeOfAssemblyInputItemFilterInput>;
  assemblyOutputItems?: InputMaybe<ListFilterInputTypeOfAssemblyOutputItemFilterInput>;
  billOfMaterialsInputItems?: InputMaybe<ListFilterInputTypeOfBillOfMaterialsInputItemFilterInput>;
  billOfMaterialsOutputItems?: InputMaybe<ListFilterInputTypeOfBillOfMaterialsOutputItemFilterInput>;
  categoryGroup?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  discountCategoryRestrictions?: InputMaybe<ListFilterInputTypeOfDiscountCategoryRestrictionFilterInput>;
  discountFlag?: InputMaybe<StringOperationFilterInput>;
  ecomCategory?: InputMaybe<StringOperationFilterInput>;
  ecomSubcategory?: InputMaybe<StringOperationFilterInput>;
  feeDonations?: InputMaybe<ListFilterInputTypeOfFeeDonationFilterInput>;
  flowerEquivalent?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  inventoryAuditToCategories?: InputMaybe<ListFilterInputTypeOfInventoryAuditToCategoryFilterInput>;
  isDeleted?: InputMaybe<BooleanOperationFilterInput>;
  labelId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  leafLinkCategoryId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  leafLinkSubCategoryId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  leaflyCategory?: InputMaybe<StringOperationFilterInput>;
  lsp?: InputMaybe<TblLspFilterInput>;
  lspId?: InputMaybe<ComparableInt32OperationFilterInput>;
  masterCategory?: InputMaybe<StringOperationFilterInput>;
  mdpricingHdrs?: InputMaybe<ListFilterInputTypeOfMdpricingHdrFilterInput>;
  metricCategoryId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  mmurformId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  mmurforms?: InputMaybe<ListFilterInputTypeOfMmurformFilterInput>;
  or?: InputMaybe<Array<TblWhseProductTypeFilterInput>>;
  productFlag?: InputMaybe<StringOperationFilterInput>;
  productTaxCategories?: InputMaybe<ListFilterInputTypeOfProductTaxCategoryFilterInput>;
  productType?: InputMaybe<StringOperationFilterInput>;
  productTypeToCustomerTypes?: InputMaybe<ListFilterInputTypeOfProductTypeToCustomerTypeFilterInput>;
  productTypeToRevenueAccount?: InputMaybe<ProductTypeToRevenueAccountFilterInput>;
  purchaseLimitCategoryId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  recFlowerEquivalent?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  regulatoryCategory?: InputMaybe<RegulatoryCategoryFilterInput>;
  regulatoryCategoryId?: InputMaybe<ComparableNullableOfInt16OperationFilterInput>;
  stateInventoryFlag?: InputMaybe<StringOperationFilterInput>;
  taxRate?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  tblMdlabels?: InputMaybe<ListFilterInputTypeOfTblMdlabelFilterInput>;
  tblWhseProducts?: InputMaybe<ListFilterInputTypeOfTblWhseProductFilterInput>;
  weedMapsCategoryId?: InputMaybe<ComparableNullableOfInt16OperationFilterInput>;
  weedMapsSubCategoryId?: InputMaybe<ComparableNullableOfInt16OperationFilterInput>;
};

export type TblWhseProductTypeSortInput = {
  allotment?: InputMaybe<SortEnumType>;
  allotmentDays?: InputMaybe<SortEnumType>;
  allotmentRdays?: InputMaybe<SortEnumType>;
  allotmentRecreational?: InputMaybe<SortEnumType>;
  categoryGroup?: InputMaybe<SortEnumType>;
  discountFlag?: InputMaybe<SortEnumType>;
  ecomCategory?: InputMaybe<SortEnumType>;
  ecomSubcategory?: InputMaybe<SortEnumType>;
  flowerEquivalent?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isDeleted?: InputMaybe<SortEnumType>;
  labelId?: InputMaybe<SortEnumType>;
  leafLinkCategoryId?: InputMaybe<SortEnumType>;
  leafLinkSubCategoryId?: InputMaybe<SortEnumType>;
  leaflyCategory?: InputMaybe<SortEnumType>;
  lsp?: InputMaybe<TblLspSortInput>;
  lspId?: InputMaybe<SortEnumType>;
  masterCategory?: InputMaybe<SortEnumType>;
  metricCategoryId?: InputMaybe<SortEnumType>;
  mmurformId?: InputMaybe<SortEnumType>;
  productFlag?: InputMaybe<SortEnumType>;
  productType?: InputMaybe<SortEnumType>;
  productTypeToRevenueAccount?: InputMaybe<ProductTypeToRevenueAccountSortInput>;
  purchaseLimitCategoryId?: InputMaybe<SortEnumType>;
  recFlowerEquivalent?: InputMaybe<SortEnumType>;
  regulatoryCategory?: InputMaybe<RegulatoryCategorySortInput>;
  regulatoryCategoryId?: InputMaybe<SortEnumType>;
  stateInventoryFlag?: InputMaybe<SortEnumType>;
  taxRate?: InputMaybe<SortEnumType>;
  weedMapsCategoryId?: InputMaybe<SortEnumType>;
  weedMapsSubCategoryId?: InputMaybe<SortEnumType>;
};

export type TblWhseProductsAudit = {
  auditAction?: Maybe<Scalars['AuditActionScalar']>;
  auditDateTimeUtc: Scalars['DateTime'];
  changedByUser?: Maybe<TblAuthUser>;
  productChanged?: Maybe<TblWhseProduct>;
  productId: Scalars['Int'];
  sessionlocId?: Maybe<Scalars['Int']>;
  sessionlspId?: Maybe<Scalars['Int']>;
  tblWhseProductsAuditData?: Maybe<Array<Maybe<TblWhseProductsAuditDatum>>>;
  userId?: Maybe<Scalars['Int']>;
  whseProductsAuditId: Scalars['Int'];
};

export type TblWhseProductsAuditCollectionSegment = {
  items?: Maybe<Array<Maybe<TblWhseProductsAudit>>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

export type TblWhseProductsAuditDatum = {
  columnChanged?: Maybe<Scalars['String']>;
  newValue?: Maybe<Scalars['String']>;
  oldValue?: Maybe<Scalars['String']>;
  whseProductsAudit?: Maybe<TblWhseProductsAudit>;
  whseProductsAuditDataId: Scalars['Int'];
  whseProductsAuditId: Scalars['Int'];
};

export type TblWhseProductsAuditDatumFilterInput = {
  and?: InputMaybe<Array<TblWhseProductsAuditDatumFilterInput>>;
  columnChanged?: InputMaybe<StringOperationFilterInput>;
  newValue?: InputMaybe<StringOperationFilterInput>;
  oldValue?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<TblWhseProductsAuditDatumFilterInput>>;
  whseProductsAudit?: InputMaybe<TblWhseProductsAuditFilterInput>;
  whseProductsAuditDataId?: InputMaybe<ComparableInt32OperationFilterInput>;
  whseProductsAuditId?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type TblWhseProductsAuditFilterInput = {
  and?: InputMaybe<Array<TblWhseProductsAuditFilterInput>>;
  auditAction?: InputMaybe<StringOperationFilterInput>;
  auditDateTimeUtc?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  or?: InputMaybe<Array<TblWhseProductsAuditFilterInput>>;
  productChanged?: InputMaybe<TblWhseProductFilterInput>;
  productId?: InputMaybe<ComparableInt32OperationFilterInput>;
  sessionlocId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  sessionlspId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  tblWhseProductsAuditData?: InputMaybe<ListFilterInputTypeOfTblWhseProductsAuditDatumFilterInput>;
  userId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  whseProductsAuditId?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type TblWhseProductsAuditSortInput = {
  auditAction?: InputMaybe<SortEnumType>;
  auditDateTimeUtc?: InputMaybe<SortEnumType>;
  productChanged?: InputMaybe<TblWhseProductSortInput>;
  productId?: InputMaybe<SortEnumType>;
  sessionlocId?: InputMaybe<SortEnumType>;
  sessionlspId?: InputMaybe<SortEnumType>;
  userId?: InputMaybe<SortEnumType>;
  whseProductsAuditId?: InputMaybe<SortEnumType>;
};

export type TrymControlInfo = {
  apiKey: Scalars['String'];
  baseUrl: Scalars['String'];
  isEnabled: Scalars['Boolean'];
  lastModifiedUtc: Scalars['DateTime'];
  loc?: Maybe<TblLspLocation>;
  locId: Scalars['Int'];
  lsp?: Maybe<TblLsp>;
  lspId: Scalars['Int'];
  trymControlInfoId: Scalars['Int'];
};

export type TrymControlInfoFilterInput = {
  and?: InputMaybe<Array<TrymControlInfoFilterInput>>;
  apiKey?: InputMaybe<StringOperationFilterInput>;
  baseUrl?: InputMaybe<StringOperationFilterInput>;
  isEnabled?: InputMaybe<BooleanOperationFilterInput>;
  lastModifiedUtc?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  loc?: InputMaybe<TblLspLocationFilterInput>;
  locId?: InputMaybe<ComparableInt32OperationFilterInput>;
  lsp?: InputMaybe<TblLspFilterInput>;
  lspId?: InputMaybe<ComparableInt32OperationFilterInput>;
  or?: InputMaybe<Array<TrymControlInfoFilterInput>>;
  trymControlInfoId?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type Unit = {
  abbreviation?: Maybe<Scalars['String']>;
  allocatedInventories?: Maybe<Array<Maybe<AllocatedInventory>>>;
  assemblyInputItems?: Maybe<Array<Maybe<AssemblyInputItem>>>;
  assemblyInputPackages?: Maybe<Array<Maybe<AssemblyInputPackage>>>;
  assemblyOutputItems?: Maybe<Array<Maybe<AssemblyOutputItem>>>;
  assemblyQuantityWasteUnits?: Maybe<Array<Maybe<Assembly>>>;
  assemblyVolumeWasteUnits?: Maybe<Array<Maybe<Assembly>>>;
  assemblyWeightWasteUnits?: Maybe<Array<Maybe<Assembly>>>;
  billOfMaterialsInputItems?: Maybe<Array<Maybe<BillOfMaterialsInputItem>>>;
  billOfMaterialsOutputItems?: Maybe<Array<Maybe<BillOfMaterialsOutputItem>>>;
  inventoryAdjustTransactions?: Maybe<Array<Maybe<InventoryAdjustTransaction>>>;
  inventoryTransactions?: Maybe<Array<Maybe<InventoryTransaction>>>;
  orderItems?: Maybe<Array<Maybe<OrderItem>>>;
  packageNetWeightUnitNavigations?: Maybe<Array<Maybe<Package>>>;
  packageUnits?: Maybe<Array<Maybe<Package>>>;
  removedInventories?: Maybe<Array<Maybe<RemovedInventory>>>;
  tblWhseProductDefaultUnits?: Maybe<Array<Maybe<TblWhseProduct>>>;
  tblWhseProductNetWeightUnitNavigations?: Maybe<Array<Maybe<TblWhseProduct>>>;
  unitId: Scalars['Int'];
  unitName: Scalars['String'];
  unitType?: Maybe<UnitType>;
  unitTypeId: Scalars['Int'];
};

export type UnitFilterInput = {
  abbreviation?: InputMaybe<StringOperationFilterInput>;
  allocatedInventories?: InputMaybe<ListFilterInputTypeOfAllocatedInventoryFilterInput>;
  and?: InputMaybe<Array<UnitFilterInput>>;
  assemblyInputItems?: InputMaybe<ListFilterInputTypeOfAssemblyInputItemFilterInput>;
  assemblyInputPackages?: InputMaybe<ListFilterInputTypeOfAssemblyInputPackageFilterInput>;
  assemblyOutputItems?: InputMaybe<ListFilterInputTypeOfAssemblyOutputItemFilterInput>;
  assemblyQuantityWasteUnits?: InputMaybe<ListFilterInputTypeOfAssemblyFilterInput>;
  assemblyVolumeWasteUnits?: InputMaybe<ListFilterInputTypeOfAssemblyFilterInput>;
  assemblyWeightWasteUnits?: InputMaybe<ListFilterInputTypeOfAssemblyFilterInput>;
  billOfMaterialsInputItems?: InputMaybe<ListFilterInputTypeOfBillOfMaterialsInputItemFilterInput>;
  billOfMaterialsOutputItems?: InputMaybe<ListFilterInputTypeOfBillOfMaterialsOutputItemFilterInput>;
  inventoryAdjustTransactions?: InputMaybe<ListFilterInputTypeOfInventoryAdjustTransactionFilterInput>;
  inventoryTransactions?: InputMaybe<ListFilterInputTypeOfInventoryTransactionFilterInput>;
  or?: InputMaybe<Array<UnitFilterInput>>;
  orderItems?: InputMaybe<ListFilterInputTypeOfOrderItemFilterInput>;
  packageNetWeightUnitNavigations?: InputMaybe<ListFilterInputTypeOfPackageFilterInput>;
  packageUnits?: InputMaybe<ListFilterInputTypeOfPackageFilterInput>;
  removedInventories?: InputMaybe<ListFilterInputTypeOfRemovedInventoryFilterInput>;
  tblWhseProductDefaultUnits?: InputMaybe<ListFilterInputTypeOfTblWhseProductFilterInput>;
  tblWhseProductNetWeightUnitNavigations?: InputMaybe<ListFilterInputTypeOfTblWhseProductFilterInput>;
  unitId?: InputMaybe<ComparableInt32OperationFilterInput>;
  unitName?: InputMaybe<StringOperationFilterInput>;
  unitType?: InputMaybe<UnitTypeFilterInput>;
  unitTypeId?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type UnitSortInput = {
  abbreviation?: InputMaybe<SortEnumType>;
  unitId?: InputMaybe<SortEnumType>;
  unitName?: InputMaybe<SortEnumType>;
  unitType?: InputMaybe<UnitTypeSortInput>;
  unitTypeId?: InputMaybe<SortEnumType>;
};

export type UnitType = {
  tblWhseProducts?: Maybe<Array<Maybe<TblWhseProduct>>>;
  unitTypeAbbreviation?: Maybe<Scalars['String']>;
  unitTypeId: Scalars['Int'];
  unitTypeName: Scalars['String'];
  units?: Maybe<Array<Maybe<Unit>>>;
};

export type UnitTypeFilterInput = {
  and?: InputMaybe<Array<UnitTypeFilterInput>>;
  or?: InputMaybe<Array<UnitTypeFilterInput>>;
  tblWhseProducts?: InputMaybe<ListFilterInputTypeOfTblWhseProductFilterInput>;
  unitTypeAbbreviation?: InputMaybe<StringOperationFilterInput>;
  unitTypeId?: InputMaybe<ComparableInt32OperationFilterInput>;
  unitTypeName?: InputMaybe<StringOperationFilterInput>;
  units?: InputMaybe<ListFilterInputTypeOfUnitFilterInput>;
};

export type UnitTypeSortInput = {
  unitTypeAbbreviation?: InputMaybe<SortEnumType>;
  unitTypeId?: InputMaybe<SortEnumType>;
  unitTypeName?: InputMaybe<SortEnumType>;
};

export type UnitsResponse = {
  unitTypes?: Maybe<Array<Maybe<UnitType>>>;
  units?: Maybe<Array<Maybe<Unit>>>;
};

export type UpdateAuditDetailInput = {
  auditDetailId: Scalars['Int'];
  auditDetailUpdates?: InputMaybe<AuditDetailUpdatesInput>;
  locId: Scalars['Int'];
  lspId: Scalars['Int'];
  sessionId?: InputMaybe<Scalars['String']>;
  userId: Scalars['Int'];
};

export type UpdateAuditDetailsViaCsvInput = {
  auditId: Scalars['Int'];
  fileBytes?: InputMaybe<Scalars['String']>;
  locId: Scalars['Int'];
  lspId: Scalars['Int'];
  sessionId?: InputMaybe<Scalars['String']>;
  userId: Scalars['Int'];
};

export type UpdateAuditDetailsViaCsvResponse = {
  auditId: Scalars['Int'];
  errors?: Maybe<Array<Maybe<Scalars['String']>>>;
  totalFailed: Scalars['Int'];
  totalRows: Scalars['Int'];
  totalUpdated: Scalars['Int'];
};

export type UpdateAuditStatusInput = {
  auditId: Scalars['Int'];
  locId: Scalars['Int'];
  lspId: Scalars['Int'];
  newStatus: AuditStatus;
  sessionId?: InputMaybe<Scalars['String']>;
  userId: Scalars['Int'];
};

export type UpdatePackageCountInput = {
  auditDetailId: Scalars['Int'];
  expectedQuantity?: InputMaybe<Scalars['Decimal']>;
  locId: Scalars['Int'];
  lspId: Scalars['Int'];
  quantity: Scalars['Decimal'];
  reasonCode?: InputMaybe<Scalars['String']>;
  sessionId?: InputMaybe<Scalars['String']>;
  userId: Scalars['Int'];
};

export type UpdateProductRetiredStatusInput = {
  lspId: Scalars['Int'];
  productRetiredUpdates?: InputMaybe<Array<InputMaybe<ProductRetiredUpdatesInput>>>;
  sessionId?: InputMaybe<Scalars['String']>;
};

export type UserGroup = {
  loc?: Maybe<TblLspLocation>;
  locId: Scalars['Int'];
  lsp?: Maybe<TblLsp>;
  lspId: Scalars['Int'];
  permissions?: Maybe<Array<Maybe<Permission>>>;
  scimGroupName?: Maybe<Scalars['String']>;
  userGroupId: Scalars['Int'];
  userGroupName: Scalars['String'];
  userToUserGroups?: Maybe<Array<Maybe<UserToUserGroup>>>;
};

export type UserGroupFilterInput = {
  and?: InputMaybe<Array<UserGroupFilterInput>>;
  loc?: InputMaybe<TblLspLocationFilterInput>;
  locId?: InputMaybe<ComparableInt32OperationFilterInput>;
  lsp?: InputMaybe<TblLspFilterInput>;
  lspId?: InputMaybe<ComparableInt32OperationFilterInput>;
  or?: InputMaybe<Array<UserGroupFilterInput>>;
  permissions?: InputMaybe<ListFilterInputTypeOfPermissionFilterInput>;
  scimGroupName?: InputMaybe<StringOperationFilterInput>;
  userGroupId?: InputMaybe<ComparableInt32OperationFilterInput>;
  userGroupName?: InputMaybe<StringOperationFilterInput>;
  userToUserGroups?: InputMaybe<ListFilterInputTypeOfUserToUserGroupFilterInput>;
};

export type UserGroupSortInput = {
  loc?: InputMaybe<TblLspLocationSortInput>;
  locId?: InputMaybe<SortEnumType>;
  lsp?: InputMaybe<TblLspSortInput>;
  lspId?: InputMaybe<SortEnumType>;
  scimGroupName?: InputMaybe<SortEnumType>;
  userGroupId?: InputMaybe<SortEnumType>;
  userGroupName?: InputMaybe<SortEnumType>;
};

export type UserLsp = {
  addedBy?: Maybe<Scalars['Int']>;
  addedOn?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  lsp?: Maybe<TblLsp>;
  lspId?: Maybe<Scalars['Int']>;
  user?: Maybe<TblAuthUser>;
  userId?: Maybe<Scalars['Int']>;
};

export type UserLspFilterInput = {
  addedBy?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  addedOn?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  and?: InputMaybe<Array<UserLspFilterInput>>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  lsp?: InputMaybe<TblLspFilterInput>;
  lspId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  or?: InputMaybe<Array<UserLspFilterInput>>;
  user?: InputMaybe<TblAuthUserFilterInput>;
  userId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
};

export type UserToPermission = {
  addedBy?: Maybe<Scalars['Int']>;
  addedDate?: Maybe<Scalars['DateTime']>;
  loc?: Maybe<TblLspLocation>;
  locId: Scalars['Int'];
  lsp?: Maybe<TblLsp>;
  lspId: Scalars['Int'];
  permission?: Maybe<Permission>;
  permissionId: Scalars['Int'];
  user?: Maybe<TblAuthUser>;
  userId: Scalars['Int'];
};

export type UserToPermissionFilterInput = {
  addedBy?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  addedDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  and?: InputMaybe<Array<UserToPermissionFilterInput>>;
  loc?: InputMaybe<TblLspLocationFilterInput>;
  locId?: InputMaybe<ComparableInt32OperationFilterInput>;
  lsp?: InputMaybe<TblLspFilterInput>;
  lspId?: InputMaybe<ComparableInt32OperationFilterInput>;
  or?: InputMaybe<Array<UserToPermissionFilterInput>>;
  permission?: InputMaybe<PermissionFilterInput>;
  permissionId?: InputMaybe<ComparableInt32OperationFilterInput>;
  user?: InputMaybe<TblAuthUserFilterInput>;
  userId?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type UserToUserGroup = {
  addedBy?: Maybe<Scalars['Int']>;
  addedDate?: Maybe<Scalars['DateTime']>;
  user?: Maybe<TblAuthUser>;
  userGroup?: Maybe<UserGroup>;
  userGroupId: Scalars['Int'];
  userId: Scalars['Int'];
};

export type UserToUserGroupFilterInput = {
  addedBy?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  addedDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  and?: InputMaybe<Array<UserToUserGroupFilterInput>>;
  or?: InputMaybe<Array<UserToUserGroupFilterInput>>;
  user?: InputMaybe<TblAuthUserFilterInput>;
  userGroup?: InputMaybe<UserGroupFilterInput>;
  userGroupId?: InputMaybe<ComparableInt32OperationFilterInput>;
  userId?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type ValidatedForm = {
  id: Scalars['Int'];
  name: Scalars['String'];
  validatedFormFields?: Maybe<Array<Maybe<ValidatedFormField>>>;
};

export type ValidatedFormField = {
  defaultValue: Scalars['Int'];
  displayName: Scalars['String'];
  id: Scalars['Int'];
  reactName: Scalars['String'];
  systemRequired: Scalars['Boolean'];
  validatedForm?: Maybe<ValidatedForm>;
  validatedFormFieldOptions?: Maybe<Array<Maybe<ValidatedFormFieldOption>>>;
  validatedFormId: Scalars['Int'];
};

export type ValidatedFormFieldFilterInput = {
  and?: InputMaybe<Array<ValidatedFormFieldFilterInput>>;
  defaultValue?: InputMaybe<ComparableInt32OperationFilterInput>;
  displayName?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  or?: InputMaybe<Array<ValidatedFormFieldFilterInput>>;
  reactName?: InputMaybe<StringOperationFilterInput>;
  systemRequired?: InputMaybe<BooleanOperationFilterInput>;
  validatedForm?: InputMaybe<ValidatedFormFilterInput>;
  validatedFormFieldOptions?: InputMaybe<ListFilterInputTypeOfValidatedFormFieldOptionFilterInput>;
  validatedFormId?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type ValidatedFormFieldOption = {
  customerOption: Scalars['Int'];
  customerRequired: Scalars['Boolean'];
  id: Scalars['Int'];
  locId: Scalars['Int'];
  lspId: Scalars['Int'];
  validatedFormField?: Maybe<ValidatedFormField>;
  validatedFormFieldId: Scalars['Int'];
};

export type ValidatedFormFieldOptionFilterInput = {
  and?: InputMaybe<Array<ValidatedFormFieldOptionFilterInput>>;
  customerOption?: InputMaybe<ComparableInt32OperationFilterInput>;
  customerRequired?: InputMaybe<BooleanOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  locId?: InputMaybe<ComparableInt32OperationFilterInput>;
  lspId?: InputMaybe<ComparableInt32OperationFilterInput>;
  or?: InputMaybe<Array<ValidatedFormFieldOptionFilterInput>>;
  validatedFormField?: InputMaybe<ValidatedFormFieldFilterInput>;
  validatedFormFieldId?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type ValidatedFormFieldOptionSortInput = {
  customerOption?: InputMaybe<SortEnumType>;
  customerRequired?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  locId?: InputMaybe<SortEnumType>;
  lspId?: InputMaybe<SortEnumType>;
  validatedFormField?: InputMaybe<ValidatedFormFieldSortInput>;
  validatedFormFieldId?: InputMaybe<SortEnumType>;
};

export type ValidatedFormFieldSortInput = {
  defaultValue?: InputMaybe<SortEnumType>;
  displayName?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  reactName?: InputMaybe<SortEnumType>;
  systemRequired?: InputMaybe<SortEnumType>;
  validatedForm?: InputMaybe<ValidatedFormSortInput>;
  validatedFormId?: InputMaybe<SortEnumType>;
};

export type ValidatedFormFilterInput = {
  and?: InputMaybe<Array<ValidatedFormFilterInput>>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ValidatedFormFilterInput>>;
  validatedFormFields?: InputMaybe<ListFilterInputTypeOfValidatedFormFieldFilterInput>;
};

export type ValidatedFormSortInput = {
  id?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
};

export type VendorType = {
  state: Scalars['String'];
  tblVendors?: Maybe<Array<Maybe<TblVendor>>>;
  vendorType1: Scalars['String'];
  vendorTypeId: Scalars['Short'];
};

export type VendorTypeFilterInput = {
  and?: InputMaybe<Array<VendorTypeFilterInput>>;
  or?: InputMaybe<Array<VendorTypeFilterInput>>;
  state?: InputMaybe<StringOperationFilterInput>;
  tblVendors?: InputMaybe<ListFilterInputTypeOfTblVendorFilterInput>;
  vendorType1?: InputMaybe<StringOperationFilterInput>;
  vendorTypeId?: InputMaybe<ComparableInt16OperationFilterInput>;
};

export type VendorTypeSortInput = {
  state?: InputMaybe<SortEnumType>;
  vendorType1?: InputMaybe<SortEnumType>;
  vendorTypeId?: InputMaybe<SortEnumType>;
};

export type VoidReason = {
  lspId: Scalars['Int'];
  reason?: Maybe<Scalars['String']>;
  reasonId: Scalars['Int'];
};

export type VoidReasonCollectionSegment = {
  items?: Maybe<Array<Maybe<VoidReason>>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

export type VoidReasonFilterInput = {
  and?: InputMaybe<Array<VoidReasonFilterInput>>;
  lspId?: InputMaybe<ComparableInt32OperationFilterInput>;
  or?: InputMaybe<Array<VoidReasonFilterInput>>;
  reason?: InputMaybe<StringOperationFilterInput>;
  reasonId?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type VoidReasonSortInput = {
  lspId?: InputMaybe<SortEnumType>;
  reason?: InputMaybe<SortEnumType>;
  reasonId?: InputMaybe<SortEnumType>;
};

export type AssemblyAttributesFragment = { assemblyId: number, name: string, startedUtc?: any | null, completedUtc?: any | null, assemblyStatus?: { assemblyStatusId: any, name?: string | null } | null, billOfMaterials?: { name: string, billOfMaterialsId: number } | null };

export type GetAssembliesQueryVariables = Exact<{
  lspId: Scalars['Int'];
  locId: Scalars['Int'];
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  orderClause?: InputMaybe<Array<AssemblySortInput> | AssemblySortInput>;
  whereClause: AssemblyFilterInput;
}>;


export type GetAssembliesQuery = { data?: { totalCount: number, items?: Array<{ assemblyId: number, name: string, startedUtc?: any | null, completedUtc?: any | null, assemblyStatus?: { assemblyStatusId: any, name?: string | null } | null, billOfMaterials?: { name: string, billOfMaterialsId: number } | null } | null> | null, pageInfo: { hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type AssemblyDetailAttributesFragment = { assemblyId: number, name: string, estimatedStartDate: any, assemblyStatus?: { assemblyStatusId: any, name?: string | null } | null, assemblyOutputItems?: Array<{ assemblyOutputItemId: number, batchId?: number | null, bypassStateSystem: boolean, cost?: number | null, expirationDateUtc?: any | null, inventoryStatusId?: number | null, isProductionBatch: boolean, outputItemTypeId: any, packageDateUtc?: any | null, quantity: number, actualQuantity: number, roomId?: number | null, serialNumber?: string | null, skip: boolean, sourceSerialNumber?: string | null, useByDate?: any | null, assemblyInputItems?: Array<{ assemblyInputItemId: number, inputItemTypeId: any, quantity: number, skip: boolean, assemblyInputPackages?: Array<{ assemblyInputPackageId: number, quantity: number, package?: { packageId: number, serialNumber: string, cost?: number | null, quantity?: number | null, useByDate?: any | null, batch?: { batchLotNumber: string } | null, room?: { roomNo: string } | null, unit?: { abbreviation?: string | null, unitTypeId: number, unitId: number } | null } | null } | null> | null, product?: { id: number, whseProductsDescription: string } | null, productType?: { id: number, productType?: string | null } | null, unit?: { abbreviation?: string | null, unitTypeId: number, unitId: number } | null } | null> | null, batch?: { id: number, batchLotNumber: string } | null, product?: { id: number, alternateDesc?: string | null, unitCost?: number | null, expirationDays?: number | null, sku: string, name: string, cost?: number | null, defaultUnit?: { unitId: number } | null, strain?: { id: number, strainName: string } | null } | null, productType?: { id: number, productType?: string | null } | null, tags?: Array<{ tagId: number, tagName: string } | null> | null, unit?: { abbreviation?: string | null, unitTypeId: number, unitId: number } | null, costType?: { name: string, costTypeId: any } | null, vendor?: { id: number, vendorName: string, vendorCode?: string | null } | null } | null> | null, billOfMaterials?: { name: string, billOfMaterialsId: number, isProcessingJob: boolean, billOfMaterialsFiles?: Array<{ billOfMaterialsFileId: number, documentTypeId: number, documentName: string, url?: string | null, fileName?: string | null, fileUrl?: string | null, userFileName?: string | null } | null> | null, metrcProcessingJobTypeTemplate?: { metrcProcessingJobTypeTemplateId: number, name: string, description: string, categoryName?: string | null, processingSteps?: string | null, metrcProcessingJobTypeAttributes?: Array<{ metrcProcessingJobTypeAttributeId: number, name: string } | null> | null } | null } | null };

export type GetAssemblyQueryVariables = Exact<{
  id: Scalars['Int'];
  lspId: Scalars['Int'];
  locId: Scalars['Int'];
}>;


export type GetAssemblyQuery = { data?: { assemblyId: number, name: string, estimatedStartDate: any, assemblyStatus?: { assemblyStatusId: any, name?: string | null } | null, assemblyOutputItems?: Array<{ assemblyOutputItemId: number, batchId?: number | null, bypassStateSystem: boolean, cost?: number | null, expirationDateUtc?: any | null, inventoryStatusId?: number | null, isProductionBatch: boolean, outputItemTypeId: any, packageDateUtc?: any | null, quantity: number, actualQuantity: number, roomId?: number | null, serialNumber?: string | null, skip: boolean, sourceSerialNumber?: string | null, useByDate?: any | null, assemblyInputItems?: Array<{ assemblyInputItemId: number, inputItemTypeId: any, quantity: number, skip: boolean, assemblyInputPackages?: Array<{ assemblyInputPackageId: number, quantity: number, package?: { packageId: number, serialNumber: string, cost?: number | null, quantity?: number | null, useByDate?: any | null, batch?: { batchLotNumber: string } | null, room?: { roomNo: string } | null, unit?: { abbreviation?: string | null, unitTypeId: number, unitId: number } | null } | null } | null> | null, product?: { id: number, whseProductsDescription: string } | null, productType?: { id: number, productType?: string | null } | null, unit?: { abbreviation?: string | null, unitTypeId: number, unitId: number } | null } | null> | null, batch?: { id: number, batchLotNumber: string } | null, product?: { id: number, alternateDesc?: string | null, unitCost?: number | null, expirationDays?: number | null, sku: string, name: string, cost?: number | null, defaultUnit?: { unitId: number } | null, strain?: { id: number, strainName: string } | null } | null, productType?: { id: number, productType?: string | null } | null, tags?: Array<{ tagId: number, tagName: string } | null> | null, unit?: { abbreviation?: string | null, unitTypeId: number, unitId: number } | null, costType?: { name: string, costTypeId: any } | null, vendor?: { id: number, vendorName: string, vendorCode?: string | null } | null } | null> | null, billOfMaterials?: { name: string, billOfMaterialsId: number, isProcessingJob: boolean, billOfMaterialsFiles?: Array<{ billOfMaterialsFileId: number, documentTypeId: number, documentName: string, url?: string | null, fileName?: string | null, fileUrl?: string | null, userFileName?: string | null } | null> | null, metrcProcessingJobTypeTemplate?: { metrcProcessingJobTypeTemplateId: number, name: string, description: string, categoryName?: string | null, processingSteps?: string | null, metrcProcessingJobTypeAttributes?: Array<{ metrcProcessingJobTypeAttributeId: number, name: string } | null> | null } | null } | null } | null };

export type AuditPackageAttributesFragment = { fgreconId?: number | null, id: number, reasonCode?: string | null, actualQty?: number | null, expectedQty?: number | null, productId?: number | null, serialNo?: string | null, comment?: string | null, package?: { batchId?: number | null, expirationDate?: any | null, hasMultipleParentPackages: boolean, inventoryStatusId?: number | null, packageId: number, parentPackageSerialNumber?: string | null, roomId?: number | null, serialNumber: string, sourceSerialNumber?: string | null, quantity?: number | null, unitId: number, vendorId?: number | null, batch?: { batchLotNumber: string, batchStrainNavigation?: { strainName: string } | null } | null, room?: { roomNo: string } | null, unit?: { abbreviation?: string | null, unitTypeId: number } | null } | null, updatedByNavigation?: { name: string, id: number } | null, product?: { cannabisInventory?: string | null, whseProductsDescription: string, whseProductsProductNo: string, productTypeNavigation?: { productType?: string | null } | null, strain?: { strainName: string } | null, brand?: { brandName: string } | null } | null };

export type GetAuditPackageIdsQueryVariables = Exact<{
  lspId: Scalars['Int'];
  fgreconId: Scalars['Int'];
  take: Scalars['Int'];
  skip: Scalars['Int'];
}>;


export type GetAuditPackageIdsQuery = { data?: { items?: Array<{ id: number, packageId?: number | null } | null> | null } | null };

export type GetAuditPackagesQueryVariables = Exact<{
  lspId: Scalars['Int'];
  fgreconId: Scalars['Int'];
  isComplete?: InputMaybe<Scalars['Boolean']>;
  hasDiscrepancy?: InputMaybe<Scalars['Boolean']>;
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  orderClause?: InputMaybe<Array<FgreconDetailSortInput> | FgreconDetailSortInput>;
  whereClause: FgreconDetailFilterInput;
}>;


export type GetAuditPackagesQuery = { data?: { totalCount: number, items?: Array<{ fgreconId?: number | null, id: number, reasonCode?: string | null, actualQty?: number | null, expectedQty?: number | null, productId?: number | null, serialNo?: string | null, comment?: string | null, package?: { batchId?: number | null, expirationDate?: any | null, hasMultipleParentPackages: boolean, inventoryStatusId?: number | null, packageId: number, parentPackageSerialNumber?: string | null, roomId?: number | null, serialNumber: string, sourceSerialNumber?: string | null, quantity?: number | null, unitId: number, vendorId?: number | null, batch?: { batchLotNumber: string, batchStrainNavigation?: { strainName: string } | null } | null, room?: { roomNo: string } | null, unit?: { abbreviation?: string | null, unitTypeId: number } | null } | null, updatedByNavigation?: { name: string, id: number } | null, product?: { cannabisInventory?: string | null, whseProductsDescription: string, whseProductsProductNo: string, productTypeNavigation?: { productType?: string | null } | null, strain?: { strainName: string } | null, brand?: { brandName: string } | null } | null } | null> | null, pageInfo: { hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type GetAuditStatusesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAuditStatusesQuery = { data?: { items?: Array<{ statusId: number, statusName: string } | null> | null } | null };

export type AuditAttributesFragment = { discrepancies: number, id: number, isBlind: boolean, isDeleted: boolean, masterCategory?: string | null, reconCompletedUTC?: any | null, reconDate: any, reconTotalFg?: number | null, scan: boolean, inventoryAuditToBrands?: Array<{ brand?: { brandId: number, brandName: string } | null } | null> | null, inventoryAuditToCategories?: Array<{ category?: { id: number, productType?: string | null } | null } | null> | null, inventoryAuditToRooms?: Array<{ room?: { id: number, roomNo: string } | null } | null> | null, reconByNavigation?: { name: string } | null, reconSubmittedByNavigation?: { name: string } | null, status?: { statusId: number, statusName: string } | null, workflow?: { workflowId: number, workflowName: string } | null, loc?: { id: number, lspLocationsName: string } | null };

export type AuditHasNegativePackageUpdatesQueryVariables = Exact<{
  auditId: Scalars['Int'];
  lspId: Scalars['Int'];
}>;


export type AuditHasNegativePackageUpdatesQuery = { data: boolean };

export type GetAuditsQueryVariables = Exact<{
  lspId: Scalars['Int'];
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  orderClause?: InputMaybe<Array<FgreconSortInput> | FgreconSortInput>;
  whereClause: FgreconFilterInput;
}>;


export type GetAuditsQuery = { data?: { totalCount: number, items?: Array<{ discrepancies: number, id: number, isBlind: boolean, isDeleted: boolean, masterCategory?: string | null, reconCompletedUTC?: any | null, reconDate: any, reconTotalFg?: number | null, scan: boolean, inventoryAuditToBrands?: Array<{ brand?: { brandId: number, brandName: string } | null } | null> | null, inventoryAuditToCategories?: Array<{ category?: { id: number, productType?: string | null } | null } | null> | null, inventoryAuditToRooms?: Array<{ room?: { id: number, roomNo: string } | null } | null> | null, reconByNavigation?: { name: string } | null, reconSubmittedByNavigation?: { name: string } | null, status?: { statusId: number, statusName: string } | null, workflow?: { workflowId: number, workflowName: string } | null, loc?: { id: number, lspLocationsName: string } | null } | null> | null, pageInfo: { hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type GetAuditQueryVariables = Exact<{
  id: Scalars['Int'];
  lspId: Scalars['Int'];
}>;


export type GetAuditQuery = { data?: { discrepancies: number, id: number, isBlind: boolean, isDeleted: boolean, masterCategory?: string | null, reconCompletedUTC?: any | null, reconDate: any, reconTotalFg?: number | null, scan: boolean, inventoryAuditToBrands?: Array<{ brand?: { brandId: number, brandName: string } | null } | null> | null, inventoryAuditToCategories?: Array<{ category?: { id: number, productType?: string | null } | null } | null> | null, inventoryAuditToRooms?: Array<{ room?: { id: number, roomNo: string } | null } | null> | null, reconByNavigation?: { name: string } | null, reconSubmittedByNavigation?: { name: string } | null, status?: { statusId: number, statusName: string } | null, workflow?: { workflowId: number, workflowName: string } | null, loc?: { id: number, lspLocationsName: string } | null } | null };

export type AddPackageToAuditMutationVariables = Exact<{
  input?: InputMaybe<AddPackageToAuditInput>;
}>;


export type AddPackageToAuditMutation = { addPackageToAudit?: { result: boolean, message?: string | null, data?: { packageId: number, auditDetailId: number } | null } | null };

export type BulkConfirmCountMutationVariables = Exact<{
  input: BulkConfirmCountInput;
}>;


export type BulkConfirmCountMutation = { bulkConfirmCount: { bulkConfirmCountOutput?: { totalRecordsUpdated: number } | null, errors?: Array<{ message: string, code: 'GqlError' } | { message: string, code: 'PackageQuantityChangedError', updatedPackageQuantities?: Array<{ id: number, quantity: number } | null> | null }> | null } };

export type BulkUpdateAuditDetailsMutationVariables = Exact<{
  input: BulkUpdateAuditDetailsInput;
}>;


export type BulkUpdateAuditDetailsMutation = { bulkUpdateAuditDetails?: { data: number, message?: string | null, result: boolean } | null };

export type CloseAuditMutationVariables = Exact<{
  input: CloseAuditInput;
}>;


export type CloseAuditMutation = { closeAudit?: { message?: string | null, result: boolean, data?: { auditId: number } | null } | null };

export type CreateAuditFromPackagesMutationVariables = Exact<{
  input: CreateAuditFromPackagesInput;
}>;


export type CreateAuditFromPackagesMutation = { createAuditFromPackages: { message?: string | null, result: boolean, data?: { auditDetailCount?: number | null, auditId?: number | null } | null } };

export type CreateAuditMutationVariables = Exact<{
  input: CreateAuditInput;
}>;


export type CreateAuditMutation = { createAudit: { data: number, message?: string | null, result: boolean } };

export type DeleteAuditMutationVariables = Exact<{
  input: DeleteAuditStatusInput;
}>;


export type DeleteAuditMutation = { deleteAudit?: { message?: string | null, result: boolean, data?: { id: number } | null } | null };

export type RemovePackageFromAuditMutationVariables = Exact<{
  input?: InputMaybe<RemovePackageFromAuditInput>;
}>;


export type RemovePackageFromAuditMutation = { removePackageFromAudit?: { result: boolean, message?: string | null, data?: { auditDetailId: number } | null } | null };

export type SubmitAuditForReviewMutationVariables = Exact<{
  input?: InputMaybe<SubmitAuditForReviewInput>;
}>;


export type SubmitAuditForReviewMutation = { submitAuditForReview?: { message?: string | null, result: boolean } | null };

export type UpdateAuditDetailMutationVariables = Exact<{
  input: UpdateAuditDetailInput;
}>;


export type UpdateAuditDetailMutation = { updateAuditDetail?: { message?: string | null, result: boolean, data?: { actualQty?: number | null, expectedQty?: number | null, reasonCode?: string | null, comment?: string | null, isDeleted: boolean, serialNo?: string | null, lastAuditedDateUtc?: any | null, productId?: number | null, packageId?: number | null } | null } | null };

export type UpdateAuditDetailsViaCsvMutationVariables = Exact<{
  input: UpdateAuditDetailsViaCsvInput;
}>;


export type UpdateAuditDetailsViaCsvMutation = { updateAuditDetailsViaCsv?: { message?: string | null, result: boolean, data?: { auditId: number, totalRows: number, totalUpdated: number, totalFailed: number, errors?: Array<string | null> | null } | null } | null };

export type UpdateAuditPackageCountMutationVariables = Exact<{
  input: UpdatePackageCountInput;
}>;


export type UpdateAuditPackageCountMutation = { updateAuditPackageCount?: { message?: string | null, result: boolean, data?: { fgreconId?: number | null, id: number, reasonCode?: string | null, actualQty?: number | null, expectedQty?: number | null, productId?: number | null, serialNo?: string | null, comment?: string | null, package?: { batchId?: number | null, expirationDate?: any | null, hasMultipleParentPackages: boolean, inventoryStatusId?: number | null, packageId: number, parentPackageSerialNumber?: string | null, roomId?: number | null, serialNumber: string, sourceSerialNumber?: string | null, quantity?: number | null, unitId: number, vendorId?: number | null, batch?: { batchLotNumber: string, batchStrainNavigation?: { strainName: string } | null } | null, room?: { roomNo: string } | null, unit?: { abbreviation?: string | null, unitTypeId: number } | null } | null, updatedByNavigation?: { name: string, id: number } | null, product?: { cannabisInventory?: string | null, whseProductsDescription: string, whseProductsProductNo: string, productTypeNavigation?: { productType?: string | null } | null, strain?: { strainName: string } | null, brand?: { brandName: string } | null } | null } | null } | null };

export type UpdateAuditStatusMutationVariables = Exact<{
  input?: InputMaybe<UpdateAuditStatusInput>;
}>;


export type UpdateAuditStatusMutation = { updateAuditStatus?: { message?: string | null, result: boolean } | null };

export type BatchesWithLabsFragment = { id: number, batchLotNumber: string, harvestCompletedOn?: any | null, lastModifiedDateUtc: any, batchStrainNavigation?: { strainName: string } | null, tblBatchThcs?: Array<{ thcValue?: number | null, thcUnit?: number | null, cbdValue?: number | null, cbdUnit?: number | null, cbdaValue?: number | null, cbdaUnit?: number | null, thcaValue?: number | null, thcaUnit?: number | null } | null> | null };

export type GetBatchesWithLabsQueryVariables = Exact<{
  lspId: Scalars['Int'];
  locId: Scalars['Int'];
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  orderClause?: InputMaybe<Array<TblBatchSortInput> | TblBatchSortInput>;
  whereClause: TblBatchFilterInput;
}>;


export type GetBatchesWithLabsQuery = { data?: { totalCount: number, items?: Array<{ id: number, batchLotNumber: string, harvestCompletedOn?: any | null, lastModifiedDateUtc: any, batchStrainNavigation?: { strainName: string } | null, tblBatchThcs?: Array<{ thcValue?: number | null, thcUnit?: number | null, cbdValue?: number | null, cbdUnit?: number | null, cbdaValue?: number | null, cbdaUnit?: number | null, thcaValue?: number | null, thcaUnit?: number | null } | null> | null } | null> | null, pageInfo: { hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type BomAttributesFragment = { billOfMaterialsId: number, name: string, createdOnUtc: any, executionCount: number, lastRanUtc?: any | null, isDeleted: boolean };

export type GetBillOfMaterialsQueryVariables = Exact<{
  lspId: Scalars['Int'];
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  orderClause?: InputMaybe<Array<BillOfMaterialSortInput> | BillOfMaterialSortInput>;
  whereClause: BillOfMaterialFilterInput;
}>;


export type GetBillOfMaterialsQuery = { data?: { totalCount: number, items?: Array<{ billOfMaterialsId: number, name: string, createdOnUtc: any, executionCount: number, lastRanUtc?: any | null, isDeleted: boolean } | null> | null, pageInfo: { hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type BomDetailAttributesFragment = { billOfMaterialsId: number, name: string, description?: string | null, executionCount: number, laborHours?: number | null, laborRate?: number | null, isProcessingJob: boolean, billOfMaterialsFiles?: Array<{ billOfMaterialsFileId: number, documentTypeId: number, documentName: string, url?: string | null, fileName?: string | null, fileUrl?: string | null, userFileName?: string | null } | null> | null, billOfMaterialsImages?: Array<{ imageFileName: string, imageUrl?: string | null } | null> | null, billOfMaterialsOutputItems?: Array<{ billOfMaterialsOutputItemId: number, quantity: number, outputTypeId: any, unitId: number, unit?: { abbreviation?: string | null, unitId: number } | null, product?: { whseProductsDescription: string, id: number, unitCost?: number | null, alternateDesc?: string | null, expirationDays?: number | null, sku: string, vendorNavigation?: { id: number } | null, strain?: { id: number, strainName: string } | null } | null, productType?: { id: number, productType?: string | null } | null, billOfMaterialsInputItems?: Array<{ billOfMaterialsInputItemId: number, quantity: number, inputTypeId: any, unitId: number, unit?: { abbreviation?: string | null, unitId: number } | null, product?: { whseProductsDescription: string, id: number } | null, productType?: { id: number, productType?: string | null } | null } | null> | null } | null> | null, metrcProcessingJobTypeTemplate?: { metrcProcessingJobTypeTemplateId: number, name: string, description: string, categoryName?: string | null, processingSteps?: string | null, metrcProcessingJobTypeAttributes?: Array<{ metrcProcessingJobTypeAttributeId: number, name: string } | null> | null } | null };

export type GetBillOfMaterialQueryVariables = Exact<{
  id: Scalars['Int'];
  lspId: Scalars['Int'];
}>;


export type GetBillOfMaterialQuery = { data?: { billOfMaterialsId: number, name: string, description?: string | null, executionCount: number, laborHours?: number | null, laborRate?: number | null, isProcessingJob: boolean, billOfMaterialsFiles?: Array<{ billOfMaterialsFileId: number, documentTypeId: number, documentName: string, url?: string | null, fileName?: string | null, fileUrl?: string | null, userFileName?: string | null } | null> | null, billOfMaterialsImages?: Array<{ imageFileName: string, imageUrl?: string | null } | null> | null, billOfMaterialsOutputItems?: Array<{ billOfMaterialsOutputItemId: number, quantity: number, outputTypeId: any, unitId: number, unit?: { abbreviation?: string | null, unitId: number } | null, product?: { whseProductsDescription: string, id: number, unitCost?: number | null, alternateDesc?: string | null, expirationDays?: number | null, sku: string, vendorNavigation?: { id: number } | null, strain?: { id: number, strainName: string } | null } | null, productType?: { id: number, productType?: string | null } | null, billOfMaterialsInputItems?: Array<{ billOfMaterialsInputItemId: number, quantity: number, inputTypeId: any, unitId: number, unit?: { abbreviation?: string | null, unitId: number } | null, product?: { whseProductsDescription: string, id: number } | null, productType?: { id: number, productType?: string | null } | null } | null> | null } | null> | null, metrcProcessingJobTypeTemplate?: { metrcProcessingJobTypeTemplateId: number, name: string, description: string, categoryName?: string | null, processingSteps?: string | null, metrcProcessingJobTypeAttributes?: Array<{ metrcProcessingJobTypeAttributeId: number, name: string } | null> | null } | null } | null };

export type BrandAttributesFragment = { brandCatalogBrandId?: string | null, brandId: number, brandName: string, isDeleted?: boolean | null };

export type GetBrandsQueryVariables = Exact<{
  lspId: Scalars['Int'];
  whereClause: BrandFilterInput;
  orderClause?: InputMaybe<Array<BrandSortInput> | BrandSortInput>;
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
}>;


export type GetBrandsQuery = { data?: { totalCount: number, items?: Array<{ brandCatalogBrandId?: string | null, brandId: number, brandName: string, isDeleted?: boolean | null } | null> | null, pageInfo: { hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type GetBrandQueryVariables = Exact<{
  id: Scalars['Int'];
  lspId: Scalars['Int'];
}>;


export type GetBrandQuery = { data?: { brandCatalogBrandId?: string | null, brandId: number, brandName: string, isDeleted?: boolean | null } | null };

export type CarAttributesFragment = { bioTvcarId?: any | null, carColor?: string | null, carLicId: string, carMake: string, carModel: string, carName?: string | null, carVin?: string | null, carYear?: string | null, id: number, isDeleted: boolean, isOperatedByThirdParty: boolean, stateCode?: string | null, thirdPartyLicenseNumber?: string | null, registerId?: number | null, roomId?: number | null, register?: { terminalName: string, isHidden: boolean } | null, room?: { roomNo: string, isDeleted: boolean } | null };

export type GetCarsQueryVariables = Exact<{
  lspId: Scalars['Int'];
  locId: Scalars['Int'];
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  orderClause?: InputMaybe<Array<TblMdcarSortInput> | TblMdcarSortInput>;
  whereClause: TblMdcarFilterInput;
}>;


export type GetCarsQuery = { data?: { totalCount: number, items?: Array<{ bioTvcarId?: any | null, carColor?: string | null, carLicId: string, carMake: string, carModel: string, carName?: string | null, carVin?: string | null, carYear?: string | null, id: number, isDeleted: boolean, isOperatedByThirdParty: boolean, stateCode?: string | null, thirdPartyLicenseNumber?: string | null, registerId?: number | null, roomId?: number | null, register?: { terminalName: string, isHidden: boolean } | null, room?: { roomNo: string, isDeleted: boolean } | null } | null> | null, pageInfo: { hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type GetCarQueryVariables = Exact<{
  id: Scalars['Int'];
  lspId: Scalars['Int'];
  locId: Scalars['Int'];
}>;


export type GetCarQuery = { data?: { bioTvcarId?: any | null, carColor?: string | null, carLicId: string, carMake: string, carModel: string, carName?: string | null, carVin?: string | null, carYear?: string | null, id: number, isDeleted: boolean, isOperatedByThirdParty: boolean, stateCode?: string | null, thirdPartyLicenseNumber?: string | null, registerId?: number | null, roomId?: number | null, register?: { terminalName: string, isHidden: boolean } | null, room?: { roomNo: string, isDeleted: boolean } | null } | null };

export type DriverAttributesFragment = { bioTdriverAltId?: string | null, bioTdriverId?: number | null, driverDob?: any | null, driverEmail?: string | null, driverHireDt?: any | null, driverId: string, driverName: string, driverPhone?: string | null, driverPicture?: string | null, driverStateId?: string | null, id: number, isOperatedByThirdParty: boolean, stateCode?: string | null, thirdPartyLicenseNumber?: string | null, userId?: number | null };

export type GetDriversQueryVariables = Exact<{
  lspId: Scalars['Int'];
  locId: Scalars['Int'];
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  orderClause?: InputMaybe<Array<TblMddriverSortInput> | TblMddriverSortInput>;
  whereClause: TblMddriverFilterInput;
}>;


export type GetDriversQuery = { data?: { totalCount: number, items?: Array<{ bioTdriverAltId?: string | null, bioTdriverId?: number | null, driverDob?: any | null, driverEmail?: string | null, driverHireDt?: any | null, driverId: string, driverName: string, driverPhone?: string | null, driverPicture?: string | null, driverStateId?: string | null, id: number, isOperatedByThirdParty: boolean, stateCode?: string | null, thirdPartyLicenseNumber?: string | null, userId?: number | null } | null> | null } | null };

export type GetDriverQueryVariables = Exact<{
  id: Scalars['Int'];
  lspId: Scalars['Int'];
  locId: Scalars['Int'];
}>;


export type GetDriverQuery = { data?: { bioTdriverAltId?: string | null, bioTdriverId?: number | null, driverDob?: any | null, driverEmail?: string | null, driverHireDt?: any | null, driverId: string, driverName: string, driverPhone?: string | null, driverPicture?: string | null, driverStateId?: string | null, id: number, isOperatedByThirdParty: boolean, stateCode?: string | null, thirdPartyLicenseNumber?: string | null, userId?: number | null } | null };

export type DiscountEventsAuditQueryVariables = Exact<{
  lspId: Scalars['Int'];
  locId: Scalars['Int'];
  userId: Scalars['Int'];
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  orderClause?: InputMaybe<Array<DiscountAuditSortInput> | DiscountAuditSortInput>;
  whereClause: DiscountAuditFilterInput;
}>;


export type DiscountEventsAuditQuery = { data?: { totalCount: number, items?: Array<{ auditAction?: any | null, auditDateTimeUtc: any, userId?: number | null, id: number, relatedData?: { discountId: number, relatedDataValue: string } | null, changedByUser?: { id: number, fullName: string } | null, changed?: Array<{ columnChanged?: string | null, oldValue?: string | null, newValue?: string | null } | null> | null } | null> | null, pageInfo: { hasNextPage: boolean } } | null };

export type FeatureEventsAuditQueryVariables = Exact<{
  lspId: Scalars['Int'];
  locId: Scalars['Int'];
  userId: Scalars['Int'];
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  orderClause?: InputMaybe<Array<LspFeaturesAuditSortInput> | LspFeaturesAuditSortInput>;
  whereClause: LspFeaturesAuditFilterInput;
}>;


export type FeatureEventsAuditQuery = { data?: { totalCount: number, items?: Array<{ id: number, auditAction?: any | null, auditDateTimeUtc: any, lspId?: number | null, locId?: number | null, userId?: number | null, newValue: boolean, relatedData?: { id: number, relatedDataValue?: string | null } | null, changedByUser?: { id: number, fullName: string } | null, location?: { id: number, name?: string | null } | null } | null> | null, pageInfo: { hasNextPage: boolean } } | null };

export type PackageEventsAuditQueryVariables = Exact<{
  lspId: Scalars['Int'];
  locId: Scalars['Int'];
  userId: Scalars['Int'];
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  orderClause?: InputMaybe<Array<PackageAuditSortInput> | PackageAuditSortInput>;
  whereClause: PackageAuditFilterInput;
}>;


export type PackageEventsAuditQuery = { data?: { items?: Array<{ auditAction?: any | null, auditDateTimeUtc: any, userId?: number | null, lspId?: number | null, locId?: number | null, id: number, relatedData?: { packageId: number, relatedDataValue: string } | null, changedByUser?: { id: number, fullName: string } | null, location?: { id: number, name?: string | null } | null, changed?: Array<{ columnChanged?: string | null, oldValue?: string | null, newValue?: string | null } | null> | null } | null> | null } | null };

export type ProductEventsAuditQueryVariables = Exact<{
  lspId: Scalars['Int'];
  locId: Scalars['Int'];
  userId: Scalars['Int'];
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  orderClause?: InputMaybe<Array<TblWhseProductsAuditSortInput> | TblWhseProductsAuditSortInput>;
  whereClause: TblWhseProductsAuditFilterInput;
}>;


export type ProductEventsAuditQuery = { data?: { totalCount: number, items?: Array<{ auditAction?: any | null, auditDateTimeUtc: any, userId?: number | null, id: number, relatedData?: { id: number, relatedDataValue: string } | null, changedByUser?: { id: number, fullName: string } | null, changed?: Array<{ columnChanged?: string | null, oldValue?: string | null, newValue?: string | null } | null> | null } | null> | null, pageInfo: { hasNextPage: boolean } } | null };

export type UserEventsAuditQueryVariables = Exact<{
  lspId: Scalars['Int'];
  locId: Scalars['Int'];
  userId: Scalars['Int'];
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  orderClause?: InputMaybe<Array<TblAuthUsersAuditSortInput> | TblAuthUsersAuditSortInput>;
  whereClause: TblAuthUsersAuditFilterInput;
}>;


export type UserEventsAuditQuery = { data?: { totalCount: number, items?: Array<{ auditAction?: any | null, auditDateTimeUtc: any, userId?: number | null, locId?: number | null, id: number, relatedData?: { id: number, relatedDataValue: string } | null, changedByUser?: { id: number, fullName: string } | null, changed?: Array<{ columnChanged?: string | null, oldValue?: string | null, newValue?: string | null }> | null, location?: { id: number, name?: string | null } | null } | null> | null, pageInfo: { hasNextPage: boolean } } | null };

export type HarvestBatchesLiteAttributesFragment = { id: number, batchLotNumber: string, harvestUnitId?: number | null, batchStrainNavigation?: { strainName: string } | null };

export type GetHarvestBatchesLiteDropdownQueryVariables = Exact<{
  lspId: Scalars['Int'];
  locId: Scalars['Int'];
  whereClause: TblBatchFilterInput;
  orderClause?: InputMaybe<Array<TblBatchSortInput> | TblBatchSortInput>;
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
}>;


export type GetHarvestBatchesLiteDropdownQuery = { data?: { totalCount: number, items?: Array<{ id: number, batchLotNumber: string, harvestUnitId?: number | null, batchStrainNavigation?: { strainName: string } | null } | null> | null, pageInfo: { hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type GetHarvestBatchesLiteQueryVariables = Exact<{
  lspId: Scalars['Int'];
  locId: Scalars['Int'];
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  orderClause?: InputMaybe<Array<TblBatchSortInput> | TblBatchSortInput>;
  whereClause: TblBatchFilterInput;
}>;


export type GetHarvestBatchesLiteQuery = { data?: { totalCount: number, items?: Array<{ id: number, batchLotNumber: string, harvestUnitId?: number | null, batchStrainNavigation?: { strainName: string } | null } | null> | null, pageInfo: { hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type GetHarvestBatchLiteQueryVariables = Exact<{
  id: Scalars['Int'];
  lspId: Scalars['Int'];
  locId: Scalars['Int'];
}>;


export type GetHarvestBatchLiteQuery = { data?: { id: number, batchLotNumber: string, harvestUnitId?: number | null, batchStrainNavigation?: { strainName: string } | null } | null };

export type InventoryPackageAttributesV2Fragment = { allocatedInventorySum?: number | null, isOnHold: boolean, isOnRecall?: boolean | null, lastDatePackageAuditedUtc?: any | null, serialNumber: string, quantity?: number | null, producerId?: number | null, expirationDate?: any | null, inventoryStatusId?: number | null, packageWeight?: number | null, netWeight?: number | null, netWeightUnit?: number | null, flowerEquivalent?: number | null, recFlowerEquivalent?: number | null, productWeight?: number | null, unitPrice?: number | null, recUnitPrice?: number | null, cost?: number | null, receivedDate?: any | null, sourceSerialNumber?: string | null, medicalOnly: boolean, metrclabTestingStatus?: string | null, bioTrackQAStatus?: string | null, packagedDate?: any | null, manufacturingDate?: any | null, iltaxCategory?: any | null, cultivationTax?: number | null, exciseTax?: number | null, isFinishedInIntegration?: boolean | null, tableId?: number | null, potencyIndicator?: number | null, packageNdc?: string | null, effectivePotencyMg?: number | null, useByDate?: any | null, parentPackageSerialNumber?: string | null, hasMultipleParentPackages: boolean, isSample?: boolean | null, id: number, packageGroup?: { packageGroupId: any, packageItemLabels?: Array<{ itemLabel?: string | null } | null> | null } | null, product?: { id: number, posproducts?: string | null, lastAuditedDateUtc?: any | null, whseProductsDescription: string, productImageFileNameProcessed?: string | null, whseProductsProductNo: string, defaultUnitId?: number | null, grossWeight?: number | null, flowerEquivalent?: number | null, recFlowerEquivalent?: number | null, whseProductsUnitPrice?: number | null, whseProductsRecUnitPrice?: number | null, lowInventoryThreshold?: number | null, productGrams?: number | null, cannabisInventory?: string | null, alternateDesc?: string | null, couponItem?: string | null, isNutrient: boolean, onlineProduct?: string | null, isRetired: boolean, isOnSale: boolean, itemTaxable?: string | null, onlineTitle?: string | null, onlineDescription?: string | null, productImageFileName?: string | null, externalCategory?: string | null, instructions?: string | null, allergenList?: string | null, ingredientList?: string | null, prescription?: string | null, approvalDateUTC?: any | null, productTypeNavigation?: { id: number, productType?: string | null, masterCategory?: string | null } | null, productToCustomerTypes?: Array<{ customerType?: { customerTypeId: number, customerTypeName: string } | null } | null> | null, unitType?: { unitTypeAbbreviation?: string | null, unitTypeName: string } | null, strain?: { strainName: string } | null, brand?: { brandName: string } | null, sizeListItem?: { description: string } | null } | null, locationProductMaster?: { price?: number | null, recPrice?: number | null, lowInventoryThreshold?: number | null, onlineAvailable?: any | null, posAvailable?: any | null } | null, inventoryStatus?: { invStatusDesc?: string | null } | null, batch?: { batchLotNumber: string, id: number, harvestCompletedOn?: any | null, lot: string, tblBatchThcs?: Array<{ thcValue?: number | null, thcUnit?: number | null, cbdValue?: number | null, cbdUnit?: number | null, cbdaValue?: number | null, cbdaUnit?: number | null, cbnValue?: number | null, cbnUnit?: number | null, thcaValue?: number | null, thcaUnit?: number | null, thc9Value?: number | null, thc9Unit?: number | null } | null> | null, batchStrainNavigation?: { strainName: string } | null } | null, vendor?: { vendorName: string, id: number, vendorCode?: string | null } | null, room?: { roomNo: string, id: number } | null, unit?: { abbreviation?: string | null, unitTypeId: number, unitId: number } | null, inventorySourceBatches?: Array<{ sourceBatch?: string | null } | null> | null, table?: { trayNumber: string } | null, producer?: { producerName?: string | null } | null, packageToTags?: Array<{ tag?: { tagId: number, tagName: string } | null } | null> | null, loc?: { whichUnitCost?: string | null, whichUnitPrice?: string | null } | null, packageToCustomerTypes?: Array<{ customerType?: { customerTypeId: number, customerTypeName: string } | null } | null> | null };

export type InventoryPackageAttributesV3Fragment = { allocatedInventorySum?: number | null, isOnHold: boolean, isOnRecall?: boolean | null, lastDatePackageAuditedUtc?: any | null, serialNumber: string, quantity?: number | null, producerId?: number | null, expirationDate?: any | null, inventoryStatusId?: number | null, packageWeight?: number | null, netWeight?: number | null, netWeightUnit?: number | null, flowerEquivalent?: number | null, recFlowerEquivalent?: number | null, productWeight?: number | null, unitPrice?: number | null, recUnitPrice?: number | null, cost?: number | null, receivedDate?: any | null, sourceSerialNumber?: string | null, medicalOnly: boolean, metrclabTestingStatus?: string | null, bioTrackQAStatus?: string | null, packagedDate?: any | null, manufacturingDate?: any | null, iltaxCategory?: any | null, cultivationTax?: number | null, exciseTax?: number | null, isFinishedInIntegration?: boolean | null, tableId?: number | null, potencyIndicator?: number | null, packageNdc?: string | null, effectivePotencyMg?: number | null, useByDate?: any | null, parentPackageSerialNumber?: string | null, hasMultipleParentPackages: boolean, isSample?: boolean | null, id: number, packageToTags?: Array<{ tag?: { tagId: number, tagName: string, smartTag?: { name?: string | null } | null } | null } | null> | null, packageGroup?: { packageGroupId: any, packageItemLabels?: Array<{ itemLabel?: string | null } | null> | null } | null, product?: { id: number, posproducts?: string | null, lastAuditedDateUtc?: any | null, whseProductsDescription: string, productImageFileNameProcessed?: string | null, whseProductsProductNo: string, defaultUnitId?: number | null, grossWeight?: number | null, flowerEquivalent?: number | null, recFlowerEquivalent?: number | null, whseProductsUnitPrice?: number | null, whseProductsRecUnitPrice?: number | null, lowInventoryThreshold?: number | null, productGrams?: number | null, cannabisInventory?: string | null, alternateDesc?: string | null, couponItem?: string | null, isNutrient: boolean, onlineProduct?: string | null, isRetired: boolean, isOnSale: boolean, itemTaxable?: string | null, onlineTitle?: string | null, onlineDescription?: string | null, productImageFileName?: string | null, externalCategory?: string | null, instructions?: string | null, allergenList?: string | null, ingredientList?: string | null, prescription?: string | null, approvalDateUTC?: any | null, productTypeNavigation?: { id: number, productType?: string | null, masterCategory?: string | null } | null, productToCustomerTypes?: Array<{ customerType?: { customerTypeId: number, customerTypeName: string } | null } | null> | null, unitType?: { unitTypeAbbreviation?: string | null, unitTypeName: string } | null, strain?: { strainName: string } | null, brand?: { brandName: string } | null, sizeListItem?: { description: string } | null } | null, locationProductMaster?: { price?: number | null, recPrice?: number | null, lowInventoryThreshold?: number | null, onlineAvailable?: any | null, posAvailable?: any | null } | null, inventoryStatus?: { invStatusDesc?: string | null } | null, batch?: { batchLotNumber: string, id: number, harvestCompletedOn?: any | null, lot: string, tblBatchThcs?: Array<{ thcValue?: number | null, thcUnit?: number | null, cbdValue?: number | null, cbdUnit?: number | null, cbdaValue?: number | null, cbdaUnit?: number | null, cbnValue?: number | null, cbnUnit?: number | null, thcaValue?: number | null, thcaUnit?: number | null, thc9Value?: number | null, thc9Unit?: number | null } | null> | null, batchStrainNavigation?: { strainName: string } | null } | null, vendor?: { vendorName: string, id: number, vendorCode?: string | null } | null, room?: { roomNo: string, id: number } | null, unit?: { abbreviation?: string | null, unitTypeId: number, unitId: number } | null, inventorySourceBatches?: Array<{ sourceBatch?: string | null } | null> | null, table?: { trayNumber: string } | null, producer?: { producerName?: string | null } | null, loc?: { whichUnitCost?: string | null, whichUnitPrice?: string | null } | null, packageToCustomerTypes?: Array<{ customerType?: { customerTypeId: number, customerTypeName: string } | null } | null> | null };

export type InventoryPackageAttributesFragment = { allocatedInventorySum?: number | null, isOnHold: boolean, isOnRecall?: boolean | null, lastDatePackageAuditedUtc?: any | null, serialNumber: string, quantity?: number | null, producerId?: number | null, expirationDate?: any | null, inventoryStatusId?: number | null, packageWeight?: number | null, netWeight?: number | null, netWeightUnit?: number | null, flowerEquivalent?: number | null, recFlowerEquivalent?: number | null, productWeight?: number | null, unitPrice?: number | null, recUnitPrice?: number | null, cost?: number | null, receivedDate?: any | null, sourceSerialNumber?: string | null, medicalOnly: boolean, metrclabTestingStatus?: string | null, bioTrackQAStatus?: string | null, packagedDate?: any | null, manufacturingDate?: any | null, iltaxCategory?: any | null, cultivationTax?: number | null, exciseTax?: number | null, isFinishedInIntegration?: boolean | null, tableId?: number | null, potencyIndicator?: number | null, packageNdc?: string | null, effectivePotencyMg?: number | null, useByDate?: any | null, parentPackageSerialNumber?: string | null, hasMultipleParentPackages: boolean, isSample?: boolean | null, id: number, product?: { id: number, posproducts?: string | null, lastAuditedDateUtc?: any | null, whseProductsDescription: string, productImageFileNameProcessed?: string | null, whseProductsProductNo: string, defaultUnitId?: number | null, grossWeight?: number | null, flowerEquivalent?: number | null, recFlowerEquivalent?: number | null, whseProductsUnitPrice?: number | null, whseProductsRecUnitPrice?: number | null, lowInventoryThreshold?: number | null, productGrams?: number | null, cannabisInventory?: string | null, alternateDesc?: string | null, couponItem?: string | null, isNutrient: boolean, onlineProduct?: string | null, isRetired: boolean, isOnSale: boolean, itemTaxable?: string | null, onlineTitle?: string | null, onlineDescription?: string | null, productImageFileName?: string | null, externalCategory?: string | null, instructions?: string | null, allergenList?: string | null, ingredientList?: string | null, prescription?: string | null, approvalDateUTC?: any | null, productTypeNavigation?: { id: number, productType?: string | null, masterCategory?: string | null } | null, productToCustomerTypes?: Array<{ customerType?: { customerTypeId: number, customerTypeName: string } | null } | null> | null, unitType?: { unitTypeAbbreviation?: string | null, unitTypeName: string } | null, strain?: { strainName: string } | null, brand?: { brandName: string } | null, sizeListItem?: { description: string } | null } | null, locationProductMaster?: { price?: number | null, recPrice?: number | null, lowInventoryThreshold?: number | null, onlineAvailable?: any | null, posAvailable?: any | null } | null, inventoryStatus?: { invStatusDesc?: string | null } | null, batch?: { batchLotNumber: string, id: number, harvestCompletedOn?: any | null, lot: string, tblBatchThcs?: Array<{ thcValue?: number | null, thcUnit?: number | null, cbdValue?: number | null, cbdUnit?: number | null, cbdaValue?: number | null, cbdaUnit?: number | null, cbnValue?: number | null, cbnUnit?: number | null, thcaValue?: number | null, thcaUnit?: number | null, thc9Value?: number | null, thc9Unit?: number | null } | null> | null, batchStrainNavigation?: { strainName: string } | null } | null, vendor?: { vendorName: string, id: number, vendorCode?: string | null } | null, room?: { roomNo: string, id: number } | null, unit?: { abbreviation?: string | null, unitTypeId: number, unitId: number } | null, inventorySourceBatches?: Array<{ sourceBatch?: string | null } | null> | null, table?: { trayNumber: string } | null, producer?: { producerName?: string | null } | null, packageToTags?: Array<{ tag?: { tagId: number, tagName: string } | null } | null> | null, loc?: { whichUnitCost?: string | null, whichUnitPrice?: string | null } | null, packageToCustomerTypes?: Array<{ customerType?: { customerTypeId: number, customerTypeName: string } | null } | null> | null };

export type GetPackagesForDropdownQueryVariables = Exact<{
  lspId: Scalars['Int'];
  locId: Scalars['Int'];
  userId: Scalars['Int'];
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  orderClause?: InputMaybe<Array<PackageSortInput> | PackageSortInput>;
  whereClause: PackageFilterInput;
}>;


export type GetPackagesForDropdownQuery = { data?: { totalCount: number, items?: Array<{ packageId: number, serialNumber: string, quantity?: number | null, useByDate?: any | null, cost?: number | null, batch?: { batchName: string } | null, room?: { roomNo: string } | null, unit?: { abbreviation?: string | null, unitTypeId: number, unitId: number } | null } | null> | null, pageInfo: { hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type PackageDropDownAttributesFragment = { packageId: number, serialNumber: string, quantity?: number | null, useByDate?: any | null, cost?: number | null, batch?: { batchName: string } | null, room?: { roomNo: string } | null, unit?: { abbreviation?: string | null, unitTypeId: number, unitId: number } | null };

export type GetPackagesForGlobalSearchQueryVariables = Exact<{
  lspId: Scalars['Int'];
  locId: Scalars['Int'];
  userId: Scalars['Int'];
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  orderClause?: InputMaybe<Array<PackageSortInput> | PackageSortInput>;
  whereClause: PackageFilterInput;
}>;


export type GetPackagesForGlobalSearchQuery = { data?: { items?: Array<{ quantity?: number | null, sourceSerialNumber?: string | null, serialNumber: string, id: number, room?: { id: number, roomNo: string } | null, product?: { id: number, whseProductsDescription: string, brand?: { brandName: string } | null } | null } | null> | null } | null };

export type GetPackagesV2QueryVariables = Exact<{
  lspId: Scalars['Int'];
  locId: Scalars['Int'];
  userId: Scalars['Int'];
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  showLowInventory?: InputMaybe<Scalars['Boolean']>;
  orderClause?: InputMaybe<Array<PackageSortInput> | PackageSortInput>;
  whereClause: PackageFilterInput;
  excludeAllocatedInventorySum: Scalars['Boolean'];
  excludeLastAuditedDateUtc: Scalars['Boolean'];
  excludeLastDatePackageAuditedUtc: Scalars['Boolean'];
}>;


export type GetPackagesV2Query = { data?: { totalCount: number, items?: Array<{ allocatedInventorySum?: number | null, isOnHold: boolean, isOnRecall?: boolean | null, lastDatePackageAuditedUtc?: any | null, serialNumber: string, quantity?: number | null, producerId?: number | null, expirationDate?: any | null, inventoryStatusId?: number | null, packageWeight?: number | null, netWeight?: number | null, netWeightUnit?: number | null, flowerEquivalent?: number | null, recFlowerEquivalent?: number | null, productWeight?: number | null, unitPrice?: number | null, recUnitPrice?: number | null, cost?: number | null, receivedDate?: any | null, sourceSerialNumber?: string | null, medicalOnly: boolean, metrclabTestingStatus?: string | null, bioTrackQAStatus?: string | null, packagedDate?: any | null, manufacturingDate?: any | null, iltaxCategory?: any | null, cultivationTax?: number | null, exciseTax?: number | null, isFinishedInIntegration?: boolean | null, tableId?: number | null, potencyIndicator?: number | null, packageNdc?: string | null, effectivePotencyMg?: number | null, useByDate?: any | null, parentPackageSerialNumber?: string | null, hasMultipleParentPackages: boolean, isSample?: boolean | null, id: number, packageGroup?: { packageGroupId: any, packageItemLabels?: Array<{ itemLabel?: string | null } | null> | null } | null, product?: { id: number, posproducts?: string | null, lastAuditedDateUtc?: any | null, whseProductsDescription: string, productImageFileNameProcessed?: string | null, whseProductsProductNo: string, defaultUnitId?: number | null, grossWeight?: number | null, flowerEquivalent?: number | null, recFlowerEquivalent?: number | null, whseProductsUnitPrice?: number | null, whseProductsRecUnitPrice?: number | null, lowInventoryThreshold?: number | null, productGrams?: number | null, cannabisInventory?: string | null, alternateDesc?: string | null, couponItem?: string | null, isNutrient: boolean, onlineProduct?: string | null, isRetired: boolean, isOnSale: boolean, itemTaxable?: string | null, onlineTitle?: string | null, onlineDescription?: string | null, productImageFileName?: string | null, externalCategory?: string | null, instructions?: string | null, allergenList?: string | null, ingredientList?: string | null, prescription?: string | null, approvalDateUTC?: any | null, productTypeNavigation?: { id: number, productType?: string | null, masterCategory?: string | null } | null, productToCustomerTypes?: Array<{ customerType?: { customerTypeId: number, customerTypeName: string } | null } | null> | null, unitType?: { unitTypeAbbreviation?: string | null, unitTypeName: string } | null, strain?: { strainName: string } | null, brand?: { brandName: string } | null, sizeListItem?: { description: string } | null } | null, locationProductMaster?: { price?: number | null, recPrice?: number | null, lowInventoryThreshold?: number | null, onlineAvailable?: any | null, posAvailable?: any | null } | null, inventoryStatus?: { invStatusDesc?: string | null } | null, batch?: { batchLotNumber: string, id: number, harvestCompletedOn?: any | null, lot: string, tblBatchThcs?: Array<{ thcValue?: number | null, thcUnit?: number | null, cbdValue?: number | null, cbdUnit?: number | null, cbdaValue?: number | null, cbdaUnit?: number | null, cbnValue?: number | null, cbnUnit?: number | null, thcaValue?: number | null, thcaUnit?: number | null, thc9Value?: number | null, thc9Unit?: number | null } | null> | null, batchStrainNavigation?: { strainName: string } | null } | null, vendor?: { vendorName: string, id: number, vendorCode?: string | null } | null, room?: { roomNo: string, id: number } | null, unit?: { abbreviation?: string | null, unitTypeId: number, unitId: number } | null, inventorySourceBatches?: Array<{ sourceBatch?: string | null } | null> | null, table?: { trayNumber: string } | null, producer?: { producerName?: string | null } | null, packageToTags?: Array<{ tag?: { tagId: number, tagName: string } | null } | null> | null, loc?: { whichUnitCost?: string | null, whichUnitPrice?: string | null } | null, packageToCustomerTypes?: Array<{ customerType?: { customerTypeId: number, customerTypeName: string } | null } | null> | null } | null> | null, pageInfo: { hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type GetPackagesV3QueryVariables = Exact<{
  lspId: Scalars['Int'];
  locId: Scalars['Int'];
  userId: Scalars['Int'];
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  showLowInventory?: InputMaybe<Scalars['Boolean']>;
  orderClause?: InputMaybe<Array<PackageSortInput> | PackageSortInput>;
  whereClause: PackageFilterInput;
  excludeAllocatedInventorySum: Scalars['Boolean'];
  excludeLastAuditedDateUtc: Scalars['Boolean'];
  excludeLastDatePackageAuditedUtc: Scalars['Boolean'];
}>;


export type GetPackagesV3Query = { data?: { totalCount: number, items?: Array<{ allocatedInventorySum?: number | null, isOnHold: boolean, isOnRecall?: boolean | null, lastDatePackageAuditedUtc?: any | null, serialNumber: string, quantity?: number | null, producerId?: number | null, expirationDate?: any | null, inventoryStatusId?: number | null, packageWeight?: number | null, netWeight?: number | null, netWeightUnit?: number | null, flowerEquivalent?: number | null, recFlowerEquivalent?: number | null, productWeight?: number | null, unitPrice?: number | null, recUnitPrice?: number | null, cost?: number | null, receivedDate?: any | null, sourceSerialNumber?: string | null, medicalOnly: boolean, metrclabTestingStatus?: string | null, bioTrackQAStatus?: string | null, packagedDate?: any | null, manufacturingDate?: any | null, iltaxCategory?: any | null, cultivationTax?: number | null, exciseTax?: number | null, isFinishedInIntegration?: boolean | null, tableId?: number | null, potencyIndicator?: number | null, packageNdc?: string | null, effectivePotencyMg?: number | null, useByDate?: any | null, parentPackageSerialNumber?: string | null, hasMultipleParentPackages: boolean, isSample?: boolean | null, id: number, packageToTags?: Array<{ tag?: { tagId: number, tagName: string, smartTag?: { name?: string | null } | null } | null } | null> | null, packageGroup?: { packageGroupId: any, packageItemLabels?: Array<{ itemLabel?: string | null } | null> | null } | null, product?: { id: number, posproducts?: string | null, lastAuditedDateUtc?: any | null, whseProductsDescription: string, productImageFileNameProcessed?: string | null, whseProductsProductNo: string, defaultUnitId?: number | null, grossWeight?: number | null, flowerEquivalent?: number | null, recFlowerEquivalent?: number | null, whseProductsUnitPrice?: number | null, whseProductsRecUnitPrice?: number | null, lowInventoryThreshold?: number | null, productGrams?: number | null, cannabisInventory?: string | null, alternateDesc?: string | null, couponItem?: string | null, isNutrient: boolean, onlineProduct?: string | null, isRetired: boolean, isOnSale: boolean, itemTaxable?: string | null, onlineTitle?: string | null, onlineDescription?: string | null, productImageFileName?: string | null, externalCategory?: string | null, instructions?: string | null, allergenList?: string | null, ingredientList?: string | null, prescription?: string | null, approvalDateUTC?: any | null, productTypeNavigation?: { id: number, productType?: string | null, masterCategory?: string | null } | null, productToCustomerTypes?: Array<{ customerType?: { customerTypeId: number, customerTypeName: string } | null } | null> | null, unitType?: { unitTypeAbbreviation?: string | null, unitTypeName: string } | null, strain?: { strainName: string } | null, brand?: { brandName: string } | null, sizeListItem?: { description: string } | null } | null, locationProductMaster?: { price?: number | null, recPrice?: number | null, lowInventoryThreshold?: number | null, onlineAvailable?: any | null, posAvailable?: any | null } | null, inventoryStatus?: { invStatusDesc?: string | null } | null, batch?: { batchLotNumber: string, id: number, harvestCompletedOn?: any | null, lot: string, tblBatchThcs?: Array<{ thcValue?: number | null, thcUnit?: number | null, cbdValue?: number | null, cbdUnit?: number | null, cbdaValue?: number | null, cbdaUnit?: number | null, cbnValue?: number | null, cbnUnit?: number | null, thcaValue?: number | null, thcaUnit?: number | null, thc9Value?: number | null, thc9Unit?: number | null } | null> | null, batchStrainNavigation?: { strainName: string } | null } | null, vendor?: { vendorName: string, id: number, vendorCode?: string | null } | null, room?: { roomNo: string, id: number } | null, unit?: { abbreviation?: string | null, unitTypeId: number, unitId: number } | null, inventorySourceBatches?: Array<{ sourceBatch?: string | null } | null> | null, table?: { trayNumber: string } | null, producer?: { producerName?: string | null } | null, loc?: { whichUnitCost?: string | null, whichUnitPrice?: string | null } | null, packageToCustomerTypes?: Array<{ customerType?: { customerTypeId: number, customerTypeName: string } | null } | null> | null } | null> | null, pageInfo: { hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type GetPackagesQueryVariables = Exact<{
  lspId: Scalars['Int'];
  locId: Scalars['Int'];
  userId: Scalars['Int'];
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  showLowInventory?: InputMaybe<Scalars['Boolean']>;
  orderClause?: InputMaybe<Array<PackageSortInput> | PackageSortInput>;
  whereClause: PackageFilterInput;
  excludeAllocatedInventorySum: Scalars['Boolean'];
  excludeLastAuditedDateUtc: Scalars['Boolean'];
  excludeLastDatePackageAuditedUtc: Scalars['Boolean'];
}>;


export type GetPackagesQuery = { data?: { totalCount: number, items?: Array<{ allocatedInventorySum?: number | null, isOnHold: boolean, isOnRecall?: boolean | null, lastDatePackageAuditedUtc?: any | null, serialNumber: string, quantity?: number | null, producerId?: number | null, expirationDate?: any | null, inventoryStatusId?: number | null, packageWeight?: number | null, netWeight?: number | null, netWeightUnit?: number | null, flowerEquivalent?: number | null, recFlowerEquivalent?: number | null, productWeight?: number | null, unitPrice?: number | null, recUnitPrice?: number | null, cost?: number | null, receivedDate?: any | null, sourceSerialNumber?: string | null, medicalOnly: boolean, metrclabTestingStatus?: string | null, bioTrackQAStatus?: string | null, packagedDate?: any | null, manufacturingDate?: any | null, iltaxCategory?: any | null, cultivationTax?: number | null, exciseTax?: number | null, isFinishedInIntegration?: boolean | null, tableId?: number | null, potencyIndicator?: number | null, packageNdc?: string | null, effectivePotencyMg?: number | null, useByDate?: any | null, parentPackageSerialNumber?: string | null, hasMultipleParentPackages: boolean, isSample?: boolean | null, id: number, product?: { id: number, posproducts?: string | null, lastAuditedDateUtc?: any | null, whseProductsDescription: string, productImageFileNameProcessed?: string | null, whseProductsProductNo: string, defaultUnitId?: number | null, grossWeight?: number | null, flowerEquivalent?: number | null, recFlowerEquivalent?: number | null, whseProductsUnitPrice?: number | null, whseProductsRecUnitPrice?: number | null, lowInventoryThreshold?: number | null, productGrams?: number | null, cannabisInventory?: string | null, alternateDesc?: string | null, couponItem?: string | null, isNutrient: boolean, onlineProduct?: string | null, isRetired: boolean, isOnSale: boolean, itemTaxable?: string | null, onlineTitle?: string | null, onlineDescription?: string | null, productImageFileName?: string | null, externalCategory?: string | null, instructions?: string | null, allergenList?: string | null, ingredientList?: string | null, prescription?: string | null, approvalDateUTC?: any | null, productTypeNavigation?: { id: number, productType?: string | null, masterCategory?: string | null } | null, productToCustomerTypes?: Array<{ customerType?: { customerTypeId: number, customerTypeName: string } | null } | null> | null, unitType?: { unitTypeAbbreviation?: string | null, unitTypeName: string } | null, strain?: { strainName: string } | null, brand?: { brandName: string } | null, sizeListItem?: { description: string } | null } | null, locationProductMaster?: { price?: number | null, recPrice?: number | null, lowInventoryThreshold?: number | null, onlineAvailable?: any | null, posAvailable?: any | null } | null, inventoryStatus?: { invStatusDesc?: string | null } | null, batch?: { batchLotNumber: string, id: number, harvestCompletedOn?: any | null, lot: string, tblBatchThcs?: Array<{ thcValue?: number | null, thcUnit?: number | null, cbdValue?: number | null, cbdUnit?: number | null, cbdaValue?: number | null, cbdaUnit?: number | null, cbnValue?: number | null, cbnUnit?: number | null, thcaValue?: number | null, thcaUnit?: number | null, thc9Value?: number | null, thc9Unit?: number | null } | null> | null, batchStrainNavigation?: { strainName: string } | null } | null, vendor?: { vendorName: string, id: number, vendorCode?: string | null } | null, room?: { roomNo: string, id: number } | null, unit?: { abbreviation?: string | null, unitTypeId: number, unitId: number } | null, inventorySourceBatches?: Array<{ sourceBatch?: string | null } | null> | null, table?: { trayNumber: string } | null, producer?: { producerName?: string | null } | null, packageToTags?: Array<{ tag?: { tagId: number, tagName: string } | null } | null> | null, loc?: { whichUnitCost?: string | null, whichUnitPrice?: string | null } | null, packageToCustomerTypes?: Array<{ customerType?: { customerTypeId: number, customerTypeName: string } | null } | null> | null } | null> | null, pageInfo: { hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type GetPackageQtyQueryVariables = Exact<{
  id: Scalars['Int'];
  lspId: Scalars['Int'];
  locId: Scalars['Int'];
}>;


export type GetPackageQtyQuery = { data?: { packageId: number, quantity?: number | null } | null };

export type GetPackageV2QueryVariables = Exact<{
  id: Scalars['Int'];
  lspId: Scalars['Int'];
  locId: Scalars['Int'];
  excludeAllocatedInventorySum: Scalars['Boolean'];
  excludeLastAuditedDateUtc: Scalars['Boolean'];
  excludeLastDatePackageAuditedUtc: Scalars['Boolean'];
}>;


export type GetPackageV2Query = { data?: { allocatedInventorySum?: number | null, isOnHold: boolean, isOnRecall?: boolean | null, lastDatePackageAuditedUtc?: any | null, serialNumber: string, quantity?: number | null, producerId?: number | null, expirationDate?: any | null, inventoryStatusId?: number | null, packageWeight?: number | null, netWeight?: number | null, netWeightUnit?: number | null, flowerEquivalent?: number | null, recFlowerEquivalent?: number | null, productWeight?: number | null, unitPrice?: number | null, recUnitPrice?: number | null, cost?: number | null, receivedDate?: any | null, sourceSerialNumber?: string | null, medicalOnly: boolean, metrclabTestingStatus?: string | null, bioTrackQAStatus?: string | null, packagedDate?: any | null, manufacturingDate?: any | null, iltaxCategory?: any | null, cultivationTax?: number | null, exciseTax?: number | null, isFinishedInIntegration?: boolean | null, tableId?: number | null, potencyIndicator?: number | null, packageNdc?: string | null, effectivePotencyMg?: number | null, useByDate?: any | null, parentPackageSerialNumber?: string | null, hasMultipleParentPackages: boolean, isSample?: boolean | null, id: number, packageGroup?: { packageGroupId: any, packageItemLabels?: Array<{ itemLabel?: string | null } | null> | null } | null, product?: { id: number, posproducts?: string | null, lastAuditedDateUtc?: any | null, whseProductsDescription: string, productImageFileNameProcessed?: string | null, whseProductsProductNo: string, defaultUnitId?: number | null, grossWeight?: number | null, flowerEquivalent?: number | null, recFlowerEquivalent?: number | null, whseProductsUnitPrice?: number | null, whseProductsRecUnitPrice?: number | null, lowInventoryThreshold?: number | null, productGrams?: number | null, cannabisInventory?: string | null, alternateDesc?: string | null, couponItem?: string | null, isNutrient: boolean, onlineProduct?: string | null, isRetired: boolean, isOnSale: boolean, itemTaxable?: string | null, onlineTitle?: string | null, onlineDescription?: string | null, productImageFileName?: string | null, externalCategory?: string | null, instructions?: string | null, allergenList?: string | null, ingredientList?: string | null, prescription?: string | null, approvalDateUTC?: any | null, productTypeNavigation?: { id: number, productType?: string | null, masterCategory?: string | null } | null, productToCustomerTypes?: Array<{ customerType?: { customerTypeId: number, customerTypeName: string } | null } | null> | null, unitType?: { unitTypeAbbreviation?: string | null, unitTypeName: string } | null, strain?: { strainName: string } | null, brand?: { brandName: string } | null, sizeListItem?: { description: string } | null } | null, locationProductMaster?: { price?: number | null, recPrice?: number | null, lowInventoryThreshold?: number | null, onlineAvailable?: any | null, posAvailable?: any | null } | null, inventoryStatus?: { invStatusDesc?: string | null } | null, batch?: { batchLotNumber: string, id: number, harvestCompletedOn?: any | null, lot: string, tblBatchThcs?: Array<{ thcValue?: number | null, thcUnit?: number | null, cbdValue?: number | null, cbdUnit?: number | null, cbdaValue?: number | null, cbdaUnit?: number | null, cbnValue?: number | null, cbnUnit?: number | null, thcaValue?: number | null, thcaUnit?: number | null, thc9Value?: number | null, thc9Unit?: number | null } | null> | null, batchStrainNavigation?: { strainName: string } | null } | null, vendor?: { vendorName: string, id: number, vendorCode?: string | null } | null, room?: { roomNo: string, id: number } | null, unit?: { abbreviation?: string | null, unitTypeId: number, unitId: number } | null, inventorySourceBatches?: Array<{ sourceBatch?: string | null } | null> | null, table?: { trayNumber: string } | null, producer?: { producerName?: string | null } | null, packageToTags?: Array<{ tag?: { tagId: number, tagName: string } | null } | null> | null, loc?: { whichUnitCost?: string | null, whichUnitPrice?: string | null } | null, packageToCustomerTypes?: Array<{ customerType?: { customerTypeId: number, customerTypeName: string } | null } | null> | null } | null };

export type GetPackageV3QueryVariables = Exact<{
  id: Scalars['Int'];
  lspId: Scalars['Int'];
  locId: Scalars['Int'];
  excludeAllocatedInventorySum: Scalars['Boolean'];
  excludeLastAuditedDateUtc: Scalars['Boolean'];
  excludeLastDatePackageAuditedUtc: Scalars['Boolean'];
}>;


export type GetPackageV3Query = { data?: { allocatedInventorySum?: number | null, isOnHold: boolean, isOnRecall?: boolean | null, lastDatePackageAuditedUtc?: any | null, serialNumber: string, quantity?: number | null, producerId?: number | null, expirationDate?: any | null, inventoryStatusId?: number | null, packageWeight?: number | null, netWeight?: number | null, netWeightUnit?: number | null, flowerEquivalent?: number | null, recFlowerEquivalent?: number | null, productWeight?: number | null, unitPrice?: number | null, recUnitPrice?: number | null, cost?: number | null, receivedDate?: any | null, sourceSerialNumber?: string | null, medicalOnly: boolean, metrclabTestingStatus?: string | null, bioTrackQAStatus?: string | null, packagedDate?: any | null, manufacturingDate?: any | null, iltaxCategory?: any | null, cultivationTax?: number | null, exciseTax?: number | null, isFinishedInIntegration?: boolean | null, tableId?: number | null, potencyIndicator?: number | null, packageNdc?: string | null, effectivePotencyMg?: number | null, useByDate?: any | null, parentPackageSerialNumber?: string | null, hasMultipleParentPackages: boolean, isSample?: boolean | null, id: number, packageToTags?: Array<{ tag?: { tagId: number, tagName: string, smartTag?: { name?: string | null } | null } | null } | null> | null, packageGroup?: { packageGroupId: any, packageItemLabels?: Array<{ itemLabel?: string | null } | null> | null } | null, product?: { id: number, posproducts?: string | null, lastAuditedDateUtc?: any | null, whseProductsDescription: string, productImageFileNameProcessed?: string | null, whseProductsProductNo: string, defaultUnitId?: number | null, grossWeight?: number | null, flowerEquivalent?: number | null, recFlowerEquivalent?: number | null, whseProductsUnitPrice?: number | null, whseProductsRecUnitPrice?: number | null, lowInventoryThreshold?: number | null, productGrams?: number | null, cannabisInventory?: string | null, alternateDesc?: string | null, couponItem?: string | null, isNutrient: boolean, onlineProduct?: string | null, isRetired: boolean, isOnSale: boolean, itemTaxable?: string | null, onlineTitle?: string | null, onlineDescription?: string | null, productImageFileName?: string | null, externalCategory?: string | null, instructions?: string | null, allergenList?: string | null, ingredientList?: string | null, prescription?: string | null, approvalDateUTC?: any | null, productTypeNavigation?: { id: number, productType?: string | null, masterCategory?: string | null } | null, productToCustomerTypes?: Array<{ customerType?: { customerTypeId: number, customerTypeName: string } | null } | null> | null, unitType?: { unitTypeAbbreviation?: string | null, unitTypeName: string } | null, strain?: { strainName: string } | null, brand?: { brandName: string } | null, sizeListItem?: { description: string } | null } | null, locationProductMaster?: { price?: number | null, recPrice?: number | null, lowInventoryThreshold?: number | null, onlineAvailable?: any | null, posAvailable?: any | null } | null, inventoryStatus?: { invStatusDesc?: string | null } | null, batch?: { batchLotNumber: string, id: number, harvestCompletedOn?: any | null, lot: string, tblBatchThcs?: Array<{ thcValue?: number | null, thcUnit?: number | null, cbdValue?: number | null, cbdUnit?: number | null, cbdaValue?: number | null, cbdaUnit?: number | null, cbnValue?: number | null, cbnUnit?: number | null, thcaValue?: number | null, thcaUnit?: number | null, thc9Value?: number | null, thc9Unit?: number | null } | null> | null, batchStrainNavigation?: { strainName: string } | null } | null, vendor?: { vendorName: string, id: number, vendorCode?: string | null } | null, room?: { roomNo: string, id: number } | null, unit?: { abbreviation?: string | null, unitTypeId: number, unitId: number } | null, inventorySourceBatches?: Array<{ sourceBatch?: string | null } | null> | null, table?: { trayNumber: string } | null, producer?: { producerName?: string | null } | null, loc?: { whichUnitCost?: string | null, whichUnitPrice?: string | null } | null, packageToCustomerTypes?: Array<{ customerType?: { customerTypeId: number, customerTypeName: string } | null } | null> | null } | null };

export type GetPackageQueryVariables = Exact<{
  id: Scalars['Int'];
  lspId: Scalars['Int'];
  locId: Scalars['Int'];
  excludeAllocatedInventorySum: Scalars['Boolean'];
  excludeLastAuditedDateUtc: Scalars['Boolean'];
  excludeLastDatePackageAuditedUtc: Scalars['Boolean'];
}>;


export type GetPackageQuery = { data?: { allocatedInventorySum?: number | null, isOnHold: boolean, isOnRecall?: boolean | null, lastDatePackageAuditedUtc?: any | null, serialNumber: string, quantity?: number | null, producerId?: number | null, expirationDate?: any | null, inventoryStatusId?: number | null, packageWeight?: number | null, netWeight?: number | null, netWeightUnit?: number | null, flowerEquivalent?: number | null, recFlowerEquivalent?: number | null, productWeight?: number | null, unitPrice?: number | null, recUnitPrice?: number | null, cost?: number | null, receivedDate?: any | null, sourceSerialNumber?: string | null, medicalOnly: boolean, metrclabTestingStatus?: string | null, bioTrackQAStatus?: string | null, packagedDate?: any | null, manufacturingDate?: any | null, iltaxCategory?: any | null, cultivationTax?: number | null, exciseTax?: number | null, isFinishedInIntegration?: boolean | null, tableId?: number | null, potencyIndicator?: number | null, packageNdc?: string | null, effectivePotencyMg?: number | null, useByDate?: any | null, parentPackageSerialNumber?: string | null, hasMultipleParentPackages: boolean, isSample?: boolean | null, id: number, product?: { id: number, posproducts?: string | null, lastAuditedDateUtc?: any | null, whseProductsDescription: string, productImageFileNameProcessed?: string | null, whseProductsProductNo: string, defaultUnitId?: number | null, grossWeight?: number | null, flowerEquivalent?: number | null, recFlowerEquivalent?: number | null, whseProductsUnitPrice?: number | null, whseProductsRecUnitPrice?: number | null, lowInventoryThreshold?: number | null, productGrams?: number | null, cannabisInventory?: string | null, alternateDesc?: string | null, couponItem?: string | null, isNutrient: boolean, onlineProduct?: string | null, isRetired: boolean, isOnSale: boolean, itemTaxable?: string | null, onlineTitle?: string | null, onlineDescription?: string | null, productImageFileName?: string | null, externalCategory?: string | null, instructions?: string | null, allergenList?: string | null, ingredientList?: string | null, prescription?: string | null, approvalDateUTC?: any | null, productTypeNavigation?: { id: number, productType?: string | null, masterCategory?: string | null } | null, productToCustomerTypes?: Array<{ customerType?: { customerTypeId: number, customerTypeName: string } | null } | null> | null, unitType?: { unitTypeAbbreviation?: string | null, unitTypeName: string } | null, strain?: { strainName: string } | null, brand?: { brandName: string } | null, sizeListItem?: { description: string } | null } | null, locationProductMaster?: { price?: number | null, recPrice?: number | null, lowInventoryThreshold?: number | null, onlineAvailable?: any | null, posAvailable?: any | null } | null, inventoryStatus?: { invStatusDesc?: string | null } | null, batch?: { batchLotNumber: string, id: number, harvestCompletedOn?: any | null, lot: string, tblBatchThcs?: Array<{ thcValue?: number | null, thcUnit?: number | null, cbdValue?: number | null, cbdUnit?: number | null, cbdaValue?: number | null, cbdaUnit?: number | null, cbnValue?: number | null, cbnUnit?: number | null, thcaValue?: number | null, thcaUnit?: number | null, thc9Value?: number | null, thc9Unit?: number | null } | null> | null, batchStrainNavigation?: { strainName: string } | null } | null, vendor?: { vendorName: string, id: number, vendorCode?: string | null } | null, room?: { roomNo: string, id: number } | null, unit?: { abbreviation?: string | null, unitTypeId: number, unitId: number } | null, inventorySourceBatches?: Array<{ sourceBatch?: string | null } | null> | null, table?: { trayNumber: string } | null, producer?: { producerName?: string | null } | null, packageToTags?: Array<{ tag?: { tagId: number, tagName: string } | null } | null> | null, loc?: { whichUnitCost?: string | null, whichUnitPrice?: string | null } | null, packageToCustomerTypes?: Array<{ customerType?: { customerTypeId: number, customerTypeName: string } | null } | null> | null } | null };

export type ProductAttributesFragment = { id: number, isRetired: boolean, whseProductsProductNo: string, whseProductsDescription: string, brand?: { brandId: number, brandName: string } | null, vendorNavigation?: { id: number, vendorName: string } | null, strain?: { id: number, strainName: string } | null, unitType?: { unitTypeId: number, unitTypeName: string } | null, defaultUnit?: { unitId: number, unitName: string } | null, productToTags?: Array<{ tag?: { tagId: number, tagName: string } | null } | null> | null, sizeListItem?: { id: number, name: string } | null, dosage?: { id: number, name: string } | null };

export type ProductDropDownAttributesFragment = { id: number, isRetired: boolean, alternateDesc?: string | null, expirationDays?: number | null, sku: string, name: string, cost?: number | null, strain?: { id: number, strainName: string } | null, defaultUnit?: { unitId: number } | null, vendorNavigation?: { id: number, vendorName: string } | null, productToTags?: Array<{ tag?: { tagId: number, tagName: string } | null } | null> | null };

export type GetProductsQueryVariables = Exact<{
  lspId: Scalars['Int'];
  userId: Scalars['Int'];
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  orderClause?: InputMaybe<Array<TblWhseProductSortInput> | TblWhseProductSortInput>;
  whereClause: TblWhseProductFilterInput;
}>;


export type GetProductsQuery = { data?: { totalCount: number, items?: Array<{ id: number, isRetired: boolean, whseProductsProductNo: string, whseProductsDescription: string, brand?: { brandId: number, brandName: string } | null, vendorNavigation?: { id: number, vendorName: string } | null, strain?: { id: number, strainName: string } | null, unitType?: { unitTypeId: number, unitTypeName: string } | null, defaultUnit?: { unitId: number, unitName: string } | null, productToTags?: Array<{ tag?: { tagId: number, tagName: string } | null } | null> | null, sizeListItem?: { id: number, name: string } | null, dosage?: { id: number, name: string } | null } | null> | null, pageInfo: { hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type GetProductsForDropdownQueryVariables = Exact<{
  lspId: Scalars['Int'];
  userId: Scalars['Int'];
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  orderClause?: InputMaybe<Array<TblWhseProductSortInput> | TblWhseProductSortInput>;
  whereClause: TblWhseProductFilterInput;
}>;


export type GetProductsForDropdownQuery = { data?: { items?: Array<{ id: number, isRetired: boolean, alternateDesc?: string | null, expirationDays?: number | null, sku: string, name: string, cost?: number | null, strain?: { id: number, strainName: string } | null, defaultUnit?: { unitId: number } | null, vendorNavigation?: { id: number, vendorName: string } | null, productToTags?: Array<{ tag?: { tagId: number, tagName: string } | null } | null> | null } | null> | null } | null };

export type UpdateProductRetiredStatusMutationVariables = Exact<{
  input: UpdateProductRetiredStatusInput;
}>;


export type UpdateProductRetiredStatusMutation = { updateProductRetiredStatus?: { result: boolean, message?: string | null } | null };

export type InventoryStatusAttributeFragment = { id: number, invStatusDesc?: string | null };

export type GetInventoryStatusesQueryVariables = Exact<{
  lspId: Scalars['Int'];
  locId: Scalars['Int'];
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  orderClause?: InputMaybe<Array<TblInventoryStatusSortInput> | TblInventoryStatusSortInput>;
  whereClause?: InputMaybe<TblInventoryStatusFilterInput>;
}>;


export type GetInventoryStatusesQuery = { data?: { totalCount: number, items?: Array<{ id: number, invStatusDesc?: string | null } | null> | null, pageInfo: { hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type SetJobStatusCancelledMutationVariables = Exact<{
  input?: InputMaybe<SetJobStatusToCancelledInput>;
}>;


export type SetJobStatusCancelledMutation = { setJobStatusCancelled?: { data?: { jobStatusId: number, cancelled: boolean, message?: string | null } | null } | null };

export type GetJobStatusQueryVariables = Exact<{
  lspId: Scalars['Int'];
  locId: Scalars['Int'];
  id: Scalars['Int'];
}>;


export type GetJobStatusQuery = { data?: { id: number, jobName: string, jobSource: string, status: string, statusDetails?: string | null, cancel: boolean, createdAtUtc: any, updatedAtUtc: any, userId: number, user?: { name: string, fullName: string } | null } | null };

export type GetJobStatusesQueryVariables = Exact<{
  lspId: Scalars['Int'];
  locId: Scalars['Int'];
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  orderClause?: InputMaybe<Array<JobStatusSortInput> | JobStatusSortInput>;
  whereClause?: InputMaybe<JobStatusFilterInput>;
}>;


export type GetJobStatusesQuery = { data?: { totalCount: number, pageInfo: { hasNextPage: boolean, hasPreviousPage: boolean }, items?: Array<{ id: number, jobName: string, jobSource: string, status: string, statusDetails?: string | null, cancel: boolean, createdAtUtc: any, updatedAtUtc: any, userId: number, user?: { name: string, fullName: string } | null } | null> | null } | null };

export type PlantAttributesFragment = { lspId?: number | null, locId?: number | null, id: number, plantSerialNo?: string | null, externalId?: string | null, plantGroup?: string | null, plantGroupId?: number | null, addedToHarvestOn?: any | null, cuttingsComment?: string | null, plantType?: string | null, pcounter?: number | null, harvestDate?: any | null, motherPlant?: string | null, motherPlantId?: number | null, plantStage?: string | null, currentRoom?: number | null, currentTray?: number | null, createDt?: any | null, plantDestroyedDate?: any | null, plantDestroyedComment?: string | null, batchId: number, bioTplantBarcodeId?: string | null, trimDate?: any | null, trimWasteWgt?: number | null, bornDate?: any | null, budWgt?: number | null, plantStatus: string, weekPlanted?: number | null, currentRoomNavigation?: { id: number, roomNo: string } | null, currentTrayNavigation?: { id: number, trayNumber: string } | null, growthPhases?: Array<{ plantStageTransitionId: number, plantId: number, fromStage?: string | null, toStage: string, transitionDateUtc: any, plantTransactionId?: number | null } | null> | null, roomHistory?: Array<{ moveDateTime: any, table?: { trayNumber: string } | null, room?: { roomNo: string } | null, userName?: { name: string } | null, locationName?: { lspLocationsName: string } | null } | null> | null, nutrientLog?: Array<{ plantId: number, productId: number, quantity: number, unitId: number, appliedBy: number, appliedOnUtc: any, product?: { whseProductsDescription: string } | null, appliedByUser?: { name: string } | null } | null> | null, motherPlantData?: { plantSerialNo?: string | null } | null, metrcWeights?: { metrcReportedWeight?: number | null, metrcReportedWeightStatus?: number | null, metrcReportedWeightDate?: any | null } | null, plantPhaseResults?: { floweringStartedOn?: any | null, floweringEndedOn?: any | null, vegetationStartedOn?: any | null, vegetationEndedOn?: any | null, daysInFlowering?: number | null, daysInVegetation?: number | null, daysInCurrentPhase?: number | null } | null, strain?: { id: number, strainName: string } | null, batch?: { batchLotNumber: string, projectedYield?: number | null, projectedYieldUnitId?: number | null, projectedHarvestDate?: any | null, batchStrainNavigation?: { id: number, strainName: string } | null } | null, tags?: Array<{ tagId: number, lspId?: number | null } | null> | null };

export type GetPlantsQueryVariables = Exact<{
  lspId: Scalars['Int'];
  locId: Scalars['Int'];
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  orderClause?: InputMaybe<Array<TblMdbatchPlantIdSortInput> | TblMdbatchPlantIdSortInput>;
  whereClause: TblMdbatchPlantIdFilterInput;
}>;


export type GetPlantsQuery = { data?: { totalCount: number, items?: Array<{ lspId?: number | null, locId?: number | null, id: number, plantSerialNo?: string | null, externalId?: string | null, plantGroup?: string | null, plantGroupId?: number | null, addedToHarvestOn?: any | null, cuttingsComment?: string | null, plantType?: string | null, pcounter?: number | null, harvestDate?: any | null, motherPlant?: string | null, motherPlantId?: number | null, plantStage?: string | null, currentRoom?: number | null, currentTray?: number | null, createDt?: any | null, plantDestroyedDate?: any | null, plantDestroyedComment?: string | null, batchId: number, bioTplantBarcodeId?: string | null, trimDate?: any | null, trimWasteWgt?: number | null, bornDate?: any | null, budWgt?: number | null, plantStatus: string, weekPlanted?: number | null, currentRoomNavigation?: { id: number, roomNo: string } | null, currentTrayNavigation?: { id: number, trayNumber: string } | null, growthPhases?: Array<{ plantStageTransitionId: number, plantId: number, fromStage?: string | null, toStage: string, transitionDateUtc: any, plantTransactionId?: number | null } | null> | null, roomHistory?: Array<{ moveDateTime: any, table?: { trayNumber: string } | null, room?: { roomNo: string } | null, userName?: { name: string } | null, locationName?: { lspLocationsName: string } | null } | null> | null, nutrientLog?: Array<{ plantId: number, productId: number, quantity: number, unitId: number, appliedBy: number, appliedOnUtc: any, product?: { whseProductsDescription: string } | null, appliedByUser?: { name: string } | null } | null> | null, motherPlantData?: { plantSerialNo?: string | null } | null, metrcWeights?: { metrcReportedWeight?: number | null, metrcReportedWeightStatus?: number | null, metrcReportedWeightDate?: any | null } | null, plantPhaseResults?: { floweringStartedOn?: any | null, floweringEndedOn?: any | null, vegetationStartedOn?: any | null, vegetationEndedOn?: any | null, daysInFlowering?: number | null, daysInVegetation?: number | null, daysInCurrentPhase?: number | null } | null, strain?: { id: number, strainName: string } | null, batch?: { batchLotNumber: string, projectedYield?: number | null, projectedYieldUnitId?: number | null, projectedHarvestDate?: any | null, batchStrainNavigation?: { id: number, strainName: string } | null } | null, tags?: Array<{ tagId: number, lspId?: number | null } | null> | null } | null> | null, pageInfo: { hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type GetPlantQueryVariables = Exact<{
  id: Scalars['Int'];
  lspId: Scalars['Int'];
  locId: Scalars['Int'];
}>;


export type GetPlantQuery = { data?: { lspId?: number | null, locId?: number | null, id: number, plantSerialNo?: string | null, externalId?: string | null, plantGroup?: string | null, plantGroupId?: number | null, addedToHarvestOn?: any | null, cuttingsComment?: string | null, plantType?: string | null, pcounter?: number | null, harvestDate?: any | null, motherPlant?: string | null, motherPlantId?: number | null, plantStage?: string | null, currentRoom?: number | null, currentTray?: number | null, createDt?: any | null, plantDestroyedDate?: any | null, plantDestroyedComment?: string | null, batchId: number, bioTplantBarcodeId?: string | null, trimDate?: any | null, trimWasteWgt?: number | null, bornDate?: any | null, budWgt?: number | null, plantStatus: string, weekPlanted?: number | null, currentRoomNavigation?: { id: number, roomNo: string } | null, currentTrayNavigation?: { id: number, trayNumber: string } | null, growthPhases?: Array<{ plantStageTransitionId: number, plantId: number, fromStage?: string | null, toStage: string, transitionDateUtc: any, plantTransactionId?: number | null } | null> | null, roomHistory?: Array<{ moveDateTime: any, table?: { trayNumber: string } | null, room?: { roomNo: string } | null, userName?: { name: string } | null, locationName?: { lspLocationsName: string } | null } | null> | null, nutrientLog?: Array<{ plantId: number, productId: number, quantity: number, unitId: number, appliedBy: number, appliedOnUtc: any, product?: { whseProductsDescription: string } | null, appliedByUser?: { name: string } | null } | null> | null, motherPlantData?: { plantSerialNo?: string | null } | null, metrcWeights?: { metrcReportedWeight?: number | null, metrcReportedWeightStatus?: number | null, metrcReportedWeightDate?: any | null } | null, plantPhaseResults?: { floweringStartedOn?: any | null, floweringEndedOn?: any | null, vegetationStartedOn?: any | null, vegetationEndedOn?: any | null, daysInFlowering?: number | null, daysInVegetation?: number | null, daysInCurrentPhase?: number | null } | null, strain?: { id: number, strainName: string } | null, batch?: { batchLotNumber: string, projectedYield?: number | null, projectedYieldUnitId?: number | null, projectedHarvestDate?: any | null, batchStrainNavigation?: { id: number, strainName: string } | null } | null, tags?: Array<{ tagId: number, lspId?: number | null } | null> | null } | null };

export type ProducerAttributesFragment = { producerId: number, producerName?: string | null, isDeleted: boolean };

export type GetProducersQueryVariables = Exact<{
  lspId: Scalars['Int'];
  locId: Scalars['Int'];
  userId: Scalars['Int'];
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  orderClause?: InputMaybe<Array<ProducerSortInput> | ProducerSortInput>;
  whereClause: ProducerFilterInput;
}>;


export type GetProducersQuery = { data?: { items?: Array<{ producerId: number, producerName?: string | null, isDeleted: boolean } | null> | null, pageInfo: { hasNextPage: boolean } } | null };

export type GetProducerQueryVariables = Exact<{
  id: Scalars['Int'];
  lspId: Scalars['Int'];
  locId: Scalars['Int'];
  userId: Scalars['Int'];
}>;


export type GetProducerQuery = { data?: { producerId: number, producerName?: string | null, isDeleted: boolean } | null };

export type ProductCategoryAttributesFragment = { flowerEquivalent?: number | null, id: number, leafLinkCategoryId?: number | null, leafLinkSubCategoryId?: number | null, leaflyCategory?: string | null, ecomCategory?: string | null, ecomSubcategory?: string | null, masterCategory?: string | null, mmurformId?: number | null, productFlag?: string | null, productType?: string | null, purchaseLimitCategoryId?: number | null, recFlowerEquivalent?: number | null, regulatoryCategoryId?: any | null, stateInventoryFlag: string, weedMapsCategoryId?: any | null, weedMapsSubCategoryId?: any | null, mmurforms?: Array<{ formId: number, form?: string | null } | null> | null, productTaxCategories?: Array<{ productTaxCategoryId: number, productTaxCategory1: string } | null> | null, productTypeToRevenueAccount?: { accountId: string } | null };

export type CategoryAttributesFragment = { id: number, productType?: string | null, masterCategory?: string | null };

export type GetProductCategoriesQueryVariables = Exact<{
  lspId: Scalars['Int'];
  whereClause: TblWhseProductTypeFilterInput;
  orderClause?: InputMaybe<Array<TblWhseProductTypeSortInput> | TblWhseProductTypeSortInput>;
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
}>;


export type GetProductCategoriesQuery = { data?: { items?: Array<{ flowerEquivalent?: number | null, id: number, leafLinkCategoryId?: number | null, leafLinkSubCategoryId?: number | null, leaflyCategory?: string | null, ecomCategory?: string | null, ecomSubcategory?: string | null, masterCategory?: string | null, mmurformId?: number | null, productFlag?: string | null, productType?: string | null, purchaseLimitCategoryId?: number | null, recFlowerEquivalent?: number | null, regulatoryCategoryId?: any | null, stateInventoryFlag: string, weedMapsCategoryId?: any | null, weedMapsSubCategoryId?: any | null, mmurforms?: Array<{ formId: number, form?: string | null } | null> | null, productTaxCategories?: Array<{ productTaxCategoryId: number, productTaxCategory1: string } | null> | null, productTypeToRevenueAccount?: { accountId: string } | null } | null> | null, pageInfo: { hasNextPage: boolean } } | null };

export type GetCategoriesQueryVariables = Exact<{
  lspId: Scalars['Int'];
  whereClause: TblWhseProductTypeFilterInput;
  orderClause?: InputMaybe<Array<TblWhseProductTypeSortInput> | TblWhseProductTypeSortInput>;
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
}>;


export type GetCategoriesQuery = { data?: { totalCount: number, items?: Array<{ id: number, productType?: string | null, masterCategory?: string | null } | null> | null, pageInfo: { hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type GetProductCategoryQueryVariables = Exact<{
  id: Scalars['Int'];
  lspId: Scalars['Int'];
}>;


export type GetProductCategoryQuery = { data?: { flowerEquivalent?: number | null, id: number, leafLinkCategoryId?: number | null, leafLinkSubCategoryId?: number | null, leaflyCategory?: string | null, ecomCategory?: string | null, ecomSubcategory?: string | null, masterCategory?: string | null, mmurformId?: number | null, productFlag?: string | null, productType?: string | null, purchaseLimitCategoryId?: number | null, recFlowerEquivalent?: number | null, regulatoryCategoryId?: any | null, stateInventoryFlag: string, weedMapsCategoryId?: any | null, weedMapsSubCategoryId?: any | null, mmurforms?: Array<{ formId: number, form?: string | null } | null> | null, productTaxCategories?: Array<{ productTaxCategoryId: number, productTaxCategory1: string } | null> | null, productTypeToRevenueAccount?: { accountId: string } | null } | null };

export type RoomAttributesFragment = { checkOutRoom?: string | null, cultivationStage?: string | null, dispensaryLimitedroom?: string | null, dispensaryRestrictedRoom?: string | null, ecommerceRoom?: string | null, examRoom?: string | null, externalId?: string | null, id: number, inspectionRoom?: string | null, inventoryRoom?: string | null, locationType?: string | null, medicationRoom?: string | null, posRoom?: string | null, preOrderRoom?: string | null, publishToMenus: boolean, quarantineRoom?: string | null, roomArea?: number | null, roomAreaUnits?: string | null, roomNo: string, roomPurpose?: string | null, vaultRoom?: string | null, waitingRoom?: string | null, roomToMenus?: Array<{ menuName?: string | null } | null> | null, roomTerminals?: Array<{ terminal?: { id: number, terminalName: string } | null } | null> | null };

export type GetRoomsDropdownQueryVariables = Exact<{
  lspId: Scalars['Int'];
  locId: Scalars['Int'];
  whereClause: TblBatchRoomFilterInput;
  orderClause?: InputMaybe<Array<TblBatchRoomSortInput> | TblBatchRoomSortInput>;
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  hideEmpty?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetRoomsDropdownQuery = { data?: { totalCount: number, items?: Array<{ id: number, roomNo: string } | null> | null, pageInfo: { hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type GetRoomsQueryVariables = Exact<{
  lspId: Scalars['Int'];
  locId: Scalars['Int'];
  whereClause: TblBatchRoomFilterInput;
  orderClause?: InputMaybe<Array<TblBatchRoomSortInput> | TblBatchRoomSortInput>;
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
}>;


export type GetRoomsQuery = { data?: { totalCount: number, items?: Array<{ checkOutRoom?: string | null, cultivationStage?: string | null, dispensaryLimitedroom?: string | null, dispensaryRestrictedRoom?: string | null, ecommerceRoom?: string | null, examRoom?: string | null, externalId?: string | null, id: number, inspectionRoom?: string | null, inventoryRoom?: string | null, locationType?: string | null, medicationRoom?: string | null, posRoom?: string | null, preOrderRoom?: string | null, publishToMenus: boolean, quarantineRoom?: string | null, roomArea?: number | null, roomAreaUnits?: string | null, roomNo: string, roomPurpose?: string | null, vaultRoom?: string | null, waitingRoom?: string | null, roomToMenus?: Array<{ menuName?: string | null } | null> | null, roomTerminals?: Array<{ terminal?: { id: number, terminalName: string } | null } | null> | null } | null> | null, pageInfo: { hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type GetRoomQueryVariables = Exact<{
  id: Scalars['Int'];
  lspId: Scalars['Int'];
  locId: Scalars['Int'];
}>;


export type GetRoomQuery = { data?: { checkOutRoom?: string | null, cultivationStage?: string | null, dispensaryLimitedroom?: string | null, dispensaryRestrictedRoom?: string | null, ecommerceRoom?: string | null, examRoom?: string | null, externalId?: string | null, id: number, inspectionRoom?: string | null, inventoryRoom?: string | null, locationType?: string | null, medicationRoom?: string | null, posRoom?: string | null, preOrderRoom?: string | null, publishToMenus: boolean, quarantineRoom?: string | null, roomArea?: number | null, roomAreaUnits?: string | null, roomNo: string, roomPurpose?: string | null, vaultRoom?: string | null, waitingRoom?: string | null, roomToMenus?: Array<{ menuName?: string | null } | null> | null, roomTerminals?: Array<{ terminal?: { id: number, terminalName: string } | null } | null> | null } | null };

export type StrainAttributesFragment = { externalId?: string | null, id: number, strainDescription: string, strainName: string, strainNo?: string | null, strainType?: string | null };

export type GetStrainsDropdownQueryVariables = Exact<{
  lspId: Scalars['Int'];
  locId: Scalars['Int'];
  whereClause: TblBatchStrainFilterInput;
  orderClause?: InputMaybe<Array<TblBatchStrainSortInput> | TblBatchStrainSortInput>;
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
}>;


export type GetStrainsDropdownQuery = { data?: { totalCount: number, items?: Array<{ externalId?: string | null, id: number, strainDescription: string, strainName: string, strainNo?: string | null, strainType?: string | null } | null> | null, pageInfo: { hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type GetStrainsQueryVariables = Exact<{
  lspId: Scalars['Int'];
  locId: Scalars['Int'];
  whereClause: TblBatchStrainFilterInput;
  orderClause?: InputMaybe<Array<TblBatchStrainSortInput> | TblBatchStrainSortInput>;
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
}>;


export type GetStrainsQuery = { data?: { totalCount: number, items?: Array<{ externalId?: string | null, id: number, strainDescription: string, strainName: string, strainNo?: string | null, strainType?: string | null } | null> | null, pageInfo: { hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type GetStrainQueryVariables = Exact<{
  id: Scalars['Int'];
  lspId: Scalars['Int'];
  locId: Scalars['Int'];
}>;


export type GetStrainQuery = { data?: { externalId?: string | null, id: number, strainDescription: string, strainName: string, strainNo?: string | null, strainType?: string | null } | null };

export type SubroomAttributesFragment = { id: number, lsp: number, lspLocation: number, trayNumber: string, width?: number | null, widthUnit?: number | null, length?: number | null, lengthUnit?: number | null, areaFt?: number | null, room?: { id: number, roomNo: string } | null };

export type GetSubRoomsDropdownQueryVariables = Exact<{
  lspId: Scalars['Int'];
  locId: Scalars['Int'];
  whereClause: TblBatchTrayFilterInput;
  orderClause?: InputMaybe<Array<TblBatchTraySortInput> | TblBatchTraySortInput>;
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
}>;


export type GetSubRoomsDropdownQuery = { data?: { totalCount: number, items?: Array<{ id: number, lsp: number, lspLocation: number, trayNumber: string, width?: number | null, widthUnit?: number | null, length?: number | null, lengthUnit?: number | null, areaFt?: number | null, room?: { id: number, roomNo: string } | null } | null> | null, pageInfo: { hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type GetSubRoomsQueryVariables = Exact<{
  lspId: Scalars['Int'];
  locId: Scalars['Int'];
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  orderClause?: InputMaybe<Array<TblBatchTraySortInput> | TblBatchTraySortInput>;
  whereClause: TblBatchTrayFilterInput;
}>;


export type GetSubRoomsQuery = { data?: { totalCount: number, items?: Array<{ id: number, lsp: number, lspLocation: number, trayNumber: string, width?: number | null, widthUnit?: number | null, length?: number | null, lengthUnit?: number | null, areaFt?: number | null, room?: { id: number, roomNo: string } | null } | null> | null, pageInfo: { hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type GetSubroomQueryVariables = Exact<{
  id: Scalars['Int'];
  lspId: Scalars['Int'];
  locId: Scalars['Int'];
}>;


export type GetSubroomQuery = { data?: { id: number, lsp: number, lspLocation: number, trayNumber: string, width?: number | null, widthUnit?: number | null, length?: number | null, lengthUnit?: number | null, areaFt?: number | null, room?: { id: number, roomNo: string } | null } | null };

export type TagAttributesV2Fragment = { tagId: number, tagName: string, smartTag?: { name?: string | null } | null };

export type TagAttributesFragment = { tagId: number, tagName: string };

export type AssociatedTagResourceCountsV2QueryVariables = Exact<{
  tagId: Scalars['Int'];
  lspId: Scalars['Int'];
}>;


export type AssociatedTagResourceCountsV2Query = { data?: { packageCount: number, productCount: number, inventoryDiscountCount: number, inventoryKitItemCount: number, productDiscountCount: number } | null };

export type AssociatedTagResourceCountsQueryVariables = Exact<{
  tagId: Scalars['Int'];
  lspId: Scalars['Int'];
}>;


export type AssociatedTagResourceCountsQuery = { data?: { packageCount: number, productCount: number, inventoryDiscountCount: number, productDiscountCount: number } | null };

export type GetTagsV2QueryVariables = Exact<{
  lspId: Scalars['Int'];
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  orderClause?: InputMaybe<Array<TagSortInput> | TagSortInput>;
  whereClause: TagFilterInput;
}>;


export type GetTagsV2Query = { data?: { totalCount: number, items?: Array<{ tagId: number, tagName: string, smartTag?: { name?: string | null } | null } | null> | null, pageInfo: { hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type GetTagsQueryVariables = Exact<{
  lspId: Scalars['Int'];
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  orderClause?: InputMaybe<Array<TagSortInput> | TagSortInput>;
  whereClause: TagFilterInput;
}>;


export type GetTagsQuery = { data?: { totalCount: number, items?: Array<{ tagId: number, tagName: string } | null> | null, pageInfo: { hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type GetTagV2QueryVariables = Exact<{
  lspId: Scalars['Int'];
  id: Scalars['Int'];
}>;


export type GetTagV2Query = { data?: { tagId: number, tagName: string, smartTag?: { name?: string | null } | null } | null };

export type GetTagQueryVariables = Exact<{
  lspId: Scalars['Int'];
  id: Scalars['Int'];
}>;


export type GetTagQuery = { data?: { tagId: number, tagName: string } | null };

export type UnitAttributesFragment = { units?: Array<{ abbreviation?: string | null, unitId: number, unitName: string, unitTypeId: number } | null> | null, unitTypes?: Array<{ unitTypeId: number, unitTypeName: string, unitTypeAbbreviation?: string | null } | null> | null };

export type GetUnitsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUnitsQuery = { data?: { units?: Array<{ abbreviation?: string | null, unitId: number, unitName: string, unitTypeId: number } | null> | null, unitTypes?: Array<{ unitTypeId: number, unitTypeName: string, unitTypeAbbreviation?: string | null } | null> | null } | null };

export type VendorAttributesFragment = { vendorName: string, id: number, vendorCode?: string | null, vendorAddr1: string, vendorCity: string, vendorState?: string | null, vendorPostalCode: string, countryId: number, contactName?: string | null, contactEmail?: string | null, contactPhone?: string | null, abbreviation?: string | null, vendorTypeId?: any | null, isActive: boolean, notes?: string | null };

export type GetVendorsQueryVariables = Exact<{
  lspId: Scalars['Int'];
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  orderClause?: InputMaybe<Array<TblVendorSortInput> | TblVendorSortInput>;
  whereClause: TblVendorFilterInput;
}>;


export type GetVendorsQuery = { data?: { totalCount: number, items?: Array<{ vendorName: string, id: number, vendorCode?: string | null, vendorAddr1: string, vendorCity: string, vendorState?: string | null, vendorPostalCode: string, countryId: number, contactName?: string | null, contactEmail?: string | null, contactPhone?: string | null, abbreviation?: string | null, vendorTypeId?: any | null, isActive: boolean, notes?: string | null } | null> | null, pageInfo: { hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type GetVendorQueryVariables = Exact<{
  id: Scalars['Int'];
  lspId: Scalars['Int'];
}>;


export type GetVendorQuery = { data?: { vendorName: string, id: number, vendorCode?: string | null, vendorAddr1: string, vendorCity: string, vendorState?: string | null, vendorPostalCode: string, countryId: number, contactName?: string | null, contactEmail?: string | null, contactPhone?: string | null, abbreviation?: string | null, vendorTypeId?: any | null, isActive: boolean, notes?: string | null } | null };

export type ZoneAttributesFragment = { maxRadius?: number | null, minRadius?: number | null, name: string, note?: string | null, zoneId: number, zoneType: number, counties?: Array<{ county?: { countyId: number, countyName: string, stateCode: string } | null } | null> | null, zipCodes?: Array<{ zipcode?: string | null } | null> | null, cities?: Array<{ cityName?: string | null } | null> | null };

export type GetZonesQueryVariables = Exact<{
  lspId: Scalars['Int'];
  locId: Scalars['Int'];
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  orderClause?: InputMaybe<Array<DeliveryZoneSortInput> | DeliveryZoneSortInput>;
  whereClause: DeliveryZoneFilterInput;
}>;


export type GetZonesQuery = { data?: { totalCount: number, items?: Array<{ maxRadius?: number | null, minRadius?: number | null, name: string, note?: string | null, zoneId: number, zoneType: number, counties?: Array<{ county?: { countyId: number, countyName: string, stateCode: string } | null } | null> | null, zipCodes?: Array<{ zipcode?: string | null } | null> | null, cities?: Array<{ cityName?: string | null } | null> | null } | null> | null } | null };

export type GetZoneQueryVariables = Exact<{
  lspId: Scalars['Int'];
  locId: Scalars['Int'];
  id: Scalars['Int'];
}>;


export type GetZoneQuery = { data?: { maxRadius?: number | null, minRadius?: number | null, name: string, note?: string | null, zoneId: number, zoneType: number, counties?: Array<{ county?: { countyId: number, countyName: string, stateCode: string } | null } | null> | null, zipCodes?: Array<{ zipcode?: string | null } | null> | null, cities?: Array<{ cityName?: string | null } | null> | null } | null };

export const AssemblyAttributesFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssemblyAttributes"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Assembly"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assemblyId"}},{"kind":"Field","name":{"kind":"Name","value":"assemblyStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assemblyStatusId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"billOfMaterials"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"billOfMaterialsId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"startedUtc"}},{"kind":"Field","name":{"kind":"Name","value":"completedUtc"}}]}}]} as unknown as DocumentNode<AssemblyAttributesFragment, unknown>;
export const AssemblyDetailAttributesFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssemblyDetailAttributes"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Assembly"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assemblyId"}},{"kind":"Field","name":{"kind":"Name","value":"assemblyStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assemblyStatusId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assemblyOutputItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assemblyInputItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assemblyInputItemId"}},{"kind":"Field","name":{"kind":"Name","value":"assemblyInputPackages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assemblyInputPackageId"}},{"kind":"Field","name":{"kind":"Name","value":"package"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"batch"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"batchLotNumber"}}]}},{"kind":"Field","name":{"kind":"Name","value":"packageId"}},{"kind":"Field","name":{"kind":"Name","value":"room"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"roomNo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"serialNumber"}},{"kind":"Field","name":{"kind":"Name","value":"unit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"abbreviation"}},{"kind":"Field","name":{"kind":"Name","value":"unitTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"unitId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cost"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"useByDate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}}]}},{"kind":"Field","name":{"kind":"Name","value":"inputItemTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"whseProductsDescription"}}]}},{"kind":"Field","name":{"kind":"Name","value":"productType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"productType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"skip"}},{"kind":"Field","name":{"kind":"Name","value":"unit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"abbreviation"}},{"kind":"Field","name":{"kind":"Name","value":"unitTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"unitId"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"assemblyOutputItemId"}},{"kind":"Field","name":{"kind":"Name","value":"batchId"}},{"kind":"Field","name":{"kind":"Name","value":"batch"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"batchLotNumber"}}]}},{"kind":"Field","name":{"kind":"Name","value":"bypassStateSystem"}},{"kind":"Field","name":{"kind":"Name","value":"cost"}},{"kind":"Field","name":{"kind":"Name","value":"expirationDateUtc"}},{"kind":"Field","name":{"kind":"Name","value":"inventoryStatusId"}},{"kind":"Field","name":{"kind":"Name","value":"isProductionBatch"}},{"kind":"Field","name":{"kind":"Name","value":"outputItemTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"packageDateUtc"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"sku"},"name":{"kind":"Name","value":"whseProductsProductNo"}},{"kind":"Field","alias":{"kind":"Name","value":"name"},"name":{"kind":"Name","value":"whseProductsDescription"}},{"kind":"Field","name":{"kind":"Name","value":"alternateDesc"}},{"kind":"Field","name":{"kind":"Name","value":"unitCost"}},{"kind":"Field","name":{"kind":"Name","value":"defaultUnit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unitId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"expirationDays"}},{"kind":"Field","name":{"kind":"Name","value":"alternateDesc"}},{"kind":"Field","name":{"kind":"Name","value":"strain"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"strainName"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"cost"},"name":{"kind":"Name","value":"unitCost"}}]}},{"kind":"Field","name":{"kind":"Name","value":"productType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"productType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tagId"}},{"kind":"Field","name":{"kind":"Name","value":"tagName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"actualQuantity"}},{"kind":"Field","name":{"kind":"Name","value":"roomId"}},{"kind":"Field","name":{"kind":"Name","value":"serialNumber"}},{"kind":"Field","name":{"kind":"Name","value":"skip"}},{"kind":"Field","name":{"kind":"Name","value":"sourceSerialNumber"}},{"kind":"Field","name":{"kind":"Name","value":"unit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"abbreviation"}},{"kind":"Field","name":{"kind":"Name","value":"unitTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"unitId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"costType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"costTypeId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"useByDate"}},{"kind":"Field","name":{"kind":"Name","value":"vendor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"vendorName"}},{"kind":"Field","name":{"kind":"Name","value":"vendorCode"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"billOfMaterials"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"billOfMaterialsId"}},{"kind":"Field","name":{"kind":"Name","value":"billOfMaterialsFiles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"billOfMaterialsFileId"}},{"kind":"Field","name":{"kind":"Name","value":"documentTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"documentName"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"fileName"}},{"kind":"Field","name":{"kind":"Name","value":"fileUrl"}},{"kind":"Field","name":{"kind":"Name","value":"userFileName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isProcessingJob"}},{"kind":"Field","name":{"kind":"Name","value":"metrcProcessingJobTypeTemplate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metrcProcessingJobTypeTemplateId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"categoryName"}},{"kind":"Field","name":{"kind":"Name","value":"processingSteps"}},{"kind":"Field","name":{"kind":"Name","value":"metrcProcessingJobTypeAttributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metrcProcessingJobTypeAttributeId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"estimatedStartDate"}}]}}]} as unknown as DocumentNode<AssemblyDetailAttributesFragment, unknown>;
export const AuditPackageAttributesFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AuditPackageAttributes"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FgreconDetail"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fgreconId"}},{"kind":"Field","name":{"kind":"Name","value":"package"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"batch"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"batchStrainNavigation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"strainName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"batchLotNumber"}}]}},{"kind":"Field","name":{"kind":"Name","value":"batchId"}},{"kind":"Field","name":{"kind":"Name","value":"expirationDate"}},{"kind":"Field","name":{"kind":"Name","value":"hasMultipleParentPackages"}},{"kind":"Field","name":{"kind":"Name","value":"inventoryStatusId"}},{"kind":"Field","name":{"kind":"Name","value":"packageId"}},{"kind":"Field","name":{"kind":"Name","value":"parentPackageSerialNumber"}},{"kind":"Field","name":{"kind":"Name","value":"room"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"roomNo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"roomId"}},{"kind":"Field","name":{"kind":"Name","value":"serialNumber"}},{"kind":"Field","name":{"kind":"Name","value":"sourceSerialNumber"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"unit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"abbreviation"}},{"kind":"Field","name":{"kind":"Name","value":"unitTypeId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"unitId"}},{"kind":"Field","name":{"kind":"Name","value":"vendorId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"reasonCode"}},{"kind":"Field","name":{"kind":"Name","value":"actualQty"}},{"kind":"Field","name":{"kind":"Name","value":"expectedQty"}},{"kind":"Field","name":{"kind":"Name","value":"updatedByNavigation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cannabisInventory"}},{"kind":"Field","name":{"kind":"Name","value":"productTypeNavigation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"strain"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"strainName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"brand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brandName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"whseProductsDescription"}},{"kind":"Field","name":{"kind":"Name","value":"whseProductsProductNo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","name":{"kind":"Name","value":"serialNo"}},{"kind":"Field","name":{"kind":"Name","value":"comment"}}]}}]} as unknown as DocumentNode<AuditPackageAttributesFragment, unknown>;
export const AuditAttributesFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AuditAttributes"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Fgrecon"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"discrepancies"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"inventoryAuditToBrands"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brandId"}},{"kind":"Field","name":{"kind":"Name","value":"brandName"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"inventoryAuditToCategories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"productType"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"inventoryAuditToRooms"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"room"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"roomNo"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"isBlind"}},{"kind":"Field","name":{"kind":"Name","value":"isDeleted"}},{"kind":"Field","name":{"kind":"Name","value":"masterCategory"}},{"kind":"Field","name":{"kind":"Name","value":"reconByNavigation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"reconCompletedUTC"}},{"kind":"Field","name":{"kind":"Name","value":"reconDate"}},{"kind":"Field","name":{"kind":"Name","value":"reconSubmittedByNavigation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"reconTotalFg"}},{"kind":"Field","name":{"kind":"Name","value":"scan"}},{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"statusId"}},{"kind":"Field","name":{"kind":"Name","value":"statusName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"workflow"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"workflowId"}},{"kind":"Field","name":{"kind":"Name","value":"workflowName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"loc"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lspLocationsName"}}]}}]}}]} as unknown as DocumentNode<AuditAttributesFragment, unknown>;
export const BatchesWithLabsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BatchesWithLabs"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TblBatch"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"batchLotNumber"}},{"kind":"Field","name":{"kind":"Name","value":"batchStrainNavigation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"strainName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"harvestCompletedOn"}},{"kind":"Field","name":{"kind":"Name","value":"lastModifiedDateUtc"}},{"kind":"Field","name":{"kind":"Name","value":"tblBatchThcs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"tchDate"},"value":{"kind":"EnumValue","value":"DESC"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"thcValue"}},{"kind":"Field","name":{"kind":"Name","value":"thcUnit"}},{"kind":"Field","name":{"kind":"Name","value":"cbdValue"}},{"kind":"Field","name":{"kind":"Name","value":"cbdUnit"}},{"kind":"Field","name":{"kind":"Name","value":"cbdaValue"}},{"kind":"Field","name":{"kind":"Name","value":"cbdaUnit"}},{"kind":"Field","name":{"kind":"Name","value":"thcaValue"}},{"kind":"Field","name":{"kind":"Name","value":"thcaUnit"}}]}}]}}]} as unknown as DocumentNode<BatchesWithLabsFragment, unknown>;
export const BomAttributesFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BOMAttributes"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BillOfMaterial"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"billOfMaterialsId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"createdOnUtc"}},{"kind":"Field","name":{"kind":"Name","value":"executionCount"}},{"kind":"Field","name":{"kind":"Name","value":"lastRanUtc"}},{"kind":"Field","name":{"kind":"Name","value":"isDeleted"}}]}}]} as unknown as DocumentNode<BomAttributesFragment, unknown>;
export const BomDetailAttributesFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BOMDetailAttributes"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BillOfMaterial"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"billOfMaterialsId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"executionCount"}},{"kind":"Field","name":{"kind":"Name","value":"laborHours"}},{"kind":"Field","name":{"kind":"Name","value":"laborRate"}},{"kind":"Field","name":{"kind":"Name","value":"isProcessingJob"}},{"kind":"Field","name":{"kind":"Name","value":"billOfMaterialsFiles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"billOfMaterialsFileId"}},{"kind":"Field","name":{"kind":"Name","value":"documentTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"documentName"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"fileName"}},{"kind":"Field","name":{"kind":"Name","value":"fileUrl"}},{"kind":"Field","name":{"kind":"Name","value":"userFileName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"billOfMaterialsImages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"imageFileName"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"billOfMaterialsOutputItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"billOfMaterialsOutputItemId"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"outputTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"unitId"}},{"kind":"Field","name":{"kind":"Name","value":"unit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"abbreviation"}},{"kind":"Field","name":{"kind":"Name","value":"unitId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"whseProductsDescription"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"unitCost"}},{"kind":"Field","name":{"kind":"Name","value":"alternateDesc"}},{"kind":"Field","alias":{"kind":"Name","value":"sku"},"name":{"kind":"Name","value":"whseProductsProductNo"}},{"kind":"Field","name":{"kind":"Name","value":"expirationDays"}},{"kind":"Field","name":{"kind":"Name","value":"vendorNavigation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"strain"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"strainName"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"productType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"productType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"billOfMaterialsInputItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"billOfMaterialsInputItemId"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"inputTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"unitId"}},{"kind":"Field","name":{"kind":"Name","value":"unit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"abbreviation"}},{"kind":"Field","name":{"kind":"Name","value":"unitId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"whseProductsDescription"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"productType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"productType"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"metrcProcessingJobTypeTemplate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metrcProcessingJobTypeTemplateId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"categoryName"}},{"kind":"Field","name":{"kind":"Name","value":"processingSteps"}},{"kind":"Field","name":{"kind":"Name","value":"metrcProcessingJobTypeAttributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metrcProcessingJobTypeAttributeId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<BomDetailAttributesFragment, unknown>;
export const BrandAttributesFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandAttributes"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Brand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brandCatalogBrandId"}},{"kind":"Field","name":{"kind":"Name","value":"brandId"}},{"kind":"Field","name":{"kind":"Name","value":"brandName"}},{"kind":"Field","name":{"kind":"Name","value":"isDeleted"}}]}}]} as unknown as DocumentNode<BrandAttributesFragment, unknown>;
export const CarAttributesFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CarAttributes"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TblMdcar"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bioTvcarId"}},{"kind":"Field","name":{"kind":"Name","value":"carColor"}},{"kind":"Field","name":{"kind":"Name","value":"carLicId"}},{"kind":"Field","name":{"kind":"Name","value":"carMake"}},{"kind":"Field","name":{"kind":"Name","value":"carModel"}},{"kind":"Field","name":{"kind":"Name","value":"carName"}},{"kind":"Field","name":{"kind":"Name","value":"carVin"}},{"kind":"Field","name":{"kind":"Name","value":"carYear"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isDeleted"}},{"kind":"Field","name":{"kind":"Name","value":"isOperatedByThirdParty"}},{"kind":"Field","name":{"kind":"Name","value":"stateCode"}},{"kind":"Field","name":{"kind":"Name","value":"thirdPartyLicenseNumber"}},{"kind":"Field","name":{"kind":"Name","value":"registerId"}},{"kind":"Field","name":{"kind":"Name","value":"register"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"terminalName"}},{"kind":"Field","name":{"kind":"Name","value":"isHidden"}}]}},{"kind":"Field","name":{"kind":"Name","value":"roomId"}},{"kind":"Field","name":{"kind":"Name","value":"room"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"roomNo"}},{"kind":"Field","name":{"kind":"Name","value":"isDeleted"}}]}}]}}]} as unknown as DocumentNode<CarAttributesFragment, unknown>;
export const DriverAttributesFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DriverAttributes"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TblMddriver"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bioTdriverAltId"}},{"kind":"Field","name":{"kind":"Name","value":"bioTdriverId"}},{"kind":"Field","name":{"kind":"Name","value":"driverDob"}},{"kind":"Field","name":{"kind":"Name","value":"driverEmail"}},{"kind":"Field","name":{"kind":"Name","value":"driverHireDt"}},{"kind":"Field","name":{"kind":"Name","value":"driverId"}},{"kind":"Field","name":{"kind":"Name","value":"driverName"}},{"kind":"Field","name":{"kind":"Name","value":"driverPhone"}},{"kind":"Field","name":{"kind":"Name","value":"driverPicture"}},{"kind":"Field","name":{"kind":"Name","value":"driverStateId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isOperatedByThirdParty"}},{"kind":"Field","name":{"kind":"Name","value":"stateCode"}},{"kind":"Field","name":{"kind":"Name","value":"thirdPartyLicenseNumber"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}}]}}]} as unknown as DocumentNode<DriverAttributesFragment, unknown>;
export const HarvestBatchesLiteAttributesFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"HarvestBatchesLiteAttributes"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TblBatch"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"batchLotNumber"}},{"kind":"Field","name":{"kind":"Name","value":"harvestUnitId"}},{"kind":"Field","name":{"kind":"Name","value":"batchStrainNavigation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"strainName"}}]}}]}}]} as unknown as DocumentNode<HarvestBatchesLiteAttributesFragment, unknown>;
export const InventoryPackageAttributesFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InventoryPackageAttributes"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Package"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"packageId"}},{"kind":"Field","name":{"kind":"Name","value":"allocatedInventorySum"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"skip"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"excludeAllocatedInventorySum"}}}]}]},{"kind":"Field","name":{"kind":"Name","value":"isOnHold"}},{"kind":"Field","name":{"kind":"Name","value":"isOnRecall"}},{"kind":"Field","name":{"kind":"Name","value":"lastDatePackageAuditedUtc"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"skip"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"excludeLastDatePackageAuditedUtc"}}}]}]},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"posproducts"}},{"kind":"Field","name":{"kind":"Name","value":"lastAuditedDateUtc"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"skip"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"excludeLastAuditedDateUtc"}}}]}]},{"kind":"Field","name":{"kind":"Name","value":"whseProductsDescription"}},{"kind":"Field","name":{"kind":"Name","value":"productImageFileNameProcessed"}},{"kind":"Field","name":{"kind":"Name","value":"whseProductsProductNo"}},{"kind":"Field","name":{"kind":"Name","value":"defaultUnitId"}},{"kind":"Field","name":{"kind":"Name","value":"grossWeight"}},{"kind":"Field","name":{"kind":"Name","value":"flowerEquivalent"}},{"kind":"Field","name":{"kind":"Name","value":"recFlowerEquivalent"}},{"kind":"Field","name":{"kind":"Name","value":"whseProductsUnitPrice"}},{"kind":"Field","name":{"kind":"Name","value":"whseProductsRecUnitPrice"}},{"kind":"Field","name":{"kind":"Name","value":"lowInventoryThreshold"}},{"kind":"Field","name":{"kind":"Name","value":"productGrams"}},{"kind":"Field","name":{"kind":"Name","value":"productTypeNavigation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"productType"}},{"kind":"Field","name":{"kind":"Name","value":"masterCategory"}}]}},{"kind":"Field","name":{"kind":"Name","value":"productToCustomerTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customerType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customerTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"customerTypeName"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"unitType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unitTypeAbbreviation"}},{"kind":"Field","name":{"kind":"Name","value":"unitTypeName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"strain"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"strainName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"brand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brandName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sizeListItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cannabisInventory"}},{"kind":"Field","name":{"kind":"Name","value":"alternateDesc"}},{"kind":"Field","name":{"kind":"Name","value":"couponItem"}},{"kind":"Field","name":{"kind":"Name","value":"isNutrient"}},{"kind":"Field","name":{"kind":"Name","value":"onlineProduct"}},{"kind":"Field","name":{"kind":"Name","value":"isRetired"}},{"kind":"Field","name":{"kind":"Name","value":"isOnSale"}},{"kind":"Field","name":{"kind":"Name","value":"itemTaxable"}},{"kind":"Field","name":{"kind":"Name","value":"onlineTitle"}},{"kind":"Field","name":{"kind":"Name","value":"onlineDescription"}},{"kind":"Field","name":{"kind":"Name","value":"productImageFileName"}},{"kind":"Field","name":{"kind":"Name","value":"externalCategory"}},{"kind":"Field","name":{"kind":"Name","value":"instructions"}},{"kind":"Field","name":{"kind":"Name","value":"allergenList"}},{"kind":"Field","name":{"kind":"Name","value":"ingredientList"}},{"kind":"Field","name":{"kind":"Name","value":"prescription"}},{"kind":"Field","name":{"kind":"Name","value":"approvalDateUTC"}}]}},{"kind":"Field","name":{"kind":"Name","value":"locationProductMaster"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"recPrice"}},{"kind":"Field","name":{"kind":"Name","value":"lowInventoryThreshold"}},{"kind":"Field","name":{"kind":"Name","value":"onlineAvailable"}},{"kind":"Field","name":{"kind":"Name","value":"posAvailable"}}]}},{"kind":"Field","name":{"kind":"Name","value":"serialNumber"}},{"kind":"Field","name":{"kind":"Name","value":"inventoryStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"invStatusDesc"}}]}},{"kind":"Field","name":{"kind":"Name","value":"batch"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"lot"},"name":{"kind":"Name","value":"batchLotNumber"}},{"kind":"Field","name":{"kind":"Name","value":"batchLotNumber"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"harvestCompletedOn"}},{"kind":"Field","name":{"kind":"Name","value":"tblBatchThcs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"tchDate"},"value":{"kind":"EnumValue","value":"DESC"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"thcValue"}},{"kind":"Field","name":{"kind":"Name","value":"thcUnit"}},{"kind":"Field","name":{"kind":"Name","value":"cbdValue"}},{"kind":"Field","name":{"kind":"Name","value":"cbdUnit"}},{"kind":"Field","name":{"kind":"Name","value":"cbdaValue"}},{"kind":"Field","name":{"kind":"Name","value":"cbdaUnit"}},{"kind":"Field","name":{"kind":"Name","value":"cbnValue"}},{"kind":"Field","name":{"kind":"Name","value":"cbnUnit"}},{"kind":"Field","name":{"kind":"Name","value":"thcaValue"}},{"kind":"Field","name":{"kind":"Name","value":"thcaUnit"}},{"kind":"Field","name":{"kind":"Name","value":"thc9Value"}},{"kind":"Field","name":{"kind":"Name","value":"thc9Unit"}}]}},{"kind":"Field","name":{"kind":"Name","value":"batchStrainNavigation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"strainName"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"vendor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"vendorName"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"vendorCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"room"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"roomNo"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"unit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"abbreviation"}},{"kind":"Field","name":{"kind":"Name","value":"unitTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"unitId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"inventorySourceBatches"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sourceBatch"}}]}},{"kind":"Field","name":{"kind":"Name","value":"table"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"trayNumber"}}]}},{"kind":"Field","name":{"kind":"Name","value":"producerId"}},{"kind":"Field","name":{"kind":"Name","value":"producer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"producerName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"packageToTags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tag"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tagId"}},{"kind":"Field","name":{"kind":"Name","value":"tagName"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"loc"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"whichUnitCost"}},{"kind":"Field","name":{"kind":"Name","value":"whichUnitPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"expirationDate"}},{"kind":"Field","name":{"kind":"Name","value":"inventoryStatusId"}},{"kind":"Field","name":{"kind":"Name","value":"packageWeight"}},{"kind":"Field","name":{"kind":"Name","value":"netWeight"}},{"kind":"Field","name":{"kind":"Name","value":"netWeightUnit"}},{"kind":"Field","name":{"kind":"Name","value":"flowerEquivalent"}},{"kind":"Field","name":{"kind":"Name","value":"recFlowerEquivalent"}},{"kind":"Field","name":{"kind":"Name","value":"productWeight"}},{"kind":"Field","name":{"kind":"Name","value":"unitPrice"}},{"kind":"Field","name":{"kind":"Name","value":"recUnitPrice"}},{"kind":"Field","name":{"kind":"Name","value":"cost"}},{"kind":"Field","name":{"kind":"Name","value":"receivedDate"}},{"kind":"Field","name":{"kind":"Name","value":"sourceSerialNumber"}},{"kind":"Field","name":{"kind":"Name","value":"medicalOnly"}},{"kind":"Field","name":{"kind":"Name","value":"metrclabTestingStatus"}},{"kind":"Field","name":{"kind":"Name","value":"bioTrackQAStatus"}},{"kind":"Field","name":{"kind":"Name","value":"packagedDate"}},{"kind":"Field","name":{"kind":"Name","value":"manufacturingDate"}},{"kind":"Field","name":{"kind":"Name","value":"iltaxCategory"}},{"kind":"Field","name":{"kind":"Name","value":"cultivationTax"}},{"kind":"Field","name":{"kind":"Name","value":"exciseTax"}},{"kind":"Field","name":{"kind":"Name","value":"isFinishedInIntegration"}},{"kind":"Field","name":{"kind":"Name","value":"tableId"}},{"kind":"Field","name":{"kind":"Name","value":"potencyIndicator"}},{"kind":"Field","name":{"kind":"Name","value":"packageNdc"}},{"kind":"Field","name":{"kind":"Name","value":"effectivePotencyMg"}},{"kind":"Field","name":{"kind":"Name","value":"useByDate"}},{"kind":"Field","name":{"kind":"Name","value":"parentPackageSerialNumber"}},{"kind":"Field","name":{"kind":"Name","value":"hasMultipleParentPackages"}},{"kind":"Field","name":{"kind":"Name","value":"isSample"}},{"kind":"Field","name":{"kind":"Name","value":"packageToCustomerTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customerType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customerTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"customerTypeName"}}]}}]}}]}}]} as unknown as DocumentNode<InventoryPackageAttributesFragment, unknown>;
export const InventoryPackageAttributesV2FragmentDoc = {"kind":"Document", "definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InventoryPackageAttributesV2"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Package"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InventoryPackageAttributes"}},{"kind":"Field","name":{"kind":"Name","value":"packageGroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"packageGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"packageItemLabels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"itemLabel"}}]}}]}}]}},...InventoryPackageAttributesFragmentDoc.definitions]} as unknown as DocumentNode<InventoryPackageAttributesV2Fragment, unknown>;
export const InventoryPackageAttributesV3FragmentDoc = {"kind":"Document", "definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InventoryPackageAttributesV3"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Package"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InventoryPackageAttributesV2"}},{"kind":"Field","name":{"kind":"Name","value":"packageToTags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tag"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tagId"}},{"kind":"Field","name":{"kind":"Name","value":"tagName"}},{"kind":"Field","name":{"kind":"Name","value":"smartTag"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}},...InventoryPackageAttributesV2FragmentDoc.definitions]} as unknown as DocumentNode<InventoryPackageAttributesV3Fragment, unknown>;
export const PackageDropDownAttributesFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PackageDropDownAttributes"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Package"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"batch"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"batchName"},"name":{"kind":"Name","value":"batchLotNumber"}}]}},{"kind":"Field","name":{"kind":"Name","value":"packageId"}},{"kind":"Field","name":{"kind":"Name","value":"room"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"roomNo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"serialNumber"}},{"kind":"Field","name":{"kind":"Name","value":"unit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"abbreviation"}},{"kind":"Field","name":{"kind":"Name","value":"unitTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"unitId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"useByDate"}},{"kind":"Field","name":{"kind":"Name","value":"cost"}}]}}]} as unknown as DocumentNode<PackageDropDownAttributesFragment, unknown>;
export const ProductAttributesFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductAttributes"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TblWhseProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isRetired"}},{"kind":"Field","name":{"kind":"Name","value":"whseProductsProductNo"}},{"kind":"Field","name":{"kind":"Name","value":"whseProductsDescription"}},{"kind":"Field","name":{"kind":"Name","value":"brand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brandId"}},{"kind":"Field","name":{"kind":"Name","value":"brandName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vendorNavigation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"vendorName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"strain"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"strainName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"unitType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unitTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"unitTypeName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"defaultUnit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unitId"}},{"kind":"Field","name":{"kind":"Name","value":"unitName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"productToTags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tag"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tagId"}},{"kind":"Field","name":{"kind":"Name","value":"tagName"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"sizeListItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"dosage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<ProductAttributesFragment, unknown>;
export const ProductDropDownAttributesFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductDropDownAttributes"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TblWhseProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isRetired"}},{"kind":"Field","alias":{"kind":"Name","value":"sku"},"name":{"kind":"Name","value":"whseProductsProductNo"}},{"kind":"Field","alias":{"kind":"Name","value":"name"},"name":{"kind":"Name","value":"whseProductsDescription"}},{"kind":"Field","name":{"kind":"Name","value":"alternateDesc"}},{"kind":"Field","name":{"kind":"Name","value":"strain"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"strainName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"expirationDays"}},{"kind":"Field","name":{"kind":"Name","value":"defaultUnit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unitId"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"cost"},"name":{"kind":"Name","value":"unitCost"}},{"kind":"Field","name":{"kind":"Name","value":"vendorNavigation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"vendorName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"productToTags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tag"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tagId"}},{"kind":"Field","name":{"kind":"Name","value":"tagName"}}]}}]}}]}}]} as unknown as DocumentNode<ProductDropDownAttributesFragment, unknown>;
export const InventoryStatusAttributeFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InventoryStatusAttribute"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TblInventoryStatus"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"invStatusDesc"}}]}}]} as unknown as DocumentNode<InventoryStatusAttributeFragment, unknown>;
export const PlantAttributesFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PlantAttributes"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TblMdbatchPlantId"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lspId"}},{"kind":"Field","name":{"kind":"Name","value":"locId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"plantSerialNo"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"plantGroup"}},{"kind":"Field","name":{"kind":"Name","value":"plantGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"addedToHarvestOn"}},{"kind":"Field","name":{"kind":"Name","value":"cuttingsComment"}},{"kind":"Field","name":{"kind":"Name","value":"plantType"}},{"kind":"Field","name":{"kind":"Name","value":"pcounter"}},{"kind":"Field","name":{"kind":"Name","value":"currentRoomNavigation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"roomNo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"currentTrayNavigation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"trayNumber"}}]}},{"kind":"Field","name":{"kind":"Name","value":"growthPhases"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"plantStageTransitionId"}},{"kind":"Field","name":{"kind":"Name","value":"plantId"}},{"kind":"Field","name":{"kind":"Name","value":"fromStage"}},{"kind":"Field","name":{"kind":"Name","value":"toStage"}},{"kind":"Field","name":{"kind":"Name","value":"transitionDateUtc"}},{"kind":"Field","name":{"kind":"Name","value":"plantTransactionId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"roomHistory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"moveDateTime"}},{"kind":"Field","name":{"kind":"Name","value":"table"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"trayNumber"}}]}},{"kind":"Field","name":{"kind":"Name","value":"room"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"roomNo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userName"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"locationName"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lspLocationsName"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"nutrientLog"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"plantId"}},{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"unitId"}},{"kind":"Field","name":{"kind":"Name","value":"appliedBy"}},{"kind":"Field","name":{"kind":"Name","value":"appliedOnUtc"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"whseProductsDescription"}}]}},{"kind":"Field","name":{"kind":"Name","value":"appliedByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"harvestDate"}},{"kind":"Field","name":{"kind":"Name","value":"motherPlant"}},{"kind":"Field","name":{"kind":"Name","value":"motherPlantId"}},{"kind":"Field","name":{"kind":"Name","value":"motherPlantData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"plantSerialNo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"plantStage"}},{"kind":"Field","name":{"kind":"Name","value":"currentRoom"}},{"kind":"Field","name":{"kind":"Name","value":"currentTray"}},{"kind":"Field","name":{"kind":"Name","value":"createDt"}},{"kind":"Field","name":{"kind":"Name","value":"plantDestroyedDate"}},{"kind":"Field","name":{"kind":"Name","value":"plantDestroyedComment"}},{"kind":"Field","name":{"kind":"Name","value":"batchId"}},{"kind":"Field","name":{"kind":"Name","value":"bioTplantBarcodeId"}},{"kind":"Field","name":{"kind":"Name","value":"trimDate"}},{"kind":"Field","name":{"kind":"Name","value":"trimWasteWgt"}},{"kind":"Field","name":{"kind":"Name","value":"bornDate"}},{"kind":"Field","name":{"kind":"Name","value":"budWgt"}},{"kind":"Field","name":{"kind":"Name","value":"metrcWeights"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metrcReportedWeight"}},{"kind":"Field","name":{"kind":"Name","value":"metrcReportedWeightStatus"}},{"kind":"Field","name":{"kind":"Name","value":"metrcReportedWeightDate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"plantPhaseResults"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"floweringStartedOn"}},{"kind":"Field","name":{"kind":"Name","value":"floweringEndedOn"}},{"kind":"Field","name":{"kind":"Name","value":"vegetationStartedOn"}},{"kind":"Field","name":{"kind":"Name","value":"vegetationEndedOn"}},{"kind":"Field","name":{"kind":"Name","value":"daysInFlowering"}},{"kind":"Field","name":{"kind":"Name","value":"daysInVegetation"}},{"kind":"Field","name":{"kind":"Name","value":"daysInCurrentPhase"}}]}},{"kind":"Field","name":{"kind":"Name","value":"plantStatus"}},{"kind":"Field","name":{"kind":"Name","value":"weekPlanted"}},{"kind":"Field","name":{"kind":"Name","value":"strain"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"strainName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"batch"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"batchLotNumber"}},{"kind":"Field","name":{"kind":"Name","value":"projectedYield"}},{"kind":"Field","name":{"kind":"Name","value":"projectedYieldUnitId"}},{"kind":"Field","name":{"kind":"Name","value":"projectedHarvestDate"}},{"kind":"Field","name":{"kind":"Name","value":"batchStrainNavigation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"strainName"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tagId"}},{"kind":"Field","name":{"kind":"Name","value":"lspId"}}]}}]}}]} as unknown as DocumentNode<PlantAttributesFragment, unknown>;
export const ProducerAttributesFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProducerAttributes"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Producer"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"producerId"}},{"kind":"Field","name":{"kind":"Name","value":"producerName"}},{"kind":"Field","name":{"kind":"Name","value":"isDeleted"}}]}}]} as unknown as DocumentNode<ProducerAttributesFragment, unknown>;
export const ProductCategoryAttributesFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductCategoryAttributes"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TblWhseProductType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"flowerEquivalent"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"leafLinkCategoryId"}},{"kind":"Field","name":{"kind":"Name","value":"leafLinkSubCategoryId"}},{"kind":"Field","name":{"kind":"Name","value":"leaflyCategory"}},{"kind":"Field","name":{"kind":"Name","value":"ecomCategory"}},{"kind":"Field","name":{"kind":"Name","value":"ecomSubcategory"}},{"kind":"Field","name":{"kind":"Name","value":"masterCategory"}},{"kind":"Field","name":{"kind":"Name","value":"mmurforms"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"formId"}},{"kind":"Field","name":{"kind":"Name","value":"form"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mmurformId"}},{"kind":"Field","name":{"kind":"Name","value":"productFlag"}},{"kind":"Field","name":{"kind":"Name","value":"productTaxCategories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productTaxCategoryId"}},{"kind":"Field","name":{"kind":"Name","value":"productTaxCategory1"}}]}},{"kind":"Field","name":{"kind":"Name","value":"productType"}},{"kind":"Field","name":{"kind":"Name","value":"productTypeToRevenueAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"purchaseLimitCategoryId"}},{"kind":"Field","name":{"kind":"Name","value":"recFlowerEquivalent"}},{"kind":"Field","name":{"kind":"Name","value":"regulatoryCategoryId"}},{"kind":"Field","name":{"kind":"Name","value":"stateInventoryFlag"}},{"kind":"Field","name":{"kind":"Name","value":"weedMapsCategoryId"}},{"kind":"Field","name":{"kind":"Name","value":"weedMapsSubCategoryId"}}]}}]} as unknown as DocumentNode<ProductCategoryAttributesFragment, unknown>;
export const CategoryAttributesFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CategoryAttributes"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TblWhseProductType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"productType"}},{"kind":"Field","name":{"kind":"Name","value":"masterCategory"}}]}}]} as unknown as DocumentNode<CategoryAttributesFragment, unknown>;
export const RoomAttributesFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RoomAttributes"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TblBatchRoom"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"checkOutRoom"}},{"kind":"Field","name":{"kind":"Name","value":"cultivationStage"}},{"kind":"Field","name":{"kind":"Name","value":"dispensaryLimitedroom"}},{"kind":"Field","name":{"kind":"Name","value":"dispensaryRestrictedRoom"}},{"kind":"Field","name":{"kind":"Name","value":"ecommerceRoom"}},{"kind":"Field","name":{"kind":"Name","value":"examRoom"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"inspectionRoom"}},{"kind":"Field","name":{"kind":"Name","value":"inventoryRoom"}},{"kind":"Field","name":{"kind":"Name","value":"locationType"}},{"kind":"Field","name":{"kind":"Name","value":"medicationRoom"}},{"kind":"Field","name":{"kind":"Name","value":"roomToMenus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"menuName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"posRoom"}},{"kind":"Field","name":{"kind":"Name","value":"preOrderRoom"}},{"kind":"Field","name":{"kind":"Name","value":"publishToMenus"}},{"kind":"Field","name":{"kind":"Name","value":"quarantineRoom"}},{"kind":"Field","name":{"kind":"Name","value":"roomArea"}},{"kind":"Field","name":{"kind":"Name","value":"roomAreaUnits"}},{"kind":"Field","name":{"kind":"Name","value":"roomNo"}},{"kind":"Field","name":{"kind":"Name","value":"roomPurpose"}},{"kind":"Field","name":{"kind":"Name","value":"roomTerminals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"terminal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"terminalName"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"vaultRoom"}},{"kind":"Field","name":{"kind":"Name","value":"waitingRoom"}}]}}]} as unknown as DocumentNode<RoomAttributesFragment, unknown>;
export const StrainAttributesFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StrainAttributes"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TblBatchStrain"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"strainDescription"}},{"kind":"Field","name":{"kind":"Name","value":"strainName"}},{"kind":"Field","name":{"kind":"Name","value":"strainNo"}},{"kind":"Field","name":{"kind":"Name","value":"strainType"}}]}}]} as unknown as DocumentNode<StrainAttributesFragment, unknown>;
export const SubroomAttributesFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SubroomAttributes"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TblBatchTray"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lsp"}},{"kind":"Field","name":{"kind":"Name","value":"lspLocation"}},{"kind":"Field","name":{"kind":"Name","value":"trayNumber"}},{"kind":"Field","name":{"kind":"Name","value":"room"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"roomNo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"widthUnit"}},{"kind":"Field","name":{"kind":"Name","value":"length"}},{"kind":"Field","name":{"kind":"Name","value":"lengthUnit"}},{"kind":"Field","name":{"kind":"Name","value":"areaFt"}}]}}]} as unknown as DocumentNode<SubroomAttributesFragment, unknown>;
export const TagAttributesV2FragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TagAttributesV2"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Tag"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tagId"}},{"kind":"Field","name":{"kind":"Name","value":"tagName"}},{"kind":"Field","name":{"kind":"Name","value":"smartTag"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<TagAttributesV2Fragment, unknown>;
export const TagAttributesFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TagAttributes"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Tag"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tagId"}},{"kind":"Field","name":{"kind":"Name","value":"tagName"}}]}}]} as unknown as DocumentNode<TagAttributesFragment, unknown>;
export const UnitAttributesFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UnitAttributes"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UnitsResponse"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"units"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"abbreviation"}},{"kind":"Field","name":{"kind":"Name","value":"unitId"}},{"kind":"Field","name":{"kind":"Name","value":"unitName"}},{"kind":"Field","name":{"kind":"Name","value":"unitTypeId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"unitTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unitTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"unitTypeName"}},{"kind":"Field","name":{"kind":"Name","value":"unitTypeAbbreviation"}}]}}]}}]} as unknown as DocumentNode<UnitAttributesFragment, unknown>;
export const VendorAttributesFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VendorAttributes"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TblVendor"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"vendorName"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"vendorCode"}},{"kind":"Field","name":{"kind":"Name","value":"vendorAddr1"}},{"kind":"Field","name":{"kind":"Name","value":"vendorCity"}},{"kind":"Field","name":{"kind":"Name","value":"vendorState"}},{"kind":"Field","name":{"kind":"Name","value":"vendorPostalCode"}},{"kind":"Field","name":{"kind":"Name","value":"countryId"}},{"kind":"Field","name":{"kind":"Name","value":"contactName"}},{"kind":"Field","name":{"kind":"Name","value":"contactEmail"}},{"kind":"Field","name":{"kind":"Name","value":"contactPhone"}},{"kind":"Field","name":{"kind":"Name","value":"abbreviation"}},{"kind":"Field","name":{"kind":"Name","value":"vendorTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}}]}}]} as unknown as DocumentNode<VendorAttributesFragment, unknown>;
export const ZoneAttributesFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ZoneAttributes"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DeliveryZone"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"maxRadius"}},{"kind":"Field","name":{"kind":"Name","value":"minRadius"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"zoneId"}},{"kind":"Field","name":{"kind":"Name","value":"zoneType"}},{"kind":"Field","name":{"kind":"Name","value":"counties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"county"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"countyId"}},{"kind":"Field","name":{"kind":"Name","value":"countyName"}},{"kind":"Field","name":{"kind":"Name","value":"stateCode"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"zipCodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"zipcode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cityName"}}]}}]}}]} as unknown as DocumentNode<ZoneAttributesFragment, unknown>;
export const GetAssembliesDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getAssemblies"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lspId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderClause"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AssemblySortInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"whereClause"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AssemblyFilterInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"data"},"name":{"kind":"Name","value":"assemblies"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"whereClause"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderClause"}}},{"kind":"Argument","name":{"kind":"Name","value":"lspId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lspId"}}},{"kind":"Argument","name":{"kind":"Name","value":"locId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssemblyAttributes"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}},...AssemblyAttributesFragmentDoc.definitions]} as unknown as DocumentNode<GetAssembliesQuery, GetAssembliesQueryVariables>;
export const GetAssemblyDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getAssembly"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lspId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"data"},"name":{"kind":"Name","value":"assembly"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"lspId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lspId"}}},{"kind":"Argument","name":{"kind":"Name","value":"locId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssemblyDetailAttributes"}}]}}]}},...AssemblyDetailAttributesFragmentDoc.definitions]} as unknown as DocumentNode<GetAssemblyQuery, GetAssemblyQueryVariables>;
export const GetAuditPackageIdsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getAuditPackageIds"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lspId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fgreconId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"data"},"name":{"kind":"Name","value":"auditPackages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"fgreconId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fgreconId"}}},{"kind":"Argument","name":{"kind":"Name","value":"lspId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lspId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"packageId"}}]}}]}}]}}]} as unknown as DocumentNode<GetAuditPackageIdsQuery, GetAuditPackageIdsQueryVariables>;
export const GetAuditPackagesDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getAuditPackages"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lspId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fgreconId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isComplete"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"hasDiscrepancy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderClause"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FgreconDetailSortInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"whereClause"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FgreconDetailFilterInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"data"},"name":{"kind":"Name","value":"auditPackages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"whereClause"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderClause"}}},{"kind":"Argument","name":{"kind":"Name","value":"fgreconId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fgreconId"}}},{"kind":"Argument","name":{"kind":"Name","value":"isComplete"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isComplete"}}},{"kind":"Argument","name":{"kind":"Name","value":"hasDiscrepancy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"hasDiscrepancy"}}},{"kind":"Argument","name":{"kind":"Name","value":"lspId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lspId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AuditPackageAttributes"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}},...AuditPackageAttributesFragmentDoc.definitions]} as unknown as DocumentNode<GetAuditPackagesQuery, GetAuditPackagesQueryVariables>;
export const GetAuditStatusesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getAuditStatuses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"data"},"name":{"kind":"Name","value":"auditStatuses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"statusId"}},{"kind":"Field","name":{"kind":"Name","value":"statusName"}}]}}]}}]}}]} as unknown as DocumentNode<GetAuditStatusesQuery, GetAuditStatusesQueryVariables>;
export const AuditHasNegativePackageUpdatesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"auditHasNegativePackageUpdates"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"auditId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lspId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"data"},"name":{"kind":"Name","value":"auditHasNegativePackageUpdates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"auditId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"auditId"}}},{"kind":"Argument","name":{"kind":"Name","value":"lspId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lspId"}}}]}]}}]} as unknown as DocumentNode<AuditHasNegativePackageUpdatesQuery, AuditHasNegativePackageUpdatesQueryVariables>;
export const GetAuditsDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getAudits"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lspId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderClause"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FgreconSortInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"whereClause"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FgreconFilterInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"data"},"name":{"kind":"Name","value":"audits"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"whereClause"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderClause"}}},{"kind":"Argument","name":{"kind":"Name","value":"lspId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lspId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AuditAttributes"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}},...AuditAttributesFragmentDoc.definitions]} as unknown as DocumentNode<GetAuditsQuery, GetAuditsQueryVariables>;
export const GetAuditDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getAudit"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lspId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"data"},"name":{"kind":"Name","value":"audit"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"lspId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lspId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AuditAttributes"}}]}}]}},...AuditAttributesFragmentDoc.definitions]} as unknown as DocumentNode<GetAuditQuery, GetAuditQueryVariables>;
export const AddPackageToAuditDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddPackageToAudit"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AddPackageToAuditInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addPackageToAudit"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"packageId"}},{"kind":"Field","name":{"kind":"Name","value":"auditDetailId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<AddPackageToAuditMutation, AddPackageToAuditMutationVariables>;
export const BulkConfirmCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"bulkConfirmCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BulkConfirmCountInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bulkConfirmCount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bulkConfirmCountOutput"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalRecordsUpdated"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"code"},"name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PackageQuantityChangedError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"updatedPackageQuantities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Error"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]}}]} as unknown as DocumentNode<BulkConfirmCountMutation, BulkConfirmCountMutationVariables>;
export const BulkUpdateAuditDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"BulkUpdateAuditDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BulkUpdateAuditDetailsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bulkUpdateAuditDetails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"result"}}]}}]}}]} as unknown as DocumentNode<BulkUpdateAuditDetailsMutation, BulkUpdateAuditDetailsMutationVariables>;
export const CloseAuditDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CloseAudit"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CloseAuditInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"closeAudit"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"auditId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"result"}}]}}]}}]} as unknown as DocumentNode<CloseAuditMutation, CloseAuditMutationVariables>;
export const CreateAuditFromPackagesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateAuditFromPackages"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateAuditFromPackagesInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createAuditFromPackages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"auditDetailCount"}},{"kind":"Field","name":{"kind":"Name","value":"auditId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"result"}}]}}]}}]} as unknown as DocumentNode<CreateAuditFromPackagesMutation, CreateAuditFromPackagesMutationVariables>;
export const CreateAuditDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateAudit"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateAuditInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createAudit"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"result"}}]}}]}}]} as unknown as DocumentNode<CreateAuditMutation, CreateAuditMutationVariables>;
export const DeleteAuditDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteAudit"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteAuditStatusInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteAudit"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"result"}}]}}]}}]} as unknown as DocumentNode<DeleteAuditMutation, DeleteAuditMutationVariables>;
export const RemovePackageFromAuditDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RemovePackageFromAudit"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"RemovePackageFromAuditInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removePackageFromAudit"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"auditDetailId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<RemovePackageFromAuditMutation, RemovePackageFromAuditMutationVariables>;
export const SubmitAuditForReviewDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SubmitAuditForReview"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"SubmitAuditForReviewInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"submitAuditForReview"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"result"}}]}}]}}]} as unknown as DocumentNode<SubmitAuditForReviewMutation, SubmitAuditForReviewMutationVariables>;
export const UpdateAuditDetailDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateAuditDetail"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateAuditDetailInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateAuditDetail"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"actualQty"}},{"kind":"Field","name":{"kind":"Name","value":"expectedQty"}},{"kind":"Field","name":{"kind":"Name","value":"reasonCode"}},{"kind":"Field","name":{"kind":"Name","value":"comment"}},{"kind":"Field","name":{"kind":"Name","value":"isDeleted"}},{"kind":"Field","name":{"kind":"Name","value":"serialNo"}},{"kind":"Field","name":{"kind":"Name","value":"lastAuditedDateUtc"}},{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","name":{"kind":"Name","value":"packageId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"result"}}]}}]}}]} as unknown as DocumentNode<UpdateAuditDetailMutation, UpdateAuditDetailMutationVariables>;
export const UpdateAuditDetailsViaCsvDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateAuditDetailsViaCsv"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateAuditDetailsViaCsvInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateAuditDetailsViaCsv"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"auditId"}},{"kind":"Field","name":{"kind":"Name","value":"totalRows"}},{"kind":"Field","name":{"kind":"Name","value":"totalUpdated"}},{"kind":"Field","name":{"kind":"Name","value":"totalFailed"}},{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"result"}}]}}]}}]} as unknown as DocumentNode<UpdateAuditDetailsViaCsvMutation, UpdateAuditDetailsViaCsvMutationVariables>;
export const UpdateAuditPackageCountDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateAuditPackageCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdatePackageCountInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateAuditPackageCount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AuditPackageAttributes"}}]}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"result"}}]}}]}},...AuditPackageAttributesFragmentDoc.definitions]} as unknown as DocumentNode<UpdateAuditPackageCountMutation, UpdateAuditPackageCountMutationVariables>;
export const UpdateAuditStatusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateAuditStatus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateAuditStatusInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateAuditStatus"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"result"}}]}}]}}]} as unknown as DocumentNode<UpdateAuditStatusMutation, UpdateAuditStatusMutationVariables>;
export const GetBatchesWithLabsDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getBatchesWithLabs"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lspId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderClause"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TblBatchSortInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"whereClause"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TblBatchFilterInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"data"},"name":{"kind":"Name","value":"batches"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"whereClause"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderClause"}}},{"kind":"Argument","name":{"kind":"Name","value":"locId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locId"}}},{"kind":"Argument","name":{"kind":"Name","value":"lspId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lspId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BatchesWithLabs"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}},...BatchesWithLabsFragmentDoc.definitions]} as unknown as DocumentNode<GetBatchesWithLabsQuery, GetBatchesWithLabsQueryVariables>;
export const GetBillOfMaterialsDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getBillOfMaterials"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lspId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderClause"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BillOfMaterialSortInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"whereClause"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BillOfMaterialFilterInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"data"},"name":{"kind":"Name","value":"billOfMaterials"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"whereClause"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderClause"}}},{"kind":"Argument","name":{"kind":"Name","value":"lspId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lspId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BOMAttributes"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}},...BomAttributesFragmentDoc.definitions]} as unknown as DocumentNode<GetBillOfMaterialsQuery, GetBillOfMaterialsQueryVariables>;
export const GetBillOfMaterialDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getBillOfMaterial"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lspId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"data"},"name":{"kind":"Name","value":"billOfMaterial"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"lspId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lspId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BOMDetailAttributes"}}]}}]}},...BomDetailAttributesFragmentDoc.definitions]} as unknown as DocumentNode<GetBillOfMaterialQuery, GetBillOfMaterialQueryVariables>;
export const GetBrandsDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getBrands"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lspId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"whereClause"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BrandFilterInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderClause"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BrandSortInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"data"},"name":{"kind":"Name","value":"brands"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"lspId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lspId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"whereClause"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderClause"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandAttributes"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}},...BrandAttributesFragmentDoc.definitions]} as unknown as DocumentNode<GetBrandsQuery, GetBrandsQueryVariables>;
export const GetBrandDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getBrand"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lspId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"data"},"name":{"kind":"Name","value":"brand"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"lspId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lspId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandAttributes"}}]}}]}},...BrandAttributesFragmentDoc.definitions]} as unknown as DocumentNode<GetBrandQuery, GetBrandQueryVariables>;
export const GetCarsDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getCars"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lspId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderClause"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TblMdcarSortInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"whereClause"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TblMdcarFilterInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"data"},"name":{"kind":"Name","value":"cars"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"whereClause"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderClause"}}},{"kind":"Argument","name":{"kind":"Name","value":"locId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locId"}}},{"kind":"Argument","name":{"kind":"Name","value":"lspId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lspId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CarAttributes"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}},...CarAttributesFragmentDoc.definitions]} as unknown as DocumentNode<GetCarsQuery, GetCarsQueryVariables>;
export const GetCarDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getCar"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lspId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"data"},"name":{"kind":"Name","value":"car"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"locId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locId"}}},{"kind":"Argument","name":{"kind":"Name","value":"lspId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lspId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CarAttributes"}}]}}]}},...CarAttributesFragmentDoc.definitions]} as unknown as DocumentNode<GetCarQuery, GetCarQueryVariables>;
export const GetDriversDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getDrivers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lspId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderClause"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TblMddriverSortInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"whereClause"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TblMddriverFilterInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"data"},"name":{"kind":"Name","value":"drivers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"whereClause"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderClause"}}},{"kind":"Argument","name":{"kind":"Name","value":"locId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locId"}}},{"kind":"Argument","name":{"kind":"Name","value":"lspId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lspId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DriverAttributes"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}},...DriverAttributesFragmentDoc.definitions]} as unknown as DocumentNode<GetDriversQuery, GetDriversQueryVariables>;
export const GetDriverDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getDriver"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lspId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"data"},"name":{"kind":"Name","value":"driver"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"locId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locId"}}},{"kind":"Argument","name":{"kind":"Name","value":"lspId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lspId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DriverAttributes"}}]}}]}},...DriverAttributesFragmentDoc.definitions]} as unknown as DocumentNode<GetDriverQuery, GetDriverQueryVariables>;
export const DiscountEventsAuditDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"DiscountEventsAudit"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lspId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderClause"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DiscountAuditSortInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"whereClause"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DiscountAuditFilterInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"data"},"name":{"kind":"Name","value":"discountAudits"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"lspId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lspId"}}},{"kind":"Argument","name":{"kind":"Name","value":"locId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locId"}}},{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderClause"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"whereClause"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"discountAuditId"}},{"kind":"Field","name":{"kind":"Name","value":"auditAction"}},{"kind":"Field","name":{"kind":"Name","value":"auditDateTimeUtc"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","alias":{"kind":"Name","value":"relatedData"},"name":{"kind":"Name","value":"discountChanged"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"discountId"}},{"kind":"Field","alias":{"kind":"Name","value":"relatedDataValue"},"name":{"kind":"Name","value":"discountName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"changedByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"changed"},"name":{"kind":"Name","value":"discountAuditData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"columnChanged"}},{"kind":"Field","name":{"kind":"Name","value":"oldValue"}},{"kind":"Field","name":{"kind":"Name","value":"newValue"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<DiscountEventsAuditQuery, DiscountEventsAuditQueryVariables>;
export const FeatureEventsAuditDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FeatureEventsAudit"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lspId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderClause"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LspFeaturesAuditSortInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"whereClause"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LspFeaturesAuditFilterInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"data"},"name":{"kind":"Name","value":"lspFeatureAudits"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"lspId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lspId"}}},{"kind":"Argument","name":{"kind":"Name","value":"locId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locId"}}},{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderClause"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"whereClause"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"auditAction"}},{"kind":"Field","name":{"kind":"Name","value":"auditDateTimeUtc"}},{"kind":"Field","alias":{"kind":"Name","value":"userId"},"name":{"kind":"Name","value":"sessionUserID"}},{"kind":"Field","alias":{"kind":"Name","value":"newValue"},"name":{"kind":"Name","value":"isEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"lspId"}},{"kind":"Field","name":{"kind":"Name","value":"locId"}},{"kind":"Field","alias":{"kind":"Name","value":"relatedData"},"name":{"kind":"Name","value":"featureChanged"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"relatedDataValue"},"name":{"kind":"Name","value":"displayName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"changedByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<FeatureEventsAuditQuery, FeatureEventsAuditQueryVariables>;
export const PackageEventsAuditDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PackageEventsAudit"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lspId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderClause"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PackageAuditSortInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"whereClause"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PackageAuditFilterInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"data"},"name":{"kind":"Name","value":"packageAudits"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"lspId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lspId"}}},{"kind":"Argument","name":{"kind":"Name","value":"locId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locId"}}},{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderClause"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"whereClause"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"packageAuditId"}},{"kind":"Field","name":{"kind":"Name","value":"auditAction"}},{"kind":"Field","name":{"kind":"Name","value":"auditDateTimeUtc"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"lspId"}},{"kind":"Field","name":{"kind":"Name","value":"locId"}},{"kind":"Field","alias":{"kind":"Name","value":"relatedData"},"name":{"kind":"Name","value":"packageChanged"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"packageId"}},{"kind":"Field","alias":{"kind":"Name","value":"relatedDataValue"},"name":{"kind":"Name","value":"serialNumber"}}]}},{"kind":"Field","name":{"kind":"Name","value":"changedByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"changed"},"name":{"kind":"Name","value":"packageAuditData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"columnChanged"}},{"kind":"Field","name":{"kind":"Name","value":"oldValue"}},{"kind":"Field","name":{"kind":"Name","value":"newValue"}}]}}]}}]}}]}}]} as unknown as DocumentNode<PackageEventsAuditQuery, PackageEventsAuditQueryVariables>;
export const ProductEventsAuditDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProductEventsAudit"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lspId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderClause"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TblWhseProductsAuditSortInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"whereClause"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TblWhseProductsAuditFilterInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"data"},"name":{"kind":"Name","value":"productAudits"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"lspId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lspId"}}},{"kind":"Argument","name":{"kind":"Name","value":"locId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locId"}}},{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderClause"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"whereClause"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"whseProductsAuditId"}},{"kind":"Field","name":{"kind":"Name","value":"auditAction"}},{"kind":"Field","name":{"kind":"Name","value":"auditDateTimeUtc"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","alias":{"kind":"Name","value":"relatedData"},"name":{"kind":"Name","value":"productChanged"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"relatedDataValue"},"name":{"kind":"Name","value":"whseProductsDescription"}}]}},{"kind":"Field","name":{"kind":"Name","value":"changedByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"changed"},"name":{"kind":"Name","value":"tblWhseProductsAuditData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"columnChanged"}},{"kind":"Field","name":{"kind":"Name","value":"oldValue"}},{"kind":"Field","name":{"kind":"Name","value":"newValue"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<ProductEventsAuditQuery, ProductEventsAuditQueryVariables>;
export const UserEventsAuditDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UserEventsAudit"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lspId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderClause"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TblAuthUsersAuditSortInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"whereClause"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TblAuthUsersAuditFilterInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"data"},"name":{"kind":"Name","value":"userAudits"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"lspId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lspId"}}},{"kind":"Argument","name":{"kind":"Name","value":"locId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locId"}}},{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderClause"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"whereClause"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"authUsersAuditId"}},{"kind":"Field","name":{"kind":"Name","value":"auditAction"}},{"kind":"Field","name":{"kind":"Name","value":"auditDateTimeUtc"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"locId"}},{"kind":"Field","alias":{"kind":"Name","value":"relatedData"},"name":{"kind":"Name","value":"userChanged"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"relatedDataValue"},"name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"changedByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"changed"},"name":{"kind":"Name","value":"authUsersAuditData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"columnChanged"}},{"kind":"Field","name":{"kind":"Name","value":"oldValue"}},{"kind":"Field","name":{"kind":"Name","value":"newValue"}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<UserEventsAuditQuery, UserEventsAuditQueryVariables>;
export const GetHarvestBatchesLiteDropdownDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getHarvestBatchesLiteDropdown"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lspId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"whereClause"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TblBatchFilterInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderClause"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TblBatchSortInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"data"},"name":{"kind":"Name","value":"harvestBatchesLite"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"lspId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lspId"}}},{"kind":"Argument","name":{"kind":"Name","value":"locId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"whereClause"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderClause"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"HarvestBatchesLiteAttributes"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}},...HarvestBatchesLiteAttributesFragmentDoc.definitions]} as unknown as DocumentNode<GetHarvestBatchesLiteDropdownQuery, GetHarvestBatchesLiteDropdownQueryVariables>;
export const GetHarvestBatchesLiteDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getHarvestBatchesLite"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lspId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderClause"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TblBatchSortInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"whereClause"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TblBatchFilterInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"data"},"name":{"kind":"Name","value":"harvestBatchesLite"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"whereClause"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderClause"}}},{"kind":"Argument","name":{"kind":"Name","value":"locId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locId"}}},{"kind":"Argument","name":{"kind":"Name","value":"lspId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lspId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"HarvestBatchesLiteAttributes"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}},...HarvestBatchesLiteAttributesFragmentDoc.definitions]} as unknown as DocumentNode<GetHarvestBatchesLiteQuery, GetHarvestBatchesLiteQueryVariables>;
export const GetHarvestBatchLiteDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getHarvestBatchLite"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lspId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"data"},"name":{"kind":"Name","value":"harvestBatchLite"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"lspId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lspId"}}},{"kind":"Argument","name":{"kind":"Name","value":"locId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"HarvestBatchesLiteAttributes"}}]}}]}},...HarvestBatchesLiteAttributesFragmentDoc.definitions]} as unknown as DocumentNode<GetHarvestBatchLiteQuery, GetHarvestBatchLiteQueryVariables>;
export const GetPackagesForDropdownDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getPackagesForDropdown"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lspId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderClause"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PackageSortInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"whereClause"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PackageFilterInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"data"},"name":{"kind":"Name","value":"packages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"whereClause"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderClause"}}},{"kind":"Argument","name":{"kind":"Name","value":"locId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locId"}}},{"kind":"Argument","name":{"kind":"Name","value":"lspId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lspId"}}},{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PackageDropDownAttributes"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}},...PackageDropDownAttributesFragmentDoc.definitions]} as unknown as DocumentNode<GetPackagesForDropdownQuery, GetPackagesForDropdownQueryVariables>;
export const GetPackagesForGlobalSearchDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getPackagesForGlobalSearch"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lspId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderClause"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PackageSortInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"whereClause"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PackageFilterInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"data"},"name":{"kind":"Name","value":"packages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"whereClause"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderClause"}}},{"kind":"Argument","name":{"kind":"Name","value":"locId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locId"}}},{"kind":"Argument","name":{"kind":"Name","value":"lspId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lspId"}}},{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"packageId"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"sourceSerialNumber"}},{"kind":"Field","name":{"kind":"Name","value":"serialNumber"}},{"kind":"Field","name":{"kind":"Name","value":"room"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"roomNo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"whseProductsDescription"}},{"kind":"Field","name":{"kind":"Name","value":"brand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brandName"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetPackagesForGlobalSearchQuery, GetPackagesForGlobalSearchQueryVariables>;
export const GetPackagesV2Document = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getPackagesV2"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lspId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"showLowInventory"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderClause"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PackageSortInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"whereClause"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PackageFilterInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"excludeAllocatedInventorySum"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"excludeLastAuditedDateUtc"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"excludeLastDatePackageAuditedUtc"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"data"},"name":{"kind":"Name","value":"packages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"whereClause"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderClause"}}},{"kind":"Argument","name":{"kind":"Name","value":"locId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locId"}}},{"kind":"Argument","name":{"kind":"Name","value":"lspId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lspId"}}},{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"Argument","name":{"kind":"Name","value":"showLowInventory"},"value":{"kind":"Variable","name":{"kind":"Name","value":"showLowInventory"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InventoryPackageAttributesV2"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}},...InventoryPackageAttributesV2FragmentDoc.definitions]} as unknown as DocumentNode<GetPackagesV2Query, GetPackagesV2QueryVariables>;
export const GetPackagesV3Document = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getPackagesV3"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lspId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"showLowInventory"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderClause"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PackageSortInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"whereClause"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PackageFilterInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"excludeAllocatedInventorySum"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"excludeLastAuditedDateUtc"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"excludeLastDatePackageAuditedUtc"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"data"},"name":{"kind":"Name","value":"packages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"whereClause"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderClause"}}},{"kind":"Argument","name":{"kind":"Name","value":"locId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locId"}}},{"kind":"Argument","name":{"kind":"Name","value":"lspId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lspId"}}},{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"Argument","name":{"kind":"Name","value":"showLowInventory"},"value":{"kind":"Variable","name":{"kind":"Name","value":"showLowInventory"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InventoryPackageAttributesV3"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}},...InventoryPackageAttributesV3FragmentDoc.definitions]} as unknown as DocumentNode<GetPackagesV3Query, GetPackagesV3QueryVariables>;
export const GetPackagesDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getPackages"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lspId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"showLowInventory"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderClause"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PackageSortInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"whereClause"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PackageFilterInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"excludeAllocatedInventorySum"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"excludeLastAuditedDateUtc"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"excludeLastDatePackageAuditedUtc"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"data"},"name":{"kind":"Name","value":"packages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"whereClause"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderClause"}}},{"kind":"Argument","name":{"kind":"Name","value":"locId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locId"}}},{"kind":"Argument","name":{"kind":"Name","value":"lspId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lspId"}}},{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"Argument","name":{"kind":"Name","value":"showLowInventory"},"value":{"kind":"Variable","name":{"kind":"Name","value":"showLowInventory"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InventoryPackageAttributes"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}},...InventoryPackageAttributesFragmentDoc.definitions]} as unknown as DocumentNode<GetPackagesQuery, GetPackagesQueryVariables>;
export const GetPackageQtyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getPackageQty"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lspId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"data"},"name":{"kind":"Name","value":"package"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"locId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locId"}}},{"kind":"Argument","name":{"kind":"Name","value":"lspId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lspId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"packageId"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}}]}}]}}]} as unknown as DocumentNode<GetPackageQtyQuery, GetPackageQtyQueryVariables>;
export const GetPackageV2Document = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getPackageV2"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lspId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"excludeAllocatedInventorySum"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"excludeLastAuditedDateUtc"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"excludeLastDatePackageAuditedUtc"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"data"},"name":{"kind":"Name","value":"package"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"locId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locId"}}},{"kind":"Argument","name":{"kind":"Name","value":"lspId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lspId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InventoryPackageAttributesV2"}}]}}]}},...InventoryPackageAttributesV2FragmentDoc.definitions]} as unknown as DocumentNode<GetPackageV2Query, GetPackageV2QueryVariables>;
export const GetPackageV3Document = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getPackageV3"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lspId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"excludeAllocatedInventorySum"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"excludeLastAuditedDateUtc"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"excludeLastDatePackageAuditedUtc"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"data"},"name":{"kind":"Name","value":"package"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"locId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locId"}}},{"kind":"Argument","name":{"kind":"Name","value":"lspId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lspId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InventoryPackageAttributesV3"}}]}}]}},...InventoryPackageAttributesV3FragmentDoc.definitions]} as unknown as DocumentNode<GetPackageV3Query, GetPackageV3QueryVariables>;
export const GetPackageDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getPackage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lspId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"excludeAllocatedInventorySum"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"excludeLastAuditedDateUtc"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"excludeLastDatePackageAuditedUtc"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"data"},"name":{"kind":"Name","value":"package"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"locId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locId"}}},{"kind":"Argument","name":{"kind":"Name","value":"lspId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lspId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InventoryPackageAttributes"}}]}}]}},...InventoryPackageAttributesFragmentDoc.definitions]} as unknown as DocumentNode<GetPackageQuery, GetPackageQueryVariables>;
export const GetProductsDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getProducts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lspId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderClause"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TblWhseProductSortInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"whereClause"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TblWhseProductFilterInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"data"},"name":{"kind":"Name","value":"products"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"whereClause"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderClause"}}},{"kind":"Argument","name":{"kind":"Name","value":"lspId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lspId"}}},{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductAttributes"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}},...ProductAttributesFragmentDoc.definitions]} as unknown as DocumentNode<GetProductsQuery, GetProductsQueryVariables>;
export const GetProductsForDropdownDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getProductsForDropdown"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lspId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderClause"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TblWhseProductSortInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"whereClause"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TblWhseProductFilterInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"data"},"name":{"kind":"Name","value":"products"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"whereClause"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderClause"}}},{"kind":"Argument","name":{"kind":"Name","value":"lspId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lspId"}}},{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductDropDownAttributes"}}]}}]}}]}},...ProductDropDownAttributesFragmentDoc.definitions]} as unknown as DocumentNode<GetProductsForDropdownQuery, GetProductsForDropdownQueryVariables>;
export const UpdateProductRetiredStatusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateProductRetiredStatus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateProductRetiredStatusInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateProductRetiredStatus"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<UpdateProductRetiredStatusMutation, UpdateProductRetiredStatusMutationVariables>;
export const GetInventoryStatusesDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getInventoryStatuses"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lspId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderClause"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TblInventoryStatusSortInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"whereClause"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"TblInventoryStatusFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"data"},"name":{"kind":"Name","value":"inventoryStatuses"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"lspId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lspId"}}},{"kind":"Argument","name":{"kind":"Name","value":"locId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locId"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderClause"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"whereClause"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InventoryStatusAttribute"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}},...InventoryStatusAttributeFragmentDoc.definitions]} as unknown as DocumentNode<GetInventoryStatusesQuery, GetInventoryStatusesQueryVariables>;
export const SetJobStatusCancelledDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"setJobStatusCancelled"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"SetJobStatusToCancelledInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"setJobStatusCancelled"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobStatusId"}},{"kind":"Field","name":{"kind":"Name","value":"cancelled"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<SetJobStatusCancelledMutation, SetJobStatusCancelledMutationVariables>;
export const GetJobStatusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getJobStatus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lspId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"data"},"name":{"kind":"Name","value":"jobStatus"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"lspId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lspId"}}},{"kind":"Argument","name":{"kind":"Name","value":"locId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locId"}}},{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"jobName"}},{"kind":"Field","name":{"kind":"Name","value":"jobSource"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"statusDetails"}},{"kind":"Field","name":{"kind":"Name","value":"cancel"}},{"kind":"Field","name":{"kind":"Name","value":"createdAtUtc"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAtUtc"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}}]}}]} as unknown as DocumentNode<GetJobStatusQuery, GetJobStatusQueryVariables>;
export const GetJobStatusesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getJobStatuses"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lspId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderClause"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JobStatusSortInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"whereClause"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JobStatusFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"data"},"name":{"kind":"Name","value":"jobStatuses"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"lspId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lspId"}}},{"kind":"Argument","name":{"kind":"Name","value":"locId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locId"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderClause"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"whereClause"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"jobName"}},{"kind":"Field","name":{"kind":"Name","value":"jobSource"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"statusDetails"}},{"kind":"Field","name":{"kind":"Name","value":"cancel"}},{"kind":"Field","name":{"kind":"Name","value":"createdAtUtc"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAtUtc"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetJobStatusesQuery, GetJobStatusesQueryVariables>;
export const GetPlantsDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getPlants"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lspId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderClause"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TblMdbatchPlantIdSortInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"whereClause"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TblMdbatchPlantIdFilterInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"data"},"name":{"kind":"Name","value":"plants"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"whereClause"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderClause"}}},{"kind":"Argument","name":{"kind":"Name","value":"locId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locId"}}},{"kind":"Argument","name":{"kind":"Name","value":"lspId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lspId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PlantAttributes"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}},...PlantAttributesFragmentDoc.definitions]} as unknown as DocumentNode<GetPlantsQuery, GetPlantsQueryVariables>;
export const GetPlantDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getPlant"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lspId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"data"},"name":{"kind":"Name","value":"plant"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"locId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locId"}}},{"kind":"Argument","name":{"kind":"Name","value":"lspId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lspId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PlantAttributes"}}]}}]}},...PlantAttributesFragmentDoc.definitions]} as unknown as DocumentNode<GetPlantQuery, GetPlantQueryVariables>;
export const GetProducersDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getProducers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lspId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderClause"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProducerSortInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"whereClause"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProducerFilterInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"data"},"name":{"kind":"Name","value":"producers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"whereClause"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderClause"}}},{"kind":"Argument","name":{"kind":"Name","value":"lspId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lspId"}}},{"kind":"Argument","name":{"kind":"Name","value":"locId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locId"}}},{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProducerAttributes"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}}]}}]}},...ProducerAttributesFragmentDoc.definitions]} as unknown as DocumentNode<GetProducersQuery, GetProducersQueryVariables>;
export const GetProducerDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getProducer"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lspId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"data"},"name":{"kind":"Name","value":"producer"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"lspId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lspId"}}},{"kind":"Argument","name":{"kind":"Name","value":"locId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locId"}}},{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProducerAttributes"}}]}}]}},...ProducerAttributesFragmentDoc.definitions]} as unknown as DocumentNode<GetProducerQuery, GetProducerQueryVariables>;
export const GetProductCategoriesDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getProductCategories"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lspId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"whereClause"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TblWhseProductTypeFilterInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderClause"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TblWhseProductTypeSortInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"data"},"name":{"kind":"Name","value":"productTypes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"whereClause"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderClause"}}},{"kind":"Argument","name":{"kind":"Name","value":"lspId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lspId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductCategoryAttributes"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}}]}}]}},...ProductCategoryAttributesFragmentDoc.definitions]} as unknown as DocumentNode<GetProductCategoriesQuery, GetProductCategoriesQueryVariables>;
export const GetCategoriesDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getCategories"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lspId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"whereClause"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TblWhseProductTypeFilterInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderClause"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TblWhseProductTypeSortInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"data"},"name":{"kind":"Name","value":"productTypes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"whereClause"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderClause"}}},{"kind":"Argument","name":{"kind":"Name","value":"lspId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lspId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CategoryAttributes"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}},...CategoryAttributesFragmentDoc.definitions]} as unknown as DocumentNode<GetCategoriesQuery, GetCategoriesQueryVariables>;
export const GetProductCategoryDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getProductCategory"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lspId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"data"},"name":{"kind":"Name","value":"productType"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"lspId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lspId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductCategoryAttributes"}}]}}]}},...ProductCategoryAttributesFragmentDoc.definitions]} as unknown as DocumentNode<GetProductCategoryQuery, GetProductCategoryQueryVariables>;
export const GetRoomsDropdownDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getRoomsDropdown"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lspId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"whereClause"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TblBatchRoomFilterInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderClause"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TblBatchRoomSortInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"hideEmpty"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"data"},"name":{"kind":"Name","value":"rooms"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"lspId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lspId"}}},{"kind":"Argument","name":{"kind":"Name","value":"locId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"whereClause"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderClause"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"hideEmpty"},"value":{"kind":"Variable","name":{"kind":"Name","value":"hideEmpty"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"roomNo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<GetRoomsDropdownQuery, GetRoomsDropdownQueryVariables>;
export const GetRoomsDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getRooms"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lspId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"whereClause"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TblBatchRoomFilterInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderClause"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TblBatchRoomSortInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"data"},"name":{"kind":"Name","value":"rooms"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"lspId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lspId"}}},{"kind":"Argument","name":{"kind":"Name","value":"locId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"whereClause"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderClause"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RoomAttributes"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}},...RoomAttributesFragmentDoc.definitions]} as unknown as DocumentNode<GetRoomsQuery, GetRoomsQueryVariables>;
export const GetRoomDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getRoom"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lspId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"data"},"name":{"kind":"Name","value":"room"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"locId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locId"}}},{"kind":"Argument","name":{"kind":"Name","value":"lspId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lspId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RoomAttributes"}}]}}]}},...RoomAttributesFragmentDoc.definitions]} as unknown as DocumentNode<GetRoomQuery, GetRoomQueryVariables>;
export const GetStrainsDropdownDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getStrainsDropdown"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lspId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"whereClause"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TblBatchStrainFilterInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderClause"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TblBatchStrainSortInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"data"},"name":{"kind":"Name","value":"batchStrains"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"lspId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lspId"}}},{"kind":"Argument","name":{"kind":"Name","value":"locId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"whereClause"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderClause"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"StrainAttributes"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}},...StrainAttributesFragmentDoc.definitions]} as unknown as DocumentNode<GetStrainsDropdownQuery, GetStrainsDropdownQueryVariables>;
export const GetStrainsDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getStrains"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lspId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"whereClause"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TblBatchStrainFilterInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderClause"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TblBatchStrainSortInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"data"},"name":{"kind":"Name","value":"batchStrains"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"lspId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lspId"}}},{"kind":"Argument","name":{"kind":"Name","value":"locId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"whereClause"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderClause"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"StrainAttributes"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}},...StrainAttributesFragmentDoc.definitions]} as unknown as DocumentNode<GetStrainsQuery, GetStrainsQueryVariables>;
export const GetStrainDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getStrain"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lspId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"data"},"name":{"kind":"Name","value":"batchStrain"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"locId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locId"}}},{"kind":"Argument","name":{"kind":"Name","value":"lspId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lspId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"StrainAttributes"}}]}}]}},...StrainAttributesFragmentDoc.definitions]} as unknown as DocumentNode<GetStrainQuery, GetStrainQueryVariables>;
export const GetSubRoomsDropdownDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getSubRoomsDropdown"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lspId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"whereClause"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TblBatchTrayFilterInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderClause"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TblBatchTraySortInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"data"},"name":{"kind":"Name","value":"subrooms"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"lspId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lspId"}}},{"kind":"Argument","name":{"kind":"Name","value":"locId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"whereClause"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderClause"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SubroomAttributes"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}},...SubroomAttributesFragmentDoc.definitions]} as unknown as DocumentNode<GetSubRoomsDropdownQuery, GetSubRoomsDropdownQueryVariables>;
export const GetSubRoomsDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getSubRooms"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lspId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderClause"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TblBatchTraySortInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"whereClause"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TblBatchTrayFilterInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"data"},"name":{"kind":"Name","value":"subrooms"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"whereClause"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderClause"}}},{"kind":"Argument","name":{"kind":"Name","value":"locId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locId"}}},{"kind":"Argument","name":{"kind":"Name","value":"lspId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lspId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SubroomAttributes"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}},...SubroomAttributesFragmentDoc.definitions]} as unknown as DocumentNode<GetSubRoomsQuery, GetSubRoomsQueryVariables>;
export const GetSubroomDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getSubroom"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lspId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"data"},"name":{"kind":"Name","value":"subroom"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"lspId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lspId"}}},{"kind":"Argument","name":{"kind":"Name","value":"locId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SubroomAttributes"}}]}}]}},...SubroomAttributesFragmentDoc.definitions]} as unknown as DocumentNode<GetSubroomQuery, GetSubroomQueryVariables>;
export const AssociatedTagResourceCountsV2Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"associatedTagResourceCountsV2"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tagId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lspId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"data"},"name":{"kind":"Name","value":"associatedTagResourceCounts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"tagId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tagId"}}},{"kind":"Argument","name":{"kind":"Name","value":"lspId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lspId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"packageCount"}},{"kind":"Field","name":{"kind":"Name","value":"productCount"}},{"kind":"Field","name":{"kind":"Name","value":"inventoryDiscountCount"}},{"kind":"Field","name":{"kind":"Name","value":"inventoryKitItemCount"}},{"kind":"Field","name":{"kind":"Name","value":"productDiscountCount"}}]}}]}}]} as unknown as DocumentNode<AssociatedTagResourceCountsV2Query, AssociatedTagResourceCountsV2QueryVariables>;
export const AssociatedTagResourceCountsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"associatedTagResourceCounts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tagId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lspId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"data"},"name":{"kind":"Name","value":"associatedTagResourceCounts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"tagId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tagId"}}},{"kind":"Argument","name":{"kind":"Name","value":"lspId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lspId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"packageCount"}},{"kind":"Field","name":{"kind":"Name","value":"productCount"}},{"kind":"Field","name":{"kind":"Name","value":"inventoryDiscountCount"}},{"kind":"Field","name":{"kind":"Name","value":"productDiscountCount"}}]}}]}}]} as unknown as DocumentNode<AssociatedTagResourceCountsQuery, AssociatedTagResourceCountsQueryVariables>;
export const GetTagsV2Document = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getTagsV2"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lspId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderClause"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TagSortInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"whereClause"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TagFilterInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"data"},"name":{"kind":"Name","value":"tags"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"whereClause"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderClause"}}},{"kind":"Argument","name":{"kind":"Name","value":"lspId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lspId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TagAttributesV2"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}},...TagAttributesV2FragmentDoc.definitions]} as unknown as DocumentNode<GetTagsV2Query, GetTagsV2QueryVariables>;
export const GetTagsDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getTags"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lspId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderClause"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TagSortInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"whereClause"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TagFilterInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"data"},"name":{"kind":"Name","value":"tags"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"whereClause"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderClause"}}},{"kind":"Argument","name":{"kind":"Name","value":"lspId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lspId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TagAttributes"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}},...TagAttributesFragmentDoc.definitions]} as unknown as DocumentNode<GetTagsQuery, GetTagsQueryVariables>;
export const GetTagV2Document = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getTagV2"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lspId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"data"},"name":{"kind":"Name","value":"tag"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"lspId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lspId"}}},{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TagAttributesV2"}}]}}]}},...TagAttributesV2FragmentDoc.definitions]} as unknown as DocumentNode<GetTagV2Query, GetTagV2QueryVariables>;
export const GetTagDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getTag"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lspId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"data"},"name":{"kind":"Name","value":"tag"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"lspId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lspId"}}},{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TagAttributes"}}]}}]}},...TagAttributesFragmentDoc.definitions]} as unknown as DocumentNode<GetTagQuery, GetTagQueryVariables>;
export const GetUnitsDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getUnits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"data"},"name":{"kind":"Name","value":"units"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UnitAttributes"}}]}}]}},...UnitAttributesFragmentDoc.definitions]} as unknown as DocumentNode<GetUnitsQuery, GetUnitsQueryVariables>;
export const GetVendorsDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getVendors"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lspId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderClause"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TblVendorSortInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"whereClause"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TblVendorFilterInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"data"},"name":{"kind":"Name","value":"vendors"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"whereClause"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderClause"}}},{"kind":"Argument","name":{"kind":"Name","value":"lspId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lspId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VendorAttributes"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}},...VendorAttributesFragmentDoc.definitions]} as unknown as DocumentNode<GetVendorsQuery, GetVendorsQueryVariables>;
export const GetVendorDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getVendor"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lspId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"data"},"name":{"kind":"Name","value":"vendor"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"lspId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lspId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VendorAttributes"}}]}}]}},...VendorAttributesFragmentDoc.definitions]} as unknown as DocumentNode<GetVendorQuery, GetVendorQueryVariables>;
export const GetZonesDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getZones"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lspId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderClause"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeliveryZoneSortInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"whereClause"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeliveryZoneFilterInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"data"},"name":{"kind":"Name","value":"zones"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"whereClause"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderClause"}}},{"kind":"Argument","name":{"kind":"Name","value":"locId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locId"}}},{"kind":"Argument","name":{"kind":"Name","value":"lspId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lspId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ZoneAttributes"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}},...ZoneAttributesFragmentDoc.definitions]} as unknown as DocumentNode<GetZonesQuery, GetZonesQueryVariables>;
export const GetZoneDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getZone"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lspId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"data"},"name":{"kind":"Name","value":"zone"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"locId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locId"}}},{"kind":"Argument","name":{"kind":"Name","value":"lspId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lspId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ZoneAttributes"}}]}}]}},...ZoneAttributesFragmentDoc.definitions]} as unknown as DocumentNode<GetZoneQuery, GetZoneQueryVariables>;